
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4d0f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4d0f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.8";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.8" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("7LWfy", function(module, exports) {
module.exports = import("274bg").then(()=>parcelRequire('7N2f3'));

});

parcelRegister("1gqde", function(module, exports) {
module.exports = import("1onzB").then(()=>parcelRequire('duPOu'));

});

parcelRegister("hL0DY", function(module, exports) {
module.exports = import("VZrzj").then(()=>parcelRequire('bggdo'));

});

parcelRegister("eymjQ", function(module, exports) {
module.exports = import("972Jr").then(()=>parcelRequire('l3c81'));

});

parcelRegister("8FGNB", function(module, exports) {
module.exports = import("cmbQR").then(()=>parcelRequire('kcsbJ'));

});

parcelRegister("1Ifet", function(module, exports) {
module.exports = import("kCZPw").then(()=>parcelRequire('4GQxG'));

});

parcelRegister("6MuVj", function(module, exports) {
module.exports = import("dgy2X").then(()=>parcelRequire('b4Z2l'));

});

parcelRegister("jr8eW", function(module, exports) {
module.exports = import("hQu1L").then(()=>parcelRequire('dBAua'));

});

parcelRegister("ivKQf", function(module, exports) {
module.exports = import("5EKe2").then(()=>parcelRequire('6cOvF'));

});

parcelRegister("gRvZX", function(module, exports) {
module.exports = import("7s0dh").then(()=>parcelRequire('3SEVM'));

});

parcelRegister("gOwRw", function(module, exports) {
module.exports = import("gOaOS").then(()=>parcelRequire('7vLes'));

});

parcelRegister("lXQOh", function(module, exports) {
module.exports = import("ONYj3").then(()=>parcelRequire('9A14v'));

});

parcelRegister("bPwzi", function(module, exports) {
module.exports = import("bTRrI").then(()=>parcelRequire('iX9JA'));

});

parcelRegister("87AoQ", function(module, exports) {
module.exports = import("9nzmr").then(()=>parcelRequire('9bYFo'));

});

parcelRegister("lRvrW", function(module, exports) {
module.exports = import("3gk3T").then(()=>parcelRequire('6ypOh'));

});

parcelRegister("5XSVk", function(module, exports) {
module.exports = import("8saTe").then(()=>parcelRequire('DpjYB'));

});

parcelRegister("iQ83R", function(module, exports) {
module.exports = import("9syHU").then(()=>parcelRequire('cLAoC'));

});

parcelRegister("3RraV", function(module, exports) {
module.exports = import("j1vnt").then(()=>parcelRequire('5ZKEH'));

});

parcelRegister("cLLOU", function(module, exports) {
module.exports = import("1ULq8").then(()=>parcelRequire('2alwl'));

});

parcelRegister("6GiKw", function(module, exports) {
module.exports = import("6QFwk").then(()=>parcelRequire('86zPb'));

});

parcelRegister("bGFwJ", function(module, exports) {
module.exports = import("7WKFa").then(()=>parcelRequire('b58dq'));

});

parcelRegister("e7dcB", function(module, exports) {
module.exports = import("iubcx").then(()=>parcelRequire('l03Ya'));

});

parcelRegister("eQ4m8", function(module, exports) {
module.exports = import("8jZB2").then(()=>parcelRequire('jaSut'));

});

parcelRegister("62n9n", function(module, exports) {
module.exports = import("dejdZ").then(()=>parcelRequire('lnu51'));

});

parcelRegister("eeVSd", function(module, exports) {
module.exports = import("b1CeP").then(()=>parcelRequire('7S1i2'));

});

parcelRegister("1YTzL", function(module, exports) {
module.exports = import("9Em8N").then(()=>parcelRequire('2alNz'));

});

parcelRegister("fhz2I", function(module, exports) {
module.exports = import("hCGSL").then(()=>parcelRequire('hVkhq'));

});

parcelRegister("9vR1F", function(module, exports) {
module.exports = import("6BZWo").then(()=>parcelRequire('8jzjN'));

});

parcelRegister("eZAfb", function(module, exports) {
module.exports = import("48sOO").then(()=>parcelRequire('9sTnQ'));

});

parcelRegister("4zqQY", function(module, exports) {
module.exports = import("8YVVj").then(()=>parcelRequire('lkoby'));

});

parcelRegister("69GhX", function(module, exports) {
module.exports = import("gOJF2").then(()=>parcelRequire('6WpH3'));

});

parcelRegister("cXE6O", function(module, exports) {
module.exports = import("hKaRb").then(()=>parcelRequire('5Ddc5'));

});

parcelRegister("c47kc", function(module, exports) {
module.exports = import("02PyZ").then(()=>parcelRequire('4ivhy'));

});

parcelRegister("1vT2h", function(module, exports) {
module.exports = import("7x1oO").then(()=>parcelRequire('aInZK'));

});

parcelRegister("9fHuQ", function(module, exports) {
module.exports = import("3R3nk").then(()=>parcelRequire('c3BgJ'));

});

parcelRegister("9TYzn", function(module, exports) {
module.exports = import("5wwPo").then(()=>parcelRequire('6UbTO'));

});

parcelRegister("ckRCV", function(module, exports) {
module.exports = import("1z7un").then(()=>parcelRequire('kLJ2y'));

});

parcelRegister("328k9", function(module, exports) {
module.exports = import("kywW1").then(()=>parcelRequire('dnB2i'));

});

parcelRegister("6ZxRv", function(module, exports) {
module.exports = import("l0esu").then(()=>parcelRequire('gvXUz'));

});

parcelRegister("ilV3d", function(module, exports) {
module.exports = import("7cr6c").then(()=>parcelRequire('9n0xW'));

});

parcelRegister("5ZB0W", function(module, exports) {
module.exports = import("jDcWY").then(()=>parcelRequire('icbbj'));

});

parcelRegister("46PJ9", function(module, exports) {
module.exports = import("cPK7G").then(()=>parcelRequire('9424m'));

});

parcelRegister("iCfe5", function(module, exports) {
module.exports = import("55zTs").then(()=>parcelRequire('5javf'));

});

parcelRegister("bVTA0", function(module, exports) {
module.exports = import("eBt08").then(()=>parcelRequire('fpp6V'));

});

parcelRegister("6fu8D", function(module, exports) {
module.exports = import("koEy8").then(()=>parcelRequire('a5brH'));

});

parcelRegister("fQdee", function(module, exports) {
module.exports = import("cBp34").then(()=>parcelRequire('4yUSC'));

});

parcelRegister("lOEZX", function(module, exports) {
module.exports = import("6VgQa").then(()=>parcelRequire('1CYT8'));

});

parcelRegister("81wOy", function(module, exports) {
module.exports = import("9sMGj").then(()=>parcelRequire('gAfaX'));

});

parcelRegister("hRRnt", function(module, exports) {
module.exports = import("fVBMv").then(()=>parcelRequire('cMj1t'));

});

parcelRegister("3NuPr", function(module, exports) {
module.exports = import("loMqQ").then(()=>parcelRequire('f1K69'));

});

parcelRegister("cPRzy", function(module, exports) {
module.exports = import("kHP41").then(()=>parcelRequire('a6uYI'));

});

parcelRegister("aV0LW", function(module, exports) {
module.exports = import("8LIid").then(()=>parcelRequire('ctGQD'));

});

parcelRegister("25GWJ", function(module, exports) {
module.exports = import("kCkoV").then(()=>parcelRequire('agS4j'));

});

parcelRegister("iBVsX", function(module, exports) {
module.exports = import("iOowM").then(()=>parcelRequire('fvV61'));

});

parcelRegister("6GTi4", function(module, exports) {
module.exports = import("21kGn").then(()=>parcelRequire('2OV5k'));

});

parcelRegister("bm5Pc", function(module, exports) {
module.exports = import("8rmVs").then(()=>parcelRequire('cuHxI'));

});

parcelRegister("ac6PO", function(module, exports) {
module.exports = import("5oa4j").then(()=>parcelRequire('3TUFG'));

});

parcelRegister("hgwRq", function(module, exports) {
module.exports = import("b1L6c").then(()=>parcelRequire('jZQB8'));

});

parcelRegister("59Bwv", function(module, exports) {
module.exports = import("ahAiN").then(()=>parcelRequire('ekBtY'));

});

parcelRegister("hM9XH", function(module, exports) {
module.exports = import("7cSfv").then(()=>parcelRequire('lQdd2'));

});

parcelRegister("1ORZd", function(module, exports) {
module.exports = import("b4go5").then(()=>parcelRequire('67lTC'));

});

parcelRegister("foXqn", function(module, exports) {
module.exports = import("87Rxk").then(()=>parcelRequire('3j1tn'));

});

parcelRegister("cZwJv", function(module, exports) {
module.exports = import("hHwqq").then(()=>parcelRequire('4Thiq'));

});

parcelRegister("a2pXF", function(module, exports) {
module.exports = import("4YvJk").then(()=>parcelRequire('lBneX'));

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


// ─────────────────────────────────────────────────────────────────────────────
// LOCAL COPY of @parsina/framework v0.23.0 `ui/lib/brand.js` — the code below the
// next rule is that file, unchanged.
//
// This panel pins the framework at v0.21.0, which has no brand module. Bumping it
// would carry two minor lines of kit changes (v0.22.x: currency, pickers, the
// clinical module) into an ops panel to get one ~450-line file, so the plan's
// rule for dentist/admin/student applies (docs/rebranding/PLAN.md D10, §7): copy
// it, and the day this panel moves to v0.23 or later, delete this file and point
// every import of '../lib/brand' at '@parsina/framework/ui/lib/brand'. Never
// edit the copy on its own: brand.test.js holds it to the same behaviour, and
// the pre-paint script in index.html mirrors its sanitising.
// ─────────────────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
// The brand — what the product is called, what its credit is called, which
// languages it offers, which calendar it reads and which market it serves — and
// how a deployment replaces it.
//
// THE PROBLEM THIS SOLVES
// One set of images runs as Parsina and as another brand (Proxia first). The
// brand is CONFIGURATION, set by the deployment (docs/rebranding/CONTRACT.md):
// the container writes `BRAND_B64` into env.js, the app decodes it at boot and
// hands it here. Everything that says the name — the catalogues' `{{brand}}`,
// the printed prescription's footer, the video call's window title — and
// everything that is Iranian by default rather than by nature — the calendar,
// the phone field's +98, the national-id rule — asks this module.
//
// WHY A REGISTRY
// The same shape as `setUiStrings` (uiStrings.js) and `configureClinical`
// (clinical/src/host.jsx): module state, set once at boot, readable from plain
// functions — a print builder, a phone parser, a locale resolver — and not only
// from components. It is not reactive: a brand does not change while a page is
// open, so it is configured BEFORE the first render and never again.
//
// THE DEFAULTS ARE THE POINT
// Every default below is the literal the framework shipped before it had a
// brand. An app that never calls `configureBrand` renders exactly what it
// rendered before, byte for byte (clinical/__tests__/brandParity.test.js holds
// the resolved catalogues to that). A deployment that configures a brand
// replaces only the fields it sets; a bad value is dropped with ONE console
// warning and its default kept — a brand must never be the reason a panel does
// not start.
//
// Brand is not market (CONTRACT §1.4). `market: 'intl'` does not rename the
// Iranian rails; it hides them (`isIranMarket()`), at the entry points.
// ─────────────────────────────────────────────────────────────────────────────
const $6386b471a95fe1b8$var$deepFreeze = (value)=>{
    if (value && typeof value === 'object' && !Object.isFrozen(value)) {
        Object.values(value).forEach($6386b471a95fe1b8$var$deepFreeze);
        Object.freeze(value);
    }
    return value;
};
const $6386b471a95fe1b8$export$c3e10d2aebbc7f30 = $6386b471a95fe1b8$var$deepFreeze({
    id: 'parsina',
    name: {
        fa: "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
        en: 'Parsina',
        ar: 'Parsina'
    },
    tagline: {
        fa: "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F \u067E\u0632\u0634\u06A9\u06CC",
        en: 'Intelligent Medical Assistant',
        ar: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0637\u0628\u064A \u0627\u0644\u0630\u0643\u064A"
    },
    // The credit's NAME, a label only — `parseh*` identifiers never change.
    // `faEz` is the Persian ezafe form («پارسهٔ کلینیک»): heh + U+0654.
    walletUnit: {
        fa: "\u067E\u0627\u0631\u0633\u0647",
        faEz: "\u067E\u0627\u0631\u0633\u0647\u0654",
        en: 'Parseh',
        ar: "\u0628\u0627\u0631\u0633\u0647"
    },
    // null = the app's own list / default / calendar / market — today's behaviour.
    locales: null,
    defaultLocale: null,
    calendar: null,
    market: null,
    assetPack: null,
    // Per-locale overlay, consulted BEFORE the catalogue: { en: { '<key>': '<text>' } }.
    strings: {}
});
const $6386b471a95fe1b8$var$CALENDARS = [
    'jalali',
    'gregory'
];
const $6386b471a95fe1b8$var$MARKETS = [
    'ir',
    'intl'
];
const $6386b471a95fe1b8$var$SLUG = /^[a-z0-9][a-z0-9-]*$/;
const $6386b471a95fe1b8$var$LOCALE_ID = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
let $6386b471a95fe1b8$var$configured = $6386b471a95fe1b8$var$deepFreeze({}); // what the deployment set, after sanitising
let $6386b471a95fe1b8$var$resolved = $6386b471a95fe1b8$export$c3e10d2aebbc7f30; // the defaults with `configured` merged over them
let $6386b471a95fe1b8$var$revision = 0;
// One warning per message per session — `brandLocales` runs on every render.
const $6386b471a95fe1b8$var$warned = new Set();
function $6386b471a95fe1b8$var$warnOnce(message) {
    if ($6386b471a95fe1b8$var$warned.has(message)) return;
    $6386b471a95fe1b8$var$warned.add(message);
    console.warn(`[brand] ${message}`);
}
const $6386b471a95fe1b8$var$isPlainObject = (v)=>v != null && typeof v === 'object' && !Array.isArray(v);
const $6386b471a95fe1b8$var$nonEmpty = (v)=>typeof v === 'string' && v.trim() !== '';
/** `{ fa: '…', en: '…' }` — keeps the entries whose value is a non-empty string. */ function $6386b471a95fe1b8$var$sanitizeMap(value, field, problems) {
    if (!$6386b471a95fe1b8$var$isPlainObject(value)) {
        problems.push(`${field} is not an object`);
        return undefined;
    }
    const out = {};
    for (const [key, text] of Object.entries(value))if ($6386b471a95fe1b8$var$nonEmpty(text)) out[key] = text;
    else problems.push(`${field}.${key} is not a non-empty string`);
    return out;
}
function $6386b471a95fe1b8$var$sanitizeLocales(value, problems) {
    if (!Array.isArray(value) || value.length === 0) {
        problems.push('locales is not a non-empty array');
        return undefined;
    }
    const ids = value.map((id)=>typeof id === 'string' ? id.trim().toLowerCase() : '');
    if (ids.some((id)=>!$6386b471a95fe1b8$var$LOCALE_ID.test(id))) {
        problems.push(`locales has an entry that is not a language tag: ${JSON.stringify(value)}`);
        return undefined;
    }
    return [
        ...new Set(ids)
    ];
}
function $6386b471a95fe1b8$var$sanitizeStrings(value, problems) {
    if (!$6386b471a95fe1b8$var$isPlainObject(value)) {
        problems.push('strings is not an object');
        return undefined;
    }
    const out = {};
    for (const [locale, table] of Object.entries(value)){
        if (!$6386b471a95fe1b8$var$isPlainObject(table)) {
            problems.push(`strings.${locale} is not an object`);
            continue;
        }
        const kept = {};
        for (const [key, text] of Object.entries(table)){
            const ok = typeof text === 'string' || Array.isArray(text) && text.every((item)=>typeof item === 'string');
            if (ok) kept[key] = text;
            else problems.push(`strings.${locale}.${key} is not a string`);
        }
        out[locale.toLowerCase()] = kept;
    }
    return out;
}
/**
 * Raw brand JSON → only the fields that are valid, with every problem noted.
 * Unknown fields are ignored without a word: the same object reaches every
 * runtime (CONTRACT §2) and may carry fields only a service reads.
 */ function $6386b471a95fe1b8$var$sanitize(input, problems) {
    if (!$6386b471a95fe1b8$var$isPlainObject(input)) {
        problems.push('the brand is not a JSON object');
        return {};
    }
    const out = {};
    const scalar = (field, test, normalise = (v)=>v)=>{
        const v = input[field];
        if (v === undefined || v === null) return;
        if (test(v)) out[field] = normalise(v);
        else problems.push(`${field} ${JSON.stringify(v)} is not valid`);
    };
    scalar('id', (v)=>typeof v === 'string' && $6386b471a95fe1b8$var$SLUG.test(v));
    scalar('calendar', (v)=>$6386b471a95fe1b8$var$CALENDARS.includes(v));
    scalar('market', (v)=>$6386b471a95fe1b8$var$MARKETS.includes(v));
    scalar('assetPack', (v)=>typeof v === 'string' && $6386b471a95fe1b8$var$SLUG.test(v));
    scalar('defaultLocale', (v)=>typeof v === 'string' && $6386b471a95fe1b8$var$LOCALE_ID.test(v.trim().toLowerCase()), (v)=>v.trim().toLowerCase());
    for (const field of [
        'name',
        'tagline',
        'walletUnit'
    ]){
        if (input[field] == null) continue;
        const map = $6386b471a95fe1b8$var$sanitizeMap(input[field], field, problems);
        if (map && Object.keys(map).length) out[field] = map;
    }
    if (input.locales != null) {
        const locales = $6386b471a95fe1b8$var$sanitizeLocales(input.locales, problems);
        if (locales) out.locales = locales;
    }
    if (input.strings != null) {
        const strings = $6386b471a95fe1b8$var$sanitizeStrings(input.strings, problems);
        if (strings) out.strings = strings;
    }
    // A first-visit language the brand does not offer is a contradiction; the
    // list wins, and `brandDefaultLocale` then answers from the list.
    if (out.defaultLocale && out.locales && !out.locales.includes(out.defaultLocale)) {
        problems.push(`defaultLocale "${out.defaultLocale}" is not one of locales`);
        delete out.defaultLocale;
    }
    return out;
}
function $6386b471a95fe1b8$export$d9cd1c078c0b61d(word) {
    const w = String(word ?? '');
    if (/ه$/.test(w)) return `${w}\u{654}`;
    if (/[او]$/.test(w)) return `${w}\u{6CC}`;
    return w;
}
function $6386b471a95fe1b8$var$merge(clean) {
    const unit = clean.walletUnit || {};
    return $6386b471a95fe1b8$var$deepFreeze({
        ...$6386b471a95fe1b8$export$c3e10d2aebbc7f30,
        ...clean,
        name: {
            ...$6386b471a95fe1b8$export$c3e10d2aebbc7f30.name,
            ...clean.name
        },
        tagline: {
            ...$6386b471a95fe1b8$export$c3e10d2aebbc7f30.tagline,
            ...clean.tagline
        },
        walletUnit: {
            ...$6386b471a95fe1b8$export$c3e10d2aebbc7f30.walletUnit,
            ...unit,
            faEz: unit.faEz ?? (unit.fa ? $6386b471a95fe1b8$export$d9cd1c078c0b61d(unit.fa) : $6386b471a95fe1b8$export$c3e10d2aebbc7f30.walletUnit.faEz)
        },
        strings: clean.strings || {}
    });
}
function $6386b471a95fe1b8$export$9b06eb23289fc34c(partial) {
    $6386b471a95fe1b8$var$revision += 1;
    if (partial === null || partial === undefined) {
        $6386b471a95fe1b8$var$configured = $6386b471a95fe1b8$var$deepFreeze({});
        $6386b471a95fe1b8$var$resolved = $6386b471a95fe1b8$export$c3e10d2aebbc7f30;
        return $6386b471a95fe1b8$var$resolved;
    }
    const problems = [];
    const clean = $6386b471a95fe1b8$var$sanitize(partial, problems);
    if (problems.length) console.warn(`[brand] kept the default for what is not valid: ${problems.join('; ')}`);
    $6386b471a95fe1b8$var$configured = $6386b471a95fe1b8$var$deepFreeze(clean);
    $6386b471a95fe1b8$var$resolved = Object.keys(clean).length ? $6386b471a95fe1b8$var$merge(clean) : $6386b471a95fe1b8$export$c3e10d2aebbc7f30;
    return $6386b471a95fe1b8$var$resolved;
}
function $6386b471a95fe1b8$export$3f8f5e31744c04b0(b64) {
    try {
        if (typeof atob !== 'function') return undefined;
        const binary = atob(String(b64).replace(/\s+/g, ''));
        const bytes = Uint8Array.from(binary, (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder('utf-8', {
            fatal: true
        }).decode(bytes));
    } catch  {
        return undefined;
    }
}
function $6386b471a95fe1b8$export$1c31b0413ff44cf2(env = typeof window !== 'undefined' ? window.__ENV__ : undefined) {
    const b64 = env?.BRAND_B64;
    if (b64 === undefined || b64 === null || String(b64).trim() === '') return $6386b471a95fe1b8$var$resolved;
    const decoded = $6386b471a95fe1b8$export$3f8f5e31744c04b0(b64);
    if (decoded === undefined) {
        console.warn("[brand] BRAND_B64 is not base64 of a UTF-8 JSON object \u2014 Parsina defaults kept");
        return $6386b471a95fe1b8$export$9b06eb23289fc34c(null);
    }
    return $6386b471a95fe1b8$export$9b06eb23289fc34c(decoded);
}
function $6386b471a95fe1b8$export$96ff94e0adb1d772() {
    return $6386b471a95fe1b8$var$resolved;
}
function $6386b471a95fe1b8$export$57a0b7719e4bc93b() {
    return $6386b471a95fe1b8$var$revision;
}
function $6386b471a95fe1b8$export$3cede7c619603eb2() {
    return $6386b471a95fe1b8$var$resolved.market !== 'intl';
}
function $6386b471a95fe1b8$export$1a326f4d00c1e158(appLocales) {
    const list = Array.isArray(appLocales) ? appLocales : [];
    const allowed = $6386b471a95fe1b8$var$resolved.locales;
    if (!allowed) return list;
    const offered = list.filter((id)=>allowed.includes(String(id).toLowerCase()));
    if (offered.length) return offered;
    $6386b471a95fe1b8$var$warnOnce(`locales ${JSON.stringify(allowed)} share nothing with this app's ${JSON.stringify(list)} \u{2014} offering the app's`);
    return list;
}
function $6386b471a95fe1b8$export$879824979a5b153a(appDefault, appLocales) {
    const offered = appLocales ? $6386b471a95fe1b8$export$1a326f4d00c1e158(appLocales) : $6386b471a95fe1b8$var$resolved.locales;
    const wanted = $6386b471a95fe1b8$var$resolved.defaultLocale;
    if (wanted && (!offered || offered.includes(wanted))) return wanted;
    if (!offered || offered.includes(appDefault)) return appDefault;
    return offered[0] ?? appDefault;
}
function $6386b471a95fe1b8$export$a350347e69c4c055(appDefault = null) {
    return $6386b471a95fe1b8$var$resolved.calendar || appDefault;
}
// ── Text ─────────────────────────────────────────────────────────────────────
/** A per-locale map read for `locale`: exact, then the base language, then English. */ function $6386b471a95fe1b8$var$pick(map, locale) {
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    if (map[id] !== undefined) return map[id];
    const base = id.split(/[-_]/)[0];
    if (map[base] !== undefined) return map[base];
    return map.en;
}
/** What the deployment itself set for `field` in `locale`, or undefined. */ const $6386b471a95fe1b8$var$configuredIn = (field, locale)=>{
    const map = $6386b471a95fe1b8$var$configured[field];
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    return map[id] ?? map[id.split(/[-_]/)[0]];
};
function $6386b471a95fe1b8$export$63a39fc1c580d092(locale) {
    return $6386b471a95fe1b8$var$pick($6386b471a95fe1b8$var$resolved.name, locale);
}
function $6386b471a95fe1b8$export$6281f283246a2f65(name, locale, inline) {
    const has = inline !== undefined && inline !== null;
    switch(name){
        case 'brand':
            {
                const set = $6386b471a95fe1b8$var$configuredIn('name', locale);
                return set ?? (has ? inline : $6386b471a95fe1b8$var$pick($6386b471a95fe1b8$var$resolved.name, locale));
            }
        case 'coin':
            {
                const set = $6386b471a95fe1b8$var$configuredIn('walletUnit', locale);
                return set ?? (has ? inline : $6386b471a95fe1b8$var$pick($6386b471a95fe1b8$var$resolved.walletUnit, locale));
            }
        case 'coinEz':
            {
                const unit = $6386b471a95fe1b8$var$configured.walletUnit;
                const set = unit && (unit.faEz ?? (unit.fa ? $6386b471a95fe1b8$export$d9cd1c078c0b61d(unit.fa) : undefined));
                return set ?? (has ? inline : $6386b471a95fe1b8$var$resolved.walletUnit.faEz);
            }
        case 'tagline':
            {
                const set = $6386b471a95fe1b8$var$configuredIn('tagline', locale);
                return set ?? (has ? inline : $6386b471a95fe1b8$var$pick($6386b471a95fe1b8$var$resolved.tagline, locale));
            }
        default:
            return undefined;
    }
}
const $6386b471a95fe1b8$export$936dfa1128462f2c = Object.freeze([
    'brand',
    'coin',
    'coinEz',
    'tagline'
]);
function $6386b471a95fe1b8$export$168e20da34ba5ff3(locale) {
    return {
        brand: $6386b471a95fe1b8$export$6281f283246a2f65('brand', locale),
        coin: $6386b471a95fe1b8$export$6281f283246a2f65('coin', locale),
        coinEz: $6386b471a95fe1b8$export$6281f283246a2f65('coinEz', locale),
        tagline: $6386b471a95fe1b8$export$6281f283246a2f65('tagline', locale)
    };
}
const $6386b471a95fe1b8$export$55fc5ffc49a23c34 = /\{\{\s*([\w.]+)\s*(?:\|([^{}]*?))?\s*\}\}/g;
function $6386b471a95fe1b8$export$1508028e88b5e6ae(text, locale) {
    if (typeof text !== 'string' || text.indexOf('{{') === -1) return text;
    return text.replace($6386b471a95fe1b8$export$55fc5ffc49a23c34, (match, name, inline)=>{
        const value = $6386b471a95fe1b8$export$6281f283246a2f65(name, locale, inline);
        return value === undefined ? match : value;
    });
}
function $6386b471a95fe1b8$export$62fa8a9cbf8a9cc6(locale, key) {
    const table = $6386b471a95fe1b8$var$resolved.strings;
    const id = String(locale || '').toLowerCase();
    const own = table[id] ?? table[id.split(/[-_]/)[0]];
    if (!own) return undefined;
    return Object.prototype.hasOwnProperty.call(own, key) ? own[key] : undefined;
}


// The brand, configured ONCE, before anything else in the panel evaluates
// (docs/rebranding/CONTRACT.md). App.jsx imports this file first: import order
// is evaluation order, and modules below read the brand while they load — the
// locale registry, the language picker's list, the logos.
//
// docker-entrypoint.sh writes `BRAND_B64` into env.js only when the container
// has a brand (BRAND_JSON or BRAND_B64). Absent, this changes nothing and the
// panel is Parsina, byte for byte; a value that does not decode is Parsina too,
// with one console warning — a brand is never the reason the panel does not start.
(0, $6386b471a95fe1b8$export$1c31b0413ff44cf2)();


/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


// ─────────────────────────────────────────────────────────────────────────────
// @parsina/ui — the unified Parsina UI kit for all three web clients
// (doctor, clinic, patient).
//
// Canonical copy: /packages/ui (monorepo root). Each client app receives a
// synced copy at src/shared/ui via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Import everything from the barrel:
//   import { Button, TextInput, useToast } from '@parsina/ui';
// Design tokens live in the sibling package:
//   import { C, CT, statusColors } from '@parsina/tokens';
// ─────────────────────────────────────────────────────────────────────────────
// Form primitives

var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


var $85fc2fe65ff21506$exports = {};
'use strict';
Object.defineProperty($85fc2fe65ff21506$exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds = (config)=>{
    const lookup = Object.create(null);
    const classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(let i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers, postfixLookupClassGroupIds: postfixLookupClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId;
        if (hasPostfixModifier) {
            const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isNamedContainerQuery = (value)=>value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelWeight, $85fc2fe65ff21506$var$isAny);
const $85fc2fe65ff21506$var$isArbitraryFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelFamilyName, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
const $85fc2fe65ff21506$var$isArbitraryVariableWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelWeight, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $85fc2fe65ff21506$var$isArbitraryFamilyName,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $85fc2fe65ff21506$var$isArbitraryVariableWeight,
    isArbitraryWeight: $85fc2fe65ff21506$var$isArbitraryWeight,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNamedContainerQuery: $85fc2fe65ff21506$var$isNamedContainerQuery,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $85fc2fe65ff21506$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariableWeight,
                        $85fc2fe65ff21506$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
$85fc2fe65ff21506$exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
$85fc2fe65ff21506$exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
$85fc2fe65ff21506$exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
$85fc2fe65ff21506$exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
$85fc2fe65ff21506$exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
$85fc2fe65ff21506$exports.twJoin = $85fc2fe65ff21506$var$twJoin;
$85fc2fe65ff21506$exports.twMerge = $85fc2fe65ff21506$var$twMerge;
$85fc2fe65ff21506$exports.validators = $85fc2fe65ff21506$var$validators;


function $42e05640dae453c1$export$1343a74baacb0543(...inputs) {
    return (0, $85fc2fe65ff21506$exports.twMerge)((0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(inputs));
}
const $42e05640dae453c1$export$e6aa7dbb1e28c5bd = (str)=>String(str).replace(/[۰-۹]/g, (d)=>d.charCodeAt(0) - 0x06F0).replace(/[٠-٩]/g, (d)=>d.charCodeAt(0) - 0x0660);


'use client';
// The field wrapper every kit input renders through — and therefore the one
// place that decides whether this design system produces labelled controls.
//
// It used to draw the label as a `<span>`. That looks identical and is not the
// same thing: a screen reader announcing an unlabelled text box says "edit
// text, blank", `getByLabelText` cannot find the control, and clicking the
// label does not focus the field. §12.3 says all form inputs are labelled
// through `FormField` with a real `<label for>` — this is that.
//
// The association is made here rather than at the call sites, because a rule
// that depends on every caller remembering to pass an `id` is a rule that is
// half-applied within a month. `useId` supplies one, the child's own `id` wins
// if it has one, and the error/helper line is wired as `aria-describedby` so
// the reason a field is red is announced with it.
const $221000a87dfafb8e$var$FormField = ({ label: label, required: required, error: error, helperText: helperText, children: children, className: className, style: style, htmlFor: htmlFor })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const only = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) ? children : null;
    const controlId = htmlFor || only?.props?.id || (only ? `${generatedId}-control` : undefined);
    // Derived from the control's id, not the wrapper's, so a component that owns
    // its own wiring (the inputs that wrap their control in a positioning div)
    // can point at this message without asking for the id back.
    const messageId = (error || helperText) && controlId ? `${controlId}-message` : undefined;
    // `htmlFor` means the caller has already put the id on the real control.
    // Cloning here too would stamp the same id onto its wrapper — two elements,
    // one id, and the label resolves to whichever the browser sees first.
    const control = only && !htmlFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(only, {
        id: controlId,
        // Never clobber a caller's own description — join, so a field that
        // already points at a hint keeps it AND gains the error line.
        'aria-describedby': [
            only.props['aria-describedby'],
            messageId
        ].filter(Boolean).join(' ') || undefined,
        'aria-invalid': only.props['aria-invalid'] ?? (error ? true : undefined)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col gap-1.5', className),
        style: style
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: controlId,
        className: "text-[11.5px] font-semibold text-[#5a6780] tracking-[0.01em] select-none leading-none"
    }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-destructive ms-1"
    }, "*")), control, error ? // Announced, not merely displayed: §12.3 requires validation errors to
    // reach a screen reader when they appear, and a field whose only signal
    // is a red border tells a non-sighted user nothing at all.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        role: "alert",
        className: "m-0 text-[11.5px] text-destructive font-medium leading-snug"
    }, error) : helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] text-muted-foreground leading-snug"
    }, helperText) : null);
};
var $221000a87dfafb8e$export$2e2bcd8739ae039 = $221000a87dfafb8e$var$FormField;



var $acw62 = parcelRequire("acw62");


'use client';
const $6e2f2bccd0e2a9fb$var$TextInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, type: type = 'text', validate: validate, disabled: disabled = false, maxLength: maxLength, style: style, inputStyle: inputStyle, dir: // Unset: the field inherits the document's direction, which is what lets one
// component render a Persian and an English account. Pass dir="ltr" for a
// phone number, a code or any other Latin-digit run inside an RTL page.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: type,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        maxLength: maxLength,
        dir: dir,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 px-3.5 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }));
});
$6e2f2bccd0e2a9fb$var$TextInput.displayName = 'TextInput';
var $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039 = $6e2f2bccd0e2a9fb$var$TextInput;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/tokens — the single source of truth for the Parsina design system.
//
// Canonical copy: /packages/tokens (monorepo root). Each client app receives a
// synced copy at src/shared/tokens via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Three historical token systems (constants/theme.js `C`, constants/unifiedTheme.js
// `CT`, and per-app CSS vars) are collapsed into this module + tokens.css +
// tailwind.preset.js. Prefer Tailwind classes; `C`/`CT` exist for the screens
// still written with inline style objects.
// ─────────────────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
// The brand — what the product is called, what its credit is called, which
// languages it offers, which calendar it reads and which market it serves — and
// how a deployment replaces it.
//
// THE PROBLEM THIS SOLVES
// One set of images runs as Parsina and as another brand (Proxia first). The
// brand is CONFIGURATION, set by the deployment (docs/rebranding/CONTRACT.md):
// the container writes `BRAND_B64` into env.js, the app decodes it at boot and
// hands it here. Everything that says the name — the catalogues' `{{brand}}`,
// the printed prescription's footer, the video call's window title — and
// everything that is Iranian by default rather than by nature — the calendar,
// the phone field's +98, the national-id rule — asks this module.
//
// WHY A REGISTRY
// The same shape as `setUiStrings` (uiStrings.js) and `configureClinical`
// (clinical/src/host.jsx): module state, set once at boot, readable from plain
// functions — a print builder, a phone parser, a locale resolver — and not only
// from components. It is not reactive: a brand does not change while a page is
// open, so it is configured BEFORE the first render and never again.
//
// THE DEFAULTS ARE THE POINT
// Every default below is the literal the framework shipped before it had a
// brand. An app that never calls `configureBrand` renders exactly what it
// rendered before, byte for byte (clinical/__tests__/brandParity.test.js holds
// the resolved catalogues to that). A deployment that configures a brand
// replaces only the fields it sets; a bad value is dropped with ONE console
// warning and its default kept — a brand must never be the reason a panel does
// not start.
//
// Brand is not market (CONTRACT §1.4). `market: 'intl'` does not rename the
// Iranian rails; it hides them (`isIranMarket()`), at the entry points.
// ─────────────────────────────────────────────────────────────────────────────
const $abf0c103b4b92127$var$deepFreeze = (value)=>{
    if (value && typeof value === 'object' && !Object.isFrozen(value)) {
        Object.values(value).forEach($abf0c103b4b92127$var$deepFreeze);
        Object.freeze(value);
    }
    return value;
};
const $abf0c103b4b92127$export$c3e10d2aebbc7f30 = $abf0c103b4b92127$var$deepFreeze({
    id: 'parsina',
    name: {
        fa: "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
        en: 'Parsina',
        ar: 'Parsina',
        fr: 'Parsina',
        de: 'Parsina'
    },
    tagline: {
        fa: "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F \u067E\u0632\u0634\u06A9\u06CC",
        en: 'Intelligent Medical Assistant',
        ar: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0637\u0628\u064A \u0627\u0644\u0630\u0643\u064A",
        fr: "Assistant m\xe9dical intelligent",
        de: 'Intelligenter medizinischer Assistent'
    },
    // The credit's NAME, a label only — `parseh*` identifiers never change.
    // `faEz` is the Persian ezafe form («پارسهٔ کلینیک»): heh + U+0654.
    walletUnit: {
        fa: "\u067E\u0627\u0631\u0633\u0647",
        faEz: "\u067E\u0627\u0631\u0633\u0647\u0654",
        en: 'Parseh',
        ar: "\u0628\u0627\u0631\u0633\u0647",
        fr: 'Parseh',
        de: 'Parseh'
    },
    // null = the app's own list / default / calendar / market — today's behaviour.
    locales: null,
    defaultLocale: null,
    calendar: null,
    market: null,
    assetPack: null,
    // Per-locale overlay, consulted BEFORE the catalogue: { en: { '<key>': '<text>' } }.
    strings: {}
});
const $abf0c103b4b92127$var$CALENDARS = [
    'jalali',
    'gregory'
];
const $abf0c103b4b92127$var$MARKETS = [
    'ir',
    'intl'
];
const $abf0c103b4b92127$var$SLUG = /^[a-z0-9][a-z0-9-]*$/;
const $abf0c103b4b92127$var$LOCALE_ID = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
let $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({}); // what the deployment set, after sanitising
let $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30; // the defaults with `configured` merged over them
let $abf0c103b4b92127$var$revision = 0;
// One warning per message per session — `brandLocales` runs on every render.
const $abf0c103b4b92127$var$warned = new Set();
function $abf0c103b4b92127$var$warnOnce(message) {
    if ($abf0c103b4b92127$var$warned.has(message)) return;
    $abf0c103b4b92127$var$warned.add(message);
    console.warn(`[brand] ${message}`);
}
const $abf0c103b4b92127$var$isPlainObject = (v)=>v != null && typeof v === 'object' && !Array.isArray(v);
const $abf0c103b4b92127$var$nonEmpty = (v)=>typeof v === 'string' && v.trim() !== '';
/** `{ fa: '…', en: '…' }` — keeps the entries whose value is a non-empty string. */ function $abf0c103b4b92127$var$sanitizeMap(value, field, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push(`${field} is not an object`);
        return undefined;
    }
    const out = {};
    for (const [key, text] of Object.entries(value))if ($abf0c103b4b92127$var$nonEmpty(text)) out[key] = text;
    else problems.push(`${field}.${key} is not a non-empty string`);
    return out;
}
function $abf0c103b4b92127$var$sanitizeLocales(value, problems) {
    if (!Array.isArray(value) || value.length === 0) {
        problems.push('locales is not a non-empty array');
        return undefined;
    }
    const ids = value.map((id)=>typeof id === 'string' ? id.trim().toLowerCase() : '');
    if (ids.some((id)=>!$abf0c103b4b92127$var$LOCALE_ID.test(id))) {
        problems.push(`locales has an entry that is not a language tag: ${JSON.stringify(value)}`);
        return undefined;
    }
    return [
        ...new Set(ids)
    ];
}
function $abf0c103b4b92127$var$sanitizeStrings(value, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push('strings is not an object');
        return undefined;
    }
    const out = {};
    for (const [locale, table] of Object.entries(value)){
        if (!$abf0c103b4b92127$var$isPlainObject(table)) {
            problems.push(`strings.${locale} is not an object`);
            continue;
        }
        const kept = {};
        for (const [key, text] of Object.entries(table)){
            const ok = typeof text === 'string' || Array.isArray(text) && text.every((item)=>typeof item === 'string');
            if (ok) kept[key] = text;
            else problems.push(`strings.${locale}.${key} is not a string`);
        }
        out[locale.toLowerCase()] = kept;
    }
    return out;
}
/**
 * Raw brand JSON → only the fields that are valid, with every problem noted.
 * Unknown fields are ignored without a word: the same object reaches every
 * runtime (CONTRACT §2) and may carry fields only a service reads.
 */ function $abf0c103b4b92127$var$sanitize(input, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(input)) {
        problems.push('the brand is not a JSON object');
        return {};
    }
    const out = {};
    const scalar = (field, test, normalise = (v)=>v)=>{
        const v = input[field];
        if (v === undefined || v === null) return;
        if (test(v)) out[field] = normalise(v);
        else problems.push(`${field} ${JSON.stringify(v)} is not valid`);
    };
    scalar('id', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('calendar', (v)=>$abf0c103b4b92127$var$CALENDARS.includes(v));
    scalar('market', (v)=>$abf0c103b4b92127$var$MARKETS.includes(v));
    scalar('assetPack', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('defaultLocale', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$LOCALE_ID.test(v.trim().toLowerCase()), (v)=>v.trim().toLowerCase());
    for (const field of [
        'name',
        'tagline',
        'walletUnit'
    ]){
        if (input[field] == null) continue;
        const map = $abf0c103b4b92127$var$sanitizeMap(input[field], field, problems);
        if (map && Object.keys(map).length) out[field] = map;
    }
    if (input.locales != null) {
        const locales = $abf0c103b4b92127$var$sanitizeLocales(input.locales, problems);
        if (locales) out.locales = locales;
    }
    if (input.strings != null) {
        const strings = $abf0c103b4b92127$var$sanitizeStrings(input.strings, problems);
        if (strings) out.strings = strings;
    }
    // A first-visit language the brand does not offer is a contradiction; the
    // list wins, and `brandDefaultLocale` then answers from the list.
    if (out.defaultLocale && out.locales && !out.locales.includes(out.defaultLocale)) {
        problems.push(`defaultLocale "${out.defaultLocale}" is not one of locales`);
        delete out.defaultLocale;
    }
    return out;
}
function $abf0c103b4b92127$export$d9cd1c078c0b61d(word) {
    const w = String(word ?? '');
    if (/ه$/.test(w)) return `${w}\u{654}`;
    if (/[او]$/.test(w)) return `${w}\u{6CC}`;
    return w;
}
function $abf0c103b4b92127$var$merge(clean) {
    const unit = clean.walletUnit || {};
    return $abf0c103b4b92127$var$deepFreeze({
        ...$abf0c103b4b92127$export$c3e10d2aebbc7f30,
        ...clean,
        name: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.name,
            ...clean.name
        },
        tagline: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.tagline,
            ...clean.tagline
        },
        walletUnit: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit,
            ...unit,
            faEz: unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : $abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit.faEz)
        },
        strings: clean.strings || {}
    });
}
function $abf0c103b4b92127$export$9b06eb23289fc34c(partial) {
    $abf0c103b4b92127$var$revision += 1;
    if (partial === null || partial === undefined) {
        $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({});
        $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30;
        return $abf0c103b4b92127$var$resolved;
    }
    const problems = [];
    const clean = $abf0c103b4b92127$var$sanitize(partial, problems);
    if (problems.length) console.warn(`[brand] kept the default for what is not valid: ${problems.join('; ')}`);
    $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze(clean);
    $abf0c103b4b92127$var$resolved = Object.keys(clean).length ? $abf0c103b4b92127$var$merge(clean) : $abf0c103b4b92127$export$c3e10d2aebbc7f30;
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$3f8f5e31744c04b0(b64) {
    try {
        if (typeof atob !== 'function') return undefined;
        const binary = atob(String(b64).replace(/\s+/g, ''));
        const bytes = Uint8Array.from(binary, (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder('utf-8', {
            fatal: true
        }).decode(bytes));
    } catch  {
        return undefined;
    }
}
function $abf0c103b4b92127$export$1c31b0413ff44cf2(env = typeof window !== 'undefined' ? window.__ENV__ : undefined) {
    const b64 = env?.BRAND_B64;
    if (b64 === undefined || b64 === null || String(b64).trim() === '') return $abf0c103b4b92127$var$resolved;
    const decoded = $abf0c103b4b92127$export$3f8f5e31744c04b0(b64);
    if (decoded === undefined) {
        console.warn("[brand] BRAND_B64 is not base64 of a UTF-8 JSON object \u2014 Parsina defaults kept");
        return $abf0c103b4b92127$export$9b06eb23289fc34c(null);
    }
    return $abf0c103b4b92127$export$9b06eb23289fc34c(decoded);
}
function $abf0c103b4b92127$export$96ff94e0adb1d772() {
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$57a0b7719e4bc93b() {
    return $abf0c103b4b92127$var$revision;
}
function $abf0c103b4b92127$export$3cede7c619603eb2() {
    return $abf0c103b4b92127$var$resolved.market !== 'intl';
}
function $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) {
    const list = Array.isArray(appLocales) ? appLocales : [];
    const allowed = $abf0c103b4b92127$var$resolved.locales;
    if (!allowed) return list;
    const offered = list.filter((id)=>allowed.includes(String(id).toLowerCase()));
    if (offered.length) return offered;
    $abf0c103b4b92127$var$warnOnce(`locales ${JSON.stringify(allowed)} share nothing with this app's ${JSON.stringify(list)} \u{2014} offering the app's`);
    return list;
}
function $abf0c103b4b92127$export$879824979a5b153a(appDefault, appLocales) {
    const offered = appLocales ? $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) : $abf0c103b4b92127$var$resolved.locales;
    const wanted = $abf0c103b4b92127$var$resolved.defaultLocale;
    if (wanted && (!offered || offered.includes(wanted))) return wanted;
    if (!offered || offered.includes(appDefault)) return appDefault;
    return offered[0] ?? appDefault;
}
function $abf0c103b4b92127$export$a350347e69c4c055(appDefault = null) {
    return $abf0c103b4b92127$var$resolved.calendar || appDefault;
}
// ── Text ─────────────────────────────────────────────────────────────────────
/** A per-locale map read for `locale`: exact, then the base language, then English. */ function $abf0c103b4b92127$var$pick(map, locale) {
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    if (map[id] !== undefined) return map[id];
    const base = id.split(/[-_]/)[0];
    if (map[base] !== undefined) return map[base];
    return map.en;
}
/** What the deployment itself set for `field` in `locale`, or undefined. */ const $abf0c103b4b92127$var$configuredIn = (field, locale)=>{
    const map = $abf0c103b4b92127$var$configured[field];
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    return map[id] ?? map[id.split(/[-_]/)[0]];
};
function $abf0c103b4b92127$export$63a39fc1c580d092(locale) {
    return $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale);
}
function $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline) {
    const has = inline !== undefined && inline !== null;
    switch(name){
        case 'brand':
            {
                const set = $abf0c103b4b92127$var$configuredIn('name', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale));
            }
        case 'coin':
            {
                const set = $abf0c103b4b92127$var$configuredIn('walletUnit', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.walletUnit, locale));
            }
        case 'coinEz':
            {
                const unit = $abf0c103b4b92127$var$configured.walletUnit;
                const set = unit && (unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : undefined));
                return set ?? (has ? inline : $abf0c103b4b92127$var$resolved.walletUnit.faEz);
            }
        case 'tagline':
            {
                const set = $abf0c103b4b92127$var$configuredIn('tagline', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.tagline, locale));
            }
        default:
            return undefined;
    }
}
const $abf0c103b4b92127$export$936dfa1128462f2c = Object.freeze([
    'brand',
    'coin',
    'coinEz',
    'tagline'
]);
function $abf0c103b4b92127$export$168e20da34ba5ff3(locale) {
    return {
        brand: $abf0c103b4b92127$export$6281f283246a2f65('brand', locale),
        coin: $abf0c103b4b92127$export$6281f283246a2f65('coin', locale),
        coinEz: $abf0c103b4b92127$export$6281f283246a2f65('coinEz', locale),
        tagline: $abf0c103b4b92127$export$6281f283246a2f65('tagline', locale)
    };
}
const $abf0c103b4b92127$export$55fc5ffc49a23c34 = /\{\{\s*([\w.]+)\s*(?:\|([^{}]*?))?\s*\}\}/g;
function $abf0c103b4b92127$export$1508028e88b5e6ae(text, locale) {
    if (typeof text !== 'string' || text.indexOf('{{') === -1) return text;
    return text.replace($abf0c103b4b92127$export$55fc5ffc49a23c34, (match, name, inline)=>{
        const value = $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline);
        return value === undefined ? match : value;
    });
}
function $abf0c103b4b92127$export$62fa8a9cbf8a9cc6(locale, key) {
    const table = $abf0c103b4b92127$var$resolved.strings;
    const id = String(locale || '').toLowerCase();
    const own = table[id] ?? table[id.split(/[-_]/)[0]];
    if (!own) return undefined;
    return Object.prototype.hasOwnProperty.call(own, key) ? own[key] : undefined;
}


const $e7c165fb515b04ea$export$e7094788287c5e9b = {
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    red: '#D93025',
    redLight: '#F5E8E7',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    bg: '#f5f7fa',
    card: '#ffffff',
    border: '#eef0f3',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$4b57bfb4dade55bd = {
    // Backgrounds
    bg: '#f5f7fa',
    surface: '#ffffff',
    surface2: '#f3f2f0',
    // Borders
    border: '#eef0f3',
    border2: '#ece9e4',
    // Text
    ink: '#1a2332',
    ink2: '#5a6780',
    mute: '#9aa3b0',
    mute2: '#b0aca3',
    // Accent (teal — logo top hue). Themed; see the note on `C`.
    accent: 'var(--p-teal)',
    accentInk: 'var(--p-navy-dark)',
    accentSoft: 'color-mix(in srgb, var(--p-teal) 12%, transparent)',
    // Good (green)
    good: '#1A9B6C',
    goodInk: '#166534',
    goodSoft: 'rgba(22,163,74,0.12)',
    // Warn (amber)
    warn: '#F59E0B',
    warnInk: '#92400e',
    warnSoft: 'rgba(217,119,6,0.12)',
    // Danger (red)
    danger: '#D93025',
    dangerInk: '#991b1b',
    dangerSoft: 'rgba(220,38,38,0.08)',
    // Legacy aliases (keep older code working)
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    red: '#D93025',
    redLight: '#F5E8E7',
    card: '#ffffff',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $e7c165fb515b04ea$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};
const $e7c165fb515b04ea$export$169e587b68892b4e = {
    base: '#e9ecf1',
    sheen: '#f6f7f9',
    // On a gradient header, the sidebar or a dark canvas: white-alpha blocks.
    onDark: 'rgba(255,255,255,0.14)',
    onDarkSheen: 'rgba(255,255,255,0.26)'
};
const $e7c165fb515b04ea$export$959fb1d648dd9e6c = 'rgba(28,27,24,0.55)';
const $e7c165fb515b04ea$export$7deb2be06092489e = 'var(--gradient-brand)';
const $e7c165fb515b04ea$export$4c2e201e0b6dbaa3 = 'var(--gradient-brand-dark)';
const $e7c165fb515b04ea$export$4a4d076b923f4e78 = 'var(--gradient-sidebar)';
const $e7c165fb515b04ea$export$18e630330c8bca65 = 50;
const $e7c165fb515b04ea$export$63b7f4b4938ce481 = 200;
function $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance) {
    if (balance == null) return null;
    if (balance < $e7c165fb515b04ea$export$18e630330c8bca65) return 'low';
    if (balance < $e7c165fb515b04ea$export$63b7f4b4938ce481) return 'mid';
    return 'ok';
}
const $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7 = {
    low: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.red,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.redLight,
        labelKey: 'credits.level.low',
        shortLabelKey: 'credits.level.lowShort'
    },
    mid: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.amber,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.amberLight,
        labelKey: 'credits.level.mid',
        shortLabelKey: 'credits.level.midShort'
    },
    ok: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.green,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.greenLight,
        labelKey: 'credits.level.ok',
        shortLabelKey: 'credits.level.okShort'
    }
};
function $e7c165fb515b04ea$export$3b48083d65d829ca(balance, fallback = $e7c165fb515b04ea$export$e7094788287c5e9b.textMuted) {
    const level = $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance);
    return level ? $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7[level].color : fallback;
}
const $e7c165fb515b04ea$export$7bce9182245b1545 = (color, alpha = 0.12)=>{
    if (typeof color !== 'string' || !color) return 'transparent';
    const c = color.trim();
    if (c.startsWith('var(') || c.startsWith('color-mix(')) {
        const pct = Math.max(0, Math.min(100, Math.round(alpha * 100)));
        return `color-mix(in srgb, ${c} ${pct}%, transparent)`;
    }
    const h = c.replace('#', '');
    const full = h.length === 3 ? h.split('').map((x)=>x + x).join('') : h;
    const n = parseInt(full, 16);
    if (!/^[0-9a-fA-F]{6}$/.test(full) || Number.isNaN(n)) return c;
    return `rgba(${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}, ${alpha})`;
};
const $e7c165fb515b04ea$export$a1d018c6ed60ae4c = [
    {
        id: 'default',
        get label () {
            return `\u{622}\u{628}\u{6CC} ${(0, $abf0c103b4b92127$export$63a39fc1c580d092)('fa')}`;
        },
        swatch: '#0173BE',
        swatch2: '#00BEB2'
    },
    {
        id: 'teal',
        label: "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
        swatch: '#00A99E',
        swatch2: '#0173BE'
    },
    {
        id: 'ocean',
        label: "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
        swatch: '#0A5C8A',
        swatch2: '#0E8F9E'
    },
    {
        id: 'slate',
        label: "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
        swatch: '#3F5E75',
        swatch2: '#5C8A9E'
    }
];
const $e7c165fb515b04ea$export$7634868d3a6a0a2e = {
    doctor: {
        label: "\u067E\u0646\u0644 \u067E\u0632\u0634\u06A9",
        primary: '#0173BE',
        ink: '#083250'
    },
    clinic: {
        label: "\u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
        primary: '#0A4F8F',
        ink: '#062F57'
    },
    patient: {
        label: "\u067E\u0631\u0648\u0646\u062F\u0647 \u0633\u0644\u0627\u0645\u062A \u0645\u0646",
        primary: '#007C8C',
        ink: '#06363F'
    },
    dentist: {
        label: "\u067E\u0646\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
        primary: '#007D74',
        ink: '#063F3C'
    }
};
function $e7c165fb515b04ea$export$32d6efa0a3310091(panel) {
    const id = $e7c165fb515b04ea$export$7634868d3a6a0a2e[panel];
    if (!id) return $e7c165fb515b04ea$export$a1d018c6ed60ae4c;
    return $e7c165fb515b04ea$export$a1d018c6ed60ae4c.map((t)=>t.id === 'default' ? {
            ...t,
            label: "\u0631\u0646\u06AF \u067E\u0646\u0644",
            swatch: id.primary
        } : t);
}
const $e7c165fb515b04ea$export$58c32c962db85532 = [
    {
        id: 'small',
        label: "\u06A9\u0648\u0686\u06A9"
    },
    {
        id: 'medium',
        label: "\u0645\u062A\u0648\u0633\u0637"
    },
    {
        id: 'large',
        label: "\u0628\u0632\u0631\u06AF"
    }
];
const $e7c165fb515b04ea$export$2faeed762aac6741 = 'default';
const $e7c165fb515b04ea$export$b1461457ea2c1179 = 'medium';
const $e7c165fb515b04ea$export$888c18c43ead4265 = (id)=>$e7c165fb515b04ea$export$a1d018c6ed60ae4c.some((t)=>t.id === id);
const $e7c165fb515b04ea$export$5414ec5c49c0af0f = (id)=>$e7c165fb515b04ea$export$58c32c962db85532.some((f)=>f.id === id);
const $e7c165fb515b04ea$export$ff61b65939f754cc = 'parsina.appearance';
function $e7c165fb515b04ea$export$dde01dc24facb6b0(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        const raw = store?.getItem($e7c165fb515b04ea$export$ff61b65939f754cc);
        const parsed = raw ? JSON.parse(raw) : null;
        return {
            theme: $e7c165fb515b04ea$export$888c18c43ead4265(parsed?.theme) ? parsed.theme : $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(parsed?.fontSize) ? parsed.fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    } catch  {
        // Private mode, quota, or a corrupt value — fall back rather than throw.
        return {
            theme: $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    }
}
function $e7c165fb515b04ea$export$48c323151b232e54({ theme: theme, fontSize: fontSize } = {}, doc) {
    const root = (doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
    if (!root) return {
        theme: $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    const resolved = {
        theme: $e7c165fb515b04ea$export$888c18c43ead4265(theme) ? theme : $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(fontSize) ? fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    root.setAttribute('data-theme', resolved.theme);
    root.setAttribute('data-font-size', resolved.fontSize);
    return resolved;
}
function $e7c165fb515b04ea$export$64464588479aad90(appearance, storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        store?.setItem($e7c165fb515b04ea$export$ff61b65939f754cc, JSON.stringify(appearance));
    } catch  {
    // Persisting the cache is best-effort; the server copy is the real record.
    }
}
const $e7c165fb515b04ea$export$6881c75116d5bd6e = {
    // Appointment lifecycle, in the scheduling service's own vocabulary and with the
    // same Persian labels the clinic day panel uses — the desk and the doctor must not
    // call the same patient two different things.
    scheduled: {
        bg: '#F1F5F9',
        text: '#475569',
        label: "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631"
    },
    arrived: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u062D\u0627\u0636\u0631"
    },
    in_visit: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    },
    completed: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647"
    },
    cancelled: {
        bg: '#FEE2E2',
        text: '#991B1B',
        label: "\u0644\u063A\u0648 \u0634\u062F\u0647"
    },
    // A booked patient who never arrived. Distinct from `cancelled` — nobody
    // cancelled it — and neutral rather than red, because it is a fact about the
    // past, not a problem to act on. The patient app used to fork its own badge
    // for exactly this key (§1.1: missing keys get added here, never re-created
    // locally).
    no_show: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0639\u062F\u0645 \u062D\u0636\u0648\u0631"
    },
    // ── Patient-originated requests (docs/PATIENT_CLINIC_CARE_CONTEXT_AND_SELF_SERVICE_DESIGN.md §3) ──
    // A patient asked for this slot from the app and the clinic has not answered yet.
    // It HOLDS the slot, so it is a real appointment state and belongs here — amber
    // because it is work waiting on the desk, not a settled fact.
    requested: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9"
    },
    // The clinic declined the request, or it expired unanswered. Terminal and neutral:
    // like `no_show`, it is a fact about the past rather than a problem to act on.
    rejected: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0631\u062F \u0634\u062F\u0647"
    },
    // Patient-record statuses (Patients / PatientDetail screens), a different domain.
    waiting: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631"
    },
    visited: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A \u0634\u062F"
    },
    inprogress: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    }
};
const $e7c165fb515b04ea$export$c7989e6ff0cf1179 = [
    '#0173BE',
    '#00BEB2',
    '#F59E0B',
    '#7C4DBE'
];
const $e7c165fb515b04ea$export$6ee8bfc459aebd80 = {
    acquired: $e7c165fb515b04ea$export$c7989e6ff0cf1179[0],
    converted: $e7c165fb515b04ea$export$c7989e6ff0cf1179[1],
    lost: $e7c165fb515b04ea$export$c7989e6ff0cf1179[2],
    recovered: $e7c165fb515b04ea$export$c7989e6ff0cf1179[3]
};


var $412e1a8a99c19c1a$exports = {};

$parcel$export($412e1a8a99c19c1a$exports, "foldDigits", () => $412e1a8a99c19c1a$export$522be3011864bb18);
$parcel$export($412e1a8a99c19c1a$exports, "SEPARATORS", () => $412e1a8a99c19c1a$export$bc4e24532d262f45);
$parcel$export($412e1a8a99c19c1a$exports, "compactPhone", () => $412e1a8a99c19c1a$export$2ae1a93e018170a7);
$parcel$export($412e1a8a99c19c1a$exports, "COUNTRIES", () => $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
$parcel$export($412e1a8a99c19c1a$exports, "DEFAULT_COUNTRY", () => $412e1a8a99c19c1a$export$84b76667b0a9e7b4);
$parcel$export($412e1a8a99c19c1a$exports, "countryForLocale", () => $412e1a8a99c19c1a$export$7684f8e22afec32c);
$parcel$export($412e1a8a99c19c1a$exports, "findByIso2", () => $412e1a8a99c19c1a$export$586b3eaa727579f5);
$parcel$export($412e1a8a99c19c1a$exports, "findByDialCode", () => $412e1a8a99c19c1a$export$21894a57509f6ed5);
$parcel$export($412e1a8a99c19c1a$exports, "countryName", () => $412e1a8a99c19c1a$export$3162e773cd568eb);
$parcel$export($412e1a8a99c19c1a$exports, "countryMatches", () => $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa);
$parcel$export($412e1a8a99c19c1a$exports, "parsePhone", () => $412e1a8a99c19c1a$export$48c6adddc5539199);
$parcel$export($412e1a8a99c19c1a$exports, "normalizePhone", () => $412e1a8a99c19c1a$export$e9b617754cf28d84);
$parcel$export($412e1a8a99c19c1a$exports, "isValidPhone", () => $412e1a8a99c19c1a$export$f9c4d85d720ef909);
$parcel$export($412e1a8a99c19c1a$exports, "toNational", () => $412e1a8a99c19c1a$export$317852993b4735b6);
$parcel$export($412e1a8a99c19c1a$exports, "forDisplay", () => $412e1a8a99c19c1a$export$1069b069fb83ae5b);
$parcel$export($412e1a8a99c19c1a$exports, "maskPhone", () => $412e1a8a99c19c1a$export$1f64b92865689d0d);
$parcel$export($412e1a8a99c19c1a$exports, "lookupVariants", () => $412e1a8a99c19c1a$export$493e0fb9b5aae030);
// Phone numbers, reduced to one canonical form — and read back in whatever form a
// human wants to look at.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE THREE SIBLINGS OF THIS FILE
//
//   microservices/parsina.patientmanagement.microservice/app/domain/phone.py
//       `normalize_phone` — the matching key behind `patients.phone_normalized`.
//       Iran only. Its tests are tests/test_phone.py.
//   sso/parsina.keycloakify/spi/src/main/java/ir/parsinabot/keycloak/phoneotp/PhoneNumbers.java
//       `normalize` / `toNational` / `lookupVariants` / `mask`, inside the Keycloak
//       authenticator. Iran only. Its tests are PhoneNumbersTest.java.
//   sso/parsina.keycloakify/src/login/lib/{countries.ts,phone.ts}
//       The login screen's country-aware picker and E.164 parse. 62 countries,
//       Iran first, "the list is a convenience, never a gate". Its flags are the
//       ones `flags.js` rasterises (PM-0078).
//
// This module is the fourth hand-rolled implementation of the same rules, and it is
// deliberate. Keycloak is a Java process that cannot import Python; the login theme
// cannot `npm install @parsina/framework` (its own `digits.ts` header says why); the
// alembic backfill re-implements the rules in SQL on purpose, because a migration is a
// historical record of what a database was actually given and must not change meaning
// when a source file changes. What holds them together is not a shared module — it is a
// shared CASE TABLE. `PhoneNumbersTest` carries `test_phone.py`'s cases, `test_phone.py`
// carries the migration's, and `ui/lib/phone.test.js` beside this file carries
// `test_phone.py`'s. Adding a country is one row here and one row in `countries.ts`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHY THIS EXISTS AT ALL
//
// A phone number is the only handle joining a walk-in patient record — typed at the
// clinic desk, on paper, in a hurry — to the Keycloak account that person later
// registers with themselves. The two are typed by different people, years apart, in
// whatever form each found natural: the desk's Persian-digit spelling, and
// `+98 912 345 6789` in the signup form. Compared literally they are two different
// strings and the match never happens — which is how a doctor whose realm record held
// `+989199118259` ended up with a SECOND account when a desk typed `09199118259`.
//
// So the canonical form is E.164 — `+`, country code, national significant number, ASCII
// digits and nothing else — and every comparison goes through `normalizePhone`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE ONE PROMISE THIS FILE MAKES
//
//   With no options, `normalizePhone` is byte-identical to `phone.py#normalize_phone`
//   and `PhoneNumbers.normalize` for EVERY INPUT — not merely for the rows of
//   tests/test_phone.py — and is idempotent.
//
// "Every input" and "every row of the table" are not the same promise, and the weaker one
// was not enough: 74 real Iranian ranges written as `+9901234567` came back as
// `+9901234567` while both twins answered `+989901234567`, and 61 spellings the twins
// accept (`+0…`, `+00…`, `00<national>`, `+<national>`) were refused outright. Every one
// of those passed a green suite, because none of them was a row in the table.
//
// So the twins' algorithm is not APPROXIMATED here by a catalog that happens to contain
// Iran — it is TRANSCRIBED, in `peelIranianMobile`, and runs before the catalog is
// consulted at all. Everything else — countries, landlines, the picker — is the
// generalisation layered around it, and reaches a string only once the peel has declined
// it. `phone.test.js` executes the two implementations against each other over a
// generated corpus, so the promise is checked rather than asserted.
//
// ═══════════════════════════════════════════════════════════════════════════════
// TWO JOBS, NOT ONE
//
// `compactPhone` is LENIENT and `parsePhone` is STRICT, and the split is on purpose:
//
//   - A FIELD filters what a human may put in a box. Typing a word after a number should
//     make the letters simply not appear — the user watches them not arrive and nothing
//     is "rejected". That is `compactPhone`, and `PhoneInput` is its only real caller.
//   - A CANONICALISER judges a string that arrived from a database, an import or another
//     system, and can afford to refuse: `"09123456789abc"` is not a number with junk on
//     it, it is a string we do not understand, and guessing would be worse than
//     declining. That is `parsePhone`, and everything else calls it.
//
// Every non-field caller wants the second one.
//
// ═══════════════════════════════════════════════════════════════════════════════
// AND A THIRD JOB: READING
//
// DISPLAYING A PHONE IS NOT VALIDATING IT.
//
// `parsePhone`/`normalizePhone`/`isValidPhone`/`toNational` all JUDGE — they are the
// converters, and `''` is a verdict they are entitled to return. A READ SURFACE is not
// entitled to it. The value is already in the column; somebody stored it; a person is
// looking at the screen for it. Showing nothing, or showing `+98…` where a human expects
// `021…`, is the only way a read can fail.
//
// So every read goes through `forDisplay`, which is `toNational` with `allowLandline`
// ALWAYS on and the raw value as its fallback, and which therefore never blanks and never
// refuses. Restricting to mobiles belongs on the INPUT — `PhoneInput`, where a desk is
// still typing — and has no meaning at all on a value already written.
//
// The exports, by which job they do:
//
//   INPUT (lenient, shapes a keystroke)   compactPhone, foldDigits
//   CONVERT/VALIDATE (strict, may refuse) parsePhone, normalizePhone, isValidPhone,
//                                         toNational, lookupVariants
//   READ (never refuses)                  forDisplay, maskPhone
//   CATALOG                               COUNTRIES, DEFAULT_COUNTRY, findByIso2,
//                                         findByDialCode, countryName,
//                                         countryMatches, countryForLocale,
//                                         SEPARATORS
// The extension is NOT optional here, and the omission was a real break.
//
// The barrel resolves either spelling because a bundler is doing the resolving.
// But this module is imported DIRECTLY by DOM-free logic that runs under Node's
// own ESM resolver — the patient and student apps do exactly that, deliberately,
// so a `node` test environment does not pull raw JSX through the barrel. Node
// does not guess extensions, so `'./money'` failed there with
// ERR_MODULE_NOT_FOUND naming a file that plainly exists.
// Money — the one place the toman/rial boundary lives.
//
// Every service, every gRPC message and every GraphQL field in Parsina carries WHOLE
// RIALS. Iranian clinics quote, type and read TOMAN. Ten rials to the toman, and the
// conversion happens here, at the display edge, and nowhere else.
//
// Getting this wrong is not a cosmetic bug. A rial figure printed under a toman label
// reads as ten times the money — a 500,000 ت visit shows as 5,000,000 ت — and a toman
// figure typed into a rial field bills a tenth of what the cashier meant. Both of those
// shipped, in opposite directions, on the same screen.
//
// So: rials cross the wire, toman meets the human. Anything reaching for
// `.toLocaleString()` on a raw rial value is a bug.
//
// A clinic may keep its books in another currency: `currency.js` handles any
// allowed one, and for IRR each of its functions returns exactly what this file's
// does. New code that shows clinic money takes the document's currency and uses it.
// With its extension: phone.js imports this module under Node's own ESM resolver
// (see the note there), and Node does not guess one.

const $ca1f40e638c62a9a$export$166519e0fc2d4fb3 = 10;
const $ca1f40e638c62a9a$export$d3105a4d9be2f59 = (rial)=>rial == null || rial === '' || !Number.isFinite(Number(rial)) ? null : Number(rial) / $ca1f40e638c62a9a$export$166519e0fc2d4fb3;
const $ca1f40e638c62a9a$export$496c2c39d7e0791 = (toman)=>{
    const n = Number(String(toman ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * $ca1f40e638c62a9a$export$166519e0fc2d4fb3) : NaN;
};
function $ca1f40e638c62a9a$export$1736ebd23f2adeaf(rial) {
    const t = $ca1f40e638c62a9a$export$d3105a4d9be2f59(rial);
    if (t == null) return "\u2014";
    // Sub-toman precision cannot exist (prices are entered in toman) but a percentage
    // discount can land on a half-toman; show it rather than silently rounding money away.
    return t.toLocaleString('fa-IR', {
        maximumFractionDigits: 1
    });
}
function $ca1f40e638c62a9a$export$cbc4bde7d9461cfb(n) {
    if (n == null || n === '' || !Number.isFinite(Number(n))) return "\u2014";
    return Number(n).toLocaleString('fa-IR');
}
function $ca1f40e638c62a9a$export$3d047decf6215cd7(input) {
    if (input == null || String(input).trim() === '') return NaN;
    return $ca1f40e638c62a9a$export$496c2c39d7e0791($ca1f40e638c62a9a$var$toAsciiDigits(input));
}
// Persian/Arabic-Indic digits → ASCII, so a pasted or typed «۵۰۰۰۰۰» parses.
function $ca1f40e638c62a9a$var$toAsciiDigits(input) {
    return String(input).replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))).replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d)));
}
function $ca1f40e638c62a9a$export$8a2f5adb56df4f49(input, allowDecimal = false, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    let raw = String(input ?? '');
    // A locale whose decimal mark is not «.» (Persian uses «٫») would otherwise have
    // it stripped as punctuation, silently turning «۱٫۵» into «۱۵». Grouping marks
    // need no such care — they are non-digits and are meant to go.
    //
    // Under a decimal-COMMA language (French) a text that holds the comma names its
    // decimal with it, so any «.» beside it is a group mark and goes first: «1.234,5»
    // is 1234.5, as `currency.parseAmount(…, 'fr')` reads it — not «1.2345». A text
    // with no comma keeps «.» as a decimal point, which every language accepts here.
    //
    // A language that GROUPS with «.» (German «1.234,5») is different: there a dot is
    // a group mark even with no comma beside it, because that is what `groupAmount`
    // prints into a `MoneyInput` — reading it as a decimal turned a typed «12345» EUR,
    // shown «1.234» after four keys, into 1.23. Two dots are never one decimal point
    // either («1.234.567»). `NumberInput` follows the same rule: under such a
    // language it shows its value with the language's own decimal mark, so a «.» in
    // the box is never its decimal point. A text whose dots are NOT valid groups
    // («12.50», «1.5») is ambiguous there; `dotsAreGroups` lets a field refuse it.
    const dotGroups = numerals.decimal === ',' && (raw.includes(',') || numerals.group === '.');
    if (allowDecimal && dotGroups) raw = raw.split('.').join('');
    if (allowDecimal && numerals.decimal !== '.') raw = raw.split(numerals.decimal).join('.');
    let s = $ca1f40e638c62a9a$var$toAsciiDigits(raw).replace(allowDecimal ? /[^\d.]/g : /\D/g, '');
    if (allowDecimal) {
        const [intPart, ...rest] = s.split('.');
        if (rest.length) s = `${intPart}.${rest.join('')}`; // collapse extra dots
    }
    return s;
}
function $ca1f40e638c62a9a$export$bb91f232d86bf745(input, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    const raw = $ca1f40e638c62a9a$var$toAsciiDigits(String(input ?? ''));
    const intPart = raw.split(numerals.decimal)[0].replace(/[^\d.]/g, '');
    if (!intPart.includes('.')) return true;
    return /^\d{1,3}(\.\d{3})+$/.test(intPart);
}
function $ca1f40e638c62a9a$export$302430bce3371cb8(value, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    if (value == null || value === '') return '';
    const s = String(value);
    const neg = s.startsWith('-') ? '-' : '';
    const [intPart, ...rest] = (neg ? s.slice(1) : s).split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, numerals.group);
    const out = neg + (rest.length ? `${grouped}${numerals.decimal}${rest.join('')}` : grouped);
    // Only the ASCII digits are remapped; the separators are already the locale's.
    return numerals === $ca1f40e638c62a9a$export$4b87c97d2471ab43 ? out : out.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
}
const $ca1f40e638c62a9a$export$4b87c97d2471ab43 = Object.freeze({
    locale: 'en',
    digits: Object.freeze([
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ]),
    group: ',',
    decimal: '.'
});
const $ca1f40e638c62a9a$var$numeralsCache = new Map([
    [
        'en',
        $ca1f40e638c62a9a$export$4b87c97d2471ab43
    ]
]);
function $ca1f40e638c62a9a$export$20975da26e036f6b(locale) {
    const key = locale || 'en';
    const hit = $ca1f40e638c62a9a$var$numeralsCache.get(key);
    if (hit) return hit;
    let resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    try {
        const plain = new Intl.NumberFormat(key, {
            useGrouping: false
        });
        const digits = Array.from({
            length: 10
        }, (_, d)=>plain.format(d));
        // 1000.1 exercises both separators in one pass; a locale missing either
        // (none in practice) falls back to the Latin one rather than to undefined.
        const parts = new Intl.NumberFormat(key, {
            useGrouping: true
        }).formatToParts(1000.1);
        const part = (type, fallback)=>parts.find((p)=>p.type === type)?.value ?? fallback;
        resolved = Object.freeze({
            locale: key,
            digits: Object.freeze(digits),
            group: part('group', ','),
            decimal: part('decimal', '.')
        });
    } catch  {
        // An unsupported or malformed tag is a caller bug, not a reason to stop
        // rendering a price. Latin digits are always readable.
        resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    }
    $ca1f40e638c62a9a$var$numeralsCache.set(key, resolved);
    return resolved;
}
function $ca1f40e638c62a9a$export$594d280e896fc02b(fallback = (0, $abf0c103b4b92127$export$879824979a5b153a)('fa')) {
    if (typeof document === 'undefined') return fallback;
    return document.documentElement?.getAttribute('lang') || fallback;
}



// ─────────────────────────────────────────────────────────────────────────────
// Digits
// ─────────────────────────────────────────────────────────────────────────────
/** Persian U+06F0–U+06F9 — the default on an Iranian keyboard. */ const $412e1a8a99c19c1a$var$FA_ZERO = 0x06f0;
/** Arabic-Indic U+0660–U+0669 — Arabic-locale keyboards and some legacy imports. */ const $412e1a8a99c19c1a$var$AR_ZERO = 0x0660;
/** Fullwidth U+FF10–U+FF19 — emitted by some IME keyboards. */ const $412e1a8a99c19c1a$var$FW_ZERO = 0xff10;
function $412e1a8a99c19c1a$export$522be3011864bb18(raw) {
    if (typeof raw !== 'string') return '';
    let out = '';
    for(let i = 0; i < raw.length; i++){
        const c = raw.charCodeAt(i);
        if (c >= $412e1a8a99c19c1a$var$FA_ZERO && c <= $412e1a8a99c19c1a$var$FA_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FA_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$AR_ZERO && c <= $412e1a8a99c19c1a$var$AR_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$AR_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$FW_ZERO && c <= $412e1a8a99c19c1a$var$FW_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FW_ZERO));
        else out += raw[i];
    }
    return out;
}
const $412e1a8a99c19c1a$export$bc4e24532d262f45 = " 	\r\n\f\v\xa0\u202F\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u205F\u3000\u200B\u200C\u200D\u200E\u200F\u061C\uFEFF-\u2010\u2011\u2012\u2013\u2014\u2015\u2212()[]{}<>._/\\|,;:*#'\"`"; // everything else a desk has been seen to type
const $412e1a8a99c19c1a$var$SEPARATOR_SET = new Set($412e1a8a99c19c1a$export$bc4e24532d262f45.split(''));
const $412e1a8a99c19c1a$var$stripSeparators = (s)=>{
    let out = '';
    for(let i = 0; i < s.length; i++)if (!$412e1a8a99c19c1a$var$SEPARATOR_SET.has(s[i])) out += s[i];
    return out;
};
/**
 * What must remain once decoration is gone: digits, optionally introduced by ONE leading
 * `+`. Anything else — a letter, a second `+`, an interior symbol we did not list — means
 * this string is not a phone number.
 */ const $412e1a8a99c19c1a$var$DIGITS_ONLY = /^\+?[0-9]+$/;
/**
 * The national significant number of an Iranian mobile: ten digits, the first a 9.
 * `phone.py#_IR_MOBILE` character for character (`\d` and `[0-9]` are the same set here,
 * and Iran's catalog row spells the same rule `/^9\d{9}$/`).
 *
 * It is written out separately from that row because the twins' peel below is not a
 * catalog lookup and must not become one — see `peelIranianMobile`.
 */ const $412e1a8a99c19c1a$var$IR_MOBILE = /^9[0-9]{9}$/;
/** E.164 caps the whole number — country code included — at 15 digits. The floor is a
 *  sanity bound, not a standard: no plan in this catalog is shorter. */ const $412e1a8a99c19c1a$var$E164_MIN_DIGITS = 7;
const $412e1a8a99c19c1a$var$E164_MAX_DIGITS = 15;
function $412e1a8a99c19c1a$export$2ae1a93e018170a7(raw) {
    const ascii = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    const prefix = ascii.startsWith('+') ? '+' : '';
    return prefix + ascii.replace(/\D/g, '');
}
const $412e1a8a99c19c1a$export$4d78c43b7fa734a7 = Object.freeze([
    Object.freeze({
        iso2: 'IR',
        dial: '98',
        en: 'Iran',
        fa: "\u0627\u06CC\u0631\u0627\u0646",
        ar: "\u0625\u064A\u0631\u0627\u0646",
        fr: 'Iran',
        de: 'Iran',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        nsnPattern: /^9\d{9}$/,
        example: '09121234567'
    }),
    Object.freeze({
        iso2: 'AF',
        dial: '93',
        en: 'Afghanistan',
        fa: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        fr: 'Afghanistan',
        de: 'Afghanistan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'DZ',
        dial: '213',
        en: 'Algeria',
        fa: "\u0627\u0644\u062C\u0632\u0627\u06CC\u0631",
        ar: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        fr: "Alg\xe9rie",
        de: 'Algerien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0551234567'
    }),
    Object.freeze({
        iso2: 'AM',
        dial: '374',
        en: 'Armenia',
        fa: "\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0631\u0645\u064A\u0646\u064A\u0627",
        fr: "Arm\xe9nie",
        de: 'Armenien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 8,
        example: '077123456'
    }),
    Object.freeze({
        iso2: 'AU',
        dial: '61',
        en: 'Australia',
        fa: "\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627",
        ar: "\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627",
        fr: 'Australie',
        de: 'Australien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0412345678'
    }),
    Object.freeze({
        iso2: 'AT',
        dial: '43',
        en: 'Austria',
        fa: "\u0627\u062A\u0631\u06CC\u0634",
        ar: "\u0627\u0644\u0646\u0645\u0633\u0627",
        fr: 'Autriche',
        de: "\xd6sterreich",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '06641234567'
    }),
    Object.freeze({
        iso2: 'AZ',
        dial: '994',
        en: 'Azerbaijan',
        fa: "\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646",
        ar: "\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646",
        fr: "Azerba\xefdjan",
        de: 'Aserbaidschan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'BH',
        dial: '973',
        en: 'Bahrain',
        fa: "\u0628\u062D\u0631\u06CC\u0646",
        ar: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        fr: "Bahre\xefn",
        de: 'Bahrain',
        nsnMin: 8,
        nsnMax: 8,
        example: '36001234'
    }),
    Object.freeze({
        iso2: 'BE',
        dial: '32',
        en: 'Belgium',
        fa: "\u0628\u0644\u0698\u06CC\u06A9",
        ar: "\u0628\u0644\u062C\u064A\u0643\u0627",
        fr: 'Belgique',
        de: 'Belgien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0470123456'
    }),
    Object.freeze({
        iso2: 'BR',
        dial: '55',
        en: 'Brazil',
        fa: "\u0628\u0631\u0632\u06CC\u0644",
        ar: "\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644",
        fr: "Br\xe9sil",
        de: 'Brasilien',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 11,
        example: '11912345678'
    }),
    Object.freeze({
        iso2: 'CA',
        dial: '1',
        en: 'Canada',
        fa: "\u06A9\u0627\u0646\u0627\u062F\u0627",
        ar: "\u0643\u0646\u062F\u0627",
        fr: 'Canada',
        de: 'Kanada',
        nsnMin: 10,
        nsnMax: 10,
        example: '4165550123'
    }),
    Object.freeze({
        iso2: 'CN',
        dial: '86',
        en: 'China',
        fa: "\u0686\u06CC\u0646",
        ar: "\u0627\u0644\u0635\u064A\u0646",
        fr: 'Chine',
        de: 'China',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 12,
        example: '13123456789'
    }),
    Object.freeze({
        iso2: 'CY',
        dial: '357',
        en: 'Cyprus',
        fa: "\u0642\u0628\u0631\u0633",
        ar: "\u0642\u0628\u0631\u0635",
        fr: 'Chypre',
        de: 'Zypern',
        nsnMin: 8,
        nsnMax: 8,
        example: '96123456'
    }),
    Object.freeze({
        iso2: 'DK',
        dial: '45',
        en: 'Denmark',
        fa: "\u062F\u0627\u0646\u0645\u0627\u0631\u06A9",
        ar: "\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643",
        fr: 'Danemark',
        de: "D\xe4nemark",
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'EG',
        dial: '20',
        en: 'Egypt',
        fa: "\u0645\u0635\u0631",
        ar: "\u0645\u0635\u0631",
        fr: "\xc9gypte",
        de: "\xc4gypten",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '01001234567'
    }),
    Object.freeze({
        iso2: 'FI',
        dial: '358',
        en: 'Finland',
        fa: "\u0641\u0646\u0644\u0627\u0646\u062F",
        ar: "\u0641\u0646\u0644\u0646\u062F\u0627",
        fr: 'Finlande',
        de: 'Finnland',
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'FR',
        dial: '33',
        en: 'France',
        fa: "\u0641\u0631\u0627\u0646\u0633\u0647",
        ar: "\u0641\u0631\u0646\u0633\u0627",
        fr: 'France',
        de: 'Frankreich',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'GE',
        dial: '995',
        en: 'Georgia',
        fa: "\u06AF\u0631\u062C\u0633\u062A\u0627\u0646",
        ar: "\u062C\u0648\u0631\u062C\u064A\u0627",
        fr: "G\xe9orgie",
        de: 'Georgien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '555123456'
    }),
    Object.freeze({
        iso2: 'DE',
        dial: '49',
        en: 'Germany',
        fa: "\u0622\u0644\u0645\u0627\u0646",
        ar: "\u0623\u0644\u0645\u0627\u0646\u064A\u0627",
        fr: 'Allemagne',
        de: 'Deutschland',
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '015112345678'
    }),
    Object.freeze({
        iso2: 'GR',
        dial: '30',
        en: 'Greece',
        fa: "\u06CC\u0648\u0646\u0627\u0646",
        ar: "\u0627\u0644\u064A\u0648\u0646\u0627\u0646",
        fr: "Gr\xe8ce",
        de: 'Griechenland',
        nsnMin: 10,
        nsnMax: 10,
        example: '6912345678'
    }),
    Object.freeze({
        iso2: 'HU',
        dial: '36',
        en: 'Hungary',
        fa: "\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646",
        ar: "\u0627\u0644\u0645\u062C\u0631",
        fr: 'Hongrie',
        de: 'Ungarn',
        trunk: '06',
        nsnMin: 8,
        nsnMax: 9,
        example: '06201234567'
    }),
    Object.freeze({
        iso2: 'IN',
        dial: '91',
        en: 'India',
        fa: "\u0647\u0646\u062F",
        ar: "\u0627\u0644\u0647\u0646\u062F",
        fr: 'Inde',
        de: 'Indien',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '9812345678'
    }),
    Object.freeze({
        iso2: 'ID',
        dial: '62',
        en: 'Indonesia',
        fa: "\u0627\u0646\u062F\u0648\u0646\u0632\u06CC",
        ar: "\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627",
        fr: "Indon\xe9sie",
        de: 'Indonesien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 12,
        example: '081234567890'
    }),
    Object.freeze({
        iso2: 'IQ',
        dial: '964',
        en: 'Iraq',
        fa: "\u0639\u0631\u0627\u0642",
        ar: "\u0627\u0644\u0639\u0631\u0627\u0642",
        fr: 'Irak',
        de: 'Irak',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '07912345678'
    }),
    Object.freeze({
        iso2: 'IT',
        dial: '39',
        en: 'Italy',
        fa: "\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627",
        ar: "\u0625\u064A\u0637\u0627\u0644\u064A\u0627",
        fr: 'Italie',
        de: 'Italien',
        nsnMin: 6,
        nsnMax: 11,
        example: '3123456789'
    }),
    Object.freeze({
        iso2: 'JP',
        dial: '81',
        en: 'Japan',
        fa: "\u0698\u0627\u067E\u0646",
        ar: "\u0627\u0644\u064A\u0627\u0628\u0627\u0646",
        fr: 'Japon',
        de: 'Japan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '09012345678'
    }),
    Object.freeze({
        iso2: 'JO',
        dial: '962',
        en: 'Jordan',
        fa: "\u0627\u0631\u062F\u0646",
        ar: "\u0627\u0644\u0623\u0631\u062F\u0646",
        fr: 'Jordanie',
        de: 'Jordanien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0791234567'
    }),
    Object.freeze({
        iso2: 'KZ',
        dial: '7',
        en: 'Kazakhstan',
        fa: "\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646",
        ar: "\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646",
        fr: 'Kazakhstan',
        de: 'Kasachstan',
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '87011234567'
    }),
    Object.freeze({
        iso2: 'KW',
        dial: '965',
        en: 'Kuwait',
        fa: "\u06A9\u0648\u06CC\u062A",
        ar: "\u0627\u0644\u0643\u0648\u064A\u062A",
        fr: "Kowe\xeft",
        de: 'Kuwait',
        nsnMin: 8,
        nsnMax: 8,
        example: '50012345'
    }),
    Object.freeze({
        iso2: 'LB',
        dial: '961',
        en: 'Lebanon',
        fa: "\u0644\u0628\u0646\u0627\u0646",
        ar: "\u0644\u0628\u0646\u0627\u0646",
        fr: 'Liban',
        de: 'Libanon',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 8,
        example: '03123456'
    }),
    Object.freeze({
        iso2: 'LY',
        dial: '218',
        en: 'Libya',
        fa: "\u0644\u06CC\u0628\u06CC",
        ar: "\u0644\u064A\u0628\u064A\u0627",
        fr: 'Libye',
        de: 'Libyen',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'MY',
        dial: '60',
        en: 'Malaysia',
        fa: "\u0645\u0627\u0644\u0632\u06CC",
        ar: "\u0645\u0627\u0644\u064A\u0632\u064A\u0627",
        fr: 'Malaisie',
        de: 'Malaysia',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0123456789'
    }),
    Object.freeze({
        iso2: 'MR',
        dial: '222',
        en: 'Mauritania',
        fa: "\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC",
        ar: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        fr: 'Mauritanie',
        de: 'Mauretanien',
        nsnMin: 8,
        nsnMax: 8,
        example: '22123456'
    }),
    Object.freeze({
        iso2: 'MA',
        dial: '212',
        en: 'Morocco',
        fa: "\u0645\u0631\u0627\u06A9\u0634",
        ar: "\u0627\u0644\u0645\u063A\u0631\u0628",
        fr: 'Maroc',
        de: 'Marokko',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NL',
        dial: '31',
        en: 'Netherlands',
        fa: "\u0647\u0644\u0646\u062F",
        ar: "\u0647\u0648\u0644\u0646\u062F\u0627",
        fr: 'Pays-Bas',
        de: 'Niederlande',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NZ',
        dial: '64',
        en: 'New Zealand',
        fa: "\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F",
        ar: "\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627",
        fr: "Nouvelle-Z\xe9lande",
        de: 'Neuseeland',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0211234567'
    }),
    Object.freeze({
        iso2: 'NO',
        dial: '47',
        en: 'Norway',
        fa: "\u0646\u0631\u0648\u0698",
        ar: "\u0627\u0644\u0646\u0631\u0648\u064A\u062C",
        fr: "Norv\xe8ge",
        de: 'Norwegen',
        nsnMin: 8,
        nsnMax: 8,
        example: '40612345'
    }),
    Object.freeze({
        iso2: 'OM',
        dial: '968',
        en: 'Oman',
        fa: "\u0639\u0645\u0627\u0646",
        ar: "\u0639\u064F\u0645\u0627\u0646",
        fr: 'Oman',
        de: 'Oman',
        nsnMin: 8,
        nsnMax: 8,
        example: '92123456'
    }),
    Object.freeze({
        iso2: 'PK',
        dial: '92',
        en: 'Pakistan',
        fa: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0627\u0643\u0633\u062A\u0627\u0646",
        fr: 'Pakistan',
        de: 'Pakistan',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '03012345678'
    }),
    Object.freeze({
        iso2: 'PS',
        dial: '970',
        en: 'Palestine',
        fa: "\u0641\u0644\u0633\u0637\u06CC\u0646",
        ar: "\u0641\u0644\u0633\u0637\u064A\u0646",
        fr: 'Palestine',
        de: "Pal\xe4stina",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0599123456'
    }),
    Object.freeze({
        iso2: 'PL',
        dial: '48',
        en: 'Poland',
        fa: "\u0644\u0647\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0648\u0644\u0646\u062F\u0627",
        fr: 'Pologne',
        de: 'Polen',
        nsnMin: 9,
        nsnMax: 9,
        example: '512345678'
    }),
    Object.freeze({
        iso2: 'QA',
        dial: '974',
        en: 'Qatar',
        fa: "\u0642\u0637\u0631",
        ar: "\u0642\u0637\u0631",
        fr: 'Qatar',
        de: 'Katar',
        nsnMin: 8,
        nsnMax: 8,
        example: '33123456'
    }),
    Object.freeze({
        iso2: 'RU',
        dial: '7',
        en: 'Russia',
        fa: "\u0631\u0648\u0633\u06CC\u0647",
        ar: "\u0631\u0648\u0633\u064A\u0627",
        fr: 'Russie',
        de: 'Russland',
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '89123456789'
    }),
    Object.freeze({
        iso2: 'SA',
        dial: '966',
        en: 'Saudi Arabia',
        fa: "\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC",
        ar: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        fr: 'Arabie saoudite',
        de: 'Saudi-Arabien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'SG',
        dial: '65',
        en: 'Singapore',
        fa: "\u0633\u0646\u06AF\u0627\u067E\u0648\u0631",
        ar: "\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629",
        fr: 'Singapour',
        de: 'Singapur',
        nsnMin: 8,
        nsnMax: 8,
        example: '81234567'
    }),
    Object.freeze({
        iso2: 'ZA',
        dial: '27',
        en: 'South Africa',
        fa: "\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC",
        ar: "\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627",
        fr: 'Afrique du Sud',
        de: "S\xfcdafrika",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0821234567'
    }),
    Object.freeze({
        iso2: 'ES',
        dial: '34',
        en: 'Spain',
        fa: "\u0627\u0633\u067E\u0627\u0646\u06CC\u0627",
        ar: "\u0625\u0633\u0628\u0627\u0646\u064A\u0627",
        fr: 'Espagne',
        de: 'Spanien',
        nsnMin: 9,
        nsnMax: 9,
        example: '612345678'
    }),
    Object.freeze({
        iso2: 'SD',
        dial: '249',
        en: 'Sudan',
        fa: "\u0633\u0648\u062F\u0627\u0646",
        ar: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        fr: 'Soudan',
        de: 'Sudan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'SE',
        dial: '46',
        en: 'Sweden',
        fa: "\u0633\u0648\u0626\u062F",
        ar: "\u0627\u0644\u0633\u0648\u064A\u062F",
        fr: "Su\xe8de",
        de: 'Schweden',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'CH',
        dial: '41',
        en: 'Switzerland',
        fa: "\u0633\u0648\u0626\u06CC\u0633",
        ar: "\u0633\u0648\u064A\u0633\u0631\u0627",
        fr: 'Suisse',
        de: 'Schweiz',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0781234567'
    }),
    Object.freeze({
        iso2: 'SY',
        dial: '963',
        en: 'Syria',
        fa: "\u0633\u0648\u0631\u06CC\u0647",
        ar: "\u0633\u0648\u0631\u064A\u0627",
        fr: 'Syrie',
        de: 'Syrien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0944567890'
    }),
    Object.freeze({
        iso2: 'TJ',
        dial: '992',
        en: 'Tajikistan',
        fa: "\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646",
        fr: 'Tadjikistan',
        de: 'Tadschikistan',
        nsnMin: 9,
        nsnMax: 9,
        example: '917123456'
    }),
    Object.freeze({
        iso2: 'TH',
        dial: '66',
        en: 'Thailand',
        fa: "\u062A\u0627\u06CC\u0644\u0646\u062F",
        ar: "\u062A\u0627\u064A\u0644\u0627\u0646\u062F",
        fr: "Tha\xeflande",
        de: 'Thailand',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0812345678'
    }),
    Object.freeze({
        iso2: 'TN',
        dial: '216',
        en: 'Tunisia',
        fa: "\u062A\u0648\u0646\u0633",
        ar: "\u062A\u0648\u0646\u0633",
        fr: 'Tunisie',
        de: 'Tunesien',
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'TM',
        dial: '993',
        en: 'Turkmenistan',
        fa: "\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646",
        fr: "Turkm\xe9nistan",
        de: 'Turkmenistan',
        trunk: '8',
        nsnMin: 8,
        nsnMax: 8,
        example: '65123456'
    }),
    Object.freeze({
        iso2: 'TR',
        dial: '90',
        en: "T\xfcrkiye",
        fa: "\u062A\u0631\u06A9\u06CC\u0647",
        ar: "\u062A\u0631\u0643\u064A\u0627",
        fr: 'Turquie',
        de: "T\xfcrkei",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '05321234567'
    }),
    Object.freeze({
        iso2: 'UA',
        dial: '380',
        en: 'Ukraine',
        fa: "\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646",
        ar: "\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627",
        fr: 'Ukraine',
        de: 'Ukraine',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'AE',
        dial: '971',
        en: 'United Arab Emirates',
        fa: "\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC",
        ar: "\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: "\xc9mirats arabes unis",
        de: 'Vereinigte Arabische Emirate',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'GB',
        dial: '44',
        en: 'United Kingdom',
        fa: "\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627",
        ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: 'Royaume-Uni',
        de: "Vereinigtes K\xf6nigreich",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '07400123456'
    }),
    Object.freeze({
        iso2: 'US',
        dial: '1',
        en: 'United States',
        fa: "\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647",
        ar: "\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: "\xc9tats-Unis",
        de: 'Vereinigte Staaten',
        nsnMin: 10,
        nsnMax: 10,
        example: '2025550123'
    }),
    Object.freeze({
        iso2: 'UZ',
        dial: '998',
        en: 'Uzbekistan',
        fa: "\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646",
        fr: "Ouzb\xe9kistan",
        de: 'Usbekistan',
        nsnMin: 9,
        nsnMax: 9,
        example: '901234567'
    }),
    Object.freeze({
        iso2: 'YE',
        dial: '967',
        en: 'Yemen',
        fa: "\u06CC\u0645\u0646",
        ar: "\u0627\u0644\u064A\u0645\u0646",
        fr: "Y\xe9men",
        de: 'Jemen',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0712345678'
    })
]);
const $412e1a8a99c19c1a$export$84b76667b0a9e7b4 = $412e1a8a99c19c1a$export$4d78c43b7fa734a7[0];
function $412e1a8a99c19c1a$export$7684f8e22afec32c(locale) {
    const tag = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).replace(/_/g, '-');
    const parts = tag.split('-');
    const region = parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p));
    const byRegion = region ? $412e1a8a99c19c1a$export$586b3eaa727579f5(region) : undefined;
    if (byRegion) return byRegion;
    const language = parts[0].toLowerCase();
    if (language === 'ar' || !(0, $abf0c103b4b92127$export$3cede7c619603eb2)()) return $412e1a8a99c19c1a$export$586b3eaa727579f5('IQ') || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
    return $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
}
function $412e1a8a99c19c1a$export$586b3eaa727579f5(iso2) {
    if (typeof iso2 !== 'string') return undefined;
    const key = iso2.toUpperCase();
    return $412e1a8a99c19c1a$export$4d78c43b7fa734a7.find((c)=>c.iso2 === key);
}
function $412e1a8a99c19c1a$export$21894a57509f6ed5(digits) {
    if (typeof digits !== 'string') return undefined;
    let best;
    for (const country of $412e1a8a99c19c1a$export$4d78c43b7fa734a7){
        if (!digits.startsWith(country.dial)) continue;
        if (best === undefined || country.dial.length > best.dial.length) best = country;
    }
    return best;
}
/**
 * The languages every row is named in — the only fields `countryName` reads and
 * `countryMatches` searches. A list rather than `country[language]`, so no locale can
 * ever read a field that is not a name (`dial`, `example`…).
 */ const $412e1a8a99c19c1a$var$NAME_LANGUAGES = Object.freeze([
    'fa',
    'en',
    'ar',
    'fr',
    'de'
]);
function $412e1a8a99c19c1a$export$3162e773cd568eb(country, locale) {
    if (!country) return '';
    const tag = locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const language = String(tag).split('-')[0];
    return $412e1a8a99c19c1a$var$NAME_LANGUAGES.includes(language) && country[language] || country.en;
}
/**
 * A name folded for SEARCH, never for display: lower case, decomposed (NFD) and stripped
 * of the combining marks U+0300–U+036F, so «etats», «Etats» and «ÉTATS» all reach
 * «États-Unis», and «turk» reaches «Türkiye» and «Türkei». «ß» has no decomposition, so
 * it is spelled out as «ss» (PM-0212): «Straße» and «strasse» fold alike.
 * Persian and Arabic letters come through unchanged — their marks sit outside that block
 * — and both sides of a comparison are folded alike, so every search that matched before
 * still matches.
 * @param {string} text
 * @returns {string}
 */ function $412e1a8a99c19c1a$var$foldForSearch(text) {
    return String(text).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
}
function $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa(country, query) {
    if (!country) return false;
    const needle = $412e1a8a99c19c1a$export$522be3011864bb18(query).trim().toLowerCase().replace(/^\+/, '');
    if (!needle) return true;
    if (country.dial.startsWith(needle) || country.iso2.toLowerCase() === needle) return true;
    const folded = $412e1a8a99c19c1a$var$foldForSearch(needle);
    return $412e1a8a99c19c1a$var$NAME_LANGUAGES.some((language)=>{
        const name = country[language];
        return typeof name === 'string' && name !== '' && $412e1a8a99c19c1a$var$foldForSearch(name).includes(folded);
    });
}
// ─────────────────────────────────────────────────────────────────────────────
// The one parse
// ─────────────────────────────────────────────────────────────────────────────
/**
 * @typedef {'required'|'tooShort'|'tooLong'|'notMobile'|'invalid'} PhoneProblem
 * Why a number was refused. Each one gets its own message: "invalid" alone tells the
 * user nothing about which digit to go looking for.
 */ /**
 * @typedef {Object} PhoneParse
 * @property {boolean} ok
 * @property {string}  e164      `'+989121234567'`, or `''` when `ok` is false.
 * @property {string}  national  `'09121234567'`, or `''` when `ok` is false — and also
 *                               `''` for an accepted number whose country is not in the
 *                               catalog, because there is no national form to render
 *                               without knowing the plan.
 * @property {Country} country   The country the MESSAGE should name: the one the number
 *                               claims where it claimed one, otherwise the selected one.
 * @property {PhoneProblem|null} problem
 */ /**
 * @typedef {Object} PhoneOptions
 * @property {Country|string} [country]        A `Country` record OR an iso2 string
 *                                             (`{ country: 'TR' }`), so no caller has to
 *                                             import the catalog to name a country.
 *                                             Default: Iran.
 * @property {boolean}        [allowLandline]  Drop the country's `nsnPattern`. Iran only,
 *                                             in practice. Default: false.
 */ const $412e1a8a99c19c1a$var$resolveCountry = (c)=>(typeof c === 'string' ? $412e1a8a99c19c1a$export$586b3eaa727579f5(c) : c) || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
/** Does this NSN look like one of `country`'s? Length, plus — where the country declares
 *  one and the caller has not waived it — a shape. */ function $412e1a8a99c19c1a$var$fitsNsn(nsn, country, allowLandline) {
    if (nsn.length < country.nsnMin || nsn.length > country.nsnMax) return false;
    if (allowLandline || country.nsnPattern === undefined) return true;
    return country.nsnPattern.test(nsn);
}
/**
 * Drop a leading trunk prefix — the digits a number wears only when it is dialled INSIDE
 * its own country, and which are never part of the national significant number.
 *
 * **A trunk that begins with `0` comes off unconditionally.** In a plan that HAS a trunk
 * zero, no NSN begins with `0` — the zero IS the trunk, by construction — so keeping it
 * cannot produce a right answer, only one that is wrong by exactly a digit. Length bounds
 * are a check ON the NSN; they were never a way to choose whether to peel. Letting them
 * choose is what made `parsePhone('0218800000', { allowLandline: true })` — a Tehran
 * landline one digit short — answer `+980218800000`: the peeled body is nine digits and
 * misses Iran's 10/10 window, the trunk-kept string is ten and fits it, so the trunk was
 * kept and `judge`, with the mobile pattern waived, passed it on length alone. The number
 * was stored AND redisplayed («00218800000») wrong, stably and silently.
 *
 * **A trunk that is an ordinary digit stays conditional.** Russia's, Kazakhstan's and
 * Turkmenistan's trunk is `8`, and `8121234567` is St Petersburg — a real national number
 * that BEGINS with the trunk digit. There is no structural rule to appeal to, so the
 * heuristic is the best available: peel when the result is a number the country
 * recognises, or when keeping it cannot produce one.
 *
 * The `!fitsNsn(candidate)` half of that heuristic is also what makes a short Russian
 * number report "too short" rather than a shape complaint.
 *
 * ONE helper, used on BOTH branches of `parsePhone`. The live login theme peels the trunk
 * only on the national path, which is why it gets `"+98 0912 345 6789"` and
 * `"00980912 3456789"` wrong — and both of those are rows in tests/test_phone.py, i.e.
 * shapes this platform's data genuinely holds. This is the single rule here that the theme
 * does not yet have; it is filed as a follow-up against parsina.keycloakify. The theme's
 * direction is the safe one (it refuses rather than mis-reads), so the symptom there is a
 * rejected login and never a wrong number.
 *
 * What this function does NOT do is peel a SECOND zero. One trunk comes off; a string
 * wearing two (`+43 0 0664…`) is not a number this module claims to understand, and
 * `judge` refuses it rather than guessing which zero was the trunk — see the guard there.
 */ function $412e1a8a99c19c1a$var$peelTrunk(candidate, country, allowLandline) {
    const trunk = country.trunk;
    if (!trunk || !candidate.startsWith(trunk) || candidate.length <= trunk.length) return candidate;
    const without = candidate.slice(trunk.length);
    if (trunk[0] === '0') return without;
    return $412e1a8a99c19c1a$var$fitsNsn(without, country, allowLandline) || !$412e1a8a99c19c1a$var$fitsNsn(candidate, country, allowLandline) ? without : candidate;
}
/**
 * Iran's rule, exactly as the twins write it: drop a leading `+`, then peel `00`, then
 * the country code `98` when what is left would be too long to be an NSN, then the trunk
 * `0` — and require the remainder to be `9` plus nine digits.
 *
 * A LINEAR PEEL, not a catalog lookup, and the difference is the whole point of this
 * function existing. The peel never asks which country `990…` belongs to, so
 * `+9901234567` is read as the 0990 mobile it is. Asking the catalog instead is how this
 * kit used to answer `+9901234567` where both twins answer `+989901234567`: no row starts
 * with `990`, the number fell through to the generic "some foreign country" accept, and
 * `lookupVariants` then offered ONE spelling. A Keycloak probe in that spelling misses the
 * same person stored as `09901234567`, and the auto-provisioning flow mints a duplicate
 * account — the precise harm this module exists to prevent. Seventy-four live Iranian
 * ranges (0940–0949, 0950–0959, 0960–0962, 0967, 0969, 0970, 0972, 0975–0979, 0990, 0991,
 * 0996, 0997, 0999) were wrong that way.
 *
 * Line for line this is `phone.py#normalize_phone`'s body after its shared prelude, down
 * to the sequential `if`s — they are NOT mutually exclusive there and must not become so
 * here, because `+00989…` wears all three prefixes at once. `phone.test.js` executes this
 * against the real Python over a generated corpus so the two cannot drift silently.
 *
 * @param {string} s  Folded, separator-stripped, already matched against `DIGITS_ONLY`.
 * @returns {string|null}  The ten-digit NSN, or `null` when this is not an Iranian mobile.
 */ function $412e1a8a99c19c1a$var$peelIranianMobile(s) {
    let t = s;
    if (t[0] === '+') t = t.slice(1);
    if (t.startsWith('00')) t = t.slice(2);
    // The `length > 10` guard is what keeps 9812345678 — an ordinary 0981 mobile — from
    // being read as country code 98 followed by an eight-digit stub.
    if (t.startsWith('98') && t.length > 10) t = t.slice(2);
    if (t.startsWith('0')) t = t.slice(1);
    return $412e1a8a99c19c1a$var$IR_MOBILE.test(t) ? t : null;
}
/**
 * The last word on an NSN once the prefixes are off it.
 *
 * The first guard is not a length rule and deliberately runs before the length rules: in a
 * plan whose trunk prefix is a zero, an NSN that still BEGINS with one is not a number
 * this module can read. `peelTrunk` takes exactly one trunk off, so a leading zero here
 * means the string wore its trunk twice (`+43 0 0664 123 4567`, and 94 shapes like it
 * across 17 of the 52 rows). Accepting it was worse than refusing for a reason that has
 * nothing to do with the user's typing: `+430664123456` fed back through this module
 * peels the surviving zero and answers `+43664123456`, so the kit emitted an E.164 it
 * would later read as a DIFFERENT phone — the one thing a matching key may never do. A
 * number cannot be both, and guessing which zero was the trunk would be inventing data,
 * so the answer is `invalid` and the value is refused whole.
 *
 * Italy is the reason this is gated on the trunk rather than written as "no NSN begins
 * with 0": Italian landlines genuinely keep their leading zero (`+39 06 …` is Rome), which
 * is exactly why Italy's row carries no `trunk` at all.
 */ function $412e1a8a99c19c1a$var$judge(nsn, country, allowLandline) {
    const digits = country.dial + nsn;
    const fail = (problem)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (country.trunk && country.trunk[0] === '0' && nsn[0] === '0') return fail('invalid');
    if (nsn.length < country.nsnMin || digits.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
    if (nsn.length > country.nsnMax || digits.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
    if (country.nsnPattern && !allowLandline && !country.nsnPattern.test(nsn)) return fail('notMobile');
    return {
        ok: true,
        e164: `+${digits}`,
        national: (country.trunk || '') + nsn,
        country: country,
        problem: null
    };
}
function $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options = {}) {
    const selected = $412e1a8a99c19c1a$var$resolveCountry(options.country);
    const allowLandline = options.allowLandline === true;
    const fail = (problem, country = selected)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (typeof raw !== 'string') return fail('invalid');
    let s = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    if (s === '') return fail('required');
    if (!$412e1a8a99c19c1a$var$DIGITS_ONLY.test(s)) return fail('invalid');
    // ── The twins ──────────────────────────────────────────────────────────────────
    // `allowLandline` does not switch this off: a landline is not an Iranian mobile, so the
    // peel declines it and the catalog below is what accepts it.
    if (selected.iso2 === 'IR') {
        const nsn = $412e1a8a99c19c1a$var$peelIranianMobile(s);
        if (nsn !== null) // Iran's trunk is `0` and its row is fixed (see COUNTRIES): `0` + NSN is the
        // national spelling, `+98` + NSN the canonical one.
        return {
            ok: true,
            e164: `+98${nsn}`,
            national: `0${nsn}`,
            country: selected,
            problem: null
        };
    }
    // ── The generalisation ─────────────────────────────────────────────────────────
    let international = false;
    if (s[0] === '+') {
        s = s.slice(1);
        international = true;
    }
    if (s.startsWith('00')) {
        s = s.slice(2);
        international = true;
    }
    if (s === '') return fail('required');
    if (international && s[0] !== '0') {
        const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(s);
        if (country === undefined) {
            if (s.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
            if (s.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
            // Accepted, with no national form to offer and the picker left where it was.
            return {
                ok: true,
                e164: `+${s}`,
                national: '',
                country: selected,
                problem: null
            };
        }
        return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(s.slice(country.dial.length), country, allowLandline), country, allowLandline);
    }
    const candidate = s.startsWith(selected.dial) && s.length > selected.nsnMax ? s.slice(selected.dial.length) : s;
    return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(candidate, selected, allowLandline), selected, allowLandline);
}
function $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).e164;
}
function $412e1a8a99c19c1a$export$f9c4d85d720ef909(raw, options) {
    return $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) !== '';
}
function $412e1a8a99c19c1a$export$317852993b4735b6(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).national;
}
function $412e1a8a99c19c1a$export$1069b069fb83ae5b(raw, options) {
    if (typeof raw !== 'string') return '';
    const parsed = $412e1a8a99c19c1a$export$48c6adddc5539199(raw, {
        ...options,
        allowLandline: true
    });
    if (!parsed.ok) return raw;
    // A number from ANOTHER country is shown internationally (PM-0078). A national
    // spelling carries no country, so `07400123456` on a desk in Tehran is dialled as an
    // Iranian number; `+447400123456` cannot be. Compared by dial code, not row, because
    // `+1` resolves to Canada whichever of the two the caller called home.
    const home = $412e1a8a99c19c1a$var$resolveCountry(options?.country);
    if (parsed.country.dial !== home.dial || !parsed.national) return parsed.e164;
    return parsed.national;
}
function $412e1a8a99c19c1a$export$1f64b92865689d0d(raw) {
    if (typeof raw !== 'string') return '';
    if (raw.length < 7) return raw;
    return `${raw.slice(0, 5)}***${raw.slice(-3)}`;
}
function $412e1a8a99c19c1a$export$493e0fb9b5aae030(raw, options) {
    const e164 = $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options);
    if (e164 === '') return [];
    const digits = e164.slice(1);
    const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(digits);
    // An accepted number from outside the catalog has no known plan, so there is no trunk
    // prefix to add and no national spelling to guess at. One shape — the only one we
    // could ever have written.
    if (!country) return [
        e164
    ];
    const nsn = digits.slice(country.dial.length);
    const seen = new Set([
        e164,
        digits,
        `00${digits}`,
        ...country.trunk ? [
            country.trunk + nsn
        ] : [],
        nsn
    ]);
    return [
        ...seen
    ];
}


// GENERATED by tools/build-flags.cjs from flag-icons 7.5.0 (MIT, lipis/flag-icons) — do not
// edit by hand. 40×30 PNG (2× the drawn 20×15), base64, one per row of COUNTRIES.
// prettier-ignore
const $b7cded1008753984$var$PNG = {
    IR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////aAAAjn0BcuHLjQEDnVVVuwIHrc3P+9PTvjo72+/f74uKHy5fzqqqU0aOk16+XZwNwAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAr0lEQVR42mNQwgIYBqGgsbFxMhCCgRkQggDDmWPJf8yepZ05lvYmLe9wXlrOmbQ8Bi4uLoYFCxZwcXVvAJFgDgMMcG+fsYEBHczdXn0TXYy7nL2gHF0p51X2gtgJaIK8VzgLfC+ga58+s7ISw6bbriF7MWznuCiLUMjBwcHQ0NDAwcG9AUSCOQwhLiEuri4uYMoVzHZ1YagsDZ0eOrUUTFWWxIaGTw+NZBDEAgahIAAf7Fwe+04+vAAAAABJRU5ErkJggg==',
    AF: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEW/AAAAAAEAmQCAEQCAAADdeHfRRUXLMDDVVlbFFhbhhYTZZWTvvrzppqXDDQ2BDgJ/AJzcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeUlEQVR42mMQBAMRBjAwUgIDhqEmyJlRXoAhOG1aexm6IFvf87oXCWiCMxL2nGbrRBNMrYs5+jwMTbAnO7x02wk0wdCdMamzQ9EEdzXEHuVYjSZYkXYrKq0dTZDr6vTKmAVogpytV3dFTED30ay7d1diBsgDviEXcQB/Wk8LWL2d8wAAAABJRU5ErkJggg==',
    DZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AYjPREDQTWzP87vG5GTP2z9bldopePTN6MjP++/zslaXeTmlERzPytsGQKjOhIQw3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mMQhAMGBBgcgsI39jmgCwpPUlJSd0ATNFXSTPErQxUUDlI1ZGBgc0ARlFQKFmTgcliAImik1CjowJ6Aqv2SkqHgniI0wSZVQcE1SqcdCAti1Y7VIqxOwup4rN7EHiBYg24QRTEAq40s8eFvTBUAAAAASUVORK5CYII=',
    AM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEXZABIAM6DyqACw8tlJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZAEAsY2oJKWMCQFgQAQLMn2UPulzIAAAAASUVORK5CYII=',
    AU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAIv/AgL//Pz/bGyNi8rd3fBUVLEYGJZzc780NKO2str+iIn/JSX/yMjvoaq2g62b1p0wAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA+klEQVR42mMwimTg2CjswDDvNAMC2FxqAAly2FxCEsyW1qrYKOy+5pAakiDnG6OQjcLrhFULkAQZWGwubRS+c8kBoqQTLKcEBBuFQSSIx6YEFhSEAxCPQzUBU5AhjQGLIASgmgkCIAM4dM9uFNY97AAT4wgtYGBf9GbLRuGlyqeA1k4AOxFo11TlcyAfLXrzjKE0AqzUhYEBqBHkdxbdwwypKjAjHm6DhNJUZQYOBwYcgBObYNIELIKVMAZ7ARZZjgZMsZRZkW4YglxKSgGYupWU4PphdrMvUlLSglrFFgUVZZ8WpJoJFWRRSoDpiVoKN2oJnLWAi4GaAACk7z96Qd+VoQAAAABJRU5ErkJggg==',
    AT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX////IEC5cagsYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYhrTg8APDLo4As4YakeJ1P9cAAAAASUVORK5CYII=',
    AZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEU/mzUAueTtKTk/nDXuM0P////sKjnxV2Pza3b4qK/2lJz1iZHyanX1ho/6wsb6wcaXspUqAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFJJREFUeNpjEMQCGIa0YJISBKjvLlKCAZigytM5vU7ognoxSkolTmiCpZOUlDpXoAluPaSksjTKiQhBrNr1sVmk8nUGppOU1PciOZ7ZGBMMaUEAYGdewLA+W8AAAAAASUVORK5CYII=',
    BH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAJ1BMVEXOESb////SJTjtp6/++Pn1z9T66evmiJLXPU7gaHXPFirQGC3icH2vW5DzAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAKUlEQVR42mMQFBSM2cCABoCCgukKWAQFnRuIFMSmPXIBFotGbR95tgMA4tMe9v5fIp8AAAAASUVORK5CYII=',
    BE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXbuwr5hhoAAAH/2QzzGDDlGv6LAAAAAnRSTlPHx/co26IAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAaSURBVHjaY1ACAwVjMBBxAQOGUcFRQVoKAgBG03Gtsi/apQAAAABJRU5ErkJggg==',
    BR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX45QkinkUrSaM+WaXa2RWbubxesjQ9pz20zhyJwChmfrhVaYXGvzGgoku93cV8h2YIpy45AAAACXBIWXMAAC4jAAAuIwF4pT92AAABA0lEQVR42mMQxAIYyBBMccMUlGBgaEcXFHNgYGBJRBUUb2AAAo5CFMEEBt7N1n8YOJEFKxh4jJSUlLZAjQULSjIwXAKKKSk7MEyECQIN5FECgw0MLIVQwQkMDKyhoYuBgroMYGOBgiVAe4+Ghr4LXaSkDWS6gQQlQY65paSkFffUSAnoWoZGQQaQqxkYPoFMXPpK6QADyA9wQS2g6LpgqCBE+yVjJeXFSspxIBXtIItSgIxTRkbKQHFTmEVgJ3ErKyktUlK2Bfof5ngHoOOBZhobb4CEFLI3FxkjeRMaIEbAAHFHDroUBt7d6EGHPZDB0QExEDniJLFEHPYoFhQsJCPZAACz20xO82VhQQAAAABJRU5ErkJggg==',
    CA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXqlY/pk4zplI3////VKx7qkYrjb2fYOCz++fj1y8n87u3zwL3uqqT54N7eVUvlfnalRQo6AAAAA3RSTlPEwsLgduwSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAi0lEQVR42mNwAQIHYzgQAfEZ6C9ouhiL4PJgTMHdIbXBGIJTXFyS0QU7lri4BDejCu49Zu7isvPVXBTBFJcwF5ftLr4ogkdcwKAYWdDiC0SwEpvKVyiC1iUg2q0Z1UnTQXQwmjttgJQf0PEqKIIx2+bEN6MJGhubNWMJJbPFxApagrWrDFAUQwDYdgDA65dwevVm0gAAAABJRU5ErkJggg==',
    CN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXuHCXvJiP//wD0ahj94AX5ow/xRh7vLSL8zAjzXhr+8AL4mxD5swzvIiTwMCL1ehZhA9qiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZklEQVR42mNgwAMYsQluRRdgZmDg3foATVBKgIGBjx1N0MgASLAGoGh2WbTEmYGhNBBFYYaSSgJQP5o9SsqYruHx9wGSbAkogqIF0kDrKxqxuJ5zAoYQbyY2b3Y8wBIemQyjgBoAAEO/DOML4QfFAAAAAElFTkSuQmCC',
    CY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////UdgD07uT7+fXaiCHLzsK9wrPpuXzuyZqvtKLe4NjeljvlrGP027ydpI2Olnz/VpYUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAn0lEQVR42mNgoAMwwBRiLlfAFCtpwFTYsheFq6HEwKC+URxVjaGgiKOgNJpmRUEgkEURuuK+ESQogWxnraMgBFxAEt0IEfLxOYwkWAgRRLXGBCwmg+oZDqCZItvRPch74giGn1mVGSzAzlBDEuR6CqVfIQvOnACmZ2Yh69dPA4mmxS9ACUe9sEnMU+OUUa1iWvY19OUqjPA1TTNgoDsAAH0MH3woys8hAAAAAElFTkSuQmCC',
    DK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAADFBMVEXIEC7////QM0zXUWbL25x8AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJ0lEQVR42mNgAANFQSEGDDDsBZXAwFBQWAkBGASxAEoFsVo0gkMeANYLEN9rIYw3AAAAAElFTkSuQmCC',
    EG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbt4LPm05f279n7+O/q2abz6cvv473gyH/SsUfizYnSsUjUtE7UtE+FUiyCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVR42mNQwgIYhrQgHHAGMGAANtaABAzB5ow2CwxB6+M1mzEEq9es2o4h6Lui6wqGoL+x8RMMQfcWjxIMwWTLydMwBFknGyNcL4gFDGlBAONAN6Idm2N7AAAAAElFTkSuQmCC',
    FI: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAHlBMVEUAL2z////n6/HZ4On19/n2+PrFz933+Prf5eze5OxGbJvuAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAM0lEQVR42mMQBIECBgYGZkE4YACTAUNUUAkEGoCCbEpwwDBUANi1E9AcD/aXAza/D1FBANf4HwFP43uLAAAAAElFTkSuQmCC',
    FR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAJH////hAA/1qq+qqtocVNyOAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGklEQVR42mNgAAMWQTAwUgIDhlHBUUFaCgIANE0qMRXTPuoAAAAASUVORK5CYII=',
    GE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAIVBMVEX/////AAD/xMT/6en/KCj/ODj/uLj/aGj/t7f/Nzf/Jye3ao04AAAACXBIWXMAAC4jAAAuIwF4pT92AAAATElEQVR42mNggAJGQUEBBnRAlCBTEUJQXQEqyCGGEGxMgIgxu4o6wwStJoYYYAiaBM4ywK0du0WUOF4QC6Cf4ACFvEkg1pAPoWfIAwBUiRrZ67e50QAAAABJRU5ErkJggg==',
    DE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUAAAH/zAD/AABTrXiPAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    GR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWXudzc5/N0otAvdLlkmMzO3u6JsNdomswWZLFHhMH///8NXq9elMpdk8mvyuWUuNy9t6ayAAAACnRSTlPHx8fH7fnw4O3tua1jCQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFxJREFUeNpj2L1796lVu1EBA+mCEwURAC54axUCYBc8c+bMr1VAwoEBCcBkXyNbRLwg8bbjFWw2RgASAsTFxSU1FEgUKSEAwyosgATB3VgACYKCWAAJtmMFlDkJADpQb8rhqOSNAAAAAElFTkSuQmCC',
    HU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEU4jQDUNRb////UNhf//f0fKhQYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHUlEQVR42mMwxgIYBLGAISPoggUwKGEBQ0Zw2AEAn7AtKfgzYVIAAAAASUVORK5CYII=',
    IN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/////mTMSiAfj4/JjY7hlZbiUlM1bW7TW1uy3t93X1+yVlc1ubrzY2O1gYLVubrvbBsOsAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAQ0lEQVR42mMQxAIYhrQgXsDsGncBQ9DcanExhqDz7EwTDMGI/NOtmIJ7vmEKPp6WaYoheB2bRcwuLgb4Ha2EBQxpQQB5PzXw6CctoQAAAABJRU5ErkJggg==',
    ID: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXnABH///9GPYQdAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mNgGAXkAkEsYFSQGEEARNwT7a82wgIAAAAASUVORK5CYII=',
    IQ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbe7uZsso/n8+2z2MYAej1bqYLO5tqEv6L0+ven0bwrkV5CnG8HfkLIbu0WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNQwgIYhrQg6YCH4QADp9kGVMFlDA0MYS6oglwHMhsYUlAEOaNmrOro5nniEoAkyPa/vLzuBW/5lQvItmQaG5uGshqbGpDqPkEsYEgLAgC7sTrOTPRwzAAAAABJRU5ErkJggg==',
    IT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXOKzf///8Akkaq28HvuLydaqNBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGUlEQVR42mNQAgNlQTBwYICAUcFRQVoKAgAHkC93JNeyBwAAAABJRU5ErkJggg==',
    JP: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///+8AC3z09u+BTH//v7+/P3WYX3BEjz22+HegpjsuMXUXXrtusb23uTeg5nBEz3t9p09AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mNgoDdg1VoUgC7GkS4oWNaAKsYyWRAILB1QBL0FwWALiuBEiKAkshivIURQGNlUNkEoSEASjIcJliIJKsIEhZAED8IEpbAJyhDSjtUirE7C6niYN+UIBwgk6OwcCAcy9uigOQAAuKIYLYzUZfoAAAAASUVORK5CYII=',
    JO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/AAAAAAH///8AmQD+AAD/QED/srLEAABNAAHEIwBNawD/Dw//6Oj/qKj/KytAcwA4JMd5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAe0lEQVR42n3Puw2AMAwE0GuokJBYgRWyACNQUTJHZqFhBQZiGHBCjH/iqtNTItvIow/mHCFyhF4JnRa0WtHoi1obKmWUii/r1IJIESn1vju1ln4t+i21IUJs0fdo0N9KYnk+c08cRmGM0hoqe1FbRWMFrRE6e9BbwuEt3d6mRppivxM/AAAAAElFTkSuQmCC',
    KZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAq8L/7C19y3mKz3EWsbVNv5VvyIE6uqAjtK1lxYcMrruZ02mz2Vqm1mHM4Err5zn1kEx1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA60lEQVR42mNgwArcvbAIqu3CInj2BhbBTbewCJ7GptJsC5Th4YAQnJwAoTuVNBtgYizWqWCaNT0yXBUmyGVpAabb4gTlIwugghw2EPmpDwUFv2vBlCZPAZuiKigoKJQB9xFYmkUTKCidDhPcfAVkzRKQSuGMpTDHHwESwQrTPwoKimslByAJxv1qihcUnFnwLgFJe18S6/Rs9Wmc5wqQLGIOn1CkllRQXuOA5CSuLa1d7V1LoyxQHO/MkJyerLCoAMWbXCUMng4s09EChIHTisE4AD3oOKL3bMcMZILRgTXisEYx1sSANdlgAQBsEkHVTQYmTgAAAABJRU5ErkJggg==',
    KW: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////zGDAAAAEA2UEAgidRCBEAQRQADgUAwzoVAgWkECABAQIFBQYICAngFizfFiwsWLaJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mPIMMYEDOrOWASV1JqxCCqVYBNUysAmiGEsSBDDWLAgurEQQTRjoYKoxkIFlTYwIAPqCB6gTPACRYKaCwWRAFQwThBTcJYgpqDqQ0xBVAOhgnGCmIKzBDEFVT9iCmIYCBKMxxQTBABu501a6aV2MQAAAABJRU5ErkJggg==',
    LB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX4sLTTr6WhrpH////uFh8CqVFNw4UotmvZ8+UWsF9jypSH1q05vHej4MDA6tTt+fModX5RAAAAA3RSTlPAyNIAJ7wgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmUlEQVR42mNwwQIYBlYQDhgRTAZjGGivgDPhgvZTQ/MwBM1mVkZ+Rhd8vm169GU0wV9hx1Zlogv2LgsNrZnWjCrYFnpsaWjZZRRB2/CdoaWhYaiCFtdjQkOrV1agCPZEhq06Gpq2G0Vw28rQ0ND0qedQBL+t/REaamyxvRnV8dahoY/RvWmx6t1xeIjAAosJGHZC8KAbfFEMAFLInkrFWlo3AAAAAElFTkSuQmCC',
    LY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAAHnABMjnkYQSiJ7AAoNDQ5BQUJsbG2jo6MkJCW3t7eWlpZ6AAri4uLt7e3///9apKbEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAARElEQVR42mMQxAIYBlbwiAsG8GGgFqgowxTjWsoQGYAuWBvAwLYzAU2wm4Eh498EYgSxasdqEVYnkQmMsQAGJSxgYAUBQNozH9QbWmcAAAAASUVORK5CYII=',
    MY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUBAWXMAADUJib////nh4fibm7wtrbcTk5qVTwrIlX429upBBbyu7v7yQGwjCDitAxVRiJQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAApUlEQVR42mNggANBOGAgILgKDkA8zglgQWM4AHI4/nVgan8/gYFz5gRUQY4bDAwzOjoZGFzggIGB/wMDw7y7L1HN5H3AwNl79wcDQzkcAFUCBfvv/piAYibfBQaGjv8dqCo57wEtm9mA5s5eoCUg55+BA5CH+jpIDBAUM7EI7oYDJO2CWABDGhaAZBKSmUpYAHYzQ7EA7Ga6YAHYzcRqO1YzsQkCAB2DeG8b518IAAAAAElFTkSuQmCC',
    MR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAYjPNKj5mRjn/xAAcbS2goBI9eSaHlhjouwR0jxsQaDDFrgv4wQFchSCwphAscyohwGQSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjklEQVR42mMQxAIYKBRUwgIY8AO2BCyC7AWYYu4V7SWYupst0PSDuMXmICkkwQlAvPM2kOBEEgxhYOD6wL+AgcEVSbASxpiOJHhjAYTm6kUSXPMAQvOdQhJkNYXQwQFIgizN+0HUbwsHZIfmGL91YLlnfAzNP8ZAgO4nV5BgCLrfPaO3TmGgEsAacTRIIQCjVisn0uVIegAAAABJRU5ErkJggg==',
    MA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXBJy1mQi+uLS1uQDClLy5aRjAUWzIyUjEZWjKbMi57PC+NNy83UTF1Py8NXjNWRzBcvfykAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPklEQVR42mNgGL6AxQGLIKMAFkH2AgwhztAf/aET0EVXHLbpwrTn7T1Mm5jK0hUwBJmztxlgukiBSYBhZAEA3FMKXRTvT/sAAAAASUVORK5CYII=',
    NL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUhRouuHCj///+QNKGcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mMQxAIYhrSgEhYwtAWHHQAA8cMn2RePrhMAAAAASUVORK5CYII=',
    NZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAJH3JES/++/wCImrklaPQMEnefo+PlbYcOoFpdKWBhKzYYnVCW5e3scfyxc3n4ukbs7NpAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVR42mPY9MPYylGs2PhICAMCbH00GSRolfoISXCKiC5QsOLqfk0kQYurm747il0J029GEjQ23/rIUezpo2JjJEElIHAUA5Fg7gEwKQgHIB5nVgMWwTAsKnlmYTMTarulfpyjmF4Y3HZ2kDsvPfV1FLuvHQt05wmQ4NIbDAzn1WK7gD665OrDwLkN5KDjExgY9KOLQX4314tm4IiGmenqAwml89oMHCcZBhhMwCLWuesApiCXNBaVnMsZBhwAAPtnOCIlvtmpAAAAAElFTkSuQmCC',
    NO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAJmTtKTn7ys4fQHf///8EKWb+8vMDntwIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPUlEQVR42mMQBAEhZwYTRUE4YBh+gkogoAYUTFKCAwYXMAAKuiAAgzEYmDIEGyMAA/EAq3asFmF10siIDgBIBDxNHFl+NQAAAABJRU5ErkJggg==',
    OM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXvLSn///8AkCX6ubjHPSjaNSjxQT397ez2gX/4nJrzYV/709LwOTX5sa/7yMf1dXKxEGopAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNgAIFEQRTAwLDgNxemYOf5xZiC7LfLMAR5i8t3b0AX5LIsP9GAob23sgGLRQxrD6ALcj5g4HiAoRIEDhujAIahD1hcUABEMEgJBQxpQQDyzjeG2etjuwAAAABJRU5ErkJggg==',
    PK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUMWQv////J2sg2djUWYBVtm2yyy7FWjFYmayXe6d79/v1+p36dvJz3+veGrYZOh01DlvGiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeklEQVR42mMQBAIFBjQwiAXZGzAFWVIZGDjQBdkmMDBwhzagChY+YGBoE0NTqVjAwPDnpgGKIMtCoCDzBlTtzIIBQMscGNAEEzDdyXJxMRbHJ0o6YApaCU4GckpQBfkEpVK/bwpA8/teIH0VPUCYTwrOacAMOofBHJsAmkIgJ8nEUEMAAAAASUVORK5CYII=',
    PS: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXtLjgAljkAAAD////IMzOWVDiXHST82tzwT1fuNT/4q68qhDlfEhZfbDgqCAr0eoGf0o+MAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeElEQVR42o3OsQ2AMAxEURcpKKDwCqzAJKyQFdiGLViJFViAxImQ8Z0QLp90X5Y840k6CcrIUDJDDBTEQEUIGMaAYQw0DIGOw7a46yg7Q7kY+sCDPvCNdH79fIk+v6q/ZpMipoPge9wwjA3j2DCOK8K4II4L4lj1BvDTQ+3mvvDBAAAAAElFTkSuQmCC',
    PL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXcFDz////vuDXSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    QA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWNGz3////z5ummTGfhw8ytWnPChZiTKEjRpLHZs76ZM1KzZ378+fratcD69fe7dovPfIyeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAANElEQVR42mMQBAGN7QwoACwoKOOKKSg0fwGm4GUGbNqfJBMpiFU7VouwOgmr40d9NJh9BABnYibF3uZjAAAAAABJRU5ErkJggg==',
    RU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEX////VKx4AOaYLRJEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    SA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUWXTHD1so6dlCUtKC6z8KevKkqa0J6o4pXi2tKgV+JrZdumn+sxbbT4dhjk3Xo7ur50TcyAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAl0lEQVR42mNgGJyAc4Ym97Tq1ZrTlBQS4IJJzme0H04vtIhqiToAF1SWjepwPeIuveqJXQBckM+1OGlXh9M148rrCEH24v/iocqXgo1nxxrABdkqgqdFyV80X5xheAxhkWCwbqPNo2XLj9SZwQVniEQvdOrRm5LTtO8AFhez0SdgmFC5hoKCgrIivi4KmCq5SxUGaeQyAABIGCoBr6ooaAAAAABJRU5ErkJggg==',
    SG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXfAAD////mMzPhDg772NjudXXpS0vkJibrX1/1qKjwh4fznJzjHBz3wMD85OT97OwLMeD+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYklEQVR42mNgIAEwrUzAFNzoxKCALsYtf4DHFV1QUZSdIYkdTXChzNkABpUGVMGJAhwJDKxopm4UZjAAQlTQKMa8lekSmiCLCMMK5uloguwPJ2PxkdWTBAaygSAWMCpIjCAAWLQjMqdY6EMAAAAASUVORK5CYII=',
    ZA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX9/v3+uRUUgE/brRp1pKfd6emZbw1kkTMvIQTrf3j50s8AeEcAAAHhOS0ADIr////nnyzWAAAAC3RSTlPv/eDZxsnBwd7m4E+UGYYAAAAJcEhZcwAALiMAAC4jAXilP3YAAAClSURBVHjaY9i9e1P8r7uogGH37t1b+DkxBXer/l+LKbjb4cNcFEEjkCCasQyC1bsxjGVIFNbGMJbhhKE4hrEMZ44JYhjLcOZMM4axQMEzcGNhACQIN5YBBoCCMGPhACwIMxZVEGYsYUFs2rFZhNVJ2BwP9ybLOyhACpCv7+CCiKDzQwjCDYx7hxDEMBAkiGEgSBDDQJggioFQQVQDIYJoBr579w4AID2uWajS1fMAAAAASUVORK5CYII=',
    ES: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXxvwDOag2qFRvmsgu7YhjStSK1PBfbmQnNhg7UvW23VRPTp6e9oUDAc1fSwrl3SlO5GvFDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mNQwgIYBlZQEAtgwAMMsAkGYxETcfPA1NzSIY4uxlws6DnTHF10ckbePk40MfaLOXn7ZNEcwLE95f/u6gI0wcte/5fZogkyP/ZyW8aHpp012OvWklB0waM2Mw/EBDAQAFiDbvBFMQDs8UAnWwjUdAAAAABJRU5ErkJggg==',
    SD: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmgAAAAH/////AAAAUwAWggBdYgD0BwDS7dKZ15koqijSGwCZPgAAGwH0+/Rdv10nNCULAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdUlEQVR42o3OsQ2AMAxEURekANF4BVZgAqbJHqzEJCyESJwIGd8J4fJJ92XJK56kg6DMDCUzxEBBDFSEgGEMGMZAwxDoOO2Lu44yMpSLoQ886APfSOfXz5fo85v6azYoYjoJvscNw9gwjg3juCKMC+K4II5Vb7xWROdp9YXoAAAAAElFTkSuQmCC',
    SE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX+ywAAUpP1seVEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAG0lEQVR42mMQBAEBBgZGQQRgGCGCAwtGcMgDAE6xGxmZ2zxDAAAAAElFTkSuQmCC',
    CH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEX/////AAD/0ND/YGD/Tk7/9vbc5piHAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVR42mMQxAIYaCkoYmzsiCEoxMCgOECCTkpKqgwMQUpKKkiCBgxQwEw9QawWDazfcUUHrRMDALp+J5UUpHr1AAAAAElFTkSuQmCC',
    SY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8Aej0AAADOESb31tnWM0X99vfbT1/RHTHniJPzwMb76OrvsbjqmKHTKDvfYnCfYG3WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfUlEQVR42mMQxAIYhrQgTuAAIrg3gEgWuOAXEMF7AUT6w8TYOkEkewGInJEAEeOMswh3YDgabBrDwFLa/HQCRPSEcTXQsGBToNHbjXug2jOMQcYVm4MMNm6DCi71BBrH9uYc0Dj2KVFQwWVAyMCygRuoPQsIcQElLGBICwIAQ45Aa03Ys2UAAAAASUVORK5CYII=',
    TJ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////MAAAAZgDibW1uqG7//vv96aH/+ur+8sb74Hv97K3844X+9tf611L722f85I0rCMw5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdklEQVR42mMQxAIYBqGgMRbAAAc8BxgwwCrOCaswBNNYA9LQhFjbQWRFAKrgNYb67wy5qIIMoQzV24EECgBazdGA7gDOCQxsCSASxcyAzn2vZ7Cimdn7LGtZ3g10d9ZlT3uOLsZ+e0XX3gIYzwULYFDCAgahIADpxEPh9dNYsAAAAABJRU5ErkJggg==',
    TH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEWlGTEtKkr09fjV1t1LSWXo09kUPIcoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJUlEQVR42mNgoBcIxQIYlLAASgVdsAAGQSxgyAgaYwE0CTp6AQB3hDElR27URQAAAABJRU5ErkJggg==',
    TN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXnABP////pDyH/9/jybXj0goz1l5/qHC3+7u/uSlf3qK7wXGj71tn84uTsMkL5vMHVD65hAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkUlEQVR42mNgGLyAfWt0AYbYQkFBKXTRFxIpbo330BQ2JrG7+ssqoAhyiTFsNhQ2TEARLGziFIwQFDRCEdyYwC/oGWIoiSIY6MB8tEBHUARd8FoBD5ogSLt3Cpr2wiY+wwx0i9ikGGYIShgGoDr+4nKmLf4yqI5neCu8NMrwOJrfmZIFBU0V0IOJaYqnwiCOWQCf5x5RzATURwAAAABJRU5ErkJggg==',
    TM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAhD2qQDNyWTaIYzXPMTBLXTuCTTe2ZTHcWS+kcTiYZVlxu5Opg3sznWRtaEfT6t5XcMERAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA3klEQVR42mNgYGAutFpYzIAGmC0frXmELsi67lXWUnRBpjN5kUYMDHsZLiBrlzo1TQhIb+BGFixxcSkGqeRGUsosrpkoBBRj4N6AEGSLfPgyCKibgR9ZMDAxMQjEuI9sZubLyCQGBt7bf1EsEiwBWsS7F8VHhYKCmN4UCg0WQhdkU5ISUsImaIShXTg0EkM70HYRTIsqOjqKMARbw0Kb0AXZg+fNC8NQWRqIqZK5oh2LmVhtl6w5g+nNmWvWHMIQPLNm5SQMQa8zk50wBFtcXDCcxNbh4oEp6NLSgqodADs3OvJyxTvoAAAAAElFTkSuQmCC',
    TR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXjChf////lFCDmISzoND/3ubz+8/TqSFL6zc/84+XxhIv1pKnuY2vzlZvvdHvsWGBydz1BAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhElEQVR42mNgGFqgemLGYnQxVUHJXVcPoIoxNYo9YGDwQRXkFkwHSTmgCDoKPgBRCvbIggvFFEAUs6VREUIwUBRMMRdOe4AQbJQGUx6CogyYKg+KGWCYyeRpfgDZ9gUgysAF2XZeQXFMdzI1Ci5iYKhB87u2oFjsjg/oIeLbOfXRYI5GAK4SGZ7PHOUxAAAAAElFTkSuQmCC',
    UA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX/1wAAV7hKNkFnAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    AE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAAAH/AAAAcy/////AHAzAAAD/Pz+OQQvYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAH0lEQVR42mMQBAMRJWTAMAwExYyRwXAQFGVAAUNZEADHSDmVngXCtwAAAABJRU5ErkJggg==',
    GB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXIEC7///8BIWnMIj387/Ht7/UTMXTZVmz0zdSgrMfqo6/L0uHigZEwSoVTaZp3iK/3wiHXAAAACXBIWXMAAC4jAAAuIwF4pT92AAABHklEQVR42r2SsUoDQRCGf1nh4EgzxIRAAsJCBAuPA5tgFxQOIU0KO5PiwMrmhCts5aqUB2Kd4DMINkIKfQHb1HmB4AM4M7uLV6R24GD2476f3dlFSceWa9gGDrvS/RQtmCd6acL7yqyQxtT5/oPJLR4JGTQgwOciGhO2aw3wUGSa4+w9bXGAgyyPqJ/DnmqAgyrvLKzdLjngTWC/AstWoAaQwIHKCl2AwLbKDMmXwNDvh+e+UsCEHv9WV74ueUuh379PPlUypdcDhRm+9Jj81TTAg/tzHV27gWzoqIhvBHaol44+BIpsFnc65JoDPmXINU1Q7vx1TGkZLXJsWIln4eJkdTGDynmAJxJQQuXGY+AAA5Ubz0YCoHLzgdWU/QIYAVlPDjvZVgAAAABJRU5ErkJggg==',
    US: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUZL13///+9PUQmOWTtyMrlsrTLaG3DT1bcmJw1SHBLXID14eKKla3Rxs9kc5Krs8T8og+qAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA7ElEQVR42m2QTWoCQRCFH/Sqm8kMXsETFDYkjPiz8QpewSvMFWbZMAlkZNBx6Q96AG8g4gUkkK0iOYPdppMeob63e9R7Vd0Q+BN12h5EdWKGNMcGh2CKbvqQLvX7yIPfUTv4g0XLY73I9Khy8Y+xB6pQOhZdMdXL0ImkfjF92uGIt8yDuBgUAz2zuoTO2HZGqLDFNZhuOw3JbX+deCBlqVIlS1maxou+k9rtueH0mXtcvGcqej5eqCK2h07FitZ7j4vbM+cu3vgQEiShnYL5FTj/x1sMyBnQZsCEge9kzYyBXzRm4DtHDHwnZ94BDlKd9LTrU4QAAAAASUVORK5CYII=',
    UZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmbX///8etTr10NRkdDJSY3wVobsKnbglqMBQucw7scaR1OC24+un3ebe8faAzNvLtHwcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAc0lEQVR42mNgwAFWzyhgYNvQzfUBSYzzOZBgn5DJsQBJkG8CFt2NCQwMtWwXerk2IAkWNjAwcLE3ZLA1IAnyfMCine0kw/EatgO9nMjaGbimJbCxJ5SxF8BFQrEABmMsgEEQCxiMglgd74IFMChhAUNFEAB4jUr4vpG2xQAAAABJRU5ErkJggg==',
    YE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAAHxBgD///8pKSrzLimF/Ry1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHklEQVR42mMQxAIYhoqgCxbAoIQFDG1BYyyAYSgDAMCBL9EnDpIBAAAAAElFTkSuQmCC'
};
function $b7cded1008753984$export$a2b8715397522463(iso2) {
    const b64 = typeof iso2 === 'string' ? $b7cded1008753984$var$PNG[iso2.toUpperCase()] : undefined;
    return b64 ? `data:image/png;base64,${b64}` : undefined;
}



// ─────────────────────────────────────────────────────────────────────────────
// The words the kit's components say when the caller did not pass their own.
//
// Rule 7 used to end at "copy arrives as props, with Persian defaults", and in
// practice no app passed all of it: an English clinic desk read «قبلی / بعدی»
// under every paged table, «ذخیره شد» on every save bar and «کد ملی وارد شده
// معتبر نیست» under a field labelled "National ID" — and a few components
// (the date-range filter, the save bar's confirmation, the national-id and
// number checks) had no prop to pass at all. The date picker moved to the page
// language in v0.19.0; this table does the same for everything else.
//
// A prop still wins. When it is absent, the default comes from here, keyed by the
// base language of `<html lang>` (or the component's own `locale` prop) — the
// channel `MoneyInput`, `PhoneInput` and the date picker already read; a region
// tag reads its base language (`fr-CA` → `fr`). Persian, English, Arabic,
// French and German each carry every word, and the test holds them to one shape, so no
// language falls through to another word by word. Adding a language is adding a
// complete entry; an unknown one reads the brand's default language, else
// Persian, as `documentLocale` falls back.
//
// Digits inside a default sentence are the caller's: a count passed in is
// rendered as given, so an app that localises its numerals keeps doing so. Nor is
// there a plural lookup — a count arrives as a finished string — so each
// language words a count to read right for any number (French «rendez-vous»
// is invariable; German reads it as a label, «Termine: 3»).
// ─────────────────────────────────────────────────────────────────────────────


const $df1b34b618a72512$export$6bdac007b5b42036 = {
    fa: {
        pager: {
            prev: "\u0642\u0628\u0644\u06CC",
            next: "\u0628\u0639\u062F\u06CC",
            page: (current, pages)=>`\u{635}\u{641}\u{62D}\u{647} ${current} \u{627}\u{632} ${pages}`
        },
        saveBar: {
            save: "\u0630\u062E\u06CC\u0631\u0647 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A",
            cancel: "\u0644\u063A\u0648",
            saved: "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F"
        },
        search: {
            placeholder: "\u062C\u0633\u062A\u062C\u0648...",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062C\u0633\u062A\u062C\u0648"
        },
        select: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F..."
        },
        confirm: {
            confirm: "\u062A\u0623\u06CC\u06CC\u062F",
            cancel: "\u0627\u0646\u0635\u0631\u0627\u0641"
        },
        errorState: {
            title: "\u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
        close: "\u0628\u0633\u062A\u0646",
        back: "\u0628\u0627\u0632\u06AF\u0634\u062A",
        slotGrid: {
            label: "\u0633\u0627\u0639\u062A\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0632\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F"
        },
        phone: {
            label: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644",
            country: "\u06A9\u0634\u0648\u0631",
            countrySearch: "\u062C\u0633\u062A\u062C\u0648\u06CC \u06A9\u0634\u0648\u0631 \u06CC\u0627 \u06A9\u062F",
            countryNoMatch: "\u06A9\u0634\u0648\u0631\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
            required: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            tooShort: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{6A9}\u{648}\u{62A}\u{627}\u{647} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{628}\u{644}\u{646}\u{62F} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{627}\u{6CC}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{645}\u{648}\u{628}\u{627}\u{6CC}\u{644} \u{646}\u{6CC}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            invalid: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dateRange: {
            title: "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
            custom: "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
            from: "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
            to: "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
            needBoth: "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
        },
        connectivity: {
            offline: "\u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0637\u0639 \u0627\u0633\u062A \u2014 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
            degraded: "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u06CC\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            restored: "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0642\u0631\u0627\u0631 \u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            busy: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026"
        },
        nationalId: {
            label: "\u06A9\u062F \u0645\u0644\u06CC",
            // A country with no rule of its own (see lib/nationalId.js).
            genericLabel: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0634\u0646\u0627\u0633\u0627\u06CC\u06CC \u0645\u0644\u06CC",
            country: "\u06A9\u0634\u0648\u0631 \u0635\u0627\u062F\u0631\u06A9\u0646\u0646\u062F\u0647",
            // `n` arrives already in the digits of the language on screen.
            placeholder: (n)=>`${n} \u{631}\u{642}\u{645}`,
            required: "\u06A9\u062F \u0645\u0644\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            incomplete: (n)=>`\u{6A9}\u{62F} \u{645}\u{644}\u{6CC} \u{628}\u{627}\u{6CC}\u{62F} ${n} \u{631}\u{642}\u{645} \u{628}\u{627}\u{634}\u{62F}`,
            tooShort: (n)=>`\u{62F}\u{633}\u{62A}\u{200C}\u{6A9}\u{645} ${n} \u{646}\u{648}\u{6CC}\u{633}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
            invalid: "\u06A9\u062F \u0645\u0644\u06CC \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A",
            valid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            notValid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dayContext: {
            prevDay: "\u0631\u0648\u0632 \u0642\u0628\u0644",
            nextDay: "\u0631\u0648\u0632 \u0628\u0639\u062F",
            today: "\u0627\u0645\u0631\u0648\u0632",
            backToToday: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            pickDay: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632"
        },
        weekPicker: {
            title: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632",
            thisWeek: "\u0627\u06CC\u0646 \u0647\u0641\u062A\u0647",
            nextWeek: "\u0647\u0641\u062A\u0647\u0654 \u0628\u0639\u062F",
            prevWeek: "\u0647\u0641\u062A\u0647\u0654 \u0642\u0628\u0644",
            fullCalendar: "\u062A\u0642\u0648\u06CC\u0645 \u06A9\u0627\u0645\u0644",
            backToWeek: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0647\u0641\u062A\u0647",
            today: "\u0627\u0645\u0631\u0648\u0632",
            close: "\u0628\u0633\u062A\u0646",
            range: (from, to)=>`${from} \u{62A}\u{627} ${to}`,
            countAria: (n)=>`${n} \u{646}\u{648}\u{628}\u{62A}`
        },
        walkIn: {
            suggested: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F",
            or: "\u06CC\u0627"
        },
        mobileHeader: {
            greeting: "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632 \u0646\u0634\u062F",
            body: "\u0647\u0646\u06AF\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634 \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F.",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        number: {
            invalid: "\u0645\u0642\u062F\u0627\u0631 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u06CC\u0633\u062A",
            min: (n)=>`\u{62D}\u{62F}\u{627}\u{642}\u{644} ${n}`,
            max: (n)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} ${n}`
        },
        account: {
            topUp: "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631",
            menu: "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC"
        },
        bottomNav: {
            label: "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC"
        },
        files: {
            phases: {
                queued: "\u062F\u0631 \u0635\u0641",
                preparing: "\u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC",
                sending: "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644\u2026",
                done: "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
                failed: "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            replace: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC",
            drop: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
            pick: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0641\u0627\u06CC\u0644",
            camera: "\u0639\u06A9\u0633 \u06AF\u0631\u0641\u062A\u0646",
            directory: "\u0627\u0646\u062A\u062E\u0627\u0628 \u067E\u0648\u0634\u0647",
            dragging: "\u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F"
        },
        imageStack: {
            frame: (i, n)=>`\u{62A}\u{635}\u{648}\u{6CC}\u{631} ${i} \u{627}\u{632} ${n}`,
            prev: "\u062A\u0635\u0648\u06CC\u0631 \u0642\u0628\u0644\u06CC",
            next: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0639\u062F\u06CC",
            slider: "\u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC \u0628\u06CC\u0646 \u062A\u0635\u0627\u0648\u06CC\u0631",
            zoomIn: "\u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
            zoomOut: "\u06A9\u0648\u0686\u06A9\u200C\u0646\u0645\u0627\u06CC\u06CC",
            reset: "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0646\u0645\u0627",
            series: "\u0633\u0631\u06CC\u200C\u0647\u0627",
            presets: "\u062A\u0646\u0638\u06CC\u0645 \u0646\u0645\u0627\u06CC\u0634",
            viewport: "\u0646\u0645\u0627\u06CC \u062A\u0635\u0648\u06CC\u0631",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062A\u0635\u0648\u06CC\u0631",
            error: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            empty: "\u062A\u0635\u0648\u06CC\u0631\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A"
        },
        prizeWheel: {
            label: "\u06AF\u0631\u062F\u0648\u0646\u0647\u0654 \u0634\u0627\u0646\u0633"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    en: {
        pager: {
            prev: 'Previous',
            next: 'Next',
            page: (current, pages)=>`Page ${current} of ${pages}`
        },
        saveBar: {
            save: 'Save changes',
            cancel: 'Cancel',
            saved: 'Saved'
        },
        search: {
            placeholder: "Search\u2026",
            clear: 'Clear search'
        },
        select: {
            placeholder: "Choose\u2026"
        },
        confirm: {
            confirm: 'Confirm',
            cancel: 'Cancel'
        },
        errorState: {
            title: 'Not available',
            retry: 'Try again'
        },
        loading: 'Loading',
        close: 'Close',
        back: 'Back',
        slotGrid: {
            label: 'Free times',
            loading: 'Loading free times'
        },
        phone: {
            label: 'Mobile number',
            country: 'Country',
            countrySearch: 'Search country or code',
            countryNoMatch: 'No country found',
            required: 'Enter a mobile number',
            tooShort: (ctx)=>`This ${ctx.countryName} number is too short \u{2014} e.g. ${ctx.example}`,
            tooLong: (ctx)=>`This ${ctx.countryName} number is too long \u{2014} e.g. ${ctx.example}`,
            notMobile: (ctx)=>`That is not a mobile number \u{2014} e.g. ${ctx.example}`,
            invalid: 'That is not a valid number'
        },
        dateRange: {
            title: 'Date range',
            custom: 'Custom range',
            from: 'From',
            to: 'To',
            needBoth: 'Pick both dates to apply'
        },
        connectivity: {
            offline: "You are offline \u2014 changes are not being saved",
            degraded: "Cannot reach the server \u2014 retrying",
            restored: 'Connection restored',
            retry: 'Try again',
            busy: "Checking\u2026"
        },
        nationalId: {
            label: 'National ID',
            genericLabel: 'National ID number',
            country: 'Issuing country',
            placeholder: (n)=>`${n} digits`,
            required: 'Enter the national ID',
            incomplete: (n)=>`A national ID has ${n} digits`,
            tooShort: (n)=>`Enter at least ${n} characters`,
            invalid: 'That national ID is not valid',
            valid: 'National ID is valid',
            notValid: 'National ID is not valid'
        },
        dayContext: {
            prevDay: 'Previous day',
            nextDay: 'Next day',
            today: 'Today',
            backToToday: 'Back to today',
            pickDay: 'Pick a day'
        },
        weekPicker: {
            title: 'Pick a day',
            thisWeek: 'This week',
            nextWeek: 'Next week',
            prevWeek: 'Last week',
            fullCalendar: 'Full calendar',
            backToWeek: 'Back to the week',
            today: 'Today',
            close: 'Close',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} appointments`
        },
        walkIn: {
            suggested: 'Suggested',
            or: 'or'
        },
        mobileHeader: {
            greeting: 'Welcome,',
            clear: 'Clear',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: 'This page did not open',
            body: 'Something went wrong while showing this page.',
            retry: 'Try again'
        },
        number: {
            invalid: 'That is not a valid number',
            min: (n)=>`At least ${n}`,
            max: (n)=>`At most ${n}`
        },
        account: {
            topUp: 'Top up credit',
            menu: 'Account'
        },
        bottomNav: {
            label: 'Main navigation'
        },
        files: {
            phases: {
                queued: 'Queued',
                preparing: 'Preparing',
                sending: "Uploading\u2026",
                done: 'Uploaded',
                failed: 'Not uploaded'
            },
            remove: 'Remove',
            retry: 'Try again',
            replace: 'Replace',
            drop: 'Drop files here or choose them',
            pick: 'Choose files',
            camera: 'Take a photo',
            directory: 'Choose a folder',
            dragging: 'Drop them'
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} of ${n}`,
            prev: 'Previous image',
            next: 'Next image',
            slider: 'Move between images',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            reset: 'Reset view',
            series: 'Series',
            presets: 'Display settings',
            viewport: 'Image view',
            loading: 'Loading image',
            error: 'The image did not load',
            retry: 'Try again',
            empty: 'No image to show'
        },
        prizeWheel: {
            label: 'Prize wheel'
        },
        toman: 'toman'
    },
    ar: {
        pager: {
            prev: "\u0627\u0644\u0633\u0627\u0628\u0642",
            next: "\u0627\u0644\u062A\u0627\u0644\u064A",
            page: (current, pages)=>`\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} ${current} \u{645}\u{646} ${pages}`
        },
        saveBar: {
            save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            cancel: "\u0625\u0644\u063A\u0627\u0621",
            saved: "\u062A\u0645 \u0627\u0644\u062D\u0641\u0638"
        },
        search: {
            placeholder: "\u0628\u062D\u062B...",
            clear: "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
        },
        select: {
            placeholder: "\u0627\u062E\u062A\u0631..."
        },
        confirm: {
            confirm: "\u062A\u0623\u0643\u064A\u062F",
            cancel: "\u0625\u0644\u063A\u0627\u0621"
        },
        errorState: {
            title: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
        close: "\u0625\u063A\u0644\u0627\u0642",
        back: "\u0631\u062C\u0648\u0639",
        slotGrid: {
            label: "\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629"
        },
        phone: {
            label: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            country: "\u0627\u0644\u062F\u0648\u0644\u0629",
            countrySearch: "\u0627\u0628\u062D\u062B \u0639\u0646 \u062F\u0648\u0644\u0629 \u0623\u0648 \u0631\u0645\u0632",
            countryNoMatch: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062F\u0648\u0644\u0629",
            required: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            tooShort: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{642}\u{635}\u{64A}\u{631} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{637}\u{648}\u{64A}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{647}\u{630}\u{627} \u{644}\u{64A}\u{633} \u{631}\u{642}\u{645} \u{62C}\u{648}\u{627}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dateRange: {
            title: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
            custom: "\u0641\u062A\u0631\u0629 \u0645\u062E\u0635\u0635\u0629",
            from: "\u0645\u0646 \u062A\u0627\u0631\u064A\u062E",
            to: "\u0625\u0644\u0649 \u062A\u0627\u0631\u064A\u062E",
            needBoth: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A\u0646 \u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0641\u062A\u0631\u0629"
        },
        connectivity: {
            offline: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u2014 \u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            degraded: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645 \u2014 \u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            restored: "\u0639\u0627\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026"
        },
        nationalId: {
            label: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            genericLabel: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0648\u0637\u0646\u064A\u0629",
            country: "\u0628\u0644\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
            placeholder: (n)=>`${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            required: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            incomplete: (n)=>`\u{627}\u{644}\u{631}\u{642}\u{645} \u{627}\u{644}\u{648}\u{637}\u{646}\u{64A} \u{64A}\u{62A}\u{643}\u{648}\u{651}\u{646} \u{645}\u{646} ${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            tooShort: (n)=>`\u{623}\u{62F}\u{62E}\u{644} ${n} \u{623}\u{62D}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            valid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0635\u0627\u0644\u062D",
            notValid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dayContext: {
            prevDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0633\u0627\u0628\u0642",
            nextDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u062A\u0627\u0644\u064A",
            today: "\u0627\u0644\u064A\u0648\u0645",
            backToToday: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            pickDay: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645"
        },
        weekPicker: {
            title: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645",
            thisWeek: "\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            nextWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0645",
            prevWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0645\u0627\u0636\u064A",
            fullCalendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
            backToWeek: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            today: "\u0627\u0644\u064A\u0648\u0645",
            close: "\u0625\u063A\u0644\u0627\u0642",
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} \u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`
        },
        walkIn: {
            suggested: "\u0645\u0642\u062A\u0631\u062D",
            or: "\u0623\u0648"
        },
        mobileHeader: {
            greeting: "\u0623\u0647\u0644\u0627\u064B\u060C",
            clear: "\u0645\u0633\u062D",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
            body: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0623\u062B\u0646\u0627\u0621 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        number: {
            invalid: "\u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            min: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{62F}\u{646}\u{649} ${n}`,
            max: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} ${n}`
        },
        account: {
            topUp: "\u0634\u062D\u0646 \u0627\u0644\u0631\u0635\u064A\u062F",
            menu: "\u0627\u0644\u062D\u0633\u0627\u0628"
        },
        bottomNav: {
            label: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A"
        },
        files: {
            phases: {
                queued: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
                preparing: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0636\u064A\u0631",
                sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
                done: "\u062A\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                failed: "\u0644\u0645 \u064A\u064F\u0631\u0633\u0644"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            replace: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644",
            drop: "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627 \u0623\u0648 \u0627\u062E\u062A\u0631\u0647\u0627",
            pick: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
            camera: "\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
            directory: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u062C\u0644\u062F",
            dragging: "\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627"
        },
        imageStack: {
            frame: (i, n)=>`\u{627}\u{644}\u{635}\u{648}\u{631}\u{629} ${i} \u{645}\u{646} ${n}`,
            prev: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
            next: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
            slider: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u0635\u0648\u0631",
            zoomIn: "\u062A\u0643\u0628\u064A\u0631",
            zoomOut: "\u062A\u0635\u063A\u064A\u0631",
            reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u0639\u0631\u0636",
            series: "\u0627\u0644\u0633\u0644\u0627\u0633\u0644",
            presets: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0639\u0631\u0636",
            viewport: "\u0639\u0631\u0636 \u0627\u0644\u0635\u0648\u0631\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            error: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0648\u0631\u0629 \u0644\u0644\u0639\u0631\u0636"
        },
        prizeWheel: {
            label: "\u0639\u062C\u0644\u0629 \u0627\u0644\u062D\u0638"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    // French (PM-0185): formal «vous», U+00A0 before ':', U+202F before ; ! ?,
    // the typographic apostrophe and a one-character ellipsis.
    fr: {
        pager: {
            prev: "Pr\xe9c\xe9dent",
            next: 'Suivant',
            page: (current, pages)=>`Page ${current} sur ${pages}`
        },
        saveBar: {
            save: 'Enregistrer les modifications',
            cancel: 'Annuler',
            saved: "Modifications enregistr\xe9es"
        },
        search: {
            placeholder: "Rechercher\u2026",
            clear: 'Effacer la recherche'
        },
        select: {
            placeholder: "Choisir\u2026"
        },
        confirm: {
            confirm: 'Confirmer',
            cancel: 'Annuler'
        },
        errorState: {
            title: 'Indisponible',
            retry: "R\xe9essayer"
        },
        loading: 'Chargement',
        close: 'Fermer',
        back: 'Retour',
        slotGrid: {
            label: "Cr\xe9neaux libres",
            loading: "Chargement des cr\xe9neaux libres"
        },
        phone: {
            label: "N\xb0 de portable",
            country: 'Pays',
            countrySearch: 'Rechercher un pays ou un indicatif',
            countryNoMatch: "Aucun pays trouv\xe9",
            required: "Saisissez un num\xe9ro de portable",
            // A French country name takes an article («l’Iran», «les Émirats»)
            // that a name passed in cannot carry, so it leads the message as a label.
            tooShort: (ctx)=>`${ctx.countryName}\xa0: num\xe9ro trop court \u{2014} ex.\xa0: ${ctx.example}`,
            tooLong: (ctx)=>`${ctx.countryName}\xa0: num\xe9ro trop long \u{2014} ex.\xa0: ${ctx.example}`,
            notMobile: (ctx)=>`Ce n\u{2019}est pas un num\xe9ro de portable \u{2014} ex.\xa0: ${ctx.example}`,
            invalid: "Ce num\xe9ro n\u2019est pas valide"
        },
        dateRange: {
            title: "P\xe9riode",
            custom: "P\xe9riode personnalis\xe9e",
            from: 'Du',
            to: 'Au',
            needBoth: "Choisissez les deux dates pour appliquer la p\xe9riode"
        },
        connectivity: {
            offline: "Vous \xeates hors ligne \u2014 les modifications ne sont pas enregistr\xe9es",
            degraded: "Impossible de joindre le serveur \u2014 nouvelle tentative en cours",
            restored: "Connexion r\xe9tablie",
            retry: "R\xe9essayer",
            busy: "V\xe9rification\u2026"
        },
        nationalId: {
            label: "Num\xe9ro national",
            genericLabel: "Num\xe9ro d\u2019identification national",
            country: "Pays de d\xe9livrance",
            // `n` is never below 5, so the noun after it is always plural.
            placeholder: (n)=>`${n} chiffres`,
            required: "Saisissez le num\xe9ro national",
            incomplete: (n)=>`Le num\xe9ro national doit comporter ${n} chiffres`,
            tooShort: (n)=>`Saisissez au moins ${n} caract\xe8res`,
            invalid: "Ce num\xe9ro national n\u2019est pas valide",
            valid: "Num\xe9ro national valide",
            notValid: "Num\xe9ro national non valide"
        },
        dayContext: {
            prevDay: "Jour pr\xe9c\xe9dent",
            nextDay: 'Jour suivant',
            today: "Aujourd\u2019hui",
            backToToday: "Revenir \xe0 aujourd\u2019hui",
            pickDay: 'Choisir un jour'
        },
        weekPicker: {
            title: 'Choisir un jour',
            thisWeek: 'Cette semaine',
            nextWeek: 'Semaine prochaine',
            prevWeek: "Semaine derni\xe8re",
            fullCalendar: 'Calendrier complet',
            backToWeek: "Revenir \xe0 la semaine",
            today: "Aujourd\u2019hui",
            close: 'Fermer',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} rendez-vous`
        },
        walkIn: {
            suggested: "Sugg\xe9r\xe9",
            or: 'ou'
        },
        mobileHeader: {
            greeting: 'Bienvenue,',
            clear: 'Effacer',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: "Impossible d\u2019ouvrir cette page",
            body: "Une erreur s\u2019est produite lors de l\u2019affichage de cette page.",
            retry: "R\xe9essayer"
        },
        number: {
            invalid: "Ce n\u2019est pas un nombre valide",
            min: (n)=>`Minimum\xa0: ${n}`,
            max: (n)=>`Maximum\xa0: ${n}`
        },
        account: {
            topUp: "Recharger le cr\xe9dit",
            menu: 'Compte'
        },
        bottomNav: {
            label: 'Navigation principale'
        },
        files: {
            phases: {
                queued: "En file d\u2019attente",
                preparing: "Pr\xe9paration",
                sending: "Import\u2026",
                done: "Import\xe9",
                failed: "\xc9chec de l\u2019import"
            },
            remove: 'Retirer',
            retry: "R\xe9essayer",
            replace: 'Remplacer',
            drop: "D\xe9posez les fichiers ici ou choisissez-les",
            pick: 'Choisir des fichiers',
            camera: 'Prendre une photo',
            directory: 'Choisir un dossier',
            dragging: "D\xe9posez-les ici"
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} sur ${n}`,
            prev: "Image pr\xe9c\xe9dente",
            next: 'Image suivante',
            slider: 'Naviguer entre les images',
            zoomIn: 'Zoom avant',
            zoomOut: "Zoom arri\xe8re",
            reset: "R\xe9initialiser la vue",
            series: "S\xe9ries",
            presets: "Param\xe8tres d\u2019affichage",
            viewport: "Vue de l\u2019image",
            loading: "Chargement de l\u2019image",
            error: "Impossible de charger l\u2019image",
            retry: "R\xe9essayer",
            empty: "Aucune image \xe0 afficher"
        },
        prizeWheel: {
            label: 'Roue de la chance'
        },
        toman: 'toman'
    },
    // German (PM-0212): formal «Sie», infinitive buttons, no space of any kind
    // before : ; ! ?, „…“ quotes, a one-character ellipsis and the en dash with a
    // space either side. Counts arrive pre-localised and German has no
    // count-neutral noun, so a count reads as a label («Termine: 3»).
    de: {
        pager: {
            prev: "Zur\xfcck",
            next: 'Weiter',
            page: (current, pages)=>`Seite ${current} von ${pages}`
        },
        saveBar: {
            save: "\xc4nderungen speichern",
            cancel: 'Abbrechen',
            saved: 'Gespeichert'
        },
        search: {
            placeholder: "Suchen\u2026",
            clear: "Suche l\xf6schen"
        },
        select: {
            placeholder: "Ausw\xe4hlen\u2026"
        },
        confirm: {
            confirm: "Best\xe4tigen",
            cancel: 'Abbrechen'
        },
        errorState: {
            title: "Nicht verf\xfcgbar",
            retry: 'Erneut versuchen'
        },
        loading: 'Wird geladen',
        close: "Schlie\xdfen",
        back: "Zur\xfcck",
        slotGrid: {
            label: 'Freie Termine',
            loading: 'Freie Termine werden geladen'
        },
        phone: {
            label: 'Mobilnummer',
            country: 'Land',
            countrySearch: 'Land oder Vorwahl suchen',
            countryNoMatch: 'Kein Land gefunden',
            required: 'Geben Sie eine Mobilnummer ein',
            // Some German country names take an article («der Iran», «die Türkei»)
            // that a name passed in cannot carry, so it leads the message as a label.
            tooShort: (ctx)=>`${ctx.countryName}: Nummer zu kurz \u{2013} z. B. ${ctx.example}`,
            tooLong: (ctx)=>`${ctx.countryName}: Nummer zu lang \u{2013} z. B. ${ctx.example}`,
            notMobile: (ctx)=>`Das ist keine Mobilnummer \u{2013} z. B. ${ctx.example}`,
            invalid: "Diese Nummer ist ung\xfcltig"
        },
        dateRange: {
            title: 'Zeitraum',
            custom: 'Benutzerdefinierter Zeitraum',
            from: 'Von',
            to: 'Bis',
            needBoth: "W\xe4hlen Sie beide Daten aus, um den Zeitraum anzuwenden"
        },
        connectivity: {
            offline: "Sie sind offline \u2013 \xc4nderungen werden nicht gespeichert",
            degraded: "Keine Verbindung zum Server \u2013 neuer Versuch l\xe4uft",
            restored: 'Verbindung wiederhergestellt',
            retry: 'Erneut versuchen',
            busy: "Wird gepr\xfcft\u2026"
        },
        nationalId: {
            label: 'Nationale ID',
            genericLabel: 'Nationale ID-Nummer',
            country: 'Ausstellungsland',
            // `n` is never below 5, so the noun after it is always plural.
            placeholder: (n)=>`${n} Ziffern`,
            required: 'Geben Sie die nationale ID ein',
            incomplete: (n)=>`Die nationale ID muss ${n} Ziffern haben`,
            tooShort: (n)=>`Geben Sie mindestens ${n} Zeichen ein`,
            invalid: "Diese nationale ID ist ung\xfcltig",
            valid: "Nationale ID ist g\xfcltig",
            notValid: "Nationale ID ist ung\xfcltig"
        },
        dayContext: {
            prevDay: 'Vorheriger Tag',
            nextDay: "N\xe4chster Tag",
            today: 'Heute',
            backToToday: "Zur\xfcck zu heute",
            pickDay: "Tag ausw\xe4hlen"
        },
        weekPicker: {
            title: "Tag ausw\xe4hlen",
            thisWeek: 'Diese Woche',
            nextWeek: "N\xe4chste Woche",
            prevWeek: 'Letzte Woche',
            fullCalendar: "Vollst\xe4ndiger Kalender",
            backToWeek: "Zur\xfcck zur Woche",
            today: 'Heute',
            close: "Schlie\xdfen",
            range: (from, to)=>`${from} bis ${to}`,
            countAria: (n)=>`Termine: ${n}`
        },
        walkIn: {
            suggested: 'Vorgeschlagen',
            or: 'oder'
        },
        mobileHeader: {
            greeting: 'Willkommen,',
            clear: "L\xf6schen",
            unknownInitial: '?'
        },
        errorBoundary: {
            title: "Diese Seite konnte nicht ge\xf6ffnet werden",
            body: 'Beim Anzeigen dieser Seite ist ein Fehler aufgetreten.',
            retry: 'Erneut versuchen'
        },
        number: {
            invalid: "Das ist keine g\xfcltige Zahl",
            min: (n)=>`Mindestens ${n}`,
            max: (n)=>`H\xf6chstens ${n}`
        },
        account: {
            topUp: 'Guthaben aufladen',
            menu: 'Konto'
        },
        bottomNav: {
            label: 'Hauptnavigation'
        },
        files: {
            phases: {
                queued: 'In Warteschlange',
                preparing: 'Wird vorbereitet',
                sending: "Wird hochgeladen\u2026",
                done: 'Hochgeladen',
                failed: 'Nicht hochgeladen'
            },
            remove: 'Entfernen',
            retry: 'Erneut versuchen',
            replace: 'Ersetzen',
            drop: "Dateien hierher ziehen oder ausw\xe4hlen",
            pick: "Dateien ausw\xe4hlen",
            camera: 'Foto aufnehmen',
            directory: "Ordner ausw\xe4hlen",
            dragging: 'Hier ablegen'
        },
        imageStack: {
            frame: (i, n)=>`Bild ${i} von ${n}`,
            prev: 'Vorheriges Bild',
            next: "N\xe4chstes Bild",
            slider: 'Zwischen Bildern wechseln',
            zoomIn: "Vergr\xf6\xdfern",
            zoomOut: 'Verkleinern',
            reset: "Ansicht zur\xfccksetzen",
            series: 'Serien',
            presets: 'Anzeigeeinstellungen',
            viewport: 'Bildansicht',
            loading: 'Bild wird geladen',
            error: 'Das Bild konnte nicht geladen werden',
            retry: 'Erneut versuchen',
            empty: 'Kein Bild zum Anzeigen'
        },
        prizeWheel: {
            label: "Gl\xfccksrad"
        },
        toman: 'Toman'
    }
};
function $df1b34b618a72512$export$cddd06f8fa3400df(locale) {
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    return $df1b34b618a72512$export$6bdac007b5b42036[base] || $df1b34b618a72512$export$6bdac007b5b42036[(0, $abf0c103b4b92127$export$879824979a5b153a)('fa')] || $df1b34b618a72512$export$6bdac007b5b42036.fa;
}


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// CountryPicker — the country half of `PhoneInput`: a button showing the flag and the
// dial code, opening a searchable, flagged list (PM-0078).
//
// PORTED from the sign-in theme (`sso/parsina.keycloakify/src/login/components/
// CountryPicker.tsx`, 6c0f939), so a doctor finds their country the same way when
// signing in and when a desk registers them. Same contract: a combobox in the WAI-ARIA
// sense — the search box owns focus and points at the active row with
// `aria-activedescendant`, so a screen reader announces each row as the arrows move.
// Search matches a name in ALL five languages, accents folded on both sides, plus the
// dial code in any digit set: a Persian reader may still type an English name, a French
// one «etats» for «États-Unis», a German one «osterreich» for «Österreich», and «+۹۷۱»
// must find the Emirates.
//
// WHY NOT THE NATIVE <select> THIS REPLACED. It could not show flags — <option> takes no
// markup — and on Chrome/Edge for Windows its open list inherited the transparent face
// and showed blank rows (the theme hit both).
//
// FLAGS ARE IMAGES, NOT EMOJI. DESIGN.md rule 10 still holds: an emoji flag is drawn by
// the OS and Windows draws none. These are the theme's flag-icons, rasterised into
// `lib/flags.js` — a named exception in DESIGN_SYSTEM.md §15.
//
// WHERE THE LIST RENDERS — the one subtle thing here.
//   - On a page: portaled to <body>, `position: fixed`, so the field's own
//     `overflow: hidden` shell and a narrow sidebar card cannot clip it.
//   - Inside a dialog or a sheet (`[role="dialog"]`): portaled INTO that dialog,
//     `position: absolute`. A modal Radix dialog sets `pointer-events: none` on <body>
//     and yanks focus back from anything outside it, so a search box portaled to <body>
//     could never be typed into (JalaliDatePicker documents the same trap, and avoids
//     typing in its popup for that reason). Inside the dialog it is in the focus scope,
//     it is not an outside click, and the kit BottomSheet's Tab trap includes it.
//   z 9999 — the `JalaliDatePicker` popup's rung of DESIGN_SYSTEM.md §9.4: a field's
//   popup must sit above the Dialog (1100) the field is in.
// ─────────────────────────────────────────────────────────────────────────────
const $7801a9372e554ab2$var$Z = 9999;
const $7801a9372e554ab2$var$GAP = 6;
const $7801a9372e554ab2$var$EDGE = 8;
const $7801a9372e554ab2$var$PANEL_WIDTH = 300;
const $7801a9372e554ab2$var$LIST_MAX = 280;
function $7801a9372e554ab2$export$48ea269755562084({ iso2: iso2, size: size = 20 }) {
    const src = (0, $b7cded1008753984$export$a2b8715397522463)(iso2);
    const box = {
        width: size,
        height: Math.round(size * 3 / 4),
        borderRadius: 2,
        flexShrink: 0 /* a flag's own corner, not a token radius */ 
    };
    if (!src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            ...box,
            display: 'inline-block',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: "",
        "aria-hidden": "true",
        width: box.width,
        height: box.height,
        style: {
            ...box,
            display: 'block',
            objectFit: 'cover',
            boxShadow: `0 0 0 1px ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    });
}
const $7801a9372e554ab2$var$sameCountry = (a, b)=>a?.iso2 === b?.iso2;
function $7801a9372e554ab2$export$3abcf2ef1ee51ab5({ value: value, onSelect: onSelect, countries: // The offered rows; the selected one is always offered even when narrowed out.
countries = (0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7), locale: localeProp, label: label, disabled: disabled = false, // Where the panel is measured from — the whole field shell, so the list lines up
// with the box rather than with the 70px button. Defaults to the button.
anchorRef: anchorProp, showDial: // `false` shows the country's two-letter code instead of its dial code — for a
// field whose country is not a phone prefix (NationalIdInput).
showDial = true, 'data-testid': testid }) {
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(localeProp).phone;
    const ariaLabel = label ?? copy.country;
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale);
    const localize = (s)=>String(s).replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const rtl = [
        'fa',
        'ar'
    ].includes(String(locale).split('-')[0]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [host, setHost] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const listId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const optionId = (iso2)=>`${listId}-${iso2}`;
    // The locale's own country first (the answer for nearly every user), the rest in the
    // reader's alphabet.
    const ordered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rows = countries.some((c)=>$7801a9372e554ab2$var$sameCountry(c, value)) || !value ? countries : [
            value,
            ...countries
        ];
        const home = (0, $412e1a8a99c19c1a$export$7684f8e22afec32c)(locale);
        const collator = new Intl.Collator(locale);
        const first = rows.filter((c)=>$7801a9372e554ab2$var$sameCountry(c, home));
        const rest = rows.filter((c)=>!$7801a9372e554ab2$var$sameCountry(c, home)).sort((a, b)=>collator.compare((0, $412e1a8a99c19c1a$export$3162e773cd568eb)(a, locale), (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(b, locale)));
        return [
            ...first,
            ...rest
        ];
    }, [
        countries,
        value,
        locale
    ]);
    // The rule — dial code, ISO code, a name in any language with accents folded on both
    // sides — is `countryMatches` in lib/phone.js, where it is tested without a DOM.
    const matches = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>ordered.filter((c)=>(0, $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa)(c, query)), [
        ordered,
        query
    ]);
    const show = ()=>{
        if (disabled) return;
        setQuery('');
        setActive(Math.max(ordered.findIndex((c)=>$7801a9372e554ab2$var$sameCountry(c, value)), 0));
        setOpen(true);
    };
    const hide = (returnFocus)=>{
        setOpen(false);
        if (returnFocus) buttonRef.current?.focus();
    };
    const choose = (country)=>{
        onSelect?.(country);
        hide(true);
    };
    // Place the panel against the anchor — in <body> with fixed coordinates, or inside
    // the enclosing dialog with coordinates relative to it (see the header).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const anchor = anchorProp?.current || buttonRef.current;
        const dialog = anchor?.closest?.('[role="dialog"]') || null;
        setHost(dialog || document.body);
        const place = ()=>{
            const a = (anchorProp?.current || buttonRef.current)?.getBoundingClientRect();
            if (!a) return;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const width = Math.min(Math.max(a.width, $7801a9372e554ab2$var$PANEL_WIDTH), vw - $7801a9372e554ab2$var$EDGE * 2);
            // The button sits at the LEFT of the field in every direction (the phone run is
            // an LTR island), so the panel lines up with the field's left edge.
            const left = Math.min(Math.max($7801a9372e554ab2$var$EDGE, a.left), vw - width - $7801a9372e554ab2$var$EDGE);
            const below = vh - a.bottom - $7801a9372e554ab2$var$EDGE * 2;
            const above = a.top - $7801a9372e554ab2$var$EDGE * 2;
            const up = below < 220 && above > below;
            const listMax = Math.max(120, Math.min($7801a9372e554ab2$var$LIST_MAX, (up ? above : below) - 60));
            const top = up ? null : a.bottom + $7801a9372e554ab2$var$GAP;
            const bottom = up ? a.top - $7801a9372e554ab2$var$GAP : null;
            if (!dialog) {
                setPos({
                    position: 'fixed',
                    left: left,
                    width: width,
                    listMax: listMax,
                    top: top,
                    bottomFromTop: bottom,
                    up: up
                });
                return;
            }
            // Relative to the dialog's padding box, scrolled with its content.
            const d = dialog.getBoundingClientRect();
            const bx = dialog.clientLeft || 0;
            const by = dialog.clientTop || 0;
            setPos({
                position: 'absolute',
                left: left - d.left - bx + dialog.scrollLeft,
                width: width,
                listMax: listMax,
                top: top == null ? null : top - d.top - by + dialog.scrollTop,
                bottomFromTop: bottom == null ? null : bottom - d.top - by + dialog.scrollTop,
                up: up
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorProp
    ]);
    // Focus the search box once the panel exists.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && pos) searchRef.current?.focus({
            preventScroll: true
        });
    }, [
        open,
        pos != null
    ]);
    // Keep the active row in view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const row = matches[active];
        if (row) document.getElementById(optionId(row.iso2))?.scrollIntoView?.({
            block: 'nearest'
        });
    }, [
        open,
        active,
        matches
    ]);
    // A press anywhere else closes it, the way a native list does.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (panelRef.current?.contains(e.target) || buttonRef.current?.contains(e.target)) return;
            hide(false);
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('touchstart', onDown);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('touchstart', onDown);
        };
    }, [
        open
    ]);
    const onSearchKey = (e)=>{
        const last = matches.length - 1;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                setActive((i)=>i >= last ? 0 : i + 1);
                break;
            case 'ArrowUp':
                e.preventDefault();
                setActive((i)=>i <= 0 ? last : i - 1);
                break;
            case 'Home':
                e.preventDefault();
                setActive(0);
                break;
            case 'End':
                e.preventDefault();
                setActive(last);
                break;
            case 'Enter':
                // Never submit the surrounding form from inside the picker.
                e.preventDefault();
                if (matches[active]) choose(matches[active]);
                break;
            case 'Escape':
                // Closes the list, not the dialog or sheet the field sits in.
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent?.stopImmediatePropagation?.();
                hide(true);
                break;
            case 'Tab':
                hide(false);
                break;
            default:
        }
    };
    const onButtonKey = (e)=>{
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            show();
        }
    };
    const activeRow = open ? matches[active] : undefined;
    const country = value || ordered[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ref: buttonRef,
        disabled: disabled,
        "aria-label": `${ariaLabel}: ${(0, $412e1a8a99c19c1a$export$3162e773cd568eb)(country, locale)}`,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": open ? listId : undefined,
        "data-testid": testid,
        "data-country": country?.iso2,
        onClick: ()=>open ? hide(false) : show(),
        onKeyDown: onButtonKey,
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 bg-transparent border-0 font-sans text-[13.5px] text-muted-foreground cursor-pointer select-none disabled:cursor-not-allowed outline-none focus-visible:bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
        iso2: country?.iso2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, showDial ? localize(`+${country?.dial ?? ''}`) : country?.iso2 ?? ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "12",
        height: "12",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m6 9 6 6 6-6"
    }))), open && pos && host && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        "data-jalali-popup": "",
        "data-testid": testid ? `${testid}-panel` : undefined,
        dir: rtl ? 'rtl' : 'ltr',
        style: {
            position: pos.position,
            left: pos.left,
            width: pos.width,
            ...pos.up ? {
                top: pos.bottomFromTop,
                transform: 'translateY(-100%)'
            } : {
                top: pos.top
            },
            zIndex: $7801a9372e554ab2$var$Z,
            background: 'white',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).floating,
            padding: 6,
            boxSizing: 'border-box',
            pointerEvents: 'auto',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '0 10px',
            height: 40,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m20 20-3.5-3.5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: searchRef,
        type: "search",
        role: "combobox",
        "aria-expanded": "true",
        "aria-controls": listId,
        "aria-autocomplete": "list",
        "aria-activedescendant": activeRow ? optionId(activeRow.iso2) : undefined,
        "aria-label": copy.countrySearch,
        placeholder: copy.countrySearch,
        autoComplete: "off",
        spellCheck: false,
        value: query,
        "data-testid": testid ? `${testid}-search` : undefined,
        onChange: (e)=>{
            setQuery(e.target.value);
            setActive(0);
        },
        onKeyDown: onSearchKey,
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 0,
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: 13.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: listId,
        role: "listbox",
        "aria-label": ariaLabel,
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            maxHeight: pos.listMax,
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        }
    }, matches.map((c, i)=>{
        const selected = $7801a9372e554ab2$var$sameCountry(c, value);
        const isActive = i === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: c.iso2,
            id: optionId(c.iso2),
            role: "option",
            "aria-selected": selected,
            "data-testid": testid ? `${testid}-option-${c.iso2}` : undefined,
            // mousedown, not click: keeps focus in the search box, so the
            // outside-press handler never sees it.
            onMouseDown: (e)=>{
                e.preventDefault();
                choose(c);
            },
            onMouseMove: ()=>setActive(i),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                minHeight: 40,
                padding: '0 10px',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                cursor: 'pointer',
                fontSize: 13.5,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                background: isActive ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : 'transparent',
                fontWeight: selected ? 600 : 400
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
            iso2: c.iso2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(c, locale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                unicodeBidi: 'isolate'
            }
        }, localize(`+${c.dial}`)), selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "14",
            height: "14",
            "aria-hidden": "true",
            style: {
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M20 6 9 17l-5-5"
        })));
    }), matches.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        style: {
            padding: '10px',
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, copy.countryNoMatch))), host));
}
var $7801a9372e554ab2$export$2e2bcd8739ae039 = $7801a9372e554ab2$export$3abcf2ef1ee51ab5;





'use client';
// The one phone field. Everywhere in Parsina a human types a phone number, it types it
// here — a patient at the desk, a staff member being added, a supplier, a clinic line.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHAT IT WRITES, AND WHAT IT SHOWS — they are not the same thing, and that is the
// whole design.
//
//   `onChange` hands back **E.164 and only E.164** — `'+989121234567'`, or `''` while
//   the number is incomplete. Never an event object. The rules live in `lib/phone.js`;
//   this component owns none of them.
//
//   The BOX still shows `09121234567`, and always will. A stored `09121234567` and a
//   stored `+989121234567` render IDENTICALLY, because the draft is seeded through
//   `toNational`. Nothing on any screen changes shape on the day this ships. That is the
//   migration cushion, and it is what lets the wire format change without a coordinated
//   three-app cutover.
//
//   `showTrunk={false}` is the one opt-out: the box shows the number AFTER the dial chip
//   — `9121234567`, `2188000000` — with the trunk `0` off, because the chip already says
//   `+98` and a desk that deletes the zero is told, by the zero coming back, that its
//   edit did nothing. It changes only the SPELLING in the box: the emitted E.164 is the
//   same, a typed `0` still parses (and comes off on blur), and a stored `0…` or `+98…`
//   seeds the same trunkless draft.
//
// Why a bare string rather than the `{ target: { value } }` shim this component used to
// emit: `MoneyInput` already broke that pattern in this kit and states the rule in its
// own header — "Value in and value out are both the BARE ASCII numeric string… onChange
// is handed that string directly, not an event" — and `JalaliDatePicker` does the same.
// Entrenching a fake event in the one component whose output is a MATCHING KEY is the
// wrong direction. The second argument carries the rest: `{ ok, problem, e164, national,
// country, draft }`, for the rare caller that needs the national form or the reason.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE VALUE/DRAFT SPLIT — the subtlest thing in this file, and the thing a later
// "simplification" will break.
//
//   - The PARENT owns the canonical value (E.164). The COMPONENT owns the visible draft.
//   - The draft is seeded from the value on mount, and RE-seeded only when the `value`
//     PROP itself changed and the two no longer normalize to the same number. So typing
//     `0912` (parent holds `''`, draft holds `'0912'`, both normalize to `''`) does not
//     wipe the half-typed number; loading a patient re-seeds; a parent reset to `''`
//     clears it; and a parent that round-trips E.164 straight back never disturbs the
//     user's own typing.
//   - It NEVER calls `onChange` on mount or on a `value` prop change. These forms drive
//     `SaveBar` and dirty-tracking, and an emit-on-mount would mark every profile dirty
//     the moment it opened.
//
// Turning this into a plain controlled input wipes half-typed numbers on every keystroke
// — a regression visible only with a parent that round-trips through async state, which
// is why `PhoneInput.test.jsx` drives it from a real Host component.
//
// ═══════════════════════════════════════════════════════════════════════════════
// COUNTRY IS DERIVED, NEVER STORED.
//
// E.164 carries the country code inside the value, so `findByDialCode` recovers the
// picker on load. There is no `country_code` column, proto field or GraphQL field
// anywhere in this platform, and this change adds none: no schema change, no migration.
//
// THE PRESELECTION FOLLOWS THE LOCALE; A STORED NUMBER DOES NOT (PM-0078).
//
// An empty field preselects `countryForLocale(locale)` — Iran under `fa`, Iraq under
// `ar`, a tag's own region where it names one — so "the default is the default locale"
// and a patient from anywhere is one tap or one `+` away. A STORED value is never read
// through that preselection: an E.164 value names its own country, and a value stored
// in NATIONAL spelling (`09121234567`) is read as Iranian, always, because this field
// has only ever written E.164 and every national spelling in the platform's columns
// predates it — and those were Iranian. Read under Iraq, `09121234567` would come back
// as `+9649121234567`, the same digits and a different person.
//
// ═══════════════════════════════════════════════════════════════════════════════
// DIGITS ON SCREEN ARE THE LOCALE'S; DIGITS ON THE WIRE ARE ASCII.
//
// DESIGN_SYSTEM.md §6.4: displayed digit strings — phone included — use the locale's
// digit set "with no per-surface exceptions". This field used to render ASCII always,
// on the argument that a phone number is a KEY; the key is what is EMITTED, and that is
// still ASCII E.164. What changed is only the paint: the draft stays an ASCII string in
// state, and `localize` maps it digit-for-digit on the way to the DOM — the dial chip,
// the box, the default placeholder and the example in an error message alike. The
// mapping is one character to one character, so the caret arithmetic below (which
// counts kept characters in the ASCII draft) is untouched; `compactPhone` already folds
// whatever numerals come back in. `locale` defaults to <html lang>, as in `MoneyInput`.
// ─────────────────────────────────────────────────────────────────────────────
// Copy. The caller's props win; otherwise the kit's own words in `<html lang>`
// (lib/kitCopy.js, DESIGN.md rule 7).
//
// Five problems, not one: "invalid" alone tells nobody which digit to go looking for.
// The example is wrapped in U+2068 FSI … U+2069 PDI so an ASCII number inside a Persian
// sentence isolates itself without any CSS — the same reasoning as rule 8's LTR island,
// applied to a string rather than a box.
// ─────────────────────────────────────────────────────────────────────────────
const $5f69d84dab43bb31$var$isolate = (s)=>`\u2068${s}\u2069`;
const $5f69d84dab43bb31$var$defaultMessages = (locale)=>{
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).phone;
    const isolated = (fn)=>(ctx)=>fn({
                ...ctx,
                example: $5f69d84dab43bb31$var$isolate(ctx.example)
            });
    return {
        required: copy.required,
        tooShort: isolated(copy.tooShort),
        tooLong: isolated(copy.tooLong),
        notMobile: isolated(copy.notMobile),
        invalid: copy.invalid
    };
};
/** A `Country`, an iso2 string, or nothing → a `Country`. */ const $5f69d84dab43bb31$var$asCountry = (value, fallback)=>(typeof value === 'string' ? (0, $412e1a8a99c19c1a$export$586b3eaa727579f5)(value) : value) || fallback;
/** The offered list: `Country` records or iso2 strings, defaulting to the whole catalog. */ function $5f69d84dab43bb31$var$resolveList(countries) {
    if (!Array.isArray(countries) || countries.length === 0) return 0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7;
    const rows = countries.map((c)=>$5f69d84dab43bb31$var$asCountry(c, undefined)).filter(Boolean);
    return rows.length ? rows : (0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
}
/**
 * What to put in the box for a value that arrived from somewhere else.
 *
 * A number becomes its national form. Anything else is shown AS STORED — and that rule
 * is load-bearing: a phone column in this platform can hold a note («تماس با منشی»), and
 * seeding an unparseable value to `''` would make the stored content vanish from the
 * field the moment the record opened, after which any save would silently wipe it.
 * Showing what is stored, emitting nothing until the user types, and letting the filter
 * strip it on the first keystroke is the honest behaviour.
 *
 * A number whose country is outside the catalog has no national form to render, so its
 * E.164 stands in — the alternative is a blank box over a real stored number.
 */ const $5f69d84dab43bb31$var$seedDraft = (parsed, value, showTrunk = true)=>parsed.ok ? $5f69d84dab43bb31$var$spellNational(parsed, showTrunk) || parsed.e164 : typeof value === 'string' ? value : '';
/**
 * `national` with the country's trunk prefix off — `'09121234567'` → `'9121234567'`.
 * Also used on a country's `example`, which is written in national form too. A string
 * that does not begin with the trunk is returned unchanged: India's example is already
 * trunkless, and a country without a trunk has nothing to take off.
 */ const $5f69d84dab43bb31$var$withoutTrunk = (national, country)=>country?.trunk && national.startsWith(country.trunk) ? national.slice(country.trunk.length) : national;
/** The national form as this field spells it: with its trunk, or without (`showTrunk`). */ const $5f69d84dab43bb31$var$spellNational = (parsed, showTrunk)=>showTrunk ? parsed.national : $5f69d84dab43bb31$var$withoutTrunk(parsed.national, parsed.country);
/**
 * The country a value arriving from STORAGE is read in. Written internationally (`+…`,
 * `00…`) it names its own country and `fallback` only matters for a dial code outside
 * the catalog; written nationally it is Iranian — see "THE PRESELECTION FOLLOWS THE
 * LOCALE" in the header. Typing never goes through here.
 */ const $5f69d84dab43bb31$var$storedCountry = (value, fallback)=>{
    const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(value);
    if (compact === '' || compact.startsWith('+') || compact.startsWith('00')) return fallback;
    return 0, $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
};
/** The characters `compactPhone` keeps. Counting these is how the caret survives a
 *  separator being filtered out from under it. */ const $5f69d84dab43bb31$var$isKept = (ch)=>ch >= '0' && ch <= '9' || ch === '+';
const $5f69d84dab43bb31$var$countKept = (s)=>(0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(s).length;
const $5f69d84dab43bb31$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: // Value — E.164 preferred, ANY legacy shape accepted (09…, +98…, 0098…, 98…, 9…,
// Persian/Arabic-Indic/fullwidth digits, separators, invisible marks).
value, onChange: onChange, onBlur: onBlur, // Country — `country` is controlled (pair it with `onCountryChange`),
// `defaultCountry` is the uncontrolled seed, itself defaulting to the locale's
// country (`countryForLocale`). A DEFAULT, never a lock.
country: countryProp, defaultCountry: defaultCountry, onCountryChange: onCountryChange, countries: // Narrow the offered list. Resolving to exactly ONE renders a static dial chip
// instead of a `<select>` — see below.
countries, allowLandline: // Drop the selected country's `nsnPattern` for this field: a supplier's or a
// clinic's number is an office line. Iran only, in practice.
allowLandline = false, showTrunk: // `false` spells the box without the trunk prefix — `9121234567` beside `+98`, not
// `09121234567`. Display only; what is emitted is unchanged. See the header.
showTrunk = true, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, messages: // Copy — each entry `string | (ctx) => string`, ctx = { country, countryName, example }.
messages, label: // Chrome — the same contract as TextInput.
label, countryLabel: countryLabel, required: required, error: externalError, helperText: helperText, disabled: disabled = false, className: // `className` merges onto the bordered SHELL — the element that carries the box,
// and the one a caller sizing this field inside a 170px column means. `style` is
// the FormField's and `inputStyle` the real input's, as in `MoneyInput`.
className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
// §17.2 requires a kit component to forward them, and a past bug was exactly this.
...rest }, ref)=>{
    const kit = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(localeProp).phone;
    if (label === undefined) label = kit.label;
    if (countryLabel === undefined) countryLabel = kit.country;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const innerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const caret = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ASCII in state, the locale's numerals in the DOM. See the header.
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    const localize = (str)=>String(str ?? '').replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const options = $5f69d84dab43bb31$var$resolveList(countries);
    const preselected = defaultCountry !== undefined ? defaultCountry : (0, $412e1a8a99c19c1a$export$7684f8e22afec32c)(localeProp);
    const base = $5f69d84dab43bb31$var$asCountry(countryProp !== undefined ? countryProp : preselected, options[0] || (0, $412e1a8a99c19c1a$export$84b76667b0a9e7b4));
    const shellRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const opts = {
        allowLandline: allowLandline
    };
    const spell = (p)=>$5f69d84dab43bb31$var$spellNational(p, showTrunk);
    const exampleFor = (c)=>showTrunk ? c.example : $5f69d84dab43bb31$var$withoutTrunk(c.example, c);
    // Draft and country live in ONE state object so a re-seed moves both atomically —
    // a load that changes the number and the country must never render half-applied.
    const [own, setOwn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const parsed = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, base)
        });
        return {
            draft: $5f69d84dab43bb31$var$seedDraft(parsed, value, showTrunk),
            country: parsed.ok ? parsed.country : base
        };
    });
    const country = countryProp !== undefined ? base : own.country;
    const draft = own.draft;
    // Re-seed on a `value` PROP change only. Comparing the normalized forms is what keeps
    // a parent that echoes E.164 back from rewriting what the user is still typing;
    // comparing the raw prop is what still lets a parent clear the field.
    const prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    if (prevValue.current !== value) {
        prevValue.current = value;
        const incoming = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, country)
        });
        if (incoming.e164 !== (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(draft, {
            ...opts,
            country: country
        }).e164) setOwn({
            draft: $5f69d84dab43bb31$var$seedDraft(incoming, value, showTrunk),
            country: incoming.ok ? incoming.country : country
        });
    }
    const parsed = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(draft, {
        ...opts,
        country: country
    });
    // An empty field is never an error unless the caller says it is required. Every other
    // problem is reported as it stands — including for a stored note, which genuinely is
    // not a phone number and is never silently cleared.
    const problem = parsed.problem === 'required' && !required ? null : parsed.problem;
    const copy = {
        ...$5f69d84dab43bb31$var$defaultMessages(localeProp),
        ...messages
    };
    const entry = problem ? copy[problem] : null;
    const internalError = typeof entry === 'function' ? entry({
        country: parsed.country,
        countryName: (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(parsed.country, localeProp),
        example: localize(exampleFor(parsed.country))
    }) : entry || '';
    // On blur only (`touched`), never while typing; an external `error` always wins; and
    // the error is ADVISORY — `onChange` still fires and the value is never cleared.
    const error = externalError || (touched ? internalError : '');
    const emit = (nextDraft, nextCountry)=>{
        const next = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(nextDraft, {
            ...opts,
            country: nextCountry
        });
        onChange?.(next.e164, {
            ...next,
            draft: nextDraft
        });
    };
    const handleChange = (event)=>{
        const el = event.target;
        const raw = el.value;
        // How many KEPT characters sat left of the caret. The filter removes characters, so
        // a separator typed or pasted mid-string shifts every index after it. Copied from
        // `MoneyInput.jsx`, which carries the same loop and the largest caret suite in the
        // kit; the counting is the part that has to be right.
        const keptLeft = $5f69d84dab43bb31$var$countKept(raw.slice(0, el.selectionStart ?? raw.length));
        const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(raw);
        const international = compact.startsWith('+') || compact.startsWith('00');
        // The picker follows an EXPLICITLY international number and nothing else. A bare
        // national number means whatever the selected country says it means, so reading a
        // country out of it would be guessing. An international number whose dial code is
        // not in the catalog leaves the picker where it was — the list is not a gate.
        let nextCountry = country;
        if (international && countryProp === undefined) {
            const claimed = (0, $412e1a8a99c19c1a$export$21894a57509f6ed5)(compact.startsWith('+') ? compact.slice(1) : compact.slice(2));
            if (claimed) nextCountry = claimed;
        }
        const next = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(compact, {
            ...opts,
            country: nextCountry
        });
        // What you typed stays on screen — no rewrite under the cursor — with ONE exception:
        // a number written internationally is re-spelled nationally once it resolves,
        // because the dial code is now showing in the chip beside it and printing `+98`
        // twice in one field is not what the user wrote either.
        const nextDraft = international && next.ok && next.national ? spell(next) : compact;
        let pos = 0;
        let seen = 0;
        while(pos < nextDraft.length && seen < keptLeft){
            if ($5f69d84dab43bb31$var$isKept(nextDraft[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        setOwn({
            draft: nextDraft,
            country: nextCountry
        });
        if (nextCountry !== country) onCountryChange?.(nextCountry);
        emit(nextDraft, nextCountry);
    };
    const handleCountry = (picked)=>{
        const next = $5f69d84dab43bb31$var$asCountry(picked, null);
        if (!next) return;
        // An explicit international prefix is rewritten in place; a bare national number is
        // left exactly as typed, because its MEANING changed the moment the country did.
        const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(draft);
        let nextDraft = draft;
        if (compact.startsWith(`+${country.dial}`)) nextDraft = `+${next.dial}${compact.slice(1 + country.dial.length)}`;
        else if (compact.startsWith(`00${country.dial}`)) nextDraft = `00${next.dial}${compact.slice(2 + country.dial.length)}`;
        setOwn({
            draft: nextDraft,
            country: next
        });
        onCountryChange?.(next);
        emit(nextDraft, next);
    };
    const handleBlur = (event)=>{
        setTouched(true);
        // The one moment where moving the caret costs nothing: a number that parses is
        // re-spelled in its national form, which is the field's confirmation that it
        // understood you. The login theme does not do this because a login field is left
        // immediately; a form field that is filled and then revisited is a different
        // surface. No emit — the canonical value has not changed.
        const spelled = parsed.ok ? spell(parsed) : '';
        if (spelled && spelled !== draft) setOwn((s)=>({
                ...s,
                draft: spelled
            }));
        onBlur?.(event);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (caret.current != null && innerRef.current) {
            innerRef.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const setRefs = (node)=>{
        innerRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    // A list that resolves to exactly one country gets a static chip, not a picker with
    // a single row: no fake choice, no tab stop, and — the practical reason — it is what
    // keeps the whole field inside the 170px and 160px boxes `SetupViews.jsx` wraps it
    // in, and off the ~150px clipping `ProfileSection.jsx` records in its own comment.
    // Every other field gets `CountryPicker`: flag, dial code, a searchable list. The
    // flags are images, never emoji (rule 10) — see that file's header.
    const single = options.length === 1;
    const testid = rest['data-testid'];
    // The error/helper line, JOINED to whatever the caller already pointed the field at —
    // never replacing it. `FormField` is passed `htmlFor`, which tells it this component
    // owns its own aria wiring, so its own join (see FormField) does not run for this
    // field and this is the only place the two ids can meet.
    //
    // Written as one value rather than an attribute before `{...rest}`, because that order
    // means a caller's `aria-describedby` OVERWRITES the message id: the field goes red,
    // and a screen reader reads the caller's hint and never says why. `MoneyInput` already
    // does it this way, for the same reason.
    const describedBy = [
        rest['aria-describedby'],
        error || helperText ? `${controlId}-message` : null
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center h-11 rounded-lg overflow-hidden bg-white border-[1.5px]', 'transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus-within:shadow-ring-red' : 'border-border focus-within:border-primary focus-within:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        className: "flex items-center w-full h-full [unicode-bidi:isolate]"
    }, single ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 font-sans text-[13.5px] text-muted-foreground select-none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7801a9372e554ab2$export$48ea269755562084), {
        iso2: country.iso2
    }), localize(`+${country.dial}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7801a9372e554ab2$export$2e2bcd8739ae039), {
        value: country,
        // A number pasted from outside the offered list still selects its own
        // country — validation must be right even where the list is narrowed —
        // so the picker always offers the current row, even when not asked for.
        countries: options,
        onSelect: handleCountry,
        locale: localeProp,
        label: countryLabel,
        disabled: disabled,
        anchorRef: shellRef,
        "data-testid": testid ? `${testid}-country` : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "w-px h-5 shrink-0 bg-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-invalid": error ? true : undefined,
        ...rest,
        // A caller's placeholder is an example NUMBER like the default, and the
        // catalogues spell it in ASCII as often as not — so it gets the page's
        // numerals too, rather than being the one Latin run left in the field.
        placeholder: localize(rest.placeholder ?? exampleFor(country)),
        // After `{...rest}`: the joined value is the one that must win, and it
        // already contains the caller's own.
        "aria-describedby": describedBy,
        ref: setRefs,
        type: "tel",
        inputMode: "tel",
        autoComplete: "tel",
        value: localize(draft),
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: disabled,
        // The DOM `maxLength={11}` is gone: one attribute cannot express both a
        // national and an international shape, and 11 silently truncated every
        // number written as `+98…`. 20 is a cap no real number reaches after
        // filtering.
        maxLength: 20,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex-1 min-w-0 w-full h-full ps-2.5 pe-3.5 bg-transparent border-0 outline-none', 'font-sans text-[13.5px] text-foreground tracking-[0.5px]', 'disabled:cursor-not-allowed disabled:bg-transparent'),
        style: inputStyle
    }))));
});
$5f69d84dab43bb31$var$PhoneInput.displayName = 'PhoneInput';
var $5f69d84dab43bb31$export$2e2bcd8739ae039 = $5f69d84dab43bb31$var$PhoneInput;




var $acw62 = parcelRequire("acw62");




// National id — the one place the rules of a national identity number live.
//
// «کد ملی» is Iran's: ten digits, the last a checksum of the nine before it. That
// rule was written down more than once (the input's own private copy, and a copy
// in whichever screen had to validate on submit), which is how a code one screen
// accepts is refused by the next. It is written here once, and `NationalIdInput`
// and every screen read it from here.
//
// Three things are kept apart on purpose:
//
//   - **The COUNTRY decides the rules.** How long the number is, whether it has a
//     checksum, whether letters may appear — a property of who issued it. Each
//     country is one entry in `NATIONAL_ID_RULES`; adding one is adding an entry,
//     and no component branches on a country code. Iran's entry is today's rule,
//     unchanged. A country with no entry gets `GENERIC_RULE`, which checks shape
//     only and therefore never claims a number is VALID — only that it is not
//     obviously malformed.
//   - **The LANGUAGE decides the digits on screen.** «۰۰۱۲۳۴۵۶۷۹» under `fa`,
//     «٠٠١٢٣٤٥٦٧٩» under `ar`, «0012345679» under `en` — resolved by `numeralsFor`,
//     the seam `MoneyInput` already uses. An English-speaking desk in Tehran still
//     enters Iranian codes: language never picks the rule.
//   - **The VALUE is always ASCII.** Localised digits exist only between a
//     component and the DOM. What a form stores, compares, sends and validates is
//     `normalizeNationalId`'s output.



const $2885454b73c45d9d$export$db3d38ac1c19b9cc = 'IR';
function $2885454b73c45d9d$export$d285ab09de6b6713(locale) {
    return (0, $abf0c103b4b92127$export$3cede7c619603eb2)() ? $2885454b73c45d9d$export$db3d38ac1c19b9cc : (0, $412e1a8a99c19c1a$export$7684f8e22afec32c)(locale).iso2;
}
// ── Iran — «کد ملی» ──────────────────────────────────────────────────────────
// Ten digits. With the digits d0…d9 and S = Σ d[i] × (10 − i) for i = 0…8,
// r = S mod 11; the check digit d9 is r when r < 2, else 11 − r. Ten equal digits
// satisfy the arithmetic («1111111111») and are issued to nobody, so they are
// refused by name.
const $2885454b73c45d9d$var$IR_LENGTH = 10;
function $2885454b73c45d9d$var$iranChecksumHolds(code) {
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += (code.charCodeAt(i) - 48) * (10 - i);
    const rem = sum % 11;
    return code.charCodeAt(9) - 48 === (rem < 2 ? rem : 11 - rem);
}
const $2885454b73c45d9d$var$IR_RULE = Object.freeze({
    country: 'IR',
    // What may be typed — decides the on-screen keyboard and what paste keeps.
    charset: 'digits',
    minLength: $2885454b73c45d9d$var$IR_LENGTH,
    maxLength: $2885454b73c45d9d$var$IR_LENGTH,
    // A rule with a checksum can say a number is VALID; one without can only say
    // it is not malformed, and the field then shows no «معتبر است».
    verifiable: true,
    // `strip` keeps every character the rule allows; `normalize` also cuts at the
    // length. The field needs both — it refuses a keystroke into a full code
    // instead of letting it push the last digit out.
    strip: (raw)=>(0, $412e1a8a99c19c1a$export$522be3011864bb18)(String(raw ?? '')).replace(/\D/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$var$IR_RULE.strip(raw).slice(0, $2885454b73c45d9d$var$IR_LENGTH),
    check (value) {
        if (value.length < $2885454b73c45d9d$var$IR_LENGTH) return 'incomplete';
        if (/^(\d)\1{9}$/.test(value) || !$2885454b73c45d9d$var$iranChecksumHolds(value)) return 'invalid';
        return null;
    },
    // A code kept as a NUMBER somewhere upstream (a spreadsheet import, an integer
    // column) has lost its leading zeros: «0012345679» arrives as «12345679». Codes
    // begin with at most two zeros, so 8 or 9 digits can be restored — and are kept
    // only when the restored code passes the checksum.
    repair (value) {
        if (value.length !== 8 && value.length !== 9) return value;
        const padded = value.padStart($2885454b73c45d9d$var$IR_LENGTH, '0');
        return $2885454b73c45d9d$var$IR_RULE.check(padded) === null ? padded : value;
    }
});
// ── A country with no entry ──────────────────────────────────────────────────
// Latin letters and digits, a plausible length, no checksum. Deliberately loose:
// refusing a real document because its country was never written down here would
// stop a foreign patient being registered at all.
const $2885454b73c45d9d$var$GENERIC_MIN = 5;
const $2885454b73c45d9d$var$GENERIC_MAX = 20;
const $2885454b73c45d9d$export$1700237b484ebbcc = Object.freeze({
    country: null,
    charset: 'alphanumeric',
    minLength: $2885454b73c45d9d$var$GENERIC_MIN,
    maxLength: $2885454b73c45d9d$var$GENERIC_MAX,
    verifiable: false,
    strip: (raw)=>(0, $412e1a8a99c19c1a$export$522be3011864bb18)(String(raw ?? '')).toUpperCase().replace(/[^A-Z0-9]/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$export$1700237b484ebbcc.strip(raw).slice(0, $2885454b73c45d9d$var$GENERIC_MAX),
    check: (value)=>value.length < $2885454b73c45d9d$var$GENERIC_MIN ? 'incomplete' : null,
    repair: (value)=>value
});
const $2885454b73c45d9d$export$92a974607f6f02fc = Object.freeze({
    IR: $2885454b73c45d9d$var$IR_RULE
});
function $2885454b73c45d9d$export$8d56917ba3265ae0(country) {
    const home = (0, $abf0c103b4b92127$export$3cede7c619603eb2)() ? $2885454b73c45d9d$var$IR_RULE : $2885454b73c45d9d$export$1700237b484ebbcc;
    const raw = String(country ?? '').trim();
    if (!raw) return home;
    const parts = raw.split(/[-_]/);
    const region = parts.length > 1 ? parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p)) : /^[A-Z]{2}$/.test(raw) ? raw : null;
    if (!region) return home;
    return $2885454b73c45d9d$export$92a974607f6f02fc[region.toUpperCase()] || $2885454b73c45d9d$export$1700237b484ebbcc;
}
function $2885454b73c45d9d$export$9997440a468738e3(input, country) {
    return $2885454b73c45d9d$export$8d56917ba3265ae0(country).normalize(input);
}
function $2885454b73c45d9d$export$8b1749206e586151(input, { country: country, required: required = false } = {}) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    if (!value) return required ? 'required' : null;
    return rule.check(value);
}
function $2885454b73c45d9d$export$89cadb74f28f5ec2(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    return !!value && rule.check(value) === null;
}
function $2885454b73c45d9d$export$f198e2644d3eb5b8(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    return rule.repair(rule.normalize(input));
}
function $2885454b73c45d9d$export$6a9c909dc504d3aa(input, locale) {
    const ascii = (0, $412e1a8a99c19c1a$export$522be3011864bb18)(String(input ?? '')).trim();
    if (!ascii) return '';
    const { digits: digits } = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    return ascii.replace(/\d/g, (d)=>digits[Number(d)]);
}




'use client';
// The one national-id field. Everywhere in Parsina a human types a «کد ملی», it
// types it here — and no screen keeps its own length check or checksum.
//
// What it does that a plain <input> cannot:
//
//   1. **The rules of the issuing COUNTRY.** `country` (ISO alpha-2, default
//      Iran) picks the rule from `lib/nationalId.js`: Iran's ten digits and
//      checksum today, another country's the day its entry is added, a
//      shape-only check for a country with no entry. Language never picks it.
//   2. **The numerals of the language on screen.** Persian digits under `fa`,
//      Arabic-Indic under `ar`, Latin under `en` — whatever keyboard typed them.
//      Resolved by `numeralsFor`, the seam `MoneyInput` uses; nothing here
//      branches on a locale.
//   3. **Anything typed or pasted becomes the code.** Persian, Arabic and
//      full-width digits fold to ASCII; the dashes and spaces of
//      «001-234567-9» are dropped; the caret stays where the typist left it.
//   4. **One verdict, said once.** Required / incomplete / invalid, in the page
//      language, on blur and live from then on (§6.3) — the same verdict
//      `nationalIdProblem` gives the screen on submit.
//
// Value in and value out are both the BARE ASCII code — «0012345679», never
// «۰۰۱۲۳۴۵۶۷۹». Two ways to listen, and they say the same thing:
//
//   onChange({ target: { value, name } }, info)   — event-shaped, so it drops
//                                                    into an existing handler
//   onValueChange(value, info)                    — the bare string
//
// `info` is `{ value, complete, valid, problem, country }`. `onComplete(value)`
// fires when the code becomes complete and acceptable — the moment to look a
// patient up.
//
// WHICH COUNTRY (PM-0076, owner 2026-10-05): a clinic's patients carry the
// national id of the country the CLINIC is in — `defaultCountry`, the clinic's
// stored country — but a clinic also sees patients from elsewhere. A patient form
// passes `allowOtherCountries`, and the field grows a country chip (the phone
// field's flagged, searchable picker) that starts on the clinic's country. Picking
// another country re-reads the typed value under that country's rule and reports
// it through `onCountryChange(iso2)`. `country` makes the choice CONTROLLED (a
// form that stores the issuing country); without it the field keeps its own.
const $6dabae5d3309de70$var$messageFor = (copy, problem, rule, localise)=>{
    if (problem === 'required') return copy.required;
    if (problem === 'incomplete') return rule.minLength === rule.maxLength ? copy.incomplete(localise(String(rule.maxLength))) : copy.tooShort(localise(String(rule.minLength)));
    if (problem === 'invalid') return copy.invalid;
    return '';
};
const $6dabae5d3309de70$var$NationalIdInput = ({ value: value, onChange: onChange, onValueChange: onValueChange, onBlur: onBlur, onComplete: onComplete, // Whose number it is — ISO 3166-1 alpha-2, or a locale tag with a region.
// Controlled when passed; otherwise the field starts on `defaultCountry` (the
// clinic's country; omitted is Iran — outside the Iranian market, the country
// the phone field would preselect: `defaultNationalIdCountry`) and keeps the
// person's own pick.
country: countryProp, defaultCountry: defaultCountry, allowOtherCountries: // Offer the other countries — on every form that registers or edits a PATIENT.
// Off for a field that can only hold one country's number (the doctor's own
// code for an Iranian insurer).
allowOtherCountries = false, onCountryChange: onCountryChange, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, placeholder: placeholder, disabled: disabled = false, showValid: // `false` keeps the field from announcing «معتبر است» — for a dense form where
// the green line would push the row below it.
showValid = true, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name, autoFocus…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const shellRef = (0, $acw62.useRef)(null);
    const [picked, setPicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    // Set by the first blur: from then on the verdict follows every keystroke.
    const [checked, setChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).nationalId;
    const numerals = (0, $acw62.useMemo)(()=>(0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale), [
        locale
    ]);
    const country = countryProp || picked || defaultCountry || (0, $2885454b73c45d9d$export$d285ab09de6b6713)(locale);
    const rule = (0, $2885454b73c45d9d$export$8d56917ba3265ae0)(country);
    const countryRow = allowOtherCountries ? (0, $412e1a8a99c19c1a$export$586b3eaa727579f5)(rule.country || country) : null;
    const localise = (ascii)=>ascii.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    // A stored value may arrive in any digits, or as a number; it is read the way
    // typing is.
    const code = rule.normalize(value);
    const problem = code ? rule.check(code) : required ? 'required' : null;
    const isComplete = code.length >= rule.minLength;
    const isValid = rule.verifiable && !!code && problem === null;
    const isInvalid = problem === 'invalid';
    const error = externalError || (checked ? $6dabae5d3309de70$var$messageFor(copy, problem, rule, localise) : '');
    const statusShown = !externalError && rule.verifiable && isComplete && (isValid || isInvalid);
    if (label === undefined) label = rule.country === 'IR' ? copy.label : copy.genericLabel;
    if (placeholder === undefined) placeholder = rule.minLength === rule.maxLength && rule.charset === 'digits' ? copy.placeholder(localise(String(rule.maxLength))) : '';
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const report = (next, nextRule, iso)=>{
        const nextProblem = next ? nextRule.check(next) : required ? 'required' : null;
        const info = {
            value: next,
            complete: next.length >= nextRule.minLength,
            valid: !!next && nextProblem === null,
            problem: nextProblem,
            country: iso
        };
        onChange?.({
            target: {
                value: next,
                name: rest.name
            }
        }, info);
        onValueChange?.(next, info);
        if (info.valid) onComplete?.(next);
    };
    const handleCountry = (row)=>{
        const iso = row?.iso2;
        if (!iso || iso === country) return;
        if (!countryProp) setPicked(iso);
        onCountryChange?.(iso);
        // The same characters, read under the new country's rule — a code typed
        // before the country was picked is kept, not cleared.
        const nextRule = (0, $2885454b73c45d9d$export$8d56917ba3265ae0)(iso);
        report(nextRule.normalize(value), nextRule, iso);
        ref.current?.focus();
    };
    const handleChange = (e)=>{
        const el = e.target;
        // Digits map one to one, so the caret belongs after as many KEPT characters
        // as sat to its left — a pasted dash or space must not push it along.
        const keptLeft = rule.strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
        const kept = rule.strip(el.value);
        const next = kept.slice(0, rule.maxLength);
        // A keystroke into a code that is already full is refused, the way a native
        // `maxLength` refuses it — otherwise a digit typed mid-code pushes the last
        // one out and silently rewrites the number. (The DOM attribute itself is not
        // used: it truncates a pasted «001-234567-9» before the dashes are dropped.)
        const overflow = code.length === rule.maxLength && kept.length > rule.maxLength;
        if (overflow || next === code) {
            // Nothing to report, so React will not re-render — put the field back by
            // hand, or the refused character stays on screen and the caret jumps.
            const pos = Math.max(0, Math.min(code.length, keptLeft - (kept.length - code.length)));
            el.value = localise(code);
            el.setSelectionRange(pos, pos);
            return;
        }
        caret.current = Math.min(keptLeft, next.length);
        report(next, rule, country);
    };
    const messageId = `${controlId}-message`;
    const validLine = showValid && isValid && !error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: validLine ? '' : helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: "relative [unicode-bidi:isolate]",
        dir: "ltr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText || validLine ? messageId : undefined,
        "aria-invalid": error ? true : undefined,
        "aria-required": required || undefined,
        autoComplete: "off",
        ...rest,
        ref: ref,
        type: "text",
        inputMode: rule.charset === 'digits' ? 'numeric' : 'text',
        value: localise(code),
        onChange: handleChange,
        onBlur: (e)=>{
            setChecked(true);
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground tracking-[1.5px] tabular-nums', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', // With the country chip the chip owns the start and the ✓/✗ moves to the end.
        countryRow ? 'ps-[84px] pe-10' : 'ps-10 pe-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : statusShown && isValid ? 'border-clinic-green shadow-ring-green' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), countryRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "absolute inset-y-0 start-0 flex items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7801a9372e554ab2$export$2e2bcd8739ae039), {
        value: countryRow,
        onSelect: handleCountry,
        locale: localeProp,
        label: copy.country,
        disabled: disabled,
        anchorRef: shellRef,
        showDial: false,
        "data-testid": rest['data-testid'] ? `${rest['data-testid']}-country` : undefined
    })), statusShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": isValid ? copy.valid : copy.notValid,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('absolute top-1/2 -translate-y-1/2 flex items-center', countryRow ? 'end-3' : 'start-3', isValid ? 'text-clinic-green' : 'text-destructive')
    }, isValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })))), validLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] font-semibold text-clinic-green leading-snug"
    }, copy.valid));
};
var $6dabae5d3309de70$export$2e2bcd8739ae039 = $6dabae5d3309de70$var$NationalIdInput;



var $acw62 = parcelRequire("acw62");




'use client';
const $4fe0519cb1ec239e$var$NumberInput = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, unit: unit, min: min, max: max, validate: validate, disabled: disabled = false, style: style, // The language whose decimal mark the field accepts; defaults to <html lang>.
locale: localeProp, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const defaultValidate = (v)=>{
        if (!v) return '';
        const n = parseFloat(v);
        const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().number;
        if (isNaN(n)) return copy.invalid;
        if (min !== undefined && n < min) return copy.min(min);
        if (max !== undefined && n > max) return copy.max(max);
        return '';
    };
    const error = externalError || (touched ? internalError : '');
    // The stored value is ASCII with «.» as the decimal point. The page language's
    // own decimal mark (French «,», Persian «٫») is folded to «.» before the strip —
    // stripping first turned «72,5» into «725». «.» is accepted in every language.
    //
    // German GROUPS with «.» (PM-0212). Echoing the stored «72.5» back made a single
    // dot the field's decimal point, so a German «1.500» was silently stored as 1.5 —
    // a factor of 1000 the box never showed. Under a language whose group mark is «.»
    // the field therefore shows its value with the language's own decimal mark
    // («72,5»), and every «.» typed into it is a group mark, as in `MoneyInput` and
    // `currency.parseAmount(…, 'de')`: «1.500» is 1500, «1.234,5» is 1234.5. A dot that
    // vanishes as it is typed («1.5» → «15») is visible; a decimal is written «1,5».
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    const localDecimal = numerals.group === '.' && numerals.decimal !== '.';
    const display = localDecimal && value != null && value !== '' ? String(value).replace('.', numerals.decimal) : value;
    const handleChange = (e)=>{
        const v = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(e.target.value, true, numerals);
        onChange({
            target: {
                value: v
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        type: "text",
        inputMode: "decimal",
        value: display,
        onChange: handleChange,
        onBlur: (e)=>{
            setTouched(true);
            setInternalError((validate || defaultValidate)(value));
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        dir: "ltr",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', unit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unit)));
};
var $4fe0519cb1ec239e$export$2e2bcd8739ae039 = $4fe0519cb1ec239e$var$NumberInput;



var $acw62 = parcelRequire("acw62");




// ─────────────────────────────────────────────────────────────────────────────
// Currency — clinic money in the currency the clinic keeps its books in.
//
// `money.js` was written for one currency: whole RIALS on the wire, TOMAN in front
// of a human. That stays true for every Iranian clinic, byte for byte. A clinic may
// now keep its books in another currency, and this module is the one place that
// knows what each allowed currency looks like:
//
//   • ON THE WIRE an amount is an integer number of MINOR UNITS of the document's
//     currency — whole rials for IRR (exponent 0, a deliberate override of ISO's 2),
//     cents for USD, fils for KWD. Field names ending in `Rial` keep their names and
//     now mean "minor units of this row's `currency`".
//   • IN FRONT OF A HUMAN an amount is divided by `displayDivisor`. That is NOT
//     10**exponent: IRR's divisor is 10, because an Iranian reads toman.
//   • An EMPTY or ABSENT currency means IRR. That is how an older server, a lagging
//     proto copy or a historical row degrades to today's behaviour.
//   • Amounts in two currencies are never added, compared or charted together.
//     There is no exchange rate anywhere in Parsina: group (`sumByCurrency`) or
//     refuse (`assertSameCurrency` → MIXED_CURRENCY).
//
// For IRR every function here returns exactly what money.js returns today:
// `formatAmount(x, 'IRR')` is `fmtToman(x)`, `toDisplay` is `rialToToman`,
// `fromDisplay` is `tomanToRial` and `parseAmount` is `parseTomanToRial` for every
// input that one accepts. The tests hold each pair against the other. Both parsers
// read money.js's notation — a «.» decimal — unless the caller names a language
// that writes a decimal COMMA (French «1 234,5», German «1.234,5»): see `parseAmount`.
//
// The table below is the closed allow-list from docs/clinic-currency/CONTRACTS.md
// §1; `currency.cases.json` beside this file is its machine-readable twin, which the
// Python services copy byte for byte. Change one, change the other.
//
// DEPENDENCY-FREE ON PURPOSE: no imports at all, not even money.js. The file must be
// droppable into an older installed framework for local testing, and into any app
// or script, without dragging a module graph along.
// ─────────────────────────────────────────────────────────────────────────────
const $fcda591c8cd139a4$export$c19ece7ea27dcd9e = 'IRR';
function $fcda591c8cd139a4$var$deepFreeze(value) {
    for (const inner of Object.values(value))if (inner && typeof inner === 'object') $fcda591c8cd139a4$var$deepFreeze(inner);
    return Object.freeze(value);
}
const $fcda591c8cd139a4$export$76e9d3e89dba5250 = $fcda591c8cd139a4$var$deepFreeze({
    IRR: {
        code: 'IRR',
        exponent: 0,
        displayDivisor: 10,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 1,
        labels: {
            fa: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            en: {
                long: 'Toman',
                short: 'T'
            },
            ar: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            fr: {
                long: 'toman',
                short: 'T'
            },
            de: {
                long: 'Toman',
                short: 'T'
            }
        }
    },
    USD: {
        code: 'USD',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0644\u0627\u0631 \u0622\u0645\u0631\u06CC\u06A9\u0627",
                short: 'USD'
            },
            en: {
                long: 'US dollar',
                short: 'USD'
            },
            ar: {
                long: "\u062F\u0648\u0644\u0627\u0631 \u0623\u0645\u0631\u064A\u0643\u064A",
                short: 'USD'
            },
            fr: {
                long: "dollar am\xe9ricain",
                short: 'USD'
            },
            de: {
                long: 'US-Dollar',
                short: 'USD'
            }
        }
    },
    EUR: {
        code: 'EUR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u06CC\u0648\u0631\u0648",
                short: 'EUR'
            },
            en: {
                long: 'Euro',
                short: 'EUR'
            },
            ar: {
                long: "\u064A\u0648\u0631\u0648",
                short: 'EUR'
            },
            fr: {
                long: 'euro',
                short: 'EUR'
            },
            de: {
                long: 'Euro',
                short: 'EUR'
            }
        }
    },
    GBP: {
        code: 'GBP',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u067E\u0648\u0646\u062F \u0627\u0646\u06AF\u0644\u06CC\u0633",
                short: 'GBP'
            },
            en: {
                long: 'Pound sterling',
                short: 'GBP'
            },
            ar: {
                long: "\u062C\u0646\u064A\u0647 \u0625\u0633\u062A\u0631\u0644\u064A\u0646\u064A",
                short: 'GBP'
            },
            fr: {
                long: 'livre sterling',
                short: 'GBP'
            },
            de: {
                long: 'Pfund Sterling',
                short: 'GBP'
            }
        }
    },
    CHF: {
        code: 'CHF',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0641\u0631\u0627\u0646\u06A9 \u0633\u0648\u0626\u06CC\u0633",
                short: 'CHF'
            },
            en: {
                long: 'Swiss franc',
                short: 'CHF'
            },
            ar: {
                long: "\u0641\u0631\u0646\u0643 \u0633\u0648\u064A\u0633\u0631\u064A",
                short: 'CHF'
            },
            fr: {
                long: 'franc suisse',
                short: 'CHF'
            },
            de: {
                long: 'Schweizer Franken',
                short: 'CHF'
            }
        }
    },
    AED: {
        code: 'AED',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0631\u0647\u0645 \u0627\u0645\u0627\u0631\u0627\u062A",
                short: 'AED'
            },
            en: {
                long: 'UAE dirham',
                short: 'AED'
            },
            ar: {
                long: "\u062F\u0631\u0647\u0645 \u0625\u0645\u0627\u0631\u0627\u062A\u064A",
                short: 'AED'
            },
            fr: {
                long: "dirham des \xc9mirats arabes unis",
                short: 'AED'
            },
            de: {
                long: 'VAE-Dirham',
                short: 'AED'
            }
        }
    },
    SAR: {
        code: 'SAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0633\u0639\u0648\u062F\u06CC",
                short: 'SAR'
            },
            en: {
                long: 'Saudi riyal',
                short: 'SAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0633\u0639\u0648\u062F\u064A",
                short: 'SAR'
            },
            fr: {
                long: 'riyal saoudien',
                short: 'SAR'
            },
            de: {
                long: 'Saudi-Riyal',
                short: 'SAR'
            }
        }
    },
    QAR: {
        code: 'QAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0642\u0637\u0631",
                short: 'QAR'
            },
            en: {
                long: 'Qatari riyal',
                short: 'QAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0642\u0637\u0631\u064A",
                short: 'QAR'
            },
            fr: {
                long: 'riyal qatari',
                short: 'QAR'
            },
            de: {
                long: 'Katar-Riyal',
                short: 'QAR'
            }
        }
    },
    TRY: {
        code: 'TRY',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0644\u06CC\u0631 \u062A\u0631\u06A9\u06CC\u0647",
                short: 'TRY'
            },
            en: {
                long: 'Turkish lira',
                short: 'TRY'
            },
            ar: {
                long: "\u0644\u064A\u0631\u0629 \u062A\u0631\u0643\u064A\u0629",
                short: 'TRY'
            },
            fr: {
                long: 'livre turque',
                short: 'TRY'
            },
            de: {
                long: "T\xfcrkische Lira",
                short: 'TRY'
            }
        }
    },
    KWD: {
        code: 'KWD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u06A9\u0648\u06CC\u062A",
                short: 'KWD'
            },
            en: {
                long: 'Kuwaiti dinar',
                short: 'KWD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0643\u0648\u064A\u062A\u064A",
                short: 'KWD'
            },
            fr: {
                long: "dinar kowe\xeftien",
                short: 'KWD'
            },
            de: {
                long: 'Kuwait-Dinar',
                short: 'KWD'
            }
        }
    },
    BHD: {
        code: 'BHD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0628\u062D\u0631\u06CC\u0646",
                short: 'BHD'
            },
            en: {
                long: 'Bahraini dinar',
                short: 'BHD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0628\u062D\u0631\u064A\u0646\u064A",
                short: 'BHD'
            },
            fr: {
                long: "dinar bahre\xefni",
                short: 'BHD'
            },
            de: {
                long: 'Bahrain-Dinar',
                short: 'BHD'
            }
        }
    },
    OMR: {
        code: 'OMR',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0639\u0645\u0627\u0646",
                short: 'OMR'
            },
            en: {
                long: 'Omani rial',
                short: 'OMR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0639\u0645\u0627\u0646\u064A",
                short: 'OMR'
            },
            fr: {
                long: 'riyal omanais',
                short: 'OMR'
            },
            de: {
                long: 'Omanischer Rial',
                short: 'OMR'
            }
        }
    },
    // Whole dinars: ISO's exponent is 3, but no fils circulate and CLDR prints IQD
    // with no decimals — the same deliberate override as IRR's.
    IQD: {
        code: 'IQD',
        exponent: 0,
        displayDivisor: 1,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 0,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0639\u0631\u0627\u0642",
                short: 'IQD'
            },
            en: {
                long: 'Iraqi dinar',
                short: 'IQD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0639\u0631\u0627\u0642\u064A",
                short: 'IQD'
            },
            fr: {
                long: 'dinar irakien',
                short: 'IQD'
            },
            de: {
                long: 'Irakischer Dinar',
                short: 'IQD'
            }
        }
    }
});
const $fcda591c8cd139a4$export$729c9ac211f2ddda = Object.freeze(Object.keys($fcda591c8cd139a4$export$76e9d3e89dba5250));
function $fcda591c8cd139a4$export$68d15a182c6bcbf0(code) {
    return typeof code === 'string' && Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$export$76e9d3e89dba5250, code);
}
function $fcda591c8cd139a4$var$invalidCurrency(code) {
    const shown = typeof code === 'string' ? JSON.stringify(code) : String(code);
    const error = new Error(`Invalid currency ${shown}: expected one of ${$fcda591c8cd139a4$export$729c9ac211f2ddda.join(', ')}`);
    error.name = 'InvalidCurrencyError';
    error.code = 'INVALID_CURRENCY';
    error.currency = code;
    return error;
}
function $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code) {
    if (code == null || code === '') return $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
    if ($fcda591c8cd139a4$export$68d15a182c6bcbf0(code)) return code;
    throw $fcda591c8cd139a4$var$invalidCurrency(code);
}
function $fcda591c8cd139a4$export$272b829bb65f9e96(code) {
    return $fcda591c8cd139a4$export$76e9d3e89dba5250[$fcda591c8cd139a4$export$b91dea8e61ccd7ef(code)];
}
function $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, currency) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return null;
    return Number(amountMinor) / displayDivisor;
}
function $fcda591c8cd139a4$export$22f3da351f420435(displayValue, currency, locale) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const n = Number($fcda591c8cd139a4$var$dotDecimal(displayValue ?? '', locale).replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * displayDivisor) : NaN;
}
// ── Parsing what a human typed ──────────────────────────────────────────────
const $fcda591c8cd139a4$var$PERSIAN_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
const $fcda591c8cd139a4$var$ARABIC_DIGITS = "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669";
function $fcda591c8cd139a4$var$toAsciiDigits(text) {
    return text.replace(/[۰-۹]/g, (d)=>String($fcda591c8cd139a4$var$PERSIAN_DIGITS.indexOf(d))).replace(/[٠-٩]/g, (d)=>String($fcda591c8cd139a4$var$ARABIC_DIGITS.indexOf(d)));
}
// Characters a formatted figure carries that are not part of the number: ICU puts
// an LRM before a Persian negative and an ALM before an Arabic one, and a copy out
// of an RTL page can bring RLM or an isolate along.
const $fcda591c8cd139a4$var$BIDI_MARKS = /[‎‏؜‪-‮⁦-⁩]/g;
const $fcda591c8cd139a4$var$GROUPING = /[,٬\s]/;
const $fcda591c8cd139a4$var$GROUPING_ALL = /[,٬\s]/g;
/**
 * `value` as a string in the notation both parsers read: «.» the decimal, «,» a
 * grouping mark. A language whose decimal mark is a COMMA (French «1 234,5»,
 * grouped with U+202F; German «1.234,5», grouped with «.») writes the two the
 * other way round, so its text has them traded back; «٫» and «٬» are never
 * ambiguous and stay as they are. The mark is
 * the one `formatAmount` prints for that language, so whatever it prints reads
 * back. A number is never re-read: `String(1.5)` is «1.5» on every page.
 */ function $fcda591c8cd139a4$var$dotDecimal(value, locale) {
    const text = String(value);
    if (typeof value !== 'string' || $fcda591c8cd139a4$var$decimalMarkOf($fcda591c8cd139a4$var$languageOf(locale)) !== ',') return text;
    return text.replace(/[.,]/g, (mark)=>mark === ',' ? '.' : ',');
}
function $fcda591c8cd139a4$export$b94f7550e5b92f9c(input, currency, locale) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (input == null) return NaN;
    const text = $fcda591c8cd139a4$var$toAsciiDigits($fcda591c8cd139a4$var$dotDecimal(input, locale)).replace($fcda591c8cd139a4$var$BIDI_MARKS, '').replace(/−/g, '-').replace(/٫/g, '.').trim();
    if (text === '') return NaN;
    if (info.code === $fcda591c8cd139a4$export$c19ece7ea27dcd9e) {
        const n = Number(text.replace($fcda591c8cd139a4$var$GROUPING_ALL, ''));
        return Number.isFinite(n) ? Math.round(n * info.displayDivisor) : NaN;
    }
    return $fcda591c8cd139a4$var$parseStrict(text, info);
}
function $fcda591c8cd139a4$var$parseStrict(text, { displayDivisor: displayDivisor, maxDisplayDecimals: maxDisplayDecimals }) {
    let body = text;
    let sign = 1;
    if (body[0] === '-' || body[0] === '+') {
        if (body[0] === '-') sign = -1;
        body = body.slice(1).trim();
    }
    const dot = body.indexOf('.');
    const whole = dot < 0 ? body : body.slice(0, dot);
    const fraction = dot < 0 ? '' : body.slice(dot + 1);
    if (!/^\d*$/.test(fraction) || fraction.length > maxDisplayDecimals) return NaN;
    const groups = whole.split($fcda591c8cd139a4$var$GROUPING);
    if (groups.length > 1 && (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some((g)=>!/^\d{3}$/.test(g)))) return NaN;
    const digits = groups.join('');
    if (!/^\d*$/.test(digits) || digits === '' && fraction === '') return NaN;
    // Integer arithmetic: «0.29» must be 29 cents, not 28.999999999999996.
    const scale = 10 ** maxDisplayDecimals;
    const units = Number(digits || '0') * scale + Number(fraction.padEnd(maxDisplayDecimals, '0') || '0');
    const minor = Math.round(units * displayDivisor / scale);
    if (!Number.isSafeInteger(minor)) return NaN;
    return minor === 0 ? 0 : sign * minor;
}
// ── Showing an amount ───────────────────────────────────────────────────────
// The Intl tag per panel language. The numbering system is spelled out for Arabic
// because ICU's bare `ar` now prints Latin digits, while every Parsina panel renders
// Arabic with Arabic-Indic ones (`-nu-arab` in each app's i18n config). `fa-IR` is
// what `fmtToman` has always used. `fr-FR` groups with U+202F NARROW NO-BREAK SPACE
// and writes a decimal COMMA, «1 234,5» — `parseAmount` reads that back only when
// it is told the text is French. `de-DE` groups with «.» and writes a decimal
// COMMA too, «1.234,5» — read back only when the text is said to be German.
// Every language here needs `labels` on every row.
const $fcda591c8cd139a4$var$INTL_TAGS = {
    fa: 'fa-IR',
    en: 'en-US',
    ar: 'ar-u-nu-arab',
    fr: 'fr-FR',
    de: 'de-DE'
};
/** `en-GB` → `en`; unknown or unset → `fa`, as the kit's `kitCopy` falls back. */ function $fcda591c8cd139a4$var$languageOf(locale) {
    const base = String(locale || 'fa').toLowerCase().split(/[-_]/)[0];
    return Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$var$INTL_TAGS, base) ? base : 'fa';
}
// The decimal mark a language prints, from the same Intl data as its formatter:
// «٫» fa and ar, «.» en, «,» fr and de. Read, not listed, so the parser can never
// disagree with the figure on screen — even on an ICU build without French data,
// where both fall back together.
const $fcda591c8cd139a4$var$decimalMarks = new Map();
function $fcda591c8cd139a4$var$decimalMarkOf(language) {
    let mark = $fcda591c8cd139a4$var$decimalMarks.get(language);
    if (mark === undefined) {
        const parts = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language]).formatToParts(1.5);
        mark = parts.find((p)=>p.type === 'decimal')?.value ?? '.';
        $fcda591c8cd139a4$var$decimalMarks.set(language, mark);
    }
    return mark;
}
// What joins a figure to its unit word. French and German typography never let a
// unit wrap away from its number (German: DIN 5008, «1.500 Toman»), so both take
// U+00A0 NO-BREAK SPACE; every other language keeps the plain space it has always
// had.
const $fcda591c8cd139a4$var$UNIT_JOINERS = {
    fr: '\u00a0',
    de: '\u00a0'
};
// A formatter per (language, currency). Constructing Intl.NumberFormat is not free
// and amounts render inside list rows.
const $fcda591c8cd139a4$var$numberFormats = new Map();
function $fcda591c8cd139a4$var$numberFormat(language, info) {
    const key = `${language}|${info.code}`;
    let nf = $fcda591c8cd139a4$var$numberFormats.get(key);
    if (!nf) {
        nf = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language], {
            minimumFractionDigits: info.minDisplayDecimals,
            maximumFractionDigits: info.maxDisplayDecimals
        });
        $fcda591c8cd139a4$var$numberFormats.set(key, nf);
    }
    return nf;
}
function $fcda591c8cd139a4$export$e251d23bea783311(amountMinor, currency, { locale: locale = 'fa', unit: unit = 'none', fallback: fallback = "\u2014" } = {}) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const value = $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, info.code);
    if (value == null) return fallback;
    const language = $fcda591c8cd139a4$var$languageOf(locale);
    const text = $fcda591c8cd139a4$var$numberFormat(language, info).format(value);
    if (unit !== 'short' && unit !== 'long') return text;
    return `${text}${$fcda591c8cd139a4$var$UNIT_JOINERS[language] ?? ' '}${info.labels[language][unit]}`;
}
function $fcda591c8cd139a4$export$846d8329e0c3da65(currency, locale = 'fa', style = 'long') {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    return info.labels[$fcda591c8cd139a4$var$languageOf(locale)][style === 'short' ? 'short' : 'long'];
}
class $fcda591c8cd139a4$export$7cfa96280ebafb15 extends Error {
    constructor(currencies = [], message){
        const list = [
            ...new Set(currencies)
        ];
        super(message || `Amounts in different currencies cannot be combined: ${list.join(', ')}`);
        this.name = 'MixedCurrencyError';
        this.code = 'MIXED_CURRENCY';
        this.currencies = list;
    }
}
function $fcda591c8cd139a4$export$73a0b246a0fd217a(...codes) {
    const seen = [];
    for (const code of codes.flat()){
        const normalized = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code);
        if (!seen.includes(normalized)) seen.push(normalized);
    }
    if (seen.length > 1) throw new $fcda591c8cd139a4$export$7cfa96280ebafb15(seen);
    return seen[0] || $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
}
const $fcda591c8cd139a4$var$picker = (pick, fallbackKey)=>{
    if (typeof pick === 'function') return pick;
    const key = pick ?? fallbackKey;
    return (row)=>row?.[key];
};
function $fcda591c8cd139a4$export$b440d7571b9fe7a6(rows, pickAmount, pickCurrency) {
    const amountOf = $fcda591c8cd139a4$var$picker(pickAmount, 'amount');
    const currencyOf = $fcda591c8cd139a4$var$picker(pickCurrency, 'currency');
    const totals = {};
    for (const row of rows || []){
        const raw = amountOf(row);
        if (raw == null || raw === '') continue;
        const amount = Number(raw);
        if (!Number.isFinite(amount)) continue;
        const code = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(currencyOf(row));
        totals[code] = (totals[code] || 0) + amount;
    }
    return totals;
}


'use client';
// The one money field. Everywhere in Parsina a human types a price, it types it here.
//
// Three things it does that a plain <input> cannot:
//
//   1. **Thousands separators as you type.** «500000» reads back as «۵۰۰٬۰۰۰».
//      Native <input type="number"> can't render a separator at all (the browser
//      rejects the comma), so this is a text input that DISPLAYS the grouped string
//      and reports the bare numeric one.
//   2. **The numerals of the language on screen.** Persian digits under `fa`, Latin
//      under `en`, each with that locale's own separators — resolved from CLDR, so
//      nothing here branches on a locale id. See `numeralsFor`.
//   3. **The unit, always.** A money field with no unit is how a rial figure ends up
//      read as toman; the label defaults rather than being optional.
//
// Value in and value out are both the BARE ASCII numeric string — «500000», never
// «۵۰۰٬۰۰۰». Localised digits exist only between here and the DOM, so no form, no
// parse and no toman↔rial conversion downstream sees them. onChange is handed that
// string directly, not an event: `onChange={setAmount}`.
//
// It preserves the caret across regrouping: inserting a digit that pushes a new
// separator in would otherwise fling the cursor to the end. We remember how many
// digits sat to the left of the caret and put it back after the same digit once
// React re-renders.
// The default chip. IRR — and no currency at all, which IS IRR — reads the kit's
// localised toman, exactly as before `currency` existed. Any other clinic currency
// reads its short form from the currency table («USD», «KWD»), because a non-IRR
// clinic must never see «تومان» beside its money. Anything that is not a currency
// («پارسه», a percentage) is still the caller's `unitLabel`.
const $b90d527c31e5b4da$var$unitLabelFor = (locale, info)=>info.code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e) ? (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).toman : (0, $fcda591c8cd139a4$export$846d8329e0c3da65)(info.code, locale, 'short');
// At most `places` digits after the decimal point. Applied only to a non-IRR
// currency: an IRR field (a toman price, a percentage discount) keeps what it
// always accepted.
function $b90d527c31e5b4da$var$limitFraction(raw, places) {
    const dot = raw.indexOf('.');
    return dot < 0 || raw.length - dot - 1 <= places ? raw : raw.slice(0, dot + 1 + places);
}
const $b90d527c31e5b4da$var$MoneyInput = ({ value: value, onChange: onChange, onBlur: onBlur, currency: // The clinic currency the figure is in. Omitted, blank or 'IRR' is today's toman
// field exactly. Another currency changes the default chip and allows up to its
// fraction digits. It never converts: value in and out stay DISPLAY units (toman,
// dollars), and the call site turns them into minor units with
// `currency.fromDisplay` — see docs/MONEY_INPUT.md §2.4 and §6.3.
currency, // Defaults to false for IRR and true for any other currency.
allowDecimal: allowDecimalProp, unit: // Unit — `unit` is a full node override, `unitLabel` just changes the text.
// `unit={null}` is the deliberate way to render none.
unit, unitLabel: unitLabel, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, validate: validate, placeholder: placeholder, disabled: disabled = false, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // A pasted figure refused as ambiguous (see handlePaste); cleared by the next edit.
    const [pasteError, setPasteError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const numerals = (0, $acw62.useMemo)(()=>(0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale), [
        locale
    ]);
    // Throws INVALID_CURRENCY for a code outside the table rather than guessing.
    const info = (0, $fcda591c8cd139a4$export$272b829bb65f9e96)(currency);
    const isIrr = info.code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
    const allowDecimal = allowDecimalProp ?? !isIrr;
    const clean = (text)=>{
        const raw = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(text, allowDecimal, numerals);
        return isIrr || !allowDecimal ? raw : $b90d527c31e5b4da$var$limitFraction(raw, info.maxDisplayDecimals);
    };
    const error = externalError || pasteError || (touched ? internalError : '');
    const display = (0, $ca1f40e638c62a9a$export$302430bce3371cb8)(value ?? '', numerals);
    // `unit === null` means "no unit, I mean it"; `undefined` means "you choose".
    const unitNode = unit !== undefined ? unit : unitLabel ?? $b90d527c31e5b4da$var$unitLabelFor(locale, info);
    const hasUnit = unitNode != null && unitNode !== '';
    // The chip is painted beside the digits, which a screen reader never connects to
    // the field — «۵۰۰٬۰۰۰» alone does not say toman. Describing the input by it is
    // what makes the unit part of the field for a non-sighted reader too. A caller's
    // own `aria-describedby` is kept, not replaced.
    const unitId = `${(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId()}-unit`;
    const describedBy = [
        rest['aria-describedby'],
        hasUnit ? unitId : null
    ].filter(Boolean).join(' ') || undefined;
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const handleChange = (e)=>{
        const el = e.target;
        // How many MEANINGFUL characters sat left of the caret — digits, plus the
        // decimal mark when one is allowed. Counting digits alone parks the caret
        // before a just-typed decimal mark, so «1.5» lands as «1.» + «5» = «15.».
        const keptLeft = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(el.value.slice(0, el.selectionStart ?? el.value.length), allowDecimal, numerals).length;
        const raw = clean(el.value);
        const grouped = (0, $ca1f40e638c62a9a$export$302430bce3371cb8)(raw, numerals);
        // Walk the regrouped string until that many are behind us; the separators it
        // inserted are skipped over. `\p{Nd}` rather than an ASCII range: «۵» is a
        // digit too, and an ASCII test flings the caret to the end in Persian.
        const isKept = (ch)=>/\p{Nd}/u.test(ch) || allowDecimal && ch === numerals.decimal;
        let pos = 0, seen = 0;
        while(pos < grouped.length && seen < keptLeft){
            if (isKept(grouped[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        if (pasteError) setPasteError('');
        onChange(raw);
    };
    // Under a language that GROUPS with «.» (German) every dot is a group mark, which
    // is what the field prints as it regroups. A pasted «12.50» or «1.5» — an English
    // decimal — would silently store 1250 or 15, a hundred or ten times the amount, so
    // a paste whose dots are not groups of three is refused with the kit's «not a valid
    // number», as `currency.parseAmount(…, 'de')` refuses it. «1.234» and «1.234,5»
    // paste as before. No other language groups with «.», so none is affected.
    const handlePaste = (e)=>{
        rest.onPaste?.(e);
        if (e.defaultPrevented || numerals.group !== '.') return;
        const text = e.clipboardData?.getData('text') ?? '';
        if ((0, $ca1f40e638c62a9a$export$bb91f232d86bf745)(text, numerals)) return;
        e.preventDefault();
        setPasteError((0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).number.invalid);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: "text",
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        // A number is an LTR run even inside an RTL form — the same rule that
        // keeps phone numbers and codes readable.
        dir: "ltr",
        value: display,
        onChange: handleChange,
        onPaste: handlePaste,
        "aria-describedby": describedBy,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', hasUnit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), hasUnit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: unitId,
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unitNode)));
};
var $b90d527c31e5b4da$export$2e2bcd8739ae039 = $b90d527c31e5b4da$var$MoneyInput;



var $acw62 = parcelRequire("acw62");


'use client';
const $26a45cd6e1b19edd$var$Textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, rows: rows = 3, maxLength: maxLength, showCount: showCount = false, validate: validate, disabled: disabled = false, style: style, inputStyle: // `style` dresses the FIELD (label + control + helper); `inputStyle` reaches
// the control itself — the same split `TextInput` already has. It exists for
// the mobile rule that a field's type must be ≥1rem or iOS zooms the page on
// focus (DESIGN-CONCEPT-MOBILE §6), which the 13.5px default is under.
inputStyle, dir: // Unset: inherits the document's direction (§16.3). It defaulted to 'rtl',
// which pinned every note field in the product to RTL whatever the language.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        rows: rows,
        maxLength: maxLength,
        dir: dir,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full px-3.5 py-3 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none resize-none leading-7', 'transition-[border-color,box-shadow] duration-150', showCount && maxLength && 'pb-6', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }), showCount && maxLength && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute bottom-2 end-3 text-[10.5px] text-muted-foreground pointer-events-none select-none"
    }, (value || '').length, "/", maxLength)));
});
$26a45cd6e1b19edd$var$Textarea.displayName = 'Textarea';
var $26a45cd6e1b19edd$export$2e2bcd8739ae039 = $26a45cd6e1b19edd$var$Textarea;



var $acw62 = parcelRequire("acw62");



'use client';
const $2f997edd3d0e9220$var$Select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, options: options = [], placeholder: placeholder, validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    if (placeholder === undefined) placeholder = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().select.placeholder;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// Logical padding, and no `dir` of its own: the room for the chevron
        // is on the field's END edge, whichever side that is. It used to be
        // `dir="rtl"` + `pr-3.5 pl-8`, which put a Persian-shaped control
        // inside an English page and the chevron on top of the text.
        'w-full h-11 ps-3.5 pe-8 rounded-lg font-sans text-[13.5px]', 'bg-white border-[1.5px] outline-none appearance-none cursor-pointer', 'transition-[border-color,box-shadow] duration-150', value ? 'text-foreground' : 'text-muted-foreground', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }, placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), options.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value
        }, o.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "15",
        height: "15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    })))));
});
$2f997edd3d0e9220$var$Select.displayName = 'Select';
var $2f997edd3d0e9220$export$2e2bcd8739ae039 = $2f997edd3d0e9220$var$Select;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $45e038b71f97d914$var$__defProp = Object.defineProperty;
var $45e038b71f97d914$var$__name = (target, value)=>$45e038b71f97d914$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = /* @__PURE__ */ $45e038b71f97d914$var$__name((props)=>{
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }, "Provider");
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, options = {}) {
        const { optional: optional = false } = options;
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        if (optional) return void 0;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    $45e038b71f97d914$var$__name(useContext2, "useContext");
    return [
        Provider,
        useContext2
    ];
}
$45e038b71f97d914$var$__name($45e038b71f97d914$export$fd42f52fd3ae1109, "createContext");
// @__NO_SIDE_EFFECTS__
function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = /* @__PURE__ */ $45e038b71f97d914$var$__name((props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, "Provider");
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope, options = {}) {
            const { optional: optional = false } = options;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            if (optional) return void 0;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        $45e038b71f97d914$var$__name(useContext2, "useContext");
        return [
            Provider,
            useContext2
        ];
    }
    $45e038b71f97d914$var$__name(createContext3, "createContext");
    const createScope = /* @__PURE__ */ $45e038b71f97d914$var$__name(()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return /* @__PURE__ */ $45e038b71f97d914$var$__name(function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        }, "useScope");
    }, "createScope");
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $45e038b71f97d914$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
$45e038b71f97d914$var$__name($45e038b71f97d914$export$50c7b4e9d9f19c1, "createContextScope");
function $45e038b71f97d914$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = /* @__PURE__ */ $45e038b71f97d914$var$__name(()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return /* @__PURE__ */ $45e038b71f97d914$var$__name(function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        }, "useComposedScopes");
    }, "createScope");
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}
$45e038b71f97d914$var$__name($45e038b71f97d914$var$composeContextScopes, "composeContextScopes");



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $fb3356a19a5676fa$var$__defProp = Object.defineProperty;
var $fb3356a19a5676fa$var$__name = (target, value)=>$fb3356a19a5676fa$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $fb3356a19a5676fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$fb3356a19a5676fa$var$__name($fb3356a19a5676fa$var$setRef, "setRef");
function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $fb3356a19a5676fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $fb3356a19a5676fa$var$setRef(refs[i], null);
            }
        };
    };
}
$fb3356a19a5676fa$var$__name($fb3356a19a5676fa$export$43e446d32b3d21af, "composeRefs");
function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}
$fb3356a19a5676fa$var$__name($fb3356a19a5676fa$export$c7b2cbe3552a0d05, "useComposedRefs");


var $cf381de56a25bc52$var$__defProp = Object.defineProperty;
var $cf381de56a25bc52$var$__name = (target, value)=>$cf381de56a25bc52$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($cf381de56a25bc52$var$isLazyComponent(children) && typeof $cf381de56a25bc52$var$use === "function") children = $cf381de56a25bc52$var$use(children._payload);
        $acw62.Children.forEach(children, (maybeSlottable)=>{
            if ($cf381de56a25bc52$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($cf381de56a25bc52$var$isLazyComponent(child) && typeof $cf381de56a25bc52$var$use === "function") child = $cf381de56a25bc52$var$use(child._payload);
                slottableElement = $cf381de56a25bc52$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $acw62.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $acw62.Children.count(children) === 1 && $acw62.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $cf381de56a25bc52$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $cf381de56a25bc52$var$createSlottableError(ownerName) : $cf381de56a25bc52$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $cf381de56a25bc52$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $acw62.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $acw62.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$export$e88b45bda5c13eb9, "createSlot");
var $cf381de56a25bc52$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $cf381de56a25bc52$export$e88b45bda5c13eb9("Slot");
var $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = /* @__PURE__ */ $cf381de56a25bc52$var$__name((props)=>"child" in props ? props.children(props.child) : props.children, "Slottable");
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$export$bf68c29d8281d0f7, "createSlottable");
var $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $cf381de56a25bc52$export$bf68c29d8281d0f7("Slottable");
var $cf381de56a25bc52$var$getSlottableElementFromSlottable = /* @__PURE__ */ $cf381de56a25bc52$var$__name((slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$acw62.isValidElement(child2)) return null;
        return $acw62.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $acw62.isValidElement(child) ? child : null;
}, "getSlottableElementFromSlottable");
function $cf381de56a25bc52$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$mergeProps, "mergeProps");
function $cf381de56a25bc52$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$getElementRef, "getElementRef");
function $cf381de56a25bc52$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$isSlottable, "isSlottable");
var $cf381de56a25bc52$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $cf381de56a25bc52$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $cf381de56a25bc52$var$REACT_LAZY_TYPE && "_payload" in element && $cf381de56a25bc52$var$isPromiseLike(element._payload);
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$isLazyComponent, "isLazyComponent");
function $cf381de56a25bc52$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
$cf381de56a25bc52$var$__name($cf381de56a25bc52$var$isPromiseLike, "isPromiseLike");
var $cf381de56a25bc52$var$createSlotError = /* @__PURE__ */ $cf381de56a25bc52$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
}, "createSlotError");
var $cf381de56a25bc52$var$createSlottableError = /* @__PURE__ */ $cf381de56a25bc52$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
}, "createSlottableError");
var $cf381de56a25bc52$var$use = $acw62[" use ".trim().toString()];



var $dc7d5df3de21cdcb$var$__defProp = Object.defineProperty;
var $dc7d5df3de21cdcb$var$__name = (target, value)=>$dc7d5df3de21cdcb$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $dc7d5df3de21cdcb$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
$dc7d5df3de21cdcb$var$__name($dc7d5df3de21cdcb$export$6d1a0317bde7de7f, "dispatchDiscreteCustomEvent");
var $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");
var $b4e9a20689651e16$var$__defProp = Object.defineProperty;
var $b4e9a20689651e16$var$__name = (target, value)=>$b4e9a20689651e16$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// src/primitive.tsx
var $b4e9a20689651e16$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return /* @__PURE__ */ $b4e9a20689651e16$var$__name(function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) return ourEventHandler?.(event);
    }, "handleEvent");
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$b9ecd428b558ff10, "composeEventHandlers");
function $b4e9a20689651e16$export$f21a1ffae260145a(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$f21a1ffae260145a, "getOwnerWindow");
function $b4e9a20689651e16$export$b204af158042fbac(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$b204af158042fbac, "getOwnerDocument");
function $b4e9a20689651e16$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b4e9a20689651e16$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($b4e9a20689651e16$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b4e9a20689651e16$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b4e9a20689651e16$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$cd4e5573fbe2b576, "getActiveElement");
function $b4e9a20689651e16$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}
$b4e9a20689651e16$var$__name($b4e9a20689651e16$export$6a12f24039de8f3a, "isFrame");



var $acw62 = parcelRequire("acw62");




"use client";
var $a9634733d4b9bce9$var$__defProp = Object.defineProperty;
var $a9634733d4b9bce9$var$__name = (target, value)=>$a9634733d4b9bce9$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = /* @__PURE__ */ $a9634733d4b9bce9$var$__name((props)=>{
        const { scope: scope, children: children } = props;
        const ref = $acw62.useRef(null);
        const itemMap = $acw62.useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    }, "CollectionProvider");
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        $acw62.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = $acw62.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    $a9634733d4b9bce9$var$__name(useCollection, "useCollection");
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$export$c74125a8e3af6bb2, "createCollection");
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    static{
        $a9634733d4b9bce9$var$__name(this, "OrderedDict");
    }
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$at, "at");
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$toSafeIndex, "toSafeIndex");
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$toSafeInteger, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $a9634733d4b9bce9$var$OrderedDict(),
        setItemMap: /* @__PURE__ */ $a9634733d4b9bce9$var$__name(()=>void 0, "setItemMap")
    });
    const CollectionProvider = /* @__PURE__ */ $a9634733d4b9bce9$var$__name(({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionInit, {
            ...props
        });
    }, "CollectionProvider");
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = /* @__PURE__ */ $a9634733d4b9bce9$var$__name((props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    }, "CollectionInit");
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = /* @__PURE__ */ $a9634733d4b9bce9$var$__name((props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = $acw62.useRef(null);
        const [collectionElement, setCollectionElement] = $acw62.useState(null);
        const composeRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        $acw62.useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    }, "CollectionProviderImpl");
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const [element, setElement] = $acw62.useState(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = $acw62.useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        $acw62.useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $a9634733d4b9bce9$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return $acw62.useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    $a9634733d4b9bce9$var$__name(useInitCollection, "useInitCollection");
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    $a9634733d4b9bce9$var$__name(useCollection, "useCollection");
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$export$ec5c5a85b7371a0f, "createCollection");
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$shallowEqual, "shallowEqual");
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$isElementPreceding, "isElementPreceding");
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$sortByDocumentPosition, "sortByDocumentPosition");
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}
$a9634733d4b9bce9$var$__name($a9634733d4b9bce9$var$getChildListObserver, "getChildListObserver");





var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $b68d88740313b08e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


var $11885ec535b13ccc$var$__defProp = Object.defineProperty;
var $11885ec535b13ccc$var$__name = (target, value)=>$11885ec535b13ccc$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $11885ec535b13ccc$var$useReactId = $acw62[" useId ".trim().toString()] || (()=>void 0);
var $11885ec535b13ccc$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$useReactId());
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($11885ec535b13ccc$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}
$11885ec535b13ccc$var$__name($11885ec535b13ccc$export$f680877a34711e37, "useId");




var $acw62 = parcelRequire("acw62");
var $95d2d9f03fd0d4db$var$__defProp = Object.defineProperty;
var $95d2d9f03fd0d4db$var$__name = (target, value)=>$95d2d9f03fd0d4db$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}
$95d2d9f03fd0d4db$var$__name($95d2d9f03fd0d4db$export$25bec8c6f54ee79a, "useCallbackRef");


// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $110a9e671b260f1d$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


// src/use-effect-event.tsx
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $1fb2ca5e3aef07a3$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};



var $acw62 = parcelRequire("acw62");
var $e812c0b307b5fab3$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $e812c0b307b5fab3$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $e812c0b307b5fab3$export$7f54fc3180508a52(callback) {
    if (typeof $e812c0b307b5fab3$var$useReactEffectEvent === "function") return $e812c0b307b5fab3$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $e812c0b307b5fab3$var$useReactInsertionEffect === "function") $e812c0b307b5fab3$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $1fb2ca5e3aef07a3$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $0e3b3d11366af198$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $110a9e671b260f1d$export$e5c5a5f917a5871c);
function $0e3b3d11366af198$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $0e3b3d11366af198$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $0e3b3d11366af198$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $0e3b3d11366af198$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $0e3b3d11366af198$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $0e3b3d11366af198$var$isFunction(value) {
    return typeof value === "function";
}
var $0e3b3d11366af198$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $0e3b3d11366af198$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $e812c0b307b5fab3$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $0e3b3d11366af198$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $0e3b3d11366af198$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $acw62 = parcelRequire("acw62");

"use client";
var $f9ad7d2f57cc5bec$var$__defProp = Object.defineProperty;
var $f9ad7d2f57cc5bec$var$__name = (target, value)=>$f9ad7d2f57cc5bec$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = /* @__PURE__ */ $f9ad7d2f57cc5bec$var$__name((props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
}, "DirectionProvider");
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
$f9ad7d2f57cc5bec$var$__name($f9ad7d2f57cc5bec$export$b39126d51d94e6f3, "useDirection");
var $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;




var $acw62 = parcelRequire("acw62");
var $05e93d8d36380231$var$__defProp = Object.defineProperty;
var $05e93d8d36380231$var$__name = (target, value)=>$05e93d8d36380231$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $05e93d8d36380231$var$_isHydrated = false;
function $05e93d8d36380231$var$useIsHydrated() {
    const [isHydrated, setIsHydrated] = $acw62.useState($05e93d8d36380231$var$_isHydrated);
    $acw62.useEffect(()=>{
        if (!$05e93d8d36380231$var$_isHydrated) {
            $05e93d8d36380231$var$_isHydrated = true;
            setIsHydrated(true);
        }
    }, []);
    return isHydrated;
}
$05e93d8d36380231$var$__name($05e93d8d36380231$var$useIsHydrated, "useIsHydrated");
// src/use-is-hydrated.tsx
var $05e93d8d36380231$var$useReactSyncExternalStore = $acw62[" useSyncExternalStore ".trim().toString()];
function $05e93d8d36380231$var$subscribe() {
    return ()=>{};
}
$05e93d8d36380231$var$__name($05e93d8d36380231$var$subscribe, "subscribe");
function $05e93d8d36380231$var$useIsHydratedModern() {
    return $05e93d8d36380231$var$useReactSyncExternalStore($05e93d8d36380231$var$subscribe, ()=>true, ()=>false);
}
$05e93d8d36380231$var$__name($05e93d8d36380231$var$useIsHydratedModern, "useIsHydratedModern");
var $05e93d8d36380231$export$fd0534379e135f3d = typeof $05e93d8d36380231$var$useReactSyncExternalStore === "function" ? $05e93d8d36380231$var$useIsHydratedModern : $05e93d8d36380231$var$useIsHydrated;



"use client";
var $0483c88073bf4923$var$__defProp = Object.defineProperty;
var $0483c88073bf4923$var$__name = (target, value)=>$0483c88073bf4923$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$8699f7c8af148338 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $0483c88073bf4923$var$__name(function RovingFocusGroup2(props, forwardedRef) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
}, "RovingFocusGroup"));
var $0483c88073bf4923$var$RovingFocusGroupImpl = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $0483c88073bf4923$var$__name(function RovingFocusGroupImpl2(props, forwardedRef) {
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $0e3b3d11366af198$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $0483c88073bf4923$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
}, "RovingFocusGroupImpl"));
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$ab9df7c53fe8454 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $0483c88073bf4923$var$__name(function RovingFocusGroupItem2(props, forwardedRef) {
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    const isHydrated = (0, $05e93d8d36380231$export$fd0534379e135f3d)();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!isHydrated || !focusable) return;
        onFocusableItemAdd();
        return ()=>onFocusableItemRemove();
    }, [
        isHydrated,
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    $acw62.useEffect(()=>{
        if (isHydrated || !focusable) return;
        onFocusableItemAdd();
        return ()=>onFocusableItemRemove();
    }, [
        isHydrated,
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
}, "RovingFocusGroupItem"));
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$getDirectionAwareKey, "getDirectionAwareKey");
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$getFocusIntent, "getFocusIntent");
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$focusFirst, "focusFirst");
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
$0483c88073bf4923$var$__name($0483c88073bf4923$var$wrapArray, "wrapArray");
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
var $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;



var $acw62 = parcelRequire("acw62");

// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $7814feaab77fb88e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


// src/use-effect-event.tsx


var $acw62 = parcelRequire("acw62");
var $58fb120775a7e1ec$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $58fb120775a7e1ec$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $58fb120775a7e1ec$export$7f54fc3180508a52(callback) {
    if (typeof $58fb120775a7e1ec$var$useReactEffectEvent === "function") return $58fb120775a7e1ec$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $58fb120775a7e1ec$var$useReactInsertionEffect === "function") $58fb120775a7e1ec$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $7814feaab77fb88e$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $2ed7ffbff667d695$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $7814feaab77fb88e$export$e5c5a5f917a5871c);
function $2ed7ffbff667d695$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $2ed7ffbff667d695$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $2ed7ffbff667d695$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $2ed7ffbff667d695$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $2ed7ffbff667d695$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $2ed7ffbff667d695$var$isFunction(value) {
    return typeof value === "function";
}
var $2ed7ffbff667d695$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $2ed7ffbff667d695$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $58fb120775a7e1ec$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $2ed7ffbff667d695$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $2ed7ffbff667d695$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}




"use client";
var $62b265af90252982$var$__defProp = Object.defineProperty;
var $62b265af90252982$var$__name = (target, value)=>$62b265af90252982$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$bea8ebba691c5813 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $62b265af90252982$var$__name(function Toggle2(props, forwardedRef) {
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed, setPressed] = (0, $2ed7ffbff667d695$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed ?? false,
        caller: $62b265af90252982$var$NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
}, "Toggle"));
var $62b265af90252982$export$be92b6f5f03c0fe9 = $62b265af90252982$export$bea8ebba691c5813;


// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $19e407685a9b7751$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


// src/use-effect-event.tsx


var $acw62 = parcelRequire("acw62");
var $53ec3635facde444$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $53ec3635facde444$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $53ec3635facde444$export$7f54fc3180508a52(callback) {
    if (typeof $53ec3635facde444$var$useReactEffectEvent === "function") return $53ec3635facde444$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $53ec3635facde444$var$useReactInsertionEffect === "function") $53ec3635facde444$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $19e407685a9b7751$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $154248d0b97bde83$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $19e407685a9b7751$export$e5c5a5f917a5871c);
function $154248d0b97bde83$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $154248d0b97bde83$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $154248d0b97bde83$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $154248d0b97bde83$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $154248d0b97bde83$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $154248d0b97bde83$var$isFunction(value) {
    return typeof value === "function";
}
var $154248d0b97bde83$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $154248d0b97bde83$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $53ec3635facde444$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $154248d0b97bde83$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $154248d0b97bde83$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}




"use client";
var $57c1675cf83b8426$var$__defProp = Object.defineProperty;
var $57c1675cf83b8426$var$__name = (target, value)=>$57c1675cf83b8426$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $57c1675cf83b8426$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$57c1675cf83b8426$var$createToggleGroupContext, $57c1675cf83b8426$export$d1c7c4bcd9f26dd4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($57c1675cf83b8426$var$TOGGLE_GROUP_NAME, [
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
var $57c1675cf83b8426$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var $57c1675cf83b8426$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroup2(props, forwardedRef) {
    const { type: type, ...toggleGroupProps } = props;
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplSingle, {
            role: "radiogroup",
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplMultiple, {
            role: "toolbar",
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$57c1675cf83b8426$var$TOGGLE_GROUP_NAME}\``);
}, "ToggleGroup"));
var [$57c1675cf83b8426$var$ToggleGroupValueProvider, $57c1675cf83b8426$var$useToggleGroupValueContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImplSingle = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupImplSingle2(props, forwardedRef) {
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = /* @__PURE__ */ $57c1675cf83b8426$var$__name(()=>{}, "onValueChange"), ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $154248d0b97bde83$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: $acw62.useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemActivate: setValue,
        onItemDeactivate: $acw62.useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
}, "ToggleGroupImplSingle"));
var $57c1675cf83b8426$var$ToggleGroupImplMultiple = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupImplMultiple2(props, forwardedRef) {
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = /* @__PURE__ */ $57c1675cf83b8426$var$__name(()=>{}, "onValueChange"), ...toggleGroupMultipleProps } = props;
    const [value, setValue] = (0, $154248d0b97bde83$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    const handleButtonActivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
}, "ToggleGroupImplMultiple"));
var [$57c1675cf83b8426$var$ToggleGroupContext, $57c1675cf83b8426$var$useToggleGroupContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupImpl2(props, forwardedRef) {
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const commonProps = {
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
}, "ToggleGroupImpl"));
var $57c1675cf83b8426$var$ITEM_NAME = "ToggleGroupItem";
var $57c1675cf83b8426$export$6d08773d2e66f8f2 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupItem2(props, forwardedRef) {
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $57c1675cf83b8426$var$useToggleGroupContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = $acw62.useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
}, "ToggleGroupItem"));
var $57c1675cf83b8426$var$ToggleGroupItemImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $57c1675cf83b8426$var$__name(function ToggleGroupItemImpl2(props, forwardedRef) {
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $62b265af90252982$export$bea8ebba691c5813), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
}, "ToggleGroupItemImpl"));




'use client';
const $43f8655df02249d5$var$ToggleGroup = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57c1675cf83b8426$export$be92b6f5f03c0fe9, {
        type: "single",
        value: value,
        onValueChange: (v)=>{
            if (!v) return;
            onChange(v);
            setTouched(true);
            if (validate) setInternalError(validate(v) || '');
        },
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex gap-1.5 p-1 rounded-xl bg-[#f4f6f9]', error && 'ring-[1.5px] ring-destructive')
    }, options.map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57c1675cf83b8426$export$6d08773d2e66f8f2, {
            key: opt.value,
            value: opt.value,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex-1 h-[38px] rounded-[9px] font-sans text-[13px]', 'flex items-center justify-center gap-1.5', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', 'data-[state=on]:bg-white data-[state=on]:text-navy data-[state=on]:font-bold data-[state=on]:shadow-sm', 'data-[state=off]:bg-transparent data-[state=off]:text-muted-foreground data-[state=off]:font-medium', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[15px]"
        }, opt.icon), opt.label))));
};
var $43f8655df02249d5$export$2e2bcd8739ae039 = $43f8655df02249d5$var$ToggleGroup;



var $acw62 = parcelRequire("acw62");


'use client';
const $fcaca06c97c91379$var$ChipSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], multi: multi = false, activeColor: activeColor = 'var(--p-navy)', activeBg: activeBg = 'hsl(var(--accent))', validate: validate, disabled: disabled = false, style: style, touch: // `touch` sizes the chips for a finger (2.75rem); `testId` names the row and,
// with each option's `testKey` (else its value), every chip in it; `children`
// follow the chips in the same row — a «more» toggle belongs there.
touch = false, testId: testId, children: children })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const isActive = (v)=>multi ? (value || []).includes(v) : value === v;
    const handleToggle = (optValue)=>{
        if (disabled) return;
        let next;
        if (multi) {
            const arr = value || [];
            next = arr.includes(optValue) ? arr.filter((v)=>v !== optValue) : [
                ...arr,
                optValue
            ];
        } else next = value === optValue ? '' : optValue;
        onChange(next);
        setTouched(true);
        if (validate) setInternalError(validate(next) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap gap-1.5",
        "data-testid": testId
    }, options.map((opt)=>{
        const active = isActive(opt.value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleToggle(opt.value),
            disabled: disabled,
            "aria-pressed": active,
            title: opt.title,
            "data-testid": testId ? `${testId}-${opt.testKey ?? opt.value}` : undefined,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)(touch ? 'min-h-11' : 'h-[34px]', 'px-3.5 rounded-full font-sans text-xs whitespace-nowrap', 'border-[1.5px] transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', error && !active && 'border-destructive', !error && !active && 'border-border text-[#5a6780] font-medium', disabled && 'cursor-not-allowed opacity-50'),
            style: active ? {
                borderColor: activeColor,
                background: activeBg,
                color: activeColor,
                fontWeight: 700
            } : undefined
        }, opt.label);
    }), children));
};
var $fcaca06c97c91379$export$2e2bcd8739ae039 = $fcaca06c97c91379$var$ChipSelector;



var $acw62 = parcelRequire("acw62");


'use client';
const $995baf94da7c0c12$var$CardSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], columns: columns = 4, validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const handleSelect = (v)=>{
        if (disabled) return;
        onChange(v);
        setTouched(true);
        if (validate) setInternalError(validate(v) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "grid gap-2",
        style: {
            gridTemplateColumns: `repeat(${columns}, 1fr)`
        }
    }, options.map((opt)=>{
        const active = value === opt.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleSelect(opt.value),
            disabled: disabled,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('py-3.5 px-2 rounded-xl border-[1.5px] text-center font-sans', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', active ? 'border-navy bg-accent text-navy shadow-sm' : error ? 'border-destructive bg-white text-muted-foreground' : 'border-border bg-white text-muted-foreground', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-xl mb-1.5 leading-none"
        }, opt.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-[11px] leading-snug', active ? 'font-bold' : 'font-medium')
        }, opt.label));
    })));
};
var $995baf94da7c0c12$export$2e2bcd8739ae039 = $995baf94da7c0c12$var$CardSelector;



var $acw62 = parcelRequire("acw62");


'use client';
// A search box is a *labelled control*, and a filter toolbar needs to be
// selectable in tests (§15.1) — so the wrapper takes the rest props
// (`data-testid`, `id`, …) and the input takes the ones that belong to a text
// field (`aria-label`, `onKeyDown`, `name`, `autoFocus`, `disabled`).
// The clear button restores focus to the field: losing focus to <body> after
// clearing is a keyboard dead end.
const $318ef1f4a903d866$var$SearchInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onChange: onChange, placeholder: placeholder, className: className, style: style, inputProps: inputProps, 'aria-label': ariaLabel, onKeyDown: onKeyDown, name: name, id: id, disabled: disabled = false, autoFocus: autoFocus, clearLabel: clearLabel, ...rest }, ref)=>{
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().search;
    if (placeholder === undefined) placeholder = copy.placeholder;
    if (clearLabel === undefined) clearLabel = copy.clear;
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The caller's ref wins; the internal one is what the clear button focuses.
    // A search box that a keyboard shortcut cannot focus is a search box the
    // keyboard-first flows (F3, `/`) have to reach by querySelector.
    const setRef = (node)=>{
        inputRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('relative', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute start-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "15",
        height: "15",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: setRef,
        type: "search",
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        "aria-label": ariaLabel || placeholder,
        name: name,
        id: id,
        disabled: disabled,
        autoFocus: autoFocus,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// min-h-11 (2.75rem), not h-10: this control ships in mobile filter
        // toolbars, where DESIGN-CONCEPT-MOBILE §368 puts the floor at 44px.
        'w-full min-h-11 ps-9 pe-8 rounded-lg font-sans text-[13px] text-foreground', 'bg-white border-[1.5px] border-border outline-none', 'transition-[border-color,box-shadow] duration-150', 'focus:border-primary focus:shadow-ring-navy', 'placeholder:text-muted-foreground', disabled && 'opacity-50 cursor-not-allowed', // The native search affordance would sit on top of our clear button.
        '[&::-webkit-search-cancel-button]:appearance-none'),
        ...inputProps
    }), value && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        onClick: ()=>{
            onChange({
                target: {
                    value: ''
                }
            });
            inputRef.current?.focus();
        },
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 flex p-0.5 rounded text-muted-foreground hover:text-foreground transition-colors"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))));
});
$318ef1f4a903d866$var$SearchInput.displayName = 'SearchInput';
var $318ef1f4a903d866$export$2e2bcd8739ae039 = $318ef1f4a903d866$var$SearchInput;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $577dc7f74ae10f8e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


// src/use-effect-event.tsx


var $acw62 = parcelRequire("acw62");
var $e4330d949f740c0c$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $e4330d949f740c0c$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $e4330d949f740c0c$export$7f54fc3180508a52(callback) {
    if (typeof $e4330d949f740c0c$var$useReactEffectEvent === "function") return $e4330d949f740c0c$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $e4330d949f740c0c$var$useReactInsertionEffect === "function") $e4330d949f740c0c$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $577dc7f74ae10f8e$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $078da60d6ebebb28$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $577dc7f74ae10f8e$export$e5c5a5f917a5871c);
function $078da60d6ebebb28$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $078da60d6ebebb28$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $078da60d6ebebb28$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $078da60d6ebebb28$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $078da60d6ebebb28$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $078da60d6ebebb28$var$isFunction(value) {
    return typeof value === "function";
}
var $078da60d6ebebb28$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $078da60d6ebebb28$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $e4330d949f740c0c$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $078da60d6ebebb28$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $078da60d6ebebb28$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $acw62 = parcelRequire("acw62");

var $db5ba6ddde57f255$var$__defProp = Object.defineProperty;
var $db5ba6ddde57f255$var$__name = (target, value)=>$db5ba6ddde57f255$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}
$db5ba6ddde57f255$var$__name($db5ba6ddde57f255$export$1ab7ae714698c4b8, "useSize");



var $acw62 = parcelRequire("acw62");

"use client";
var $3207c0aa9f229d8f$var$__defProp = Object.defineProperty;
var $3207c0aa9f229d8f$var$__name = (target, value)=>$3207c0aa9f229d8f$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $3207c0aa9f229d8f$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$useStateMachine, "useStateMachine");
// src/presence.tsx
var $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = /* @__PURE__ */ $3207c0aa9f229d8f$var$__name((props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = $3207c0aa9f229d8f$var$useStableComposedRefs(presence.ref, $3207c0aa9f229d8f$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
}, "Presence");
function $3207c0aa9f229d8f$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef(null);
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const mountAnimationNameRef = $acw62.useRef(void 0);
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        if (state === "mounted") {
            prevAnimationNameRef.current = mountAnimationNameRef.current ?? $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            mountAnimationNameRef.current = void 0;
        } else prevAnimationNameRef.current = "none";
    }, [
        state
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(styles);
            if (present) {
                mountAnimationNameRef.current = currentAnimationName;
                send("MOUNT");
            } else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = /* @__PURE__ */ $3207c0aa9f229d8f$var$__name((event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            }, "handleAnimationEnd");
            const handleAnimationStart = /* @__PURE__ */ $3207c0aa9f229d8f$var$__name((event)=>{
                if (event.target === node) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            }, "handleAnimationStart");
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            if (node2) {
                const styles = getComputedStyle(node2);
                stylesRef.current = styles;
                mountAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(styles);
            } else stylesRef.current = null;
            setNode(node2);
        }, [])
    };
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$usePresence, "usePresence");
function $3207c0aa9f229d8f$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$setRef, "setRef");
function $3207c0aa9f229d8f$var$useStableComposedRefs(...refs) {
    const refsRef = $acw62.useRef(refs);
    refsRef.current = refs;
    return $acw62.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $3207c0aa9f229d8f$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $3207c0aa9f229d8f$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$useStableComposedRefs, "useStableComposedRefs");
function $3207c0aa9f229d8f$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$getAnimationName, "getAnimationName");
function $3207c0aa9f229d8f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$3207c0aa9f229d8f$var$__name($3207c0aa9f229d8f$var$getElementRef, "getElementRef");
var $3207c0aa9f229d8f$export$be92b6f5f03c0fe9 = $3207c0aa9f229d8f$export$99c2b779aa4e8b8b;




"use client";
var $99e5d66a1fc753c6$var$__defProp = Object.defineProperty;
var $99e5d66a1fc753c6$var$__name = (target, value)=>$99e5d66a1fc753c6$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $99e5d66a1fc753c6$var$CHECKBOX_NAME = "Checkbox";
var [$99e5d66a1fc753c6$var$createCheckboxContext, $99e5d66a1fc753c6$export$b566c4ff5488ea01] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($99e5d66a1fc753c6$var$CHECKBOX_NAME);
var [$99e5d66a1fc753c6$var$CheckboxProviderImpl, $99e5d66a1fc753c6$var$useCheckboxContext] = $99e5d66a1fc753c6$var$createCheckboxContext($99e5d66a1fc753c6$var$CHECKBOX_NAME);
function $99e5d66a1fc753c6$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $078da60d6ebebb28$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $99e5d66a1fc753c6$var$CHECKBOX_NAME
    });
    const [control, setControl] = $acw62.useState(null);
    const [bubbleInput, setBubbleInput] = $acw62.useState(null);
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const [userInteractionCount, onUserInteraction] = $acw62.useReducer((count)=>count + 1, 0);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        userInteractionCount: userInteractionCount,
        onUserInteraction: onUserInteraction,
        required: required,
        defaultChecked: $99e5d66a1fc753c6$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $99e5d66a1fc753c6$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$export$1335a92a9ee50a8d, "CheckboxProvider");
var $99e5d66a1fc753c6$var$TRIGGER_NAME = "CheckboxTrigger";
var $99e5d66a1fc753c6$export$1386466acbe59ca2 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function CheckboxTrigger2({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef) {
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, onUserInteraction: onUserInteraction, isFormControl: isFormControl, bubbleInput: bubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $acw62.useRef(checked);
    $acw62.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = /* @__PURE__ */ $99e5d66a1fc753c6$var$__name(()=>setChecked(initialCheckedStateRef.current), "reset");
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $99e5d66a1fc753c6$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onClick, (event)=>{
            onUserInteraction();
            setChecked((prevChecked)=>$99e5d66a1fc753c6$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
}, "CheckboxTrigger"));
var $99e5d66a1fc753c6$export$48513f6b9f8ce62d = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function Checkbox2(props, forwardedRef) {
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
}, "Checkbox"));
var $99e5d66a1fc753c6$var$INDICATOR_NAME = "CheckboxIndicator";
var $99e5d66a1fc753c6$export$59aad738f51d1c05 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function CheckboxIndicator2(props, forwardedRef) {
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || $99e5d66a1fc753c6$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, {
            "data-state": $99e5d66a1fc753c6$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
}, "CheckboxIndicator"));
var $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $99e5d66a1fc753c6$export$493083511fc9f964 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $99e5d66a1fc753c6$var$__name(function CheckboxBubbleInput2({ __scopeCheckbox: __scopeCheckbox, onClick: onClick, ...props }, forwardedRef) {
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, userInteractionCount: userInteractionCount, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const controlSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(control);
    const shouldStopClickPropagationRef = $acw62.useRef(false);
    const prevCheckedRef = $acw62.useRef(checked);
    const prevUserInteractionCountRef = $acw62.useRef(userInteractionCount);
    $acw62.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const isUserInteraction = userInteractionCount !== prevUserInteractionCountRef.current;
        prevUserInteractionCountRef.current = userInteractionCount;
        const checkedChanged = prevCheckedRef.current !== checked;
        prevCheckedRef.current = checked;
        const bubbles = !(isUserInteraction && hasConsumerStoppedPropagationRef.current);
        if (checkedChanged && setChecked) {
            shouldStopClickPropagationRef.current = !isUserInteraction;
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
            setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
            shouldStopClickPropagationRef.current = false;
        }
    }, [
        bubbleInput,
        checked,
        hasConsumerStoppedPropagationRef,
        userInteractionCount
    ]);
    const defaultCheckedRef = $acw62.useRef($99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onClick, (event)=>{
            if (shouldStopClickPropagationRef.current) event.stopPropagation();
        }),
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
}, "CheckboxBubbleInput"));
function $99e5d66a1fc753c6$var$isFunction(value) {
    return typeof value === "function";
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$var$isFunction, "isFunction");
function $99e5d66a1fc753c6$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$var$isIndeterminate, "isIndeterminate");
function $99e5d66a1fc753c6$var$getState(checked) {
    return $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
$99e5d66a1fc753c6$var$__name($99e5d66a1fc753c6$var$getState, "getState");



'use client';
// `label` takes a node, not just a string: a picker row is a checkbox whose
// label IS the row (name, value, trend), and wrapping it here keeps the whole
// row inside the native <label> hit area instead of re-implementing one.
// `className`/rest land on that <label> so callers can carry the §15.1
// `data-testid` / `data-state` contract without a wrapper element.
const $7a6c6e1277da35de$var$Checkbox = ({ checked: checked, onChange: onChange, label: label, disabled: disabled = false, className: className, labelClassName: labelClassName, style: style, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center gap-2.5 select-none', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99e5d66a1fc753c6$export$48513f6b9f8ce62d, {
        checked: checked,
        onCheckedChange: onChange,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('h-[18px] w-[18px] shrink-0 rounded-[5px] border-[1.5px]', 'flex items-center justify-center', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', checked ? 'bg-navy border-navy' : 'bg-white border-border', disabled && 'opacity-50')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99e5d66a1fc753c6$export$59aad738f51d1c05, {
        className: "flex items-center justify-center text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "11",
        height: "11"
    }, checked === 'indeterminate' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 11h14v2H5z"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })))), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-sm font-sans text-foreground', labelClassName)
    }, label));
var $7a6c6e1277da35de$export$2e2bcd8739ae039 = $7a6c6e1277da35de$var$Checkbox;



var $acw62 = parcelRequire("acw62");

'use client';
function $ddccb5e00ce1ba3b$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, label: label, description: description, disabled: disabled = false, id: id, ...rest }) {
    const reactId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const rowId = id || reactId;
    const labelId = `${rowId}-label`;
    const descId = description ? `${rowId}-desc` : undefined;
    // The kit styles inline, which cannot express :focus-visible — so the ring is
    // tracked here. Keyed on :focus-visible rather than :focus so a pointer tap
    // does not leave a ring behind, which is the behaviour the pseudo-class
    // exists to give. Setting only outlineColor (as this component did) paints
    // nothing: without an outline-style there is no outline to colour.
    const [focusRing, setFocusRing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16,
            padding: '14px 0',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        id: labelId,
        htmlFor: rowId,
        style: {
            display: 'block',
            fontSize: 14,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }
    }, label), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descId,
        style: {
            display: 'block',
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        id: rowId,
        role: "switch",
        "aria-checked": checked,
        "aria-labelledby": labelId,
        "aria-describedby": descId,
        disabled: disabled,
        onClick: ()=>!disabled && onChange(!checked),
        onFocus: (e)=>{
            // `matches` can throw on engines without :focus-visible; a ring on
            // plain focus is a better failure than no ring at all.
            let visible = true;
            try {
                visible = e.target.matches(':focus-visible');
            } catch  {}
            setFocusRing(visible);
        },
        onBlur: ()=>setFocusRing(false),
        style: {
            width: 44,
            height: 24,
            borderRadius: 999,
            flexShrink: 0,
            padding: 0,
            border: `1px solid ${checked ? 'transparent' : '#cbd2dc'}`,
            background: checked ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : '#d1d5db',
            cursor: disabled ? 'not-allowed' : 'pointer',
            position: 'relative',
            transition: 'background 0.25s, box-shadow 0.15s',
            outline: 'none',
            boxShadow: focusRing ? `0 0 0 3px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.45)}` : 'none'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 2,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: 'white',
            transition: 'inset-inline-end 0.25s',
            insetInlineEnd: checked ? 2 : 22,
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            pointerEvents: 'none'
        }
    })));
}



var $acw62 = parcelRequire("acw62");

/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };



'use client';
const $39b6a9e95398564b$export$dca1ee5a936bb312 = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)('inline-flex items-center justify-center gap-2 font-sans font-semibold rounded-lg transition-all duration-150 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 select-none', {
    variants: {
        variant: {
            default: 'bg-navy text-white hover:bg-navy-dark active:scale-[0.98]',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 active:scale-[0.98]',
            outline: 'border-[1.5px] border-border bg-white text-foreground hover:bg-muted active:scale-[0.98]',
            ghost: 'bg-transparent text-foreground hover:bg-muted',
            link: 'text-primary underline-offset-4 hover:underline',
            teal: 'bg-clinic-teal text-white hover:opacity-90 active:scale-[0.98]',
            // Tonal primary — a navy-tinted pill for secondary actions that still read
            // as brand (jump-to-today, filter chips) without the weight of a solid fill.
            subtle: 'bg-navy/5 text-navy border-[1.5px] border-navy/20 hover:bg-navy/10 active:scale-[0.98]',
            // A sidebar destination, on the deep-azure gradient rail. Selected state
            // arrives as `data-active="true"` (set it beside `aria-current="page"`),
            // NOT as a className the caller assembles: all four staff shells were
            // writing the same four overrides onto `variant="ghost"`, which §17.1
            // calls a fork of a kit component. The active pill is the brand
            // gradient — the single lit moment on a deliberately teal-free rail.
            nav: 'w-full justify-start font-medium text-white/60 hover:bg-white/10 hover:text-white data-[active=true]:bg-gradient-brand data-[active=true]:text-white data-[active=true]:font-bold data-[active=true]:hover:bg-gradient-brand'
        },
        size: {
            default: 'h-11 px-5 text-[13.5px]',
            sm: 'h-9  px-4 text-xs rounded-md',
            lg: 'h-12 px-7 text-[15px]',
            icon: 'h-10 w-10'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const $39b6a9e95398564b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $cf381de56a25bc52$export$be92b6f5f03c0fe9) : 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)($39b6a9e95398564b$export$dca1ee5a936bb312({
            variant: variant,
            size: size
        }), className),
        ...props
    });
});
$39b6a9e95398564b$export$353f5b6fc5456de1.displayName = 'Button';
var $39b6a9e95398564b$export$2e2bcd8739ae039 = $39b6a9e95398564b$export$353f5b6fc5456de1;



var $acw62 = parcelRequire("acw62");


'use client';
const $ddd0c49a5377bd48$export$48443d129636634d = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)('inline-flex items-center rounded-full font-sans font-semibold whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-accent text-accent-foreground text-[11px] px-2.5 py-0.5',
            // The three pale chip pairs are CSS variables (tokens.css), not
            // literals. Same pixels; the point is that a theme can reach them —
            // every raw hex left in a component is a future dark-mode bug (§11).
            destructive: 'bg-[var(--chip-danger-bg)]  text-[var(--chip-danger-ink)]  text-[11px] px-2.5 py-0.5',
            success: 'bg-[var(--chip-success-bg)] text-[var(--chip-success-ink)] text-[11px] px-2.5 py-0.5',
            warning: 'bg-[var(--chip-warning-bg)] text-[var(--chip-warning-ink)] text-[11px] px-2.5 py-0.5',
            outline: 'border border-border text-foreground text-[11px] px-2.5 py-0.5',
            // `count` — the ONE unread/tally chip. A solid navy pill, not the pale
            // tint `default` gives: every conversation row in every app was
            // overriding `default` with the same inline `background`/`color` to get
            // this, which is the hand-rolled primitive rule in slow motion.
            // `tabular-nums` keeps «۱» and «۹+» the same width so a live count does
            // not jitter the row, and `min-w-5` keeps a single digit round.
            // The swatch is navy, matching `BottomNav`'s `badgeTone: 'count'` —
            // one colour means "unread" everywhere (see DESIGN.md, Messaging).
            // `var(--p-navy)` rather than the `bg-navy` hex so the chip follows the
            // doctor's accent preset exactly as `C.navy` (which BottomNav uses) does.
            count: 'bg-[var(--p-navy)] text-white text-[11px] font-bold leading-5 min-w-5 justify-center px-1.5 tabular-nums shrink-0'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
const $ddd0c49a5377bd48$export$37acb3580601e69a = ({ className: className, variant: variant, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)($ddd0c49a5377bd48$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    }, children);
var $ddd0c49a5377bd48$export$2e2bcd8739ae039 = $ddd0c49a5377bd48$export$37acb3580601e69a;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $503fd9331600e952$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


// src/use-effect-event.tsx
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $a2b725a5f7da055e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};



var $acw62 = parcelRequire("acw62");
var $5ca4f71777be5acb$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $5ca4f71777be5acb$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $5ca4f71777be5acb$export$7f54fc3180508a52(callback) {
    if (typeof $5ca4f71777be5acb$var$useReactEffectEvent === "function") return $5ca4f71777be5acb$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $5ca4f71777be5acb$var$useReactInsertionEffect === "function") $5ca4f71777be5acb$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $a2b725a5f7da055e$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $cf6c8262ce26f2a3$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $503fd9331600e952$export$e5c5a5f917a5871c);
function $cf6c8262ce26f2a3$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $cf6c8262ce26f2a3$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $cf6c8262ce26f2a3$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $cf6c8262ce26f2a3$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $cf6c8262ce26f2a3$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $cf6c8262ce26f2a3$var$isFunction(value) {
    return typeof value === "function";
}
var $cf6c8262ce26f2a3$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $cf6c8262ce26f2a3$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $5ca4f71777be5acb$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $cf6c8262ce26f2a3$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $cf6c8262ce26f2a3$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $acw62 = parcelRequire("acw62");





"use client";
var $30a399657994b369$var$__defProp = Object.defineProperty;
var $30a399657994b369$var$__name = (target, value)=>$30a399657994b369$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $30a399657994b369$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $30a399657994b369$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $30a399657994b369$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $30a399657994b369$var$originalBodyPointerEvents;
var $30a399657994b369$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $30a399657994b369$export$177fb62ff3ec1f22 = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $30a399657994b369$var$__name(function DismissableLayer2(props, forwardedRef) {
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $acw62.useRef(false);
    const pointerDownOutside = $30a399657994b369$var$usePointerDownOutside((event)=>{
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: $acw62.useCallback((target)=>{
            if (!(target instanceof Node)) return false;
            const isPointerDownOnBranch = [
                ...context.branches
            ].some((branch)=>branch.contains(target));
            return isPointerEventsEnabled && !isPointerDownOnBranch;
        }, [
            context.branches,
            isPointerEventsEnabled
        ])
    });
    const focusOutside = $30a399657994b369$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const isHighestLayer = node ? index === layers.length - 1 : false;
    const handleKeyDown = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)((event)=>{
        if (event.key !== "Escape") return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    $acw62.useEffect(()=>{
        if (!isHighestLayer) return;
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        ownerDocument,
        isHighestLayer,
        handleKeyDown
    ]);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $30a399657994b369$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $30a399657994b369$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = /* @__PURE__ */ $30a399657994b369$var$__name(()=>force({}), "handleUpdate");
        document.addEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
}, "DismissableLayer"));
var $30a399657994b369$export$4d5eb2109db14228 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $30a399657994b369$var$__name(function DismissableLayerBranch2(props, forwardedRef) {
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
}, "DismissableLayerBranch"));
function $30a399657994b369$export$210785236bdfcb27() {
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
$30a399657994b369$var$__name($30a399657994b369$export$210785236bdfcb27, "useDismissableLayerSurface");
var $30a399657994b369$var$IS_TRUE = /* @__PURE__ */ $30a399657994b369$var$__name(()=>true, "IS_TRUE");
function $30a399657994b369$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces, shouldHandlePointerDownOutside: shouldHandlePointerDownOutside = $30a399657994b369$var$IS_TRUE } = args;
    const handlePointerDownOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const isPointerDownOutsideRef = $acw62.useRef(false);
    const interceptedOutsideInteractionEventsRef = $acw62.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        $30a399657994b369$var$__name(resetOutsideInteraction, "resetOutsideInteraction");
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        $30a399657994b369$var$__name(isOutsideInteractionIntercepted, "isOutsideInteractionIntercepted");
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        $30a399657994b369$var$__name(handleInteractionCapture, "handleInteractionCapture");
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        $30a399657994b369$var$__name(handleInteractionBubble, "handleInteractionBubble");
        const handlePointerDown = /* @__PURE__ */ $30a399657994b369$var$__name((event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                $30a399657994b369$var$__name(handleAndDispatchPointerDownOutsideEvent2, "handleAndDispatchPointerDownOutsideEvent");
                if (!shouldHandlePointerDownOutside(event.target)) {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    resetOutsideInteraction();
                    isPointerInsideReactTreeRef.current = false;
                    return;
                }
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        }, "handlePointerDown");
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces,
        shouldHandlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: /* @__PURE__ */ $30a399657994b369$var$__name(()=>isPointerInsideReactTreeRef.current = true, "onPointerDownCapture")
    };
}
$30a399657994b369$var$__name($30a399657994b369$var$usePointerDownOutside, "usePointerDownOutside");
function $30a399657994b369$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = /* @__PURE__ */ $30a399657994b369$var$__name((event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        }, "handleFocus");
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: /* @__PURE__ */ $30a399657994b369$var$__name(()=>isFocusInsideReactTreeRef.current = true, "onFocusCapture"),
        onBlurCapture: /* @__PURE__ */ $30a399657994b369$var$__name(()=>isFocusInsideReactTreeRef.current = false, "onBlurCapture")
    };
}
$30a399657994b369$var$__name($30a399657994b369$var$useFocusOutside, "useFocusOutside");
function $30a399657994b369$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
$30a399657994b369$var$__name($30a399657994b369$var$dispatchUpdate, "dispatchUpdate");
function $30a399657994b369$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
$30a399657994b369$var$__name($30a399657994b369$var$handleAndDispatchCustomEvent, "handleAndDispatchCustomEvent");
var $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
var $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");




"use client";
var $03c48a27777929a8$var$__defProp = Object.defineProperty;
var $03c48a27777929a8$var$__name = (target, value)=>$03c48a27777929a8$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $03c48a27777929a8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $03c48a27777929a8$export$20e40289641fbbb6 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $03c48a27777929a8$var$__name(function FocusScope2(props, forwardedRef) {
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setContainer);
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            $03c48a27777929a8$var$__name(handleFocusIn2, "handleFocusIn");
            $03c48a27777929a8$var$__name(handleFocusOut2, "handleFocusOut");
            $03c48a27777929a8$var$__name(handleMutations2, "handleMutations");
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $03c48a27777929a8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$focusFirst($03c48a27777929a8$var$removeLinks($03c48a27777929a8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                    container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
}, "FocusScope"));
function $03c48a27777929a8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$focusFirst, "focusFirst");
function $03c48a27777929a8$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$getTabbableEdges, "getTabbableEdges");
function $03c48a27777929a8$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: /* @__PURE__ */ $03c48a27777929a8$var$__name((node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }, "acceptNode")
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$getTabbableCandidates, "getTabbableCandidates");
function $03c48a27777929a8$var$findVisible(elements, container) {
    const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({
        checkVisibilityCSS: true
    });
    for (const element of elements){
        const hidden = canUseCheckVisibility ? !element.checkVisibility({
            checkVisibilityCSS: true
        }) : $03c48a27777929a8$var$isHidden(element, {
            upTo: container
        });
        if (!hidden) return element;
    }
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$findVisible, "findVisible");
function $03c48a27777929a8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$isHidden, "isHidden");
function $03c48a27777929a8$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$isSelectableInput, "isSelectableInput");
function $03c48a27777929a8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$isSelectableInput(element) && select) element.select();
    }
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$focus, "focus");
var $03c48a27777929a8$var$focusScopesStack = $03c48a27777929a8$var$createFocusScopesStack();
function $03c48a27777929a8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$createFocusScopesStack, "createFocusScopesStack");
function $03c48a27777929a8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$arrayRemove, "arrayRemove");
function $03c48a27777929a8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
$03c48a27777929a8$var$__name($03c48a27777929a8$var$removeLinks, "removeLinks");
var $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



"use client";
var $95d053caea9c023a$var$__defProp = Object.defineProperty;
var $95d053caea9c023a$var$__name = (target, value)=>$95d053caea9c023a$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $95d053caea9c023a$export$602eac185826482c = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $95d053caea9c023a$var$__name(function Portal2(props, forwardedRef) {
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $1u0KT.createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
}, "Portal"));
var $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;





var $acw62 = parcelRequire("acw62");
"use client";
var $264faec0fdf8876a$var$__defProp = Object.defineProperty;
var $264faec0fdf8876a$var$__name = (target, value)=>$264faec0fdf8876a$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $264faec0fdf8876a$var$count = 0;
var $264faec0fdf8876a$var$guards = null;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
$264faec0fdf8876a$var$__name($264faec0fdf8876a$export$ac5b58043b79449b, "FocusGuards");
function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        if (!$264faec0fdf8876a$var$guards) $264faec0fdf8876a$var$guards = {
            start: $264faec0fdf8876a$var$createFocusGuard(),
            end: $264faec0fdf8876a$var$createFocusGuard()
        };
        const { start: start, end: end } = $264faec0fdf8876a$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $264faec0fdf8876a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$count === 1) {
                $264faec0fdf8876a$var$guards?.start.remove();
                $264faec0fdf8876a$var$guards?.end.remove();
                $264faec0fdf8876a$var$guards = null;
            }
            $264faec0fdf8876a$var$count = Math.max(0, $264faec0fdf8876a$var$count - 1);
        };
    }, []);
}
$264faec0fdf8876a$var$__name($264faec0fdf8876a$export$b7ece24a22aeda8c, "useFocusGuards");
function $264faec0fdf8876a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
$264faec0fdf8876a$var$__name($264faec0fdf8876a$var$createFocusGuard, "createFocusGuard");



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $eeaeb48e23f662e7$var$__defProp = Object.defineProperty;
var $eeaeb48e23f662e7$var$__name = (target, value)=>$eeaeb48e23f662e7$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = /* @__PURE__ */ $eeaeb48e23f662e7$var$__name((props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $cf6c8262ce26f2a3$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    const [titleCount, setTitleCount] = $acw62.useState(0);
    const [descriptionCount, setDescriptionCount] = $acw62.useState(0);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        titleId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        descriptionId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        titlePresent: titleCount > 0,
        descriptionPresent: descriptionCount > 0,
        setTitleCount: setTitleCount,
        setDescriptionCount: setDescriptionCount,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
}, "Dialog");
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogTrigger2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
}, "DialogTrigger"));
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = /* @__PURE__ */ $eeaeb48e23f662e7$var$__name((props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $95d053caea9c023a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
}, "DialogPortal");
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogOverlay2(props, forwardedRef) {
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
}, "DialogOverlay"));
var $eeaeb48e23f662e7$var$Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogOverlayImpl2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    const registerDismissableSurface = (0, $30a399657994b369$export$210785236bdfcb27)();
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, registerDismissableSurface);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: composedRefs,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
}, "DialogOverlayImpl"));
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContent2(props, forwardedRef) {
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
}, "DialogContent"));
var $eeaeb48e23f662e7$var$DialogContentModal = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContentModal2(props, forwardedRef) {
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
}, "DialogContentModal"));
var $eeaeb48e23f662e7$var$DialogContentNonModal = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContentNonModal2(props, forwardedRef) {
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
}, "DialogContentNonModal"));
var $eeaeb48e23f662e7$var$DialogContentImpl = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogContentImpl2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
            asChild: true,
            loop: true,
            trapped: trapFocus,
            onMountAutoFocus: onOpenAutoFocus,
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
                role: "dialog",
                id: context.contentId,
                "aria-describedby": context.descriptionPresent ? context.descriptionId : void 0,
                "aria-labelledby": context.titlePresent ? context.titleId : void 0,
                "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                ...contentProps,
                ref: forwardedRef,
                deferPointerDownOutside: true,
                onDismiss: ()=>context.onOpenChange(false)
            })
        })
    });
}, "DialogContentImpl"));
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogTitle2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    const { setTitleCount: setTitleCount } = context;
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        setTitleCount((count)=>count + 1);
        return ()=>setTitleCount((count)=>count - 1);
    }, [
        setTitleCount
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
}, "DialogTitle"));
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$393edc798c47379d = /* @__PURE__ */ $acw62.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogDescription2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    const { setDescriptionCount: setDescriptionCount } = context;
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        setDescriptionCount((count)=>count + 1);
        return ()=>setDescriptionCount((count)=>count - 1);
    }, [
        setDescriptionCount
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
}, "DialogDescription"));
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = /* @__PURE__ */ $acw62.forwardRef(/* @__PURE__ */ $eeaeb48e23f662e7$var$__name(function DialogClose2(props, forwardedRef) {
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
}, "DialogClose"));
var $eeaeb48e23f662e7$export$69b62a49393917d6 = /* @__PURE__ */ $eeaeb48e23f662e7$var$__name((props)=>{
    return props.children;
}, "WarningProvider");
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}
$eeaeb48e23f662e7$var$__name($eeaeb48e23f662e7$var$getState, "getState");



'use client';
const $ace11be13f1c53cf$export$3ddf2d174ce01153 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
const $ace11be13f1c53cf$export$2e1e1122cf0cba88 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
const $ace11be13f1c53cf$export$fba2fb7cd781b7ac = $eeaeb48e23f662e7$export$f39c2d165cd861fe;
const $ace11be13f1c53cf$export$dad7c95542bacce0 = $eeaeb48e23f662e7$export$dad7c95542bacce0;
// ── Overlay z-scale (keep these in sync; see DESIGN.md "Overlay layering") ──
// Drawer 11 < BottomSheet 1000 < Dialog/ConfirmDialog 1100 < Toast / JalaliDatePicker 9999
//
// The dialog layer MUST sit above BottomSheet: a ConfirmDialog is routinely opened from
// inside a sheet (destructive confirms, unsaved-changes guards). At the old z-50 it
// rendered *behind* the sheet while Radix's modal mode set `pointer-events: none` on
// <body> — so the sheet froze with an invisible modal trapping focus, unrecoverable by
// touch. Raising the dialog (rather than lowering the sheet) is the safe direction:
// mobile chrome that must stay under a sheet — the doctor app's MobileBottomNav (z-50)
// and MobileVisitClosureFlow (z-60) — keeps working unchanged.
const $ace11be13f1c53cf$var$Z_DIALOG = 'z-[1100]';
// A dialog is a transition the user asked for, so it animates — but §12.4 of the
// design concept says every transition collapses to instant under
// `prefers-reduced-motion`. Radix drives the animation through `data-state`
// classes, so the opt-out has to be a class too; without it the dialog was the
// one overlay that kept moving for a user who asked it not to.
const $ace11be13f1c53cf$var$MOTION_SAFE = 'motion-reduce:animate-none motion-reduce:transition-none';
const $ace11be13f1c53cf$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$bd1d06c79be19e17, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('fixed inset-0 bg-black/45', $ace11be13f1c53cf$var$Z_DIALOG, 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }));
$ace11be13f1c53cf$export$bd1d06c79be19e17.displayName = 'DialogOverlay';
// Floating layers portaled to <body> (e.g. the Jalali calendar popup) live outside the
// dialog's DOM, so Radix would treat interacting with them as an outside click and close
// the dialog mid-pick. Anything inside [data-jalali-popup] is ours, not "outside".
const $ace11be13f1c53cf$var$isInFloatingLayer = (e)=>e.target instanceof Element && e.target.closest('[data-jalali-popup]');
// ── Width ────────────────────────────────────────────────────────────────────
// Four widths rather than a free `className` override, because "how wide is a
// dialog" is a design-system decision: a confirm and a full review surface must
// not each pick their own number. `md` is the historical default, so every
// existing call site keeps its exact width.
const $ace11be13f1c53cf$var$SIZE = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    xl: 'max-w-[52rem]'
};
// ── Layout ───────────────────────────────────────────────────────────────────
// `scroll` (default) is the classic dialog: one padded box that scrolls as a
// whole. `frame` is the surface with its own chrome — a fixed header, a
// scrolling body and a docked footer — which is what a review/receipt overlay
// needs so its primary action never scrolls out of reach. The three slot
// components read the mode from context rather than taking a prop, so a caller
// cannot half-apply it.
const $ace11be13f1c53cf$var$LayoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('scroll');
const $ace11be13f1c53cf$export$b6d9565de1e068cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, children: children, showClose: showClose = true, size: size = 'md', layout: layout = 'scroll', ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$dad7c95542bacce0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$bd1d06c79be19e17, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
        ref: ref,
        onPointerDownOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onFocusOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', $ace11be13f1c53cf$var$Z_DIALOG, 'w-full bg-white rounded-2xl shadow-modal', $ace11be13f1c53cf$var$SIZE[size] || $ace11be13f1c53cf$var$SIZE.md, layout === 'frame' ? [
            'grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden',
            'max-h-[calc(100vh-3rem)] [@supports(height:1dvh)]:max-h-[calc(100dvh-3rem)]'
        ] : 'max-h-[90vh] overflow-y-auto p-8', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2', 'data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%]', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$var$LayoutContext.Provider, {
        value: layout
    }, children), showClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
        className: "absolute end-5 top-5 rounded-sm opacity-70 hover:opacity-100 outline-none focus:ring-2 focus:ring-ring transition-opacity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))))));
$ace11be13f1c53cf$export$b6d9565de1e068cf.displayName = 'DialogContent';
const $ace11be13f1c53cf$export$742513523b177e3b = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col gap-1.5', layout === 'frame' ? 'px-5 py-4 border-b border-border' : 'mb-6', className),
        ...props
    });
};
// The scroll region of a `frame` dialog. `overscroll-contain` is what stops a
// flick at the end of the list from scrolling the page behind the dialog.
const $ace11be13f1c53cf$export$5d20f2c38fcde41f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(layout === 'frame' ? 'overflow-y-auto overscroll-contain p-5' : '', className),
        ...props
    });
});
$ace11be13f1c53cf$export$5d20f2c38fcde41f.displayName = 'DialogBody';
const $ace11be13f1c53cf$export$7bbfb2d443473050 = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex gap-2.5', layout === 'frame' ? 'px-5 py-3 border-t border-border flex-wrap' : 'mt-6', className),
        ...props
    });
};
const $ace11be13f1c53cf$export$16f7638e4a34b909 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$16f7638e4a34b909, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-[18px] font-extrabold text-foreground', className),
        ...props
    }));
$ace11be13f1c53cf$export$16f7638e4a34b909.displayName = 'DialogTitle';
const $ace11be13f1c53cf$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$393edc798c47379d, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-sm text-muted-foreground leading-6', className),
        ...props
    }));
$ace11be13f1c53cf$export$94e94c2ec2c954d5.displayName = 'DialogDescription';



var $acw62 = parcelRequire("acw62");

'use client';
function $49383ac93d397699$export$2e2bcd8739ae039({ open: open, onClose: onClose, width: width = 400, children: children }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: onClose,
        style: {
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: 10,
            backdropFilter: 'blur(1px)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            // Docks at the inline-END — the side away from the shell's sidebar, so
            // a drawer never covers the navigation it was opened from (§5.2). This
            // was `left: 0`, the inline-end under `rtl` and the inline-START under
            // `ltr`, i.e. straight over an English layout's sidebar.
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            width: width,
            height: '100%',
            background: '#fff',
            // No x-offset: a signed offset points at a physical side, and this
            // panel sits on whichever side the reading direction puts the end on.
            boxShadow: '0 0 24px rgba(0,0,0,0.12)',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, children));
}
function $49383ac93d397699$export$bb68d554ded258ea({ title: title, sub: sub, onClose: onClose, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 20px',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 16,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 2
        }
    }, sub), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 22,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1,
            padding: '2px 6px'
        }
    }, "\xd7"));
}
function $49383ac93d397699$export$4ed8420cdfcb2b8f({ children: children, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflow: 'auto',
            padding: 20,
            ...style
        }
    }, children);
}
function $49383ac93d397699$export$d05a7d25ec5abf06({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '16px 20px',
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            gap: 8,
            flexShrink: 0
        }
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
'use client';
function $0286d675359db131$export$9ff6616b10aa518d() {
    const [insets, setInsets] = (0, $acw62.useState)({
        top: 0,
        bottom: 0
    });
    (0, $acw62.useEffect)(()=>{
        const vv = typeof window === 'undefined' ? null : window.visualViewport;
        if (!vv) return undefined;
        const read = ()=>{
            const top = Math.max(0, Math.round(vv.offsetTop));
            // Everything below the visual viewport's bottom edge is covered.
            const bottom = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
            setInsets((prev)=>prev.top === top && prev.bottom === bottom ? prev : {
                    top: top,
                    bottom: bottom
                });
        };
        read();
        vv.addEventListener('resize', read);
        vv.addEventListener('scroll', read);
        return ()=>{
            vv.removeEventListener('resize', read);
            vv.removeEventListener('scroll', read);
        };
    }, []);
    return insets;
}
var $0286d675359db131$export$2e2bcd8739ae039 = $0286d675359db131$export$9ff6616b10aa518d;



var $acw62 = parcelRequire("acw62");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// useOverlayHistory — put an overlay INTO the history stack.
//
// ── The problem ─────────────────────────────────────────────────────────────
// A bottom sheet, a full-screen picker and a closure overlay are all things a
// person opened and expects to be able to *back out of*. On a phone that means
// the hardware back button on Android and the browser's back gesture on iOS —
// neither of which the page can veto. Because no overlay pushed anything onto
// the history stack, pressing back with a sheet open navigated the ROUTE
// UNDERNEATH it: the sheet stayed on screen over a different screen, or the
// person left a half-finished form without ever being asked.
//
// Per-screen fixes for this do not work. Every app that tried one ended up with
// a `popstate` listener per screen, each guessing how many entries to unwind,
// and one of them (the doctor app's visit guard) hardcoded `history.go(-2)` —
// correct only while exactly one anchor exists, and wrong the moment a sheet is
// open on top of it.
//
// ── The rule this implements ────────────────────────────────────────────────
// Opening an overlay pushes ONE history entry tagged with a private token;
// closing it pops that entry. A `popstate` that removes the token is the
// platform saying "close this overlay", so `onClose` runs and nothing else
// happens — the route never changes. Overlays stack: the innermost one owns the
// newest entry, so back closes them one at a time, in order.
//
// The pushed entry deliberately CARRIES THE ROUTER'S OWN STATE FORWARD
// (`...history.state`), which keeps `idx`/`key` identical. React Router reads
// `state.idx` on `popstate` to compute a delta; leaving it untouched makes the
// delta zero, so the router sees the pop and correctly does nothing. Bumping it
// would make the router re-navigate to the same URL with a new key and reset
// screen state that the overlay was sitting on top of.
//
// ── Depth, for guarded routes ───────────────────────────────────────────────
// A route with a leave-guard (an open visit) has to unwind its own anchor PLUS
// whatever overlays are above it. `overlayHistoryDepth()` is that count, so the
// guard says `history.go(-(1 + overlayHistoryDepth()))` rather than a literal.
//
// ── Whose pop is this? (v0.11.5) ────────────────────────────────────────────
// A leave-guard is itself a `popstate` listener, and `popstate` does not say
// what was left — only what was landed on. So a guard that treats every pop
// as "the person is leaving" fires on the pops THIS hook makes: close a sheet
// with the ✕, the scrim or a submit, the cleanup below calls `back()` to drop
// the sheet's entry, and the guard asks «خروج از ویزیت؟» over a screen the
// person never tried to leave. Found on a phone in the doctor app, where every
// sheet on the visit did it.
//
// `overlayOwnsPop()` is the one question a guard needs to ask first. It is
// true in exactly the two cases where a pop is an overlay's business:
//   · an overlay still HOLDS an entry — the platform back is closing it, and
//     the overlay's own listener (registered later, so it runs after the
//     guard's) will handle it;
//   · this hook has just popped its own entry from inside the app. That is
//     announced BEFORE `back()` and consumed by the first reader within a
//     short window, so a `back()` that never produced a pop cannot swallow a
//     real one later.
//
// SSR/jsdom-safe: with no `window.history` it is inert, so a caller can add it
// unconditionally.
// ─────────────────────────────────────────────────────────────────────────────
const $6fd4a6c8c2176e20$var$MARK = 'parsinaOverlay';
let $6fd4a6c8c2176e20$var$sequence = 0;
/** Tokens of the overlays that currently own a history entry, innermost last. */ const $6fd4a6c8c2176e20$var$openTokens = [];
/** When this hook last popped its own entry (ms epoch); 0 when it has not. */ let $6fd4a6c8c2176e20$var$selfPopAt = 0;
// A history traversal completes within a frame or two; the window is only
// there so a `back()` that never produced a pop cannot claim a later one.
const $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS = 1000;
function $6fd4a6c8c2176e20$export$9452f2c4c9460e1e() {
    return $6fd4a6c8c2176e20$var$openTokens.length;
}
function $6fd4a6c8c2176e20$export$2846246580854e2f() {
    if ($6fd4a6c8c2176e20$var$openTokens.length > 0) return true;
    if ($6fd4a6c8c2176e20$var$selfPopAt && Date.now() - $6fd4a6c8c2176e20$var$selfPopAt < $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS) {
        $6fd4a6c8c2176e20$var$selfPopAt = 0;
        return true;
    }
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
    return false;
}
function $6fd4a6c8c2176e20$export$b512be9f39899018() {
    $6fd4a6c8c2176e20$var$openTokens.length = 0;
    $6fd4a6c8c2176e20$var$sequence = 0;
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
}
function $6fd4a6c8c2176e20$export$2e2bcd8739ae039(open, onClose, { enabled: enabled = true, id: id } = {}) {
    // `onClose` is almost always an inline arrow, so depending on it would tear
    // the history entry down and rebuild it on every render of the host screen.
    const onCloseRef = (0, $acw62.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !open) return undefined;
        if (typeof window === 'undefined' || !window.history?.pushState) return undefined;
        const seq = ++$6fd4a6c8c2176e20$var$sequence;
        const token = `${id || 'overlay'}#${seq}`;
        $6fd4a6c8c2176e20$var$openTokens.push(token);
        // True once the platform has already taken our entry off the stack, so the
        // cleanup below knows not to pop a second time.
        let popped = false;
        // Set by the cleanup; a reclaim scheduled before it must not fire after it.
        let disposed = false;
        let reclaimTimer = null;
        // The URL the entry was claimed on. A pop that lands on a different URL is
        // a navigation (a leave-guard's `go(-n)`), never a refused close.
        const claimedHref = window.location.href;
        const drop = ()=>{
            const at = $6fd4a6c8c2176e20$var$openTokens.indexOf(token);
            if (at !== -1) $6fd4a6c8c2176e20$var$openTokens.splice(at, 1);
        };
        const ours = ()=>window.history.state?.[$6fd4a6c8c2176e20$var$MARK] === token;
        try {
            window.history.pushState({
                ...window.history.state || {},
                [$6fd4a6c8c2176e20$var$MARK]: token
            }, '');
        } catch  {
            // iOS caps pushState calls per interval. An overlay that cannot claim an
            // entry still opens; it just does not intercept back, which is exactly
            // today's behaviour and strictly better than refusing to render.
            drop();
            return undefined;
        }
        // ── A refused close (v0.16.1) ─────────────────────────────────────────────
        // The platform back has ALREADY removed our entry by the time `onClose`
        // runs, and the page cannot veto that. A consumer may still refuse — a dirty
        // form that asks «خروج بدون ذخیره؟» and hears «بمانم», or TaskOverlay's
        // `busy` withholding `onClose` mid-write. Before this, the overlay stayed on
        // screen with no entry, so the NEXT back left the route under it.
        //
        // So one tick after `onClose`: if this effect is still alive (nothing set
        // `open` to false), claim the entry again. An honoured close has cleaned the
        // effect up by then and nothing here runs.
        const reclaim = ()=>{
            reclaimTimer = null;
            if (disposed || !popped || ours()) return;
            if (window.location.href !== claimedHref) return;
            const seqOf = (t)=>Number(t.slice(t.lastIndexOf('#') + 1));
            // Overlays opened DURING the refusal (a confirm sheet) already pushed
            // their entries above where ours belongs. With exactly one, rotate: the
            // top entry becomes ours and theirs is pushed back on top of it.
            const above = $6fd4a6c8c2176e20$var$openTokens.filter((t)=>seqOf(t) > seq);
            const state = window.history.state || {};
            try {
                if (above.length === 0) window.history.pushState({
                    ...state,
                    [$6fd4a6c8c2176e20$var$MARK]: token
                }, '');
                else if (above.length === 1 && state[$6fd4a6c8c2176e20$var$MARK] === above[0]) {
                    window.history.replaceState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: token
                    }, '');
                    window.history.pushState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: above[0]
                    }, '');
                } else // Two or more inner entries cannot be reordered without a traversal
                // the person would see; leave it as it was rather than misorder them.
                return;
            } catch  {
                return; // the iOS pushState cap — same fallback as the first claim
            }
            const at = above.length ? $6fd4a6c8c2176e20$var$openTokens.indexOf(above[0]) : -1;
            if (at === -1) $6fd4a6c8c2176e20$var$openTokens.push(token);
            else $6fd4a6c8c2176e20$var$openTokens.splice(at, 0, token);
            popped = false;
        };
        const onPop = ()=>{
            // Still ours: something DEEPER popped, and its own hook is handling it.
            if (ours()) return;
            popped = true;
            drop();
            onCloseRef.current?.();
            if (!disposed && reclaimTimer === null) reclaimTimer = setTimeout(reclaim, 0);
        };
        window.addEventListener('popstate', onPop);
        return ()=>{
            disposed = true;
            if (reclaimTimer !== null) {
                clearTimeout(reclaimTimer);
                reclaimTimer = null;
            }
            window.removeEventListener('popstate', onPop);
            drop();
            // Closed from inside the app (the ✕, a submit, Escape). Our entry is
            // still on the stack, so remove it — otherwise back would have to be
            // pressed once for the ghost entry and once for the actual route.
            //
            // `ours()` is the guard that makes this safe on unmount-by-navigation: a
            // sheet whose button routed somewhere else no longer owns the top entry,
            // and calling back() there would undo the navigation it just performed.
            if (!popped && ours()) {
                // Announced before the traversal, because the guard's listener will
                // run inside the resulting `popstate` and has no other way to know.
                $6fd4a6c8c2176e20$var$selfPopAt = Date.now();
                try {
                    window.history.back();
                } catch  {
                    $6fd4a6c8c2176e20$var$selfPopAt = 0;
                }
            }
        };
    }, [
        open,
        enabled,
        id
    ]);
}



'use client';
// ─────────────────────────────────────────────────────────────────────────────
// BottomSheet — mobile-first modal that slides up from the bottom edge.
// Replaces the duplicated ClinicModal implementations in the patient app and
// ad-hoc bottom sheets elsewhere. For desktop-centred dialogs use Dialog.
//
// It is the default overlay for a mobile task or filter set
// (DESIGN-CONCEPT-MOBILE §6); `ConfirmDialog` stays a centered dialog and sits
// ABOVE this one on the z-scale (DESIGN.md, Overlay layering).
//
// ── What makes it phone-grade (v0.10.0) ─────────────────────────────────────
// Every one of these was a defect a phone could reproduce and a desktop could
// not, and each was found in all three apps at once because they all render
// this component:
//
//   dvh, not vh        `85vh` is measured against the LARGEST viewport, so on
//                      iOS Safari with the address bar expanded the sheet was
//                      taller than the screen and its own footer sat under the
//                      toolbar. `100dvh` tracks the live viewport; the `vh`
//                      declaration stays as the fallback for browsers without
//                      it, behind an `@supports` upgrade.
//   the keyboard       `position: fixed` is blind to the software keyboard, so
//                      a focused field's submit button sat *under* the keys.
//                      The sheet sits INSIDE the visible box: the scrim pads by
//                      what the keyboard covers (bottom) and by what the browser
//                      panned past (top), and the ceiling comes down by the
//                      same amount so the sheet's top edge does not move.
//                      (v0.23.3, PM-0108) It used to only shrink its ceiling
//                      while keeping its bottom edge on the LAYOUT viewport —
//                      so on Android Chrome, which paints the keyboard over the
//                      layout viewport (`resizes-visual`), the lower part of
//                      every sheet, footer included, sat under the keys, and
//                      Chrome's attempt to reveal the field panned the visual
//                      viewport so the title bar and the field left through the
//                      top of the screen. The booking sheet on a phone was the
//                      report. Repro: the doctor client's
//                      `e2e/booking.keyboard.mobile.spec.js`.
//   back closes it     the platform back button used to navigate the route
//                      underneath an open sheet, leaving the sheet floating
//                      over a different screen. `useOverlayHistory` puts the
//                      sheet in the history stack (opt out with
//                      `historyIntegration={false}` for a desktop dialog).
//   focus stays in     a modal that leaks focus to the page behind it is not a
//                      modal. Focus moves in on open, Tab cycles inside, and
//                      the previously-focused element gets it back on close.
//   the page is still  without a scroll lock, scrolling past the sheet's end
//                      scrolls the screen behind it — on iOS the page then
//                      rubber-bands and the sheet appears to drift.
//   44px close         the ✕ was 30px, under the 2.75rem minimum (§6).
//   tokens             surfaces, scrim, radius and text now come from the token
//                      layer instead of five literal hexes.
//   rendered at body   (v0.11.4) `position: fixed` and a z-index only mean
//                      what they say inside the ROOT stacking context. A sheet
//                      mounted deep in a screen — inside the scroller of a tab,
//                      say — sat in whatever context its ancestors made: iOS
//                      WebKit composites an overflow scroller and traps fixed
//                      descendants in it, so the sheet was clipped to the
//                      scroller and the screen's own docked bar, later in the
//                      DOM, painted OVER it. Chromium does not do this, which
//                      is why a browser test could not see it. The sheet now
//                      portals to `document.body`, exactly as the kit `Dialog`
//                      does through Radix: where a sheet happens to be mounted
//                      is no longer something a screen has to get right.
//
// Props:
//   open / onClose
//   title      — optional heading
//   footer     — optional docked commit row. §6 says "submit docks bottom", and
//                the sheet's body is a scroll region, so a footer placed in
//                `children` scrolls away exactly when it is needed. This slot
//                sticks to the bottom edge, above the safe-area inset AND above
//                the software keyboard.
//   fullHeight — a tall form (a stepper, a long picker) takes the whole
//                available height instead of hugging its content, so the footer
//                sits at the bottom edge rather than halfway up the screen.
//   snap       — cap the sheet at a fraction of the viewport (0.2–1, default
//                0.85). `snap={1}` with `fullHeight` is a full-screen task.
//   dir        — writing direction. UNSET by default, so the sheet INHERITS the
//                document's. It used to hardcode `dir="rtl"`, which renders
//                backwards in an app that also ships `en`; the three RTL apps
//                set `dir="rtl"` on <html>, so inheriting is identical for them.
//   closeLabel — accessible name of the close button (default «بستن»)
//   maxWidth   — the sheet's cap on a wide viewport
//   historyIntegration — false to opt out of the back-button behaviour
//   portal     — false to render in place instead of at `document.body`. Only
//                for a consumer that deliberately scopes CSS custom properties
//                to a subtree and needs the sheet inside it; the default is the
//                one that is correct on a phone.
//   className / data-testid and any other prop are forwarded to the overlay.
//
// `dir` inherits from `<html>` after the portal, which is what it inherited
// before in every app that sets the direction where the I18N rule says to.
// ─────────────────────────────────────────────────────────────────────────────
// Everything focusable a sheet can realistically contain. `[hidden]` and
// `disabled` are excluded because Tab skips them anyway, and a trap that
// disagrees with the browser about the cycle is worse than no trap.
const $cfba7d02b5e7069f$var$FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $cfba7d02b5e7069f$var$PANEL_CLASS = 'parsina-sheet-panel';
// One stylesheet for every sheet on the page, not one per instance: the rules
// are identical and the per-sheet numbers arrive as custom properties.
const $cfba7d02b5e7069f$var$SHEET_CSS = `
  @keyframes parsina-sheet-fade{from{opacity:0}to{opacity:1}}
  @keyframes parsina-sheet-up{from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-vh)}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-vh)}
  /* The upgrade. Guarded because a custom property holding an unsupported unit
     is invalid at computed-value time, which would drop max-height entirely. */
  @supports (height: 100dvh){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-dvh)}
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-dvh)}
  }
  @media (prefers-reduced-motion: reduce){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}, .parsina-sheet-scrim{animation:none!important}
  }
`;
function $cfba7d02b5e7069f$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, footer: footer, fullHeight: fullHeight = false, snap: snap = 0.85, dir: dir, closeLabel: closeLabel, maxWidth: maxWidth = 480, historyIntegration: historyIntegration = true, portal: portal = true, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().close;
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const restoreFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The box the user can see, as insets of the layout viewport (PM-0108).
    const { top: panInset, bottom: keyboardInset } = (0, $0286d675359db131$export$2e2bcd8739ae039)();
    // Back / hardware-back closes the sheet and leaves the route alone.
    (0, $6fd4a6c8c2176e20$export$2e2bcd8739ae039)(open, onClose, {
        enabled: historyIntegration,
        id: testId || 'sheet'
    });
    // Escape + the focus trap. One listener for both: they are the same contract
    // — while this is open, the keyboard belongs to it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                onClose?.();
                return;
            }
            if (e.key !== 'Tab') return;
            const panel = panelRef.current;
            if (!panel) return;
            const items = [
                ...panel.querySelectorAll($cfba7d02b5e7069f$var$FOCUSABLE)
            ].filter((el)=>el.offsetParent !== null);
            if (items.length === 0) {
                e.preventDefault();
                panel.focus();
                return;
            }
            const first = items[0];
            const last = items[items.length - 1];
            const active = document.activeElement;
            // Wrapping by hand is what keeps focus inside: the browser's own next
            // stop after `last` is the page behind the scrim.
            if (e.shiftKey && (active === first || !panel.contains(active))) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Move focus in on open and hand it back on close. Without the hand-back, a
    // sheet opened from a list left focus on <body>, so the next Tab started from
    // the top of the page instead of from the control that opened it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        restoreFocusRef.current = document.activeElement;
        // After paint, so the panel and its children exist to receive it.
        const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(()=>{
            const panel = panelRef.current;
            if (!panel) return;
            const firstField = panel.querySelector($cfba7d02b5e7069f$var$FOCUSABLE);
            (firstField || panel).focus?.({
                preventScroll: true
            });
        }) : null;
        return ()=>{
            if (raf !== null) cancelAnimationFrame(raf);
            const previous = restoreFocusRef.current;
            restoreFocusRef.current = null;
            if (previous && typeof previous.focus === 'function' && document.contains(previous)) previous.focus({
                preventScroll: true
            });
        };
    }, [
        open
    ]);
    // When the visible box changes under an open sheet — the keyboard arriving,
    // the browser panning — the sheet re-lays out, and the field being typed into
    // may now sit below the body's shrunken edge. Bring it back the way a finger
    // would. `nearest` scrolls only the sheet's own scroller: the panel is inside
    // the visible box by construction, so nothing outside it has to move.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || panInset === 0 && keyboardInset === 0) return undefined;
        if (typeof requestAnimationFrame !== 'function') return undefined;
        const raf = requestAnimationFrame(()=>{
            const panel = panelRef.current;
            const active = typeof document === 'undefined' ? null : document.activeElement;
            if (!panel || !active || active === panel || !panel.contains(active)) return;
            if (typeof active.scrollIntoView !== 'function') return;
            active.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        open,
        panInset,
        keyboardInset
    ]);
    // Body scroll lock. Restores the exact previous inline values rather than
    // clearing them, so two stacked sheets do not leave the page unlocked when
    // the inner one closes.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof document === 'undefined') return undefined;
        const body = document.body;
        const previous = {
            overflow: body.style.overflow,
            touchAction: body.style.touchAction,
            overscroll: body.style.overscrollBehavior
        };
        body.style.overflow = 'hidden';
        // iOS ignores `overflow: hidden` on <body> for touch scrolling; these two
        // are what actually stop the page behind the scrim from moving.
        body.style.touchAction = 'none';
        body.style.overscrollBehavior = 'none';
        return ()=>{
            body.style.overflow = previous.overflow;
            body.style.touchAction = previous.touchAction;
            body.style.overscrollBehavior = previous.overscroll;
        };
    }, [
        open
    ]);
    if (!open) return null;
    // `calc()` multiplies a NUMBER by a length, so the snap stays a fraction.
    const cap = Math.min(Math.max(Number(snap) || 0.85, 0.2), 1);
    const tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: dir,
        className: className ? `parsina-sheet-scrim ${className}` : 'parsina-sheet-scrim',
        "data-testid": testId,
        onClick: onClose,
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: (0, $e7c165fb515b04ea$export$959fb1d648dd9e6c),
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            // The scrim keeps covering the whole layout viewport (a keyboard frame
            // in flight must never show the page behind); the PANEL is confined to
            // the box the user can see — above the keys, below what was panned past.
            paddingTop: panInset ? `${panInset}px` : undefined,
            paddingBottom: keyboardInset ? `${keyboardInset}px` : undefined,
            animation: 'parsina-sheet-fade 0.2s ease-out'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $cfba7d02b5e7069f$var$SHEET_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        className: $cfba7d02b5e7069f$var$PANEL_CLASS,
        "data-full-height": fullHeight ? '' : undefined,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title || closeLabel,
        tabIndex: -1,
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: '100%',
            maxWidth: maxWidth,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderRadius: `${(0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).hero}px ${(0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).hero}px 0 0`,
            boxShadow: '0 -12px 40px rgba(0,0,0,0.18)',
            // The visible box lost `keyboardInset + panInset` pixels, so the
            // ceiling comes down by exactly that: the sheet's TOP edge stays
            // where it was and the content gives up the keyboard's height, rather
            // than the whole sheet jumping. Both units are published; the
            // stylesheet picks.
            '--parsina-sheet-vh': `calc(${cap} * 100vh - ${keyboardInset + panInset}px)`,
            '--parsina-sheet-dvh': `calc(${cap} * 100dvh - ${keyboardInset + panInset}px)`,
            animation: 'parsina-sheet-up 0.25s cubic-bezier(0.4,0,0.2,1)',
            // No `fontFamily` here: the typeface is set once at the app root and
            // inherited (§2.1 — a component-level font declaration is a defect).
            outline: 'none',
            padding: '1rem 1.25rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem',
            marginBottom: title ? '0.75rem' : 0,
            flexShrink: 0
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            margin: 0,
            minWidth: 0
        }
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": closeLabel,
        "data-testid": testId ? `${testId}-close` : undefined,
        style: {
            border: 'none',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            cursor: 'pointer',
            // §6: 2.75rem is the floor for anything a thumb has to hit. The
            // glyph stays small; the TARGET is what grew.
            width: '2.75rem',
            height: '2.75rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            flexShrink: 0,
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 6 6 18M6 6l12 12"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: fullHeight ? 1 : undefined,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            // The sheet is the one scroller while it is open; a flick that
            // reaches its end must not hand the gesture to the page behind it.
            overscrollBehavior: 'contain',
            paddingBottom: footer ? 0 : 'calc(1.25rem + env(safe-area-inset-bottom, 0px))'
        }
    }, children), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            marginTop: '0.75rem',
            marginInline: '-1.25rem',
            padding: '0.625rem 1.25rem',
            paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, footer)));
    // `document` is absent during a Next.js server render; a sheet that is open
    // on the server (rare, but a valid initial state) renders in place there and
    // moves to <body> on the client.
    if (portal && typeof document !== 'undefined') return /*#__PURE__*/ (0, $1u0KT.createPortal)(tree, document.body);
    return tree;
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Menu — an anchored menu.
//
// PROMOTED from the clinic app's `src/components/common/ClinicMenu.jsx`, which
// had marked itself a promotion candidate: the kit had no menu primitive at any
// version — not a Menu, not a Popover, not a DropdownMenu — so per DESIGN.md
// rule 4 it lived in the app until a second app needed one. `AccountCard` is
// that second need, in all four panels at once.
//
// Not built from `Dialog`: a Dialog is a centred modal and this is an anchored
// menu, so the kit's overlay would be the wrong shape AND the wrong semantics
// (`role="dialog"` where a screen reader needs `role="menu"`).
//
// Portaled to `document.body` so a clipping ancestor cannot cut it off — the
// staff sidebars are fixed-width flex columns with `overflow: hidden`, and an
// anchored child of one is sliced at 260px (or at 68px when collapsed).
//
// LAYERING — z 900. Above every piece of app chrome (the doctor app's mobile
// bottom nav at z-50, its visit-closure flow at z-60) and below every kit
// overlay: BottomSheet 1000, Dialog/ConfirmDialog 1100. That order is the one
// DESIGN.md insists on — a ConfirmDialog raised from inside a menu row (sign
// out, a destructive switch) must render ABOVE the menu, and the fix for that
// ordering is never to lower the dialog. ClinicMenu sat at 11, the Drawer
// level, which was enough for the one trigger it had; 900 is what a menu opened
// from anywhere needs.
//
// Props:
//   open / onClose        — controlled
//   anchorRef             — ref to the trigger; the menu is measured against it
//   placement             — 'bottom' (default) | 'top' | 'auto'. 'auto' opens
//                           downward and flips up when the space below is too
//                           small. A menu at the FOOT of a sidebar wants 'top'.
//   width                 — px (default 300)
//   ariaLabel             — required in practice: the trigger's visible text is
//                           often a person's or a clinic's name, not the menu's
//   children              — the rows; give them role="menuitem"/"menuitemradio"
//   data-testid
// ─────────────────────────────────────────────────────────────────────────────
const $08d1958bc1315b40$var$Z = 900;
const $08d1958bc1315b40$var$GAP = 6; // breathing room between trigger and menu
const $08d1958bc1315b40$var$EDGE = 8; // never touch the viewport edge
const $08d1958bc1315b40$var$MIN_BELOW = 180; // 'auto' flips up below this much room
// Every focusable row, in DOM order. Radio rows come from ClinicSwitcher, plain
// menuitems from AccountCard; `[data-menu-focus]` lets a caller nominate
// something else entirely (ClinicSwitcher's search box).
const $08d1958bc1315b40$var$ROW_SELECTOR = '[data-menu-focus="true"], [role="menuitem"]:not([aria-disabled="true"]), [role="menuitemradio"]:not([aria-disabled="true"])';
function $08d1958bc1315b40$export$d9b273488cd8ce6f({ open: open, onClose: onClose, anchorRef: anchorRef, children: children, ariaLabel: ariaLabel, width: width = 300, placement: placement = 'bottom', 'data-testid': testId = 'menu' }) {
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Position against the trigger. Measured on open and on every resize/scroll,
    // rather than once: the sidebar collapses under a CSS transition, so a
    // position captured at open time is wrong 300ms later.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const place = ()=>{
            const el = anchorRef?.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
            // Anchor to the INLINE-START edge in both directions, which is the visual
            // edge the trigger shares with its container in RTL and LTR alike.
            const left = isRtl ? Math.max($08d1958bc1315b40$var$EDGE, r.right - width) : Math.min(r.left, window.innerWidth - width - $08d1958bc1315b40$var$EDGE);
            const roomBelow = window.innerHeight - r.bottom - $08d1958bc1315b40$var$EDGE * 2;
            const roomAbove = r.top - $08d1958bc1315b40$var$EDGE * 2;
            const up = placement === 'top' || placement === 'auto' && roomBelow < $08d1958bc1315b40$var$MIN_BELOW && roomAbove > roomBelow;
            const room = up ? roomAbove : roomBelow;
            const maxHeight = Math.min(Math.max(160, room), Math.round(window.innerHeight * 0.6));
            setPos(up ? {
                bottom: Math.max($08d1958bc1315b40$var$EDGE, window.innerHeight - r.top + $08d1958bc1315b40$var$GAP),
                left: left,
                maxHeight: maxHeight
            } : {
                top: r.bottom + $08d1958bc1315b40$var$GAP,
                left: left,
                maxHeight: maxHeight
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorRef,
        width,
        placement
    ]);
    // Close on an outside press. `mousedown` rather than `click`, so a press that
    // starts outside and ends inside cannot re-open what it just closed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (menuRef.current?.contains(e.target)) return;
            if (anchorRef?.current?.contains(e.target)) return;
            onClose?.();
        };
        document.addEventListener('mousedown', onDown);
        return ()=>document.removeEventListener('mousedown', onDown);
    }, [
        open,
        onClose,
        anchorRef
    ]);
    // Escape closes, arrows walk the rows, Home/End jump. A menu you can open by
    // keyboard but only leave by mouse is a trap.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
                return;
            }
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
            const rows = Array.from(menuRef.current?.querySelectorAll($08d1958bc1315b40$var$ROW_SELECTOR) || []);
            if (!rows.length) return;
            e.preventDefault();
            const at = rows.indexOf(document.activeElement);
            const next = e.key === 'Home' ? 0 : e.key === 'End' ? rows.length - 1 : e.key === 'ArrowDown' ? (at + 1) % rows.length : at <= 0 ? rows.length - 1 : at - 1;
            rows[next]?.focus?.();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Focus lands inside on open and returns to the trigger on close — a menu that
    // opens without focus is unreachable by keyboard, and one that drops focus on
    // close strands the caret at the top of the document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const t = window.setTimeout(()=>{
            menuRef.current?.querySelector($08d1958bc1315b40$var$ROW_SELECTOR)?.focus?.();
        }, 0);
        const anchor = anchorRef?.current;
        return ()=>{
            window.clearTimeout(t);
            if (anchor && document.contains(anchor)) anchor.focus?.();
        };
    }, [
        open,
        anchorRef
    ]);
    if (!open || !pos) return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        role: "menu",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            position: 'fixed',
            top: pos.top,
            bottom: pos.bottom,
            left: pos.left,
            width: width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: 'white',
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            boxShadow: '0 18px 48px rgba(15, 34, 51, 0.18)',
            zIndex: $08d1958bc1315b40$var$Z,
            padding: 6,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, children), document.body);
}
var $08d1958bc1315b40$export$2e2bcd8739ae039 = $08d1958bc1315b40$export$d9b273488cd8ce6f;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * useResponsive — is this viewport the MOBILE surface?
 *
 * ≤ 768px is mobile across the whole product (DESIGN-CONCEPT-MOBILE preamble:
 * "everything rendered when `useResponsive()` reports ≤ 768px"). The boundary
 * is inclusive: 768 is mobile, 769 is desktop.
 *
 * It lives in the kit because it is the switch every `X.mobile.jsx` fork is
 * chosen by, and a byte-identical copy already existed in the doctor and the
 * clinic client — the second app needing it is DESIGN.md rule 4's trigger to
 * move it here. It sits beside `useKeyboardInset` and `useMeasuredWidth`: all
 * three are facts about the device's geometry that a whole class of screens
 * depends on.
 *
 * Hardened over the app-local copies in two ways:
 *   • `matchMedia` rather than a `resize` listener, so a rotation or a
 *     window drag fires once at the boundary instead of on every frame;
 *   • an SSR / no-window guard, so importing it in a Next.js server component
 *     or a node-environment test does not throw. It reports DESKTOP there —
 *     the surface with the full content, which is the safe default for a
 *     first paint that has not measured anything yet.
 *
 * @param breakpoint the inclusive mobile ceiling in px (default 768)
 * @returns { isMobile }
 */ const $e959a5a9c1f6e19d$var$query = (breakpoint)=>`(max-width: ${breakpoint}px)`;
const $e959a5a9c1f6e19d$var$read = (breakpoint)=>{
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function') return window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint)).matches;
    return window.innerWidth <= breakpoint;
};
function $e959a5a9c1f6e19d$export$2e2bcd8739ae039(breakpoint = 768) {
    const [isMobile, setIsMobile] = (0, $acw62.useState)(()=>$e959a5a9c1f6e19d$var$read(breakpoint));
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        // The state initialiser ran before mount; re-read now in case the viewport
        // is not what it was (hydration, a rotation during boot).
        setIsMobile($e959a5a9c1f6e19d$var$read(breakpoint));
        if (typeof window.matchMedia !== 'function') {
            const onResize = ()=>setIsMobile(window.innerWidth <= breakpoint);
            window.addEventListener('resize', onResize);
            return ()=>window.removeEventListener('resize', onResize);
        }
        const mq = window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint));
        const onChange = (e)=>setIsMobile(e.matches);
        // `addListener` is the pre-2019 Safari spelling; still worth keeping while
        // the product supports older iOS webviews.
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else mq.addListener(onChange);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', onChange);
            else mq.removeListener(onChange);
        };
    }, [
        breakpoint
    ]);
    return {
        isMobile: isMobile
    };
}




'use client';
// The panel surface both shells paint on. A sticky header has to repaint it, or
// the body shows through as it scrolls under.
const $382b400f7624ec9d$var$OVERLAY_SURFACE = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card;
function $382b400f7624ec9d$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, description: description, header: header, footer: footer, children: children, busy: busy = false, size: size = 'md', isMobile: isMobile, historyIntegration: historyIntegration = true, snap: snap = 1, fullHeight: fullHeight = true, closeLabel: closeLabel, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().close;
    const auto = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    // ── Why this cannot be server-rendered blind ──────────────────────────────
    // WHICH SHELL this is depends on the viewport, and a server does not have
    // one. Rendering the desktop guess and then swapping to a sheet on the client
    // is a hydration mismatch — React discards the tree and re-renders it, and in
    // an app that streams the overlay open from a deep link (`?book=1`) that is a
    // visible flash of the wrong shape.
    //
    // So: when the caller TELLS us the tier we trust it and render on the server
    // like anything else. When it does not, we wait for the client, where the
    // question has an answer. One frame later than ideal, and never wrong.
    const told = isMobile !== undefined;
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(told);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    const mobile = told ? isMobile : auto.isMobile;
    // One guard for every way out, so "can this close right now?" has a single
    // answer rather than one per dismissal path. On the sheet tier a platform back
    // has already popped the sheet's history entry when this refuses; the sheet's
    // `useOverlayHistory` re-claims it one tick later (v0.16.1), so a busy overlay
    // keeps exactly one entry and the next back is delivered to it again.
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (busy) return;
        if (typeof onClose === 'function') onClose();
    }, [
        busy,
        onClose
    ]);
    if (!open || !mounted) return null;
    if (mobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        title: title,
        footer: footer,
        snap: snap,
        fullHeight: fullHeight,
        closeLabel: closeLabel,
        historyIntegration: historyIntegration,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        ...rest
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: $382b400f7624ec9d$var$OVERLAY_SURFACE,
            padding: '0 1.25rem 0.75rem'
        }
    }, header) : null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) close();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
        size: size,
        layout: "frame",
        showClose: !busy,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        // Radix would otherwise close on Esc or an outside click mid-write.
        onEscapeKeyDown: (e)=>{
            if (busy) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if (busy) e.preventDefault();
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$742513523b177e3b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
        dir: "auto"
    }, title), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$94e94c2ec2c954d5), {
        dir: "auto"
    }, description) : null, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            marginTop: '0.75rem'
        }
    }, header) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), null, children), footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$7bbfb2d443473050), null, footer) : null));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $da50fe1f8f323572$export$a477a7ade7efed9c() {
    // One listener implementation for both facts: the bottom inset IS the
    // keyboard, `top` is the pan a sheet needs (PM-0108) and a composer does not.
    return (0, $0286d675359db131$export$9ff6616b10aa518d)().bottom;
}
var $da50fe1f8f323572$export$2e2bcd8739ae039 = $da50fe1f8f323572$export$a477a7ade7efed9c;


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Toast — the one notification system for every Parsina client.
//
// Replaces: native alert() calls (doctor app), the 5+ per-screen setToast/
// setTimeout implementations (clinic app), and inline-only feedback (patient app).
//
// Usage:
//   <ToastProvider>  ← once, at the app root
//   const toast = useToast();
//   toast.success('ذخیره شد');
//   toast.error('خطا در ارتباط با سرور');
//   toast.info('...'); toast.warn('...');
//
// The contract is DESIGN_SYSTEM §9.3 / DESIGN_CONCEPT §7 (PM-0022):
//   • one sentence, auto-dismissed after 4 s — an error after 6 s;
//   • at most 3 stacked on desktop, 2 on a phone (the oldest leaves);
//   • desktop: the bottom, inline-END corner (the one farthest from the sidebar);
//     phone: bottom-centre, ABOVE whatever is docked there — the bottom nav
//     (`--app-bottom-nav`), a screen's CTA footer (`--app-bottom-dock`, see
//     `usePublishedHeight`) and the software keyboard;
//   • polite to a screen reader, except an error, which interrupts.
// ─────────────────────────────────────────────────────────────────────────────
const $352ffee698fbd002$var$PALETTE = {
    success: {
        bg: '#1A9B6C',
        text: '#ffffff'
    },
    error: {
        bg: '#D93025',
        text: '#ffffff'
    },
    warn: {
        bg: '#F59E0B',
        text: '#1a2332'
    },
    info: {
        bg: '#0173BE',
        text: '#ffffff'
    }
};
const $352ffee698fbd002$var$ToastContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $352ffee698fbd002$export$beb43bca45d33d34 = 4000;
const $352ffee698fbd002$export$7a658dea7a198286 = 6000;
const $352ffee698fbd002$export$3b92a0a0bf23cbdd = {
    desktop: 3,
    mobile: 2
};
let $352ffee698fbd002$var$nextId = 1;
function $352ffee698fbd002$export$f5d03d415824e0e({ children: children, duration: duration = $352ffee698fbd002$export$beb43bca45d33d34, errorDuration: errorDuration = $352ffee698fbd002$export$7a658dea7a198286 }) {
    const [toasts, setToasts] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const timers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const keyboardInset = (0, $da50fe1f8f323572$export$2e2bcd8739ae039)();
    const max = isMobile ? $352ffee698fbd002$export$3b92a0a0bf23cbdd.mobile : $352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop;
    const dismiss = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setToasts((t)=>t.filter((x)=>x.id !== id));
        const timer = timers.current.get(id);
        if (timer) {
            clearTimeout(timer);
            timers.current.delete(id);
        }
    }, []);
    const push = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message, type = 'info', opts = {})=>{
        const id = $352ffee698fbd002$var$nextId++;
        // The state keeps the desktop cap; the phone's smaller one is applied at
        // render, so a rotation never needs the list rewritten.
        setToasts((t)=>[
                ...t,
                {
                    id: id,
                    message: message,
                    type: type
                }
            ].slice(-$352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop));
        const life = opts.duration ?? (type === 'error' ? errorDuration : duration);
        timers.current.set(id, setTimeout(()=>dismiss(id), life));
        return id;
    }, [
        dismiss,
        duration,
        errorDuration
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            timers.current.forEach(clearTimeout);
        }, []);
    const api = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            show: push,
            success: (m, o)=>push(m, 'success', o),
            error: (m, o)=>push(m, 'error', o),
            warn: (m, o)=>push(m, 'warn', o),
            info: (m, o)=>push(m, 'info', o),
            dismiss: dismiss
        }), [
        push,
        dismiss
    ]);
    const visible = toasts.slice(-max);
    // Phone: clear the nav + a docked footer, or the keyboard when that is taller
    // (a footer that pads for the keyboard already contains it — hence `max`, not
    // a sum). Desktop has neither; the corner offset is all there is.
    const bottom = isMobile ? `calc(max(var(--app-bottom-nav, 0px) + var(--app-bottom-dock, 0px), env(safe-area-inset-bottom, 0px), ${keyboardInset}px) + 0.75rem)` : '1.5rem';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($352ffee698fbd002$var$ToastContext.Provider, {
        value: api
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "toast-stack",
        "data-placement": isMobile ? 'bottom-center' : 'bottom-end',
        style: {
            position: 'fixed',
            bottom: bottom,
            insetInline: 0,
            paddingInline: isMobile ? '1rem' : '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: '0.5rem',
            zIndex: 9999,
            pointerEvents: 'none'
        }
    }, visible.map((t)=>{
        const p = $352ffee698fbd002$var$PALETTE[t.type] || $352ffee698fbd002$var$PALETTE.info;
        const isError = t.type === 'error';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: t.id,
            onClick: ()=>dismiss(t.id),
            role: isError ? 'alert' : 'status',
            "aria-live": isError ? 'assertive' : 'polite',
            "data-testid": "toast",
            "data-type": t.type,
            style: {
                pointerEvents: 'auto',
                cursor: 'pointer',
                background: p.bg,
                color: p.text,
                padding: '0.625rem 1.125rem',
                borderRadius: 'var(--radius, 10px)',
                fontSize: '0.8125rem',
                fontWeight: 600,
                boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                maxWidth: 'min(92vw, 26.25rem)',
                animation: 'parsina-toast-in 0.22s ease-out'
            }
        }, t.message);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-toast-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@media (prefers-reduced-motion: reduce){[data-testid="toast"]{animation:none !important}}`)));
}
function $352ffee698fbd002$export$a407b657d3044108() {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($352ffee698fbd002$var$ToastContext);
    if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
}



var $acw62 = parcelRequire("acw62");


'use client';
function $31e8de2f297417a1$export$7f7cbe89f1eacd2({ size: size = 32, color: color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, thickness: thickness = 2, style: style, label: label }) {
    if (label === undefined) label = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().loading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        // The accessible name is a PROP (rule 7). It used to be a Persian string
        // literal with no way past it, so an English screen announced its loading
        // state in Persian and the app could do nothing about it.
        "aria-label": label,
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            border: `${thickness}px solid ${color}`,
            borderTopColor: 'transparent',
            animation: 'parsina-spin 0.8s linear infinite',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-spin{to{transform:rotate(360deg)}}`));
}
function $31e8de2f297417a1$export$e2b0760399e6dece({ label: label, minHeight: minHeight = '60vh' }) {
    return(// No `dir` of its own — it inherits the document's, like every other
    // component in the kit. It is a centred column either way.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minHeight: minHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31e8de2f297417a1$export$7f7cbe89f1eacd2, {
        label: label
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            color: '#9aa3b0',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, label) : null));
}
var $31e8de2f297417a1$export$2e2bcd8739ae039 = $31e8de2f297417a1$export$7f7cbe89f1eacd2;



var $acw62 = parcelRequire("acw62");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SessionCheck / SessionError / SessionPage — what EVERY Parsina panel shows
// between opening the tab and knowing who is signed in.
//
// The Keycloak round trip, the token check and whatever read a panel needs
// before its first screen (onboarding status, memberships, appearance) all sit
// behind this one card. It was the doctor panel's (its App.jsx `AuthPage`),
// copied into the clinic panel in 2026-09 and drawn differently again in the
// dentist, student and admin panels — five front doors to one product. It is
// the kit's now, so a person who opens two panels in one morning meets one
// door, and a change to it is one release rather than five edits.
//
//   SessionPage   the canvas (145° navy gradient, two drifting discs) and the
//                 420px white card that rises in
//   SessionCheck  the loading state: brand hero, three bouncing dots, the
//                 progress track, and the manual sign-in link after 4s
//   SessionError  a boot that could not finish: logo, tone disc, message,
//                 one gradient action, and the SSO host it tried
//
// ── Continuing across a remount ─────────────────────────────────────────────
//
// A panel's boot often has two owners — the auth check, then a provider that
// reads what the panel needs — and each renders its own SessionCheck. Left
// alone the second mount would restart every animation: the card rising again,
// the track snapping back to 5%. So every animation is offset by the time since
// this MODULE loaded (≈ the page's start) with a negative `animation-delay`,
// and the manual link counts from the same moment. The second mount continues
// the first.
//
// Every word is a PROP (rule 7) and so is the logo: the kit ships no image, and
// a panel with its own mark (ParsinaDent) passes its own.
// ─────────────────────────────────────────────────────────────────────────────
const $3c4ca280922aa4ea$var$now = ()=>typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
const $3c4ca280922aa4ea$var$SESSION_T0 = $3c4ca280922aa4ea$var$now();
/** Milliseconds since the kit loaded — the one clock every session screen shares. */ const $3c4ca280922aa4ea$var$sinceBoot = ()=>$3c4ca280922aa4ea$var$now() - $3c4ca280922aa4ea$var$SESSION_T0;
const $3c4ca280922aa4ea$var$continued = (elapsedMs, ownDelayS = 0)=>({
        animationDelay: `${ownDelayS - elapsedMs / 1000}s`
    });
const $3c4ca280922aa4ea$export$6b89370abb8fc4ae = `linear-gradient(145deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 55%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`;
const $3c4ca280922aa4ea$export$e3b7f640fe979c0e = `linear-gradient(160deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 60%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`;
const $3c4ca280922aa4ea$var$SESSION_ACTION = `linear-gradient(135deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark}, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy})`;
// Reduced motion: the card simply appears, the dots rest, the track sits part
// filled. Those resting values are the base rules, so they hold wherever the
// animation does not.
const $3c4ca280922aa4ea$var$SESSION_CSS = `
  @keyframes parsina-session-rise { from { opacity: 0; transform: translateY(24px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes parsina-session-dot { 0%, 65%, 100% { transform: translateY(0); opacity: 0.3 } 30% { transform: translateY(-9px); opacity: 1 } }
  @keyframes parsina-session-progress { 0% { width: 5% } 50% { width: 65% } 85% { width: 88% } 100% { width: 93% } }
  @keyframes parsina-session-float { 0%, 100% { transform: scale(1) } 50% { transform: scale(1.06) } }
  @keyframes parsina-session-appear { from { opacity: 0 } to { opacity: 1 } }
  [data-session-dot] { opacity: 0.6; }
  [data-session-progress] { width: 65%; }
  @media (prefers-reduced-motion: no-preference) {
    [data-session-card] { animation: parsina-session-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both; }
    [data-session-dot] { animation: parsina-session-dot 1.5s ease-in-out infinite; }
    [data-session-progress] { animation: parsina-session-progress 3s ease-out both; }
    [data-session-float] { animation-name: parsina-session-float; animation-timing-function: ease-in-out; animation-iteration-count: infinite; }
    [data-session-appear] { animation: parsina-session-appear 0.4s ease both; }
  }
`;
function $3c4ca280922aa4ea$export$15364261a1aca489({ children: children, testId: testId }) {
    // Read once per mount: the offset must not move under a running animation.
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
            background: $3c4ca280922aa4ea$export$6b89370abb8fc4ae,
            fontFamily: 'Meshkat, sans-serif',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $3c4ca280922aa4ea$var$SESSION_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            top: -120,
            insetInlineEnd: -80,
            width: 380,
            height: 380,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)',
            animationDuration: '9s',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            bottom: -160,
            insetInlineStart: -100,
            width: 500,
            height: 500,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
            animationDuration: '12s',
            pointerEvents: 'none',
            ...$3c4ca280922aa4ea$var$continued(elapsed, 3)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        "data-session-card": "",
        style: {
            background: 'white',
            borderRadius: 16,
            width: 420,
            maxWidth: 'calc(100vw - 48px)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.3), 0 8px 32px rgba(0,0,0,0.18)',
            textAlign: 'center',
            overflow: 'hidden',
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    }, children));
}
function $3c4ca280922aa4ea$export$cd72095868f03c30({ logo: logo, brandName: brandName, panelName: panelName, title: title, subtitle: subtitle, stuckLabel: stuckLabel, manualLabel: manualLabel, onManualSignIn: onManualSignIn, manualAfterMs: manualAfterMs = 4000, testId: testId = 'session-check' }) {
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    const [showManual, setShowManual] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>elapsed >= manualAfterMs);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (showManual || !onManualSignIn) return undefined;
        const timer = setTimeout(()=>setShowManual(true), Math.max(0, manualAfterMs - $3c4ca280922aa4ea$var$sinceBoot()));
        return ()=>clearTimeout(timer);
    }, [
        showManual,
        onManualSignIn,
        manualAfterMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: $3c4ca280922aa4ea$export$e3b7f640fe979c0e,
            padding: '36px 44px 32px',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            top: -24,
            insetInlineEnd: -24,
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            bottom: -30,
            insetInlineStart: -20,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 14,
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 72,
            height: 72,
            borderRadius: 18,
            background: 'rgba(255,255,255,0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain'
        }
    }))) : null, brandName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 26,
            fontWeight: 800,
            color: 'white',
            marginBottom: 4,
            letterSpacing: -0.5
        }
    }, brandName) : null, panelName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: 'rgba(255,255,255,0.55)'
        }
    }, panelName) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '32px 44px 40px'
        },
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
            marginBottom: 18
        }
    }, [
        0,
        0.18,
        0.36
    ].map((delay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: delay,
            "data-session-dot": "",
            style: {
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                ...$3c4ca280922aa4ea$var$continued(elapsed, delay)
            }
        }))), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 15,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: 6,
            fontWeight: 500
        }
    }, title) : null, subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 28
        }
    }, subtitle) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            width: '100%',
            height: 4,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 28
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-progress": "",
        style: {
            height: '100%',
            background: `linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark}, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight})`,
            borderRadius: 4,
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    })), showManual && onManualSignIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-appear": "",
        style: {
            marginTop: 18,
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, stuckLabel, stuckLabel ? ' ' : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onManualSignIn,
        "data-testid": `${testId}-manual`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit',
            fontSize: 13,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            textDecoration: 'underline',
            textUnderlineOffset: 3
        }
    }, manualLabel)) : null));
}
// Filled glyphs (Material `error`, `cloud_off`) — the doctor card's family.
const $3c4ca280922aa4ea$var$ErrorGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }));
const $3c4ca280922aa4ea$var$OfflineGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
    }));
const $3c4ca280922aa4ea$var$TONES = {
    /** The sign-in service failed, or the redirect looped. */ danger: {
        bg: '#FEF2F2',
        ring: '#FECACA',
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
        Glyph: $3c4ca280922aa4ea$var$ErrorGlyph
    },
    /** Signed in, but the panel's backend did not answer. */ warning: {
        bg: '#FFFBEB',
        ring: '#FDE68A',
        ink: '#B45309',
        Glyph: $3c4ca280922aa4ea$var$OfflineGlyph
    }
};
function $3c4ca280922aa4ea$export$d422f67d76bf24e4({ tone: tone = 'danger', logo: logo, brandName: brandName, title: title, body: body, detail: detail, actionLabel: actionLabel, onAction: onAction, secondary: secondary, host: host, testId: testId = 'session-error', stateTestId: stateTestId }) {
    const look = $3c4ca280922aa4ea$var$TONES[tone] || $3c4ca280922aa4ea$var$TONES.danger;
    const { Glyph: Glyph } = look;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '40px 44px 44px'
        },
        role: "alert",
        "data-testid": stateTestId
    }, logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain',
            marginBottom: 20,
            opacity: 0.55
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: look.bg,
            border: `2px solid ${look.ring}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        color: look.ink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0 0 10px',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: -0.3
        }
    }, title), body ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontSize: 14,
            marginBottom: detail ? 12 : 32,
            lineHeight: 1.8
        }
    }, body) : null, detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontSize: 12,
            marginBottom: 32,
            lineHeight: 1.7,
            wordBreak: 'break-word'
        }
    }, detail) : null, onAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAction,
        style: {
            width: '100%',
            height: 50,
            background: $3c4ca280922aa4ea$var$SESSION_ACTION,
            color: 'white',
            border: 'none',
            borderRadius: 12,
            fontSize: 15,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            boxShadow: `0 4px 16px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.3)}`,
            marginBottom: secondary ? 10 : 20
        }
    }, actionLabel) : null, secondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: secondary.onClick,
        style: {
            width: '100%',
            height: 44,
            background: 'white',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            marginBottom: 20
        }
    }, secondary.label) : null, host ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: '10px 14px',
            background: '#f8fafc',
            borderRadius: 10,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        width: "13",
        height: "13",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: 11,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontFamily: 'monospace',
            letterSpacing: 0.2
        }
    }, host)) : null));
}
var $3c4ca280922aa4ea$export$2e2bcd8739ae039 = $3c4ca280922aa4ea$export$cd72095868f03c30;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Skeleton family — the loading state of every Parsina screen.
//
// A screen that is fetching draws ITS OWN SHAPE in placeholder blocks: the
// header, tabs, filters, table or cards it is about to show, at the sizes they
// will have. Not a centred spinner, not «در حال بارگذاری…», not a blank page —
// see DESIGN.md §"Loading & skeleton". The primitives here are the vocabulary;
// each screen composes its own skeleton from them (`PatientDetailSkeleton`,
// `ReceptionSkeleton`, …) so the skeleton matches THAT screen, desktop and
// mobile alike, and nothing jumps when the data lands.
//
// Sizes mirror the real components on purpose: `SkeletonInput` is 44px like a
// `TextInput`, `SkeletonButton` 44px like a `Button`, `SkeletonTable` rows are
// 52px (44 dense) like `Table`, `SkeletonCard` has the `Card` surface. If a real
// component's geometry changes, change its skeleton in the same commit.
//
// Every block is `aria-hidden`; a composite root carries `role="status"`,
// `aria-busy` and an accessible `label` (a prop, rule 7) so assistive tech hears
// ONE "loading" instead of forty empty boxes. Motion respects
// `prefers-reduced-motion`: the sheen stops, the blocks stay.
// ─────────────────────────────────────────────────────────────────────────────
const $c90190398471f24a$var$SHIMMER_CSS = `
  @keyframes parsina-shimmer {
    0%   { background-position: 200% 0 }
    100% { background-position: -200% 0 }
  }
  [data-skeleton] {
    background: linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base} 25%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).sheen} 50%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base} 75%);
    background-size: 200% 100%;
    animation: parsina-shimmer 1.4s ease-in-out infinite;
  }
  [data-skeleton][data-tone="onDark"] {
    background: linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark} 25%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDarkSheen} 50%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark} 75%);
    background-size: 200% 100%;
  }
  @media (prefers-reduced-motion: reduce) {
    [data-skeleton] { animation: none; background: ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base}; }
    [data-skeleton][data-tone="onDark"] { background: ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark}; }
  }
`;
// One stylesheet for the whole family. React 19 hoists a <style> with `href` +
// `precedence` into <head> once, however many skeletons are on screen.
const $c90190398471f24a$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-skeleton",
        precedence: "default"
    }, $c90190398471f24a$var$SHIMMER_CSS);
function $c90190398471f24a$export$8f31e4c4a37b8e9c({ width: width = '100%', height: height = 14, radius: radius = (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip, circle: circle = false, tone: tone, style: style, className: className, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-skeleton": "",
        // `tone="onDark"` — white-alpha blocks for a gradient header, a sidebar
        // or a dark image canvas, where the neutral grey would read as a hole.
        "data-tone": tone === 'onDark' ? 'onDark' : undefined,
        className: className,
        style: {
            width: width,
            height: circle ? width : height,
            borderRadius: circle ? '50%' : radius,
            flexShrink: 0,
            ...style
        },
        ...rest
    }));
}
// Whether we are already inside an announced skeleton region. A page skeleton
// composed of a SkeletonStats, a SkeletonTable and two SkeletonCards used to
// announce "loading" four times; only the OUTERMOST region speaks now, the
// nested ones are plain hidden boxes.
const $c90190398471f24a$var$Nested = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $c90190398471f24a$export$8b3e24dbbac64362({ as: Tag = 'div', label: label, style: style, children: children, ...rest }) {
    const nested = (0, $acw62.useContext)($c90190398471f24a$var$Nested);
    if (nested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "aria-hidden": true,
        "data-state": "loading",
        style: style,
        ...rest
    }, children);
    // An announced region is named in whatever language the page is showing: the
    // caller's `label`, or the kit's own word for "loading" in `<html lang>`.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Nested.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        role: "status",
        "aria-busy": "true",
        "aria-label": label ?? (0, $df1b34b618a72512$export$cddd06f8fa3400df)().loading,
        "data-state": "loading",
        style: style,
        ...rest
    }, children));
}
const $c90190398471f24a$var$Root = $c90190398471f24a$export$8b3e24dbbac64362;
// Line widths for a paragraph — the last line is shorter, like real text.
const $c90190398471f24a$var$LINE_WIDTHS = [
    '100%',
    '92%',
    '96%',
    '85%',
    '70%'
];
function $c90190398471f24a$export$cb6ddd830302c2a8({ width: width = '60%', height: height = 14, lines: lines = 1, lastWidth: lastWidth = '60%', gap: gap = 8, style: style, ...rest }) {
    if (lines <= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: width,
        height: height,
        style: style,
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            width: '100%',
            ...style
        },
        ...rest
    }, Array.from({
        length: lines
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: height,
            width: i === lines - 1 ? lastWidth : $c90190398471f24a$var$LINE_WIDTHS[i % $c90190398471f24a$var$LINE_WIDTHS.length]
        })));
}
function $c90190398471f24a$export$53c2c5a35a7e31a2({ size: size = 40, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size,
        circle: true,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$7387c3f2666b9f16({ width: width = 112, size: size = 'default', style: style, ...rest }) {
    const height = size === 'sm' ? 36 : size === 'icon' ? 40 : 44;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size === 'icon' ? height : width,
        height: height,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$5ce4f4d8e50e2948({ label: label = true, labelWidth: labelWidth = 88, multiline: multiline = false, width: width = '100%', style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            width: width,
            ...style
        },
        ...rest
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: labelWidth,
        height: 12
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: multiline ? 96 : 44,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }));
}
function $c90190398471f24a$export$5956eb8f2ff4afde({ avatar: avatar = true, lines: lines = 0, chips: chips = 2, actions: actions = 2, padding: padding = 20, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: padding,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
        size: 48
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "60%",
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "40%",
        height: 11
    }))), lines > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$cb6ddd830302c2a8, {
        lines: lines,
        height: 12
    }) : null, chips > 0 || actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }) : null, chips > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: 60 + i % 2 * 12,
            height: 22,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }))) : null, actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: 36,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            style: {
                flex: 1
            }
        }))) : null);
}
const $c90190398471f24a$var$ROW_WIDTHS = [
    48,
    120,
    100,
    70,
    80,
    70,
    100
];
function $c90190398471f24a$export$8bbcb87f63697989({ cols: cols = 7, widths: widths = $c90190398471f24a$var$ROW_WIDTHS, dense: dense = false, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        "aria-hidden": true,
        style: {
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            height: dense ? 44 : 52
        },
        ...rest
    }, Array.from({
        length: cols
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            key: i,
            style: {
                padding: '0 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: widths[i % widths.length] || 80,
            height: i === 0 ? 18 : 13
        }))));
}
function $c90190398471f24a$export$6a15d3f7c248c5bb({ rows: rows = 6, columns: columns = 5, dense: dense = false, header: header = true, style: style, label: label, ...rest }) {
    const cols = Array.isArray(columns) ? columns : Array.from({
        length: columns
    }, (_, i)=>$c90190398471f24a$var$ROW_WIDTHS[(i + 1) % $c90190398471f24a$var$ROW_WIDTHS.length]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            overflow: 'hidden',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed'
        }
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            height: 40
        }
    }, cols.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            style: {
                padding: '0 16px',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: Math.min(typeof w === 'number' ? w * 0.7 : 72, 96),
            height: 11
        }))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: rows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8bbcb87f63697989, {
            key: i,
            cols: cols.length,
            widths: cols,
            dense: dense
        })))));
}
function $c90190398471f24a$export$9e2e66b17fdb9730({ count: count = 5, avatar: avatar = true, trailing: trailing = 56, divided: divided = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                minHeight: avatar ? 64 : 52,
                padding: '0 4px',
                borderTop: divided && i > 0 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
            }
        }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
            size: 40
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${55 + i * 17 % 30}%`,
            height: 14
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${30 + i * 11 % 25}%`,
            height: 11
        })), trailing > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: trailing,
            height: 22,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }) : null)));
}
function $c90190398471f24a$export$452537ec11d5437e({ count: count = 4, widths: widths, gap: gap = 4, padding: padding = '12px 14px', style: style, ...rest }) {
    const ws = widths || Array.from({
        length: count
    }, (_, i)=>[
            72,
            60,
            96,
            84,
            68
        ][i % 5]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: gap,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            overflowX: 'hidden',
            ...style
        },
        ...rest
    }, ws.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: padding
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: w,
            height: 13
        }))));
}
const $c90190398471f24a$var$BAR_HEIGHTS = [
    0.55,
    0.8,
    0.4,
    0.95,
    0.65,
    0.75,
    0.5,
    0.85,
    0.6,
    0.7,
    0.45,
    0.9
];
function $c90190398471f24a$export$9e5a4339fadac171({ height: height = 200, bars: bars = 8, line: line = false, legend: legend = 2, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            ...style
        }
    }, legend > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, Array.from({
        length: legend
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 10,
            circle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 56,
            height: 11
        })))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: height,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: '0 8px'
        }
    }, line ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: Math.round(height * 0.35),
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        style: {
            marginBottom: Math.round(height * 0.25)
        }
    }) : Array.from({
        length: bars
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: Math.round(height * $c90190398471f24a$var$BAR_HEIGHTS[i % $c90190398471f24a$var$BAR_HEIGHTS.length]),
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            style: {
                flex: 1,
                width: 'auto'
            }
        }))));
}
function $c90190398471f24a$export$68fb050a45c52f04({ fields: fields = 4, columns: columns = 1, actions: actions = 1, multiline: multiline = [], gap: gap = 16, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: gap
        }
    }, Array.from({
        length: fields
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$5ce4f4d8e50e2948, {
            key: i,
            multiline: multiline.includes(i),
            style: multiline.includes(i) && columns > 1 ? {
                gridColumn: '1 / -1'
            } : undefined
        }))), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 120 : 96
        }))) : null);
}
function $c90190398471f24a$export$171a4533b2ae49b5({ subtitle: subtitle = true, actions: actions = 1, back: back = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            minHeight: 44,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minWidth: 0
        }
    }, back ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 36,
        height: 36,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 160,
        height: 20
    }), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 110,
        height: 12
    }) : null)), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 112 : 44
        }))) : null);
}
function $c90190398471f24a$export$f70e1ea07462d9df({ search: search = true, chips: chips = 3, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            ...style
        },
        ...rest
    }, search ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 240,
        height: 44,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
        style: {
            maxWidth: '100%'
        }
    }) : null, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: [
                84,
                72,
                96,
                64
            ][i % 4],
            height: 36,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        })));
}
function $c90190398471f24a$export$3122f708803a735a({ count: count = 4, icon: icon = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
            gap: 12,
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderRadius: 12,
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 44,
            height: 44,
            radius: 12
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "55%",
            height: 22
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "70%",
            height: 11
        })))));
}
var $c90190398471f24a$export$2e2bcd8739ae039 = $c90190398471f24a$export$8f31e4c4a37b8e9c;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && array.indexOf(className) === index;
    }).join(" ");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};


const $3206cd97f03c9458$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Inbox", [
    [
        "polyline",
        {
            points: "22 12 16 12 14 15 10 15 8 12 2 12",
            key: "o97t9d"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ]
]);



'use client';
function $838915ee2bfb8ab1$export$2e2bcd8739ae039({ icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3206cd97f03c9458$export$2e2bcd8739ae039), {
    size: 44,
    strokeWidth: 1.5,
    "aria-hidden": true
}), title: title, description: description, action: action, fill: fill = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            animation: 'fadeUp .3s ease',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 56,
            marginBottom: 16,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, icon), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, description), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, action));
}



var $acw62 = parcelRequire("acw62");
'use client';
// Inlined so the component carries no bundler-specific asset import (Parcel's
// `url:` scheme does not exist in Next.js) — same default-avatar silhouette.
const $a53b6ea678d7efe0$var$defaultAvatarSrc = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e2e8f0"/><circle cx="20" cy="15" r="7" fill="#94a3b8"/><path d="M6 38c1.8-8 7.5-12 14-12s12.2 4 14 12z" fill="#94a3b8"/></svg>');
const $a53b6ea678d7efe0$var$AVATAR_COLORS = [
    '#1d4ed8',
    '#0891b2',
    '#0d9488',
    '#7c3aed',
    '#db2777',
    '#ea580c',
    '#16a34a'
];
function $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name) {
    const s = name || '';
    let h = 0;
    for(let i = 0; i < s.length; i++)h = s.charCodeAt(i) + ((h << 5) - h);
    return $a53b6ea678d7efe0$var$AVATAR_COLORS[Math.abs(h) % $a53b6ea678d7efe0$var$AVATAR_COLORS.length];
}
const $a53b6ea678d7efe0$var$Avatar = ({ name: name, size: size = 40, bg: bg, color: color = 'white', src: src })=>{
    const resolvedBg = bg ?? $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name);
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src ? 'loading' : 'idle');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setStatus(src ? 'loading' : 'idle');
    }, [
        src
    ]);
    const initials = (name || '').split(' ').filter(Boolean).map((w)=>w[0]).join('').slice(0, 2) || '?';
    const isSkeleton = status === 'loading';
    const isError = status === 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            background: isSkeleton ? '#e2e8f0' : src && !isError ? 'transparent' : resolvedBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.35,
            fontWeight: '700',
            color: color,
            flexShrink: 0,
            overflow: 'hidden',
            position: 'relative',
            animation: isSkeleton ? 'avatar-pulse 1.4s ease-in-out infinite' : 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes avatar-pulse{0%,100%{opacity:1}50%{opacity:.4}}`), src && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: name,
        onLoad: ()=>setStatus('loaded'),
        onError: ()=>setStatus('error'),
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: isSkeleton ? 0 : 1,
            transition: 'opacity 0.25s',
            position: 'absolute',
            inset: 0
        }
    }), (!src || isError) && (isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: $a53b6ea678d7efe0$var$defaultAvatarSrc,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, initials)));
};
var $a53b6ea678d7efe0$export$2e2bcd8739ae039 = $a53b6ea678d7efe0$var$Avatar;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PersonRow — a person, offered for choosing or simply stated.
//
// ── Why this is kit ─────────────────────────────────────────────────────────
// RECEPTION_PRACTITIONER_BOOKING §6.2 specifies a row anatomy for the clinic's
// practitioner picker — avatar, name, a meta line of «حرفه · تخصص · مدت», a
// trailing availability phrase, an ordinal for the first nine, and a disabled
// state that still says WHY. The patient app's practitioner step is the same
// row with different words in it. Two apps, one anatomy, and a *document*
// specifying it app-agnostically: §17.1 answers yes twice over.
//
// The rule it encodes is DESIGN.md rule 12 — an avatar means a person. This is
// not for anything that is not somebody.
//
// ── One component, two sizes — deliberately not two components ──────────────
// `size="sm"` is the CHIP: the pill in the clinic `BookingModal`'s header and
// the identity line of the patient's booking overlay. It is the same person
// with the same avatar and the same two lines, smaller and not tappable —
// shipping it as a second export would be the many-components failure §17.1
// warns about, and would let the two drift.
//
// Interactivity follows `onClick`: with one it is a real `<button>` and grows a
// chevron; without one it is a `<div>` that states rather than offers. A caller
// never has to ask for both.
//
// ── Unbookable is shown, never hidden (§2.6, §8.5) ──────────────────────────
// `disabled` mutes the row and shows `disabledReason` instead of dropping it
// from the list. Omitting is what makes a list lie: a patient looking for a
// specific doctor concludes they have left the clinic. `action` is the way out
// of the reason — the «تعریف ↗» link the clinic offers somebody who may fix it
// — and is simply not passed to a caller who may not.
//
// ── No copy, no numbers of its own ──────────────────────────────────────────
// §16.2 / §16.1: `name`, `meta`, `trailing`, `disabledReason` and `ordinal` are
// rendered VERBATIM, so their digits are whatever the app's own seam already
// made them. This component must never call a formatter and carries no
// catalogue. The patient app's `formatNumber` and the clinic's `formatDigits`
// are different seams, and both stay on their side of this line.
// ─────────────────────────────────────────────────────────────────────────────
// The chevron points the way the reader travels, which flips with the document.
// `--dir-flip` is the kit's one mirror (§11) — there is no `dir` prop, because a
// component that took one could be told to disagree with <html>.
const $cff717c1fa706fb8$var$Chevron = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        fill: "currentColor",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $cff717c1fa706fb8$var$SIZES = {
    md: {
        avatar: 34,
        pad: '0.6875rem 0.875rem',
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        name: '0.84375rem',
        meta: '0.75rem',
        gap: '0.625rem'
    },
    sm: {
        avatar: 28,
        pad: '0.3125rem 0.75rem',
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
        name: '0.8125rem',
        meta: '0.6875rem',
        gap: '0.5rem'
    }
};
function $cff717c1fa706fb8$export$2e2bcd8739ae039({ name: name, meta: meta, trailing: trailing, ordinal: ordinal, avatar: avatar, size: size = 'md', selected: selected = false, disabled: disabled = false, disabledReason: disabledReason, action: action, chevron: chevron, onClick: onClick, as: as, className: className, 'data-testid': testId, ...rest }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    const interactive = typeof onClick === 'function' && !disabled;
    const showChevron = chevron === undefined ? interactive : chevron && !disabled;
    const tail = disabled && disabledReason ? disabledReason : trailing;
    const Tag = as || (interactive ? 'button' : 'div');
    const isButton = Tag === 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        type: isButton ? 'button' : undefined,
        onClick: interactive ? onClick : undefined,
        disabled: isButton ? disabled : undefined,
        "aria-disabled": !isButton && disabled ? true : undefined,
        "aria-selected": rest.role === 'option' ? selected : undefined,
        "data-testid": testId,
        "data-state": disabled ? 'disabled' : selected ? 'selected' : 'default',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(interactive || size === 'md' ? 'w-full text-start' : 'text-start', className),
        style: {
            // A chip HUGS its contents; a row fills the list it is in. A
            // block-level chip stretched to the panel width reads as an empty field
            // rather than as a named person.
            display: size === 'sm' ? 'inline-flex' : 'flex',
            width: size === 'sm' ? 'fit-content' : undefined,
            maxWidth: '100%',
            alignItems: 'center',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: size === 'sm' ? 'none' : `1px solid ${selected ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: size === 'sm' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.08) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            cursor: disabled ? 'not-allowed' : interactive ? 'pointer' : 'default',
            opacity: disabled ? 0.6 : 1,
            // ≥ 2.75rem is the phone hit target (MOBILE_WEB_PWA §5); a chip is not a
            // target at all, so it is exempt.
            minHeight: size === 'sm' ? undefined : '2.75rem',
            minWidth: 0,
            transition: 'background 0.15s, border-color 0.15s'
        },
        ...rest
    }, ordinal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            width: '1.25rem',
            textAlign: 'center',
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, ordinal) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: avatar?.name ?? (typeof name === 'string' ? name : ''),
        bg: avatar?.color,
        src: avatar?.src,
        size: S.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.name,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, meta) : null), tail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            flexShrink: 0,
            fontSize: '0.6875rem',
            fontWeight: 700,
            lineHeight: 1.5,
            color: disabled ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
            textAlign: 'end'
        }
    }, tail) : null, action, showChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cff717c1fa706fb8$var$Chevron, null) : null);
}
function $cff717c1fa706fb8$export$fb8511da6566433c({ count: count = 4, size: size = 'md', label: label, 'data-testid': testId }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: label,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: S.gap,
                padding: S.pad,
                borderRadius: S.radius,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: S.avatar,
            height: S.avatar,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "45%",
            height: 11,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "30%",
            height: 9,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip
        })))));
}



var $acw62 = parcelRequire("acw62");




'use client';
function $7718f00aead6941c$export$2e2bcd8739ae039({ state: state = 'content', slots: slots = [], value: value, onSelect: onSelect, notice: notice = null, label: label, loadingLabel: loadingLabel, min: min = '5rem', columns: columns, loadingCount: loadingCount = 12, className: className, 'data-testid': testId, ...rest }) {
    if (label === undefined) label = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().slotGrid.label;
    if (loadingLabel === undefined) loadingLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().slotGrid.loading;
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: columns ? `repeat(${columns}, minmax(0, 1fr))` : `repeat(auto-fill, minmax(${min}, 1fr))`,
        gap: '0.5rem'
    };
    if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: loadingLabel,
        "data-testid": testId,
        "data-state": "loading",
        style: gridStyle
    }, Array.from({
        length: loadingCount
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            key: i,
            height: 44,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
        })));
    if (state === 'error' || state === 'empty') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: className,
        ...rest
    }, notice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label,
        "data-testid": testId,
        "data-state": "content",
        className: className,
        style: gridStyle,
        ...rest
    }, slots.map((slot)=>{
        const selected = value != null && slot.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: slot.value,
            type: "button",
            onClick: slot.disabled ? undefined : ()=>onSelect?.(slot),
            disabled: slot.disabled,
            "aria-pressed": selected,
            "data-testid": `${testId || 'slot'}-${slot.value}`,
            "data-state": slot.disabled ? 'disabled' : selected ? 'selected' : 'default',
            "data-held": slot.held || undefined,
            className: "tabular-nums",
            style: {
                // ≥ 2.75rem: a time is among the smallest things a thumb has to
                // hit on this screen, and there are dozens of them.
                minHeight: '2.75rem',
                padding: '0.5rem 0.625rem',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                fontSize: '0.8125rem',
                fontWeight: 600,
                cursor: slot.disabled ? 'not-allowed' : 'pointer',
                border: selected ? `2px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent}` : slot.held ? `1.5px dashed ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn}` : `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.14) : slot.held ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                color: selected ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                opacity: slot.disabled ? 0.45 : 1,
                transition: 'background 0.14s, border-color 0.14s'
            }
        }, slot.label);
    }));
}



var $acw62 = parcelRequire("acw62");


'use client';
// Card — the system's surface unit.
//
// With `onClick` it becomes a REAL button (never a `<div onClick>`): callers used
// to wrap it in a `role="button"` div to get keyboard operation and a focus ring
// back, which nested two interactive elements and handed screen readers a control
// inside a control. Those semantics belong here. Pass `role="link"` when the tap
// navigates rather than acts.
const $9169df7fa2fdff01$var$Card = ({ children: children, style: style, onClick: onClick, role: role, disabled: disabled, className: className, ...rest })=>{
    const surface = {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        borderRadius: 16,
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
        ...style
    };
    if (!onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        style: surface,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: role,
        disabled: disabled,
        onClick: onClick,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('outline-none focus-visible:ring-2 focus-visible:ring-ring', className),
        style: {
            ...surface,
            display: 'block',
            width: '100%',
            textAlign: 'inherit',
            font: 'inherit',
            color: 'inherit',
            cursor: disabled ? 'default' : 'pointer',
            transition: 'transform 0.15s, box-shadow 0.15s'
        },
        onMouseDown: (e)=>{
            if (!disabled) e.currentTarget.style.transform = 'scale(0.98)';
        },
        onMouseUp: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        ...rest
    }, children);
};
var $9169df7fa2fdff01$export$2e2bcd8739ae039 = $9169df7fa2fdff01$var$Card;



var $acw62 = parcelRequire("acw62");

'use client';
function $4f942082497afe1e$export$2e2bcd8739ae039({ status: status, style: style }) {
    const cfg = (0, $e7c165fb515b04ea$export$6881c75116d5bd6e)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, cfg.label);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $178f36e6e586ad89$export$2e2bcd8739ae039({ label: label, value: value, unit: unit, icon: icon, bg: bg, accent: accent, loading: loading, minWidth: minWidth = 140, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderRadius: 12,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            flex: 1,
            minWidth: minWidth,
            ...rest.style
        }
    }, icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 44,
            height: 44,
            borderRadius: 12,
            background: bg || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 22,
            fontWeight: 800,
            color: accent || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            whiteSpace: 'nowrap'
        }
    }, loading ? "\u2014" : value), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("wbr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 500,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginInlineStart: 4,
            whiteSpace: 'nowrap'
        }
    }, unit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginTop: 4
        }
    }, label)));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $64626580dc6749e0$export$2e2bcd8739ae039({ stats: stats, loading: loading, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: '12px 32px',
            display: 'flex',
            gap: 12,
            flexShrink: 0,
            overflowX: 'auto',
            ...style
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: s.bg,
                borderRadius: 10,
                padding: '8px 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 20,
                fontWeight: 800,
                color: s.color
            }
        }, loading ? "\u2014" : s.value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                fontWeight: 600,
                color: s.color,
                opacity: 0.75
            }
        }, s.label))));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $ed420e5a4f8c639f$export$2e2bcd8739ae039({ title: title, sub: sub, breadcrumb: breadcrumb, children: children, autoFocus: autoFocus = false, ...rest }) {
    const hasMeta = sub || breadcrumb;
    const titleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!autoFocus) return;
        // `preventScroll`: the heading is already at the top of the page, and
        // scrolling on focus would fight the route change's own scroll reset.
        titleRef.current?.focus({
            preventScroll: true
        });
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: hasMeta ? '14px 32px' : '0 32px',
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            minHeight: 64,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, breadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 3
        }
    }, breadcrumb), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: titleRef,
        // -1: reachable by script, never a stop in the tab order. A heading
        // that took a Tab of its own would be a new obstacle on every page.
        tabIndex: autoFocus ? -1 : undefined,
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: 18,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.2,
            outline: 'none'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, sub)), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);





'use client';
function $3c79ee8367a72d83$export$2e2bcd8739ae039({ onBack: onBack, backLabel: backLabel, title: title, sub: sub, avatar: avatar, status: status, badges: badges, meta: meta, stats: stats, children: children, className: className, 'data-testid': testId, ...rest }) {
    if (backLabel === undefined) backLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().back;
    const metaItems = (meta || []).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            paddingInline: '1.75rem',
            paddingBlock: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            minHeight: '4rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        },
        ...rest
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": testId ? `${testId}-back` : undefined,
        className: "shrink-0 gap-1.5 ps-2 pe-3 text-muted-foreground hover:text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flex: 1,
            minWidth: 0
        }
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        dir: "auto",
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: '1.125rem',
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, title), status, badges), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: '0.1875rem'
        }
    }, sub), metaItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.78125rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, metaItems.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: 3,
                height: 3,
                borderRadius: '50%',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                opacity: 0.6,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, m)))))), (stats?.length || children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        }
    }, stats?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5625rem'
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                minWidth: '4.5rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.375rem',
                borderRadius: 'var(--radius, 0.625rem)',
                textAlign: 'center',
                background: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                border: `1px solid ${s.accent ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 600,
                marginBottom: '0.0625rem',
                color: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, s.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 800,
                letterSpacing: '-0.01em',
                color: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                fontVariantNumeric: 'tabular-nums'
            }
        }, s.value)))), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, children)));
}



var $acw62 = parcelRequire("acw62");

'use client';
const $ca91b548719491bb$var$TopBar = ({ title: title, subtitle: subtitle, onBack: onBack, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            padding: '16px 20px 20px',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onBack,
        style: {
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            borderRadius: 10,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: 'white',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 18 15 12 9 6"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'white',
            fontSize: 18,
            fontWeight: 700
        }
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: 12,
            marginTop: 2
        }
    }, subtitle))), action));
var $ca91b548719491bb$export$2e2bcd8739ae039 = $ca91b548719491bb$var$TopBar;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronLeft", [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Search", [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);







var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayStatStrip — a day's figures as ONE row: the mobile KPI zone of a
// LIST-DOMINANT cockpit (MOBILE_WEB_PWA §4, `StatStrip`), where the list is the
// screen's purpose and the counts only frame it. It replaces 4-up tiles, which
// cost ~100px above the first row.
//
//   «۱۲ نوبت · ۳ منتظر · ۵ انجام · ۱ لغو»                       [end]
//
// Each number carries its semantic ink. A count that has not loaded is «–»,
// never 0 — a zero is a claim. Below 360px the words go and the coloured
// numbers stay; the row keeps a sentence for assistive tech either way.
//
// With `onSelect` each figure is also the FILTER it counts (aria-pressed): the
// clinic desk's status chips and its counts were two rows saying the same
// numbers, and are one here. Without it the row only reads.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.3), PM-0052.
//
// Props:
//   items      — [{ key, value (number|null), label, color? }]
//   loading    — every value reads «–»
//   format     — (n) => string; the caller's digits (default: String)
//   ariaLabel  — the row read as one sentence
//   activeKey / onSelect(key) — makes the figures toggle filters
//   end        — optional trailing node (a money figure, a link)
//   testIdPrefix — default 'reception' → `reception-stats`, `reception-stat-<key>`
//   onDark     — the strip on brand chrome (MobileHeader `figures`, PM-0120): white
//                ink, no surface, no rule — the gradient is the background
// ─────────────────────────────────────────────────────────────────────────────
const $93cce909f7881164$var$useNarrow = ()=>{
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== 'undefined' && window.innerWidth < 360);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const onResize = ()=>setNarrow(window.innerWidth < 360);
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return narrow;
};
function $93cce909f7881164$export$2e2bcd8739ae039({ items: items, loading: loading = false, format: format = (n)=>String(n), ariaLabel: ariaLabel, activeKey: activeKey, onSelect: onSelect, end: end, testIdPrefix: testIdPrefix = 'reception', onDark: onDark = false, style: style }) {
    const narrow = $93cce909f7881164$var$useNarrow();
    const p = testIdPrefix;
    const n = (v)=>loading || v == null ? "\u2013" : format(v);
    const interactive = typeof onSelect === 'function';
    const figure = (it)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 800,
                color: onDark ? 'rgba(255,255,255,0.95)' : it.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
            }
        }, n(it.value)), !narrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 500,
                color: onDark ? 'rgba(255,255,255,0.72)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                marginInlineStart: '0.1875rem'
            }
        }, it.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-stats`,
        style: {
            flexShrink: 0,
            minHeight: interactive ? '2.75rem' : '2.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: onDark ? 0 : '0 0.875rem',
            background: onDark ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            borderBottom: onDark ? 'none' : `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": ariaLabel,
        className: "mobile-strip",
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: interactive ? 'center' : 'baseline',
            gap: interactive ? 0 : '0.375rem',
            overflowX: interactive ? 'auto' : 'hidden',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none'
        }
    }, items.map((it, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: it.key
        }, i > 0 && !interactive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                color: onDark ? 'rgba(255,255,255,0.4)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                fontSize: '0.75rem'
            }
        }, "\xb7"), interactive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "ghost",
            size: "sm",
            "data-testid": `${p}-stat-${it.key}`,
            "aria-pressed": activeKey === it.key,
            "aria-label": `${it.label} ${n(it.value)}`,
            onClick: ()=>onSelect(it.key),
            className: "h-auto min-h-9 shrink-0 rounded-full px-1.5 py-0 font-normal",
            style: {
                fontSize: '0.78125rem',
                background: activeKey === it.key ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)(it.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.14) : 'transparent',
                boxShadow: activeKey === it.key ? `inset 0 0 0 1px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)(it.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.45)}` : 'none'
            }
        }, figure(it)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${p}-stat-${it.key}`,
            "aria-hidden": true,
            style: {
                fontSize: '0.78125rem'
            }
        }, figure(it))))), end ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, end) : null);
}


'use client';
/**
 * MobileHeader — the gradient screen header that is the mobile brand signature
 * (DESIGN-CONCEPT-MOBILE §3.2). Every top-level mobile screen opens with it.
 *
 * Two modes, chosen by the props you pass — never a mode flag:
 *
 *   • **Cockpit** (`user`) — the person's name as a *greeting*, not chrome:
 *     avatar + «خوش آمدید،» + name on the inline-start edge. What a top-level
 *     bottom-nav destination uses.
 *   • **Content screen** (`onBack` + `title`) — a drilled-into full-screen
 *     surface has no bottom nav, so the header itself carries the way back:
 *     back affordance above the screen title, on the same brand chrome rather
 *     than in a separate bar above it (§3.1).
 *   • **Compact** (`compact`) — one 3.75rem row for a WORKSPACE screen, where
 *     the chrome competes with the work (the visit room): icon-only back,
 *     the title and `subtitle` as two short lines beside an optional `avatar`,
 *     then `action`, then `actions`. The title shrinks a step at a time
 *     (0.9375 → 0.75rem) before it ellipsises, so a long name is read rather
 *     than cut. `onTitleClick` makes the identity block a button — the name IS
 *     the way into the record — and `titleActionLabel` says so under it.
 *
 * Both modes render `title` as the page's single `<h1>` (§12.1) and accept
 * `actions` — white-alpha square quick actions ≥2.75rem, the sanctioned way to
 * tint on-gradient chrome (§2.2). A control that navigates nowhere is a defect,
 * so a caller passes an action only when its destination exists.
 *
 * `children` is the optional context-widget row (a date navigator, a filter
 * strip) rendered inside the gradient below the identity row.
 *
 * Props:
 *   title      — screen title; rendered as the page's <h1>
 *   subtitle   — optional line under the title
 *   greeting   — cockpit lead-in above the name (default «خوش آمدید،»)
 *   user       — { name, avatar } → cockpit greeting mode
 *   onBack     — back handler → content mode; renders the «بازگشت» affordance
 *   backLabel  — label for the back affordance (default «بازگشت»)
 *   actions    — [{ key, icon, label, onClick, badge? }] end-side quick actions;
 *                `badge` = { color } renders a small status dot
 *   action     — a single trailing node (shorthand; rendered after `actions`;
 *                in compact mode BEFORE them, so a live control such as the
 *                visit's listen pill sits next to the identity, and «⋯» last)
 *   compact    — the one-row workspace layout (see above)
 *   figures    — compact only (PM-0120): [{ key, value, label, color? }] rendered
 *                as ONE inline row of figures under the identity row, on the
 *                gradient (`DayStatStrip onDark`) — the place a content screen
 *                used to spend four stat tiles and ~200 px on. Hidden when every
 *                value is null and nothing is loading: a row of «–» is not a
 *                glance. `figuresLoading`, `figuresFormat`, `figuresLabel` and
 *                `figuresTestIdPrefix` (→ `<prefix>-stats`) are the strip's own.
 *   avatar     — compact only: `{ name, src }` → a 2rem avatar before the title
 *   leading    — compact only: one node right after the back affordance, in
 *                the header's top inline-START corner (the visit's event bell).
 *                It renders nothing when it has nothing to say, so the slot
 *                costs the title no width until then.
 *   onTitleClick / titleActionLabel — compact only: make the identity block a
 *                button and name its destination under the title
 *   backTestId — override for the back control's `data-testid`. Defaults to
 *                `${testId}-back`; a screen whose selector contract already
 *                names its own back control passes it here rather than
 *                renaming the whole header (which is what an app fork did).
 *   sticky     — pin the header to the top of its scroller. A list destination
 *                whose filter bar lives in `children` needs the bar to stay
 *                reachable while the list scrolls under it (§3.2).
 *   search     — `{ value, onChange, placeholder, clearLabel, onClear, onSubmit,
 *                autoFocus, testId }`. Renders the on-gradient search field that a lookup
 *                screen opens into: a real `<input>` at ≥2.75rem with an inline
 *                clear control, sitting above `children`. Passing it is what
 *                turns a 🔍 quick action into a search surface, so no screen
 *                hand-rolls a white field on the brand chrome again.
 *   children   — optional context-widget row
 *   className / data-testid — forwarded to the root (§15.1)
 */ function $62f4a9fc87ba90f8$var$QuickActions({ actions: actions, testId: testId }) {
    if (!actions?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, actions.map(({ key: key, icon: icon, label: label, onClick: onClick, badge: badge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "ghost",
            size: "icon",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "data-testid": testId ? `${testId}-action-${key}` : undefined,
            className: "min-w-11 min-h-11 text-white hover:bg-white/25",
            style: {
                background: 'rgba(255,255,255,0.14)',
                borderRadius: 'var(--radius, 0.625rem)'
            }
        }, icon), badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                position: 'absolute',
                top: '0.25rem',
                insetInlineEnd: '0.25rem',
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: badge.color,
                border: '1.5px solid rgba(1,94,156,0.9)'
            }
        }))));
}
// The compact title: tries each size in turn and keeps the largest at which
// the text still fits its box, then ellipsises. A patient's full name is the
// one thing on a visit header that must be READ, and a phone gives it ~9rem.
const $62f4a9fc87ba90f8$var$TITLE_SIZES = [
    '0.9375rem',
    '0.875rem',
    '0.8125rem',
    '0.75rem'
];
function $62f4a9fc87ba90f8$var$FitTitle({ children: children, testId: testId }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [step, setStep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = ref.current;
        if (!el) return undefined;
        const fit = ()=>{
            let k = 0;
            el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[0];
            while(k < $62f4a9fc87ba90f8$var$TITLE_SIZES.length - 1 && el.scrollWidth > el.clientWidth + 1){
                k += 1;
                el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[k];
            }
            setStep(k);
        };
        fit();
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
        ro?.observe(el.parentElement || el);
        return ()=>ro?.disconnect();
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: ref,
        dir: "auto",
        "data-testid": testId,
        style: {
            margin: 0,
            minWidth: 0,
            color: '#fff',
            fontWeight: 700,
            lineHeight: 1.25,
            fontSize: $62f4a9fc87ba90f8$var$TITLE_SIZES[step],
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, children);
}
function $62f4a9fc87ba90f8$var$CompactIdentity({ title: title, subtitle: subtitle, avatar: avatar, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, testId: testId }) {
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: avatar.name || title || (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.unknownInitial,
        size: 32,
        bg: "rgba(255,255,255,0.2)",
        src: avatar.src || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            gap: '0.0625rem',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$FitTitle, {
        testId: `${testId}-title`
    }, title), (subtitle || onTitleClick && titleActionLabel) && /* One run of inline text, so a narrow slot ellipsises the whole line
             instead of clipping the hint. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            fontSize: '0.6875rem',
            lineHeight: 1.3,
            color: 'rgba(255,255,255,0.72)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, subtitle, subtitle && onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, " \xb7 "), onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 600
        }
    }, titleActionLabel, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c31db635520dc385$export$2e2bcd8739ae039), {
        size: 11,
        "aria-hidden": true,
        style: {
            display: 'inline-block',
            verticalAlign: '-0.125em',
            marginInlineStart: '0.125rem',
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    })))));
    const layout = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        minWidth: 0,
        flex: 1,
        minHeight: '2.75rem'
    };
    if (!onTitleClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: layout
    }, body);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onTitleClick,
        "aria-label": titleActionLabel ? `${titleActionLabel} \u{2014} ${title}` : title,
        "data-testid": `${testId}-identity`,
        className: "rounded-lg hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60",
        style: {
            ...layout,
            background: 'transparent',
            border: 0,
            padding: '0 0.25rem',
            color: '#fff',
            cursor: 'pointer',
            font: 'inherit'
        }
    }, body);
}
function $62f4a9fc87ba90f8$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, greeting: greeting, user: user, onBack: onBack, backLabel: backLabel, actions: actions = [], action: action, compact: compact = false, figures: figures, figuresLoading: figuresLoading = false, figuresFormat: figuresFormat, figuresLabel: figuresLabel, figuresTestIdPrefix: figuresTestIdPrefix = 'header', avatar: avatar, leading: leading, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, backTestId: backTestId, sticky: sticky = false, search: search, children: children, className: className, style: style, 'data-testid': testId = 'mobile-header', ...rest }) {
    if (greeting === undefined) greeting = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.greeting;
    if (backLabel === undefined) backLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().back;
    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        "data-compact": "",
        style: {
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            padding: 'calc(0.5rem + env(safe-area-inset-top, 0px)) 0.75rem 0.5rem',
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-2.5rem',
            insetInlineEnd: '-1.875rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            minHeight: '2.75rem'
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "min-w-11 min-h-11 shrink-0 text-white/90 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
        size: 20,
        "aria-hidden": true
    })), leading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$CompactIdentity, {
        title: title,
        subtitle: subtitle,
        avatar: avatar,
        onTitleClick: onTitleClick,
        titleActionLabel: titleActionLabel,
        testId: testId
    }), action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    })), figures && (figuresLoading || figures.some((f)=>f.value != null)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93cce909f7881164$export$2e2bcd8739ae039), {
        onDark: true,
        items: figures,
        loading: figuresLoading,
        format: figuresFormat,
        ariaLabel: figuresLabel,
        testIdPrefix: figuresTestIdPrefix,
        style: {
            marginTop: '0.125rem',
            minHeight: '2rem'
        }
    }), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem'
        }
    }, children));
    const hasTrailing = actions.length > 0 || Boolean(action);
    const trailing = hasTrailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    }), action);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 1.5rem',
            // `sticky` keeps the filter bar in `children` reachable while a long
            // list scrolls under it; `relative` is the default so the decorative
            // circles below still clip to the header.
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            // A caller's `style` is MERGED OVER the computed layout, the convention
            // the rest of the kit follows (`Card`, the chat family). It used to fall
            // into `...rest` and — because the spread sits after this attribute —
            // REPLACE the whole object: passing `style` for so much as a
            // `position: sticky` silently deleted the brand gradient, the padding
            // and the safe-area inset, and left white text on a white page.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-1.875rem',
            insetInlineEnd: '-1.875rem',
            width: '8.75rem',
            height: '8.75rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            bottom: '-1.25rem',
            insetInlineStart: '-0.625rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, onBack ? /* Content mode — the way back lives on the brand chrome (§3.1). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "h-auto min-h-11 gap-1.5 ps-0 pe-2 text-white/85 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0.25rem 0 0',
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)) : /* Cockpit mode — greeting (or a bare title) + quick actions (§3.2). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (user || hasTrailing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: user.name || (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.unknownInitial,
        size: 40,
        bg: "rgba(255,255,255,0.2)",
        src: user.avatar || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.6875rem'
        }
    }, greeting), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            color: '#fff',
            fontSize: '0.9375rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, user.name || "\u2026"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: user || hasTrailing ? '0.75rem 0 0' : 0,
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.75rem',
            marginTop: '0.25rem'
        }
    }, subtitle), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, children)));
}
/**
 * The on-gradient search field (§3.2). A real `<input>` — not a kit `TextInput`
 * — because the kit field is painted for a white surface and this one sits on
 * the brand chrome; the shared contract it does keep is the 2.75rem height, the
 * ≥1rem font (anything smaller triggers iOS focus-zoom) and a clear control.
 */ function $62f4a9fc87ba90f8$var$SearchField({ value: value = '', onChange: onChange, onClear: onClear, onSubmit: onSubmit, placeholder: placeholder, clearLabel: clearLabel, autoFocus: autoFocus = false, testId: testId, headerTestId: headerTestId }) {
    if (clearLabel === undefined) clearLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.clear;
    const id = testId || `${headerTestId}-search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        role: "search",
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit?.(value);
        },
        style: {
            marginTop: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.16)',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            paddingInline: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
        size: 17,
        color: "rgba(255,255,255,0.75)",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "search",
        inputMode: "search",
        enterKeyHint: "search",
        autoFocus: autoFocus,
        value: value,
        onChange: (e)=>onChange?.(e.target.value),
        placeholder: placeholder,
        "data-testid": id,
        style: {
            flex: 1,
            minWidth: 0,
            height: '2.75rem',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: '#fff',
            // ≥1rem or iOS zooms the whole page on focus and never zooms back.
            fontSize: '1rem',
            fontFamily: 'inherit'
        }
    }), value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>onClear?.(),
        "aria-label": clearLabel,
        "data-testid": `${id}-clear`,
        className: "min-w-11 min-h-11 text-white/80 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    })) : null);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CalendarDays", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);





'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayContextCard — the context row of a LIST-DOMINANT cockpit's gradient
// header (MOBILE_WEB_PWA §3.2): one white-alpha inset card answering "what am
// I looking at", in two rows.
//
//   line     — the lens: WHERE / WHOSE list this is. The doctor's پذیرش says
//              where the presence schedule puts them («اکنون در کلینیک مهر ·
//              تا ۱۴:۰۰»); the clinic's says whose queue the desk is working
//              («دکتر رضایی · تزریق»). With a choice to make it is the trigger
//              for the caller's picker (`onOpen`); without one it only informs
//              — absent, never disabled.
//   date bar — ‹ day › with the label opening the week sheet. It replaces a
//              navigator + week strip stack that cost ~130px of a phone.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.2) when
// the clinic's phone reception was rebuilt on the same anatomy (PM-0052). The
// card renders; it decides nothing: the sentence, the icon and the picker are
// the caller's.
//
// Props:
//   line        — null | {
//                   icon      lucide component
//                   text      the sentence (already formatted)
//                   hint      optional second, smaller line
//                   pill      optional trailing chip (the lens as it stands)
//                   tone      'warn' | 'muted' | undefined
//                   state     forwarded as data-place-state (tests, styling)
//                   onOpen    makes the row a button that opens a picker
//                   openLabel the button's accessible name
//                   ariaLabel the live region's label (live lines only)
//                   live      announce changes politely (a schedule boundary
//                             flips the sentence once, so it is said once)
//                 }
//   action      — optional node at the END of the lens row, outside its button
//                 (the clinic desk's registry search). On-gradient, ≥2.75rem.
//   dateLabel / isToday / onPrev / onNext / onToday / onOpenWeek
//   labels      — { prevDay, nextDay, today, backToToday, pickDay } (kitCopy defaults)
//   testIdPrefix — default 'reception' → `reception-context`, `-place`,
//                  `-place-open`, `-place-lens`, `-place-hint`, `-datenav`,
//                  `-datenav-prev|pick|today|next`
// ─────────────────────────────────────────────────────────────────────────────
const $9dd7f5e3d401ab69$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $9dd7f5e3d401ab69$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $9dd7f5e3d401ab69$var$rowBase = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    flex: 1,
    minWidth: 0,
    minHeight: '2.75rem',
    padding: '0 0.625rem',
    color: '#fff',
    textAlign: 'start'
};
function $9dd7f5e3d401ab69$export$2e2bcd8739ae039({ line: line, action: action, dateLabel: dateLabel, isToday: isToday, onPrev: onPrev, onNext: onNext, onToday: onToday, onOpenWeek: onOpenWeek, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception', style: style }) {
    const copy = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).dayContext,
        ...labels
    };
    const p = testIdPrefix;
    const Icon = line?.icon;
    const warn = line?.tone === 'warn';
    const muted = line?.tone === 'muted';
    const lineBody = line && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 15,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: warn ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight : '#fff',
            opacity: muted ? 0.7 : 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: '0.78125rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            opacity: muted ? 0.8 : 1
        }
    }, line.text), line.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-hint`,
        style: {
            display: 'block',
            fontSize: '0.65625rem',
            fontWeight: 500,
            color: 'rgba(255,255,255,0.7)'
        }
    }, line.hint)), line.pill && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-lens`,
        style: {
            flexShrink: 0,
            maxWidth: '40%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.2)'
        }
    }, line.pill), line.onOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.75
        }
    }));
    const liveProps = line?.live ? {
        role: 'status',
        'aria-live': 'polite',
        'aria-label': line.ariaLabel ? `${line.ariaLabel}: ${line.text}` : undefined
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-context`,
        style: {
            background: 'rgba(255,255,255,0.12)',
            borderRadius: '0.75rem',
            overflow: 'hidden',
            ...style
        }
    }, line && line.text != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...liveProps,
        "data-testid": `${p}-place`,
        "data-place-state": line.state,
        style: {
            borderBottom: '1px solid rgba(255,255,255,0.14)',
            ...action ? {
                display: 'flex',
                alignItems: 'center'
            } : null
        }
    }, line.onOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        "data-testid": `${p}-place-open`,
        "aria-haspopup": "dialog",
        "aria-label": line.openLabel,
        className: "h-auto justify-start rounded-none font-normal hover:bg-white/10",
        style: $9dd7f5e3d401ab69$var$rowBase,
        onClick: line.onOpen
    }, lineBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9dd7f5e3d401ab69$var$rowBase,
            minHeight: action ? '2.75rem' : '2.25rem',
            paddingBlock: '0.375rem'
        }
    }, lineBody), action ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            paddingInlineEnd: '0.25rem'
        }
    }, action) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-datenav`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-prev`,
        "aria-label": copy.prevDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-pick`,
        "aria-label": onOpenWeek ? `${dateLabel} \u{2014} ${copy.pickDay}` : undefined,
        "aria-haspopup": onOpenWeek ? 'dialog' : undefined,
        className: "h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15",
        onClick: onOpenWeek
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {
        size: 14,
        style: {
            opacity: 0.75
        },
        "aria-hidden": true
    }), dateLabel), isToday ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.24)',
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, copy.today) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-today`,
        className: "h-auto min-h-8 px-2 py-0.5 text-[0.65625rem] font-bold text-white whitespace-nowrap rounded-full hover:bg-white/25",
        style: {
            background: 'rgba(255,255,255,0.18)'
        },
        onClick: onToday
    }, copy.backToToday)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-next`,
        "aria-label": copy.nextDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$NEXT_GLYPH
    }))));
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


// ─────────────────────────────────────────────────────────────────────────────
// What the date picker draws in each UI language.
//
// The picker used to be Persian whatever the page was: an English reception
// desk read «۴ مهر ۱۴۰۵» in a field whose own heading said «Saturday,
// September 26, 2026», and a mistyped date answered «قالب تاریخ: ۱۴۰۴/۰۵/۱۲».
// Everything the picker shows now comes from this table, keyed by the base
// language of `<html lang>` — the channel `MoneyInput` and `PhoneInput` already
// read (see `documentLocale` in money.js). The kit cannot import an app's i18n.
//
// `calendar` is the one entry that is not wording. It matches the calendar each
// app's locale descriptor hands Intl (`intl` in i18n/config.js): Persian and
// Arabic are Jalali (`-u-ca-persian`), English, French and German are Gregorian. The
// picker and the app's own `formatDate` have to agree, or the desk picks one day
// and reads back another. CLDR cannot supply it — it gives `ar` the Gregorian
// calendar, which both apps deliberately override — so it is data here, not
// `resolvedOptions().calendar`.
//
// `months` carries BOTH calendars' names for every language, because a caller
// can pin the calendar (`calendar="jalali"`) on a surface that is Jalali in
// every language — an accounting period is bounded by Jalali months whatever
// the UI language is.
//
// `date` is wording AND word order: DateRangeFilter reads the order of a range
// label off it (day first unless `{month}` leads), never off `calendar` — French
// and German are Gregorian like English and still put the day first; German's
// «{d}.» also gives every day of a range its ordinal dot. `weekStart` is the
// first column of a GREGORIAN grid only; a Jalali grid opens on Saturday in
// every language (JalaliDatePicker.jsx `JALALI.weekStart`).
//
// Adding a language is adding an entry. An unknown one gets Persian, the product
// default, exactly as `documentLocale` falls back — or the brand's default
// language when the brand names one.
//
// A BRAND that names a calendar (`calendar: 'gregory' | 'jalali'`,
// ui/lib/brand.js) moves every language's `calendar` to it, the same switch the
// apps' locale descriptors make, so picker and `formatDate` still agree. A caller
// that pins `calendar` on the picker still wins.
// ─────────────────────────────────────────────────────────────────────────────


// The brand's calendar ids → this table's.
const $0873d4f32691c14e$var$PICKER_CALENDAR = {
    gregory: 'gregorian',
    jalali: 'jalali'
};
const $0873d4f32691c14e$export$4b8e9f545c94f612 = {
    fa: {
        calendar: 'jalali',
        dir: 'rtl',
        digits: "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9",
        // First column of a Gregorian grid; a Jalali grid always opens on شنبه.
        weekStart: 6,
        // Indexed by `Date#getDay()` — 0 is Sunday.
        weekdays: [
            "\u06CC",
            "\u062F",
            "\u0633",
            "\u0686",
            "\u067E",
            "\u062C",
            "\u0634"
        ],
        months: {
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
                "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u06CC\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u06CC\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u06CC",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u0698\u0627\u0646\u0648\u06CC\u0647",
                "\u0641\u0648\u0631\u06CC\u0647",
                "\u0645\u0627\u0631\u0633",
                "\u0622\u0648\u0631\u06CC\u0644",
                "\u0645\u0647",
                "\u0698\u0648\u0626\u0646",
                "\u0698\u0648\u0626\u06CC\u0647",
                "\u0627\u0648\u062A",
                "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
                "\u0627\u06A9\u062A\u0628\u0631",
                "\u0646\u0648\u0627\u0645\u0628\u0631",
                "\u062F\u0633\u0627\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0633\u0627\u0639\u062A {time}",
        strings: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
            selectYear: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0644",
            goToToday: "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
            openCalendar: "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
            time: "\u0633\u0627\u0639\u062A",
            hour: "\u0633\u0627\u0639\u062A",
            minute: "\u062F\u0642\u06CC\u0642\u0647",
            stepUp: "{label} \u0628\u06CC\u0634\u062A\u0631",
            stepDown: "{label} \u06A9\u0645\u062A\u0631",
            now: "\u0627\u06A9\u0646\u0648\u0646",
            confirm: "\u062A\u0627\u06CC\u06CC\u062F"
        },
        errors: {
            format: "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: {example}",
            range: "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            time: "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            noTime: "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
            future: "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A"
        }
    },
    en: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        weekStart: 0,
        weekdays: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        months: {
            // The Latin spellings ICU gives `en-US-u-ca-persian`, so a pinned-Jalali
            // picker and the app's `clinicCalendarIntl` labels name a month the same way.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ]
        },
        date: '{month} {d}, {y}',
        dateTime: '{date}, {time}',
        strings: {
            placeholder: 'Select date',
            selectYear: 'Select year',
            goToToday: 'Go to today',
            clear: 'Clear date',
            openCalendar: 'Show calendar',
            time: 'Time',
            hour: 'Hour',
            minute: 'Minute',
            stepUp: '{label} up',
            stepDown: '{label} down',
            now: 'Now',
            confirm: 'Done'
        },
        errors: {
            format: 'Date format: {example}',
            range: 'Invalid date',
            time: 'Invalid time',
            noTime: 'This field does not take a time',
            future: 'Future dates are not allowed'
        }
    },
    ar: {
        calendar: 'jalali',
        dir: 'rtl',
        // Arabic-Indic, the set the apps' `-u-nu-arab` renders — NOT Persian's.
        digits: "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669",
        weekStart: 6,
        weekdays: [
            "\u062D",
            "\u0646",
            "\u062B",
            "\u0631",
            "\u062E",
            "\u062C",
            "\u0633"
        ],
        months: {
            // The apps' corrected list (`monthNames` on their `ar` descriptor): CLDR's
            // Arabic names for the Persian calendar are not words in any language.
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
                "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u064A\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u064A\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u064A",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u064A\u0646\u0627\u064A\u0631",
                "\u0641\u0628\u0631\u0627\u064A\u0631",
                "\u0645\u0627\u0631\u0633",
                "\u0623\u0628\u0631\u064A\u0644",
                "\u0645\u0627\u064A\u0648",
                "\u064A\u0648\u0646\u064A\u0648",
                "\u064A\u0648\u0644\u064A\u0648",
                "\u0623\u063A\u0633\u0637\u0633",
                "\u0633\u0628\u062A\u0645\u0628\u0631",
                "\u0623\u0643\u062A\u0648\u0628\u0631",
                "\u0646\u0648\u0641\u0645\u0628\u0631",
                "\u062F\u064A\u0633\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0627\u0644\u0633\u0627\u0639\u0629 {time}",
        strings: {
            placeholder: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            selectYear: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0646\u0629",
            goToToday: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            clear: "\u0645\u0633\u062D \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            openCalendar: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
            time: "\u0627\u0644\u0648\u0642\u062A",
            hour: "\u0627\u0644\u0633\u0627\u0639\u0629",
            minute: "\u0627\u0644\u062F\u0642\u064A\u0642\u0629",
            stepUp: "\u0632\u064A\u0627\u062F\u0629 {label}",
            stepDown: "\u0625\u0646\u0642\u0627\u0635 {label}",
            now: "\u0627\u0644\u0622\u0646",
            confirm: "\u062A\u0623\u0643\u064A\u062F"
        },
        errors: {
            format: "\u0635\u064A\u063A\u0629 \u0627\u0644\u062A\u0627\u0631\u064A\u062E: {example}",
            range: "\u062A\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            time: "\u0648\u0642\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            noTime: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0644\u0627 \u064A\u0642\u0628\u0644 \u0648\u0642\u062A\u064B\u0627",
            future: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u062A\u0627\u0631\u064A\u062E \u0645\u0633\u062A\u0642\u0628\u0644\u064A"
        }
    },
    // PM-0185 (D3/D8/D9 = the workspace's docs/locale/FRENCH.md §9): Gregorian like
    // `en`, but day first and Monday first.
    fr: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        // Monday, as French calendars draw a week (CLDR fr firstDay 1, D9). Only the
        // Gregorian grid reads it; the panels' own week strips stay Saturday-first.
        weekStart: 1,
        // Indexed by `Date#getDay()` — 0 is Sunday. Two letters: CLDR's narrow
        // «D L M M J V S» names Tuesday and Wednesday alike.
        weekdays: [
            'Di',
            'Lu',
            'Ma',
            'Me',
            'Je',
            'Ve',
            'Sa'
        ],
        months: {
            // D8: the English UI's spellings, one fixed list — the `monthNames` the apps'
            // French descriptors pass (with `stripEra`) and server text's month names —
            // so picker, formatter and server name a month alike. Not ICU's
            // `fr-u-ca-persian` names (ordibehešt, khordâd …), which differ between ICU builds.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            // Lower case, as French writes them, the calendar's heading included.
            gregorian: [
                'janvier',
                "f\xe9vrier",
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                "ao\xfbt",
                'septembre',
                'octobre',
                'novembre',
                "d\xe9cembre"
            ]
        },
        // What Intl prints for `fr-FR`: «26 septembre 2026», «26 septembre 2026 à 14:30».
        date: '{d} {month} {y}',
        dateTime: "{date} \xe0 {time}",
        strings: {
            placeholder: 'Choisir une date',
            selectYear: "Choisir l\u2019ann\xe9e",
            goToToday: "Aller \xe0 aujourd\u2019hui",
            clear: 'Effacer la date',
            openCalendar: 'Afficher le calendrier',
            time: 'Heure',
            hour: 'Heure',
            minute: 'Minute',
            // `{label}` is `hour` or `minute` above, capitalised — so it leads.
            stepUp: "{label}\xa0: augmenter",
            stepDown: "{label}\xa0: diminuer",
            now: 'Maintenant',
            confirm: 'OK'
        },
        errors: {
            format: "Format de date\xa0: {example}",
            range: 'Date non valide',
            time: 'Heure non valide',
            noTime: "Ce champ n\u2019accepte pas d\u2019heure",
            future: "Les dates futures ne sont pas autoris\xe9es"
        }
    },
    // PM-0212: German follows the French plan — Gregorian like `en`, day first and
    // Monday first, and the day is an ordinal («26. September 2026»).
    de: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        // Monday, as German calendars draw a week (CLDR de firstDay 1, DIN 1355). Only
        // the Gregorian grid reads it; the panels' own week strips stay Saturday-first.
        weekStart: 1,
        // Indexed by `Date#getDay()` — 0 is Sunday. The two-letter forms German
        // calendars print (CLDR `de` short: «So Mo Di Mi Do Fr Sa»).
        weekdays: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa'
        ],
        months: {
            // The English UI's spellings, one fixed list — the `monthNames` the apps'
            // German descriptors pass (with `stripEra`) and server text's month names —
            // as for French (D8), not ICU's `de-u-ca-persian` names.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'Januar',
                'Februar',
                "M\xe4rz",
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
            ]
        },
        // What Intl prints for `de-DE`: «26. September 2026», «26. September 2026 um 14:30».
        // The «.» after `{d}` is the ordinal; DateRangeFilter keeps it on every day.
        date: '{d}. {month} {y}',
        dateTime: '{date} um {time}',
        strings: {
            placeholder: "Datum w\xe4hlen",
            selectYear: "Jahr w\xe4hlen",
            goToToday: 'Zu heute springen',
            clear: "Datum l\xf6schen",
            openCalendar: 'Kalender anzeigen',
            time: 'Uhrzeit',
            hour: 'Stunde',
            minute: 'Minute',
            // `{label}` is `hour` or `minute` above, a capitalised noun — so it leads.
            stepUp: "{label} erh\xf6hen",
            stepDown: '{label} verringern',
            now: 'Jetzt',
            confirm: 'Fertig'
        },
        errors: {
            format: 'Datumsformat: {example}',
            range: "Ung\xfcltiges Datum",
            time: "Ung\xfcltige Uhrzeit",
            noTime: 'Dieses Feld nimmt keine Uhrzeit an',
            future: "Ein Datum in der Zukunft ist nicht zul\xe4ssig"
        }
    }
};
function $0873d4f32691c14e$export$90e478cf5247906b(locale) {
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    const L = $0873d4f32691c14e$export$4b8e9f545c94f612[base] || $0873d4f32691c14e$export$4b8e9f545c94f612[(0, $abf0c103b4b92127$export$879824979a5b153a)('fa')] || $0873d4f32691c14e$export$4b8e9f545c94f612.fa;
    const calendar = $0873d4f32691c14e$var$PICKER_CALENDAR[(0, $abf0c103b4b92127$export$a350347e69c4c055)(null)];
    return !calendar || calendar === L.calendar ? L : {
        ...L,
        calendar: calendar
    };
}
const $0873d4f32691c14e$export$9a328bbde6508c84 = (template, vars)=>String(template).replace(/\{(\w+)\}/g, (m, k)=>k in vars ? String(vars[k]) : m);
const $0873d4f32691c14e$export$545c62727d3740ae = (s, digits)=>String(s).replace(/\d/g, (d)=>digits[d]);


'use client';
// Everything the picker SHOWS — calendar, digits, month and weekday names, its own
// labels and its error messages — follows the page language (`<html lang>`, or the
// `locale` prop), from the table in lib/datePickerLocale.js. Under `en` that means a
// Gregorian, left-to-right calendar; under `fa` and `ar`, the Jalali one. `value` is
// Gregorian 'YYYY-MM-DD' in every language, so no caller changes with the language.
const $d9dd19094c9f758e$var$FA_DIGITS = (0, $0873d4f32691c14e$export$4b8e9f545c94f612).fa.digits;
const $d9dd19094c9f758e$var$pad2 = (n)=>String(n).padStart(2, '0');
// ── Jalali math (works for years 1300–1500) ───────────────────────────────────
function $d9dd19094c9f758e$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $d9dd19094c9f758e$var$jMonthDays(y, m) {
    if (m <= 6) return 31;
    if (m <= 11) return 30;
    return $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29;
}
// Anchor: 1400/01/01 = 2021-03-21 UTC. Works backward too.
function $d9dd19094c9f758e$var$jalaliToMs(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21);
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(jy) ? 30 : 29
    ];
    let doy = jd - 1;
    for(let i = 0; i < jm - 1; i++)doy += md[i];
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    return anchor + (days + doy) * 86400000;
}
function $d9dd19094c9f758e$var$msToJalali(ms) {
    const anchor = Date.UTC(2021, 2, 21);
    let days = Math.floor((ms - anchor) / 86400000);
    let y = 1400;
    if (days >= 0) while(true){
        const diy = $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    else while(days < 0){
        y--;
        days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(m < 11 && days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
// ── The two calendars ─────────────────────────────────────────────────────────
// One shape, so the grids, the parser and the disableFuture rules below exist once
// and never ask which calendar they are drawing. Dates are `{ y, m, d }` with a
// 1-based month; `toMs`/`fromMs` read the day at UTC midnight.
const $d9dd19094c9f758e$var$JALALI = {
    id: 'jalali',
    firstYear: 1300,
    lastYear: 1500,
    weekStart: 6,
    monthDays: $d9dd19094c9f758e$var$jMonthDays,
    toMs: $d9dd19094c9f758e$var$jalaliToMs,
    fromMs: $d9dd19094c9f758e$var$msToJalali
};
const $d9dd19094c9f758e$var$GREGORIAN = {
    id: 'gregorian',
    firstYear: 1921,
    lastYear: 2121,
    weekStart: null,
    monthDays: (y, m)=>new Date(Date.UTC(y, m, 0)).getUTCDate(),
    toMs: (y, m, d)=>Date.UTC(y, m - 1, d),
    fromMs: (ms)=>{
        const t = new Date(ms);
        return {
            y: t.getUTCFullYear(),
            m: t.getUTCMonth() + 1,
            d: t.getUTCDate()
        };
    }
};
const $d9dd19094c9f758e$var$CALENDARS = {
    jalali: $d9dd19094c9f758e$var$JALALI,
    gregorian: $d9dd19094c9f758e$var$GREGORIAN
};
const $d9dd19094c9f758e$var$calendarOf = (id)=>$d9dd19094c9f758e$var$CALENDARS[id] || $d9dd19094c9f758e$var$JALALI;
const $d9dd19094c9f758e$var$todayIn = (cal)=>cal.fromMs(Date.now());
// 'YYYY-MM-DD' → the same day in `cal`.
function $d9dd19094c9f758e$var$valueToDate(cal, str) {
    if (!str || str.length < 10) return null;
    const [y, m, d] = str.split('-').map(Number);
    if (!y || !m || !d) return null;
    return cal.fromMs(Date.UTC(y, m - 1, d));
}
// A day in `cal` → 'YYYY-MM-DD'.
function $d9dd19094c9f758e$var$dateToValue(cal, y, m, d) {
    const dt = new Date(cal.toMs(y, m, d));
    return [
        dt.getUTCFullYear(),
        String(dt.getUTCMonth() + 1).padStart(2, '0'),
        String(dt.getUTCDate()).padStart(2, '0')
    ].join('-');
}
// The locale's data plus the calendar it resolves to — `calendar` pins one.
function $d9dd19094c9f758e$var$resolvePicker(locale, calendar) {
    const L = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale);
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar || L.calendar);
    return {
        L: L,
        cal: cal,
        months: L.months[cal.id],
        weekStart: cal.weekStart ?? L.weekStart,
        num: (n)=>(0, $0873d4f32691c14e$export$545c62727d3740ae)(n, L.digits)
    };
}
function $d9dd19094c9f758e$export$565a3e0423f3fda3(value) {
    const s = String(value || '').trim();
    if (!s) return {
        date: '',
        time: ''
    };
    const [date, rest = ''] = s.split(/[T\s]+/);
    const t = rest.match(/^(\d{1,2}):(\d{1,2})/);
    return {
        date: date,
        time: t ? `${$d9dd19094c9f758e$var$pad2(+t[1])}:${$d9dd19094c9f758e$var$pad2(+t[2])}` : ''
    };
}
function $d9dd19094c9f758e$export$26bc4d93216d514d(raw, { withTime: withTime = false, disableFuture: disableFuture = false, calendar: calendar = 'jalali' } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const s = (0, $42e05640dae453c1$export$e6aa7dbb1e28c5bd)(raw ?? '').replace(/[،,]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return {
        empty: true
    };
    const m = s.match(/^(\d{4})\s*[/\-.]\s*(\d{1,2})\s*[/\-.]\s*(\d{1,2})(?:[ T]+(\d{1,2})\s*[:.]\s*(\d{1,2}))?$/);
    if (!m) return {
        error: 'format'
    };
    const y = +m[1], mo = +m[2], d = +m[3];
    if (y < cal.firstYear || y > cal.lastYear) return {
        error: 'range'
    };
    if (mo < 1 || mo > 12) return {
        error: 'range'
    };
    if (d < 1 || d > cal.monthDays(y, mo)) return {
        error: 'range'
    };
    const hasTime = m[4] !== undefined;
    let hh = 0, mi = 0;
    if (hasTime) {
        if (!withTime) return {
            error: 'noTime'
        };
        hh = +m[4];
        mi = +m[5];
        if (hh > 23 || mi > 59) return {
            error: 'time'
        };
    }
    if (disableFuture) {
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        if (cal.toMs(y, mo, d) > cal.toMs(t.y, t.m, t.d)) return {
            error: 'future'
        };
    }
    const date = $d9dd19094c9f758e$var$dateToValue(cal, y, mo, d);
    return {
        j: {
            y: y,
            m: mo,
            d: d
        },
        hh: hh,
        mi: mi,
        hasTime: hasTime,
        value: withTime ? `${date} ${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}` : date
    };
}
function $d9dd19094c9f758e$export$c715042cb80ca422(value, { withTime: withTime = false, calendar: calendar = 'jalali', digits: digits = $d9dd19094c9f758e$var$FA_DIGITS } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const c = $d9dd19094c9f758e$var$valueToDate(cal, date);
    if (!c) return '';
    const base = `${c.y}/${$d9dd19094c9f758e$var$pad2(c.m)}/${$d9dd19094c9f758e$var$pad2(c.d)}`;
    return (0, $0873d4f32691c14e$export$545c62727d3740ae)(withTime ? `${base} ${time || '00:00'}` : base, digits);
}
const $d9dd19094c9f758e$export$5a5aa410a9e7d978 = (raw, opts = {})=>$d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
        ...opts,
        calendar: 'jalali'
    });
const $d9dd19094c9f758e$export$544b31198dd3053c = (value, { withTime: withTime = false } = {})=>$d9dd19094c9f758e$export$c715042cb80ca422(value, {
        withTime: withTime,
        calendar: 'jalali',
        digits: $d9dd19094c9f758e$var$FA_DIGITS
    });
function $d9dd19094c9f758e$var$buildGrid(cal, y, m, weekStart) {
    const days = cal.monthDays(y, m);
    const offset = (new Date(cal.toMs(y, m, 1)).getUTCDay() - weekStart + 7) % 7;
    const cells = [
        ...Array(offset).fill(null),
        ...Array.from({
            length: days
        }, (_, i)=>i + 1)
    ];
    while(cells.length % 7)cells.push(null);
    const grid = [];
    for(let i = 0; i < cells.length; i += 7)grid.push(cells.slice(i, i + 7));
    return grid;
}
// ── Sub-components ────────────────────────────────────────────────────────────
const $d9dd19094c9f758e$var$NavBtn = ({ onClick: onClick, children: children, disabled: disabled })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov && !disabled ? '#e2e8f0' : '#f0f4f8',
            border: 'none',
            borderRadius: 6,
            width: 28,
            height: 28,
            cursor: disabled ? 'default' : 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: disabled ? '#c8c8c8' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            flexShrink: 0,
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevR = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }));
const $d9dd19094c9f758e$var$ChevL = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $d9dd19094c9f758e$var$GridCell = ({ label: label, selected: selected, current: current, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    let bg = hov && !disabled ? '#e2e8f0' : '#f8fafc';
    let color = disabled ? '#c8c8c8' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    let fw = 400;
    if (selected && !disabled) {
        bg = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        color = 'white';
        fw = 700;
    } else if (current && !disabled) {
        bg = '#EAF4FC';
        color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        fw = 600;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 36,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            fontWeight: fw,
            background: bg,
            color: color,
            transition: 'background 0.12s'
        }
    }, label);
};
const $d9dd19094c9f758e$var$DayCell = ({ day: day, label: label, isToday: isToday, isSel: isSel, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (!day) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    let bg = hov && !disabled ? '#f0f4f8' : 'transparent';
    let color = disabled ? '#d0d0d0' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    let fw = 400;
    if (isSel && !disabled) {
        bg = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        color = 'white';
        fw = 700;
    } else if (isToday) {
        bg = '#EAF4FC';
        color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        fw = 700;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 34,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            background: bg,
            color: color,
            fontWeight: fw,
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            transition: 'background 0.12s'
        }
    }, label);
};
// ‹ label › — earlier on the LEFT and later on the RIGHT in every language. That is
// the reading order under `ltr`, and it is what the RTL picker has always drawn, so
// the row pins its own direction instead of mirroring with the card.
const $d9dd19094c9f758e$var$NavRow = ({ onPrev: onPrev, onNext: onNext, nextDisabled: nextDisabled, marginBottom: marginBottom, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: marginBottom,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onNext,
        disabled: nextDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)));
const $d9dd19094c9f758e$export$9c97d98ce20c6c7a = ({ locale: locale, calendar: calendar, ...rest })=>{
    const picker = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    // Keyed on the calendar: the view state is a year and month IN that calendar, so a
    // language switch that changes calendars starts over rather than reading 1405 as a
    // Gregorian year.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$CalendarBody, {
        key: picker.cal.id,
        picker: picker,
        ...rest
    });
};
const $d9dd19094c9f758e$var$CalendarBody = ({ value: value, onChange: onChange, disableFuture: disableFuture = false, picker: picker })=>{
    const { L: L, cal: cal, months: months, weekStart: weekStart, num: num } = picker;
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d9dd19094c9f758e$var$todayIn(cal), [
        cal
    ]);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day'); // 'day' | 'month' | 'year'
    const [viewY, setViewY] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.y);
    const [viewM, setViewM] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.m);
    const [sel, setSel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const yrRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // scrollable year container
    const yrSelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // selected/current year cell
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (value) {
            const c = $d9dd19094c9f758e$var$valueToDate(cal, value);
            if (c) {
                setSel(c);
                setViewY(c.y);
                setViewM(c.m);
                return;
            }
        }
        setSel(null);
    }, [
        value,
        cal
    ]);
    const changeMonth = (delta)=>{
        let m = viewM + delta, y = viewY;
        if (m > 12) {
            m = 1;
            y++;
        }
        if (m < 1) {
            m = 12;
            y--;
        }
        setViewM(m);
        setViewY(y);
    };
    const enterYearMode = ()=>setMode('year');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (mode !== 'year') return;
        const t = setTimeout(()=>{
            if (yrSelRef.current && yrRef.current) {
                const el = yrSelRef.current;
                const container = yrRef.current;
                container.scrollTop = el.offsetTop - container.clientHeight / 2 + el.clientHeight / 2;
            }
        }, 30);
        return ()=>clearTimeout(t);
    }, [
        mode
    ]);
    const selectDay = (d)=>{
        if (!d) return;
        setSel({
            y: viewY,
            m: viewM,
            d: d
        });
        onChange($d9dd19094c9f758e$var$dateToValue(cal, viewY, viewM, d));
        setMode('day');
    };
    // disableFuture checks
    const yearDisabled = (y)=>disableFuture && y > today.y;
    const monthDisabled = (y, m)=>disableFuture && (y > today.y || y === today.y && m > today.m);
    const dayDisabled = (d)=>{
        if (!disableFuture || !d) return false;
        if (viewY > today.y) return true;
        if (viewY === today.y && viewM > today.m) return true;
        if (viewY === today.y && viewM === today.m && d > today.d) return true;
        return false;
    };
    const grid = $d9dd19094c9f758e$var$buildGrid(cal, viewY, viewM, weekStart);
    const weekdays = Array.from({
        length: 7
    }, (_, i)=>L.weekdays[(weekStart + i) % 7]);
    // Shared header label button style
    const labelBtn = (extra)=>({
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif',
            borderRadius: 6,
            padding: '4px 10px',
            ...extra
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, mode === 'year' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: 10,
            letterSpacing: 1
        }
    }, L.strings.selectYear), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: yrRef,
        style: {
            maxHeight: 240,
            overflowY: 'auto',
            paddingLeft: 2,
            paddingRight: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 4
        }
    }, Array.from({
        length: today.y - cal.firstYear + 1 + (disableFuture ? 0 : 6)
    }, (_, i)=>cal.firstYear + i).map((yr)=>{
        const isFocused = yr === (sel?.y ?? today.y);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: yr,
            ref: isFocused ? yrSelRef : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            label: num(yr),
            selected: sel ? yr === sel.y : false,
            current: yr === today.y,
            disabled: yearDisabled(yr),
            onClick: ()=>{
                setViewY(yr);
                setMode('month');
            }
        }));
    })))), mode === 'month' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 6
        }
    }, months.map((name, idx)=>{
        const mn = idx + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            key: idx,
            label: name,
            selected: !!(sel && sel.y === viewY && sel.m === mn),
            current: viewY === today.y && mn === today.m,
            disabled: monthDisabled(viewY, mn),
            onClick: ()=>{
                setViewM(mn);
                setMode('day');
            }
        });
    }))), mode === 'day' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 4,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 13,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>changeMonth(-1),
        onNext: ()=>changeMonth(1),
        nextDisabled: monthDisabled(viewM === 12 ? viewY + 1 : viewY, viewM === 12 ? 1 : viewM + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setMode('month'),
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        })
    }, months[viewM - 1])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            marginBottom: 10
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginBottom: 4
        }
    }, weekdays.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                textAlign: 'center',
                fontSize: 11,
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                padding: '2px 0'
            }
        }, d))), grid.map((week, wi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: wi,
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: 2
            }
        }, week.map((day, di)=>{
            const isToday = day && viewY === today.y && viewM === today.m && day === today.d;
            const isSel = day && sel && viewY === sel.y && viewM === sel.m && day === sel.d;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$DayCell, {
                key: di,
                day: day,
                label: day ? num(day) : '',
                isToday: isToday,
                isSel: isSel,
                disabled: dayDisabled(day),
                onClick: ()=>selectDay(day)
            });
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setViewY(today.y);
            setViewM(today.m);
        },
        style: {
            marginTop: 12,
            width: '100%',
            height: 32,
            background: '#f8fafc',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.goToToday)));
};
// ── Popup shell ───────────────────────────────────────────────────────────────
// The floating card the calendar sits in, positioned under `anchorRef` (flipping above
// it when the viewport has no room below) and closed by a click anywhere outside both.
// Portaled to <body>: an ancestor with a CSS transform (e.g. a centered DialogContent)
// would otherwise become the containing block of this fixed card and misplace it, and
// an ancestor overflow would clip it. Dialog.jsx whitelists [data-jalali-popup] so the
// portaled card doesn't count as an outside click that dismisses the dialog.
//
// Placement is measured from the card's REAL height, never a guessed constant: the
// calendar is ~380px tall in day mode, so the old `spaceBelow > 320` test opened it
// downward with 60px too little room and the last week of the month fell off the
// bottom of the screen — the exact failure seen with the field low in a tall modal.
// The measured box is then clamped into the viewport on both axes, and re-placed on
// scroll/resize because a field inside a scrollable DialogContent moves under it.
const $d9dd19094c9f758e$var$POPUP_WIDTH = 300;
const $d9dd19094c9f758e$var$POPUP_GAP = 6; // breathing room between the trigger and the card
const $d9dd19094c9f758e$var$POPUP_MARGIN = 8; // never touch the viewport edge
const $d9dd19094c9f758e$export$bb703e6cd16789d6 = ({ anchorRef: anchorRef, onClose: onClose, children: children, width: width = $d9dd19094c9f758e$var$POPUP_WIDTH, locale: locale })=>{
    const cardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The card reads in the language its calendar is drawn in — pass the same `locale`
    // to both, or neither and let both read `<html lang>`.
    const rtl = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale).dir === 'rtl';
    // Positions the card by writing to the DOM node rather than through state: this runs
    // from a ResizeObserver (mode switches change the card's height) and from scroll, and
    // a setState there would re-render → re-measure → re-render without ever settling.
    const place = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const card = cardRef.current;
        const anchor = anchorRef.current;
        if (!card || !anchor) return;
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        const maxH = vh - $d9dd19094c9f758e$var$POPUP_MARGIN * 2;
        // Cap first, measure second — otherwise a card taller than the viewport reports a
        // height no placement can satisfy.
        card.style.maxHeight = `${maxH}px`;
        const h = Math.min(card.offsetHeight || 0, maxH);
        const rect = anchor.getBoundingClientRect();
        const roomBelow = vh - rect.bottom - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        const roomAbove = rect.top - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        // Below by default; flip above only when that side genuinely has more room.
        let top = h <= roomBelow || roomBelow >= roomAbove ? rect.bottom + $d9dd19094c9f758e$var$POPUP_GAP : rect.top - $d9dd19094c9f758e$var$POPUP_GAP - h;
        top = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(top, vh - $d9dd19094c9f758e$var$POPUP_MARGIN - h));
        // The trigger's START edge: right edges align under RTL, left edges under LTR. Then
        // clamp so a trigger near either viewport edge can't push the card off-screen.
        let left = rtl ? rect.right - width : rect.left;
        left = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(left, vw - $d9dd19094c9f758e$var$POPUP_MARGIN - width));
        card.style.top = `${top}px`;
        card.style.left = `${left}px`;
        card.style.visibility = 'visible';
    }, [
        anchorRef,
        width,
        rtl
    ]);
    // Layout effect, before paint: a card positioned after the fact is a card the user
    // sees jump from the corner of the screen to where it belongs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        place();
        const onScroll = ()=>place();
        // capture:true — the scroll that matters is usually an ancestor's (the modal body),
        // and scroll events from those don't bubble to window.
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', place);
        let ro;
        if (typeof ResizeObserver !== 'undefined' && cardRef.current) {
            ro = new ResizeObserver(()=>place());
            ro.observe(cardRef.current);
        }
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
            window.removeEventListener('resize', place);
            ro?.disconnect();
        };
    }, [
        place
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const h = (e)=>{
            if (cardRef.current?.contains(e.target)) return;
            if (anchorRef.current?.contains(e.target)) return; // the trigger toggles itself
            onClose();
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        anchorRef,
        onClose
    ]);
    // A modal Radix dialog locks scrolling with react-remove-scroll, which cancels every
    // `wheel` and `touchmove` that reaches `document` from OUTSIDE the dialog — and this
    // card is portaled out of it. So in «ویرایش بیمار» and every other dialog with a date
    // field the year list (and a card taller than the screen) could not be scrolled by
    // wheel, trackpad or finger, only by dragging a scrollbar (PM-0121). Stopped here they
    // never reach that listener; the card's own scrolling is the browser's and needs
    // nothing more. Passive: nothing here cancels a scroll. The page behind stays locked.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const card = cardRef.current;
        if (!card) return undefined;
        const keep = (e)=>e.stopPropagation();
        card.addEventListener('wheel', keep, {
            passive: true
        });
        card.addEventListener('touchmove', keep, {
            passive: true
        });
        return ()=>{
            card.removeEventListener('wheel', keep);
            card.removeEventListener('touchmove', keep);
        };
    }, []);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cardRef,
        "data-jalali-popup": "",
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            visibility: 'hidden',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            zIndex: 9999,
            width: width,
            background: 'white',
            borderRadius: 16,
            padding: '16px 14px',
            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            direction: rtl ? 'rtl' : 'ltr',
            boxSizing: 'border-box',
            pointerEvents: 'auto'
        }
    }, children), document.body);
};
// ── Time row ──────────────────────────────────────────────────────────────────
// Two spinnable segments under the calendar, shown only when `withTime`. Rendered LTR:
// an "HH:MM" pair inside an RTL paragraph gets its two numeric runs reordered by the
// bidi algorithm, so the minutes would appear where the hours belong.
//
// Steppers, not text boxes, on purpose. The popup is portaled to <body>, so inside a
// modal Radix dialog it sits outside the focus scope and anything focusable in it gets
// focus yanked straight back into the dialog — a text field there could never be typed
// into. Buttons don't need focus to be clicked, and an exact time can always be typed
// into the field itself, which does live inside the dialog.
const $d9dd19094c9f758e$var$StepBtn = ({ onClick: onClick, label: label, children: children })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov ? '#e2e8f0' : 'transparent',
            border: 'none',
            borderRadius: 4,
            width: 26,
            height: 18,
            padding: 0,
            cursor: 'pointer',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevUp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }));
const $d9dd19094c9f758e$var$ChevDn = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 16l6-6-1.41-1.41L12 13.17 7.41 8.59 6 10z"
    }));
const $d9dd19094c9f758e$var$TimeSegment = ({ value: value, onChange: onChange, max: max, step: step, label: label, L: L })=>{
    const wrap = (n)=>(n % (max + 1) + max + 1) % (max + 1);
    const shown = (0, $0873d4f32691c14e$export$545c62727d3740ae)($d9dd19094c9f758e$var$pad2(value), L.digits);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "spinbutton",
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": 0,
        "aria-valuemax": max,
        "aria-valuetext": shown,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.strings.stepUp, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value + step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevUp, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 42,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            background: '#f8fafc',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: 'Meshkat, sans-serif',
            boxSizing: 'border-box',
            userSelect: 'none'
        }
    }, shown), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.strings.stepDown, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value - step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevDn, null)));
};
const $d9dd19094c9f758e$var$TimeRow = ({ hh: hh, mi: mi, onChange: onChange, minuteStep: minuteStep = 5, L: L })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.hour,
        value: hh,
        max: 23,
        step: 1,
        onChange: (h)=>onChange(h, mi)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.minute,
        value: mi,
        max: 59,
        step: minuteStep,
        onChange: (m)=>onChange(hh, m)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>{
            const n = new Date();
            onChange(n.getHours(), Math.floor(n.getMinutes() / minuteStep) * minuteStep);
        },
        style: {
            background: '#f8fafc',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            height: 28,
            padding: '0 10px',
            fontSize: 12,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.now));
// ── Main Component ────────────────────────────────────────────────────────────
// Editable input + the shared calendar. The selected moment lives entirely in `value` —
// the only local copy is `draft`, the half-typed text, which exists exactly while the
// field has focus and is discarded (never committed) if it never parses.
//
// Idle, the field reads «۱۲ مرداد ۱۴۰۴» (English: «August 3, 2025»); focused, it
// becomes the numeric «۱۴۰۴/۰۵/۱۲» («2025/08/03») the parser round-trips. The input is
// dir="ltr" while typed so date and time segments keep their order — bidi reorders two
// numeric runs inside an RTL field.
//
// `locale` (default `<html lang>`) and `calendar` behave as on `JalaliCalendar`.
const $d9dd19094c9f758e$var$JalaliDatePicker = ({ value: value, onChange: onChange, placeholder: placeholder, locale: locale, calendar: calendar, height: height = 44, fontSize: fontSize = 14, disabled: disabled = false, disableFuture: disableFuture = false, withTime: withTime = false, minuteStep: minuteStep = 5, readOnlyInput: readOnlyInput = false, id: // Forwarded to the typeable <input> (v0.16.1), so a FormField label can name it
// (DESIGN_CONCEPT §12.3) and a caller can validate on blur.
id, name: name, onBlur: onBlur, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, 'data-testid': testId })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null ⇒ not typing
    // The error CODE, not its wording — so a language switch re-words a standing error.
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { L: L, cal: cal, months: months, num: num } = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    const rtl = L.dir === 'rtl';
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const sel = date ? $d9dd19094c9f758e$var$valueToDate(cal, date) : null;
    const [hh, mi] = time ? time.split(':').map(Number) : [
        0,
        0
    ];
    const prettyDate = sel ? (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.date, {
        d: num(sel.d),
        month: months[sel.m - 1],
        y: num(sel.y)
    }) : '';
    const prettyVal = sel && withTime && time ? (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.dateTime, {
        date: prettyDate,
        time: num(`${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}`)
    }) : prettyDate;
    // «Date format: 2026/09/26» — the example is today, in the calendar and digits shown.
    const errorText = (()=>{
        if (!error) return '';
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        return (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.errors[error] || L.errors.format, {
            example: num(`${t.y}/${$d9dd19094c9f758e$var$pad2(t.m)}/${$d9dd19094c9f758e$var$pad2(t.d)}`)
        });
    })();
    const editable = !disabled && !readOnlyInput;
    const shownText = draft !== null ? draft : prettyVal;
    // The time a with-time field falls back to when a date arrives without one — by
    // picking or by typing, the same either way. Now, rounded down to the step: 00:00 is
    // almost never the moment someone meant, and the result is visible in the field.
    const fallbackTime = ()=>{
        const now = new Date();
        return `${$d9dd19094c9f758e$var$pad2(now.getHours())}:${$d9dd19094c9f758e$var$pad2(Math.floor(now.getMinutes() / minuteStep) * minuteStep)}`;
    };
    const emitDate = (gregorian)=>{
        if (!gregorian) {
            onChange('');
            return;
        }
        if (!withTime) {
            onChange(gregorian);
            setOpen(false);
            return;
        }
        onChange(`${gregorian} ${time || fallbackTime()}`); // popup stays open for the time
    };
    // Setting a time before a day picks today, so the field can never hold a bare time.
    // The draft is dropped: a modal's focus trap can bounce focus back into the field
    // while the popup is used, and a stale half-typed draft would then hide the new time.
    const emitTime = (h, m)=>{
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        const d = date || $d9dd19094c9f758e$var$dateToValue(cal, t.y, t.m, t.d);
        setDraft(null);
        setError('');
        onChange(`${d} ${$d9dd19094c9f758e$var$pad2(h)}:${$d9dd19094c9f758e$var$pad2(m)}`);
    };
    const handleType = (raw)=>{
        setDraft(raw);
        if (!raw.trim()) {
            setError('');
            if (value) onChange('');
            return;
        }
        const r = $d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
            withTime: withTime,
            disableFuture: disableFuture,
            calendar: cal.id
        });
        if (r.error) {
            setError(r.error);
            return;
        }
        setError('');
        // A date typed with no time keeps the time the field already holds.
        if (withTime && !r.hasTime) onChange(`${r.value.slice(0, 10)} ${time || fallbackTime()}`);
        else onChange(r.value);
    };
    const startEditing = ()=>{
        if (!editable || draft !== null) return;
        setDraft($d9dd19094c9f758e$export$c715042cb80ca422(value, {
            withTime: withTime,
            calendar: cal.id,
            digits: L.digits
        }));
    };
    const commit = ()=>{
        if (draft === null) return;
        setDraft(null); // whatever survived is already in `value`; anything else reverts
        setError('');
    };
    const clearDate = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setDraft(null);
        setError('');
        onChange('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggerRef,
        onMouseDown: (e)=>{
            // Only the box's own padding — the input and the icons handle their own clicks.
            if (disabled || e.target !== e.currentTarget) return;
            if (editable) {
                e.preventDefault();
                inputRef.current?.focus();
                setOpen(true);
            } else setOpen((o)=>!o);
        },
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 12px',
            gap: 6,
            border: `1.5px solid ${error ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : open || draft !== null ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            cursor: disabled ? 'default' : editable ? 'text' : 'pointer',
            background: disabled ? '#f8fafc' : 'white',
            transition: 'border-color 0.18s',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        type: "text",
        id: id,
        name: name,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": ariaInvalid ?? (error ? true : undefined),
        "data-testid": testId,
        // Displayed in the reader's direction, edited LTR. «۱۷ مهر ۱۳۶۹» is
        // number/word/number: under an LTR base the day lands on the far left and the
        // whole thing reads backwards. The typed «۱۳۶۹/۰۷/۱۷ ۱۴:۳۰» is the opposite
        // case — two numeric runs that bidi would swap in an RTL field, putting the
        // minutes where the year belongs.
        dir: draft !== null ? 'ltr' : L.dir,
        value: shownText,
        placeholder: placeholder ?? L.strings.placeholder,
        disabled: disabled,
        readOnly: !editable,
        onFocus: startEditing,
        onClick: ()=>{
            if (disabled) return;
            if (editable) setOpen(true);
            else setOpen((o)=>!o);
        },
        onChange: (e)=>handleType(e.target.value),
        onBlur: (e)=>{
            commit();
            onBlur?.(e);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
                setOpen(false);
                inputRef.current?.blur();
            } else if (e.key === 'Escape') {
                setDraft(null);
                setError('');
                setOpen(false);
            } else if (e.key === 'ArrowDown' && !open) setOpen(true);
        },
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 'none',
            outline: 'none',
            // Pinned to the reader's side, so starting to type does not jump the text.
            background: 'transparent',
            padding: 0,
            textAlign: rtl ? 'right' : 'left',
            fontSize: fontSize,
            fontFamily: 'Meshkat, sans-serif',
            color: shownText ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            cursor: editable ? 'text' : disabled ? 'default' : 'pointer'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0
        }
    }, (sel || draft) && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.clear,
        onMouseDown: clearDate,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 2,
            borderRadius: 4,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.openCalendar,
        onMouseDown: (e)=>{
            e.preventDefault();
            if (!disabled) setOpen((o)=>!o);
        },
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: disabled ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: open ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 5 2 5.9 2 7v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: 11,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, errorText), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$bb703e6cd16789d6, {
        anchorRef: triggerRef,
        onClose: ()=>setOpen(false),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$9c97d98ce20c6c7a, {
        locale: locale,
        calendar: calendar,
        value: date,
        onChange: (v)=>{
            setDraft(null);
            setError('');
            emitDate(v);
        },
        disableFuture: disableFuture
    }), withTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeRow, {
        L: L,
        hh: hh,
        mi: mi,
        minuteStep: minuteStep,
        onChange: emitTime
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(false),
        style: {
            marginTop: 10,
            width: '100%',
            height: 34,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 700,
            color: 'white',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.confirm))));
};
var $d9dd19094c9f758e$export$2e2bcd8739ae039 = $d9dd19094c9f758e$var$JalaliDatePicker;




// ─────────────────────────────────────────────────────────────────────────────
// Jalali weeks over Iran-local ISO dates ('YYYY-MM-DD').
//
// The reception surfaces of the doctor and clinic panels both browse a day at
// a time and a week at a time (`WeekPickerSheet`), and both speak an absolute
// ISO date in the URL or state. The arithmetic is done at UTC noon so neither
// DST nor the browser's own zone can move a day across midnight.
//
// A Jalali week opens on Saturday: شنبه = 0 … جمعه = 6.
// ─────────────────────────────────────────────────────────────────────────────
const $1d28c7ea24194f0d$var$DAY_MS = 86400000;
const $1d28c7ea24194f0d$var$noonMs = (iso)=>Date.parse(`${iso}T12:00:00Z`);
const $1d28c7ea24194f0d$export$c13cab26eb520a22 = (iso, days)=>new Date($1d28c7ea24194f0d$var$noonMs(iso) + days * $1d28c7ea24194f0d$var$DAY_MS).toISOString().split('T')[0];
const $1d28c7ea24194f0d$export$f9f83315c2979a2f = (iso)=>(new Date($1d28c7ea24194f0d$var$noonMs(iso)).getUTCDay() + 1) % 7;
const $1d28c7ea24194f0d$export$4905be222d58a860 = (iso)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(iso, -$1d28c7ea24194f0d$export$f9f83315c2979a2f(iso));
const $1d28c7ea24194f0d$export$6b21eb5279a580dd = (startISO)=>Array.from({
        length: 7
    }, (_, i)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(startISO, i));
const $1d28c7ea24194f0d$export$fa5589c3fde4793c = $1d28c7ea24194f0d$var$noonMs;


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// WeekPickerSheet — week browsing in a bottom sheet, opened from a day bar's
// label (`DayContextCard`). A seven-chip week strip answers a question asked a
// few times a day and costs ~64px on every screen load; the sheet costs none.
//
// Weeks are Jalali, Saturday → Friday, over Iran-local ISO dates, and the sheet
// opens on the week holding the selected day. Each row says what the day holds:
// the caller's `describeDay` line (the doctor: where the schedule puts them)
// and the count of appointments — `·` not counted yet, `—` counted and empty.
// A row described as `off` is muted but still tappable. Picking a day only
// calls `onPick(iso)` — the sheet never navigates.
//
// «تقویم کامل» swaps the body for the month grid (one sheet, two views — no
// stacked sheets) for far jumps.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.4), PM-0052.
//
// Props:
//   open / onClose / selISO / todayISO / onPick(iso)
//   useWeekCounts — a HOOK `(weekStartISO, { enabled }) => [{ iso, count|null }]`
//                   called on every render (pass a stable function); omit it
//                   and the count column stays blank
//   describeDay   — optional `(iso) => null | { text, aria?, off? }`
//   fmt           — { weekday(ms), dayMonth(ms), weekdayDayMonth(ms), number(n) };
//                   defaults use Intl with the Persian calendar
//   labels        — overrides for kitCopy().weekPicker
//   testIdPrefix  — default 'reception' → `reception-week-sheet`, `-week-<iso>`, …
// ─────────────────────────────────────────────────────────────────────────────
const $b3d011a6fde34c03$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $b3d011a6fde34c03$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $b3d011a6fde34c03$var$noCounts = ()=>null;
function $b3d011a6fde34c03$var$defaultFmt(locale) {
    const tag = `${locale || 'fa'}-IR-u-ca-persian`;
    const make = (opts)=>{
        try {
            const f = new Intl.DateTimeFormat(tag, {
                timeZone: 'UTC',
                ...opts
            });
            return (ms)=>f.format(ms);
        } catch  {
            return (ms)=>new Date(ms).toISOString().split('T')[0];
        }
    };
    const nf = (()=>{
        try {
            return new Intl.NumberFormat(tag);
        } catch  {
            return null;
        }
    })();
    return {
        weekday: make({
            weekday: 'long'
        }),
        dayMonth: make({
            day: 'numeric',
            month: 'long'
        }),
        weekdayDayMonth: make({
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        }),
        number: (n)=>nf ? nf.format(n) : String(n)
    };
}
function $b3d011a6fde34c03$export$2e2bcd8739ae039({ open: open, onClose: onClose, selISO: selISO, todayISO: todayISO, onPick: onPick, useWeekCounts: useWeekCounts = $b3d011a6fde34c03$var$noCounts, describeDay: describeDay, fmt: fmtProp, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception' }) {
    const loc = locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const copy = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)(loc).weekPicker,
        ...labels
    };
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            ...$b3d011a6fde34c03$var$defaultFmt(loc),
            ...fmtProp
        }), [
        loc,
        fmtProp
    ]);
    const p = testIdPrefix;
    const [weekStart, setWeekStart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $1d28c7ea24194f0d$export$4905be222d58a860)(selISO));
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('week');
    // Every opening starts on the selected day's week, in the week view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setWeekStart((0, $1d28c7ea24194f0d$export$4905be222d58a860)(selISO));
            setView('week');
        }
    }, [
        open,
        selISO
    ]);
    const days = useWeekCounts(weekStart, {
        enabled: open
    }) || [];
    const countOf = new Map(days.map((d)=>[
            d.iso,
            d.count
        ]));
    const thisWeek = (0, $1d28c7ea24194f0d$export$4905be222d58a860)(todayISO);
    const isoDays = (0, $1d28c7ea24194f0d$export$6b21eb5279a580dd)(weekStart);
    const range = copy.range(fmt.dayMonth((0, $1d28c7ea24194f0d$export$fa5589c3fde4793c)(isoDays[0])), fmt.dayMonth((0, $1d28c7ea24194f0d$export$fa5589c3fde4793c)(isoDays[6])));
    const pick = (iso)=>{
        onClose();
        if (iso) onPick(iso);
    };
    const quick = [
        {
            key: 'this',
            label: copy.thisWeek,
            start: thisWeek
        },
        {
            key: 'next',
            label: copy.nextWeek,
            start: (0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(thisWeek, 7)
        },
        {
            key: 'prev',
            label: copy.prevWeek,
            start: (0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(thisWeek, -7)
        }
    ];
    const footer = view === 'week' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        "data-testid": `${p}-week-calendar`,
        className: "w-full min-h-11 gap-2",
        onClick: ()=>setView('month')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), copy.fullCalendar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        "data-testid": `${p}-week-back`,
        className: "w-full min-h-11",
        onClick: ()=>setView('week')
    }, copy.backToWeek);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: copy.title,
        closeLabel: copy.close,
        footer: footer,
        "data-testid": `${p}-week-sheet`
    }, view === 'month' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$9c97d98ce20c6c7a), {
        value: selISO,
        onChange: (v)=>pick(v)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, quick.map((q)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: q.key,
            variant: weekStart === q.start ? 'default' : 'outline',
            size: "sm",
            "aria-pressed": weekStart === q.start,
            "data-testid": `${p}-week-quick-${q.key}`,
            className: "min-h-9 rounded-full",
            onClick: ()=>setWeekStart(q.start)
        }, q.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-prev`,
        "aria-label": copy.prevWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(s, -7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-week-range`,
        style: {
            flex: 1,
            textAlign: 'center',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, range), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-next`,
        "aria-label": copy.nextWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(s, 7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, isoDays.map((iso)=>{
        const ms = (0, $1d28c7ea24194f0d$export$fa5589c3fde4793c)(iso);
        const desc = describeDay ? describeDay(iso) : null;
        const count = countOf.get(iso);
        const selected = iso === selISO;
        const today = iso === todayISO;
        const off = Boolean(desc?.off);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: iso,
            variant: "ghost",
            "data-testid": `${p}-week-${iso}`,
            "aria-current": selected ? 'date' : undefined,
            "aria-label": [
                fmt.weekdayDayMonth(ms),
                desc?.aria || (desc?.text && desc.text !== "\u2014" ? desc.text : null),
                count != null ? copy.countAria(fmt.number(count)) : null
            ].filter(Boolean).join(" \xb7 "),
            className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-none px-2 py-1.5 font-normal",
            style: {
                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : 'transparent',
                textAlign: 'start'
            },
            onClick: ()=>pick(iso)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '4.5rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.8125rem',
                fontWeight: selected ? 800 : 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
            }
        }, fmt.weekday(ms)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.6875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
            }
        }, fmt.dayMonth(ms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.75rem',
                color: off ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, desc?.text || ''), today && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flexShrink: 0,
                fontSize: '0.625rem',
                fontWeight: 700,
                borderRadius: '1rem',
                padding: '0.0625rem 0.4375rem',
                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.12),
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }
        }, copy.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: '1.75rem',
                flexShrink: 0,
                textAlign: 'center',
                fontSize: '0.875rem',
                fontWeight: 800,
                color: count ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, count == null ? useWeekCounts === $b3d011a6fde34c03$var$noCounts ? '' : "\xb7" : count === 0 ? "\u2014" : fmt.number(count)));
    }))));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);






'use client';
function $336d0c00b1b6b543$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, closeLabel: closeLabel, groups: groups = [], locale: locale, testIdPrefix: testIdPrefix = 'choice' }) {
    const close = closeLabel || (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).close;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: title,
        closeLabel: close,
        "data-testid": `${testIdPrefix}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, groups.filter((g)=>g.options?.length).map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.key,
            "data-testid": `${testIdPrefix}-group-${g.key}`
        }, g.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                margin: '0 0 0.25rem',
                padding: '0 0.25rem',
                fontSize: '0.75rem',
                fontWeight: 800,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
            }
        }, g.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "radiogroup",
            "aria-label": g.label || g.title,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, g.options.map((row)=>{
            const Icon = row.icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                key: row.id,
                variant: "ghost",
                role: "radio",
                "aria-checked": Boolean(row.checked),
                "data-testid": `${testIdPrefix}-option-${row.id}`,
                className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-xl px-2.5 py-2 font-normal",
                style: {
                    background: row.checked ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : 'transparent',
                    textAlign: 'start'
                },
                onClick: ()=>{
                    g.onPick?.(row.id);
                    if (!row.keepOpen) onClose?.();
                }
            }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                style: {
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '0.5rem',
                    flexShrink: 0,
                    display: 'grid',
                    placeItems: 'center',
                    background: row.quiet ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.12),
                    color: row.quiet ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    display: 'block',
                    fontSize: '0.84375rem',
                    fontWeight: 700,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            }, row.name), row.meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'block',
                    fontSize: '0.71875rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    whiteSpace: 'normal'
                }
            }, row.meta)), row.checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true,
                style: {
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                    flexShrink: 0
                }
            }));
        }))))));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $28cc8471170fac89$export$2e2bcd8739ae039({ checked: checked = false, onChange: onChange, disabled: disabled = false, suggested: suggested = false, separated: separated = false, compact: compact = false, title: title, hint: hint = null, labels: labels, locale: locale, testId: testId = 'walkin-toggle', style: style }) {
    const copy = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).walkIn,
        ...labels
    };
    const lead = suggested && !checked && !disabled;
    const ink = checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : lead ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    const border = checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : lead ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border;
    const bg = checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft : lead ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.07) : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface;
    const track = {
        w: compact ? 34 : 40,
        h: compact ? 20 : 22
    };
    const knob = track.h - 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            ...style
        }
    }, separated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-testid": `${testId}-or`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 11.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }), copy.or, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        onClick: ()=>onChange?.(!checked),
        "data-testid": testId,
        "data-suggested": lead ? 'true' : undefined,
        style: {
            position: 'relative',
            width: '100%',
            minHeight: compact ? 44 : 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: compact ? 10 : 12,
            padding: compact ? '6px 12px' : '10px 14px',
            borderRadius: 10,
            border: `1.5px solid ${border}`,
            background: bg,
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            transition: 'background .14s, border-color .14s'
        }
    }, lead && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-badge`,
        style: {
            position: 'absolute',
            top: -9,
            insetInlineEnd: 10,
            padding: '0 8px',
            borderRadius: 999,
            fontSize: 10.5,
            fontWeight: 800,
            lineHeight: '17px',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy}`
        }
    }, copy.suggested), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            minWidth: 0,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: compact ? 13 : 13.5,
            fontWeight: 700,
            color: ink
        }
    }, title), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-hint`,
        style: {
            fontSize: compact ? 11 : 11.5,
            lineHeight: 1.55,
            fontWeight: 500,
            color: checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, hint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'relative',
            flexShrink: 0,
            width: track.w,
            height: track.h,
            borderRadius: 999,
            background: checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .14s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 3,
            width: knob,
            height: knob,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
            insetInlineStart: checked ? track.w - knob - 3 : 3,
            transition: 'inset-inline-start .14s'
        }
    }))));
}




var $acw62 = parcelRequire("acw62");



'use client';
function $5943a0a75dff01a1$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, heightVar: heightVar = '--app-bottom-nav', className: className, 'data-testid': testId = 'bottom-nav', ...rest }) {
    const barRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Publish the real height while this bar is mounted, and clear it when it is
    // not — the bar is absent on full-screen flows, and a stale value there would
    // push floating chrome up over nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = barRef.current;
        if (!el || !heightVar || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(heightVar, `${Math.round(el.offsetHeight)}px`);
        publish();
        // ResizeObserver is absent in jsdom and in older webviews; the one-shot
        // measurement above is already right for them, since what it would catch
        // (a rotation changing the inset, a text-size change) is rare and
        // self-correcting on the next navigation.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(heightVar);
        };
    }, [
        heightVar,
        items.length
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ref: barRef,
        className: className,
        "data-testid": testId,
        "aria-label": (0, $df1b34b618a72512$export$cddd06f8fa3400df)().bottomNav.label,
        style: {
            flexShrink: 0,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-around',
            paddingInline: '0.5rem',
            paddingTop: 0,
            // `max(…)`, not the bare inset: in a browser tab the inset is 0 because
            // the browser's own toolbar occupies that strip, which left the labels
            // sitting on the very edge of the window. The floor gives them the same
            // breathing room the home indicator provides in standalone mode.
            paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 0.25rem)',
            position: 'relative',
            zIndex: 50
        },
        ...rest
    }, items.map((item)=>{
        const isActive = item.key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: item.key,
            variant: "ghost",
            onClick: ()=>onSelect?.(item.key, item),
            "aria-current": isActive ? 'page' : undefined,
            "data-testid": `${testId}-${item.key}`,
            className: "h-auto min-h-11 flex-1 flex-col gap-1 rounded-none py-2 font-medium",
            style: {
                color: isActive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'relative',
                display: 'inline-flex'
            }
        }, item.icon, item.badge != null && item.badge !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testId}-${item.key}-badge`,
            // The count is decoration to the eye and information to a
            // screen reader; without a label it is read as a bare digit
            // beside the destination's name. The caller supplies the
            // sentence because only it knows what is being counted.
            "aria-label": item.badgeLabel,
            style: {
                position: 'absolute',
                top: '-0.25rem',
                insetInlineEnd: '-0.375rem',
                minWidth: '1rem',
                height: '1rem',
                paddingInline: '0.25rem',
                borderRadius: '0.5rem',
                // Tone is the caller's to choose, and the default is NOT the
                // safe one. Red carries "something is wrong"; an unread count
                // is not wrong, it is waiting — the colour budget reserves red
                // for destructive meaning, so a count uses `badgeTone="count"`.
                // ('accent' is the original spelling and still resolves here;
                // it drew navy from the start, and navy is the swatch the
                // whole unread family now agrees on.)
                // The default stays red only because it is what shipped, and
                // changing it silently would restyle callers that meant alarm.
                background: item.badgeTone === 'count' || item.badgeTone === 'accent' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                color: '#fff',
                fontSize: '0.625rem',
                fontWeight: 700,
                lineHeight: '1rem',
                textAlign: 'center'
            }
        }, item.badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: isActive ? 700 : 500
            }
        }, item.label));
    }));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $ea4bc4a14affb445$export$2e2bcd8739ae039({ tiles: tiles = [], loading: loading = false, columns: columns = 4, className: className, 'data-testid': testId = 'stat-tiles', ...rest }) {
    if (!tiles.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": loading ? 'loading' : 'content',
        style: {
            display: 'grid',
            // minmax(0, 1fr) rather than 1fr: a grid track's default `min-width:auto`
            // is its content's minimum, so one long value would push the row past
            // 320px and take the whole page into horizontal scroll (§9).
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: '0.5rem'
        },
        ...rest
    }, tiles.map(({ key: key, label: label, value: value, icon: icon, color: color, solid: solid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ?? label,
            "data-testid": `${testId}-${key ?? label}`,
            style: {
                background: solid ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderRadius: '0.875rem',
                padding: '0.625rem 0.25rem',
                textAlign: 'center',
                boxShadow: solid ? `0 4px 16px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.35)}` : '0 1px 4px rgba(0,0,0,0.06)',
                border: `1px solid ${solid ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                minWidth: 0
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '0.1875rem',
                color: solid ? '#fff' : color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: solid ? '#fff' : color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loading || value == null || value === '' ? "\u2014" : value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.59375rem',
                color: solid ? 'rgba(255,255,255,0.7)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                marginTop: '0.125rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, label))));
}



var $acw62 = parcelRequire("acw62");





'use client';
// ─────────────────────────────────────────────────────────────────────────────
// AccountCard — the block at the foot of the sidebar.
//
// ONE component for the doctor, clinic, dentist and patient panels, each of
// which had hand-rolled its own version: three copies of the پارسه balance card
// that already disagreed about their hex values, and four different answers to
// «چطور از حسابم خارج شوم؟».
//
// ── TWO ZONES, ONE COMPONENT ────────────────────────────────────────────────
// The balance on top, the identity below it, separated by the hairline that was
// already there. Not one merged row: the balance is a number read at a glance
// many times an hour, the identity is a control pressed rarely. The doctor and
// clinic panels independently arrived at this same stacking; this makes it the
// rule rather than a coincidence.
//
// ── THE IDENTITY ROW IS THE MENU TRIGGER ────────────────────────────────────
// The two loose 16px glyphs are gone. A sign-out icon sat one pixel from an
// external-link icon, both unlabelled, and the only thing distinguishing «رفتن
// به حساب» from «خروج» was the shape of a 16px arrow. Now the whole row opens a
// menu whose every destination is named in words.
//
// ── ONE BALANCE: THE SIGNED-IN PERSON'S OWN ─────────────────────────────────
// In the clinic panel there are two pots of money — the clinic's shared pool
// that reception AI spends, and the person's own wallet. This card shows ONLY
// the person's. They are never summed and never offset, and a block labelled
// «حساب من» must not be able to show money that belongs to the clinic. Omit
// `credit` entirely (a receptionist owns no wallet; patients hold no پارسه at
// all) and the zone is not rendered — there is then no number here to be wrong
// about.
//
// ── THE APP FORMATS THE DIGITS ──────────────────────────────────────────────
// `credit.amount` is a STRING the app already localised — Persian digits in fa,
// Latin in en. Same seam as `BottomNav`'s badge: the digit boundary belongs to
// the app, which knows its locale; the kit does not. `credit.level` likewise
// comes from `creditLevel()` in @parsina/framework/tokens, so all four panels
// agree on what «کم» means.
//
// ── SURVIVING THE 68px RAIL ─────────────────────────────────────────────────
// Coin tile and avatar sit in fixed-width cells FIRST in DOM order, so under RTL
// they are rightmost and the collapse — which clips from the inline-end — takes
// only the fading text. Both zones stay operable collapsed, and the menu still
// opens (it is portaled, so the sidebar's `overflow: hidden` cannot slice it).
// Nothing focusable is left painted at zero opacity: the top-up button is not
// rendered at all when collapsed, rather than faded into an invisible tab stop.
//
// Props:
//   user       {name, subtitle?, avatarUrl?}                       — required
//   credit     {amount, level, unit, label, levelLabel, onClick?}  — omit to hide the zone
//   onTopUp    ()=>void  — shows «شارژ اعتبار», expanded + level 'low' only
//   topUpLabel string
//   items      MenuItem[] — {key, label, description?, icon?, href?, external?,
//                            onClick?, tone?, separatorBefore?, 'data-testid'?}
//   collapsed  boolean    — the 68px rail
//   overlay    'auto' | 'menu' | 'sheet'  — auto switches at 768px (DESIGN.md §6:
//              a BottomSheet is the default overlay for a task on mobile; a 236px
//              popover anchored to the bottom edge of a phone is not)
//   menuLabel  string     — accessible name; required, because the trigger's own
//                           visible text is a person's name
// ─────────────────────────────────────────────────────────────────────────────
const $a13c7c62f369d090$var$MINI = 68; // the collapsed rail, and so the width of every icon cell
const $a13c7c62f369d090$var$INSET = 10; // the card's inset from the sidebar edges
const $a13c7c62f369d090$var$NARROW_QUERY = '(max-width: 768px)';
function $a13c7c62f369d090$var$useNarrow(enabled) {
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia($a13c7c62f369d090$var$NARROW_QUERY);
        const sync = ()=>setNarrow(mq.matches);
        sync();
        // `addListener` is the Safari < 14 spelling; both are cheap to support and
        // the patient app is the one that actually meets phones.
        if (mq.addEventListener) mq.addEventListener('change', sync);
        else mq.addListener(sync);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', sync);
            else mq.removeListener(sync);
        };
    }, [
        enabled
    ]);
    return narrow;
}
const $a13c7c62f369d090$var$CoinGlyph = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: size,
        height: size,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7.5v9M9.5 10h5M9.5 14h5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round"
    }));
// Says the press LEAVES this panel. Without it a row that navigates to حساب
// پارسینا reads as a tab that never opens.
const $a13c7c62f369d090$var$ExternalGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "10",
        y1: "14",
        x2: "21",
        y2: "3"
    }));
// ── one menu row, in either presentation ────────────────────────────────────
function $a13c7c62f369d090$var$AccountMenuRow({ item: item, onDone: onDone, compact: compact, testIdBase: testIdBase }) {
    const destructive = item.tone === 'destructive';
    const ink = destructive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    const hover = destructive ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.10) : (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08);
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: compact ? '10px' : '13px 12px',
        minHeight: compact ? 40 : 48,
        border: 'none',
        borderRadius: 9,
        background: 'transparent',
        color: ink,
        textAlign: 'start',
        textDecoration: 'none',
        fontFamily: 'inherit',
        fontSize: 13.5,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background 0.14s'
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            display: 'flex',
            color: destructive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        },
        "aria-hidden": true
    }, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.label), item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: 11,
            fontWeight: 500,
            marginTop: 1,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.description)), item.external && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$ExternalGlyph, null));
    const shared = {
        role: 'menuitem',
        'data-testid': item['data-testid'] || `${testIdBase}-item-${item.key}`,
        style: style,
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = hover;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        }
    };
    // A real <a> when the destination is a URL: it must be focusable, openable in
    // a new tab with the usual modifiers, and readable in the status bar.
    return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...shared,
        href: item.href,
        target: item.target,
        rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: ()=>onDone?.()
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...shared,
        type: "button",
        onClick: ()=>{
            onDone?.();
            item.onClick?.();
        }
    }, body);
}
// ── the balance, in either presentation ─────────────────────────────────────
// A real <a> when `credit.href` is given — the clinic panel's balance points at
// حساب پارسینا, and a link there must be middle-clickable and readable in the
// status bar rather than a button that happens to navigate. A <button> when the
// destination is inside this SPA, so it does not reload the app.
function $a13c7c62f369d090$var$CreditZone({ credit: credit, levelColor: levelColor, isLow: isLow, collapsed: collapsed, fade: fade, testId: testId }) {
    const bg = (hovered)=>isLow ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, hovered ? 0.24 : 0.16) : `rgba(255,255,255,${hovered ? 0.12 : 0.06})`;
    const props = {
        'data-testid': `${testId}-credit`,
        onClick: credit.onClick,
        title: collapsed ? `${credit.label} \u{2014} ${credit.amount} ${credit.unit}` : undefined,
        'aria-label': `${credit.label} \u{2014} ${credit.amount} ${credit.unit}`,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `0 ${$a13c7c62f369d090$var$INSET}px`,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 12,
            padding: 0,
            background: bg(false),
            border: `1px solid ${isLow ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.4) : 'rgba(255,255,255,0.08)'}`,
            cursor: credit.href || credit.onClick ? 'pointer' : 'default',
            fontFamily: 'inherit',
            textAlign: 'start',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'background 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = bg(true);
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = bg(false);
        }
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI - $a13c7c62f369d090$var$INSET * 2,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            padding: '9px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 9,
            flexShrink: 0,
            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)(levelColor, 0.22),
            color: levelColor,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 16
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: $a13c7c62f369d090$var$INSET
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: 10.5,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.5)',
            whiteSpace: 'nowrap'
        }
    }, credit.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            marginTop: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 15,
            fontWeight: 800,
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, credit.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'rgba(255,255,255,0.5)'
        }
    }, credit.unit), credit.levelLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginInlineStart: 'auto',
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: levelColor
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10.5,
            fontWeight: 700,
            color: 'rgba(255,255,255,0.6)'
        }
    }, credit.levelLabel)))));
    return credit.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...props,
        href: credit.href,
        target: credit.target,
        rel: credit.target === '_blank' ? 'noopener noreferrer' : undefined
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...props,
        type: "button"
    }, body);
}
function $a13c7c62f369d090$export$2e2bcd8739ae039({ user: user, credit: credit = null, onTopUp: onTopUp, topUpLabel: topUpLabel, items: items = [], collapsed: collapsed = false, overlay: overlay = 'auto', menuLabel: menuLabel, 'data-testid': testId = 'account-card' }) {
    if (topUpLabel === undefined) topUpLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().account.topUp;
    if (menuLabel === undefined) menuLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().account.menu;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const narrow = $a13c7c62f369d090$var$useNarrow(overlay === 'auto');
    const asSheet = overlay === 'sheet' || overlay === 'auto' && narrow;
    // Collapsing must not leave the menu floating beside a rail that just changed
    // width — the anchor moves 192px under a CSS transition.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOpen(false);
    }, [
        collapsed
    ]);
    const rows = items.filter(Boolean);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    const fade = {
        opacity: collapsed ? 0 : 1,
        pointerEvents: collapsed ? 'none' : 'auto',
        transition: 'opacity 0.16s ease'
    };
    const level = credit?.level || 'ok';
    const levelColor = (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level]?.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal;
    const isLow = level === 'low';
    const rendered = rows.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.key
        }, item.separatorBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "separator",
            style: {
                height: 1,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                margin: '5px 8px'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$AccountMenuRow, {
            item: item,
            onDone: close,
            compact: !asSheet,
            testIdBase: testId
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            flexShrink: 0,
            position: 'relative'
        }
    }, credit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '6px 0 2px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CreditZone, {
        credit: credit,
        levelColor: levelColor,
        isLow: isLow,
        collapsed: collapsed,
        fade: fade,
        testId: testId
    }), onTopUp && isLow && !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `${testId}-topup`,
        onClick: onTopUp,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `6px ${$a13c7c62f369d090$var$INSET}px 0`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            border: 'none',
            borderRadius: 10,
            padding: '7px 0',
            color: '#fff',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 800
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 13
    }), " ", topUpLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": `${testId}-trigger`,
        onClick: ()=>setOpen((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-label": `${menuLabel} \u{2014} ${user?.name || ''}`,
        title: collapsed ? `${menuLabel} \u{2014} ${user?.name || ''}` : undefined,
        style: {
            width: '100%',
            marginTop: credit ? 10 : 0,
            display: 'flex',
            alignItems: 'center',
            padding: '12px 0',
            border: 'none',
            borderTop: '1px solid rgba(255,255,255,0.07)',
            background: open ? 'rgba(255,255,255,0.09)' : 'transparent',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            overflow: 'hidden',
            transition: 'background 0.16s'
        },
        onMouseEnter: (e)=>{
            if (!open) e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        },
        onMouseLeave: (e)=>{
            if (!open) e.currentTarget.style.background = 'transparent';
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: user?.name || '',
        size: 36,
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        src: user?.avatarUrl || undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: '#fff',
            fontSize: 13,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user?.name || "\u2014"), user?.subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: 'rgba(255,255,255,0.42)',
            fontSize: 11,
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user.subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "15",
        height: "15",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: open ? '#fff' : 'rgba(255,255,255,0.45)',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.18s, color 0.18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "18 15 12 9 6 15"
    })))), asSheet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        title: menuLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menu",
        "aria-label": menuLabel,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, rendered)) : // 'top': this card is the LAST thing in the sidebar, so a menu opening
    // downward would render off the bottom of the viewport.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        anchorRef: triggerRef,
        ariaLabel: menuLabel,
        placement: "top",
        width: 236,
        "data-testid": `${testId}-menu`
    }, rendered));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $dd795e2724b3b1d0$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, ariaLabel: ariaLabel, className: className, 'data-testid': testId = 'section-nav', ...rest }) {
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Keep the selected section in view: a strip long enough to scroll can put
    // the active item off-screen (or half-clipped at an edge) after a tap, a
    // route restore, or a rotation.
    //
    // Feature-detected, not assumed: `scrollIntoView` does not exist in jsdom and
    // is missing from some old webviews, and an unguarded call there throws from
    // inside an effect — which unmounts the whole record rather than merely
    // failing to centre a tab. Centring is a convenience; rendering is not.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = activeRef.current;
        if (typeof el?.scrollIntoView !== 'function') return;
        el.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "tablist",
        "aria-label": ariaLabel,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            flexShrink: 0,
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        },
        ...rest
    }, items.map(({ key: key, label: label, icon: icon })=>{
        const on = key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: key,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `${testId}-${key}`,
            onClick: ()=>onSelect?.(key, {
                    key: key,
                    label: label,
                    icon: icon
                }),
            className: "h-auto min-h-11 shrink-0 flex-col gap-0.5 rounded-none px-3.5 py-2 hover:bg-transparent",
            style: {
                color: on ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy}` : '2.5px solid transparent'
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                display: 'inline-flex'
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
}



var $acw62 = parcelRequire("acw62");




'use client';
/**
 * DateNavigator — the mobile day stepper (DESIGN-CONCEPT-MOBILE §4): prev/next
 * arrows around a TAPPABLE day label that opens the kit `JalaliCalendar` in a
 * `BottomSheet`. It is the mobile counterpart of the desktop header's
 * `JalaliDatePicker`, and it exists because §4 says arrow-stepping must never
 * be the ONLY path to a date — a doctor looking at next Tuesday should not
 * press an arrow five times.
 *
 * `variant="onGradient"` is the §3.2 "white-alpha inset card": the context
 * widget that lives INSIDE `MobileHeader`'s gradient.
 *
 * Every label is a prop and none is defaulted to Persian. The kit has no
 * translator, the calendar formatting stays with the app (the same rule
 * `TimeRuler.formatTick` and `ChatDayDivider.label` follow), and this component
 * is used by an app that ships in two languages.
 *
 * Props:
 *   value / onChange  — Gregorian 'YYYY-MM-DD', like every kit date component
 *   dateLabel         — the day, formatted by the caller (Jalaali under fa)
 *   subLabel          — optional second line, shown only when `isToday`
 *   isToday           — drives the «back to today» affordance
 *   onPrev / onNext / onToday
 *   prevLabel / nextLabel / pickLabel / todayLabel / sheetTitle — all required
 *                       in practice; they are this component's whole copy
 *   variant           — 'onGradient' (default) | 'plain'
 *   className / data-testid — forwarded to the root
 */ const $e0ac3bcac665682a$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $e0ac3bcac665682a$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
function $e0ac3bcac665682a$export$2e2bcd8739ae039({ value: value, onChange: onChange, dateLabel: dateLabel, subLabel: subLabel, isToday: isToday = true, onPrev: onPrev, onNext: onNext, onToday: onToday, prevLabel: prevLabel, nextLabel: nextLabel, pickLabel: pickLabel, todayLabel: todayLabel, sheetTitle: sheetTitle, closeLabel: closeLabel, variant: variant = 'onGradient', className: className, 'data-testid': testId = 'date-navigator', ...rest }) {
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onGradient = variant === 'onGradient';
    const arrowClass = onGradient ? 'min-w-11 min-h-11 text-white hover:bg-white/25' : 'min-w-11 min-h-11';
    const arrowStyle = onGradient ? {
        background: 'rgba(255,255,255,0.12)',
        borderRadius: '0.5rem'
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            background: onGradient ? 'rgba(255,255,255,0.12)' : 'transparent',
            borderRadius: '0.75rem',
            padding: '0.375rem 0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.375rem'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-prev`,
        "aria-label": prevLabel,
        title: prevLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-pick`,
        "aria-label": pickLabel,
        className: onGradient ? 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15' : 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold',
        onClick: ()=>setPickerOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $beb58fc2118025b6$export$2e2bcd8739ae039), {
        size: 14,
        style: {
            opacity: 0.7
        },
        "aria-hidden": true
    }), dateLabel), isToday ? subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: onGradient ? 'rgba(255,255,255,0.6)' : undefined,
            fontSize: '0.6875rem'
        }
    }, subLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-today`,
        className: onGradient ? 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold text-white/85 hover:bg-transparent hover:text-white' : 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold',
        onClick: onToday
    }, todayLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-next`,
        "aria-label": nextLabel,
        title: nextLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7979593adeba180b$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        title: sheetTitle || pickLabel,
        closeLabel: closeLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$9c97d98ce20c6c7a), {
        value: value,
        onChange: (v)=>{
            setPickerOpen(false);
            if (v) onChange?.(v);
        }
    }), !isToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        className: "mt-3 w-full min-h-11",
        "data-testid": `${testId}-sheet-today`,
        onClick: ()=>{
            setPickerOpen(false);
            onToday?.();
        }
    }, todayLabel)));
}



var $acw62 = parcelRequire("acw62");





'use client';
function $a1c3a031457b1019$export$2e2bcd8739ae039({ onSave: onSave, onCancel: onCancel, saving: saving = false, saved: saved = false, disabled: disabled = false, sticky: sticky = false, saveLabel: saveLabel, cancelLabel: cancelLabel, savedLabel: savedLabel, className: className, style: // Merged OVER the computed layout, the `Card`/messaging-family precedent
// (DESIGN.md). It used to arrive through `...rest`, which is spread after
// `style` — so a caller adding one padding value silently deleted `display`,
// `position` and the safe-area inset and took the whole bar's layout with it.
style, 'data-testid': testId = 'savebar', ...rest }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().saveBar;
    if (saveLabel === undefined) saveLabel = copy.save;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    if (savedLabel === undefined) savedLabel = copy.saved;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": saving ? 'saving' : saved ? 'saved' : 'idle',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginTop: '1.75rem',
            ...sticky && {
                position: 'sticky',
                bottom: 0,
                marginTop: '1rem',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                padding: '0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                zIndex: 5
            },
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        onClick: onSave,
        disabled: saving || disabled,
        "data-testid": `${testId}-submit`
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 16,
        thickness: 2,
        color: "currentColor"
    }), saved && !saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), saved && !saving ? savedLabel : saveLabel), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onCancel,
        disabled: saving,
        "data-testid": `${testId}-cancel`
    }, cancelLabel));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $5f9cbffc25828c55$export$2e2bcd8739ae039({ n: n, title: title, sub: sub, icon: Icon, children: children, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...rest,
        style: {
            background: '#fff',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 18,
            boxShadow: '0 1px 2px rgba(22,39,61,.04), 0 8px 24px rgba(22,39,61,.05)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 13,
            padding: '18px 22px 0'
        }
    }, n != null && n !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            width: 30,
            height: 30,
            borderRadius: '50%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            color: '#fff',
            fontWeight: 800,
            fontSize: 14,
            display: 'grid',
            placeItems: 'center'
        }
    }, n), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 16,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 17,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
    }), title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, sub))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 22px 22px',
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ChevronUp", [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
]);




'use client';
function $82e7212e133be19c$export$2e2bcd8739ae039({ columns: columns = [], rows: rows = [], rowKey: rowKey, onRowClick: onRowClick, onRowActivate: onRowActivate, rowProps: rowProps, empty: empty, loading: loading = false, skeletonRows: skeletonRows = 6, dense: dense = false, ariaLabel: ariaLabel, caption: caption, sort: sort, onSort: onSort, ...rest }) {
    const rowH = dense ? 44 : 52;
    // Logical, not physical. `'end'` used to resolve to `left`, which is the end
    // of an RTL row and the START of an LTR one — so a numeric column aligned to
    // the wrong edge the moment a table rendered in English.
    const alignOf = (a)=>a === 'center' ? 'center' : a === 'end' ? 'end' : 'start';
    const isEmpty = !loading && rows.length === 0;
    // Placeholder block widths for the loading body, derived from the REAL
    // column widths so a cell's block sits where that column's content will.
    // Without this the blocks cycled a generic width list, and a 70px status
    // column drew a 120px block that the <th> then clipped — the one thing a
    // skeleton exists to avoid. A column with no declared width (the flexible
    // ones, usually the name) keeps the generic rhythm; a percentage width is
    // relative to a table whose pixel size we do not know here, so it falls
    // back too. 60% of the column, because a cell is content plus padding.
    const skeletonWidths = columns.map((col, i)=>{
        const w = col.width;
        const px = typeof w === 'number' ? w : typeof w === 'string' && /^\d+(\.\d+)?px$/.test(w) ? parseFloat(w) : null;
        if (px == null) return [
            120,
            96,
            110,
            84
        ][i % 4];
        return Math.max(32, Math.round(px * 0.6));
    });
    const activate = onRowActivate || null;
    const interactive = !!(activate || onRowClick);
    const headerCell = (col)=>{
        if (!col.sortable || !onSort) return col.header;
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onSort(key),
            className: "inline-flex items-center gap-1 bg-transparent border-0 p-0 cursor-pointer text-inherit hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded",
            style: {
                fontSize: 'inherit',
                fontWeight: 'inherit',
                fontFamily: 'inherit'
            },
            "data-active": active ? 'true' : undefined
        }, col.header, active ? sort.dir === 'asc' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": loading ? 'loading' : isEmpty ? 'empty' : 'content',
        "aria-busy": loading ? 'true' : undefined,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "aria-label": caption ? undefined : ariaLabel,
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 13.5
        }
    }, caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        style: {
            captionSide: 'top',
            textAlign: 'start',
            padding: '0 14px 8px',
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, caption), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, columns.map((col)=>{
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: col.key,
            scope: "col",
            "aria-sort": !col.sortable || !onSort ? undefined : active ? sort.dir === 'asc' ? 'ascending' : 'descending' : 'none',
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                fontWeight: 700,
                fontSize: 12.5,
                textAlign: alignOf(col.align),
                padding: '10px 14px',
                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                width: col.width,
                whiteSpace: 'nowrap'
            }
        }, headerCell(col));
    }))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: skeletonRows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8bbcb87f63697989), {
            key: i,
            cols: columns.length,
            widths: skeletonWidths,
            dense: dense
        }))), !loading && !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row, i)=>{
        const extra = rowProps ? rowProps(row, i) || {} : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowKey ? rowKey(row, i) : row.id ?? i,
            onClick: interactive ? ()=>(activate || onRowClick)(row) : undefined,
            // Hover and focus are CSS states. The onMouseEnter/onMouseLeave
            // pair this replaces mutated inline styles — which §1.3 forbids,
            // and which left a row stuck highlighted whenever the pointer
            // left during a re-render.
            className: interactive ? 'transition-colors hover:bg-muted focus-visible:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring' : undefined,
            ...activate ? {
                tabIndex: 0,
                role: 'link',
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        activate(row);
                    }
                }
            } : null,
            ...extra,
            style: {
                height: rowH,
                cursor: interactive ? 'pointer' : 'default',
                ...extra.style
            }
        }, columns.map((col)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: col.key,
                style: {
                    textAlign: alignOf(col.align),
                    padding: '8px 14px',
                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    verticalAlign: 'middle'
                }
            }, col.render ? col.render(row, i) : row[col.key])));
    })))), isEmpty && empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, empty) : null);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $24dfcaee8d76ee07$export$2e2bcd8739ae039({ options: options = [], value: value, onChange: onChange, size: size = 'md', semantics: semantics = 'tabs', ariaLabel: ariaLabel, ...rest }) {
    const h = size === 'lg' ? 44 : size === 'sm' ? 32 : 36;
    const isFilter = semantics === 'filter';
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const move = (delta)=>{
        const enabled = options.filter((o)=>!o.disabled);
        if (!enabled.length) return;
        const at = enabled.findIndex((o)=>o.value === value);
        const next = enabled[(at + delta + enabled.length) % enabled.length];
        if (next) onChange?.(next.value);
    };
    const onKeyDown = (e)=>{
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key)) return;
        e.preventDefault();
        if (e.key === 'Home' || e.key === 'End') {
            const enabled = options.filter((o)=>!o.disabled);
            const target = e.key === 'Home' ? enabled[0] : enabled[enabled.length - 1];
            if (target) onChange?.(target.value);
            return;
        }
        // Direction from the DOM, not an assumption: the visual "next" option is on
        // the left in an RTL group and on the right in an LTR one.
        const rtl = ref.current ? getComputedStyle(ref.current).direction === 'rtl' : true;
        const forward = rtl ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
        move(forward ? 1 : -1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        ref: ref,
        role: isFilter ? 'radiogroup' : 'tablist',
        "aria-label": ariaLabel,
        onKeyDown: onKeyDown,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, options.map((opt)=>{
        const active = opt.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            role: isFilter ? 'radio' : 'tab',
            ...isFilter ? {
                'aria-checked': active
            } : {
                'aria-selected': active
            },
            // Roving tabindex: the group is ONE tab stop and the arrows move
            // inside it. Without this every option is its own stop, so tabbing
            // past a six-option filter takes six presses.
            tabIndex: active ? 0 : -1,
            disabled: opt.disabled,
            "data-state": active ? 'active' : 'inactive',
            onClick: ()=>!opt.disabled && onChange?.(opt.value),
            className: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
            style: {
                height: h,
                padding: size === 'sm' ? '0 12px' : '0 16px',
                border: 'none',
                cursor: opt.disabled ? 'not-allowed' : 'pointer',
                borderRadius: 9,
                fontSize: size === 'sm' ? 12.5 : 13.5,
                fontWeight: 700,
                fontFamily: 'inherit',
                background: active ? '#fff' : 'transparent',
                color: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                boxShadow: active ? '0 1px 3px rgba(22,39,61,.12)' : 'none',
                opacity: opt.disabled ? 0.5 : 1,
                transition: 'all .15s',
                whiteSpace: 'nowrap'
            }
        }, opt.label);
    }));
}



var $acw62 = parcelRequire("acw62");



'use client';
// The page's own numerals — the digit set the date picker draws for `<html lang>`.
const $7bca3244df749c49$var$pageNum = (n)=>(0, $0873d4f32691c14e$export$545c62727d3740ae)(String(Math.trunc(Number(n))), (0, $0873d4f32691c14e$export$90e478cf5247906b)().digits);
function $7bca3244df749c49$export$2e2bcd8739ae039({ page: page = 1, pageCount: pageCount, total: total, pageSize: pageSize = 20, onChange: onChange, prevLabel: prevLabel, nextLabel: nextLabel, pageLabel: pageLabel, formatNumber: formatNumber = $7bca3244df749c49$var$pageNum }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().pager;
    if (prevLabel === undefined) prevLabel = copy.prev;
    if (nextLabel === undefined) nextLabel = copy.next;
    if (pageLabel === undefined) pageLabel = copy.page;
    const pages = pageCount ?? Math.max(1, Math.ceil((total || 0) / pageSize));
    if (pages <= 1) return null;
    const go = (p)=>{
        if (p >= 1 && p <= pages && p !== page) onChange?.(p);
    };
    const btn = (label, target, disabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>go(target),
            disabled: disabled,
            style: {
                minWidth: 34,
                height: 34,
                padding: '0 10px',
                borderRadius: 9,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: '#fff',
                cursor: disabled ? 'default' : 'pointer',
                color: disabled ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                fontFamily: 'inherit',
                fontSize: 13,
                opacity: disabled ? 0.5 : 1
            }
        }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: '12px 0'
        }
    }, btn(prevLabel, page - 1, page <= 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontWeight: 600,
            padding: '0 6px'
        }
    }, pageLabel(formatNumber(page), formatNumber(pages))), btn(nextLabel, page + 1, page >= pages));
}



var $acw62 = parcelRequire("acw62");



'use client';
function $ab3d370aebf1b917$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, confirmLabel: confirmLabel, cancelLabel: cancelLabel, destructive: destructive = false, loading: loading = false, confirmDisabled: confirmDisabled = false, onConfirm: onConfirm, children: children, confirmTestId: confirmTestId, cancelTestId: cancelTestId, ...rest }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().confirm;
    if (confirmLabel === undefined) confirmLabel = copy.confirm;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
        size: "sm",
        showClose: false,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$742513523b177e3b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$16f7638e4a34b909), null, title)), typeof description === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "text-sm text-muted-foreground leading-6"
    }, description) : description || null, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "mt-4"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
        className: "mt-6 flex gap-2 justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: destructive ? 'destructive' : 'default',
        disabled: loading || confirmDisabled,
        onClick: onConfirm,
        "data-testid": confirmTestId
    }, confirmLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        disabled: loading,
        autoFocus: true,
        onClick: ()=>onOpenChange?.(false),
        "data-testid": cancelTestId
    }, cancelLabel))));
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inline alert / callout banner (zone ②). Tokened bg/ink per variant — never raw hex.
 *
 * Props:
 *   variant  — 'info' | 'success' | 'warning' | 'error' | 'neutral'
 *   title    — optional bold lead line
 *   icon     — optional leading lucide node
 *   action   — optional trailing node (e.g. a Button)
 *   children — body content
 */ const $35331361c3270146$var$VARIANT = {
    info: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    success: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    warning: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    error: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
    },
    neutral: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
    }
};
function $35331361c3270146$export$2e2bcd8739ae039({ variant: variant = 'info', title: title, icon: icon, action: action, children: children, style: style, ...rest }) {
    const v = $35331361c3270146$var$VARIANT[variant] || $35331361c3270146$var$VARIANT.info;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: v.bg,
            color: v.ink,
            padding: '11px 16px',
            borderRadius: 12,
            fontSize: 13,
            ...style
        }
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            marginBottom: children ? 4 : 0
        }
    }, title), children), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, action));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("TriangleAlert", [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
]);





'use client';
function $3cbee9b1abdcb86a$export$2e2bcd8739ae039({ icon: icon, title: title, description: description, onRetry: onRetry, retryLabel: retryLabel, fill: fill = false, style: style, ...rest }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorState;
    if (title === undefined) title = copy.title;
    if (retryLabel === undefined) retryLabel = copy.retry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": "error",
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-flex',
            marginBottom: 16,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
        size: 44
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 16
        }
    }, description), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onRetry
    }, retryLabel));
}



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a user is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • sizes and weights are the documented type roles (hero / metric / body /
//     caption). The kit cannot import an app's `type` module, so the values are
//     inlined with the role named beside them — never a size chosen for this
//     component alone,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $46e1ac2ff7a7c6a8$var$TONES = {
    neutral: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight
        }),
    danger: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $46e1ac2ff7a7c6a8$var$DISC = 56;
// The documented type roles, at their default-setting values. The kit cannot
// import an app's `constants/typography`, so the scale is restated here rather
// than sizes being invented per component — spread it exactly as an app spreads
// `type.*`, and the two surfaces stay identical.
const $46e1ac2ff7a7c6a8$var$TYPE = {
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    body: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1.85
    },
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    }
};
function $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($46e1ac2ff7a7c6a8$var$TONES[tone] || $46e1ac2ff7a7c6a8$var$TONES.neutral)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // user was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: fullscreen ? '100vw' : '100%',
            height: fullscreen ? '100vh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: '2rem 1.25rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            padding: '2.5rem 2rem 2rem',
            maxWidth: '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $46e1ac2ff7a7c6a8$var$DISC,
            height: $46e1ac2ff7a7c6a8$var$DISC,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.metric,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.body,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46e1ac2ff7a7c6a8$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the user decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $46e1ac2ff7a7c6a8$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $46e1ac2ff7a7c6a8$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $46e1ac2ff7a7c6a8$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adc6ced7fde9e43e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("OctagonAlert", [
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
            key: "1fd625"
        }
    ]
]);




'use client';
class $10231e94a06472aa$export$7583e06808a373a5 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Keep the component stack. `error.stack` points at the component that
        // threw, not the tree that rendered it — and for a shared primitive
        // (Button, Card) the latter is the only part identifying WHICH screen is
        // broken.
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack);
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({
            error: null
        });
    }
    reset = ()=>this.setState({
            error: null
        });
    render() {
        if (!this.state.error) return this.props.children;
        return this.props.renderFallback(this.state.error, this.reset);
    }
}
function $10231e94a06472aa$export$2e2bcd8739ae039({ children: children, resetKey: resetKey, title: title, body: body, retryLabel: retryLabel, showRetry: showRetry = true, actions: actions = [], footer: footer, fullscreen: fullscreen = false, onError: onError, testId: testId = 'error-boundary' }) {
    if (title === undefined) title = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorBoundary.title;
    if (body === undefined) body = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorBoundary.body;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorBoundary.retry;
    const renderFallback = (error, reset)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039), {
            testId: testId,
            tone: "danger",
            fullscreen: fullscreen,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $adc6ced7fde9e43e$export$2e2bcd8739ae039), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: title,
            body: body,
            // The message, not the stack: a user cannot read a stack, and the message
            // is the part that lets support reproduce it. The stack is in the console
            // for whoever goes looking.
            detail: error?.message || String(error),
            actions: [
                ...showRetry ? [
                    {
                        key: 'retry',
                        label: retryLabel,
                        onClick: reset,
                        variant: 'primary',
                        testId: `${testId}-retry`
                    }
                ] : [],
                ...actions
            ],
            footer: footer
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($10231e94a06472aa$export$7583e06808a373a5, {
        resetKey: resetKey,
        renderFallback: renderFallback,
        onError: onError
    }, children);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $29b392183a56ed0d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CloudOff", [
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193",
            key: "yfwify"
        }
    ],
    [
        "path",
        {
            d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07",
            key: "jlfiyv"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("RefreshCw", [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b144e577f231bbf4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Wifi", [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $31bc6c20417221be$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("WifiOff", [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 5.17-2.69",
            key: "1dl1wf"
        }
    ],
    [
        "path",
        {
            d: "M19 12.859a10 10 0 0 0-2.007-1.523",
            key: "4k23kn"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 4.177-2.643",
            key: "1grhjp"
        }
    ],
    [
        "path",
        {
            d: "M22 8.82a15 15 0 0 0-11.288-3.764",
            key: "z3jwby"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
]);





var $acw62 = parcelRequire("acw62");
// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $1ca1f567c505cbd8$var$listeners = new Set();
function $1ca1f567c505cbd8$export$288ba6b4215d30f3(listener) {
    $1ca1f567c505cbd8$var$listeners.add(listener);
    return ()=>$1ca1f567c505cbd8$var$listeners.delete(listener);
}
function $1ca1f567c505cbd8$export$87a8bdb1d0a966cf() {
    for (const listener of $1ca1f567c505cbd8$var$listeners)try {
        listener();
    } catch  {}
}
function $1ca1f567c505cbd8$export$d433e139d37a5376() {
    $1ca1f567c505cbd8$var$listeners.clear();
}


// ─────────────────────────────────────────────────────────────────────────────
// Is the app actually able to reach its backend?
//
// The app had no answer to this at all. A doctor whose Wi-Fi dropped mid-clinic
// saw each screen fail on its own schedule, each with its own error card, none
// of them saying the one thing that explained all of them — and nothing told
// them when it came back, so the habit became "refresh and hope".
//
// `navigator.onLine` alone is not the answer, and the direction of its error
// matters. It is RELIABLE when false (the OS says there is no route to
// anywhere) and near-worthless when true (it means "an interface is up", which
// a captive portal, an expired hotel Wi-Fi login, a VPN drop and a firewall all
// satisfy while dropping every packet to the BFF). So:
//
//   offline  — the browser says so. Trusted immediately, no probe needed.
//   degraded — the browser says we are online but the BFF is not answering.
//              Only entered from real evidence: a request that actually failed,
//              confirmed by a probe. This is the state that catches the captive
//              portal, and it is why a bare `navigator.onLine` hook was not
//              enough.
//   online   — reachable.
//
// The probe is deliberately cheap and deliberately rare: it only runs while
// something is known to be wrong, or once when the browser says the network
// came back. It never polls a healthy connection — a heartbeat that fires all
// day to detect a condition that lasts seconds is a battery cost paid by every
// doctor to benefit none of them.
// ─────────────────────────────────────────────────────────────────────────────
/** The browser's own verdict. Reliable when true, worthless when false — see above. */ const $2a96b0bae45a4311$var$isBrowserOffline = ()=>typeof navigator !== 'undefined' && navigator.onLine === false;
const $2a96b0bae45a4311$export$cd9c3c6bf535afc9 = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline'
};
// Backoff for the recovery probe while disconnected. Starts brisk — most
// outages are a few seconds of a lift or a dead spot, and the doctor should not
// wait a minute to be told they are back — then eases off so a genuinely long
// outage is not a request every two seconds for twenty minutes.
const $2a96b0bae45a4311$var$PROBE_MIN_MS = 3000;
const $2a96b0bae45a4311$var$PROBE_MAX_MS = 30000;
// The probe budget. Much shorter than a real query's: this asks one question
// ("is anything there?") and a slow answer is a no for our purposes.
const $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS = 5000;
/**
 * Ask the BFF whether it is reachable.
 *
 * Sends the smallest legal GraphQL request rather than hitting a health path:
 * the BFF has no unauthenticated health endpoint, and this way the probe
 * traverses exactly the path real queries do — same origin, same proxy, same
 * TLS. Any HTTP response at all counts as reachable, INCLUDING 400 and 401: the
 * question is whether packets arrive, not whether we are welcome. Treating a
 * 401 as "offline" would put a network banner in front of a user whose session
 * simply expired, which is a different problem with different copy.
 */ async function $2a96b0bae45a4311$var$probeBff(url, signal) {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: '{__typename}'
            }),
            signal: signal,
            cache: 'no-store'
        });
        return Boolean(res);
    } catch  {
        return false;
    }
}
function $2a96b0bae45a4311$export$a32c5b7f472865fb({ url: url } = {}) {
    const [state, setState] = (0, $acw62.useState)(()=>$2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE);
    // Was the connection ever lost in this session? Drives the transient «اتصال
    // برقرار شد» confirmation — without it, the banner would announce a recovery
    // to every doctor who simply opened the app.
    const [recovered, setRecovered] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)(null);
    const backoffRef = (0, $acw62.useRef)($2a96b0bae45a4311$var$PROBE_MIN_MS);
    const abortRef = (0, $acw62.useRef)(null);
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const clearTimer = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const goOnline = (0, $acw62.useCallback)(()=>{
        backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
        clearTimer();
        setState((prev)=>{
            if (prev !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) setRecovered(true);
            return $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE;
        });
    }, []);
    /**
   * Run one probe now and schedule the next if it fails.
   *
   * Exposed as `check` so a failed real request can hand its evidence over
   * rather than making the hook discover the same outage independently.
   */ const check = (0, $acw62.useCallback)(async ()=>{
        if ($2a96b0bae45a4311$var$isBrowserOffline()) {
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
            return false;
        }
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const timeout = setTimeout(()=>controller.abort(), $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS);
        const reachable = url ? await $2a96b0bae45a4311$var$probeBff(url, controller.signal) : true;
        clearTimeout(timeout);
        if (reachable) {
            goOnline();
            return true;
        }
        // Re-read the authoritative signal at the moment of the verdict rather than
        // trusting the state we entered with: a probe can outlive the condition that
        // started it, and an in-flight request that resolves after the interface
        // genuinely dropped must not downgrade a true OFFLINE to DEGRADED.
        //
        // The reverse matters more, and is the case the test pins: once the browser
        // reports online again, a failing probe means DEGRADED — there IS a network,
        // the BFF is just not on the other end of it. Keeping OFFLINE sticky here
        // would have described a captive portal as "no internet", which sends the
        // doctor to look at a router that is working perfectly.
        setState($2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED);
        clearTimer();
        timerRef.current = setTimeout(check, backoffRef.current);
        backoffRef.current = Math.min(backoffRef.current * 2, $2a96b0bae45a4311$var$PROBE_MAX_MS);
        return false;
    }, [
        goOnline,
        url
    ]);
    /**
   * Report a request that just failed for transport reasons.
   *
   * The distinction that makes this hook trustworthy: we do NOT go straight to
   * `degraded` on one failed request. A single 502 from one flaky upstream is
   * not a connectivity problem, and telling the doctor their connection is down
   * when one panel failed would train them to ignore the banner — which is the
   * whole asset here. The probe is what turns a suspicion into a claim.
   */ const reportFailure = (0, $acw62.useCallback)(()=>{
        if (stateRef.current === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
    }, [
        check
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>{
            // No probe: the browser is authoritative in this direction, and firing a
            // request at a machine with no route just burns a timeout.
            clearTimer();
            abortRef.current?.abort();
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        };
        // …and NOT authoritative in the other. 'online' means an interface came up,
        // which a captive portal satisfies. Confirm before claiming recovery.
        const handleOnline = ()=>{
            backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
            check();
        };
        // Coming back to a backgrounded tab is the other moment worth checking: a
        // laptop that slept through a network change reports nothing, and the first
        // thing the doctor does is read a screen full of stale data.
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible' && stateRef.current !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
        };
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        document.addEventListener('visibilitychange', handleVisibility);
        // The evidence `navigator.onLine` cannot give us: a real request that just
        // failed at the transport layer.
        const unsubscribe = (0, $1ca1f567c505cbd8$export$288ba6b4215d30f3)(reportFailure);
        // A tab that BOOTS offline never fires an event — it was already in that
        // state — so the initial value has to stand on its own, and it does.
        if ($2a96b0bae45a4311$var$isBrowserOffline()) setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        return ()=>{
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubscribe();
            clearTimer();
            abortRef.current?.abort();
        };
    }, [
        check,
        reportFailure
    ]);
    return {
        state: state,
        isOnline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE,
        isOffline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE,
        isDegraded: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED,
        recovered: recovered,
        acknowledgeRecovery: (0, $acw62.useCallback)(()=>setRecovered(false), []),
        check: check,
        reportFailure: reportFailure
    };
}
var $2a96b0bae45a4311$export$2e2bcd8739ae039 = $2a96b0bae45a4311$export$a32c5b7f472865fb;



'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one place the app says «you are not connected».
//
// Without one, a dropped connection produces N independent error cards, one per
// panel, each blaming itself, none of them explaining the others — and no signal
// at all when it comes back, so the user's only strategy is to refresh and see.
//
// Deliberate choices:
//
//   It is a BAR, not a modal or a toast. A modal would block a doctor from
//   reading the notes already on screen, which are still perfectly good and are
//   the most valuable thing in the room during an outage. A toast would vanish
//   while the condition persisted. A bar states an ongoing fact and lets work
//   continue around it.
//
//   It sits at the top and pushes content down rather than floating over it.
//   Overlaying would cover the page header on every screen — which in a
//   clinical app is often the patient's name, not something to hide.
//
//   Recovery is announced ONCE and then disappears on its own. A permanent
//   «متصل» is chrome nobody reads; the useful signal is the transition, and
//   specifically the moment a user can stop wondering whether their last save
//   went through.
// ─────────────────────────────────────────────────────────────────────────────
const $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS = 4000;
const $0790d8ae08647dfa$var$VARIANTS = {
    [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).OFFLINE]: {
        Icon: (0, $31bc6c20417221be$export$2e2bcd8739ae039),
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
        fg: '#fff',
        testId: 'connectivity-offline'
    },
    [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).DEGRADED]: {
        Icon: (0, $29b392183a56ed0d$export$2e2bcd8739ae039),
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
        // Amber is a light hue; white on it fails contrast. `CT.warnInk` is the
        // ink the kit already pairs with a warning surface — a hand-mixed brown
        // here is how a second, slightly-off warning colour enters a design system.
        fg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk,
        testId: 'connectivity-degraded'
    }
};
function $0790d8ae08647dfa$export$2e2bcd8739ae039({ state: state, recovered: recovered, onAcknowledgeRecovery: onAcknowledgeRecovery, onRetry: onRetry, busy: busy, offlineLabel: offlineLabel, degradedLabel: degradedLabel, restoredLabel: restoredLabel, retryLabel: retryLabel, busyLabel: busyLabel }) {
    if (offlineLabel === undefined) offlineLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.offline;
    if (degradedLabel === undefined) degradedLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.degraded;
    if (restoredLabel === undefined) restoredLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.restored;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.retry;
    if (busyLabel === undefined) busyLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.busy;
    const disconnected = state !== (0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).ONLINE;
    const LABELS = {
        [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).OFFLINE]: offlineLabel,
        [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).DEGRADED]: degradedLabel
    };
    // The recovery bar retires itself. The timer is keyed on the flag so a second
    // outage inside the window restarts it rather than inheriting a stale
    // countdown that would hide the confirmation early.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!recovered || disconnected) return undefined;
        const timer = setTimeout(()=>onAcknowledgeRecovery?.(), $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS);
        return ()=>clearTimeout(timer);
    }, [
        recovered,
        disconnected,
        onAcknowledgeRecovery
    ]);
    if (disconnected) {
        const variant = $0790d8ae08647dfa$var$VARIANTS[state];
        if (!variant) return null;
        const { Icon: Icon, bg: bg, fg: fg, testId: testId } = variant;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
            bg: bg,
            fg: fg,
            testId: testId,
            state: state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 15,
            strokeWidth: 2.2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, LABELS[state]), onRetry && // The kit Button at `sm`, not a hand-rolled pill. It sits on a
        // coloured bar rather than the page, so `currentColor` carries the
        // bar's ink through — the only thing the variants cannot know — and
        // height, radius, type, focus ring and disabled state all come from
        // the kit like every other button.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            size: "sm",
            variant: "ghost",
            onClick: onRetry,
            disabled: busy,
            "data-testid": "connectivity-retry",
            style: {
                marginInlineStart: 'auto',
                color: fg,
                border: '1px solid currentColor',
                background: 'transparent',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8a800148d042d893$export$2e2bcd8739ae039), {
            size: 12,
            "aria-hidden": true,
            style: busy ? {
                animation: 'connectivity-spin 0.9s linear infinite'
            } : undefined
        }), busy ? busyLabel : retryLabel));
    }
    if (recovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
        fg: "#fff",
        testId: "connectivity-restored",
        state: "restored"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b144e577f231bbf4$export$2e2bcd8739ae039), {
        size: 15,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, restoredLabel));
    return null;
}
function $0790d8ae08647dfa$var$Bar({ bg: bg, fg: fg, testId: testId, state: state, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-connection-state": state,
        role: "status",
        // `polite`, not `assertive`. A user mid-sentence must not have their
        // screen reader interrupted by an infrastructure notice — the connection
        // dropping is not more urgent than what they are writing.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.4375rem 1rem',
            background: bg,
            color: fg,
            fontSize: '0.75rem',
            fontWeight: 600,
            flexShrink: 0,
            zIndex: 40
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, '@keyframes connectivity-spin { to { transform: rotate(360deg) } }'), children);
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Square icon-only button with a ≥44px touch target (mobile-safe) and a required
 * accessible label. `onGradient` variant is the white-alpha control for gradient
 * headers (§3.2). Encapsulates the affordance so screens never hand-roll a raw <button>.
 *
 * Props:
 *   icon     — lucide node (required)
 *   label    — accessible label / tooltip (required)
 *   variant  — 'default' | 'ghost' | 'outline' | 'onGradient'
 *   size     — px (default 44 — the mobile minimum)
 *   onClick, disabled
 */ const $26386601b5f40a7d$var$VARIANT = {
    default: {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        color: '#fff',
        border: 'none'
    },
    ghost: {
        background: 'transparent',
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
        border: 'none'
    },
    outline: {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
    },
    onGradient: {
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: 'none'
    }
};
function $26386601b5f40a7d$export$2e2bcd8739ae039({ icon: icon, label: label, onClick: onClick, variant: variant = 'default', size: size = 44, disabled: disabled = false, style: style, ...rest }) {
    const v = $26386601b5f40a7d$var$VARIANT[variant] || $26386601b5f40a7d$var$VARIANT.default;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ...rest,
        onClick: onClick,
        disabled: disabled,
        "aria-label": label,
        title: label,
        style: {
            width: size,
            height: size,
            minWidth: size,
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            flexShrink: 0,
            fontFamily: 'inherit',
            ...v,
            ...style
        }
    }, icon);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Plus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
]);



'use client';
function $9b6fb81a56105b0d$export$2e2bcd8739ae039({ label: label, icon: icon, onClick: onClick, minHeight: minHeight = 118, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        style: {
            width: '100%',
            minHeight: minHeight,
            padding: 16,
            background: 'transparent',
            border: `1.5px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            cursor: 'pointer',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            fontFamily: 'inherit',
            fontWeight: 700,
            fontSize: 14,
            ...style
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
        size: 22
    }), label);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $0d47a2201c3cd6a9$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, disabled: disabled = false, label: label, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "switch",
        "aria-checked": checked,
        "aria-disabled": disabled,
        "aria-label": label,
        onClick: ()=>{
            if (!disabled) onChange?.(!checked);
        },
        style: {
            width: 44,
            height: 24,
            borderRadius: 4,
            flexShrink: 0,
            position: 'relative',
            cursor: disabled ? 'not-allowed' : 'pointer',
            background: checked ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .25s',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 3,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            right: checked ? 3 : 23,
            transition: 'right .25s'
        }
    }));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $2358e3acbc4a7e55$export$2e2bcd8739ae039({ title: title, badge: badge, defaultOpen: defaultOpen = false, open: controlledOpen, onOpenChange: onOpenChange, children: children, style: style }) {
    const [uncontrolled, setUncontrolled] = (0, $acw62.useState)(defaultOpen);
    const open = controlledOpen !== undefined ? controlledOpen : uncontrolled;
    const toggle = ()=>{
        const next = !open;
        if (onOpenChange) onOpenChange(next);
        if (controlledOpen === undefined) setUncontrolled(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: toggle,
        "aria-expanded": open,
        style: {
            width: '100%',
            minHeight: 44,
            padding: '14px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700,
            fontSize: 14.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6
        }
    }, title, badge != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            fontSize: 12
        }
    }, badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
        size: 18,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        style: {
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s'
        }
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: 8
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");



'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PrizeWheel — a wheel of fortune: N equal slices that spin and stop on one.
//
// Domain-free on purpose. The kit draws a circle and turns it; it knows nothing
// about prizes, wallets, campaigns or Parseh. The caller hands it the slices it
// should print and the slice it should land on, and is told when the wheel has
// stopped.
//
//   segments     [{ index, label }] in index order — position i IS slice i.
//                Labels arrive FORMATTED: Persian digits go through the app's
//                own digit seam (rule 7), never through the kit.
//   targetIndex  the winning slice, or null while nobody knows it yet. The
//                SERVER picks it; the wheel only animates to it.
//   spinning     whether the wheel should be turning. With a target but no
//                spin the wheel sits AT the result — that is how an already
//                spun draw is re-shown without replaying the animation.
//   onSettled    fired once, when the spin has stopped.
//   size         pixel diameter (it still shrinks to its container).
//
// ── Geometry ────────────────────────────────────────────────────────────────
// One 400×400 viewBox, so every number below is a user unit and the whole wheel
// scales with `size` — including the label type, which is why the labels do not
// need a second size prop. Slice i runs from `i·step − 90°` (SVG angles start
// at 3 o'clock and grow clockwise, so −90° is 12 o'clock) clockwise by one
// step. A label is rotated onto its slice's mid-angle and flipped 180° through
// the bottom half of the wheel, because a label that is merely rotated is
// upside down for half the circle.
//
// ── Motion ──────────────────────────────────────────────────────────────────
// ONE CSS transition on the slice group: θ = 5 full turns + (360 − the centre
// angle of the winning slice), so the slice's middle finishes under the pointer
// at 12 o'clock. The turns accumulate, so a wheel that is spun twice keeps
// turning the same way instead of unwinding.
//
// **Clockwise whatever the document's direction is.** Rule 8 is about layout
// and about content that carries direction; a wheel has neither. What the eye
// tracks is the pointer, and an RTL page that spun the other way would read as
// a different mechanism, not as a mirrored one.
//
// `prefers-reduced-motion: reduce` removes the transition (the BottomSheet /
// Dialog / Skeleton pattern: a media query in the kit's own stylesheet), so the
// wheel JUMPS to its result. `transitionend` then never fires — hence the
// timer, which is the real settle signal and the transition's is the early one.
// Whichever arrives first wins; `onSettled` is called exactly once per spin.
//
// ── Colour ──────────────────────────────────────────────────────────────────
// Four brand tones, cycled, with the label ink flipped against them so both
// pass contrast. The inks are `C.card` on the two filled tones and
// `var(--panel-ink)` on the two tints — the panel's deep ink rather than
// `CT.accentInk`, because an accent preset may NOT re-tint `--panel-ink`
// (tokens.css) while it does re-tint `--p-navy-dark`: under the فیروزه‌ای preset
// `accentInk` on a tint falls to ~3.9:1, and `--panel-ink` holds above 11:1
// under every preset and every panel.
// ─────────────────────────────────────────────────────────────────────────────
const $c173fca63c358943$var$CX = 200;
const $c173fca63c358943$var$CY = 200;
const $c173fca63c358943$var$R_SLICE = 190; // the coloured slices
const $c173fca63c358943$var$R_RIM = 196; // the white rim they sit on
const $c173fca63c358943$var$R_LABEL = 128; // where a slice prints its label
const $c173fca63c358943$var$R_HUB = 34; // the white hub cap
const $c173fca63c358943$var$R_HUB_INNER = 22;
const $c173fca63c358943$var$R_PIP = 9;
const $c173fca63c358943$var$TURNS = 5;
const $c173fca63c358943$var$SPIN_MS = 4000;
const $c173fca63c358943$var$SPIN_EASE = 'cubic-bezier(0.17, 0.67, 0.12, 1)';
// The transition's own `transitionend` is the early signal; this is the one
// that is always sent. The grace covers the frame between committing the
// rotation and the browser starting to paint it.
const $c173fca63c358943$var$SETTLE_GRACE_MS = 200;
const $c173fca63c358943$var$REDUCED_SETTLE_MS = 50;
const $c173fca63c358943$var$FILLS = [
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight,
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark,
    (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
];
const $c173fca63c358943$var$INKS = [
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
    'var(--panel-ink)',
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
    'var(--panel-ink)'
];
const $c173fca63c358943$var$DISC_CSS = `
  [data-prize-disc] { transform-origin: ${$c173fca63c358943$var$CX}px ${$c173fca63c358943$var$CY}px; }
  [data-prize-disc][data-spinning="true"] { transition: transform ${$c173fca63c358943$var$SPIN_MS}ms ${$c173fca63c358943$var$SPIN_EASE}; }
  @media (prefers-reduced-motion: reduce) {
    [data-prize-disc][data-spinning="true"] { transition: none !important; }
  }
`;
// One stylesheet for every wheel on the page: React 19 hoists a <style> with
// `href` + `precedence` into <head> once (the Skeleton family does the same).
const $c173fca63c358943$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-prize-wheel",
        precedence: "default"
    }, $c173fca63c358943$var$DISC_CSS);
// Reduced motion, read in JS — only to choose how long to wait for a spin that
// the media query above has already cancelled. Defensive like the clinical
// module's `prefersInstant()`: with no window and no `matchMedia` there is no
// animation to wait for either, so "reduced" is the safe answer.
function $c173fca63c358943$var$prefersReducedMotion() {
    if (typeof window === 'undefined') return true;
    if (typeof window.matchMedia !== 'function') return true;
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return true;
    }
}
const $c173fca63c358943$var$pol = (deg, r)=>{
    const t = deg * Math.PI / 180;
    return [
        $c173fca63c358943$var$CX + r * Math.cos(t),
        $c173fca63c358943$var$CY + r * Math.sin(t)
    ];
};
// The angle the disc must come to rest at, from zero, for slice `index` of
// `count` to face the pointer: whole turns for the show, then back to the
// slice's own middle.
function $c173fca63c358943$var$angleFor(index, count) {
    const step = 360 / count;
    return $c173fca63c358943$var$TURNS * 360 + (360 - (index * step + step / 2));
}
function $c173fca63c358943$export$2e2bcd8739ae039({ segments: segments = [], targetIndex: targetIndex = null, spinning: spinning = false, onSettled: onSettled, size: size = 320, label: // Rule 7: the app passes its own; unset, the kit's word in `<html lang>`.
label, className: className, style: style, ...rest }) {
    if (label === undefined) label = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().prizeWheel.label;
    const slices = Array.isArray(segments) ? segments : [];
    const count = slices.length;
    const step = count > 0 ? 360 / count : 0;
    const target = Number.isInteger(targetIndex) && targetIndex >= 0 && targetIndex < count ? targetIndex : null;
    const spin = Boolean(spinning) && target != null;
    const [rotation, setRotation] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // The live callback, so a caller that passes a fresh closure every render
    // does not re-arm the timer mid-spin.
    const onSettledRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onSettled);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onSettledRef.current = onSettled;
    });
    // The armed settle, shared with `transitionend`; null when no spin is running.
    const settleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (target == null) {
            setRotation(0);
            return;
        }
        // Drop the fraction of a turn the disc is already at, then add whole turns:
        // the rotation only ever grows, so the wheel never runs backwards.
        setRotation((prev)=>prev - prev % 360 + $c173fca63c358943$var$angleFor(target, count));
    }, [
        target,
        count
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!spin) return undefined;
        let fired = false;
        const fire = ()=>{
            if (fired) return;
            fired = true;
            onSettledRef.current?.();
        };
        settleRef.current = fire;
        const timer = setTimeout(fire, $c173fca63c358943$var$prefersReducedMotion() ? $c173fca63c358943$var$REDUCED_SETTLE_MS : $c173fca63c358943$var$SPIN_MS + $c173fca63c358943$var$SETTLE_GRACE_MS);
        return ()=>{
            clearTimeout(timer);
            settleRef.current = null;
        };
    }, [
        spin,
        target
    ]);
    // Under two slices there is no wheel to draw — the arc flag below describes a
    // minor arc, and a single slice has no arc at all. Nothing is drawn rather
    // than something misleading, as `Sparkline` does with a single point.
    if (count < 2) return null;
    const paths = [];
    const labels = [];
    for(let i = 0; i < count; i += 1){
        const from = i * step - 90;
        const to = from + step;
        const mid = from + step / 2;
        const [x0, y0] = $c173fca63c358943$var$pol(from, $c173fca63c358943$var$R_SLICE);
        const [x1, y1] = $c173fca63c358943$var$pol(to, $c173fca63c358943$var$R_SLICE);
        const [lx, ly] = $c173fca63c358943$var$pol(mid, $c173fca63c358943$var$R_LABEL);
        // Through the bottom half of the wheel a label rotated onto its slice reads
        // upside down; turning it over keeps every label the right way up.
        const upright = mid > 90 && mid < 270 ? mid + 180 : mid;
        paths.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            key: `slice-${i}`,
            d: `M${$c173fca63c358943$var$CX},${$c173fca63c358943$var$CY} L${x0.toFixed(2)},${y0.toFixed(2)} A${$c173fca63c358943$var$R_SLICE},${$c173fca63c358943$var$R_SLICE} 0 0 1 ${x1.toFixed(2)},${y1.toFixed(2)} Z`,
            fill: $c173fca63c358943$var$FILLS[i % $c173fca63c358943$var$FILLS.length],
            stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            strokeWidth: 3
        }));
        labels.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: `label-${i}`,
            transform: `translate(${lx.toFixed(2)} ${ly.toFixed(2)}) rotate(${upright.toFixed(2)})`,
            fill: $c173fca63c358943$var$INKS[i % $c173fca63c358943$var$INKS.length],
            fontSize: 17,
            fontWeight: 700,
            textAnchor: "middle",
            dominantBaseline: "middle"
        }, slices[i]?.label));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c173fca63c358943$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 400 400",
        // The pointer sits above the disc, outside the box.
        style: {
            display: 'block',
            overflow: 'visible',
            maxWidth: '100%',
            height: 'auto',
            ...style
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        role: "img",
        "aria-label": label,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_RIM,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "data-prize-disc": "",
        "data-spinning": spin ? 'true' : 'false',
        style: {
            transform: `rotate(${rotation}deg)`
        },
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'transform') settleRef.current?.();
        }
    }, paths, labels), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB_INNER,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_PIP,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M182,-2 L218,-2 L200,34 Z",
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        strokeWidth: 3,
        strokeLinejoin: "round"
    })));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7fca19d3fce363c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Camera", [
    [
        "path",
        {
            d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
            key: "1tc9qg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "3",
            key: "1vg3eu"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("FileText", [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b6fccb27ddbe0a20$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("FolderOpen", [
    [
        "path",
        {
            d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
            key: "usdka0"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f68e7f5ef2ab511$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Upload", [
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "polyline",
        {
            points: "17 8 12 3 7 8",
            key: "t8dd8p"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "3",
            y2: "15",
            key: "widbto"
        }
    ]
]);









'use client';
const $ad7c85561d054b68$export$d8640b1e4d69af25 = [
    'queued',
    'preparing',
    'sending',
    'done',
    'failed'
];
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5); a mouse keeps `sm`.
const $ad7c85561d054b68$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $ad7c85561d054b68$var$SIZES = {
    regular: {
        padBlock: '1.75rem',
        icon: 28
    },
    compact: {
        padBlock: '1rem',
        icon: 20
    }
};
// ── accept matching ─────────────────────────────────────────────────────────
function $ad7c85561d054b68$var$acceptTokens(accept) {
    if (!accept) return [];
    const list = Array.isArray(accept) ? accept : String(accept).split(',');
    return list.map((t)=>String(t).trim().toLowerCase()).filter(Boolean);
}
function $ad7c85561d054b68$export$b4699969e89702eb(file, accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    if (tokens.length === 0) return true;
    const name = String(file?.name || '').toLowerCase();
    const type = String(file?.type || '').toLowerCase();
    return tokens.some((token)=>{
        if (token.startsWith('.')) return name.endsWith(token);
        if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
// `null`, '' and [] mean "no filter" — and no `accept` attribute on the input.
function $ad7c85561d054b68$var$acceptAttr(accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    return tokens.length ? tokens.join(',') : undefined;
}
function $ad7c85561d054b68$var$isImage(file) {
    return !!file && typeof file.type === 'string' && file.type.toLowerCase().startsWith('image/');
}
function $ad7c85561d054b68$export$8c95ef2c56e9a241({ name: name, meta: meta, phase: phase = 'queued', progress: progress, progressLabel: progressLabel, error: error, file: file, previewUrl: previewUrl, badge: badge, removable: removable, replaceable: replaceable = false, trailing: trailing, busy: busy = false, disabled: disabled = false, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, phaseLabels: phaseLabels, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, as: Tag = 'li', className: className, 'data-testid': testId, ...rest }) {
    if (removeLabel === undefined) removeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.replace;
    const labels = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.phases,
        ...phaseLabels
    };
    const phaseLabel = labels[phase] ?? phase;
    // A thumbnail for an image File, created here and revoked when the row
    // leaves or the file changes — a leaked object URL holds the whole blob.
    const [objectUrl, setObjectUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wantsObjectUrl = !previewUrl && !badge && $ad7c85561d054b68$var$isImage(file);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!wantsObjectUrl || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
            setObjectUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return ()=>{
            if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
        };
    }, [
        file,
        wantsObjectUrl
    ]);
    const thumbSrc = previewUrl || (wantsObjectUrl ? objectUrl : null);
    const canRemove = (removable ?? phase !== 'done') && !busy && typeof onRemove === 'function';
    const canRetry = phase === 'failed' && !!file && !busy && typeof onRetry === 'function';
    const canReplace = replaceable && !busy && typeof onReplace === 'function';
    const hasBar = typeof progress === 'number' && Number.isFinite(progress);
    const pct = hasBar ? Math.max(0, Math.min(100, progress)) : 0;
    const phaseColor = phase === 'failed' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk : phase === 'done' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "data-testid": testId,
        "data-state": phase,
        "aria-live": "polite",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center', className),
        style: {
            gap: '0.625rem',
            paddingBlock: '0.5rem',
            paddingInline: '0.625rem',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            minWidth: 0,
            opacity: disabled ? 0.6 : 1
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "flex items-center justify-center overflow-hidden",
        style: {
            flexShrink: 0,
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontSize: '0.625rem',
            fontWeight: 800
        }
    }, badge ? badge : thumbSrc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: thumbSrc,
        alt: "",
        "data-testid": testId ? `${testId}-thumb` : undefined,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $adb270212de20834$export$2e2bcd8739ae039), {
        size: 18,
        strokeWidth: 1.5
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-col",
        style: {
            flex: 1,
            minWidth: 0,
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-start",
        style: {
            unicodeBidi: 'isolate',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), error ? // Keyed on the text: a CHANGED error remounts and is announced once;
    // an unchanged one re-rendering stays quiet.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        key: String(error),
        role: "alert",
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
            lineHeight: 1.5
        }
    }, error) : meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, meta) : null, hasBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct,
        "aria-label": progressLabel || phaseLabel,
        className: "flex",
        style: {
            flex: 1,
            height: '0.25rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "transition-[width] duration-200 motion-reduce:transition-none",
        style: {
            width: `${pct}%`,
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }
    })), progressLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "tabular-nums",
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, progressLabel) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            flexShrink: 0,
            gap: '0.375rem'
        }
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.25rem',
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: phaseColor
        }
    }, phase === 'sending' || phase === 'preparing' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "inline-flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 14,
        thickness: 2,
        label: ""
    })) : null, phase === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14,
        strokeWidth: 2,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, phaseLabel)), canReplace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onReplace,
        disabled: disabled,
        "data-testid": testId ? `${testId}-replace` : undefined
    }, replaceLabel) : null, canRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "outline",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onRetry,
        disabled: disabled,
        "data-testid": testId ? `${testId}-retry` : undefined
    }, retryLabel) : null, canRemove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: 40,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        label: removeLabel,
        onClick: onRemove,
        disabled: disabled,
        "data-testid": testId ? `${testId}-remove` : undefined
    }) : null));
}
const $ad7c85561d054b68$export$731398005976572f = $ad7c85561d054b68$export$8c95ef2c56e9a241;
// ─────────────────────────────────────────────────────────────────────────────
// FileDropzone
// ─────────────────────────────────────────────────────────────────────────────
// Every row the zone counts: the flat `files`, or the rows of every group.
function $ad7c85561d054b68$var$rowsOf(groups, files) {
    if (Array.isArray(groups)) return groups.flatMap((g)=>Array.isArray(g?.files) ? g.files : []);
    return Array.isArray(files) ? files : [];
}
function $ad7c85561d054b68$export$2e2bcd8739ae039({ files: filesProp, groups: groups, onFiles: onFiles, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, accept: accept, multiple: multiple = true, maxFiles: maxFiles, maxBytes: maxBytes, capture: capture, directory: directory = false, extraActions: extraActions, disabled: disabled = false, busy: busy = false, error: error, size: size = 'regular', label: label, required: required, helperText: helperText, dropLabel: dropLabel, pickLabel: pickLabel, cameraLabel: cameraLabel, directoryLabel: directoryLabel, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, phaseLabels: phaseLabels, draggingLabel: draggingLabel, emptyHint: emptyHint, listLabel: listLabel, className: className, style: style, 'data-testid': testId, ...rest }) {
    if (dropLabel === undefined) dropLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.drop;
    if (pickLabel === undefined) pickLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.pick;
    if (cameraLabel === undefined) cameraLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.camera;
    if (directoryLabel === undefined) directoryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.directory;
    if (removeLabel === undefined) removeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.replace;
    if (draggingLabel === undefined) draggingLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.dragging;
    const S = $ad7c85561d054b68$var$SIZES[size] || $ad7c85561d054b68$var$SIZES.regular;
    const baseId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const zoneId = `${baseId}-zone`;
    const helperId = helperText ? `${baseId}-helper` : undefined;
    const errorId = error ? `${baseId}-error` : undefined;
    const mainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const cameraRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const directoryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragDepth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [dragging, setDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const files = $ad7c85561d054b68$var$rowsOf(groups, filesProp);
    const warnedBoth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const inert = disabled || busy;
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    // `webkitdirectory` is not a React prop; it has to be an attribute.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = directoryRef.current;
        if (!el) return;
        el.setAttribute('webkitdirectory', '');
        el.setAttribute('directory', '');
    }, [
        directory
    ]);
    // Never lingers in `dragging` if the zone is disabled mid-drag.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inert) {
            dragDepth.current = 0;
            setDragging(false);
        }
    }, [
        inert
    ]);
    const report = (picked, source)=>{
        const list = Array.from(picked || []);
        // Nothing picked (a cancelled dialog, a drop of text) is not a batch.
        if (list.length === 0) return;
        let room = Infinity;
        if (typeof maxFiles === 'number') room = Math.max(0, maxFiles - files.length);
        if (!multiple) room = Math.min(room, 1);
        const accepted = [];
        const rejected = [];
        for (const f of list){
            if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) rejected.push({
                file: f,
                reason: 'type'
            });
            else if (typeof maxBytes === 'number' && typeof f.size === 'number' && f.size > maxBytes) rejected.push({
                file: f,
                reason: 'size'
            });
            else if (accepted.length >= room) rejected.push({
                file: f,
                reason: 'count'
            });
            else accepted.push(f);
        }
        onFiles?.(accepted, rejected, source);
    };
    const onInputChange = (source)=>(e)=>{
            const picked = e.target.files;
            try {
                report(picked, source);
            } finally{
                // Reset, so picking the same file twice still fires `change`.
                e.target.value = '';
            }
        };
    const onReplaceChange = (e)=>{
        const f = e.target.files?.[0];
        const id = replaceTarget.current;
        e.target.value = '';
        replaceTarget.current = null;
        if (!f || id == null) return;
        // A refused replacement is reported like any refused pick, so the caller
        // has one place that writes the sentence.
        if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'type'
                }
            ], 'picker');
            return;
        }
        if (typeof maxBytes === 'number' && f.size > maxBytes) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'size'
                }
            ], 'picker');
            return;
        }
        onReplace?.(id, f);
    };
    const open = (ref)=>()=>{
            if (inert) return;
            ref.current?.click();
        };
    const hasDragFiles = (e)=>{
        const types = e.dataTransfer?.types;
        if (!types) return true;
        return Array.from(types).includes('Files');
    };
    const onDragEnter = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (inert) return;
        dragDepth.current += 1;
        setDragging(true);
    };
    const onDragOver = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = inert ? 'none' : 'copy';
    };
    const onDragLeave = ()=>{
        if (inert) return;
        // `dragleave` fires on every child boundary; only the last one leaves.
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) setDragging(false);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        dragDepth.current = 0;
        setDragging(false);
        if (inert) return;
        report(e.dataTransfer?.files, 'drop');
    };
    const state = disabled ? 'disabled' : dragging ? 'dragging' : files.length ? 'has-files' : 'idle';
    const accentOn = dragging && !inert;
    const describedBy = [
        helperId,
        errorId
    ].filter(Boolean).join(' ') || undefined;
    const pickerProps = {
        type: 'button',
        variant: 'outline',
        size: 'sm',
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        disabled: disabled,
        'aria-disabled': busy || undefined
    };
    const renderRow = (f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7c85561d054b68$export$8c95ef2c56e9a241, {
            key: f.id,
            name: f.name,
            meta: f.meta,
            phase: f.phase,
            progress: f.progress,
            progressLabel: f.progressLabel,
            error: f.error,
            file: f.file,
            previewUrl: f.previewUrl,
            badge: f.badge,
            removable: f.removable,
            replaceable: f.replaceable,
            trailing: f.trailing,
            busy: busy,
            disabled: disabled,
            phaseLabels: phaseLabels,
            removeLabel: removeLabel,
            retryLabel: retryLabel,
            replaceLabel: replaceLabel,
            onRemove: onRemove ? ()=>onRemove(f.id) : undefined,
            onRetry: onRetry ? ()=>onRetry(f.id) : undefined,
            onReplace: onReplace ? ()=>{
                if (inert) return;
                replaceTarget.current = f.id;
                replaceRef.current?.click();
            } : undefined,
            "data-testid": testId ? `${testId}-row-${f.id}` : undefined
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        "data-busy": busy || undefined,
        className: className,
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        htmlFor: zoneId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('frame'),
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop,
        className: "flex flex-col items-center",
        style: {
            gap: '0.625rem',
            paddingBlock: S.padBlock,
            paddingInline: '1rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            border: `1.5px dashed ${accentOn ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: accentOn ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.06) : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : undefined,
            transition: 'border-color 0.15s, background 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        id: zoneId,
        type: "button",
        "data-testid": tid('zone'),
        onClick: open(mainRef),
        disabled: disabled,
        "aria-disabled": busy || undefined,
        "aria-describedby": describedBy,
        className: "flex w-full flex-col items-center text-center outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        style: {
            gap: '0.375rem',
            background: 'transparent',
            border: 'none',
            padding: '0.25rem',
            cursor: inert ? disabled ? 'not-allowed' : 'default' : 'pointer',
            font: 'inherit',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: S.icon,
        strokeWidth: 1.5,
        color: accentOn ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, accentOn ? draggingLabel : dropLabel), emptyHint && files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, emptyHint) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center justify-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(mainRef),
        "data-testid": tid('pick')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), pickLabel), capture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(cameraRef),
        "data-testid": tid('camera-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fca19d3fce363c2$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), cameraLabel) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(directoryRef),
        "data-testid": tid('directory-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b6fccb27ddbe0a20$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), directoryLabel) : null, typeof extraActions === 'function' ? extraActions({
        openPicker: open(mainRef),
        openCamera: capture ? open(cameraRef) : undefined,
        openDirectory: directory ? open(directoryRef) : undefined,
        labels: {
            pick: pickLabel,
            camera: cameraLabel,
            directory: directoryLabel
        },
        disabled: inert
    }) : extraActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: mainRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": pickLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        multiple: multiple,
        disabled: disabled,
        onChange: onInputChange('picker'),
        "data-testid": tid('input')
    }), capture ? // A SEPARATE input: `capture` on the main one makes iOS skip the
    // gallery entirely.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: cameraRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": cameraLabel,
        accept: "image/*",
        capture: capture,
        disabled: disabled,
        onChange: onInputChange('camera'),
        "data-testid": tid('camera')
    }) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: directoryRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": directoryLabel,
        multiple: true,
        disabled: disabled,
        onChange: onInputChange('directory'),
        "data-testid": tid('directory')
    }) : null, typeof onReplace === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: replaceRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": replaceLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        disabled: disabled,
        onChange: onReplaceChange,
        "data-testid": tid('replace-input')
    }) : null), helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: helperId,
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, helperText) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: errorId,
        key: String(error),
        role: "alert",
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
            fontWeight: 500,
            lineHeight: 1.5
        }
    }, error) : null, Array.isArray(groups) ? groups.map((g)=>{
        const rows = Array.isArray(g.files) ? g.files : [];
        const headingId = `${baseId}-group-${g.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.id,
            "aria-labelledby": headingId,
            "data-testid": tid(`group-${g.id}`),
            "data-state": rows.length ? 'has-files' : 'empty',
            className: "flex flex-col",
            style: {
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-baseline",
            style: {
                gap: '0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: headingId,
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                lineHeight: 1.5
            }
        }, g.title), g.meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                lineHeight: 1.5
            }
        }, g.meta) : null), rows.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "aria-labelledby": headingId,
            className: "m-0 flex list-none flex-col p-0",
            style: {
                gap: '0.375rem'
            }
        }, rows.map(renderRow)) : g.emptyText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0",
            style: {
                fontSize: '0.71875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                lineHeight: 1.5
            }
        }, g.emptyText) : null);
    }) : files.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": listLabel || (typeof label === 'string' ? label : undefined),
        className: "m-0 flex list-none flex-col p-0",
        style: {
            gap: '0.375rem'
        }
    }, files.map(renderRow)) : null)));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $19a9d9625d2a478d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Maximize", [
    [
        "path",
        {
            d: "M8 3H5a2 2 0 0 0-2 2v3",
            key: "1dcmit"
        }
    ],
    [
        "path",
        {
            d: "M21 8V5a2 2 0 0 0-2-2h-3",
            key: "1e4gt3"
        }
    ],
    [
        "path",
        {
            d: "M3 16v3a2 2 0 0 0 2 2h3",
            key: "wsl5sc"
        }
    ],
    [
        "path",
        {
            d: "M16 21h3a2 2 0 0 0 2-2v-3",
            key: "18trek"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c082792a8b35a18c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ZoomIn", [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16.65",
            y1: "21",
            y2: "16.65",
            key: "13gj7c"
        }
    ],
    [
        "line",
        {
            x1: "11",
            x2: "11",
            y1: "8",
            y2: "14",
            key: "1vmskp"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "14",
            y1: "11",
            y2: "11",
            key: "durymu"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f7faf703d6528e5f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ZoomOut", [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16.65",
            y1: "21",
            y2: "16.65",
            key: "13gj7c"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "14",
            y1: "11",
            y2: "11",
            key: "durymu"
        }
    ]
]);













'use client';
function $cb5da664f84994ea$export$bb0048c9149cbdb(locale) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).imageStack;
    const { digits: digits } = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale);
    return {
        ...copy,
        frame: (i, n)=>copy.frame((0, $0873d4f32691c14e$export$545c62727d3740ae)(i, digits), (0, $0873d4f32691c14e$export$545c62727d3740ae)(n, digits))
    };
}
const $cb5da664f84994ea$export$eb119caddc05b7a2 = $cb5da664f84994ea$export$bb0048c9149cbdb('fa');
const $cb5da664f84994ea$var$MIN_ZOOM = 1;
const $cb5da664f84994ea$var$MAX_ZOOM = 8;
const $cb5da664f84994ea$var$ZOOM_STEP = 1.25;
// Pixels of wheel delta / finger travel per frame. Interaction thresholds,
// not layout — they never reach a style.
const $cb5da664f84994ea$var$WHEEL_PER_FRAME = 60;
const $cb5da664f84994ea$var$SWIPE_PER_FRAME = 24;
const $cb5da664f84994ea$var$DOUBLE_TAP_MS = 300;
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5).
const $cb5da664f84994ea$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $cb5da664f84994ea$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
function $cb5da664f84994ea$export$2e2bcd8739ae039({ frameCount: frameCount = 0, index: indexProp, defaultIndex: defaultIndex = 0, onIndexChange: onIndexChange, loadFrame: loadFrame, revokeFrame: revokeFrame, preloadRadius: preloadRadius = 5, sourceKey: sourceKey, series: series, activeSeriesId: activeSeriesId, onSeriesChange: onSeriesChange, presets: presets, activePresetId: activePresetId, onPresetChange: onPresetChange, caption: caption, banner: banner, loading: loading = false, error: error, onRetry: onRetry, labels: labelsProp, className: className, style: style, 'data-testid': testId, ...rest }) {
    const labels = {
        ...$cb5da664f84994ea$export$bb0048c9149cbdb(),
        ...labelsProp
    };
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    const n = Math.max(0, Math.floor(Number(frameCount) || 0));
    // ── index: controlled when `index` is given, otherwise internal ───────────
    const [innerIndex, setInnerIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultIndex);
    const controlled = indexProp !== undefined && indexProp !== null;
    const index = n ? $cb5da664f84994ea$var$clamp(Math.floor(controlled ? indexProp : innerIndex) || 0, 0, n - 1) : 0;
    const indexRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(index);
    indexRef.current = index;
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!n) return;
        const target = $cb5da664f84994ea$var$clamp(Math.round(next), 0, n - 1);
        if (target === indexRef.current) return;
        if (!controlled) setInnerIndex(target);
        onIndexChange?.(target);
    }, [
        n,
        controlled,
        onIndexChange
    ]);
    // ── frame cache ───────────────────────────────────────────────────────────
    const loadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(loadFrame);
    loadRef.current = loadFrame;
    const revokeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(revokeFrame);
    revokeRef.current = revokeFrame;
    const cache = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → url
    const pending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → AbortController
    const failed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set()); // i
    const shownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // url on screen
    const [, bump] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((x)=>x + 1, 0);
    const [shownUrl, setShownUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [, setRetryTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const release = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        if (!url || url === shownRef.current) return;
        revokeRef.current?.(url);
    }, []);
    const source = `${activeSeriesId ?? ''}|${activePresetId ?? ''}|${n}|${sourceKey ?? ''}`;
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(source);
    // A new source: cancel everything in flight and forget every frame. The
    // shown image stays up (under a spinner) until its replacement arrives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (sourceRef.current === source) return;
        sourceRef.current = source;
        for (const ctrl of pending.current.values())ctrl.abort();
        pending.current.clear();
        for (const url of cache.current.values())release(url);
        cache.current.clear();
        failed.current.clear();
        bump();
    }, [
        source,
        release
    ]);
    // Load the current frame and its neighbours; evict what fell out.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!n || typeof loadRef.current !== 'function' || loading || error) return;
        const lo = Math.max(0, index - preloadRadius);
        const hi = Math.min(n - 1, index + preloadRadius);
        for (const [i, ctrl] of pending.current)if (i < lo || i > hi) {
            ctrl.abort();
            pending.current.delete(i);
        }
        for (const [i, url] of cache.current)if (i < lo || i > hi) {
            cache.current.delete(i);
            release(url);
        }
        for (const i of failed.current)if (i < lo || i > hi) failed.current.delete(i);
        // Current frame first, then outward: ±1, ±2, …
        const order = [
            index
        ];
        for(let d = 1; d <= preloadRadius; d += 1){
            if (index + d <= hi) order.push(index + d);
            if (index - d >= lo) order.push(index - d);
        }
        const mySource = sourceRef.current;
        for (const i of order){
            if (cache.current.has(i) || pending.current.has(i) || failed.current.has(i)) continue;
            const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : {
                abort () {},
                signal: undefined
            };
            pending.current.set(i, ctrl);
            let p;
            try {
                p = Promise.resolve(loadRef.current(i, {
                    signal: ctrl.signal
                }));
            } catch (e) {
                p = Promise.reject(e);
            }
            p.then((url)=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) {
                    if (url) revokeRef.current?.(url);
                    return;
                }
                pending.current.delete(i);
                cache.current.set(i, url);
                bump();
            }, ()=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) return;
                pending.current.delete(i);
                failed.current.add(i);
                bump();
            });
        }
    });
    // Show the current frame as soon as it is cached; revoke what it replaced.
    const currentUrl = cache.current.get(index) ?? null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!currentUrl || currentUrl === shownRef.current) return;
        const previous = shownRef.current;
        shownRef.current = currentUrl;
        setShownUrl(currentUrl);
        if (previous && ![
            ...cache.current.values()
        ].includes(previous)) revokeRef.current?.(previous);
    }, [
        currentUrl
    ]);
    // Unmount: cancel, and hand back every URL still held.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const ctrl of pending.current.values())ctrl.abort();
            pending.current.clear();
            const urls = new Set([
                ...cache.current.values(),
                shownRef.current
            ].filter(Boolean));
            cache.current.clear();
            shownRef.current = null;
            for (const url of urls)revokeRef.current?.(url);
        }, []);
    const retryFrame = ()=>{
        failed.current.delete(index);
        setRetryTick((t)=>t + 1);
    };
    const frameState = failed.current.has(index) ? 'error' : currentUrl ? 'ready' : 'loading';
    // ── zoom & pan ────────────────────────────────────────────────────────────
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const stageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clampPan = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((p, z)=>{
        const rect = stageRef.current?.getBoundingClientRect?.();
        if (!rect || !rect.width || !rect.height) return z <= 1 ? {
            x: 0,
            y: 0
        } : p;
        const mx = (z - 1) * rect.width / 2;
        const my = (z - 1) * rect.height / 2;
        return {
            x: $cb5da664f84994ea$var$clamp(p.x, -mx, mx),
            y: $cb5da664f84994ea$var$clamp(p.y, -my, my)
        };
    }, []);
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z)=>{
        const next = $cb5da664f84994ea$var$clamp(z, $cb5da664f84994ea$var$MIN_ZOOM, $cb5da664f84994ea$var$MAX_ZOOM);
        setZoom(next);
        setPan((p)=>next <= 1 ? {
                x: 0,
                y: 0
            } : clampPan(p, next));
    }, [
        clampPan
    ]);
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        resetView();
    }, [
        activeSeriesId,
        resetView
    ]);
    // Latest values for the native listeners below.
    const live = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    live.current = {
        zoom: zoom,
        go: go,
        index: index,
        zoomTo: zoomTo
    };
    // Wheel needs a non-passive listener to keep the page from scrolling.
    const wheelAcc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = stageRef.current;
        if (!el) return undefined;
        const onWheel = (e)=>{
            e.preventDefault();
            const L = live.current;
            if (e.ctrlKey || e.metaKey) {
                L.zoomTo(L.zoom * (e.deltaY < 0 ? $cb5da664f84994ea$var$ZOOM_STEP : 1 / $cb5da664f84994ea$var$ZOOM_STEP));
                return;
            }
            // Line/page deltas (a notched mouse on some platforms) step one frame
            // per event; pixel deltas (trackpads) accumulate.
            if (e.deltaMode !== 0) {
                wheelAcc.current = 0;
                if (e.deltaY) L.go(L.index + Math.sign(e.deltaY));
                return;
            }
            wheelAcc.current += e.deltaY;
            const steps = Math.trunc(wheelAcc.current / $cb5da664f84994ea$var$WHEEL_PER_FRAME);
            if (steps) {
                wheelAcc.current -= steps * $cb5da664f84994ea$var$WHEEL_PER_FRAME;
                L.go(L.index + steps);
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    });
    // Pointers: one finger pans (zoomed) or swipes frames (not zoomed); two pinch.
    const pointers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const gesture = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const lastTap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const onPointerDown = (e)=>{
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        const pts = [
            ...pointers.current.values()
        ];
        if (pts.length === 2) gesture.current = {
            kind: 'pinch',
            dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
            zoom: zoom
        };
        else if (pts.length === 1) gesture.current = zoom > 1 ? {
            kind: 'pan',
            x: e.clientX,
            y: e.clientY,
            pan: pan
        } : {
            kind: 'swipe',
            y: e.clientY,
            index: index
        };
    };
    const onPointerMove = (e)=>{
        if (!pointers.current.has(e.pointerId)) return;
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        const g = gesture.current;
        if (!g) return;
        if (g.kind === 'pinch') {
            const pts = [
                ...pointers.current.values()
            ];
            if (pts.length < 2) return;
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
            zoomTo(g.zoom * (dist / g.dist));
        } else if (g.kind === 'pan') setPan(clampPan({
            x: g.pan.x + (e.clientX - g.x),
            y: g.pan.y + (e.clientY - g.y)
        }, zoom));
        else if (g.kind === 'swipe') {
            // Finger up = next frame, like scrolling a page of film.
            const steps = Math.trunc((g.y - e.clientY) / $cb5da664f84994ea$var$SWIPE_PER_FRAME);
            go(g.index + steps);
        }
    };
    const onPointerUp = (e)=>{
        pointers.current.delete(e.pointerId);
        if (pointers.current.size === 0) {
            if (e.pointerType === 'touch') {
                const now = Date.now();
                if (now - lastTap.current < $cb5da664f84994ea$var$DOUBLE_TAP_MS) {
                    resetView();
                    lastTap.current = 0;
                } else lastTap.current = now;
            }
            gesture.current = null;
        } else if (pointers.current.size === 1) {
            const [pt] = [
                ...pointers.current.values()
            ];
            gesture.current = zoom > 1 ? {
                kind: 'pan',
                x: pt.x,
                y: pt.y,
                pan: pan
            } : null;
        }
    };
    const onKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowUp':
            case 'PageUp':
                go(index - 1);
                break;
            case 'ArrowDown':
            case 'PageDown':
                go(index + 1);
                break;
            case 'Home':
                go(0);
                break;
            case 'End':
                go(n - 1);
                break;
            case '+':
            case '=':
                zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '-':
            case '_':
                zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '0':
                resetView();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    // ── states ────────────────────────────────────────────────────────────────
    const state = loading ? 'loading' : error ? 'error' : n === 0 ? 'empty' : 'content';
    const frameText = n ? labels.frame(index + 1, n) : '';
    const canvasStyle = {
        position: 'relative',
        width: '100%',
        aspectRatio: '1 / 1',
        maxHeight: '70dvh',
        maxWidth: '100%',
        borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink,
        overflow: 'hidden'
    };
    const seriesStrip = Array.isArray(series) && series.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": labels.series,
        "data-testid": tid('series'),
        className: "flex",
        style: {
            gap: '0.5rem',
            overflowX: 'auto',
            paddingBlock: '0.125rem',
            scrollbarWidth: 'thin'
        }
    }, series.map((s)=>{
        const active = s.id === activeSeriesId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            "aria-pressed": active,
            "data-state": active ? 'active' : 'inactive',
            "data-testid": tid(`series-${s.id}`),
            onClick: ()=>{
                if (!active) onSeriesChange?.(s.id);
            },
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('inline-flex items-center outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flexShrink: 0,
                gap: '0.375rem',
                minHeight: '2.25rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.25rem',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                border: `1px solid ${active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                font: 'inherit',
                fontSize: '0.75rem',
                fontWeight: 600,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, s.label), s.badge != null && s.badge !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
                paddingInline: '0.3125rem'
            }
        }, s.badge) : null);
    })) : null;
    const presetControl = Array.isArray(presets) && presets.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('presets'),
        style: {
            maxWidth: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
        semantics: "filter",
        size: "lg",
        ariaLabel: labels.presets,
        options: presets.map((p)=>({
                value: p.id,
                label: p.label
            })),
        value: activePresetId,
        onChange: (id)=>{
            if (id !== activePresetId) onPresetChange?.(id);
        }
    })) : null;
    let body;
    if (state === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: labels.loading,
        "data-testid": tid('loading'),
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
        height: "auto",
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        style: {
            ...canvasStyle,
            background: undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
        height: "2.75rem",
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }));
    else if (state === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        "data-testid": tid('error'),
        title: typeof error === 'string' ? error : labels.error,
        onRetry: onRetry,
        retryLabel: labels.retry
    });
    else if (state === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        "data-testid": tid('empty'),
        title: labels.empty
    });
    else {
        const transform = `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`;
        body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: stageRef,
            role: "img",
            "aria-roledescription": labels.viewport,
            "aria-label": frameText,
            tabIndex: 0,
            "data-testid": tid('stage'),
            "data-frame-state": frameState,
            "data-zoom": String(Math.round(zoom * 100) / 100),
            onKeyDown: onKeyDown,
            onPointerDown: onPointerDown,
            onPointerMove: onPointerMove,
            onPointerUp: onPointerUp,
            onPointerCancel: onPointerUp,
            onDoubleClick: resetView,
            className: "outline-none focus-visible:ring-2 focus-visible:ring-ring",
            style: {
                ...canvasStyle,
                touchAction: 'none',
                userSelect: 'none',
                cursor: zoom > 1 ? 'grab' : 'ns-resize'
            }
        }, shownUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: shownUrl,
            alt: "",
            draggable: false,
            "data-testid": tid('image'),
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transform: transform,
                transformOrigin: 'center',
                opacity: frameState === 'ready' ? 1 : 0.6,
                pointerEvents: 'none'
            }
        }) : frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
            tone: "onDark",
            width: "100%",
            height: "100%",
            radius: 0,
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0
            }
        }) : null, frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('frame-loading'),
            className: "flex items-center justify-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
            size: 28,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            label: labels.loading
        })) : null, frameState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('frame-error'),
            className: "flex flex-col items-center justify-center text-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                gap: '0.75rem',
                paddingInline: '1rem',
                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink, 0.7),
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "alert",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600
            }
        }, labels.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            variant: "outline",
            size: "sm",
            className: $cb5da664f84994ea$var$TOUCH_TARGET,
            onClick: retryFrame,
            "data-testid": tid('frame-retry')
        }, labels.retry)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-wrap items-center",
            style: {
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.prev,
            onClick: ()=>go(index - 1),
            disabled: index <= 0,
            "data-testid": tid('prev')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "range",
            min: 0,
            max: Math.max(0, n - 1),
            step: 1,
            value: index,
            "aria-label": labels.slider,
            "aria-valuetext": frameText,
            onChange: (e)=>go(Number(e.target.value)),
            disabled: n <= 1,
            "data-testid": tid('slider'),
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flex: '1 1 8rem',
                minWidth: 0,
                minHeight: '2.25rem',
                accentColor: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.next,
            onClick: ()=>go(index + 1),
            disabled: index >= n - 1,
            "data-testid": tid('next')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-live": "polite",
            "aria-atomic": "true",
            "data-testid": tid('counter'),
            className: "tabular-nums",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                whiteSpace: 'nowrap'
            }
        }, frameText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex items-center",
            style: {
                gap: '0.25rem',
                marginInlineStart: 'auto'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f7faf703d6528e5f$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomOut,
            onClick: ()=>zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom <= $cb5da664f84994ea$var$MIN_ZOOM,
            "data-testid": tid('zoom-out')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c082792a8b35a18c$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomIn,
            onClick: ()=>zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom >= $cb5da664f84994ea$var$MAX_ZOOM,
            "data-testid": tid('zoom-in')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19a9d9625d2a478d$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.reset,
            onClick: resetView,
            disabled: zoom === 1 && pan.x === 0 && pan.y === 0,
            "data-testid": tid('reset')
        }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col', className),
        style: {
            gap: '0.625rem',
            minWidth: 0,
            ...style
        },
        ...rest
    }, banner, state !== 'loading' ? seriesStrip : null, state !== 'loading' ? presetControl : null, body, caption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, caption) : null);
}



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// FilterChip — one toggleable filter in a chip row (category, type, status).
//
// Distinct from `ChipSelector`, which is a *form field* (label, validation,
// helper text, a value the user submits). This is a **view filter**: it narrows
// what a list shows, lives in a toolbar rather than a form, and reports its
// state through `aria-pressed` — the correct semantics for a toggle button, and
// the reason the two are not one component.
//
// Sized for touch by default (`min-h-11` = 2.75rem), because the phone is where
// chip rows are used most and a sub-44px target is a defect there. `count` is a
// node, not a number, so the caller formats digits in its own locale.
// ─────────────────────────────────────────────────────────────────────────────
const $4f5f0e3d96e18162$var$FilterChip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, count: count, active: active = false, onClick: onClick, disabled: disabled, className: className, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ref: ref,
        type: "button",
        variant: active ? 'subtle' : 'outline',
        size: "sm",
        "aria-pressed": active,
        disabled: disabled,
        onClick: onClick,
        "data-state": active ? 'active' : 'inactive',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('min-h-11 shrink-0 rounded-full gap-1', className),
        ...rest
    }, label ?? children, count != null && count !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.625rem] opacity-70"
    }, "(", count, ")")));
$4f5f0e3d96e18162$var$FilterChip.displayName = 'FilterChip';
var $4f5f0e3d96e18162$export$2e2bcd8739ae039 = $4f5f0e3d96e18162$var$FilterChip;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Sparkline — an inline, axis-less trend glyph for a short numeric series.
//
// The smallest data-viz unit in the system: it rides inside a row or a tile to
// answer «is this going up or down?» without spending a chart's worth of space.
// It is deliberately unlabelled — the row already carries the name, the value
// and the unit, and the glyph only has to show shape.
//
// Tones resolve from the token set, so a sparkline never invents a colour:
// `accent` for an in-range series, `danger`/`warn` when the caller has already
// judged the latest reading out of range.
//
// Empty appearance (by design): fewer than two numeric points cannot describe a
// trend, so the glyph renders nothing at all rather than a misleading flat line.
// ─────────────────────────────────────────────────────────────────────────────
const $91c948f90369c6a3$var$TONES = {
    accent: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
    danger: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger,
    warn: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    good: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good,
    mute: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
};
const $91c948f90369c6a3$var$Sparkline = ({ points: points = [], width: width = 72, height: height = 26, tone: tone = 'accent', strokeWidth: strokeWidth = 1.5, showLast: showLast = true, className: className, style: style, ...rest })=>{
    const vals = (points || []).map((p)=>typeof p === 'number' ? p : parseFloat(p)).filter((v)=>!Number.isNaN(v));
    if (vals.length < 2) return null;
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    // A flat series would divide by zero; pad it so the line sits mid-height.
    const pad = (max - min) * 0.15 || 1;
    const lo = min - pad;
    const hi = max + pad;
    const xOf = (i)=>i / (vals.length - 1) * width;
    const yOf = (v)=>height - (v - lo) / (hi - lo) * height;
    const path = vals.map((v, i)=>`${xOf(i).toFixed(1)},${yOf(v).toFixed(1)}`).join(' ');
    const stroke = $91c948f90369c6a3$var$TONES[tone] || $91c948f90369c6a3$var$TONES.accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        // Time always reads left→right, including on an RTL page.
        style: {
            direction: 'ltr',
            overflow: 'visible',
            display: 'block',
            flexShrink: 0,
            ...style
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "aria-hidden": true,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: xOf(vals.length - 1),
        cy: yOf(vals[vals.length - 1]),
        r: "2.5",
        fill: stroke
    }));
};
var $91c948f90369c6a3$export$2e2bcd8739ae039 = $91c948f90369c6a3$var$Sparkline;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TrendChart — the full-size counterpart to `Sparkline`: one numeric series over
// time, with an optional reference band and per-point status.
//
// It is the system's answer to «show me this measurement's history» — a lab
// analyte, a vital sign, a wallet balance, a clinic's daily revenue. It stays
// presentational: the caller normalises its data to `readings` and decides what
// «abnormal» means; the chart only draws.
//
//   readings   [{ value, date?, status? }]  — chronological, oldest first
//   refLow/refHigh                          — optional reference band + guides
//   formatX(reading, index)                 — axis label; the caller owns the
//                                             locale (Jalali dates, digits…)
//   formatValue(v)                          — value-axis label; same reason —
//                                             digits follow the UI locale, and
//                                             only the app knows what that is
//   emptyLabel                              — copy for the not-enough-data state;
//                                             omitted ⇒ silent blank of the same
//                                             height, so layout never jumps
//
// Status → colour uses the semantic tokens and accepts either casing, because
// clinical back-ends disagree about it (`ABNORMAL` vs `abnormal`).
// ─────────────────────────────────────────────────────────────────────────────
const $b7b57ad44712e2b0$var$STATUS_TONE = {
    abnormal: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    ABNORMAL: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    critical: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger,
    CRITICAL: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger
};
const $b7b57ad44712e2b0$var$VIEWBOX_W = 520;
const $b7b57ad44712e2b0$var$PAD = {
    t: 12,
    r: 16,
    b: 36,
    l: 46
};
const $b7b57ad44712e2b0$var$TrendChart = ({ readings: readings = [], color: color = (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, refLow: refLow, refHigh: refHigh, height: height = 160, gridLines: gridLines = 4, formatX: formatX, formatValue: formatValue = (v)=>v.toFixed(1), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const numeric = (readings || []).map((r)=>({
            ...r,
            num: typeof r?.value === 'number' ? r.value : parseFloat(r?.value)
        }));
    const plottable = numeric.filter((r)=>!Number.isNaN(r.num));
    if (plottable.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    const nums = plottable.map((r)=>r.num);
    const dataMin = Math.min(...nums);
    const dataMax = Math.max(...nums);
    const span = dataMax - dataMin;
    // Include the reference band in the visible window, then breathe by 15% (or a
    // flat ±2 when every reading is identical and the span is 0).
    const lo = Math.min(dataMin, refLow ?? dataMin) - (span * 0.15 || 2);
    const hi = Math.max(dataMax, refHigh ?? dataMax) + (span * 0.15 || 2);
    const range = hi - lo || 1;
    const H = height;
    const cw = $b7b57ad44712e2b0$var$VIEWBOX_W - $b7b57ad44712e2b0$var$PAD.l - $b7b57ad44712e2b0$var$PAD.r;
    const ch = H - $b7b57ad44712e2b0$var$PAD.t - $b7b57ad44712e2b0$var$PAD.b;
    const xOf = (i)=>$b7b57ad44712e2b0$var$PAD.l + i / (plottable.length - 1) * cw;
    const yOf = (v)=>$b7b57ad44712e2b0$var$PAD.t + ch - (v - lo) / range * ch;
    const path = plottable.map((r, i)=>`${xOf(i).toFixed(1)},${yOf(r.num).toFixed(1)}`).join(' ');
    const xStep = Math.max(1, Math.floor(plottable.length / 5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${$b7b57ad44712e2b0$var$VIEWBOX_W} ${H}`,
        // Decorative by contract: every screen that plots a series also lists the
        // readings, and the list is the accessible equivalent (§12).
        "aria-hidden": true,
        focusable: "false",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "content",
        // A time axis reads left→right regardless of the page's direction.
        style: {
            width: '100%',
            height: H,
            display: 'block',
            overflow: 'visible',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: $b7b57ad44712e2b0$var$PAD.l,
        y: yOf(refHigh),
        width: cw,
        height: Math.abs(yOf(refLow) - yOf(refHigh)),
        fill: (0, $e7c165fb515b04ea$export$7bce9182245b1545)(color, 0.08),
        rx: "2"
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = yOf(v);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: $b7b57ad44712e2b0$var$PAD.l,
            x2: $b7b57ad44712e2b0$var$PAD.l + cw,
            y1: y,
            y2: y,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: $b7b57ad44712e2b0$var$PAD.l - 5,
            y: y + 4,
            textAnchor: "end",
            fontSize: "10",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), plottable.map((r, i)=>{
        const cx = xOf(i);
        const cy = yOf(r.num);
        const dot = $b7b57ad44712e2b0$var$STATUS_TONE[r.status] || color;
        const label = i % xStep === 0 && formatX ? formatX(r, i) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: r.id ?? i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: cx,
            cy: cy,
            r: "4",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            stroke: dot,
            strokeWidth: "2"
        }), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: cx,
            y: H - 6,
            textAnchor: "middle",
            fontSize: "9",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }, label));
    }), refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refHigh) + 4,
        fontSize: "9",
        fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
    }, formatValue(refHigh)), refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refLow) + 4,
        fontSize: "9",
        fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
    }, formatValue(refLow)));
};
var $b7b57ad44712e2b0$export$2e2bcd8739ae039 = $b7b57ad44712e2b0$var$TrendChart;



var $acw62 = parcelRequire("acw62");


// ─────────────────────────────────────────────────────────────────────────────
// timeScale — the shared time→pixel mapping behind the kit's timeline charts.
//
// A timeline is only useful when every lane agrees on the clock: the whole
// point of stacking a measurement strip over an interval bar is that a vertical
// line means «the same moment». So the scale is computed ONCE by the caller and
// handed to every lane, instead of each chart deriving its own domain from its
// own data (which would silently misalign lanes with different date coverage).
//
// Domain-free by contract: milliseconds in, viewBox units out. The kit never
// decides what a date *means* — locale, calendar and label text stay with the
// app (the same division `TrendChart.formatX` already draws).
// ─────────────────────────────────────────────────────────────────────────────
// A linear scale over [min,max] → [padStart, width-padEnd].
//
//   scale.x(t)        → viewBox x for a timestamp (ms)
//   scale.invert(px)  → timestamp for a viewBox x
//   scale.clampX(t)   → x, clamped into the plot area (bars that start before
//                       the window still render, flush to the edge)
//   scale.inWindow(t) → is this timestamp inside the visible domain
function $95e851aef96b9382$export$27d74465d4d4bf01({ min: min, max: max, width: width, padStart: padStart = 0, padEnd: padEnd = 0 }) {
    const span = max - min || 1;
    const x0 = padStart;
    const x1 = Math.max(padStart + 1, width - padEnd);
    const w = x1 - x0;
    const x = (t)=>x0 + (t - min) / span * w;
    return {
        min: min,
        max: max,
        x0: x0,
        x1: x1,
        width: w,
        x: x,
        clampX: (t)=>Math.min(x1, Math.max(x0, x(t))),
        invert: (px)=>min + (px - x0) / w * span,
        inWindow: (t)=>t >= min && t <= max
    };
}
function $95e851aef96b9382$export$b9a1c56e49c8e590(min, max, count = 6) {
    const step = (max - min) / Math.max(1, count);
    return Array.from({
        length: count + 1
    }, (_, i)=>min + step * i);
}
function $95e851aef96b9382$export$849b7cb2b6ea39a7(points, scale, minGapPx = 8, isSignificant) {
    if (!points || points.length < 3) return points || [];
    const out = [];
    let lastX = -Infinity;
    points.forEach((p, i)=>{
        const px = scale.x(p.x);
        const keep = i === 0 || i === points.length - 1 || (isSignificant ? isSignificant(p) : false) || px - lastX >= minGapPx;
        if (keep) {
            out.push(p);
            lastX = px;
        }
    });
    return out;
}



var $acw62 = parcelRequire("acw62");

'use client';
const $33096ab4a7258714$export$52ff61eca6e84e5a = ({ scale: scale, ticks: ticks, top: top = 0, bottom: bottom })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "aria-hidden": true
    }, (ticks || []).map((t, i)=>{
        if (!scale.inWindow(t)) return null;
        const x = Math.round(scale.x(t)) + 0.5; // crisp hairline
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            key: i,
            "data-chrome": "grid",
            x1: x,
            x2: x,
            y1: top,
            y2: bottom,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        });
    }));
const $33096ab4a7258714$export$cb94255ec4be9f06 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "now",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
        strokeWidth: "1",
        opacity: "0.9",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$5c09e766dd7f9830 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "cursor",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
        strokeWidth: "1",
        opacity: "0.75",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$348dc3495f07d294 = (status, fallback)=>{
    const s = String(status || '').toLowerCase();
    if (s === 'critical') return (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger;
    if (s === 'abnormal' || s === 'high' || s === 'low' || s === 'h' || s === 'l') return (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn;
    return fallback;
};
const $33096ab4a7258714$export$3b8c55d8340f8b88 = {
    start: 44,
    end: 12
};


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TimeRuler — the clock a stack of timeline lanes shares.
//
// It draws the tick labels once, at the top of the stack, so the lanes beneath
// stay pure plot. The caller owns the calendar: it supplies the tick
// timestamps and `formatTick`, exactly as `TrendChart.formatX` already does —
// the kit never decides that a boundary is a Jalali month rather than a week.
//
// Time reads left→right even on an RTL page (`direction: ltr`), the convention
// `Sparkline` and `TrendChart` already set; the surrounding labels stay RTL.
//
//   scale     — from createTimeScale, or pass xMin/xMax/width and let it build
//   ticks     — timestamps (ms) to label
//   formatTick(t, i) → node
//   nowAt     — timestamp of «now», drawn as the accent boundary
//   cursorAt  — synced crosshair position
//   markers   — optional [{ t, tone, shape, label }] event dots riding the axis
// ─────────────────────────────────────────────────────────────────────────────
const $88ed18dfb45d0422$var$TimeRuler = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, ticks: ticks = [], formatTick: formatTick, nowAt: nowAt, cursorAt: cursorAt, markers: markers, height: height = 52, labelGap: labelGap = 56, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const axisY = height - 18;
    // Labels thin out rather than collide: a tick keeps its gridline always, but
    // only prints its label when it clears the previous printed one. The newest
    // boundary is the anchor a reader looks for, so labelling walks from the end.
    const labelled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const keep = new Set();
        let lastX = Infinity;
        for(let i = ticks.length - 1; i >= 0; i -= 1){
            const t = ticks[i];
            if (!scale.inWindow(t)) continue;
            const x = scale.x(t);
            if (lastX - x >= labelGap) {
                keep.add(i);
                lastX = x;
            }
        }
        return keep;
    }, [
        ticks,
        scale,
        labelGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        // Decorative by contract (DESIGN.md data-viz rule): the readout and the
        // table view carry the same information for assistive tech.
        "aria-hidden": true,
        focusable: "false",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: axisY
    }), (markers || []).map((m, i)=>{
        if (!scale.inWindow(m.t)) return null;
        const cx = scale.x(m.t);
        const cy = axisY - 20;
        if (m.shape === 'cross') {
            const r = 4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: m.id ?? i,
                stroke: m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy - r,
                x2: cx + r,
                y2: cy + r
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy + r,
                x2: cx + r,
                y2: cy - r
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            key: m.id ?? i,
            cx: cx,
            cy: cy,
            r: "4.5",
            fill: m.filled ? m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            stroke: m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            strokeWidth: "2"
        });
    }), formatTick && ticks.map((t, i)=>{
        if (!labelled.has(i)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: i,
            x: scale.x(t),
            y: height - 5,
            textAnchor: "middle",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            style: {
                fontSize: '0.625rem'
            }
        }, formatTick(t, i));
    }));
};
var $88ed18dfb45d0422$export$2e2bcd8739ae039 = $88ed18dfb45d0422$var$TimeRuler;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SeriesLane — one measurement plotted against a SHARED time axis.
//
// The time-domain sibling of `TrendChart`. The two are deliberately different
// components rather than one with a mode, because they answer different
// questions and their x-axes are not the same kind of thing:
//
//   TrendChart  — one series, standalone, points spaced by INDEX. «How has this
//                 analyte moved?» Even spacing is a feature there: it spends
//                 every pixel on shape, and a lone chart has nothing to align to.
//   SeriesLane  — points sit at their real TIMESTAMPS on a domain the caller
//                 owns, so several lanes stack into one timeline and a vertical
//                 line means «the same moment» in all of them.
//
// Multiple series per lane are for the components of ONE measurement (systolic
// and diastolic), never for unrelated metrics: those get their own lane with
// their own value scale. Two unrelated measures sharing one y-axis is the
// dual-axis mistake, and it invents correlations that are not in the data.
//
//   series      — [{ points:[{x,y,status?,id?}], color?, label? }] (x = ms, sorted)
//   refLow/High — reference band + the window it must stay inside
//   ticks       — the shared gridline timestamps
//   formatValue — value-axis labels; the caller owns the locale/digits
// ─────────────────────────────────────────────────────────────────────────────
const $db32618d5eb876e6$var$PAD_TOP = 10;
const $db32618d5eb876e6$var$PAD_BOTTOM = 8;
const $db32618d5eb876e6$var$SeriesLane = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, series: series = [], refLow: refLow, refHigh: refHigh, height: height = 88, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, gridLines: gridLines = 2, formatValue: formatValue = (v)=>String(Math.round(v * 10) / 10), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const lanes = (series || []).map((s)=>({
            ...s,
            points: (s.points || []).filter((p)=>p && Number.isFinite(p.y))
        })).filter((s)=>s.points.length);
    const all = lanes.flatMap((s)=>s.points.map((p)=>p.y));
    if (!all.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    // The value window always contains the reference band: a result is read
    // against its range, so a band pushed off-canvas would hide the very thing
    // that makes the number mean something.
    const dataMin = Math.min(...all, refLow ?? Infinity);
    const dataMax = Math.max(...all, refHigh ?? -Infinity);
    const span = dataMax - dataMin;
    const lo = dataMin - (span * 0.18 || Math.abs(dataMin * 0.1) || 1);
    const hi = dataMax + (span * 0.18 || Math.abs(dataMax * 0.1) || 1);
    const range = hi - lo || 1;
    const plotTop = $db32618d5eb876e6$var$PAD_TOP;
    const plotBottom = height - $db32618d5eb876e6$var$PAD_BOTTOM;
    const yOf = (v)=>plotTop + (plotBottom - plotTop) - (v - lo) / range * (plotBottom - plotTop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": "content",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: scale.x0,
        y: yOf(refHigh),
        width: scale.x1 - scale.x0,
        height: Math.max(1, Math.abs(yOf(refLow) - yOf(refHigh))),
        fill: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.09)
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = Math.round(yOf(v)) + 0.5;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: `g${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: scale.x0,
            x2: scale.x1,
            y1: y,
            y2: y,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: scale.x0 - 6,
            y: y + 3,
            textAnchor: "end",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            style: {
                fontSize: '0.5625rem'
            }
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: plotTop,
        bottom: plotBottom
    }), lanes.map((s, si)=>{
        const color = s.color || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent;
        const inWin = s.points.filter((p)=>p.x >= scale.min && p.x <= scale.max);
        if (!inWin.length) return null;
        const path = inWin.map((p)=>`${scale.x(p.x).toFixed(1)},${yOf(p.y).toFixed(1)}`).join(' ');
        // Dots thin when dense, but an out-of-range reading is never thinned
        // away — the abnormal point is the one the doctor came for.
        const dots = (0, $95e851aef96b9382$export$849b7cb2b6ea39a7)(inWin, scale, 9, (p)=>!!p.status && p.status !== 'normal');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: s.id ?? si
        }, inWin.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: path,
            fill: "none",
            stroke: color,
            strokeWidth: "2",
            strokeLinejoin: "round",
            strokeLinecap: "round"
        }), dots.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: p.id ?? i,
                cx: scale.x(p.x),
                cy: yOf(p.y),
                r: "3.5",
                fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                stroke: (0, $33096ab4a7258714$export$348dc3495f07d294)(p.status, color),
                strokeWidth: "2"
            })));
    }));
};
var $db32618d5eb876e6$export$2e2bcd8739ae039 = $db32618d5eb876e6$var$SeriesLane;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// IntervalBars — spans of time as bars on a shared axis (a Gantt lane).
//
// Some facts are not points: a prescription is an exposure window, a shift is a
// span of coverage. Plotted as intervals against the same clock as the
// measurement lanes, they answer the question a dot never can — «was this
// running while that changed?».
//
//   rows  — [{ id, label, segments: [{ from, to, label?, tone?, open? }] }]
//           `to == null` (or open) ⇒ still running: the bar reaches `nowAt`
//           and takes an arrow cap instead of a flat end.
//
// Adjacent segments of one row are separated by a 2px gap in the surface
// colour — never a stroke around the bar: the gap is the separator, a border
// would add ink that is not data. That gap is also how a dosage change reads
// as a change rather than one long uninterrupted bar.
// ─────────────────────────────────────────────────────────────────────────────
const $c413dd52a563653b$var$SEG_GAP = 2;
// SVG has no text-overflow, and slicing a string is the wrong tool for a label
// that may be RTL: cutting Persian text and appending «…» puts the ellipsis on
// the visually *leading* edge, so the label reads as though its beginning were
// missing. So a label is drawn only when it fits whole (measure-free estimate at
// the label's font size, ~6.2px/char for the mixed fa/Latin names this carries);
// otherwise it is dropped and the value lives in the row header and the table.
// «A label that won't fit doesn't get clipped.»
const $c413dd52a563653b$var$CHAR_W = 6.2;
const $c413dd52a563653b$var$labelFits = (label, room)=>String(label).length * $c413dd52a563653b$var$CHAR_W <= room;
const $c413dd52a563653b$var$IntervalBars = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, rows: rows = [], rowHeight: rowHeight = 26, barThickness: barThickness = 15, height: height, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, formatLabel: formatLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const h = height || Math.max(rowHeight, rows.length * rowHeight + 8);
    const r = barThickness / 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": rows.length ? 'content' : 'empty',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), rows.map((row, ri)=>{
        const cy = 4 + ri * rowHeight + rowHeight / 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: row.id ?? ri
        }, (row.segments || []).map((seg, si)=>{
            const open = seg.open || seg.to == null;
            const rawTo = open ? nowAt ?? scale.max : seg.to;
            if (seg.from > scale.max || rawTo < scale.min) return null;
            const x1 = scale.clampX(seg.from);
            // The gap belongs to every segment but the row's last one.
            const isLast = si === row.segments.length - 1;
            const x2 = Math.max(x1 + 2, scale.clampX(rawTo) - (isLast ? 0 : $c413dd52a563653b$var$SEG_GAP));
            const w = Math.max(2, x2 - x1);
            const tone = seg.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).navy;
            const label = formatLabel ? formatLabel(seg, row) : seg.label;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: seg.id ?? si
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                x: x1,
                y: cy - r,
                width: w,
                height: barThickness,
                rx: Math.min(4, r),
                fill: tone
            }), open && scale.inWindow(rawTo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: `M${x2 - 1},${cy - r} L${x2 + 6},${cy} L${x2 - 1},${cy + r} Z`,
                fill: tone
            }), label && w > 52 && $c413dd52a563653b$var$labelFits(label, w - 14) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
                x: x1 + w / 2,
                y: cy + 3.5,
                textAnchor: "middle",
                fill: "#ffffff",
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    direction: 'rtl'
                }
            }, label));
        }));
    }));
};
var $c413dd52a563653b$export$2e2bcd8739ae039 = $c413dd52a563653b$var$IntervalBars;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// EventMarkers — discrete moments on a shared time axis.
//
// The lane for things that happen rather than things that are measured: a
// diagnosis recorded, an order placed, a document filed. Each mark carries its
// identity in its SHAPE and its row as well as its tone, so the lane still
// reads under colour-blindness, in monochrome print, and — the case that
// actually bites — under an accent preset where two brand hues sit close
// together. Colour reinforces identity here; it never carries it alone.
//
//   events — [{ id, t, row, label, tone, shape }]
//            shape: 'triangle' | 'diamond' | 'circle' | 'square'
//            row:   0-based lane row (events of a kind share a row)
//
// Labels are placed left→right and only when they clear the previous label on
// the same row; the rest stay reachable through the crosshair readout and the
// table view. A dense month is normal for a sick patient, and overlapping
// labels would make exactly those months unreadable.
// ─────────────────────────────────────────────────────────────────────────────
const $b578d6619b9c2e00$var$SHAPES = {
    triangle: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy + s * 0.8} L${cx - s},${cy + s * 0.8} Z`,
    diamond: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy} L${cx},${cy + s} L${cx - s},${cy} Z`,
    square: (cx, cy, s)=>`M${cx - s},${cy - s} L${cx + s},${cy - s} L${cx + s},${cy + s} L${cx - s},${cy + s} Z`
};
const $b578d6619b9c2e00$var$CHAR_W = 5.6;
const $b578d6619b9c2e00$var$EventMarkers = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, events: events = [], rows: rows = 1, rowHeight: rowHeight = 22, height: height, size: size = 5, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, showLabels: showLabels = true, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const h = height || rows * rowHeight + 10;
    // Declutter per row, walking forward; `labelEnd` tracks where the last
    // printed label finished so the next one only prints if it clears it.
    const placed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rowEnd = {};
        return [
            ...events
        ].filter((e)=>scale.inWindow(e.t)).sort((a, b)=>a.t - b.t).map((e)=>{
            const x = scale.x(e.t);
            const row = e.row || 0;
            const textW = String(e.label || '').length * $b578d6619b9c2e00$var$CHAR_W;
            const start = x + 9;
            const show = showLabels && !!e.label && start >= (rowEnd[row] ?? -Infinity) + 8;
            if (show) rowEnd[row] = start + textW;
            return {
                ...e,
                x: x,
                row: row,
                showLabel: show
            };
        });
    }, [
        events,
        scale,
        showLabels
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": events.length ? 'content' : 'empty',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), placed.map((e, i)=>{
        const cy = 6 + e.row * rowHeight + rowHeight / 2;
        const tone = e.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent;
        const path = $b578d6619b9c2e00$var$SHAPES[e.shape];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: e.id ?? i
        }, path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: path(e.x, cy, size + 1),
            fill: tone,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            strokeWidth: "1.5"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: e.x,
            cy: cy,
            r: size,
            fill: tone,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            strokeWidth: "1.5"
        }), e.showLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: e.x + 9,
            y: cy + 3.5,
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
            style: {
                fontSize: '0.625rem'
            }
        }, e.label));
    }));
};
var $b578d6619b9c2e00$export$2e2bcd8739ae039 = $b578d6619b9c2e00$var$EventMarkers;




var $acw62 = parcelRequire("acw62");
'use client';
function $28afc58f3cd2c6a9$export$7266b1e659c4866f(initial = 640) {
    const [width, setWidth] = (0, $acw62.useState)(initial);
    const observerRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // Expose the node on the callback ref itself.
        ref.current = node;
        if (!node) return;
        const read = ()=>{
            const w = node.clientWidth || node.getBoundingClientRect?.().width || 0;
            // Sub-pixel jitter would re-render every lane on every scroll.
            if (w > 0) setWidth((prev)=>Math.abs(prev - w) >= 0.5 ? w : prev);
        };
        read();
        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(read);
            ro.observe(node);
            observerRef.current = ro;
        }
    }, []);
    return [
        ref,
        width
    ];
}
var $28afc58f3cd2c6a9$export$2e2bcd8739ae039 = $28afc58f3cd2c6a9$export$7266b1e659c4866f;





var $acw62 = parcelRequire("acw62");
'use client';
function $f1d9659251ef0350$export$2e2bcd8739ae039(ref, varName = '--app-bottom-dock', enabled = true) {
    (0, $acw62.useEffect)(()=>{
        const el = ref?.current;
        if (!enabled || !el || !varName || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(varName, `${Math.round(el.offsetHeight)}px`);
        publish();
        // Absent in jsdom and older webviews; the one-shot measurement stands in.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(varName);
        };
    }, [
        ref,
        varName,
        enabled
    ]);
}







var $acw62 = parcelRequire("acw62");
function $1cf0083ab82acba7$export$8f772b88f40431ca({ pairingUrl: pairingUrl, getToken: getToken, headers: headers, loadSession: loadSession, unlinkSession: unlinkSession, pollWhileDisconnected: pollWhileDisconnected = false } = {}) {
    const [session, setSession] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    // The live pairing attempt: { kind, code, expiresAt, message } or null.
    const [pairing, setPairing] = (0, $acw62.useState)(null);
    const controller = (0, $acw62.useRef)(null);
    // The callers are re-created on every render by most call sites, and a
    // dependency on them would restart the effects below forever. The ref is read
    // at call time, so the newest one is always the one used.
    const io = (0, $acw62.useRef)({
        getToken: getToken,
        headers: headers,
        loadSession: loadSession,
        unlinkSession: unlinkSession
    });
    (0, $acw62.useEffect)(()=>{
        io.current = {
            getToken: getToken,
            headers: headers,
            loadSession: loadSession,
            unlinkSession: unlinkSession
        };
    });
    const refetch = (0, $acw62.useCallback)(async ()=>{
        try {
            const next = await io.current.loadSession?.() || null;
            setSession(next);
            setError(null);
            return next;
        } catch (err) {
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    const stopPairing = (0, $acw62.useCallback)(()=>{
        // Aborting closes the HTTP response, which the BFF turns into a gRPC cancel.
        // Without it the gateway holds a fresh, half-linked device open for the full
        // three-minute window and the phone accumulates abandoned entries in its
        // «linked devices» list.
        controller.current?.abort();
        controller.current = null;
        setPairing(null);
    }, []);
    // Whatever happens — a tab closed, a route change, a component unmounted — the
    // stream must not outlive the screen that opened it.
    (0, $acw62.useEffect)(()=>()=>{
            controller.current?.abort();
        }, []);
    // DISCONNECTED is transient and recovers on its own, which is why a screen that
    // gates an action on the link may ask to watch it: somebody who fixes the link
    // in another tab must see the action become available without reopening
    // anything. Opt-in, because a settings page has no such need and a poll nobody
    // is watching is a request nobody wanted. PAIRING is NOT polled — the stream
    // delivers it.
    (0, $acw62.useEffect)(()=>{
        if (!pollWhileDisconnected || session?.state !== 'DISCONNECTED') return undefined;
        const timer = setInterval(refetch, 2500);
        return ()=>clearInterval(timer);
    }, [
        pollWhileDisconnected,
        session?.state,
        refetch
    ]);
    const startLink = (0, $acw62.useCallback)(async (method, phone)=>{
        stopPairing();
        // A new attempt clears the last one's failure. Without this the screen keeps
        // reporting a gateway that was down two minutes ago while a code is on the way.
        setError(null);
        const token = await io.current.getToken?.();
        if (!token) throw new Error('Not authenticated');
        const url = new URL(pairingUrl, typeof window === 'undefined' ? undefined : window.location.origin);
        url.searchParams.set('method', method === 'PAIRING_CODE' ? 'PAIRING_CODE' : 'QR');
        if (phone) url.searchParams.set('phone', phone);
        const ctrl = new AbortController();
        controller.current = ctrl;
        const extra = typeof io.current.headers === 'function' ? io.current.headers() || {} : io.current.headers || {};
        let res;
        try {
            res = await fetch(url.toString(), {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'text/event-stream',
                    ...extra
                },
                signal: ctrl.signal
            });
        } catch (err) {
            // AN ABORT IS NOT A FAILURE, and reporting it as one is a bug users meet
            // constantly: while a code is slow to arrive the screen looks dead, so
            // people press the button again — or switch from QR to the typed code —
            // and THAT aborts this request. Rethrowing put the browser's own
            // «signal is aborted without reason» on a Persian screen, as the reason
            // the attempt they had just started had failed.
            //
            // `readStream` has always swallowed its own aborts for this reason; this
            // is the same rule on the half of the request that happens before the
            // stream exists.
            if (err?.name === 'AbortError') return false;
            throw err;
        }
        if (!res.ok || !res.body) {
            const body = await res.json().catch(()=>null);
            controller.current = null;
            // The BFF's own sentence when it has one — it knows whether this was a
            // missing permission, a missing account or an unreachable gateway, and the
            // screen does not. It travels as `serverMessage` rather than as the
            // Error's own message, so a caller that renders it cannot accidentally
            // render a DOMException's English text the same way. Absent on purpose
            // when the BFF said nothing: copy belongs in the caller's catalogue.
            const refusal = new Error(body?.error || 'pairing refused');
            refusal.serverMessage = body?.error || '';
            throw refusal;
        }
        setPairing({
            kind: 'CONNECTING',
            code: '',
            expiresAt: null,
            message: ''
        });
        // Deliberately not awaited: the stream lives for as long as the pairing does,
        // and the caller needs its button back the moment the first code can arrive.
        $1cf0083ab82acba7$var$readStream(res.body, ctrl, controller, {
            setPairing: setPairing,
            refetch: refetch,
            setError: setError
        });
        return true;
    }, [
        pairingUrl,
        refetch,
        stopPairing
    ]);
    const unlink = (0, $acw62.useCallback)(async ()=>{
        stopPairing();
        await io.current.unlinkSession?.();
        await refetch();
    }, [
        refetch,
        stopPairing
    ]);
    return {
        session: session,
        loading: loading,
        error: error,
        pairing: pairing,
        refetch: refetch,
        startLink: startLink,
        stopPairing: stopPairing,
        unlink: unlink,
        /** The one state where a message can actually leave the building. */ canSend: session?.state === 'CONNECTED'
    };
}
/**
 * Reads SSE frames off the response body.
 *
 * Frames are separated by a blank line and a frame's `data:` is one JSON object.
 * Lines beginning `:` are the server's keep-alive comments and carry nothing —
 * they exist so an intermediary does not close a connection that is idle between
 * two QR codes.
 */ async function $1cf0083ab82acba7$var$readStream(body, ctrl, controller, { setPairing: setPairing, refetch: refetch, setError: setError }) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
        for(;;){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            let split;
            while((split = buffer.indexOf('\n\n')) >= 0){
                const frame = buffer.slice(0, split);
                buffer = buffer.slice(split + 2);
                const parsed = $1cf0083ab82acba7$export$9616b51a1be2e082(frame);
                if (!parsed) continue;
                if (parsed.event === 'error') {
                    // Server copy, or nothing — see the comment on the failed-response branch.
                    setError(new Error(parsed.data?.message || ''));
                    setPairing(null);
                    continue;
                }
                const { kind: kind, code: code, expiresInSeconds: expiresInSeconds, message: message } = parsed.data || {};
                if (kind === 'SUCCESS') {
                    setPairing(null);
                    await refetch();
                    continue;
                }
                if (kind === 'TIMEOUT' || kind === 'ERROR') {
                    setPairing({
                        kind: kind,
                        code: '',
                        expiresAt: null,
                        message: message || ''
                    });
                    continue;
                }
                setPairing({
                    kind: kind || 'QR',
                    code: code || '',
                    // An absolute instant, not a countdown: a component that re-renders for
                    // its own reasons must not restart the clock.
                    expiresAt: expiresInSeconds > 0 ? new Date(Date.now() + expiresInSeconds * 1000).toISOString() : null,
                    message: message || ''
                });
            }
        }
    } catch (err) {
        // An abort is this hook's own doing — the operator navigated away — and is
        // not a failure to report.
        if (err?.name !== 'AbortError') setError(err);
    } finally{
        // The stream that just finished may not be the one now in flight: pressing
        // «اتصال» twice aborts the first, and its cleanup must not wipe the second
        // one's code off the screen.
        if (controller.current === ctrl) {
            controller.current = null;
            setPairing(null);
        }
    }
}
function $1cf0083ab82acba7$export$9616b51a1be2e082(frame) {
    let event = 'message';
    const data = [];
    for (const line of String(frame).split('\n')){
        if (!line || line.startsWith(':')) continue;
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trim());
    }
    if (!data.length) return null;
    try {
        return {
            event: event,
            data: JSON.parse(data.join('\n'))
        };
    } catch  {
        return null;
    }
}
var $1cf0083ab82acba7$export$2e2bcd8739ae039 = $1cf0083ab82acba7$export$8f772b88f40431ca;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Clock", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16 14",
            key: "68esgv"
        }
    ]
]);




'use client';
/**
 * ChatBubble — one message in a conversation (kit-grade per DESIGN-CONCEPT
 * §17.2: tokens only, logical properties only, language-free, presentational).
 *
 * The chat-spec decisions this component encodes so no app re-derives them:
 *
 *  - **Alignment is `alignSelf`, never a margin hack.** `flex-end` for my
 *    messages, `flex-start` for the other party — logical values, so the whole
 *    conversation mirrors correctly under `dir="ltr"` with no direction prop.
 *  - **Radius 14px card scale (`0.875rem`) with a 10px "tail" corner**
 *    (`var(--radius, 0.625rem)`): the reduced corner sits on the block-end,
 *    *inline-start-or-end* edge nearest the sender — `borderEndEndRadius` on
 *    mine, `borderEndStartRadius` on theirs. Logical corners: the tail flips
 *    with the document direction by itself.
 *  - **No `•` separator ever** — the meta row (time + status) is a space-gap
 *    flex layout.
 *  - **A failed write must look failed**: `failed` restyles the surface from
 *    the `CT.danger*` family and renders a retry affordance; the caller decides
 *    when to actually re-send (`onRetry`).
 *  - **Delivery state is never colour-only.** Pass `status` and the bubble
 *    draws the glyph itself — `Clock` / `Check` / `TriangleAlert` — so the
 *    difference between "sending", "sent" and "failed" survives a colour-blind
 *    reader and a greyscale screen (DESIGN-CONCEPT §12 "colour is never the
 *    only carrier of meaning"). Apps do not ship their own dot.
 *
 * States (always stamped on the root as `data-state`): `sent` | `pending`
 * (60% opacity — visibly in flight) | `failed`.
 *
 * The root stays a plain div forwarding `...rest`; `role="listitem"` and any
 * grouping semantics are the caller's business.
 *
 * Props:
 *   body        — message text (rendered `dir="auto"`, pre-wrap, wraps anywhere)
 *   timeLabel   — pre-formatted time string; the calendar/locale stays with the app
 *   mine        — true for the authenticated user's own messages
 *   pending     — in-flight local echo (awaiting the server)
 *   failed      — the send failed; renders the retry affordance when `onRetry` given
 *   status      — 'pending' | 'sent' | 'failed': draws the delivery glyph. This
 *                 is the supported way to show delivery state; `statusLabel`
 *                 names it for screen readers.
 *   statusIcon  — escape hatch: a caller-supplied status node, used INSTEAD of
 *                 the built-in glyph
 *   statusLabel — screen-reader text for the status glyph (an icon alone says
 *                 nothing). NOTE: `statusLabel` on its own draws nothing
 *                 visible — it is the accessible name of a glyph, so it needs
 *                 `status` (or `statusIcon`) beside it. Dev builds warn.
 *   onRetry     — re-send handler; button rendered only when `failed`
 *   retryLabel  — label for the retry affordance
 *   style       — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // The delivery vocabulary the kit draws. Three states, three shapes — the
// glyph, not the hue, is what distinguishes them.
const $a6342f4e7688b45e$var$STATUS_GLYPH = {
    pending: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
    sent: (0, $8240f8fcfc513968$export$2e2bcd8739ae039),
    failed: (0, $00824d397ec63c04$export$2e2bcd8739ae039)
};
function $a6342f4e7688b45e$export$2e2bcd8739ae039({ body: body, timeLabel: timeLabel, mine: mine = false, pending: pending = false, failed: failed = false, status: status, statusIcon: statusIcon, statusLabel: statusLabel, onRetry: onRetry, retryLabel: retryLabel, className: className, style: style, 'data-testid': testId = 'chat-bubble', ...rest }) {
    const state = failed ? 'failed' : pending ? 'pending' : 'sent';
    // Surface per party; `failed` overrides both — an undelivered message is a
    // problem to act on, not a normal bubble at lower opacity.
    const surface = failed ? {
        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger, 0.4)}`
    } : mine ? {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        color: '#ffffff',
        border: 'none'
    } : {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
    };
    // Meta ink follows the surface. On navy the safe soft ink is literal white at
    // reduced opacity (colour arithmetic on a var() token is banned — soft() would
    // work, but #fff is the one sanctioned literal on navy).
    const metaStyle = failed ? {
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        opacity: 0.8
    } : mine ? {
        color: '#ffffff',
        opacity: 0.75
    } : {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
    };
    const Glyph = status ? $a6342f4e7688b45e$var$STATUS_GLYPH[status] : null;
    // Tint: the muted ink for the two quiet states, the danger ink for a failed
    // write. The one exception is the navy `mine` surface, where a fixed grey is
    // simply unreadable — there the glyph inherits the meta row's ink, which is
    // already the muted value FOR that surface. Same intent, legible result.
    const glyphColor = mine && !failed ? 'currentColor' : status === 'failed' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute;
    const glyph = statusIcon || (Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        size: 13,
        strokeWidth: 2.25,
        "aria-hidden": true,
        style: {
            color: glyphColor
        }
    }) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: mine ? 'flex-end' : 'flex-start',
            // Alignment via alignSelf ONLY — never marginInline hacks, never textAlign.
            alignSelf: mine ? 'flex-end' : 'flex-start',
            maxWidth: 'min(85%, 42rem)',
            gap: '0.25rem',
            // Caller style MERGES over the computed layout (the `Card` precedent) —
            // spreading it after `...rest` used to silently drop `alignSelf` and
            // take mine/theirs alignment with it.
            ...style
        },
        ...rest,
        // AFTER ...rest: the delivery state is derived, not caller-supplied.
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...surface,
            borderRadius: '0.875rem',
            // The "tail": the corner nearest the sender drops to the base radius.
            ...mine ? {
                borderEndEndRadius: 'var(--radius, 0.625rem)'
            } : {
                borderEndStartRadius: 'var(--radius, 0.625rem)'
            },
            padding: '0.5rem 0.875rem',
            ...pending && {
                opacity: 0.6
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.875rem',
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere'
        }
    }, body), (timeLabel || glyph || statusLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '0.375rem',
            marginTop: '0.125rem',
            fontSize: '0.75rem',
            ...metaStyle
        }
    }, timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, timeLabel), glyph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": statusLabel,
        style: {
            display: 'inline-flex',
            alignItems: 'center'
        }
    }, glyph), !glyph && statusLabel && // Misuse (warned above), but the fact is not thrown away: assistive
    // tech still gets the delivery state.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            width: 1,
            height: 1,
            margin: -1,
            padding: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            border: 0
        }
    }, statusLabel))), failed && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onRetry,
        "data-testid": `${testId}-retry`,
        // size="sm" is 2.25rem; this renders on both apps' phone threads,
        // where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger
        }
    }, retryLabel));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $01fd1e3fa9bffaa8$export$2e2bcd8739ae039({ label: label, className: className, style: style, 'data-testid': testId = 'chat-day-divider', ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            paddingBlock: '0.5rem',
            // Caller style MERGES over the computed layout (the `Card` precedent):
            // arriving inside `...rest` it used to replace `display: flex` outright
            // and collapse the two hairlines.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            paddingInline: '0.625rem',
            borderRadius: 'var(--radius, 0.625rem)',
            whiteSpace: 'nowrap'
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $84e37213187279fb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Send", [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
]);






'use client';
function $27c9e9585cb6c9b4$export$2e2bcd8739ae039({ value: value, onChange: onChange, onSend: onSend, disabled: disabled = false, sending: sending = false, placeholder: placeholder, sendLabel: sendLabel, sendIcon: sendIcon, readOnlyNotice: readOnlyNotice, maxLength: maxLength = 4000, autoGrowMaxRem: autoGrowMaxRem = 7.5, className: className, style: style, 'data-testid': testId = 'chat-composer', inputProps: inputProps, ...rest }) {
    const fieldRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Auto-grow: collapse, then take the content's scrollHeight. The rem clamp
    // lives in CSS (`maxHeight`), so the px assignment here never exceeds it and
    // the field starts scrolling instead of growing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = fieldRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [
        value,
        readOnlyNotice
    ]);
    if (readOnlyNotice) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            padding: '0.5rem 1rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        },
        ...rest,
        "data-state": "readonly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "info",
        "data-testid": `${testId}-notice`
    }, readOnlyNotice));
    const canSend = !disabled && !sending && Boolean(value && value.trim());
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter' || e.shiftKey) return;
        // Committing IME composition ends with Enter too — that one is not a send.
        if (e.nativeEvent && e.nativeEvent.isComposing) return;
        e.preventDefault();
        if (canSend) onSend();
    };
    const { className: fieldClassName, style: fieldStyle, ...fieldRest } = inputProps || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            // Caller style MERGES over the computed layout (the `Card` precedent).
            ...style
        },
        ...rest,
        // AFTER ...rest: the send lifecycle is the composer's own state.
        "data-state": sending ? 'sending' : 'ready'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: fieldRef,
        value: value,
        onChange: onChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        "aria-label": placeholder,
        disabled: disabled || sending,
        rows: 1,
        maxLength: maxLength,
        dir: "auto",
        "data-testid": `${testId}-field`,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// The replacement for the outline we suppress — keyboard focus on the
        // feature's primary input has to be visible (§12.2).
        'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', 'transition-shadow duration-150', fieldClassName),
        style: {
            flex: 1,
            minWidth: 0,
            // ≥1rem or iOS zooms the page on focus — the composer's iron rule.
            fontSize: '1rem',
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 'var(--radius, 0.625rem)',
            padding: '0.625rem 0.875rem',
            resize: 'none',
            maxHeight: `${autoGrowMaxRem}rem`,
            overflowY: 'auto',
            ...disabled || sending ? {
                opacity: 0.6
            } : null,
            ...fieldStyle
        },
        ...fieldRest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        icon: sendIcon || // RTL-first flip — see the header note; LTR apps override via sendIcon.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $84e37213187279fb$export$2e2bcd8739ae039), {
            size: 18,
            "aria-hidden": true,
            style: {
                transform: 'scaleX(-1)'
            }
        }),
        label: sendLabel,
        onClick: ()=>{
            if (canSend) onSend();
        },
        disabled: !canSend,
        "data-testid": `${testId}-send`
    }));
}



var $acw62 = parcelRequire("acw62");



'use client';
/**
 * ChatThread — the message column of a conversation (kit-grade per
 * DESIGN-CONCEPT §17.2). A flex column of `ChatBubble`/`ChatDayDivider`
 * children with the two behaviours every thread needs and no app should
 * re-derive:
 *
 *  - **Backwards pagination is a button, never a scroll trigger** (the
 *    pagination-not-infinite-scroll rule): when `hasOlder`, a ghost expander
 *    sits at the top of the thread; `loadingOlder` disables it and shows the
 *    kit spinner.
 *  - **Containment-safe autoscroll**: when the children count grows and the
 *    user was at/near the bottom (within ~4rem), the thread follows — by
 *    assigning `scrollTop` on the **resolved scroll container**, NEVER
 *    `scrollIntoView`, which walks every ancestor scroller and yanks the whole
 *    page in an embedded pane. A reader scrolled up into history is never
 *    yanked down, and a prepended older page never triggers it.
 *
 * Two containment modes via `fill`:
 *   true  — the thread IS the scroll container (`flex: 1; minHeight: 0;
 *           overflowY: auto`) for a desktop pane (the doctor app's P4 column);
 *   false — the thread sits in page flow and something ABOVE it scrolls.
 *
 * **Resolving the scroller (why this is not `document.scrollingElement`).**
 * In `fill={false}` mode the scroller is whatever ancestor actually scrolls,
 * and on a phone that is almost never the document: both mobile shells are
 * `inset: 0; overflow: hidden` with a single inner `overflow-y: auto` region.
 * Writing `document.scrollingElement.scrollTop` there lands on an element that
 * cannot scroll, and listening on `window` never fires, so the sampled gap
 * stays at its seed and autoscroll is silently dead. So the component walks
 * `containerRef.current.parentElement` upward for a computed `overflowY` of
 * `auto`/`scroll` and uses the first hit — falling back to
 * `document.scrollingElement` for a genuinely page-scrolled surface. The result
 * is cached per mount and re-resolved if the container node itself changes.
 * Callers may name the scroller explicitly with `scrollParentRef` instead.
 *
 * `role="log"` + `aria-live="polite"`: new messages are announced without
 * interrupting, and assistive tech knows earliest-first ordering applies.
 *
 * Exposes `scrollToBottom()` via ref for the caller's "jump to latest"
 * affordances.
 *
 * Props:
 *   children       — the message column (bubbles, day dividers)
 *   fill           — scroll-container mode (see above; default false)
 *   padBlockRem    — block padding in rem. Pass this instead of
 *                    `style={{ paddingBlock }}`: `style` is merged now, but a
 *                    named prop keeps the caller out of the layout entirely.
 *   hasOlder       — render the load-older expander
 *   onLoadOlder    — expander handler
 *   loadingOlder   — expander busy state (disabled + spinner)
 *   loadOlderLabel — expander label
 *   autoScroll     — follow new messages when near the bottom (default true)
 *   scrollParentRef— optional ref to the scroll container, skipping resolution
 *   style          — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // "Near the bottom" — ~4rem at the default type scale. Close enough that the
// reader is clearly following the conversation, not studying history.
const $af5a908f2b99a71b$var$NEAR_BOTTOM_PX = 64;
const $af5a908f2b99a71b$var$SCROLLY = new Set([
    'auto',
    'scroll',
    'overlay'
]);
const $af5a908f2b99a71b$var$ChatThread = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChatThread({ children: children, fill: fill = false, padBlockRem: padBlockRem, hasOlder: hasOlder = false, onLoadOlder: onLoadOlder, loadingOlder: loadingOlder = false, loadOlderLabel: loadOlderLabel, autoScroll: autoScroll = true, scrollParentRef: scrollParentRef, className: className, style: style, 'data-testid': testId = 'chat-thread', ...rest }, ref) {
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Distance from the bottom edge, sampled on every scroll — read (not
    // recomputed) when children arrive, so the decision reflects where the user
    // WAS before the DOM grew. Starts at 0: opening a thread lands on the latest
    // message.
    const bottomGapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const prevCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // The resolved scroller, cached per mount, plus the container node it was
    // resolved FROM — a `key` swap gives us a new node and must re-resolve.
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollerForRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Set while a backwards page is being prepended, so the growth it causes is
    // not mistaken for a new message. Without it a short thread — one that never
    // scrolled, so the sampled gap is still its 0 seed — passes the near-bottom
    // guard and yanks the reader away from the «older» button they just pressed.
    const prependingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children);
    const resolveScroller = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = containerRef.current;
        if (!el) return null;
        // `fill` — the thread IS the scroller; nothing to walk.
        if (fill) return el;
        if (scrollParentRef && scrollParentRef.current) return scrollParentRef.current;
        if (scrollerForRef.current === el && scrollerRef.current) return scrollerRef.current;
        let found = null;
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') for(let node = el.parentElement; node; node = node.parentElement){
            const overflowY = window.getComputedStyle(node).overflowY;
            if ($af5a908f2b99a71b$var$SCROLLY.has(overflowY)) {
                found = node;
                break;
            }
        }
        // Nothing between here and the root scrolls → the page really does.
        if (!found && typeof document !== 'undefined') found = document.scrollingElement;
        scrollerRef.current = found;
        scrollerForRef.current = el;
        return found;
    }, [
        fill,
        scrollParentRef
    ]);
    const sampleGap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) bottomGapRef.current = el.scrollHeight - el.scrollTop - el.clientHeight;
    }, [
        resolveScroller
    ]);
    const scrollToBottom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) el.scrollTop = el.scrollHeight; // the scroller itself — containment-safe
        bottomGapRef.current = 0;
    }, [
        resolveScroller
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            scrollToBottom: scrollToBottom
        }), [
        scrollToBottom
    ]);
    // Sample the gap from whatever actually scrolls.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const el = resolveScroller();
        if (!el) return undefined;
        // The viewport's scroll event is dispatched at the Document, not at <html>,
        // so a document-level scroller has to be listened to on `window`.
        const isDocScroller = typeof document !== 'undefined' && (el === document.scrollingElement || el === document.documentElement || el === document.body);
        const target = isDocScroller ? window : el;
        const onScroll = ()=>sampleGap();
        target.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>target.removeEventListener('scroll', onScroll);
    }, [
        resolveScroller,
        sampleGap
    ]);
    // Follow growth only when the reader was already at the bottom.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const prev = prevCountRef.current;
        prevCountRef.current = childCount;
        if (!autoScroll || childCount <= prev) return;
        // Backwards page: the growth is above the reader, never below.
        if (prependingRef.current) {
            prependingRef.current = false;
            return;
        }
        if (bottomGapRef.current <= $af5a908f2b99a71b$var$NEAR_BOTTOM_PX) scrollToBottom();
    }, [
        childCount,
        autoScroll,
        scrollToBottom
    ]);
    // Declared AFTER the growth effect on purpose: when a load-older resolves,
    // both run in the same commit and the growth effect must still see the flag.
    // This one only clears a flag the fetch never spent — an empty or failed page
    // produces no growth, and a stale flag would swallow the next real message.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!loadingOlder) prependingRef.current = false;
    }, [
        loadingOlder
    ]);
    const handleLoadOlder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        prependingRef.current = true;
        onLoadOlder?.(e);
    }, [
        onLoadOlder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "log",
        "aria-live": "polite",
        ref: containerRef,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            paddingInline: '1rem',
            ...padBlockRem != null && {
                paddingBlock: `${padBlockRem}rem`
            },
            ...fill && {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            // Caller style MERGES over the computed layout — it never replaces it.
            // (Same precedent as `Card`.) Anything a caller genuinely needs to own,
            // like block padding, has a named prop.
            ...style
        },
        ...rest,
        // AFTER ...rest: the thread's own busy state is not the caller's to
        // overwrite — a caller-side data-state would hide `loading` forever.
        "data-state": loadingOlder ? 'loading' : 'ready'
    }, hasOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            paddingBlock: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: handleLoadOlder,
        disabled: loadingOlder,
        "data-testid": `${testId}-load-older`,
        // size="sm" is 2.25rem; this control renders on both apps' phone
        // threads, where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, loadingOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 14,
        thickness: 2
    }), loadOlderLabel)), children);
});
var $af5a908f2b99a71b$export$2e2bcd8739ae039 = $af5a908f2b99a71b$var$ChatThread;






var $acw62 = parcelRequire("acw62");

const $393fa4133562fea6$export$6c2d0d964670e2e3 = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
const $393fa4133562fea6$export$fb4a539c21dc93d2 = [
    "\u0634",
    "\u06CC",
    "\u062F",
    "\u0633",
    "\u0686",
    "\u067E",
    "\u062C"
];
const $393fa4133562fea6$export$961e0c326b64dc98 = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[+d]);
const $393fa4133562fea6$export$c7153f4b19854938 = 12600000;
const $393fa4133562fea6$export$710ba58c9cc5d7e7 = ()=>new Date(Date.now() + $393fa4133562fea6$export$c7153f4b19854938);
function $393fa4133562fea6$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $393fa4133562fea6$export$129955be4a159fb3(ms) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = Math.floor((ms - anchor) / 86400000);
    if (!Number.isFinite(days)) return null;
    // Nothing in a medical record predates the Jalali era, so a timestamp that
    // far back is corrupt input. Reject it rather than walk ~270,000 iterations
    // and hand the caller a confident negative year.
    if (days < -520000) return null; // ≈ year 1
    let y = 1400;
    // Before the anchor: step back a year at a time until the day index lands
    // inside one, mirroring the forward walk below.
    while(days < 0){
        y--;
        days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    }
    while(true){
        const diy = $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
function $393fa4133562fea6$export$998538909dbe3791(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29
    ];
    for(let m = 0; m < jm - 1; m++)days += md[m];
    days += jd - 1;
    return anchor + days * 86400000;
}
function $393fa4133562fea6$export$33c90dd38a62167e(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    return $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29;
}
function $393fa4133562fea6$export$748262491e74cb62() {
    const now = $393fa4133562fea6$export$710ba58c9cc5d7e7();
    // Day-of-week in Iran time: getUTCDay() because we manually shifted the clock
    const jsDay = now.getUTCDay(); // 0=Sun … 6=Sat
    const irWeekday = (jsDay + 1) % 7; // 0=ش … 6=ج
    const nowMs = now.getTime(); // already shifted UTC+3:30
    return Array.from({
        length: 7
    }, (_, i)=>{
        const dayMs = nowMs + (i - irWeekday) * 86400000;
        return {
            ...$393fa4133562fea6$export$129955be4a159fb3(dayMs),
            shortName: $393fa4133562fea6$export$fb4a539c21dc93d2[i],
            isToday: i === irWeekday
        };
    });
}






'use client';
/**
 * Date-range filter as a single dropdown.
 *
 * The trigger always reads out the *applied* range ("امروز", "۱۲–۱۸ تیر", "Sep 12–18"), so the
 * active filter is never ambiguous — the older layout left the two date inputs
 * visible next to the preset chips, and a custom range highlighted no chip at all.
 *
 * Props:
 *   presets   — [{ id, label }]; the ids are opaque, the parent maps them to a window
 *   preset    — active preset id, or 'custom'
 *   custom    — { from, to } applied custom range, Gregorian 'YYYY-MM-DD' (picker format)
 *   onPreset  — (id) => void
 *   onCustom  — (from, to) => void; only fired once BOTH ends are picked
 */ // Gregorian 'YYYY-MM-DD' (what JalaliDatePicker emits) → { y, m, d } in the
// calendar the page reads: Jalali for Persian and Arabic, Gregorian for English,
// French and German — the same choice the picker itself makes (lib/datePickerLocale.js).
const $751677fd0a80fd7a$var$partsOf = (s, calendar)=>{
    if (!s || s.length < 10) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return calendar === 'jalali' ? (0, $393fa4133562fea6$export$129955be4a159fb3)(Date.UTC(y, m - 1, d)) : {
        y: y,
        m: m,
        d: d
    };
};
const $751677fd0a80fd7a$var$dayKey = (p)=>p.y * 10000 + p.m * 100 + p.d;
// Month first or day first. Persian, English and Arabic keep the order this label
// has always had, the CALENDAR's: month first on a Gregorian page ("September
// 12–18", «سبتمبر ١٢–١٨» under a Gregorian brand), day first on a Jalali one —
// a live Gregorian brand (Proxia, en + ar) must read exactly as before (PM-0185
// D15). A language added since (French, German) reads its own date template
// instead: «12–18 septembre», «12.–18. September», «12–18 Tir», day first
// whichever calendar the page reads.
const $751677fd0a80fd7a$var$CALENDAR_ORDER = new Set([
    'fa',
    'en',
    'ar'
]);
const $751677fd0a80fd7a$var$monthFirst = (L, locale)=>{
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    if ($751677fd0a80fd7a$var$CALENDAR_ORDER.has(base) || !(0, $0873d4f32691c14e$export$4b8e9f545c94f612)[base]) return L.calendar === 'gregorian';
    return L.date.indexOf('{month}') < L.date.indexOf('{d}');
};
// What a day-first language writes right after the day number, read off the same
// template: German's ordinal dot («{d}. {month} {y}» → «12.–18. September»,
// «30. August – 2. September»); nothing for French. fa/en/ar keep their old label.
const $751677fd0a80fd7a$var$dayMark = (L, locale)=>{
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    if ($751677fd0a80fd7a$var$CALENDAR_ORDER.has(base) || !(0, $0873d4f32691c14e$export$4b8e9f545c94f612)[base]) return '';
    const m = /\{d\}(\S*)\s+\{month\}/.exec(L.date);
    return m ? m[1] : '';
};
function $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale) {
    const L = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale);
    let a = $751677fd0a80fd7a$var$partsOf(fromStr, L.calendar);
    let b = $751677fd0a80fd7a$var$partsOf(toStr, L.calendar);
    if (!a || !b) return (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).dateRange.custom;
    if ($751677fd0a80fd7a$var$dayKey(a) > $751677fd0a80fd7a$var$dayKey(b)) [a, b] = [
        b,
        a
    ];
    const num = (x)=>(0, $0873d4f32691c14e$export$545c62727d3740ae)(x, L.digits);
    const month = (p)=>L.months[L.calendar][p.m - 1];
    if ($751677fd0a80fd7a$var$monthFirst(L, locale)) {
        const md = (p)=>`${month(p)} ${num(p.d)}`;
        if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${md(a)}, ${num(a.y)}`;
        if (a.y === b.y && a.m === b.m) return `${month(a)} ${num(a.d)}\u{2013}${num(b.d)}`;
        if (a.y === b.y) return `${md(a)} \u{2013} ${md(b)}`;
        return `${md(a)}, ${num(a.y)} \u{2013} ${md(b)}, ${num(b.y)}`;
    }
    const mark = $751677fd0a80fd7a$var$dayMark(L, locale);
    const day = (p)=>`${num(p.d)}${mark}`;
    const dm = (p)=>`${day(p)} ${month(p)}`;
    if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${dm(a)} ${num(a.y)}`;
    if (a.y === b.y && a.m === b.m) return `${day(a)}\u{2013}${day(b)} ${month(a)}`;
    if (a.y === b.y) return `${dm(a)} \u{2013} ${dm(b)}`;
    return `${dm(a)} ${num(a.y)} \u{2013} ${dm(b)} ${num(b.y)}`;
}
function $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, fromStr, toStr, presets, locale) {
    if (preset === 'custom') return $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale);
    return (presets.find((p)=>p.id === preset) || {}).label || '';
}
const $751677fd0a80fd7a$var$CalendarIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 3 2 3.9 2 5v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }));
const $751677fd0a80fd7a$var$ChevronIcon = ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "14",
        height: "14",
        fill: "currentColor",
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
const $751677fd0a80fd7a$var$CheckIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));
const $751677fd0a80fd7a$var$PresetRow = ({ label: label, active: active, onClick: onClick })=>{
    const [hov, setHov] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            border: 'none',
            background: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight : hov ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : 'transparent',
            color: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontSize: 13,
            fontWeight: active ? 700 : 500,
            fontFamily: 'inherit',
            cursor: 'pointer',
            textAlign: 'start',
            transition: 'background 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CheckIcon, null));
};
function $751677fd0a80fd7a$export$2e2bcd8739ae039({ presets: presets, preset: preset, custom: custom, onPreset: onPreset, onCustom: onCustom }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    // Draft dates live here, not in the parent: a range is only *applied* once both
    // ends exist, so a half-picked range can never desync the trigger label from the
    // window the list is actually showing.
    const [dFrom, setDFrom] = (0, $acw62.useState)(custom.from);
    const [dTo, setDTo] = (0, $acw62.useState)(custom.to);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setDFrom(custom.from);
            setDTo(custom.to);
        }
    }, [
        open,
        custom.from,
        custom.to
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (!ref.current) return;
            if (ref.current.contains(e.target)) return;
            // The two custom-range fields are `JalaliDatePicker`s, and their calendar
            // is PORTALED to <body> so a clipping ancestor cannot slice it. That puts
            // it outside `ref`, so picking a day counted as an outside click and shut
            // the dropdown before the date could register — which made the custom
            // range unreachable by calendar in every screen that uses this filter.
            if (e.target.closest?.('[data-jalali-popup]')) return;
            setOpen(false);
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open
    ]);
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().dateRange;
    const isCustom = preset === 'custom';
    const label = $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, custom.from, custom.to, presets);
    const halfDone = !!dFrom !== !!dTo;
    const pickPreset = (id)=>{
        onPreset(id);
        setOpen(false);
    };
    const pickFrom = (v)=>{
        setDFrom(v);
        if (v && dTo) {
            onCustom(v, dTo);
            setOpen(false);
        }
    };
    const pickTo = (v)=>{
        setDTo(v);
        if (v && dFrom) {
            onCustom(dFrom, v);
            setOpen(false);
        }
    };
    const highlighted = open || isCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOpen((o)=>!o),
        title: copy.title,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            height: 36,
            padding: '0 12px',
            borderRadius: 8,
            border: `1px solid ${highlighted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: highlighted ? '#fff' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            color: highlighted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CalendarIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$ChevronIcon, {
        open: open
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 'calc(100% + 6px)',
            insetInlineStart: 0,
            zIndex: 60,
            width: 260,
            background: '#fff',
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            boxShadow: '0 12px 36px rgba(0,0,0,0.14)',
            padding: 8
        }
    }, presets.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$PresetRow, {
            key: p.id,
            label: p.label,
            active: preset === p.id,
            onClick: ()=>pickPreset(p.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            margin: '8px 4px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: isCustom ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            padding: '2px 10px 8px'
        }
    }, copy.custom), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: 8,
            padding: '0 4px 4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
        value: dFrom,
        onChange: pickFrom,
        placeholder: copy.from,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
        value: dTo,
        onChange: pickTo,
        placeholder: copy.to,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), halfDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            fontWeight: 600,
            padding: '0 2px'
        }
    }, copy.needBoth))));
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Applies the doctor's accent preset and type scale to <html>.
 *
 * Where the value comes from, in order:
 *   1. localStorage, read synchronously during the first render, so a reload
 *      paints the chosen accent immediately instead of flashing the default
 *      while the `me` query is still in flight.
 *   2. The server copy, pushed in via `appearance` once settings load. That is
 *      the real record and wins whenever it differs — it is how the preference
 *      follows the doctor to another device.
 *
 * Themed values are CSS custom properties (see tokens.css), so switching the
 * preset re-themes every screen without re-rendering anything: this provider
 * only sets two attributes on the root element.
 */ const $54fc473ae52026aa$var$ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $54fc473ae52026aa$export$d8964aec282183a3({ appearance: appearance, children: children }) {
    // Lazy initialiser — runs before first paint, not in an effect.
    const [local, setLocal] = (0, $acw62.useState)(()=>{
        const stored = (0, $e7c165fb515b04ea$export$dde01dc24facb6b0)();
        (0, $e7c165fb515b04ea$export$48c323151b232e54)(stored);
        return stored;
    });
    const serverTheme = appearance?.theme;
    const serverFontSize = appearance?.fontSize;
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // the accent on another device). Nulls mean "not loaded yet" — not "reset".
    (0, $acw62.useEffect)(()=>{
        if (!serverTheme && !serverFontSize) return;
        setLocal((prev)=>{
            const next = {
                theme: serverTheme || prev.theme,
                fontSize: serverFontSize || prev.fontSize
            };
            if (next.theme === prev.theme && next.fontSize === prev.fontSize) return prev;
            const resolved = (0, $e7c165fb515b04ea$export$48c323151b232e54)(next);
            (0, $e7c165fb515b04ea$export$64464588479aad90)(resolved);
            return resolved;
        });
    }, [
        serverTheme,
        serverFontSize
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            theme: local.theme,
            fontSize: local.fontSize,
            // Apply a choice locally and cache it. Two callers:
            //   - the settings picker, so the accent switches under the doctor's cursor
            //     instead of after a server round trip;
            //   - app boot, to adopt the server's copy once `me` resolves.
            // Persisting to the BFF is the caller's job — this only paints and caches.
            setAppearance: (patch)=>{
                setLocal((prev)=>{
                    const resolved = (0, $e7c165fb515b04ea$export$48c323151b232e54)({
                        ...prev,
                        ...patch
                    });
                    (0, $e7c165fb515b04ea$export$64464588479aad90)(resolved);
                    return resolved;
                });
            }
        }), [
        local
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54fc473ae52026aa$var$ThemeContext.Provider, {
        value: value
    }, children);
}
function $54fc473ae52026aa$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($54fc473ae52026aa$var$ThemeContext) ?? {
        theme: (0, $e7c165fb515b04ea$export$2faeed762aac6741),
        fontSize: (0, $e7c165fb515b04ea$export$b1461457ea2c1179),
        setAppearance: ()=>{}
    };
}
var $54fc473ae52026aa$export$2e2bcd8739ae039 = $54fc473ae52026aa$export$d8964aec282183a3;




var $acw62 = parcelRequire("acw62");
'use client';
const $02b96a2843192315$export$df49a36517896dd5 = {
    // ── The Jalali date picker ────────────────────────────────────────────────
    'common.datePicker.placeholder': "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.clear': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.openCalendar': "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
    'common.datePicker.today': "\u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.goToToday': "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.now': "\u0627\u06A9\u0646\u0648\u0646",
    'common.datePicker.hour': "\u0633\u0627\u0639\u062A",
    'common.datePicker.minute': "\u062F\u0642\u06CC\u0642\u0647",
    // `{{unit}}` is one of the two above — a stepper's two arrows are named
    // "hour more" / "hour less" for a screen reader.
    'common.datePicker.increase': "{{unit}} \u0628\u06CC\u0634\u062A\u0631",
    'common.datePicker.decrease': "{{unit}} \u06A9\u0645\u062A\u0631",
    'common.datePicker.previousMonth': "\u0645\u0627\u0647 \u0642\u0628\u0644",
    'common.datePicker.nextMonth': "\u0645\u0627\u0647 \u0628\u0639\u062F",
    'common.datePicker.errors.format': "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: \u06F1\u06F4\u06F0\u06F4/\u06F0\u06F5/\u06F1\u06F2",
    'common.datePicker.errors.range': "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.time': "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.noTime': "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
    'common.datePicker.errors.future': "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A",
    // ── The mobile shell ──────────────────────────────────────────────────────
    // Not visible copy — the bottom bar's accessible name. It is here for the
    // same reason the rest is: a screen reader in an English panel should not
    // announce the navigation in Persian.
    'common.a11y.primaryNav': "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC",
    // ── The date-range filter ─────────────────────────────────────────────────
    'common.dateRange.label': "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
    'common.dateRange.custom': "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
    'common.dateRange.from': "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.to': "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.pickBoth': "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
};
const $02b96a2843192315$export$cdafc612aa9b582a = {
    'common.calendar.months': [
        "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
        "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
        "\u062E\u0631\u062F\u0627\u062F",
        "\u062A\u06CC\u0631",
        "\u0645\u0631\u062F\u0627\u062F",
        "\u0634\u0647\u0631\u06CC\u0648\u0631",
        "\u0645\u0647\u0631",
        "\u0622\u0628\u0627\u0646",
        "\u0622\u0630\u0631",
        "\u062F\u06CC",
        "\u0628\u0647\u0645\u0646",
        "\u0627\u0633\u0641\u0646\u062F"
    ],
    // Saturday-first, one glyph each — the calendar header.
    'common.calendar.weekdaysNarrow': [
        "\u0634",
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C"
    ]
};
/** Persian digits — what the kit has always rendered. */ const $02b96a2843192315$var$toPersianDigits = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
// ── The registry ────────────────────────────────────────────────────────────
//
// Module state rather than context, because it has to be readable from plain
// functions (the date parser's error messages) and not only from components.
// `version` is what makes it REACTIVE: a panel that switches language at
// runtime bumps it, and every mounted kit component re-reads.
let $02b96a2843192315$var$table = null;
let $02b96a2843192315$var$version = 0;
const $02b96a2843192315$var$listeners = new Set();
function $02b96a2843192315$export$bf11b40754c929ae(next) {
    $02b96a2843192315$var$table = next || null;
    $02b96a2843192315$var$version += 1;
    $02b96a2843192315$var$listeners.forEach((notify)=>notify());
}
function $02b96a2843192315$var$subscribe(notify) {
    $02b96a2843192315$var$listeners.add(notify);
    return ()=>$02b96a2843192315$var$listeners.delete(notify);
}
const $02b96a2843192315$var$snapshot = ()=>$02b96a2843192315$var$version;
/** `{{unit}}` → vars.unit. The kit needs no more interpolation than this. */ function $02b96a2843192315$var$interpolate(text, vars) {
    if (!vars) return text;
    return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name)=>vars[name] === undefined ? match : String(vars[name]));
}
function $02b96a2843192315$export$44bc4c060d9b3ece(key, vars) {
    const override = $02b96a2843192315$var$table?.string?.(key);
    const text = override === undefined || override === null ? $02b96a2843192315$export$df49a36517896dd5[key] : override;
    // A key with no default is a bug in the kit, not in the app — surfacing the
    // key beats rendering `undefined` into the DOM.
    return $02b96a2843192315$var$interpolate(text === undefined ? key : text, vars);
}
function $02b96a2843192315$export$d041a4afca2888c(key) {
    const override = $02b96a2843192315$var$table?.list?.(key);
    return Array.isArray(override) ? override : $02b96a2843192315$export$cdafc612aa9b582a[key] || [];
}
function $02b96a2843192315$export$aa5144520a3863d7(value) {
    const override = $02b96a2843192315$var$table?.number?.(value);
    return override === undefined || override === null ? $02b96a2843192315$var$toPersianDigits(value) : String(override);
}
function $02b96a2843192315$export$ee19af4091ffbbfc() {
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore($02b96a2843192315$var$subscribe, $02b96a2843192315$var$snapshot, $02b96a2843192315$var$snapshot);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            t: $02b96a2843192315$export$44bc4c060d9b3ece,
            list: $02b96a2843192315$export$d041a4afca2888c,
            num: $02b96a2843192315$export$aa5144520a3863d7
        }), // `version` is read through the store above; naming it here is what ties
    // the memo to a catalogue swap.
    [
        $02b96a2843192315$var$version
    ]);
}










// ─────────────────────────────────────────────────────────────────────────────
// The i18n barrel — import from '../i18n', never from a file inside it.
//
//   import { useTranslation } from '../../i18n';
//
// Keeping the surface here means the internals (loader strategy, translator
// implementation, which Intl objects get memoised) can change without a sweep
// through the app.
//
// Full guide: docs/I18N.md
// ─────────────────────────────────────────────────────────────────────────────


var $acw62 = parcelRequire("acw62");
// ─────────────────────────────────────────────────────────────────────────────
// The locale registry — the one place that knows which languages exist.
//
// Adding a language is meant to be a data change, not a code change: append an
// entry here, drop a folder under `translations/`, register its loaders in
// loader.js, and every picker, formatter and direction switch picks it up. No
// component, screen or service is allowed to branch on a locale id — if a
// behaviour differs per language it belongs in the descriptor below.
//
// Ported from the clinic panel (`parsina.client.clinic/src/i18n`), whose
// `docs/I18N.md` and the doctor app's are the fuller treatment. The mechanics
// are unchanged on purpose: this is the fourth panel to need them, and a fourth
// private implementation of "which language is this" is how the three drift.
//
// TWO differences from the clinic's copy, both deliberate:
//
//   • No `ar`. The platform back office is an INTERNAL tool for Parsina staff,
//     not a customer surface — there is no Arabic-speaking audience for it. The
//     registry supports adding one later without touching a component; what it
//     would need is the four CLDR corrections the clinic's `ar` descriptor
//     documents (ICU's Arabic month names for the Jalali calendar are corrupt
//     in six of twelve), so copy that descriptor rather than writing a new one.
//
//   • `FALLBACK_LOCALE` is `fa`, not `en`. See the note on it below.
//
// THE BRAND (src/lib/brand.js, configured at boot by src/lib/brandBoot.js)
// narrows this list and moves its defaults, never the descriptors' data:
// `locales` decides which of these languages are OFFERED (`isOfferedLocale` —
// every resolver below asks it, so a language the brand does not offer is never
// started in or cached), and `defaultLocale` is the first-visit language.
// `calendar` swaps each descriptor's calendar through the descriptor's own
// `calendars` data. With no brand all three are exactly what they were. Same
// rules as the clinic panel's config.js.
// ─────────────────────────────────────────────────────────────────────────────

// The twelve Jalali months as the English UI spells them, index 0 = Farvardin.
// French shows its Jalali months in these words (PM-0185, D8) rather than ICU's
// French data («ordibehešt», «khordâd»), which reads as scholarly
// transliteration and is spelled differently by different ICU builds — the
// kit's date picker and the server's text use the same twelve words. German
// does the same (PM-0212) instead of ICU's «Schahriwar», «Ordibehescht».
const $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN = [
    'Farvardin',
    'Ordibehesht',
    'Khordad',
    'Tir',
    'Mordad',
    'Shahrivar',
    'Mehr',
    'Aban',
    'Azar',
    'Dey',
    'Bahman',
    'Esfand'
];
const $94f36eaf2deb686d$export$e49c1078bc46f17 = {
    // i18n-exempt: a locale's `label` is its ENDONYM — the name the language gives
    // itself — so it is deliberately not translated. «فارسی» stays «فارسی» in the
    // English UI, the same way «English» stays «English» in the Persian one; that
    // is what makes a language switcher usable to someone who cannot read the
    // language currently on screen. `weekdaySeparator` is likewise locale data.
    fa: {
        id: 'fa',
        label: "\u0641\u0627\u0631\u0633\u06CC",
        englishLabel: 'Persian',
        dir: 'rtl',
        // -u-ca-persian → Jalali (Shamsi) calendar; -u-nu-arabext → Persian digits.
        intl: 'fa-IR-u-ca-persian-nu-arabext',
        calendar: 'jalali',
        calendars: {
            gregory: {
                intl: 'fa-IR-u-ca-gregory-nu-arabext'
            }
        },
        timeZone: 'Asia/Tehran',
        weekdaySeparator: "\u060C ",
        // Persian is the language the platform's own stored data is in — clinic
        // names, clinic types, the notes an operator types onto an activation.
        readsPersianData: true
    },
    en: {
        id: 'en',
        label: 'English',
        englishLabel: 'English',
        dir: 'ltr',
        // JALALI, not Gregorian — and this is the one place this panel's registry
        // differs in SUBSTANCE from the clinic panel's rather than in scope.
        //
        // A subscription period, a trial deadline and a payment period are the same
        // commercial facts the clinic sees in its own panel and on its invoices, and
        // those are Jalali end to end. With `en-US` this screen said "Sep 18, 2026"
        // where the clinic's own screen said «۲۷ شهریور ۱۴۰۵» — so an operator on the
        // phone to a clinic was reading a different date than the person they were
        // helping, about the same row. Language changes words and direction; it must
        // not change what a date MEANS.
        //
        // ICU renders the Jalali months in Latin for this tag: «Shahrivar 27, 1405».
        // The numbering system is untouched, so digits stay Latin.
        intl: 'en-US-u-ca-persian',
        calendar: 'jalali',
        calendars: {
            // A brand on the Gregorian calendar (Proxia) keeps no Jalali books: plain
            // US English, and neither Jalali correction below applies.
            gregory: {
                intl: 'en-US',
                stripEra: undefined,
                numericDateOrder: undefined
            }
        },
        timeZone: 'Asia/Tehran',
        weekdaySeparator: ', ',
        // ICU appends the era — «Shahrivar 27, 1405 AP» — for a calendar that is not
        // the locale's own default, and `era: undefined` does not suppress it. Nobody
        // writing a Jalali date writes the era.
        stripEra: true,
        // ICU writes the all-numeric form US-style, month-first («6/27/1405»), where
        // Persian writes it year-first («۱۴۰۵/۰۶/۲۷»). Two locales disagreeing about
        // the field order of the same calendar on the same product is how a date gets
        // transcribed wrong. Applied only when the date really is all-numeric, so a
        // month NAME is never reordered.
        numericDateOrder: [
            'year',
            'month',
            'day'
        ]
    },
    // French mirrors English (PM-0185, D3), which here means JALALI — for the
    // same reason: an operator on the phone to a clinic reads the date the clinic
    // reads. Latin digits, the era dropped, the numeric form year-first, exactly
    // as `en` does it; what differs is French data.
    fr: {
        id: 'fr',
        label: "Fran\xe7ais",
        englishLabel: 'French',
        dir: 'ltr',
        intl: 'fr-FR-u-ca-persian',
        calendar: 'jalali',
        calendars: {
            // A brand on the Gregorian calendar: plain French dates, and none of the
            // Jalali corrections — the month names below would rename August.
            gregory: {
                intl: 'fr-FR',
                stripEra: undefined,
                numericDateOrder: undefined,
                monthNames: undefined
            }
        },
        timeZone: 'Asia/Tehran',
        // «samedi 27 Shahrivar 1405» — French joins the weekday without a comma.
        weekdaySeparator: ' ',
        // ICU's French `medium` abbreviates the month («27 šahr. 1405»); the panel's
        // default date carries the whole name, as Persian's does.
        dateStyles: {
            medium: {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }
        },
        stripEra: true,
        numericDateOrder: [
            'year',
            'month',
            'day'
        ],
        monthNames: $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN,
        fallsBackTo: 'en'
    },
    // German mirrors English too (PM-0212, as French D3): JALALI here, Latin
    // digits, the era dropped, the numeric form year-first, the months spelled as
    // the English UI spells them. What differs is German data — «27. Shahrivar
    // 1405», the weekday joined with a comma, «1.234» grouped with a dot.
    de: {
        id: 'de',
        label: 'Deutsch',
        englishLabel: 'German',
        dir: 'ltr',
        intl: 'de-DE-u-ca-persian',
        calendar: 'jalali',
        calendars: {
            // A brand on the Gregorian calendar: plain German dates, and none of the
            // Jalali corrections — the month names below would rename August.
            gregory: {
                intl: 'de-DE',
                stripEra: undefined,
                numericDateOrder: undefined,
                monthNames: undefined
            }
        },
        timeZone: 'Asia/Tehran',
        // «Freitag, 27. Shahrivar 1405» — German joins the weekday with a comma.
        weekdaySeparator: ', ',
        dateStyles: {
            // ICU's German `short` has a TWO-digit year («27.06.05»), which the
            // year-first reorder below would turn into «05.06.27»; the four-digit
            // year keeps the numeric date unambiguous: «1405.06.27».
            short: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            },
            // ICU's German `medium` is all-numeric («27.06.1405»); the panel's
            // default date carries the whole month name, as Persian's does.
            medium: {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }
        },
        stripEra: true,
        numericDateOrder: [
            'year',
            'month',
            'day'
        ],
        monthNames: $94f36eaf2deb686d$var$JALALI_MONTHS_LATIN,
        fallsBackTo: 'en'
    }
};
const $94f36eaf2deb686d$export$d953adbca2df8efa = Object.keys($94f36eaf2deb686d$export$e49c1078bc46f17);
const $94f36eaf2deb686d$export$1af4c7e47ad72f44 = 'fa';
const $94f36eaf2deb686d$export$95b7602913551865 = 'fa';
const $94f36eaf2deb686d$export$4d2fb7344096e022 = [
    'common',
    'nav',
    'validation',
    'errors',
    'auth',
    'shortcuts',
    'dashboard',
    'clinics',
    'clinic',
    'aiPricing',
    'marketplace',
    'demoRequests',
    'whatsapp',
    'doctorPages',
    'countries',
    'accounts'
];
const $94f36eaf2deb686d$export$17a6a815985c8621 = (id)=>Object.prototype.hasOwnProperty.call($94f36eaf2deb686d$export$e49c1078bc46f17, id);
const $94f36eaf2deb686d$export$60d894e7aa1bc86e = ()=>(0, $6386b471a95fe1b8$export$1a326f4d00c1e158)($94f36eaf2deb686d$export$d953adbca2df8efa);
const $94f36eaf2deb686d$export$d14eda3de108abc4 = (id)=>$94f36eaf2deb686d$export$17a6a815985c8621(id) && $94f36eaf2deb686d$export$60d894e7aa1bc86e().includes(id);
function $94f36eaf2deb686d$export$171765a6a37c37cd() {
    const ids = $94f36eaf2deb686d$export$60d894e7aa1bc86e();
    if (ids.length === $94f36eaf2deb686d$export$d953adbca2df8efa.length) return $94f36eaf2deb686d$export$e49c1078bc46f17;
    return Object.fromEntries(ids.map((id)=>[
            id,
            $94f36eaf2deb686d$export$e49c1078bc46f17[id]
        ]));
}
const $94f36eaf2deb686d$export$1ad85a23f306da6d = ()=>(0, $6386b471a95fe1b8$export$879824979a5b153a)($94f36eaf2deb686d$export$1af4c7e47ad72f44, $94f36eaf2deb686d$export$d953adbca2df8efa);
const $94f36eaf2deb686d$export$74da1d9411446207 = ()=>$94f36eaf2deb686d$export$d14eda3de108abc4($94f36eaf2deb686d$export$95b7602913551865) ? $94f36eaf2deb686d$export$95b7602913551865 : $94f36eaf2deb686d$export$1ad85a23f306da6d();
function $94f36eaf2deb686d$export$c7ec71c848fb6d9a(id) {
    const chain = [];
    const own = $94f36eaf2deb686d$export$e49c1078bc46f17[id]?.fallsBackTo;
    if (own && own !== id && $94f36eaf2deb686d$export$d14eda3de108abc4(own)) chain.push(own);
    const last = $94f36eaf2deb686d$export$74da1d9411446207();
    if (last !== id && !chain.includes(last)) chain.push(last);
    return chain;
}
const $94f36eaf2deb686d$export$57270fb1f2649979 = (id)=>{
    const descriptor = $94f36eaf2deb686d$export$e49c1078bc46f17[id] || $94f36eaf2deb686d$export$e49c1078bc46f17[$94f36eaf2deb686d$export$1ad85a23f306da6d()];
    const calendar = (0, $6386b471a95fe1b8$export$a350347e69c4c055)(null);
    if (!calendar || calendar === descriptor.calendar) return descriptor;
    return {
        ...descriptor,
        ...descriptor.calendars?.[calendar],
        calendar: calendar
    };
};
function $94f36eaf2deb686d$export$dca0327c9b9c6498(tag) {
    if (!tag) return null;
    const raw = String(tag).trim();
    const base = raw.toLowerCase().split(/[-_]/)[0];
    const id = $94f36eaf2deb686d$export$17a6a815985c8621(raw) ? raw : $94f36eaf2deb686d$export$17a6a815985c8621(base) ? base : null;
    return id && $94f36eaf2deb686d$export$d14eda3de108abc4(id) ? id : null;
}
const $94f36eaf2deb686d$export$86880b4b2e1a2384 = 'parsina.locale';
function $94f36eaf2deb686d$export$9e89f130e918dc2a() {
    try {
        return $94f36eaf2deb686d$export$dca0327c9b9c6498(window.localStorage.getItem($94f36eaf2deb686d$export$86880b4b2e1a2384));
    } catch  {
        // Private mode, disabled storage, or no window at all (tests, SSR).
        return null;
    }
}
function $94f36eaf2deb686d$export$e8146f0b19c81b97(id) {
    try {
        if ($94f36eaf2deb686d$export$d14eda3de108abc4(id)) window.localStorage.setItem($94f36eaf2deb686d$export$86880b4b2e1a2384, id);
    } catch  {
    /* A locale we cannot cache still works — it just re-resolves next launch. */ }
}
function $94f36eaf2deb686d$export$831a5617a2963db1() {
    return $94f36eaf2deb686d$export$9e89f130e918dc2a() || $94f36eaf2deb686d$export$1ad85a23f306da6d();
}
function $94f36eaf2deb686d$export$fff0f9a021c4ca38(id) {
    const locale = $94f36eaf2deb686d$export$d14eda3de108abc4(id) ? id : $94f36eaf2deb686d$export$1ad85a23f306da6d();
    const root = typeof document !== 'undefined' ? document.documentElement : null;
    if (root) {
        root.setAttribute('lang', locale);
        root.setAttribute('dir', $94f36eaf2deb686d$export$e49c1078bc46f17[locale].dir);
    }
    return locale;
}


// ─────────────────────────────────────────────────────────────────────────────
// Translation loading + cache.
//
// Every namespace is its own `import()`, so Parcel code-splits each module's
// strings into its own asset and a locale is only ever downloaded once someone
// actually selects it. English is not on the wire for an operator who never
// leaves Persian.
//
// Two caches, both process-lifetime:
//   `cache`    locale/namespace → the parsed bundle. A second switch back to a
//              language is synchronous — nothing is re-fetched or re-parsed.
//   `inflight` locale/namespace → the in-progress promise, so N simultaneous
//              requests for the same file share one network round trip.
//
// The map below is written out by hand rather than built from a template
// literal because Parcel resolves `import()` statically: a computed specifier
// would silently produce a bundle with no translations in it.
// ─────────────────────────────────────────────────────────────────────────────

































































const $d7c2f9731adebacb$var$IMPORTERS = {
    fa: {
        common: ()=>(parcelRequire("7LWfy")),
        nav: ()=>(parcelRequire("1gqde")),
        validation: ()=>(parcelRequire("hL0DY")),
        errors: ()=>(parcelRequire("eymjQ")),
        auth: ()=>(parcelRequire("8FGNB")),
        shortcuts: ()=>(parcelRequire("1Ifet")),
        dashboard: ()=>(parcelRequire("6MuVj")),
        clinics: ()=>(parcelRequire("jr8eW")),
        clinic: ()=>(parcelRequire("ivKQf")),
        aiPricing: ()=>(parcelRequire("gRvZX")),
        marketplace: ()=>(parcelRequire("gOwRw")),
        demoRequests: ()=>(parcelRequire("lXQOh")),
        whatsapp: ()=>(parcelRequire("bPwzi")),
        doctorPages: ()=>(parcelRequire("87AoQ")),
        countries: ()=>(parcelRequire("lRvrW")),
        accounts: ()=>(parcelRequire("5XSVk"))
    },
    en: {
        common: ()=>(parcelRequire("iQ83R")),
        nav: ()=>(parcelRequire("3RraV")),
        validation: ()=>(parcelRequire("cLLOU")),
        errors: ()=>(parcelRequire("6GiKw")),
        auth: ()=>(parcelRequire("bGFwJ")),
        shortcuts: ()=>(parcelRequire("e7dcB")),
        dashboard: ()=>(parcelRequire("eQ4m8")),
        clinics: ()=>(parcelRequire("62n9n")),
        clinic: ()=>(parcelRequire("eeVSd")),
        aiPricing: ()=>(parcelRequire("1YTzL")),
        marketplace: ()=>(parcelRequire("fhz2I")),
        demoRequests: ()=>(parcelRequire("9vR1F")),
        whatsapp: ()=>(parcelRequire("eZAfb")),
        doctorPages: ()=>(parcelRequire("4zqQY")),
        countries: ()=>(parcelRequire("69GhX")),
        accounts: ()=>(parcelRequire("cXE6O"))
    },
    fr: {
        common: ()=>(parcelRequire("c47kc")),
        nav: ()=>(parcelRequire("1vT2h")),
        validation: ()=>(parcelRequire("9fHuQ")),
        errors: ()=>(parcelRequire("9TYzn")),
        auth: ()=>(parcelRequire("ckRCV")),
        shortcuts: ()=>(parcelRequire("328k9")),
        dashboard: ()=>(parcelRequire("6ZxRv")),
        clinics: ()=>(parcelRequire("ilV3d")),
        clinic: ()=>(parcelRequire("5ZB0W")),
        aiPricing: ()=>(parcelRequire("46PJ9")),
        marketplace: ()=>(parcelRequire("iCfe5")),
        demoRequests: ()=>(parcelRequire("bVTA0")),
        whatsapp: ()=>(parcelRequire("6fu8D")),
        doctorPages: ()=>(parcelRequire("fQdee")),
        countries: ()=>(parcelRequire("lOEZX")),
        accounts: ()=>(parcelRequire("81wOy"))
    },
    de: {
        common: ()=>(parcelRequire("hRRnt")),
        nav: ()=>(parcelRequire("3NuPr")),
        validation: ()=>(parcelRequire("cPRzy")),
        errors: ()=>(parcelRequire("aV0LW")),
        auth: ()=>(parcelRequire("25GWJ")),
        shortcuts: ()=>(parcelRequire("iBVsX")),
        dashboard: ()=>(parcelRequire("6GTi4")),
        clinics: ()=>(parcelRequire("bm5Pc")),
        clinic: ()=>(parcelRequire("ac6PO")),
        aiPricing: ()=>(parcelRequire("hgwRq")),
        marketplace: ()=>(parcelRequire("59Bwv")),
        demoRequests: ()=>(parcelRequire("hM9XH")),
        whatsapp: ()=>(parcelRequire("1ORZd")),
        doctorPages: ()=>(parcelRequire("foXqn")),
        countries: ()=>(parcelRequire("cZwJv")),
        accounts: ()=>(parcelRequire("a2pXF"))
    }
};
const $d7c2f9731adebacb$var$cache = new Map();
const $d7c2f9731adebacb$var$inflight = new Map();
const $d7c2f9731adebacb$var$cacheKey = (locale, namespace)=>`${locale}/${namespace}`;
// Parcel hands back a module namespace object; the JSON is on `default` for a
// JSON asset, but a plain object comes through untouched under Vitest's transform.
const $d7c2f9731adebacb$var$unwrap = (mod)=>mod && mod.default || mod || {};
function $d7c2f9731adebacb$export$3c148aa2c2f6601d(locale, namespace) {
    const key = $d7c2f9731adebacb$var$cacheKey(locale, namespace);
    if ($d7c2f9731adebacb$var$cache.has(key)) return Promise.resolve($d7c2f9731adebacb$var$cache.get(key));
    if ($d7c2f9731adebacb$var$inflight.has(key)) return $d7c2f9731adebacb$var$inflight.get(key);
    const importer = $d7c2f9731adebacb$var$IMPORTERS[locale]?.[namespace];
    if (!importer) {
        $d7c2f9731adebacb$var$cache.set(key, {});
        return Promise.resolve({});
    }
    const promise = importer().then((mod)=>$d7c2f9731adebacb$var$unwrap(mod)).catch((err)=>{
        return {};
    }).then((bundle)=>{
        $d7c2f9731adebacb$var$cache.set(key, bundle);
        $d7c2f9731adebacb$var$inflight.delete(key);
        return bundle;
    });
    $d7c2f9731adebacb$var$inflight.set(key, promise);
    return promise;
}
function $d7c2f9731adebacb$export$5bd1a830868d1d11(locale) {
    if (!(0, $94f36eaf2deb686d$export$17a6a815985c8621)(locale)) return Promise.resolve({});
    return Promise.all((0, $94f36eaf2deb686d$export$4d2fb7344096e022).map((ns)=>$d7c2f9731adebacb$export$3c148aa2c2f6601d(locale, ns).then((bundle)=>[
                ns,
                bundle
            ]))).then(Object.fromEntries);
}
function $d7c2f9731adebacb$export$d2d95d0a2b5fab1e(locale) {
    const entries = (0, $94f36eaf2deb686d$export$4d2fb7344096e022).map((ns)=>[
            ns,
            $d7c2f9731adebacb$var$cache.get($d7c2f9731adebacb$var$cacheKey(locale, ns))
        ]);
    return entries.every(([, bundle])=>bundle !== undefined) ? Object.fromEntries(entries) : null;
}
function $d7c2f9731adebacb$export$f2675afc1de9f02e(locale) {
    $d7c2f9731adebacb$export$5bd1a830868d1d11(locale).catch(()=>{});
}
function $d7c2f9731adebacb$export$ff2d99e7c0f75ee6() {
    $d7c2f9731adebacb$var$cache.clear();
    $d7c2f9731adebacb$var$inflight.clear();
}


// ─────────────────────────────────────────────────────────────────────────────
// The translator — key → string. Pure, synchronous, and it never throws.
//
// A key is FULLY QUALIFIED and its first segment is the namespace:
//
//     t('settings.language.title')   → translations/<locale>/settings.json
//                                      → { language: { title: … } }
//
// One rule, no per-call configuration, and a key is enough to find the string
// on disk. That matters more than the keystrokes a scoped `t` would save: the
// question asked in front of a screen is always "where does this text live".
//
// Resolution order for every lookup:
//   1. the active locale — the brand's `strings` overlay, then the catalogue
//   2. the locale's own nearer fallbacks, if it names any (`bridges`: French
//      and German read English), overlay first in the same way
//   3. FALLBACK_LOCALE (Persian — the source catalogue, where every key
//      exists), overlay first in the same way
//   4. the key's last segment, humanised
//
// Step 4 exists so a missing key degrades to something an operator can read
// rather than to a crash or an empty button. Steps 2–4 log once per key in
// development and stay silent in production.
//
// THE BRAND (src/lib/brand.js). A catalogue value names the product as
// `{{brand}}` and its credit as `{{coin}}` / `{{coinEz}}`; those resolve here, in
// the language of the catalogue the text came from, with no value passed by the
// caller. With no brand configured they resolve to the words the catalogue used
// to spell out, so the output is what it always was
// (src/i18n/brandParity.test.js). The clinic panel's translator does the same.
// ─────────────────────────────────────────────────────────────────────────────


const $56c2db411f2e97f5$var$isDev = false;
// One warning per key per session. A missing key inside a list that renders on
// every keystroke would otherwise bury the console it is trying to inform.
const $56c2db411f2e97f5$var$warned = new Set();
function $56c2db411f2e97f5$var$warnOnce(message) {
    if (!$56c2db411f2e97f5$var$isDev) return;
    if ($56c2db411f2e97f5$var$warned.has(message)) return;
    $56c2db411f2e97f5$var$warned.add(message);
    console.warn(`[i18n] ${message}`);
}
function $56c2db411f2e97f5$export$d141035fe52f4cd7() {
    $56c2db411f2e97f5$var$warned.clear();
}
/**
 * `settings.language.title` → `catalog.settings.language.title`, or undefined.
 * Dotted segments only; a value that is not a string or array is treated as a
 * miss, so pointing a key at a whole subtree reports as missing instead of
 * rendering `[object Object]`.
 */ function $56c2db411f2e97f5$var$lookup(catalog, key) {
    if (!catalog || !key) return undefined;
    let node = catalog;
    for (const segment of key.split('.')){
        if (node == null || typeof node !== 'object') return undefined;
        node = node[segment];
    }
    return typeof node === 'string' || Array.isArray(node) ? node : undefined;
}
/**
 * `lookup`, with the brand's own text for `key` in `locale` asked first — the
 * `strings` overlay a deployment uses for wording a token cannot express.
 */ function $56c2db411f2e97f5$var$find(catalog, locale, key) {
    const own = (0, $6386b471a95fe1b8$export$62fa8a9cbf8a9cc6)(locale, key);
    if (typeof own === 'string' || Array.isArray(own)) return own;
    return $56c2db411f2e97f5$var$lookup(catalog, key);
}
/**
 * `{{name}}` → the matching value. An unknown placeholder is left verbatim so
 * the gap is visible in review rather than silently swallowed.
 *
 * A NUMBER is interpolated through the locale's number formatter, not
 * `String()`. «۳ مورد» is the Persian for "3 items"; «3 مورد» is a half-
 * translated string, and it is the single easiest way for Latin digits to leak
 * into an otherwise Persian screen — every count, total and threshold in the
 * app arrives through this function.
 *
 * Pass a STRING when a number must not be grouped or localised — a year, a
 * version, an ICD code. That is the escape hatch, and it is explicit at the
 * call site rather than inferred from magnitude.
 *
 * Values are inserted as text: this returns a string for React to render as a
 * text node, so there is no HTML parsing and nothing to escape. Interpolating
 * markup is deliberately impossible — a string that needs a bold span is two
 * keys and a component, not a template.
 *
 * A placeholder the caller did not name may be a BRAND token (`{{brand}}`,
 * `{{coin}}`, `{{coinEz}}`) — resolved for `locale`, the language of the
 * template. One pass, so a caller's value that happens to contain `{{brand}}` is
 * inserted as written and never resolved.
 */ function $56c2db411f2e97f5$var$interpolate(template, values, formatNumber, locale) {
    if (template.indexOf('{{') === -1) return template;
    return template.replace((0, $6386b471a95fe1b8$export$55fc5ffc49a23c34), (match, name, inline)=>{
        const named = values != null && Object.prototype.hasOwnProperty.call(values, name);
        if (!named) {
            const token = (0, $6386b471a95fe1b8$export$6281f283246a2f65)(name, locale, inline);
            if (token !== undefined) return token;
            return match;
        }
        const value = values[name];
        if (value == null) return match;
        if (typeof value === 'number' && Number.isFinite(value)) return formatNumber(value);
        return String(value);
    });
}
/**
 * Plural suffix for `count`, using the locale's own CLDR rules — Persian has
 * `one`/`other`, English has `one`/`other`, and a language added later with six
 * forms works without touching this file.
 *
 * `key_zero` is honoured ahead of the CLDR category when it exists, because
 * "no appointments" is usually a different sentence rather than a different
 * number, in every language.
 */ function $56c2db411f2e97f5$var$pluralKey(get, key, count, pluralRules) {
    if (count === 0 && get(`${key}_zero`) !== undefined) return `${key}_zero`;
    const category = pluralRules ? pluralRules.select(count) : 'other';
    if (get(`${key}_${category}`) !== undefined) return `${key}_${category}`;
    if (get(`${key}_other`) !== undefined) return `${key}_other`;
    return key;
}
/** `settings.language.title` → `Title`. The last-resort rendering. */ function $56c2db411f2e97f5$var$humanise(key) {
    const last = String(key).split('.').pop() || String(key);
    return last.replace(/[_-]+/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (c)=>c.toUpperCase());
}
function $56c2db411f2e97f5$export$6f3122ee6dbd9f46({ locale: locale, catalog: catalog, fallbackCatalog: fallbackCatalog, pluralRules: pluralRules, joinList: joinList, formatNumber: formatNumber, fallbackLocale: fallbackLocale = (0, $94f36eaf2deb686d$export$95b7602913551865), bridges: bridges = [] }) {
    const join = joinList || ((items)=>items.join(', '));
    const num = formatNumber || ((n)=>String(n));
    const active = (key)=>$56c2db411f2e97f5$var$find(catalog, locale, key);
    // Every catalogue after the active one, in the order a missing key reads them.
    // One that IS the active catalogue (a locale that is its own fallback) is
    // skipped rather than read twice.
    const hops = [
        ...bridges,
        {
            locale: fallbackLocale,
            catalog: fallbackCatalog
        }
    ].filter((hop)=>hop.catalog && hop.catalog !== catalog).map((hop)=>({
            locale: hop.locale,
            get: (key)=>$56c2db411f2e97f5$var$find(hop.catalog, hop.locale, key)
        }));
    /** The first fallback that has `key` (plural-resolved per catalogue), or null. */ const fallback = (key, count)=>{
        for (const hop of hops){
            const resolved = count === undefined ? key : $56c2db411f2e97f5$var$pluralKey(hop.get, key, count, pluralRules);
            const value = hop.get(resolved);
            if (value !== undefined) return {
                value: value,
                from: hop.locale
            };
        }
        return null;
    };
    /**
   * @param {string} key    fully-qualified, e.g. 'common.actions.save'
   * @param {object} [vars] interpolation values; `count` also selects the plural
   * @returns {string}      always a string, even when everything is missing
   */ function t(key, vars) {
        if (typeof key !== 'string' || !key) {
            $56c2db411f2e97f5$var$warnOnce(`t() called with a non-string key: ${JSON.stringify(key)}`);
            return '';
        }
        const hasCount = vars != null && typeof vars.count === 'number';
        // Active locale.
        const resolved = hasCount ? $56c2db411f2e97f5$var$pluralKey(active, key, vars.count, pluralRules) : key;
        let value = active(resolved);
        // The language the text is in — brand tokens resolve in it.
        let from = locale;
        // The fallback locales, nearest first.
        if (value === undefined) {
            const hit = fallback(key, hasCount ? vars.count : undefined);
            if (hit) {
                ({ value: value, from: from } = hit);
                $56c2db411f2e97f5$var$warnOnce(`missing key "${key}" in "${locale}" \u{2014} fell back to "${from}"`);
            }
        }
        // Nothing anywhere.
        if (value === undefined) {
            $56c2db411f2e97f5$var$warnOnce(`missing key "${key}" in every locale \u{2014} showing the key`);
            return $56c2db411f2e97f5$var$humanise(key);
        }
        // A key whose value is an array joined for `t`; `tList` returns the array.
        if (Array.isArray(value)) return join(value.map((item)=>$56c2db411f2e97f5$var$interpolate(String(item), vars, num, from)));
        return $56c2db411f2e97f5$var$interpolate(value, vars, num, from);
    }
    /**
   * A key whose value is a JSON array, as an array — for bullet lists and
   * option sets, so a translator can add or drop an item without a code change.
   * Always an array, empty when the key is missing.
   */ function tList(key, vars) {
        const own = active(key);
        const hit = own === undefined ? fallback(key) : null;
        const value = own ?? hit?.value;
        const from = hit ? hit.from : locale;
        if (!Array.isArray(value)) {
            if (value === undefined) $56c2db411f2e97f5$var$warnOnce(`missing list key "${key}"`);
            return [];
        }
        return value.map((item)=>$56c2db411f2e97f5$var$interpolate(String(item), vars, num, from));
    }
    /** Whether a key resolves anywhere — for conditionally-rendered optional copy. */ function has(key) {
        return active(key) !== undefined || fallback(key) !== null;
    }
    return {
        t: t,
        tList: tList,
        has: has
    };
}


// ─────────────────────────────────────────────────────────────────────────────
// Locale-aware formatting: dates, times, numbers, money, relative time.
//
// Everything here is driven by the locale descriptor's `intl` tag, which
// carries the calendar and numbering system as Unicode extensions
// (`fa-IR-u-ca-persian-nu-arabext`). That is what makes "add a language" a
// data change: no formatter in this file branches on a locale id, and the
// Jalali↔Gregorian switch is a consequence of the tag, not an `if`.
//
// Where ICU's own data for a locale disagrees with how an Iranian clinic writes
// a date — or is simply wrong — the correction is declared on the DESCRIPTOR
// (`dateStyles`, `stripEra`, `numericDateOrder`, `monthNames`) and applied
// generically below. That is the escape hatch that keeps the rule above true:
// the knowledge that Arabic on the Persian calendar needs an era stripped and
// six of CLDR's twelve month names replaced lives with the locale, not in here.
//
// Two rules that are not negotiable:
//
//   • MONEY. Every service, gRPC message and GraphQL field in Parsina carries
//     an integer number of MINOR UNITS of the document's currency — WHOLE RIALS
//     for IRR, which is also what a blank currency means. Humans read TOMAN for
//     IRR: `formatMoney` takes rials and renders toman, exactly like
//     @parsina/framework's `fmtToman` — it only adds the locale. Passing a toman
//     figure to it bills a tenth of what was meant. A clinic's money in another
//     currency is passed as `{ currency }` and read through the kit's
//     `currency` table; two currencies are never added or compared. Platform
//     money (subscriptions, MRR, Parseh) is always IRR and never passes one.
//
//   • TIME ZONE. A clinic runs on Iran local time whatever language the UI is
//     in: an appointment at 14:30 is 14:30 in Tehran, not in the browser's
//     zone. Every date formatter pins `timeZone` from the descriptor.
//
// Instances are memoised per (locale, shape) because constructing an
// Intl.DateTimeFormat is expensive relative to using one, and these run inside
// list rows that re-render on every keystroke.
// ─────────────────────────────────────────────────────────────────────────────


const $c53f9539af19d960$var$memo = new Map();
function $c53f9539af19d960$var$intl(Ctor, name, locale, options) {
    const key = `${name}|${locale}|${JSON.stringify(options)}`;
    let instance = $c53f9539af19d960$var$memo.get(key);
    if (!instance) {
        instance = new Ctor(locale, options);
        $c53f9539af19d960$var$memo.set(key, instance);
    }
    return instance;
}
/** Anything date-ish → Date, or null when it is not a usable instant. */ function $c53f9539af19d960$var$toDate(value) {
    if (value == null || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
// One instant inside each Jalali month, used only to ASK ICU for that month's
// name. The 15th at noon UTC: far enough from either boundary that no time zone
// — including the Asia/Tehran the formatters pin to — can push it into a
// neighbouring month. 1404 is an ordinary (non-leap) Jalali year, so every
// month has a 15th.
const $c53f9539af19d960$var$MONTH_ANCHORS = [
    Date.UTC(2025, 3, 4),
    Date.UTC(2025, 4, 5),
    Date.UTC(2025, 5, 5),
    Date.UTC(2025, 6, 6),
    Date.UTC(2025, 7, 6),
    Date.UTC(2025, 8, 6),
    Date.UTC(2025, 9, 7),
    Date.UTC(2025, 10, 6),
    Date.UTC(2025, 11, 6),
    Date.UTC(2026, 0, 5),
    Date.UTC(2026, 1, 4),
    Date.UTC(2026, 2, 6)
].map((ms)=>ms + 43200000);
// One instant on each weekday, Saturday first — used only to ASK ICU for that
// day's name. 2025-08-02 is a Saturday; noon UTC keeps every one of them on the
// same calendar day in Asia/Tehran (UTC+3:30), which is the zone the formatters
// pin to.
const $c53f9539af19d960$var$WEEKDAY_ANCHORS = Array.from({
    length: 7
}, (_, i)=>Date.UTC(2025, 7, 2 + i) + 43200000);
// What an empty/unparseable value renders as. An em dash reads as "no value"
// in both scripts and never looks like a zero.
const $c53f9539af19d960$var$EMPTY = "\u2014";
// Named date shapes, so screens ask for a meaning rather than a field list and
// every «visit date» in the app looks the same.
//
//   short    ۱۴۰۴/۵/۱۲            8/3/25          dense tables
//   medium   ۱۲ مرداد ۱۴۰۴        Aug 3, 2025     the default
//   long     ۱۲ مرداد ۱۴۰۴        August 3, 2025  headers
//   full     یکشنبه، ۱۲ مرداد ۱۴۰۴ Sunday, …      day views
//   dayMonth ۱۲ مرداد            Aug 3           calendar chrome
//   weekdayDayMonth  یکشنبه، ۱۲ مرداد   Sunday, Aug 3   day navigator
//
// A descriptor may override individual shapes through its `dateStyles` field
// when ICU's pattern for that locale disagrees with how an Iranian clinic
// writes the date. The override is data, not a branch: a locale declares
// `numericDateOrder` and format.js applies it without knowing which locale it is.
const $c53f9539af19d960$var$DATE_STYLES = {
    short: {
        dateStyle: 'short'
    },
    medium: {
        dateStyle: 'medium'
    },
    long: {
        dateStyle: 'long'
    },
    dayMonth: {
        day: 'numeric',
        month: 'long'
    },
    monthYear: {
        month: 'long',
        year: 'numeric'
    },
    // The month alone — for a chart's month gridline, where the year is carried
    // by the one tick that crosses it rather than repeated on all twelve.
    month: {
        month: 'long'
    }
};
/**
 * Drop the era designator ICU appends when a locale is asked for a calendar
 * that is not its own default: Arabic on the Persian calendar renders
 * «١٢ مرداد ١٤٠٤ ه‍.ش», and `era: undefined` does not suppress it. The literal
 * that only ever joined the era to the date goes with it, so nothing is left
 * dangling at either end.
 */ function $c53f9539af19d960$var$dropEra(parts) {
    if (!parts.some((part)=>part.type === 'era')) return parts;
    return parts.filter((part, i)=>{
        if (part.type === 'era') return false;
        if (part.type !== 'literal') return true;
        return parts[i - 1]?.type !== 'era' && parts[i + 1]?.type !== 'era';
    });
}
// Any Unicode decimal digit — Arabic-Indic ٠-٩ and Persian ۰-۹ included. Used
// to tell a numeric month («٥») from a month NAME («مرداد») without knowing
// which numbering system is in play.
const $c53f9539af19d960$var$DIGITS_ONLY = /^\p{Nd}+$/u;
const $c53f9539af19d960$var$DATE_FIELDS = [
    'year',
    'month',
    'day'
];
/** A month rendered as a NAME rather than as digits. */ const $c53f9539af19d960$var$isNamedMonth = (part)=>part.type === 'month' && !$c53f9539af19d960$var$DIGITS_ONLY.test(part.value);
/**
 * Substitute the descriptor's own month names for ICU's, for the locales where
 * CLDR's data for this language/calendar pairing is wrong. Only a month
 * rendered as a name is touched — a numeric month is already correct, and
 * replacing it would turn «٥» into a word.
 */ function $c53f9539af19d960$var$withMonthNames(parts, names, monthNumber) {
    const replacement = names[monthNumber - 1];
    if (!replacement) return parts;
    return parts.map((part)=>$c53f9539af19d960$var$isNamedMonth(part) ? {
            ...part,
            value: replacement
        } : part);
}
/**
 * Re-order an ALL-NUMERIC date into the descriptor's field order, keeping the
 * separator the locale itself chose. ICU writes the numeric Arabic date
 * day-first while Persian writes it year-first, and two RTL languages
 * disagreeing about the same calendar on the same screen is how a date gets
 * transcribed wrong.
 *
 * Returns null — meaning "leave this one alone" — for any shape that is not
 * exactly three numeric fields and their separators, so a month name, a
 * weekday or a time is never reordered.
 */ function $c53f9539af19d960$var$reorderNumericDate(parts, order) {
    const fields = parts.filter((part)=>$c53f9539af19d960$var$DATE_FIELDS.includes(part.type));
    if (fields.length !== 3) return null;
    if (!fields.every((part)=>$c53f9539af19d960$var$DIGITS_ONLY.test(part.value))) return null;
    if (parts.some((part)=>part.type !== 'literal' && !$c53f9539af19d960$var$DATE_FIELDS.includes(part.type))) return null;
    const value = Object.fromEntries(fields.map((part)=>[
            part.type,
            part.value
        ]));
    const separator = parts.find((part)=>part.type === 'literal')?.value ?? '/';
    return order.map((type)=>value[type]).join(separator);
}
function $c53f9539af19d960$export$c3f4cd5551df13fd(localeId) {
    const { intl: tag, timeZone: timeZone, weekdaySeparator: weekdaySeparator = ', ', dateStyles: styleOverrides, stripEra: stripEra, numericDateOrder: numericDateOrder, monthNames: monthNames, clinicCalendarIntl: clinicCalendarIntl } = (0, $94f36eaf2deb686d$export$57270fb1f2649979)(localeId);
    // Surfaces that are Jalali in every language fall back to the locale's own
    // tag, which is already Jalali for `fa`.
    const clinicTag = clinicCalendarIntl || tag;
    const dateTime = (options)=>$c53f9539af19d960$var$intl(Intl.DateTimeFormat, 'dt', tag, {
            timeZone: timeZone,
            ...options
        });
    const number = (options)=>$c53f9539af19d960$var$intl(Intl.NumberFormat, 'n', tag, options);
    /** The options for a named shape, with the locale's override applied. */ const styleOptions = (style)=>{
        const name = $c53f9539af19d960$var$DATE_STYLES[style] || styleOverrides?.[style] ? style : 'medium';
        return styleOverrides?.[name] || $c53f9539af19d960$var$DATE_STYLES[name];
    };
    /**
   * The month's number (1-12) in this locale's own calendar. Forced to Latin
   * digits so it is an index rather than a glyph run — the tag's `-nu-` would
   * otherwise hand back «٥».
   */ const monthNumber = (date)=>Number($c53f9539af19d960$var$intl(Intl.DateTimeFormat, 'dt', tag, {
            timeZone: timeZone,
            month: 'numeric',
            numberingSystem: 'latn'
        }).format(date));
    /**
   * One date shape, with the descriptor's corrections applied. A locale that
   * declares none of them goes straight through ICU untouched, which is every
   * locale but `ar`.
   */ const renderDate = (date, style)=>{
        const formatter = dateTime(styleOptions(style));
        if (!stripEra && !numericDateOrder && !monthNames) return formatter.format(date);
        let parts = formatter.formatToParts(date);
        if (stripEra) parts = $c53f9539af19d960$var$dropEra(parts);
        if (monthNames && parts.some($c53f9539af19d960$var$isNamedMonth)) parts = $c53f9539af19d960$var$withMonthNames(parts, monthNames, monthNumber(date));
        if (numericDateOrder) {
            const reordered = $c53f9539af19d960$var$reorderNumericDate(parts, numericDateOrder);
            if (reordered !== null) return reordered;
        }
        return parts.map((part)=>part.value).join('').trim();
    };
    /**
   * The month of the CLINIC's calendar — Jalali — in the reading locale's
   * language and digits, whatever calendar that locale otherwise uses.
   *
   * The analysis timeline grids its axis on Jalali month boundaries, because
   * «this month» to an Iranian clinic means the Jalali month on the wall. A
   * gridline standing at 1 Mordad must therefore be labelled «مرداد» /
   * «Mordad», not «August» — the Gregorian month that line does not start.
   *
   * Composed from parts rather than asked for as a pattern, for two reasons ICU
   * forces: every locale puts the year on a different side of the month (Persian
   * emits «۱۴۰۴ مرداد», English «Mordad 1404»), and a non-default calendar drags
   * an era along with it («1404 AP», «١٤٠٤ ه‍.ش»). An axis label has to be the
   * same shape in all three languages and has no room for an era.
   */ const formatClinicMonth = (value, { withYear: withYear = false } = {})=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        const options = {
            month: 'long',
            ...withYear ? {
                year: 'numeric'
            } : {}
        };
        let parts = $c53f9539af19d960$var$intl(Intl.DateTimeFormat, 'dt', clinicTag, {
            timeZone: timeZone,
            ...options
        }).formatToParts(date);
        parts = $c53f9539af19d960$var$dropEra(parts);
        if (monthNames && parts.some($c53f9539af19d960$var$isNamedMonth)) parts = $c53f9539af19d960$var$withMonthNames(parts, monthNames, monthNumber(date));
        const month = parts.find((part)=>part.type === 'month')?.value ?? '';
        const year = parts.find((part)=>part.type === 'year')?.value ?? '';
        return withYear && year ? `${month} ${year}` : month;
    };
    /**
   * The twelve JALALI month names, index 0 = فروردین, in the reader's language.
   *
   * For a Jalali date PICKER — a month dropdown beside a year and a day. The
   * picker is Jalali in every language (`@parsina/framework`'s is Jalali-only,
   * and a clinic's day sheet, accounting period and shift report are all Jalali
   * whatever the panel is set to), so its month list is the clinic's calendar
   * rendered in the reader's words: «مرداد» / «Mordad», never «August».
   *
   * This replaced a hardcoded `J_MONTHS` array that every picker imported, and
   * which therefore showed Persian month names inside an otherwise-English
   * form. Built from a real date in each month rather than from a table so it
   * follows the same ICU data — and the same `monthNames` override — as every
   * other date on the screen.
   */ const clinicMonthNames = ()=>$c53f9539af19d960$var$MONTH_ANCHORS.map((ms)=>formatClinicMonth(ms));
    /**
   * The seven weekday names, index 0 = SATURDAY, in the reader's language.
   *
   * Saturday-first because that is the Iranian week: a clinic's working-days
   * selector, its weekly rota and its shift board all start on شنبه, and reordering
   * them for an English reader would move every doctor's Tuesday.
   *
   * `width` is passed through to `formatWeekday`, where 'short' is a trap: it
   * is NOT short in Persian — «یکشنبه» is the full word — and only English
   * abbreviates. A one-letter chip needs 'narrow'.
   *
   * This replaced hardcoded `['شنبه', 'یکشنبه', …]` arrays copied into four
   * screens, which rendered Persian weekdays in the English UI.
   */ const weekdayNames = (width = 'long')=>$c53f9539af19d960$var$WEEKDAY_ANCHORS.map((ms)=>formatWeekday(ms, width));
    /**
   * A date in one of the named shapes above.
   *
   * `full` is composed rather than delegated to `dateStyle: 'full'`. Node's
   * bundled ICU emits the Persian full pattern as year–month–day–weekday
   * («۱۴۰۴ مرداد ۱۲، یکشنبه»), which is both wrong for Persian and the reverse
   * of what the same ICU gives for `long`. Browsers disagree with it and with
   * each other. Composing weekday + long date makes the one date shape a
   * doctor reads at the top of a day sheet identical everywhere, which matters
   * more here than deferring to CLDR.
   */ const formatDate = (value, style = 'medium')=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        // `full` and `weekdayDayMonth` are the two composed shapes.
        if (style === 'full' || style === 'weekdayDayMonth') {
            const weekday = dateTime({
                weekday: 'long'
            }).format(date);
            const rest = renderDate(date, style === 'full' ? 'long' : 'dayMonth');
            return `${weekday}${weekdaySeparator}${rest}`;
        }
        return renderDate(date, style);
    };
    /**
   * Clock time, 24-hour in every locale. Iranian clinical scheduling is written
   * and spoken in 24-hour time, and an English UI for an Iranian clinic that
   * suddenly says "2:30 PM" while the printed day sheet says 14:30 is a
   * transcription error waiting to happen.
   */ const formatTime = (value)=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        return dateTime({
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    };
    const formatDateTime = (value, style = 'medium')=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        return `${formatDate(date, style)} ${formatTime(date)}`;
    };
    /**
   * Weekday name. The three widths are NOT what the names suggest in Persian,
   * so pick by looking at the output rather than by analogy with English:
   *
   *   long    یکشنبه   Sunday   الأحد
   *   short   یکشنبه   Sun      الأحد     ← Persian/Arabic `short` is the FULL word
   *   narrow  ی        S        ح
   *
   * A one-letter chip — the reception week strip — needs `narrow`; anything that
   * reads as a word needs `long`. `short` only differs from `long` in English.
   */ const formatWeekday = (value, width = 'long')=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        return dateTime({
            weekday: width
        }).format(date);
    };
    /**
   * A plain count — NOT money, so no toman conversion. Persian digits in `fa`,
   * Latin in `en`, grouped in both.
   */ const formatNumber = (value, options)=>{
        if (value == null || value === '' || !Number.isFinite(Number(value))) return $c53f9539af19d960$var$EMPTY;
        return number(options).format(Number(value));
    };
    const formatPercent = (value, options)=>{
        if (value == null || !Number.isFinite(Number(value))) return $c53f9539af19d960$var$EMPTY;
        return number({
            style: 'percent',
            maximumFractionDigits: 0,
            ...options
        }).format(Number(value) / 100);
    };
    /**
   * Money: MINOR UNITS of `currency` in → the figure a human reads out.
   *
   * No currency — or '' or 'IRR' — is the contract this always had: WHOLE RIALS
   * in, a toman figure out, and `withUnit` appends the caller's `unitLabel` (the
   * app's own «تومان»/«toman» catalogue word), or nothing when there is none.
   *
   * Any other currency is divided by its own divisor and shown with its own
   * fraction digits (USD 2, KWD 3) in this locale's digits. With `withUnit` its
   * unit is the currency table's word — `unitStyle` 'long' («US dollar»,
   * default) or 'short' («USD») — and a caller's `unitLabel` is IGNORED: at every
   * call site written before currencies existed it is a toman word, and a
   * non-IRR figure must never read «تومان». A code outside the table throws.
   */ const formatMoney = (amountMinor, { currency: currency, withUnit: withUnit = false, unitLabel: unitLabel = '', unitStyle: unitStyle = 'long' } = {})=>{
        const info = (0, $fcda591c8cd139a4$export$272b829bb65f9e96)(currency);
        if (info.code !== (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e)) {
            const value = (0, $fcda591c8cd139a4$export$57a9131fd362a631)(amountMinor, info.code);
            if (value == null) return $c53f9539af19d960$var$EMPTY;
            const text = number({
                minimumFractionDigits: info.minDisplayDecimals,
                maximumFractionDigits: info.maxDisplayDecimals
            }).format(value);
            return withUnit ? `${text} ${(0, $fcda591c8cd139a4$export$846d8329e0c3da65)(info.code, localeId, unitStyle)}` : text;
        }
        if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return $c53f9539af19d960$var$EMPTY;
        const toman = Number(amountMinor) / 10; // IRR: whole rials → toman
        // Prices are entered in toman so sub-toman precision cannot exist, but a
        // percentage discount can land on a half-toman: show it rather than
        // silently rounding money away.
        const text = number({
            maximumFractionDigits: 1
        }).format(toman);
        return withUnit && unitLabel ? `${text} ${unitLabel}` : text;
    };
    /**
   * «۳ روز پیش» / «3 days ago». Picks the largest unit that fits, so a two-hour
   * gap reads in hours and a two-month gap in months.
   */ const formatRelativeTime = (value, now = Date.now())=>{
        const date = $c53f9539af19d960$var$toDate(value);
        if (!date) return $c53f9539af19d960$var$EMPTY;
        const rtf = $c53f9539af19d960$var$intl(Intl.RelativeTimeFormat, 'rt', tag, {
            numeric: 'auto'
        });
        const deltaSeconds = (date.getTime() - now) / 1000;
        const units = [
            [
                'year',
                31536000
            ],
            [
                'month',
                2592000
            ],
            [
                'week',
                604800
            ],
            [
                'day',
                86400
            ],
            [
                'hour',
                3600
            ],
            [
                'minute',
                60
            ]
        ];
        for (const [unit, seconds] of units){
            if (Math.abs(deltaSeconds) >= seconds) return rtf.format(Math.round(deltaSeconds / seconds), unit);
        }
        return rtf.format(Math.round(deltaSeconds), 'second');
    };
    /** «الف، ب و ج» / «a, b, and c» — grammatically correct list joining. */ const formatList = (items, type = 'conjunction')=>{
        const list = (items || []).filter((item)=>item != null && item !== '').map(String);
        if (!list.length) return '';
        if (typeof Intl.ListFormat !== 'function') return list.join(', ');
        return $c53f9539af19d960$var$intl(Intl.ListFormat, 'lf', tag, {
            style: 'long',
            type: type
        }).format(list);
    };
    /**
   * Digits only, in the locale's numbering system, with NO grouping — for
   * things that are digit strings rather than quantities: a national id, a
   * medical-council code, a file number. Grouping one of those would read as a
   * different identifier.
   */ // '0'…'9' in this locale's numbering system, resolved once.
    const digitMap = Array.from({
        length: 10
    }, (_, d)=>number({
            useGrouping: false
        }).format(d));
    const formatDigits = (value)=>{
        if (value == null || value === '') return '';
        return String(value).replace(/\d/g, (d)=>digitMap[Number(d)]);
    };
    return {
        formatDate: formatDate,
        formatTime: formatTime,
        formatDateTime: formatDateTime,
        formatWeekday: formatWeekday,
        formatClinicMonth: formatClinicMonth,
        clinicMonthNames: clinicMonthNames,
        weekdayNames: weekdayNames,
        formatNumber: formatNumber,
        formatPercent: formatPercent,
        formatMoney: formatMoney,
        formatRelativeTime: formatRelativeTime,
        formatList: formatList,
        formatDigits: formatDigits
    };
}
/**
 * Phone numbers, emails and URLs are never localised — they are LTR digit/ASCII
 * runs that must read left-to-right even inside an RTL paragraph. Spread this
 * onto the element that holds one; it is the direction equivalent of not
 * translating a proper noun.
 *
 *   <span {...LTR_TEXT}>{doctor.phone}</span>
 *
 * `unicode-bidi: isolate` is what stops a trailing «:» or a following Persian
 * word from being dragged to the wrong end of the number.
 */ /**
 * Any shipped locale's digits IN, ASCII out.
 *
 * The inverse of `formatDigits`, and a PARSER rather than a renderer: a
 * national id, a phone or a file number typed on a Persian or an Arabic
 * keyboard has to reach the server as ASCII whatever the panel is set to. It
 * deliberately does not follow the active locale — someone reading the panel in
 * English may still be typing on a Persian keyboard.
 *
 * Built from the REGISTRY, not from a hand-written list of digit ranges, so a
 * fourth language stays a data change: `Intl.NumberFormat` is asked for each
 * locale's 0–9 and the mapping is inverted. Enumerating ranges by hand is how
 * this came to fold Persian «۰۱۲» and not Arabic-Indic «٠١٢» — two different
 * blocks that look alike at a glance, and the exact trap the doctor app hit
 * when it added Arabic.
 */ // Numbering systems we accept as INPUT, over and above the ones the registry
// ships as UI languages. The two are different axes: this panel is fa/en only,
// and an operator can still paste «٠٩١٢…» out of an email or type it on an
// Arabic keyboard. Folding it costs one entry and the alternative is a value
// that reaches the wire non-numeric.
//
// Latin is implicit (it is already ASCII). `arabext` is Persian's, so it arrives
// with the `fa` descriptor.
const $c53f9539af19d960$var$EXTRA_INPUT_NUMBERING = [
    'ar-u-nu-arab'
];
const $c53f9539af19d960$var$ASCII_BY_DIGIT = (()=>{
    const map = new Map();
    const tags = [
        ...Object.values((0, $94f36eaf2deb686d$export$e49c1078bc46f17)).map((d)=>d.intl),
        ...$c53f9539af19d960$var$EXTRA_INPUT_NUMBERING
    ];
    for (const tag of tags){
        let format;
        try {
            format = new Intl.NumberFormat(tag, {
                useGrouping: false
            });
        } catch  {
            continue; // an unsupported tag must not break input
        }
        for(let value = 0; value <= 9; value += 1)map.set(format.format(value), String(value));
    }
    return map;
})();
function $c53f9539af19d960$export$e53ee9755c8a3679(value) {
    if (value == null || value === '') return '';
    return String(value).replace(/./gu, (ch)=>$c53f9539af19d960$var$ASCII_BY_DIGIT.get(ch) ?? ch);
}
const $c53f9539af19d960$export$3433559efc22d110 = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate'
    }
};
const $c53f9539af19d960$export$ddb338179359cccc = {
    transform: 'scaleX(var(--dir-flip, 1))'
};


// ─────────────────────────────────────────────────────────────────────────────
// The one i18n context. Everything a screen needs — `t`, the formatters, the
// direction, the way to change language — comes from here and nowhere else.
//
// It is deliberately shaped like the design system's ThemeProvider, because it
// solves the same problem and should be read the same way:
//
//   1. localStorage, read synchronously during the first render, so a reload
//      paints the right language AND the right direction immediately instead of
//      flashing Persian at an English-speaking user.
//   2. The server copy (the user's `locale` attribute in Keycloak), pushed in
//      once `me` resolves. That is the real record and wins whenever it differs
//      — it is how the choice follows a staff member to the second desk.
//
// Switching language NEVER unmounts anything. The new catalogue is loaded, then
// swapped in one state update, so the router, every open dialog and every
// half-filled form survive the switch — requirement 7, and the reason this is a
// context value rather than a remount with a `key`.
// ─────────────────────────────────────────────────────────────────────────────
const $a278322405d51c25$export$5603ab5ced17ce64 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $a278322405d51c25$export$a54013f0d02a8f82({ language: language, children: children, fallback: fallback = null }) {
    // Lazy initialiser — runs before first paint, not in an effect, so <html dir>
    // is correct for the very first frame.
    const [locale, setLocale] = (0, $acw62.useState)(()=>(0, $94f36eaf2deb686d$export$fff0f9a021c4ca38)((0, $94f36eaf2deb686d$export$831a5617a2963db1)()));
    // The catalogues currently being rendered. `null` until the first load lands;
    // on a LATER switch the previous catalogue keeps rendering until the new one
    // is ready, so there is no flash of untranslated keys.
    // Where a missing key is read, nearest first (config.js `fallbackLocalesFor`):
    // Persian — unless the brand does not offer Persian — and for French and
    // German, English before it. Joined into a string so the effect below re-runs only when the
    // chain really changes, not on every render's new array.
    const chainKey = (0, $94f36eaf2deb686d$export$c7ec71c848fb6d9a)(locale).join(',');
    const [catalogs, setCatalogs] = (0, $acw62.useState)(()=>{
        const active = (0, $d7c2f9731adebacb$export$d2d95d0a2b5fab1e)(locale);
        if (!active) return null;
        const hops = (0, $94f36eaf2deb686d$export$c7ec71c848fb6d9a)(locale).map((id)=>({
                locale: id,
                catalog: (0, $d7c2f9731adebacb$export$d2d95d0a2b5fab1e)(id)
            }));
        return hops.every((hop)=>hop.catalog) ? {
            locale: locale,
            active: active,
            hops: hops
        } : null;
    });
    // Guards against an out-of-order resolution when the user switches twice
    // quickly: only the most recently requested locale may commit.
    const requested = (0, $acw62.useRef)(locale);
    (0, $acw62.useEffect)(()=>{
        requested.current = locale;
        let live = true;
        // The fallback catalogues are loaded alongside the active one so a key
        // missing from a translation can resolve synchronously, inside `t`, rather
        // than triggering a load mid-render.
        const chain = chainKey ? chainKey.split(',') : [];
        Promise.all([
            (0, $d7c2f9731adebacb$export$5bd1a830868d1d11)(locale),
            ...chain.map((id)=>(0, $d7c2f9731adebacb$export$5bd1a830868d1d11)(id))
        ]).then(([active, ...rest])=>{
            if (!live || requested.current !== locale) return;
            setCatalogs({
                locale: locale,
                active: active,
                hops: chain.map((id, i)=>({
                        locale: id,
                        catalog: rest[i]
                    }))
            });
        });
        return ()=>{
            live = false;
        };
    }, [
        locale,
        chainKey
    ]);
    // Adopt the server's copy when it arrives or changes (e.g. the user changed
    // language on another device). `null`/`undefined` means "not loaded yet" —
    // NOT "reset to default" — so an in-flight `me` query never clobbers a choice
    // the user just made. An unrecognised tag is ignored rather than applied:
    // a language this build does not ship must not blank the UI.
    const serverLanguage = (0, $94f36eaf2deb686d$export$dca0327c9b9c6498)(language);
    (0, $acw62.useEffect)(()=>{
        if (!serverLanguage) return;
        setLocale((prev)=>{
            if (prev === serverLanguage) return prev;
            (0, $94f36eaf2deb686d$export$e8146f0b19c81b97)(serverLanguage);
            return (0, $94f36eaf2deb686d$export$fff0f9a021c4ca38)(serverLanguage);
        });
    }, [
        serverLanguage
    ]);
    /**
   * Apply a language locally and cache it. Two callers:
   *   - the settings picker, so the UI switches under the user's cursor
   *     instead of after a server round trip;
   *   - app boot, to adopt the server's copy once `myProfile` resolves.
   * Persisting to the BFF is the caller's job — this only paints and caches.
   */ const changeLocale = (0, $acw62.useCallback)((next)=>{
        const id = (0, $94f36eaf2deb686d$export$dca0327c9b9c6498)(next);
        if (!id) return;
        setLocale((prev)=>{
            if (prev === id) return prev;
            (0, $94f36eaf2deb686d$export$e8146f0b19c81b97)(id);
            return (0, $94f36eaf2deb686d$export$fff0f9a021c4ca38)(id);
        });
    }, []);
    const value = (0, $acw62.useMemo)(()=>{
        const descriptor = (0, $94f36eaf2deb686d$export$57270fb1f2649979)(locale);
        const formatters = (0, $c53f9539af19d960$export$c3f4cd5551df13fd)(locale);
        // Catalogues for a DIFFERENT locale than `locale` means a switch is in
        // flight: keep translating with what we have. `t` still resolves — it just
        // resolves in the outgoing language for the frame or two it takes the new
        // catalogue to arrive from cache or network.
        const active = catalogs?.active || {};
        const renderedLocale = catalogs?.locale || locale;
        // The LAST hop is FALLBACK_LOCALE's catalogue; any before it are the
        // locale's own nearer ones. A locale with no hop is its own fallback.
        const hops = catalogs?.hops || [];
        const last = hops[hops.length - 1];
        const pluralRules = typeof Intl.PluralRules === 'function' ? new Intl.PluralRules((0, $94f36eaf2deb686d$export$57270fb1f2649979)(renderedLocale).intl) : null;
        const { t: t, tList: tList, has: has } = (0, $56c2db411f2e97f5$export$6f3122ee6dbd9f46)({
            locale: renderedLocale,
            catalog: active,
            fallbackCatalog: last ? last.catalog : active,
            fallbackLocale: last ? last.locale : renderedLocale,
            bridges: hops.slice(0, -1),
            pluralRules: pluralRules,
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        return {
            locale: // identity
            locale,
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            // Whether this reader can read the Persian clinical reference data. NOT
            // implied by `isRTL` — Arabic shares the direction and not the language.
            readsPersianData: descriptor.readsPersianData === true,
            locales: (0, $94f36eaf2deb686d$export$171765a6a37c37cd)(),
            t: // translation
            t,
            tList: tList,
            has: has,
            // formatting
            ...formatters,
            // control
            setLocale: changeLocale,
            preloadLocale: (0, $d7c2f9731adebacb$export$f2675afc1de9f02e),
            // true once the active locale's catalogue is the one being rendered
            ready: catalogs?.locale === locale
        };
    }, [
        locale,
        catalogs,
        changeLocale
    ]);
    // Only the FIRST load blocks — after that `catalogs` is never null again, so
    // a language switch re-renders in place and the navigation state survives.
    if (!catalogs) return fallback;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a278322405d51c25$export$5603ab5ced17ce64.Provider, {
        value: value,
        children: children
    });
}
var $a278322405d51c25$export$2e2bcd8739ae039 = $a278322405d51c25$export$a54013f0d02a8f82;



var $acw62 = parcelRequire("acw62");




// ─────────────────────────────────────────────────────────────────────────────
// The only way a component reads a string.
//
//   const { t, formatDate, isRTL } = useTranslation();
//   <button>{t('common.actions.save')}</button>
//
// Keys are always fully qualified — the first segment names the file the string
// lives in (see translator.js). There is no scoped/`useTranslation('visit')`
// form on purpose: one rule means a key you see in a screen is a key you can
// grep for, and a string cannot be reached by two different names.
// ─────────────────────────────────────────────────────────────────────────────
// Rendered outside a provider — a component under test, or an error boundary
// that caught the provider itself. It reports the default locale and translates
// to the humanised key rather than throwing, because "no translations" must
// never be the reason a clinical screen fails to render.
let $a3661f2c9a55da7f$var$orphan = null;
function $a3661f2c9a55da7f$var$orphanValue() {
    if (!$a3661f2c9a55da7f$var$orphan) {
        const descriptor = (0, $94f36eaf2deb686d$export$57270fb1f2649979)((0, $94f36eaf2deb686d$export$1af4c7e47ad72f44));
        const formatters = (0, $c53f9539af19d960$export$c3f4cd5551df13fd)((0, $94f36eaf2deb686d$export$1af4c7e47ad72f44));
        const { t: t, tList: tList, has: has } = (0, $56c2db411f2e97f5$export$6f3122ee6dbd9f46)({
            locale: (0, $94f36eaf2deb686d$export$1af4c7e47ad72f44),
            catalog: {},
            fallbackCatalog: {},
            joinList: formatters.formatList,
            formatNumber: formatters.formatNumber
        });
        $a3661f2c9a55da7f$var$orphan = {
            locale: (0, $94f36eaf2deb686d$export$1af4c7e47ad72f44),
            dir: descriptor.dir,
            isRTL: descriptor.dir === 'rtl',
            readsPersianData: descriptor.readsPersianData === true,
            locales: {},
            t: t,
            tList: tList,
            has: has,
            ...formatters,
            setLocale: ()=>{},
            preloadLocale: ()=>{},
            ready: false
        };
    }
    return $a3661f2c9a55da7f$var$orphan;
}
function $a3661f2c9a55da7f$export$9fc83ad70ead8663() {
    return (0, $acw62.useContext)((0, $a278322405d51c25$export$5603ab5ced17ce64)) ?? $a3661f2c9a55da7f$var$orphanValue();
}
var $a3661f2c9a55da7f$export$2e2bcd8739ae039 = $a3661f2c9a55da7f$export$9fc83ad70ead8663;











var $acw62 = parcelRequire("acw62");

/**
 * Keyboard shortcuts — the clinic app's central registry.
 *
 * The clinic app is keyboard-focused by doctrine (clinic-app/CLAUDE.md §4.2): the
 * پذیرش desk and the صندوق are wide monitors running the same few flows hundreds of
 * times a day, and the benchmark is invoice entry in under 30 seconds. That is only
 * reachable if the high-frequency actions have keys.
 *
 * Everything registers HERE. Screens never attach their own `window.addEventListener`
 * for a shortcut, because two screens binding the same key independently is invisible
 * until they are mounted together, and because a key nobody can enumerate is a key
 * nobody discovers — the `?` overlay can only list what the registry knows.
 *
 *   useShortcut('f3', () => inputRef.current?.focus(), { label: 'جست‌وجوی بیمار' })
 *
 * Precedence is last-registered-wins, so a modal that registers `esc` shadows the
 * screen underneath it for as long as it is mounted, then hands the key back.
 */ /**
 * Two contexts, deliberately.
 *
 * `RegistryCtx` must keep a STABLE identity for the life of the provider, because
 * `useShortcut` lists it as an effect dependency. A single context carrying both the
 * registry and the overlay state would change identity on every registration, which
 * would re-run every consumer's effect, which registers, which bumps again — an
 * infinite loop that only shows up once something actually binds a key.
 */ const $a2acbbdcdb6ac534$var$RegistryCtx = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $a2acbbdcdb6ac534$var$HelpCtx = /*#__PURE__*/ (0, $acw62.createContext)(null);
/** Monotonic registration counter — higher wins when several handlers share a combo. */ let $a2acbbdcdb6ac534$var$SEQ = 0;
const $a2acbbdcdb6ac534$var$FKEY = /^f([1-9]|1[0-2])$/;
const $a2acbbdcdb6ac534$export$491029574d911e8 = (raw)=>{
    const parts = String(raw || '').toLowerCase().split('+').map((s)=>s.trim()).filter(Boolean);
    let key = '';
    const mods = new Set();
    for (const p of parts){
        if (p === 'ctrl' || p === 'cmd' || p === 'meta') mods.add('ctrl');
        else if (p === 'alt' || p === 'option') mods.add('alt');
        else if (p === 'shift') mods.add('shift');
        else key = p === 'escape' ? 'esc' : p;
    }
    if (!key) return '';
    const out = [];
    if (mods.has('ctrl')) out.push('ctrl');
    if (mods.has('alt')) out.push('alt');
    if (mods.has('shift')) out.push('shift');
    out.push(key);
    return out.join('+');
};
const $a2acbbdcdb6ac534$export$fec7a04f3f2b43c1 = (e)=>{
    let key = e?.key;
    if (!key) return '';
    key = key === 'Escape' ? 'esc' : key === ' ' ? 'space' : key.toLowerCase();
    const out = [];
    if (e.ctrlKey || e.metaKey) out.push('ctrl');
    if (e.altKey) out.push('alt');
    if (e.shiftKey && key.length > 1) out.push('shift');
    out.push(key);
    return out.join('+');
};
const $a2acbbdcdb6ac534$export$763c4b15adcf804b = (el)=>{
    if (!el || !el.tagName) return false;
    const tag = el.tagName.toUpperCase();
    return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable === true;
};
const $a2acbbdcdb6ac534$export$570b40aed3a24e82 = (combo)=>{
    const key = combo.split('+').pop();
    return combo.includes('ctrl+') || combo.includes('alt+') || key === 'esc' || $a2acbbdcdb6ac534$var$FKEY.test(key);
};
/** Human-readable key caps for the help overlay, right-to-left friendly. */ const $a2acbbdcdb6ac534$var$CAP = {
    ctrl: 'Ctrl',
    alt: 'Alt',
    shift: 'Shift',
    esc: 'Esc',
    space: 'Space'
};
const $a2acbbdcdb6ac534$export$f5026c738b75de96 = (combo)=>combo.split('+').map((p)=>$a2acbbdcdb6ac534$var$CAP[p] || ($a2acbbdcdb6ac534$var$FKEY.test(p) ? p.toUpperCase() : p.toUpperCase())).join(' + ');
const $a2acbbdcdb6ac534$export$87dd7790e69558a9 = ({ children: children })=>{
    // A ref, not state: registering must not re-render the tree that is registering.
    const regs = (0, $acw62.useRef)(new Map());
    const [revision, bump] = (0, $acw62.useState)(0);
    const [helpOpen, setHelpOpen] = (0, $acw62.useState)(false);
    const register = (0, $acw62.useCallback)((id, def)=>{
        regs.current.set(id, def);
        bump((v)=>v + 1);
        return ()=>{
            regs.current.delete(id);
            bump((v)=>v + 1);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onKey = (e)=>{
            const combo = $a2acbbdcdb6ac534$export$fec7a04f3f2b43c1(e);
            if (!combo) return;
            const editable = $a2acbbdcdb6ac534$export$763c4b15adcf804b(e.target);
            let best = null;
            for (const def of regs.current.values()){
                if (def.combo !== combo || def.passive) continue;
                const fires = def.firesInInput ?? $a2acbbdcdb6ac534$export$570b40aed3a24e82(def.combo);
                if (editable && !fires) continue;
                if (!best || def.seq > best.seq) best = def; // last registered wins
            }
            if (!best) return;
            // Claim the key only once we know something handles it, so an unbound F5 still
            // reloads and Ctrl+S in a field the app does not own still belongs to the browser.
            e.preventDefault();
            e.stopPropagation();
            best.run(e);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, []);
    // Stable for the provider's lifetime: `register` is a useCallback with no deps and
    // `regs` is a ref. Nothing here may depend on `revision`.
    const registry = (0, $acw62.useMemo)(()=>({
            register: register,
            regs: regs
        }), [
        register
    ]);
    const help = (0, $acw62.useMemo)(()=>({
            revision: revision,
            helpOpen: helpOpen,
            setHelpOpen: setHelpOpen
        }), [
        revision,
        helpOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2acbbdcdb6ac534$var$RegistryCtx.Provider, {
        value: registry,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a2acbbdcdb6ac534$var$HelpCtx.Provider, {
            value: help,
            children: [
                children,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2acbbdcdb6ac534$var$ShortcutHelp, {})
            ]
        })
    });
};
const $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a = (combo, handler, opts = {})=>{
    const { label: label, group: groupOpt, enabled: enabled = true, firesInInput: firesInInput, passive: passive = false } = opts;
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    // Resolved here rather than as a default parameter: a default is evaluated
    // before the hook body, where `t` does not exist yet. Both `label` and
    // `group` arrive ALREADY TRANSLATED from the call site — they are copy the
    // caller owns — and `t`'s identity changes on a language switch, so the
    // effect below re-registers and the `?` overlay is never left in the
    // previous language.
    const group = groupOpt || t('shortcuts.groups.general');
    const registry = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$RegistryCtx);
    // The handler is read through a ref so a fresh closure every render does not
    // re-register — re-registering on every render would bump the provider, re-render
    // the child, and register again, forever.
    const handlerRef = (0, $acw62.useRef)(handler);
    handlerRef.current = handler;
    const idRef = (0, $acw62.useRef)(null);
    if (idRef.current === null) idRef.current = Symbol('shortcut');
    (0, $acw62.useEffect)(()=>{
        if (!registry || !enabled) return undefined;
        const normalized = $a2acbbdcdb6ac534$export$491029574d911e8(combo);
        if (!normalized) return undefined;
        return registry.register(idRef.current, {
            combo: normalized,
            label: label,
            group: group,
            firesInInput: firesInInput,
            passive: passive,
            seq: ++$a2acbbdcdb6ac534$var$SEQ,
            run: (e)=>handlerRef.current?.(e)
        });
    }, [
        registry,
        combo,
        label,
        group,
        enabled,
        firesInInput,
        passive
    ]);
};
const $a2acbbdcdb6ac534$export$8dc9f6f80a84c72b = ()=>{
    const registry = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$RegistryCtx);
    const help = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$HelpCtx);
    const revision = help?.revision;
    return (0, $acw62.useMemo)(()=>{
        if (!registry) return [];
        const groups = new Map();
        for (const def of registry.regs.current.values()){
            if (!def.label) continue;
            if (!groups.has(def.group)) groups.set(def.group, new Map());
            // Same combo registered twice (screen + modal): the overlay shows the one that
            // would actually fire, not both.
            const byCombo = groups.get(def.group);
            const prev = byCombo.get(def.combo);
            if (!prev || def.seq > prev.seq) byCombo.set(def.combo, def);
        }
        return [
            ...groups.entries()
        ].map(([group, byCombo])=>({
                group: group,
                items: [
                    ...byCombo.values()
                ].sort((a, b)=>a.combo.localeCompare(b.combo))
            }));
    // `revision` is the signal that `regs` (a ref) changed — it is a dependency even
    // though the body never reads it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registry,
        revision
    ]);
};
const $a2acbbdcdb6ac534$export$5e66ad77b1eb2956 = ({ combo: combo, style: style })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
        "aria-hidden": "true",
        style: {
            fontFamily: 'inherit',
            fontSize: 10,
            fontWeight: 700,
            lineHeight: 1,
            padding: '2px 5px',
            borderRadius: 4,
            whiteSpace: 'nowrap',
            background: 'rgba(255,255,255,0.22)',
            color: 'inherit',
            border: '1px solid rgba(255,255,255,0.28)',
            ...style
        },
        children: $a2acbbdcdb6ac534$export$f5026c738b75de96($a2acbbdcdb6ac534$export$491029574d911e8(combo))
    });
/**
 * The `?` overlay. Mounted once by the provider — it is the only discovery surface a
 * shortcut has, so a shortcut worth binding is a shortcut worth labelling.
 */ const $a2acbbdcdb6ac534$var$ShortcutHelp = ()=>{
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const help = (0, $acw62.useContext)($a2acbbdcdb6ac534$var$HelpCtx);
    const groups = $a2acbbdcdb6ac534$export$8dc9f6f80a84c72b();
    $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a('?', ()=>help?.setHelpOpen((v)=>!v), {
        label: t('shortcuts.overlay.title'),
        group: t('shortcuts.groups.general')
    });
    if (!help) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: help.helpOpen,
        onOpenChange: help.setHelpOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            className: "max-w-lg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t('shortcuts.overlay.heading')
                    })
                }),
                groups.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        fontSize: 13,
                        opacity: 0.7
                    },
                    children: t('shortcuts.overlay.empty')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16,
                        marginTop: 4
                    },
                    children: groups.map(({ group: group, items: items })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    style: {
                                        margin: '0 0 6px',
                                        fontSize: 12,
                                        fontWeight: 800,
                                        opacity: 0.55
                                    },
                                    children: group
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    style: {
                                        margin: 0,
                                        padding: 0,
                                        listStyle: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2
                                    },
                                    children: items.map((it)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                gap: 12,
                                                padding: '5px 0',
                                                fontSize: 13
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: it.label
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                                    dir: "ltr",
                                                    style: {
                                                        fontFamily: 'inherit',
                                                        fontSize: 11,
                                                        fontWeight: 700,
                                                        padding: '3px 7px',
                                                        borderRadius: 5,
                                                        unicodeBidi: 'isolate',
                                                        background: 'rgba(0,0,0,0.06)',
                                                        border: '1px solid rgba(0,0,0,0.1)'
                                                    },
                                                    children: $a2acbbdcdb6ac534$export$f5026c738b75de96(it.combo)
                                                })
                                            ]
                                        }, it.combo))
                                })
                            ]
                        }, group))
                })
            ]
        })
    });
};
var $a2acbbdcdb6ac534$export$2e2bcd8739ae039 = $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a;



var $acw62 = parcelRequire("acw62");

// OIDC Authorization Code + PKCE flow for Keycloak
// Runtime configuration, resolved once at module load.
//
// window.__ENV__ is written by docker-entrypoint.sh at container start from the
// k8s deployment env, so ONE image serves beta1 and staging. process.env is the
// Parcel build-time fallback for local dev.
const $d87bd335296b449f$var$runtime = typeof window !== 'undefined' && window.__ENV__ || {};
const $d87bd335296b449f$export$60d50aa713e44074 = $d87bd335296b449f$var$runtime.ADMIN_BFF_URL || undefined || 'http://localhost:4003';
const $d87bd335296b449f$export$91dbb4a8660769db = $d87bd335296b449f$var$runtime.KEYCLOAK_URL || $d87bd335296b449f$var$runtime.PARSINA_KC_BASE_URL || undefined || 'https://sso.itechtrade.ir';
// ── Keycloak identity: realm and client ─────────────────────────────────────
// Which realm this panel signs in to and which client it signs in as. Parsina's
// own values are the fallbacks, so an image run with none of these set signs in
// exactly as before; a deployment on another realm (Proxia) sets them at
// container start, same image. The same lookups as the doctor panel's.
//
// Each lookup takes the first value that is set: the brand-neutral name in
// env.js, the legacy PARSINA_* name in env.js, what the image was built with,
// today's literal. docker-entrypoint.sh writes the neutral keys and
// PARSINA_KC_REALM only when they are set.
//
// Read on every call, not once at load like the values above: what decides is
// the env.js of the page that is running, and a test can set its own.
const $d87bd335296b449f$var$runtimeNow = ()=>typeof window !== 'undefined' && window.__ENV__ || {};
function $d87bd335296b449f$export$982c4c4b626b71dc() {
    const env = $d87bd335296b449f$var$runtimeNow();
    return env.KEYCLOAK_REALM || env.PARSINA_KC_REALM || undefined || undefined || 'parsina';
}
function $d87bd335296b449f$export$7769b0c1484b082d() {
    const env = $d87bd335296b449f$var$runtimeNow();
    return env.KEYCLOAK_CLIENT_ID || env.PARSINA_KC_CLIENT_ID || undefined || 'parsina-web';
}
const $d87bd335296b449f$export$d83c88e8fa34151c = $d87bd335296b449f$var$runtime.PARSINA_ENV || undefined || 'local';
const $d87bd335296b449f$export$92162f94eb6c49d9 = $d87bd335296b449f$var$runtime.DOCTORSITE_PUBLIC_URL || undefined || 'https://parsinabot.ir/doctors';
const $d87bd335296b449f$export$3c6615908c3d10c3 = $d87bd335296b449f$export$92162f94eb6c49d9.replace(/^[a-z][a-z0-9+.-]*:\/\//i, '').replace(/\/+$/, '');
const $d87bd335296b449f$export$8ee1df3c6367a60 = $d87bd335296b449f$var$runtime.PARSINA_VERSION || undefined || 'dev';


// The realm's OIDC base and this panel's client, read at call time from env.js
// (src/lib/runtimeEnv.js): realm `parsina` and client `parsina-web` unless the
// deployment says otherwise.
const $3bdb28763df76ec7$var$kcBase = ()=>`${0, $d87bd335296b449f$export$91dbb4a8660769db}/realms/${encodeURIComponent((0, $d87bd335296b449f$export$982c4c4b626b71dc)())}`;
// Always derived at call time so redirect_uri is consistent across
// the auth request and token exchange even if the page reloads.
function $3bdb28763df76ec7$var$getRedirectUri() {
    return `${window.location.origin}/`;
}
// ── PKCE helpers ─────────────────────────────────────────────────────────────
function $3bdb28763df76ec7$var$randomBytes(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return arr;
}
function $3bdb28763df76ec7$var$base64url(buf) {
    return btoa(String.fromCharCode(...buf)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
async function $3bdb28763df76ec7$var$sha256(str) {
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return new Uint8Array(buf);
}
async function $3bdb28763df76ec7$var$generateChallenge(verifier) {
    return $3bdb28763df76ec7$var$base64url(await $3bdb28763df76ec7$var$sha256(verifier));
}
// ── Token storage ─────────────────────────────────────────────────────────────
// A sign-in lasts as long as Keycloak's refresh token — 30 days on beta1 — not
// as long as one tab (PM-0158). The REFRESH token and the id token (the logout
// hint) live in localStorage, so a new tab, a reopened browser or a Chrome that
// Android killed in the background signs in silently from them. The 5-minute
// ACCESS token stays per tab. Before this, all three lived in sessionStorage and
// every new tab or browser restart threw a valid 30-day token away and sent the
// user to the login form. A copy left in sessionStorage by an older build is
// still read, so a tab open across the deploy keeps working.
const $3bdb28763df76ec7$var$PERSISTED = [
    'kc_refresh',
    'kc_id_token'
];
function $3bdb28763df76ec7$var$durable() {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$var$readPersisted(key) {
    try {
        const v = $3bdb28763df76ec7$var$durable()?.getItem(key);
        if (v) return v;
    } catch  {}
    return sessionStorage.getItem(key);
}
function $3bdb28763df76ec7$export$257b2d10b709d8ef() {
    return sessionStorage.getItem('kc_token');
}
function $3bdb28763df76ec7$export$c8736e6c4fef498e() {
    return $3bdb28763df76ec7$var$readPersisted('kc_refresh');
}
function $3bdb28763df76ec7$export$393ade1005606e67() {
    return $3bdb28763df76ec7$var$readPersisted('kc_id_token');
}
function $3bdb28763df76ec7$var$saveTokens(token, refresh, idToken) {
    sessionStorage.setItem('kc_token', token);
    const pairs = [
        [
            'kc_refresh',
            refresh
        ],
        [
            'kc_id_token',
            idToken
        ]
    ].filter(([, v])=>v);
    try {
        const store = $3bdb28763df76ec7$var$durable();
        if (!store) throw new Error('no localStorage');
        pairs.forEach(([k, v])=>store.setItem(k, v));
        pairs.forEach(([k])=>sessionStorage.removeItem(k));
    } catch  {
        // Private mode or blocked storage: the tab still works, as it always did.
        pairs.forEach(([k, v])=>sessionStorage.setItem(k, v));
    }
}
function $3bdb28763df76ec7$export$67488bf92fa15f1e() {
    [
        'kc_token',
        'kc_refresh',
        'kc_id_token',
        'kc_verifier',
        'kc_state'
    ].forEach((k)=>sessionStorage.removeItem(k));
    try {
        $3bdb28763df76ec7$var$PERSISTED.forEach((k)=>$3bdb28763df76ec7$var$durable()?.removeItem(k));
    } catch  {}
}
// Keycloak ROTATES the refresh token. With it shared across tabs, two tabs
// refreshing at the same moment would present the same token twice and the
// second would be refused — and a refused refresh signs the user out. The
// browser's Web Locks serialise refreshes across every tab of this origin; each
// refresh reads the stored token inside the lock, so it uses the one the
// previous tab just received. Where Web Locks are missing, the per-tab
// single-flight below still holds.
async function $3bdb28763df76ec7$var$withRefreshLock(fn) {
    const locks = typeof navigator !== 'undefined' ? navigator.locks : null;
    if (!locks || typeof locks.request !== 'function') return fn();
    return locks.request('parsina-kc-refresh', ()=>fn());
}
// ── Redirect-loop guard ───────────────────────────────────────────────────────
// Records each redirect timestamp. If 3+ happen within 30 s, stops redirecting
// and lets the app render an error screen instead.
const $3bdb28763df76ec7$var$LOOP_KEY = 'kc_redirect_ts';
const $3bdb28763df76ec7$var$LOOP_LIMIT = 3;
const $3bdb28763df76ec7$var$LOOP_WIN = 30000; // ms
function $3bdb28763df76ec7$var$redirectAllowed() {
    const raw = sessionStorage.getItem($3bdb28763df76ec7$var$LOOP_KEY);
    const hist = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const recent = hist.filter((ts)=>now - ts < $3bdb28763df76ec7$var$LOOP_WIN);
    if (recent.length >= $3bdb28763df76ec7$var$LOOP_LIMIT) return false;
    sessionStorage.setItem($3bdb28763df76ec7$var$LOOP_KEY, JSON.stringify([
        ...recent,
        now
    ]));
    return true;
}
function $3bdb28763df76ec7$export$639ddbdf19445d0c() {
    sessionStorage.removeItem($3bdb28763df76ec7$var$LOOP_KEY);
}
async function $3bdb28763df76ec7$export$2fb87bbf5418dbe1() {
    if (!$3bdb28763df76ec7$var$redirectAllowed()) {
        // Too many consecutive redirects — surface the error to the user instead.
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/?auth_error=loop');
        window.location.reload();
        return;
    }
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256'
    });
    window.location.href = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/auth?${params}`;
}
async function $3bdb28763df76ec7$export$cb38df48a6bc4232() {
    console.log('[reauthorize] starting silent KC re-auth with prompt=none');
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256',
        prompt: 'none'
    });
    const url = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/auth?${params}`;
    console.log('[reauthorize] redirecting to KC:', url);
    window.location.href = url;
}
async function $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7() {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const code = params.get('code');
    const state = params.get('state');
    const verifier = sessionStorage.getItem('kc_verifier');
    const saved = sessionStorage.getItem('kc_state');
    console.log('[handleCallback] error:', error, '| hasCode:', !!code, '| stateMatch:', state === saved, '| hasVerifier:', !!verifier);
    // Keycloak returned an explicit error (access_denied, login_required, etc.)
    if (error) {
        console.warn('[handleCallback] KC returned error:', error, params.get('error_description'));
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/');
        return false;
    }
    // Missing or mismatched PKCE / state — don't retry immediately
    if (!code || !verifier || state !== saved) {
        console.warn("[handleCallback] missing code/verifier or state mismatch \u2014 aborting");
        window.history.replaceState({}, '', '/');
        return false;
    }
    const res = await fetch(`${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
            redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
            code: code,
            code_verifier: verifier
        })
    });
    window.history.replaceState({}, '', '/');
    if (!res.ok) {
        console.error('[handleCallback] token exchange failed:', res.status, await res.text());
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        console.error('[handleCallback] no access_token in response:', JSON.stringify(data));
        return false;
    }
    // Log roles from new token
    try {
        const claims = JSON.parse(atob(data.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        const roles = claims?.resource_access?.['parsina-bff']?.roles || [];
        console.log('[handleCallback] new token roles:', roles, '| sub:', claims?.sub, '| clinic_id:', claims?.clinic_id);
    } catch  {}
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    console.log('[handleCallback] tokens saved successfully');
    return true;
}
async function $3bdb28763df76ec7$var$refreshAccessTokenInTab() {
    const refresh = $3bdb28763df76ec7$export$c8736e6c4fef498e();
    if (!refresh) return false;
    const res = await fetch(`${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
            refresh_token: refresh
        })
    });
    if (!res.ok) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    return true;
}
function $3bdb28763df76ec7$export$a0973bcfe11b05c9() {
    const idToken = $3bdb28763df76ec7$export$393ade1005606e67();
    $3bdb28763df76ec7$export$67488bf92fa15f1e();
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    const params = new URLSearchParams({
        client_id: (0, $d87bd335296b449f$export$7769b0c1484b082d)(),
        post_logout_redirect_uri: $3bdb28763df76ec7$var$getRedirectUri()
    });
    if (idToken) params.set('id_token_hint', idToken);
    window.location.href = `${$3bdb28763df76ec7$var$kcBase()}/protocol/openid-connect/logout?${params}`;
}
function $3bdb28763df76ec7$export$83cd1f1503eb19c0(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$export$b007d77a962aa175(token) {
    const p = $3bdb28763df76ec7$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}
function $3bdb28763df76ec7$export$f8f36faf9a051362() {
    return $3bdb28763df76ec7$var$withRefreshLock(()=>$3bdb28763df76ec7$var$refreshAccessTokenInTab());
}



/**
 * GraphQL client for the back office.
 *
 * Auth lives entirely in auth.js — the same OIDC + PKCE flow the clinic panel
 * uses, against the same Keycloak client — so there is exactly one place a
 * mistake could grant platform access.
 */ // ── Boot vs. mounted ─────────────────────────────────────────────────────────
//
// DESIGN-CONCEPT §13.1: "a session ending is an EVENT, not a navigation", and a
// global redirect on expiry is forbidden — it is a full-document navigation, so
// React unmounts and everything unsaved on screen is destroyed without warning.
// In this panel that is a typed suspension reason or a half-filled activation,
// both of which are audited writes an operator would have to reconstruct.
//
// The one place a redirect IS right is BOOT, where there is nothing on screen to
// lose. So the client has two modes, and `AuthGate` flips it once the app is
// actually rendering.
let $4d933cf7e127f21f$var$mounted = false;
function $4d933cf7e127f21f$export$54b154e1405b9756() {
    $4d933cf7e127f21f$var$mounted = true;
}
function $4d933cf7e127f21f$export$d371eae1159a57ef() {
    $4d933cf7e127f21f$var$mounted = false;
}
const $4d933cf7e127f21f$export$d4e460b079aa2f23 = 'parsina:session-ended';
const $4d933cf7e127f21f$export$e104a61a53f2685 = 'parsina:forbidden';
function $4d933cf7e127f21f$var$endSession() {
    if ($4d933cf7e127f21f$var$mounted) {
        // Over the intact screen. Re-login returns to the same URL, so the operator
        // lands back where they were rather than on the dashboard.
        window.dispatchEvent(new Event($4d933cf7e127f21f$export$d4e460b079aa2f23));
        return;
    }
    (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
}
async function $4d933cf7e127f21f$var$validToken() {
    let token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
    if (!token) return null;
    if ((0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
        const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
        if (!ok) return null;
        token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
    }
    return token;
}
function $4d933cf7e127f21f$export$ffa605e3a9639d6(url, { dispatchForbidden: dispatchForbidden = true, unavailableCode: unavailableCode = null } = {}) {
    async function post(token, query, variables) {
        try {
            return await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    query: query,
                    variables: variables
                })
            });
        } catch (err) {
            // A THROWN fetch is a transport failure — DNS, a dropped connection, a
            // firewall — as opposed to an HTTP error, which means the BFF answered. Only
            // the former is evidence the connection is degraded, and it is evidence the
            // browser itself cannot supply: `navigator.onLine` is reliable when it says
            // false and worthless when it says true, so a captive portal or a dead VPN
            // reports "online" while discarding every packet. This report is what lets
            // the ConnectivityBanner know the difference.
            (0, $1ca1f567c505cbd8$export$87a8bdb1d0a966cf)();
            throw err;
        }
    }
    const unavailable = (message)=>{
        const err = new Error(message);
        err.code = unavailableCode;
        return err;
    };
    return async function request(query, variables = {}) {
        const token = await $4d933cf7e127f21f$var$validToken();
        if (!token) {
            $4d933cf7e127f21f$var$endSession();
            const err = new Error('Not authenticated');
            err.code = 'UNAUTHENTICATED';
            throw err;
        }
        let res = await post(token, query, variables);
        // A 401 can also mean server-side expiry or clock skew; refresh once and retry
        // before troubling the operator at all.
        if (res.status === 401) {
            const refreshed = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
            if (!refreshed) {
                $4d933cf7e127f21f$var$endSession();
                const err = new Error('Session expired');
                err.code = 'UNAUTHENTICATED';
                throw err;
            }
            res = await post((0, $3bdb28763df76ec7$export$257b2d10b709d8ef)(), query, variables);
        }
        let json;
        if (unavailableCode) try {
            json = await res.json();
        } catch  {
            throw unavailable(`HTTP ${res.status}`);
        }
        else json = await res.json();
        if (json.errors?.length) {
            const first = json.errors[0];
            const err = new Error(first.message);
            err.code = first.extensions?.code;
            // UNAUTHENTICATED means the token itself was rejected. FORBIDDEN is different
            // in kind: they ARE signed in but lack platform_admin, and logging in again
            // would produce the same token and the same rejection — so that one surfaces
            // as a page, never as a redirect, or it is an infinite loop that looks like a
            // broken site.
            if (err.code === 'UNAUTHENTICATED') $4d933cf7e127f21f$var$endSession();
            else if (err.code === 'FORBIDDEN' && dispatchForbidden) window.dispatchEvent(new Event($4d933cf7e127f21f$export$e104a61a53f2685));
            throw err;
        }
        if (unavailableCode && !res.ok) throw unavailable(`HTTP ${res.status}`);
        return json.data;
    };
}
const $4d933cf7e127f21f$export$72e4926bf8358653 = $4d933cf7e127f21f$export$ffa605e3a9639d6((0, $d87bd335296b449f$export$60d50aa713e44074));
function $4d933cf7e127f21f$export$8f882f1265f4e46e(code) {
    switch(code){
        case 'FORBIDDEN_DOWNSTREAM':
            return 'errors.code.forbiddenDownstream';
        case 'NOT_FOUND':
            return 'errors.code.notFound';
        case 'UNAVAILABLE':
            return 'errors.code.unavailable';
        case 'BUSINESS_RULE':
            return null;
        default:
            return null;
    }
}
function $4d933cf7e127f21f$export$493b5823483d2c4e(err, t) {
    const key = $4d933cf7e127f21f$export$8f882f1265f4e46e(err?.code);
    if (key) return t(key);
    return err?.message || t('errors.code.unknown');
}


const $592c9188583a4dfe$var$ME_QUERY = `query Me { me { sub name username access { platform crm } } }`;
/** What an admin BFF that predates the access model can answer. */ const $592c9188583a4dfe$var$LEGACY_ME_QUERY = `query Me { me { sub name username } }`;
function $592c9188583a4dfe$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $acw62.useState)({
        me: null,
        status: 'loading'
    });
    (0, $acw62.useEffect)(()=>{
        let live = true;
        const settle = (next)=>{
            if (live) setState(next);
        };
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)($592c9188583a4dfe$var$ME_QUERY).then((d)=>settle({
                me: d?.me || null,
                status: d?.me ? 'ready' : 'error'
            })).catch((err)=>{
            if (err?.code !== 'GRAPHQL_VALIDATION_FAILED') {
                settle({
                    me: null,
                    status: 'error'
                });
                return;
            }
            (0, $4d933cf7e127f21f$export$72e4926bf8358653)($592c9188583a4dfe$var$LEGACY_ME_QUERY).then((d)=>settle({
                    me: d?.me ? {
                        ...d.me,
                        access: null
                    } : null,
                    status: 'error'
                })).catch(()=>settle({
                    me: null,
                    status: 'error'
                }));
        });
        return ()=>{
            live = false;
        };
    }, []);
    return state;
}


/**
 * The panel's two gates, as the client sees them.
 *
 * The admin BFF computes `me.access = { platform, crm }` from the token and
 * enforces it on every request; the client only uses it to decide what to
 * OFFER — which nav items exist, which route renders a screen and which the
 * 403 page, and where `/` lands. The server stays the authority.
 *
 * Kept pure so the whole matrix is testable without rendering.
 */ /** The Keycloak role each gate names, for the 403 page's detail line. Identifiers — never translated. */ const $92377dba2841090c$export$4a9d8acae95e484b = {
    platform: 'platform_admin',
    crm: "crm_admin \xb7 marketing"
};
function $92377dba2841090c$export$2152ba8ad7f65e08({ me: me, status: status } = {}) {
    if (status === 'loading') return null;
    if (me?.access) return {
        platform: !!me.access.platform,
        crm: !!me.access.crm
    };
    return {
        platform: true,
        crm: false
    };
}
function $92377dba2841090c$export$1e5901f44ff1577d(access, requires) {
    if (!requires) return true;
    return !!access?.[requires];
}
function $92377dba2841090c$export$5d5930b97498321d(access) {
    if (!access) return null;
    if (access.platform) return '/dashboard';
    if (access.crm) return '/demo-requests';
    return null;
}




var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $224502d93617e0e1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Building2", [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ec88f95add56de8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Coins", [
    [
        "circle",
        {
            cx: "8",
            cy: "8",
            r: "6",
            key: "3yglwk"
        }
    ],
    [
        "path",
        {
            d: "M18.09 10.37A6 6 0 1 1 10.34 18",
            key: "t5s6rm"
        }
    ],
    [
        "path",
        {
            d: "M7 6h1v4",
            key: "1obek4"
        }
    ],
    [
        "path",
        {
            d: "m16.71 13.88.7.71-2.82 2.82",
            key: "1rbuyh"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cd9e54fee16cc3e5$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Earth", [
    [
        "path",
        {
            d: "M21.54 15H17a2 2 0 0 0-2 2v4.54",
            key: "1djwo0"
        }
    ],
    [
        "path",
        {
            d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
            key: "1tzkfa"
        }
    ],
    [
        "path",
        {
            d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05",
            key: "14pb5j"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b51f4920eac1ba0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Globe", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3eb8b08a7e082855$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LayoutDashboard", [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("LogOut", [
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 21 12 16 7",
            key: "1gabdz"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $59ab4c4f93bd486b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("MessageCircle", [
    [
        "path",
        {
            d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z",
            key: "vv11sd"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c1d1f5631e6bb3d2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Presentation", [
    [
        "path",
        {
            d: "M2 3h20",
            key: "91anmk"
        }
    ],
    [
        "path",
        {
            d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3",
            key: "2k9sn8"
        }
    ],
    [
        "path",
        {
            d: "m7 21 5-5 5 5",
            key: "bip4we"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f17d085e2e0469d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Store", [
    [
        "path",
        {
            d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7",
            key: "ztvudi"
        }
    ],
    [
        "path",
        {
            d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
            key: "1b2hhj"
        }
    ],
    [
        "path",
        {
            d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4",
            key: "2ebpfo"
        }
    ],
    [
        "path",
        {
            d: "M2 7h20",
            key: "1fcdvo"
        }
    ],
    [
        "path",
        {
            d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
            key: "6c3vgh"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $26e74a24e9f2bb34$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UsersRound", [
    [
        "path",
        {
            d: "M18 21a8 8 0 0 0-16 0",
            key: "3ypg7q"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "8",
            r: "5",
            key: "o932ke"
        }
    ],
    [
        "path",
        {
            d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3",
            key: "10s06x"
        }
    ]
]);







var $acw62 = parcelRequire("acw62");


const $d25e8e437795d8de$export$29264c00fb99857a = `${String((0, $d87bd335296b449f$export$60d50aa713e44074)).replace(/\/+$/, '')}/crm`;
const $d25e8e437795d8de$export$4ca7f0e3754e6cff = (0, $4d933cf7e127f21f$export$ffa605e3a9639d6)($d25e8e437795d8de$export$29264c00fb99857a, {
    dispatchForbidden: false,
    unavailableCode: 'CRM_UNAVAILABLE'
});
function $d25e8e437795d8de$export$a7044042db0fe2b0(code) {
    switch(code){
        case 'CRM_UNAVAILABLE':
        case 'SERVICE_UNAVAILABLE':
            return 'demoRequests.errors.unavailable';
        case 'FORBIDDEN':
            return 'demoRequests.errors.forbidden';
        case 'NOT_FOUND':
            return 'demoRequests.errors.notFound';
        default:
            return null;
    }
}
function $d25e8e437795d8de$export$9818a52a86c726ab(err, t) {
    const key = $d25e8e437795d8de$export$a7044042db0fe2b0(err?.code);
    if (key) return t(key);
    return err?.message || t('errors.code.unknown');
}
const $d25e8e437795d8de$export$ddcdf05b93a79128 = 'parsina:demo-requests-changed';
function $d25e8e437795d8de$export$ebec4e912cbab394() {
    try {
        window.dispatchEvent(new Event($d25e8e437795d8de$export$ddcdf05b93a79128));
    } catch  {}
}


/**
 * Every GraphQL document the demo-request screen sends. They go through
 * `crmGql` (src/lib/crmApi.js) to the admin BFF's `POST /crm`, and are built
 * against the CRM's OWN schema:
 * `marketing/parsina.bff.crm/src/graphql/typeDefs/{customer,pipeline}.js`.
 *
 * Timestamps are epoch-millisecond STRINGS end to end (`createdAtMs`,
 * `dueAtMs`, …). No write carries an actor: the CRM stamps the named human
 * from the token `sub`, and no input type there has an actor field.
 */ const $7a0de4ba2300127a$var$LEAD_FIELDS = `
  id customerId customerName title status source ownerId product
  statusChangedMs closedAtMs lostReason note createdAtMs updatedAtMs
  intent subjectRef allowedNextStatuses
  requestDetails {
    practiceType dentistCount demoMode preferredTime currentSystem
    organization city province message formId landingUrl reference
    utm { source medium campaign content term }
    slug councilNumber doctorDisplayName preferredChannel
  }
`;
const $7a0de4ba2300127a$var$INTERACTION_FIELDS = `
  id channel direction outcome leadId subject body durationSeconds actorId occurredAtMs recordedAtMs
`;
const $7a0de4ba2300127a$var$FOLLOW_UP_FIELDS = `
  id title note dueAtMs status assignedTo leadId createdBy createdAtMs completedAtMs completedBy outcomeNote
`;
const $7a0de4ba2300127a$var$NOTE_FIELDS = 'id body actorId isPinned createdAtMs';
const $7a0de4ba2300127a$export$9529f28a1af7c0ca = `
  query DemoRequests(
    $intent: String, $statuses: [String!], $ownerId: String, $unassignedOnly: Boolean,
    $createdFromMs: String, $createdToMs: String, $query: String, $limit: Int, $offset: Int,
    $withMobile: Boolean = false
  ) {
    crmLeads(
      intent: $intent, statuses: $statuses, ownerId: $ownerId, unassignedOnly: $unassignedOnly,
      createdFromMs: $createdFromMs, createdToMs: $createdToMs, query: $query, limit: $limit, offset: $offset
    ) {
      total
      leads { ${$7a0de4ba2300127a$var$LEAD_FIELDS} customerMobile @include(if: $withMobile) }
    }
  }
`;
const $7a0de4ba2300127a$export$232ffa1b964dd74b = `
  query DemoRequestsNewCount($intent: String = "demo_request") {
    crmLeads(intent: $intent, statuses: ["new"], limit: 1) { total }
  }
`;
const $7a0de4ba2300127a$export$96db00428c5a8fe2 = `
  query DemoRequestsOverdue($dueBeforeMs: String) {
    crmFollowUps(status: "open", dueBeforeMs: $dueBeforeMs, limit: 200) {
      followUps { id leadId dueAtMs }
    }
  }
`;
const $7a0de4ba2300127a$export$9a9bca587ad2669c = `
  query DemoRequest($id: ID!) {
    crmLead(id: $id) { ${$7a0de4ba2300127a$var$LEAD_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$586fa2c0c410c3b3 = `
  query DemoRequestContext($customerId: ID!, $leadId: ID!) {
    crmCustomer(id: $customerId) {
      customer {
        id firstName lastName title displayName fullName lifecycle
        doNotContact doNotContactReason archivedAtMs createdAtMs
      }
      contactPoints { id kind value isPrimary isActive label }
      professions { id specialty organization isPrimary }
    }
    crmInteractions(leadId: $leadId, limit: 200) { total interactions { ${$7a0de4ba2300127a$var$INTERACTION_FIELDS} } }
    crmFollowUps(customerId: $customerId, limit: 200) { total followUps { ${$7a0de4ba2300127a$var$FOLLOW_UP_FIELDS} } }
    crmNotes(customerId: $customerId, limit: 200) { total notes { ${$7a0de4ba2300127a$var$NOTE_FIELDS} } }
  }
`;
const $7a0de4ba2300127a$export$73df17fa4f19ea3e = `
  query DemoRequestSameNumber($value: String!, $kind: String) {
    crmFindByContact(value: $value, kind: $kind) { id fullName createdAtMs archivedAtMs }
  }
`;
const $7a0de4ba2300127a$export$b86d435ecf91a978 = `
  query DemoRequestsOfCustomer($customerId: ID!, $intent: String = "demo_request") {
    crmLeads(customerId: $customerId, intent: $intent, limit: 5) {
      leads { id status createdAtMs requestDetails { reference } }
    }
  }
`;
const $7a0de4ba2300127a$export$7db0f0dc8b39b035 = `
  mutation DemoRequestUpdate($leadId: ID!, $input: UpdateLeadInput!) {
    crmUpdateLead(leadId: $leadId, input: $input) { ${$7a0de4ba2300127a$var$LEAD_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$1b8b6acfc93feabe = `
  mutation DemoRequestSetStatus($leadId: ID!, $status: String!, $lostReason: String) {
    crmSetLeadStatus(leadId: $leadId, status: $status, lostReason: $lostReason) { ${$7a0de4ba2300127a$var$LEAD_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$da09a68702ba103c = `
  mutation DemoRequestLogContact($customerId: ID!, $input: InteractionInput!) {
    crmLogInteraction(customerId: $customerId, input: $input) { ${$7a0de4ba2300127a$var$INTERACTION_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$f69e2454bd83b8eb = `
  mutation DemoRequestFollowUp($customerId: ID!, $input: FollowUpInput!) {
    crmCreateFollowUp(customerId: $customerId, input: $input) { ${$7a0de4ba2300127a$var$FOLLOW_UP_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$e8cc1e431380fd2f = `
  mutation DemoRequestFollowUpStatus($followUpId: ID!, $status: String!, $outcomeNote: String) {
    crmSetFollowUpStatus(followUpId: $followUpId, status: $status, outcomeNote: $outcomeNote) { ${$7a0de4ba2300127a$var$FOLLOW_UP_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$cb9f0bb579809bdc = `
  mutation DemoRequestAddNote($customerId: ID!, $body: String!) {
    crmAddNote(customerId: $customerId, body: $body) { ${$7a0de4ba2300127a$var$NOTE_FIELDS} }
  }
`;
const $7a0de4ba2300127a$export$c2bde8b8b24a9d2e = `
  mutation DemoRequestArchive($id: ID!, $reason: String) {
    crmArchiveCustomer(id: $id, reason: $reason) { customer { id archivedAtMs } }
  }
`;


/**
 * The CRM lead vocabulary, as label KEYS.
 *
 * What is NOT here, on purpose: a map of which status may follow which. The
 * marketing service owns that state machine (`app/domain/lifecycle.py`
 * LEAD_TRANSITIONS) and returns `allowedNextStatuses` on every lead, computed
 * from it; this screen offers exactly that list. A second copy here would be
 * the "state machine written twice" the CRM gateway refuses to be
 * (`marketing/parsina.bff.crm/src/graphql/resolvers/pipeline.js`), and would
 * show up the first time the two disagreed as a button the server refuses.
 *
 * The vocabularies below are CLOSED sets on the server too; an unknown value
 * arriving from the wire is echoed raw by the screen, never mislabelled.
 */ /** Every lead status, in pipeline order. */ const $57e4f51624ccb99c$export$8d0cbc65f4d44137 = [
    'new',
    'contacted',
    'qualified',
    'proposal',
    'negotiation',
    'won',
    'lost'
];
const $57e4f51624ccb99c$export$7b3f54e64bb3abd5 = [
    'won',
    'lost'
];
const $57e4f51624ccb99c$export$9c9ec7eceea5d445 = (status)=>$57e4f51624ccb99c$export$7b3f54e64bb3abd5.includes(status);
const $57e4f51624ccb99c$export$dab13a906eae6c67 = (status)=>`demoRequests.status.${status}`;
const $57e4f51624ccb99c$export$82bc72f537d8f36 = {
    new: 'warning',
    contacted: 'default',
    qualified: 'default',
    proposal: 'default',
    negotiation: 'default',
    won: 'success',
    lost: 'outline'
};
const $57e4f51624ccb99c$export$571c06e0117d64c4 = 'demo_request';
const $57e4f51624ccb99c$export$ef13f627afefba0c = 'doctor_page_appointment';
const $57e4f51624ccb99c$export$7f0da323261755e2 = [
    $57e4f51624ccb99c$export$571c06e0117d64c4,
    $57e4f51624ccb99c$export$ef13f627afefba0c
];
const $57e4f51624ccb99c$export$a3dd10d1dbe08007 = (intent)=>`demoRequests.intent.${intent}`;
const $57e4f51624ccb99c$export$f84c3aaf3984b2c5 = [
    'call',
    'sms',
    'whatsapp'
];
const $57e4f51624ccb99c$export$c0ddbbb7e1c927ca = [
    'call',
    'whatsapp',
    'sms',
    'email',
    'in_person'
];
const $57e4f51624ccb99c$export$c648f9daf410fc3a = [
    'answered',
    'no_answer',
    'busy',
    'wrong_number',
    'voicemail',
    'interested',
    'not_interested',
    'callback_requested',
    'meeting_set',
    'delivered',
    'failed',
    'other'
];
const $57e4f51624ccb99c$export$a95c54b781d921ce = [
    'answered',
    'interested',
    'callback_requested',
    'meeting_set'
];
const $57e4f51624ccb99c$export$a390fae083956549 = (channel)=>`demoRequests.channel.${channel}`;
const $57e4f51624ccb99c$export$aab9b9c5e06fb4fa = (outcome)=>`demoRequests.outcome.${outcome}`;
const $57e4f51624ccb99c$export$8af1706d329452f8 = [
    'noAnswer',
    'otherSoftware',
    'price',
    'notReady',
    'duplicate',
    'spam'
];
const $57e4f51624ccb99c$export$10fc55516681f8b1 = (preset)=>`demoRequests.lost.presets.${preset}`;
const $57e4f51624ccb99c$export$e4bb73c65f68314b = Object.freeze({
    // i18n-exempt: stored CRM data (lost_reason), not UI copy — must be locale-independent.
    noAnswer: "\u067E\u0627\u0633\u062E \u0646\u062F\u0627\u062F",
    // i18n-exempt: stored CRM data (lost_reason), not UI copy — must be locale-independent.
    otherSoftware: "\u0646\u0631\u0645\u200C\u0627\u0641\u0632\u0627\u0631 \u062F\u06CC\u06AF\u0631\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0631\u062F",
    // i18n-exempt: stored CRM data (lost_reason), not UI copy — must be locale-independent.
    price: "\u0642\u06CC\u0645\u062A",
    // i18n-exempt: stored CRM data (lost_reason), not UI copy — must be locale-independent.
    notReady: "\u0645\u0637\u0628 \u0647\u0646\u0648\u0632 \u0622\u0645\u0627\u062F\u0647 \u0646\u06CC\u0633\u062A",
    // i18n-exempt: stored CRM data (lost_reason), not UI copy — must be locale-independent.
    duplicate: "\u062A\u06A9\u0631\u0627\u0631\u06CC",
    // i18n-exempt: stored CRM data (lost_reason), not UI copy — must be locale-independent.
    spam: "\u0627\u0633\u067E\u0645/\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631"
});
const $57e4f51624ccb99c$export$312e35cca8fa1c08 = 200;
const $57e4f51624ccb99c$export$45895a8451f5beee = [
    'demoSession',
    'callback'
];
const $57e4f51624ccb99c$export$676e59173ed33c48 = (preset)=>`demoRequests.followUp.presets.${preset}`;
const $57e4f51624ccb99c$export$e4869c977fd21324 = 200;
const $57e4f51624ccb99c$export$2daf5676b9ee9779 = 1000;
const $57e4f51624ccb99c$export$8d7ab321b2f5f92a = [
    'solo_office',
    'group_practice',
    'clinic',
    'other'
];
const $57e4f51624ccb99c$export$4816d0791e82f7af = [
    '1',
    '2-5',
    '6-15',
    '16+'
];
const $57e4f51624ccb99c$export$9519ea7f1259d4af = [
    'online',
    'in_person',
    'phone'
];
const $57e4f51624ccb99c$export$36bcb65afa4f49de = [
    'morning',
    'afternoon',
    'evening',
    'any'
];
const $57e4f51624ccb99c$export$abc7cced1f8727a4 = [
    'paper',
    'other_software',
    'none'
];


const $27f8b163a2bd6068$export$25f4edec250a6f85 = 60000;
function $27f8b163a2bd6068$export$2e2bcd8739ae039({ enabled: enabled = true, intervalMs: intervalMs = $27f8b163a2bd6068$export$25f4edec250a6f85, intent: intent = (0, $57e4f51624ccb99c$export$571c06e0117d64c4) } = {}) {
    const [count, setCount] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!enabled) {
            setCount(null);
            return undefined;
        }
        let live = true;
        let seq = 0;
        const hidden = ()=>typeof document !== 'undefined' && document.visibilityState === 'hidden';
        const load = ()=>{
            if (hidden()) return;
            seq += 1;
            const mine = seq;
            (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$232ffa1b964dd74b), {
                intent: intent
            }).then((d)=>{
                if (!live || mine !== seq) return;
                const total = Number(d?.crmLeads?.total);
                setCount(Number.isFinite(total) ? total : null);
            }).catch(()=>{
                if (live && mine === seq) setCount(null);
            });
        };
        load();
        const timer = setInterval(load, intervalMs);
        const onVisible = ()=>{
            if (!hidden()) load();
        };
        window.addEventListener('focus', load);
        window.addEventListener((0, $d25e8e437795d8de$export$ddcdf05b93a79128), load);
        document.addEventListener('visibilitychange', onVisible);
        return ()=>{
            live = false;
            clearInterval(timer);
            window.removeEventListener('focus', load);
            window.removeEventListener((0, $d25e8e437795d8de$export$ddcdf05b93a79128), load);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, [
        enabled,
        intervalMs,
        intent
    ]);
    return count;
}



var $f0b50123bb07e4c7$exports = {};
$f0b50123bb07e4c7$exports = import.meta.resolve("8C9I7");


var $ea750477e199405c$exports = {};
$ea750477e199405c$exports = import.meta.resolve("b5lck");


// ─────────────────────────────────────────────────────────────────────────────
// The panel's own images, chosen by the brand's `assetPack`
// (docs/rebranding/CONTRACT.md §2). Same shape as the clinic panel's.
//
//   logoWhite  the white mark on the brand gradient — the rail and the sign-in card
//
// (The pack's gradient logo.png is the favicon, set by the entrypoint; nothing in
// the panel draws it, so it is not bundled.)
//
// No pack: today's bundled Parsina images, exactly as before. A pack this build
// carries (its files live in brand-packs/<pack>/, the same folder the image
// bakes and docker-entrypoint.sh serves at /brand/ for the favicon): that pack's
// images. An image the pack does NOT carry is `null`, never Parsina's — a pack
// exists precisely so nothing of Parsina's shows. Callers hide what comes back null.
// ─────────────────────────────────────────────────────────────────────────────
const $33feb484f084e2c2$var$PARSINA = Object.freeze({
    logoWhite: (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))
});
const $33feb484f084e2c2$var$PACKS = Object.freeze({
    proxia: Object.freeze({
        logoWhite: (0, (/*@__PURE__*/$parcel$interopDefault($ea750477e199405c$exports)))
    })
});
/** The pack in force, or null for today's images (none named, or one this build lacks). */ function $33feb484f084e2c2$var$activePack() {
    const id = (0, $6386b471a95fe1b8$export$96ff94e0adb1d772)().assetPack;
    return id && Object.prototype.hasOwnProperty.call($33feb484f084e2c2$var$PACKS, id) ? $33feb484f084e2c2$var$PACKS[id] : null;
}
function $33feb484f084e2c2$export$62e0383b4cfd0a36(name) {
    const pack = $33feb484f084e2c2$var$activePack();
    if (!pack) return $33feb484f084e2c2$var$PARSINA[name] ?? null;
    return pack[name] ?? null;
}



parcelRequire("acw62");


function $28747882bd241f7d$export$2e2bcd8739ae039({ tone: tone = 'neutral', titleKey: titleKey, adviceKey: adviceKey, values: values, code: code, icon: icon, detail: detail, actions: actions = [], footer: footer, fullscreen: fullscreen = false, testId: testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039), {
        tone: tone,
        icon: icon,
        code: code,
        title: titleKey ? t(titleKey, values) : undefined,
        body: adviceKey ? t(adviceKey, values) : undefined,
        detail: detail,
        footer: footer,
        fullscreen: fullscreen,
        testId: testId,
        actions: actions
    });
}


const $b338720a444d7bab$export$90d2a9a6af631642 = [
    {
        path: '/dashboard',
        labelKey: 'nav.items.dashboard',
        Icon: (0, $3eb8b08a7e082855$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    {
        path: '/clinics',
        labelKey: 'nav.items.clinics',
        Icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    {
        path: '/ai-pricing',
        labelKey: 'nav.items.aiPricing',
        Icon: (0, $9ec88f95add56de8$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    {
        path: '/marketplace',
        labelKey: 'nav.items.marketplace',
        Icon: (0, $3f17d085e2e0469d$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    {
        path: '/whatsapp',
        labelKey: 'nav.items.whatsapp',
        Icon: (0, $59ab4c4f93bd486b$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    {
        path: '/doctor-pages',
        labelKey: 'nav.items.doctorPages',
        Icon: (0, $9b51f4920eac1ba0$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    // The rules of each jurisdiction (PM-0218) — profiles, history, insurer catalogue.
    {
        path: '/countries',
        labelKey: 'nav.items.countries',
        Icon: (0, $cd9e54fee16cc3e5$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    // Support: one person's two sign-in accounts, a record's account released (PM-0536, PM-0546).
    {
        path: '/patient-accounts',
        labelKey: 'nav.items.patientAccounts',
        Icon: (0, $26e74a24e9f2bb34$export$2e2bcd8739ae039),
        requires: 'platform'
    },
    {
        path: '/demo-requests',
        labelKey: 'nav.items.demoRequests',
        Icon: (0, $c1d1f5631e6bb3d2$export$2e2bcd8739ae039),
        requires: 'crm',
        badge: 'demoRequests'
    }
];
const $b338720a444d7bab$export$f815ccab4c996d7d = (access)=>access ? $b338720a444d7bab$export$90d2a9a6af631642.filter((item)=>(0, $92377dba2841090c$export$1e5901f44ff1577d)(access, item.requires)) : [];
/** The Compact tier's icon rail (§4.1: 769–1180px). */ const $b338720a444d7bab$var$COMPACT_QUERY = '(max-width: 1180px)';
function $b338720a444d7bab$var$useCompact() {
    const [compact, setCompact] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia($b338720a444d7bab$var$COMPACT_QUERY);
        const sync = ()=>setCompact(mq.matches);
        sync();
        if (mq.addEventListener) mq.addEventListener('change', sync);
        else mq.addListener(sync);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', sync);
            else mq.removeListener(sync);
        };
    }, []);
    return compact;
}
/**
 * One sidebar destination.
 *
 * A real `<a href>` via `asChild`, not a button with an onClick, so
 * middle-click, ⌘-click and "copy link" work — an operator who keeps the estate
 * open in one tab and a clinic in another cannot do that with a button. The
 * selected look comes from the kit's `variant="nav"` reading `data-active`, so
 * this component holds no colours of its own.
 */ function $b338720a444d7bab$var$NavItem({ path: path, label: label, Icon: Icon, active: active, compact: compact, badge: badge, badgeLabel: badgeLabel }) {
    const { formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    // The count is announced as words (`badgeLabel`), the digits are decoration.
    const shown = badge > 99 ? `${formatNumber(99)}+` : formatNumber(badge);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        asChild: true,
        variant: "nav",
        "data-active": active ? 'true' : undefined,
        className: compact ? 'justify-center px-0' : 'gap-2.5 px-3',
        "data-testid": `nav-${path.slice(1)}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
            to: path,
            // The current page is announced, not merely tinted: colour alone does
            // not tell a screen-reader user where they are (§12.1).
            "aria-current": active ? 'page' : undefined,
            title: compact ? label : undefined,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "relative inline-flex",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                            size: 18,
                            "aria-hidden": true
                        }),
                        compact && badge > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            "aria-hidden": true,
                            className: "absolute -top-1 -end-1 h-2 w-2 rounded-full bg-[var(--chip-warning-ink)]",
                            "data-testid": `nav-badge-dot-${path.slice(1)}`
                        }) : null
                    ]
                }),
                compact ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "sr-only",
                    children: label
                }) : label,
                badge > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        !compact ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "count",
                            className: "ms-auto",
                            "aria-hidden": true,
                            "data-testid": `nav-badge-${path.slice(1)}`,
                            children: shown
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "sr-only",
                            children: ` (${badgeLabel})`
                        })
                    ]
                }) : null
            ]
        })
    });
}
function $b338720a444d7bab$export$2e2bcd8739ae039({ children: children, me: me, access: access }) {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { t: t, locale: locale, setLocale: setLocale, preloadLocale: preloadLocale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const compact = $b338720a444d7bab$var$useCompact();
    const { state: state, recovered: recovered, acknowledgeRecovery: acknowledgeRecovery } = (0, $2a96b0bae45a4311$export$a32c5b7f472865fb)();
    // The «unanswered demo requests» badge (§2 D8): polled only for a caller
    // who can open the queue; hidden on any failure.
    const newDemoCount = (0, $27f8b163a2bd6068$export$2e2bcd8739ae039)({
        enabled: !!access?.crm
    });
    const badges = {
        demoRequests: newDemoCount
    };
    const railWidth = compact ? '4.25rem' : '15rem';
    // Language rows rather than a segmented control: `AccountCard`'s menu takes
    // `{label, icon, onClick}` items, and a picker that has to be a control is a
    // reason to change the kit, not to smuggle a node in. Two named rows with a
    // tick on the active one is what a menu does anyway, and each row's label is
    // the language's ENDONYM — «فارسی» stays «فارسی» in the English UI, because the
    // person who needs it is the one who cannot read the current language.
    // Only the languages the brand offers; a brand that offers one gets no rows.
    const offered = (0, $94f36eaf2deb686d$export$60d894e7aa1bc86e)();
    const languageItems = (offered.length > 1 ? offered : []).map((id)=>({
            key: `lang-${id}`,
            label: (0, $94f36eaf2deb686d$export$e49c1078bc46f17)[id].label,
            icon: id === locale ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                size: 16
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    width: 16
                }
            }),
            onClick: ()=>setLocale(id),
            onMouseEnter: ()=>preloadLocale(id),
            'data-testid': `shell-lang-${id}`
        }));
    const accountItems = [
        ...languageItems,
        {
            key: 'sign-out',
            label: t('nav.account.signOut'),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                size: 16
            }),
            tone: 'destructive',
            // A separator and the destructive tone, so nobody reaches it on the way to
            // switching language.
            separatorBefore: languageItems.length > 0,
            onClick: ()=>{
                (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
                (0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)();
            },
            'data-testid': 'shell-logout'
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid h-screen",
        style: {
            gridTemplateColumns: `${railWidth} minmax(0, 1fr)`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "#main",
                className: "sr-only focus:not-sr-only focus:absolute focus:z-[1200] focus:m-2 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-foreground focus:shadow-md",
                "data-testid": "shell-skip",
                children: t('nav.skipToContent')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
                className: "flex min-w-0 flex-col py-5",
                style: {
                    background: (0, $e7c165fb515b04ea$export$4a4d076b923f4e78)
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: compact ? 'flex justify-center pb-6' : 'flex items-center gap-2.5 px-5 pb-6',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, $33feb484f084e2c2$export$62e0383b4cfd0a36)('logoWhite'),
                                alt: "",
                                "aria-hidden": true,
                                className: "h-9 w-auto shrink-0 object-contain"
                            }),
                            !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "truncate text-base font-extrabold text-white",
                                        children: t('common.brand.name')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "truncate text-xs text-white/55",
                                        children: t('nav.product')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        "aria-label": t('nav.primary'),
                        className: "flex flex-col gap-1 px-2.5",
                        children: $b338720a444d7bab$export$f815ccab4c996d7d(access).map(({ path: path, labelKey: labelKey, Icon: Icon, badge: badge })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b338720a444d7bab$var$NavItem, {
                                path: path,
                                label: t(labelKey),
                                Icon: Icon,
                                badge: badge ? badges[badge] : null,
                                badgeLabel: badge && badges[badge] ? t(`nav.badge.${badge}`, {
                                    count: badges[badge]
                                }) : '',
                                // A second-level page keeps its parent section highlighted (§3.1),
                                // so /clinics/:id still lights «کلینیک‌ها».
                                active: location.pathname === path || location.pathname.startsWith(`${path}/`),
                                compact: compact
                            }, path))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "px-5 pb-2 font-mono text-[11px] text-white/45",
                        dir: "ltr",
                        style: {
                            unicodeBidi: 'isolate'
                        },
                        "data-testid": "shell-env",
                        children: [
                            (0, $d87bd335296b449f$export$d83c88e8fa34151c),
                            " \xb7 v",
                            (0, $d87bd335296b449f$export$8ee1df3c6367a60)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a13c7c62f369d090$export$2e2bcd8739ae039), {
                        user: {
                            name: me?.name || me?.username || t('nav.account.unknown'),
                            subtitle: me?.username || undefined
                        },
                        items: accountItems,
                        collapsed: compact,
                        menuLabel: t('nav.account.menuLabel'),
                        "data-testid": "shell-account"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                id: "main",
                className: "flex min-w-0 flex-col overflow-hidden bg-background",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0790d8ae08647dfa$export$2e2bcd8739ae039), {
                        state: state,
                        recovered: recovered,
                        onAcknowledgeRecovery: acknowledgeRecovery,
                        offlineLabel: t('errors.connectivity.offline'),
                        degradedLabel: t('errors.connectivity.degraded'),
                        restoredLabel: t('errors.connectivity.restored')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10231e94a06472aa$export$7583e06808a373a5), {
                        resetKey: location.pathname,
                        renderFallback: (error, reset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
                                tone: "danger",
                                titleKey: "errors.system.crash.title",
                                adviceKey: "errors.system.crash.advice",
                                actions: [
                                    // Re-render in place first: a screen that threw on transient data
                                    // usually comes back, and that is cheaper than a full reload for
                                    // an operator mid-ticket.
                                    {
                                        key: 'retry',
                                        label: t('common.actions.retry'),
                                        onClick: reset
                                    },
                                    {
                                        key: 'reload',
                                        label: t('common.actions.reload'),
                                        variant: 'secondary',
                                        onClick: ()=>window.location.reload()
                                    }
                                ],
                                testId: "system-crash"
                            }),
                        children: children
                    })
                ]
            })
        ]
    });
}



parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4666dd9ae485baaf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShieldAlert", [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ]
]);





function $205f65ac2abc44f3$export$2e2bcd8739ae039({ access: access, need: need, children: children }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    if (!access) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($205f65ac2abc44f3$export$e8258cba659840da, {});
    if (!(0, $92377dba2841090c$export$1e5901f44ff1577d)(access, need)) {
        const home = (0, $92377dba2841090c$export$5d5930b97498321d)(access);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
            tone: "neutral",
            code: "403",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                size: 30,
                "aria-hidden": true
            }),
            titleKey: "auth.routeDenied.title",
            adviceKey: "auth.routeDenied.body",
            detail: (0, $92377dba2841090c$export$4a9d8acae95e484b)[need],
            testId: `route-denied-${need}`,
            actions: home ? [
                {
                    key: 'home',
                    label: home === '/dashboard' ? t('common.actions.goToDashboard') : t('common.actions.goToDemoRequests'),
                    onClick: ()=>navigate(home)
                }
            ] : []
        });
    }
    return children ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {});
}
function $205f65ac2abc44f3$export$e8258cba659840da() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: t('auth.resolving'),
        className: "flex h-full flex-col gap-6 px-8 py-6",
        "data-testid": "access-pending",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$171a4533b2ae49b5), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$6a15d3f7c248c5bb), {
                rows: 6,
                columns: 5,
                dense: true
            })
        ]
    });
}
function $205f65ac2abc44f3$export$ea9a9513fd654098() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
        tone: "neutral",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
            size: 30,
            "aria-hidden": true
        }),
        titleKey: "auth.noSections.title",
        adviceKey: "auth.noSections.body",
        testId: "route-no-sections"
    });
}
function $205f65ac2abc44f3$export$b94310965bed44e6({ access: access }) {
    if (!access) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($205f65ac2abc44f3$export$e8258cba659840da, {});
    const home = (0, $92377dba2841090c$export$5d5930b97498321d)(access);
    return home ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: home,
        replace: true
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($205f65ac2abc44f3$export$ea9a9513fd654098, {});
}




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




/** Where to come back to after re-authenticating. */ const $cf276cdc77beba46$var$RETURN_KEY = 'post_login_return';
function $cf276cdc77beba46$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [ended, setEnded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onEnded = ()=>setEnded(true);
        window.addEventListener((0, $4d933cf7e127f21f$export$d4e460b079aa2f23), onEnded);
        return ()=>window.removeEventListener((0, $4d933cf7e127f21f$export$d4e460b079aa2f23), onEnded);
    }, []);
    if (!ended) return null;
    const signIn = ()=>{
        try {
            sessionStorage.setItem($cf276cdc77beba46$var$RETURN_KEY, window.location.pathname + window.location.search);
        } catch  {}
        (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
        (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: true,
        modal: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            role: "alertdialog",
            showClose: false,
            size: "sm",
            // Nothing here closes the dialog: the session is gone and every action
            // behind it would fail. The way out is forward.
            onEscapeKeyDown: (e)=>e.preventDefault(),
            onPointerDownOutside: (e)=>e.preventDefault(),
            onInteractOutside: (e)=>e.preventDefault(),
            "data-testid": "session-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: t('auth.session.title')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-sm leading-6 text-muted-foreground",
                    children: t('auth.session.body')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: signIn,
                        "data-testid": "session-dialog-signin",
                        children: t('auth.session.action')
                    })
                })
            ]
        })
    });
}
function $cf276cdc77beba46$export$edbe441a27ea7c58() {
    try {
        const url = sessionStorage.getItem($cf276cdc77beba46$var$RETURN_KEY);
        sessionStorage.removeItem($cf276cdc77beba46$var$RETURN_KEY);
        return url || null;
    } catch  {
        return null;
    }
}




/** The Keycloak role this panel requires. An identifier, so never translated. */ const $2dcfdcdd64e961a3$var$REQUIRED_ROLE = 'platform_admin';
function $2dcfdcdd64e961a3$export$2e2bcd8739ae039({ children: children }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [state, setState] = (0, $acw62.useState)('checking'); // checking | ready | denied | looped
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const params = new URLSearchParams(window.location.search);
            // The redirect guard gave up on an earlier pass. Rendering an error is the
            // ONLY thing that breaks the cycle — this branch used to be missing, so the
            // guard reloaded onto ?auth_error=loop, found no token, redirected, tripped
            // the guard again and reloaded forever on a blank page. Check it first,
            // before anything that could redirect.
            if (params.get('auth_error')) {
                setState('looped');
                return;
            }
            // Returning from Keycloak with ?code=… — exchange it before anything else.
            // Same shape the doctor and clinic panels use, and for the same reason: a
            // failed exchange is usually a single-use code being replayed (a refresh,
            // a back button, a stale tab), and one clean login fixes it. Dead-ending
            // here instead traps the operator on an error screen that a re-login would
            // have cleared. Runaway retries are the redirect guard's job, and the
            // auth_error branch above is what finally surfaces them.
            if (params.has('code')) {
                const exchanged = await (0, $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7)();
                if (cancelled) return;
                if (!exchanged) {
                    await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
                    return;
                }
                // Back to where the session ended, not to the dashboard: an operator who
                // was three filters deep in the estate when their token expired should
                // not have to find their way back.
                const back = (0, $cf276cdc77beba46$export$edbe441a27ea7c58)();
                if (back && back !== '/') window.history.replaceState({}, '', back);
            }
            const token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
            // Silent sign-in from the stored 30-day refresh token first (PM-0158).
            const restored = (!token || (0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) && (0, $3bdb28763df76ec7$export$c8736e6c4fef498e)() ? await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)() : false;
            if (!restored && (!token || (0, $3bdb28763df76ec7$export$b007d77a962aa175)(token))) {
                await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
                return;
            }
            if (!cancelled) {
                // From here on an expiry is an EVENT over the live screen rather than a
                // navigation that would discard an open form (§13.1).
                (0, $4d933cf7e127f21f$export$54b154e1405b9756)();
                setState('ready');
            }
        })().catch(()=>{
            if (!cancelled) setState('denied');
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    // A FORBIDDEN anywhere in the app means "signed in, but not platform staff".
    // Surfaced here so every screen does not have to handle it separately.
    (0, $acw62.useEffect)(()=>{
        const onForbidden = ()=>setState('denied');
        window.addEventListener((0, $4d933cf7e127f21f$export$e104a61a53f2685), onForbidden);
        return ()=>window.removeEventListener((0, $4d933cf7e127f21f$export$e104a61a53f2685), onForbidden);
    }, []);
    // The kit's session card (packages/DESIGN.md §"Session check") — the same
    // card, motion and manual sign-in link as every other Parsina panel.
    if (state === 'checking') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$cd72095868f03c30), {
        logo: (0, $33feb484f084e2c2$export$62e0383b4cfd0a36)('logoWhite'),
        brandName: t('common.brand.name'),
        panelName: t('nav.product'),
        title: t('auth.checking'),
        subtitle: t('auth.checkingHint'),
        stuckLabel: t('auth.stuck'),
        manualLabel: t('auth.manualSignIn'),
        onManualSignIn: ()=>{
            (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
        }
    });
    // Signed in against a Keycloak the BFF does not trust, or an exchange that
    // keeps failing. The SSO origin is shown because the failure this screen was
    // written for was a stale bundle pointing at the retired SSO host: the login
    // succeeded there, and the BFF rejected the resulting token forever.
    if (state === 'looped') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
        tone: "warning",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
            size: 30,
            "aria-hidden": true
        }),
        titleKey: "auth.loop.title",
        adviceKey: "auth.loop.body",
        detail: (0, $d87bd335296b449f$export$91dbb4a8660769db).replace(/^https?:\/\//, ''),
        fullscreen: true,
        testId: "auth-looped",
        actions: [
            {
                key: 'retry',
                label: t('auth.loop.retry'),
                testId: 'auth-looped-retry',
                onClick: ()=>{
                    (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                    (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
                    window.location.href = '/';
                }
            },
            {
                key: 'other',
                label: t('auth.loop.other'),
                variant: 'secondary',
                testId: 'auth-looped-logout',
                onClick: ()=>{
                    (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                    (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
                    (0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)();
                }
            }
        ]
    });
    if (state === 'denied') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
        tone: "neutral",
        code: "403",
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
            size: 30,
            "aria-hidden": true
        }),
        titleKey: "auth.denied.title",
        adviceKey: "auth.denied.body",
        // The role name as its own LTR line: it is the actionable half, and an
        // identifier inside a Persian sentence is at bidi's mercy.
        detail: $2dcfdcdd64e961a3$var$REQUIRED_ROLE,
        fullscreen: true,
        testId: "auth-denied",
        actions: [
            {
                key: 'other',
                label: t('auth.denied.action'),
                variant: 'secondary',
                testId: 'auth-denied-logout',
                onClick: ()=>{
                    (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
                    (0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)();
                }
            }
        ]
    });
    return children;
}






var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $40c424bab0bc0a95$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Layers", [
    [
        "path",
        {
            d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
            key: "8b97xw"
        }
    ],
    [
        "path",
        {
            d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65",
            key: "dd6zsq"
        }
    ],
    [
        "path",
        {
            d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65",
            key: "ep9fru"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e325251f2797f6cf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShieldCheck", [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("TrendingUp", [
    [
        "polyline",
        {
            points: "22 7 13.5 15.5 8.5 10.5 2 17",
            key: "126l90"
        }
    ],
    [
        "polyline",
        {
            points: "16 7 22 7 22 13",
            key: "kwv8wd"
        }
    ]
]);





var $acw62 = parcelRequire("acw62");

function $eb17209f5f553d78$export$2e2bcd8739ae039(titleKey) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(()=>{
        if (!titleKey) return;
        document.title = `${t(titleKey)} \xb7 ${t('nav.title.suffix')}`;
    }, [
        titleKey,
        t
    ]);
}



var $acw62 = parcelRequire("acw62");

function $e77179a3ce65222f$export$6a582373474709af(schema) {
    const [params, setParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const state = (0, $acw62.useMemo)(()=>{
        const out = {};
        for (const [key, spec] of Object.entries(schema)){
            const raw = params.get(key);
            if (raw == null || raw === '') {
                out[key] = spec.default;
                continue;
            }
            const parsed = spec.parse ? spec.parse(raw) : raw;
            // A value outside the allowed set is junk, not a filter. Falling back beats
            // rendering an empty list the operator cannot explain.
            const ok = spec.values ? spec.values.includes(parsed) : parsed != null;
            out[key] = ok ? parsed : spec.default;
        }
        return out;
    }, [
        params,
        schema
    ]);
    /**
   * Merge a patch into the URL. `null`/`undefined`/'' clears a param, as does
   * setting it to its default.
   */ const update = (0, $acw62.useCallback)((patch, { push: push = false } = {})=>{
        setParams((prev)=>{
            const next = new URLSearchParams(prev);
            for (const [key, value] of Object.entries(patch)){
                const spec = schema[key] || {};
                const serialised = value == null ? '' : String(spec.serialise ? spec.serialise(value) : value);
                if (serialised === '' || serialised === String(spec.default ?? '')) next.delete(key);
                else next.set(key, serialised);
            }
            return next;
        }, {
            replace: !push
        });
    }, [
        setParams,
        schema
    ]);
    /** Clear every param in the schema. Used by «حذف فیلترها». */ const reset = (0, $acw62.useCallback)(()=>{
        setParams((prev)=>{
            const next = new URLSearchParams(prev);
            for (const key of Object.keys(schema))next.delete(key);
            return next;
        }, {
            replace: true
        });
    }, [
        setParams,
        schema
    ]);
    return [
        state,
        update,
        reset
    ];
}
var $e77179a3ce65222f$export$2e2bcd8739ae039 = $e77179a3ce65222f$export$6a582373474709af;


/**
 * The subscription vocabulary — the two ORTHOGONAL axes this panel talks about,
 * and the order each is read in.
 *
 * Status and tier are a different question about the same clinic, and the whole
 * design turns on not conflating them: a پایه clinic is ACTIVE and entitled but
 * capped, while a lapsed طلایی clinic is EXPIRED and still holds CLINIC_GOLD —
 * it loses entitlement, not the tier it bought.
 *
 * WHY THIS IS APP-LEVEL AND NOT `statusColors` FROM THE FRAMEWORK. The kit's
 * `statusColors` covers exactly two vocabularies — the appointment lifecycle and
 * patient-record states — and DESIGN.md is explicit that a third one stays out,
 * because apps spread that map into one merged lookup and a new key would
 * clobber an existing one. A subscription's «completed» does not exist and its
 * «active» is not an appointment's. So this is the ONE place the panel names
 * these states, and there is no second copy anywhere.
 *
 * Labels are NOT here: they are catalogue keys (`clinics.status.ACTIVE`,
 * `clinics.tier.CLINIC_GOLD`), so they translate. What lives here is the part
 * that is not language — which states exist, their order, and their colour.
 */ // ── Status ───────────────────────────────────────────────────────────────────
/**
 * "No subscription row at all", which is NOT one of the service's statuses and
 * must never be dressed up as one. A clinic with no row is reported by the
 * subscription service as entitled (it fails open), so folding it into EXPIRED —
 * or into ACTIVE — is exactly how un-provisioned clinics stay invisible to ops.
 * It is a filter value and a badge of its own.
 */ const $ec7f110ce929cf56$export$bc262605061d3b3 = 'UNPROVISIONED';
const $ec7f110ce929cf56$export$7efb248cddc0b649 = 'TRIALING';
const $ec7f110ce929cf56$export$5259853bfd781fda = 'ACTIVE';
const $ec7f110ce929cf56$export$a3c5aecbde19a676 = 'PAST_DUE';
const $ec7f110ce929cf56$export$d843a31c0f9593b9 = 'EXPIRED';
const $ec7f110ce929cf56$export$ed283815468fe932 = 'SUSPENDED';
const $ec7f110ce929cf56$export$b41c0f52c41112e3 = [
    $ec7f110ce929cf56$export$7efb248cddc0b649,
    $ec7f110ce929cf56$export$5259853bfd781fda,
    $ec7f110ce929cf56$export$a3c5aecbde19a676,
    $ec7f110ce929cf56$export$d843a31c0f9593b9,
    $ec7f110ce929cf56$export$ed283815468fe932
];
const $ec7f110ce929cf56$export$7d4209ff166fcb41 = [
    'ALL',
    $ec7f110ce929cf56$export$bc262605061d3b3,
    $ec7f110ce929cf56$export$a3c5aecbde19a676,
    $ec7f110ce929cf56$export$7efb248cddc0b649,
    $ec7f110ce929cf56$export$5259853bfd781fda,
    $ec7f110ce929cf56$export$d843a31c0f9593b9,
    $ec7f110ce929cf56$export$ed283815468fe932
];
const $ec7f110ce929cf56$export$a2a7e133070551dc = [
    $ec7f110ce929cf56$export$bc262605061d3b3,
    $ec7f110ce929cf56$export$ed283815468fe932,
    $ec7f110ce929cf56$export$d843a31c0f9593b9,
    $ec7f110ce929cf56$export$a3c5aecbde19a676,
    $ec7f110ce929cf56$export$7efb248cddc0b649,
    $ec7f110ce929cf56$export$5259853bfd781fda
];
const $ec7f110ce929cf56$export$c26dc91cd2a16d73 = {
    [$ec7f110ce929cf56$export$7efb248cddc0b649]: 'outline',
    [$ec7f110ce929cf56$export$5259853bfd781fda]: 'success',
    [$ec7f110ce929cf56$export$a3c5aecbde19a676]: 'warning',
    [$ec7f110ce929cf56$export$d843a31c0f9593b9]: 'destructive',
    [$ec7f110ce929cf56$export$ed283815468fe932]: 'destructive',
    [$ec7f110ce929cf56$export$bc262605061d3b3]: 'outline'
};
const $ec7f110ce929cf56$export$a6fa64a5bb204a1a = 'CLINIC_BASIC';
const $ec7f110ce929cf56$export$e2dd0f36757cc41b = 'CLINIC_SILVER';
const $ec7f110ce929cf56$export$7326a3ac3521b9d2 = 'CLINIC_GOLD';
const $ec7f110ce929cf56$export$67a3419b6c83c58c = [
    $ec7f110ce929cf56$export$a6fa64a5bb204a1a,
    $ec7f110ce929cf56$export$e2dd0f36757cc41b,
    $ec7f110ce929cf56$export$7326a3ac3521b9d2
];
const $ec7f110ce929cf56$export$5ecd1cf643281a55 = {
    [$ec7f110ce929cf56$export$a6fa64a5bb204a1a]: 'outline',
    [$ec7f110ce929cf56$export$e2dd0f36757cc41b]: 'default',
    [$ec7f110ce929cf56$export$7326a3ac3521b9d2]: 'success'
};
const $ec7f110ce929cf56$export$d926e5d057600107 = (capabilitySet)=>$ec7f110ce929cf56$export$67a3419b6c83c58c.indexOf(capabilitySet);
const $ec7f110ce929cf56$export$5aeba3c817b68975 = (status)=>`clinics.status.${status || $ec7f110ce929cf56$export$bc262605061d3b3}`;
const $ec7f110ce929cf56$export$bf4a1c4dc050ab09 = (capabilitySet)=>$ec7f110ce929cf56$export$67a3419b6c83c58c.includes(capabilitySet) ? `clinics.tier.${capabilitySet}` : null;
const $ec7f110ce929cf56$export$60ca8054b2cfeba4 = {
    GRANDFATHERED: 'clinic.origin.grandfathered',
    SALES: 'clinic.origin.sales',
    SELF_SERVICE: 'clinic.origin.selfService'
};
const $ec7f110ce929cf56$export$70ef9c0ff7dc41b7 = {
    GATEWAY: 'clinic.periods.source.gateway',
    MANUAL: 'clinic.periods.source.manual',
    INITIAL: 'clinic.periods.source.initial'
};
const $ec7f110ce929cf56$export$f19a5aaabf336f6c = {
    'clinic.subscription.created': 'clinic.eventType.created',
    'clinic.subscription.activated': 'clinic.eventType.activated',
    'clinic.subscription.renewed': 'clinic.eventType.renewed',
    'clinic.subscription.reactivated': 'clinic.eventType.reactivated',
    'clinic.subscription.past_due': 'clinic.eventType.pastDue',
    'clinic.subscription.expired': 'clinic.eventType.expired',
    'clinic.subscription.suspended': 'clinic.eventType.suspended',
    'clinic.subscription.unsuspended': 'clinic.eventType.unsuspended',
    'clinic.subscription.override_granted': 'clinic.eventType.overrideGranted',
    'clinic.subscription.not_renewing_set': 'clinic.eventType.notRenewingSet',
    'clinic.subscription.trial_ended': 'clinic.eventType.trialEnded',
    'clinic.subscription.plan_changed': 'clinic.eventType.planChanged',
    'clinic.subscription.expiring_soon': 'clinic.eventType.expiringSoon'
};


/**
 * Domain formatting for the back office.
 *
 * These are the answers that are the same in every language once you hand them a
 * translator: which words describe a term, what "valid until" means for a
 * subscription that has no end date, how close a lapse is. Everything that is
 * genuinely locale work — digits, dates, money, plurals — belongs to
 * `useTranslation()` and is NOT re-implemented here.
 *
 * That split is why the previous version of this file is gone rather than
 * extended. It exported `toFa`, `faAmount`, `jalaliDate` and `rialToToman`, so
 * every render site called a Persian-only formatter directly: the panel rendered
 * «۱۲ مرداد ۱۴۰۴» and «۱۵٬۰۰۰٬۰۰۰ تومان» whatever language it was set to, and a
 * render site knew which language was active — which DESIGN-CONCEPT §16.1 names
 * as the defect, because a single seam is the only way the rule can hold.
 *
 * Every function takes `t` (and a formatter where it needs one) as an argument
 * rather than calling a hook, so they stay pure and testable without rendering.
 */ 
/**
 * List behaviour, in one place so two screens cannot disagree about it.
 */ /**
 * Rows per page in the clinic list.
 *
 * Paging is CLIENT-SIDE: the BFF answers `clinics` with the whole estate in one
 * call (it joins every clinic to a batched entitlement snapshot), so narrowing,
 * sorting and paging cost no round trip. 50 is chosen against the two failure
 * modes — a page an operator has to scroll twice, and a DOM big enough to make
 * sorting feel slow. DESIGN-CONCEPT §9.1 caps unbounded rendering at ~200 rows.
 *
 * When the estate passes roughly a thousand clinics this has to move to the
 * server (`limit`/`offset`/`sort` on the query), and the filters with it. That
 * is a BFF change, not a client one; until then client paging is the honest
 * shape, because the data is already here.
 */ const $cdf3712044ab22f9$export$8ec3d08588d2eeda = 50;
const $cdf3712044ab22f9$export$e907fe684aa8ce6c = 300;
const $cdf3712044ab22f9$export$d6920ac008449896 = 2;
const $cdf3712044ab22f9$export$4946d8446c21041b = 20;
const $cdf3712044ab22f9$export$97f98e27f371942a = 14;




const $7df21990c7b31bb5$export$ccb33e29d92c9a58 = "\u2014";
function $7df21990c7b31bb5$export$c6aafd8353c81df({ planCode: planCode, capabilitySet: capabilitySet, tierNameFa: tierNameFa } = {}, t) {
    const key = (0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(capabilitySet);
    if (key) return t(key);
    if (capabilitySet) return capabilitySet;
    if (tierNameFa) return tierNameFa;
    return planCode || $7df21990c7b31bb5$export$ccb33e29d92c9a58;
}
function $7df21990c7b31bb5$export$497627c16d0f1457(periodMonths, t) {
    if (!periodMonths) return t('common.term.unlimited');
    if (periodMonths === 12) return t('common.term.annual');
    if (periodMonths === 1) return t('common.term.monthly');
    return t('common.term.months', {
        count: periodMonths
    });
}
function $7df21990c7b31bb5$export$316445b56b177ccd(subscription, { t: t, formatDate: formatDate }) {
    if (!subscription) return $7df21990c7b31bb5$export$ccb33e29d92c9a58;
    if (subscription.currentPeriodEnd) return formatDate(subscription.currentPeriodEnd);
    if (subscription.trialEndsAt) return t('clinic.unlimited.trial', {
        date: formatDate(subscription.trialEndsAt)
    });
    return subscription.planCode ? t('clinic.unlimited.perpetual') : t('clinic.unlimited.grandfathered');
}
function $7df21990c7b31bb5$export$74a7c8108b4f784d(iso, now = Date.now()) {
    if (!iso) return null;
    const end = new Date(iso).getTime();
    if (Number.isNaN(end)) return null;
    const day = 86400000;
    return Math.floor(end / day) - Math.floor(now / day);
}
function $7df21990c7b31bb5$export$550e570667f607fb(iso, { t: t, now: now = Date.now() } = {}) {
    const days = $7df21990c7b31bb5$export$74a7c8108b4f784d(iso, now);
    if (days === null) return null;
    if (days < 0) return {
        tone: 'danger',
        text: t('clinics.lapse.pastDays', {
            count: -days
        })
    };
    if (days === 0) return {
        tone: 'danger',
        text: t('clinics.lapse.today')
    };
    if (days <= (0, $cdf3712044ab22f9$export$97f98e27f371942a)) return {
        tone: 'warn',
        text: t('clinics.lapse.inDays', {
            count: days
        })
    };
    return null;
}
const $7df21990c7b31bb5$export$78fb443a25ba8d2d = (row)=>row?.currentPeriodEnd || row?.trialEndsAt || null;
function $7df21990c7b31bb5$export$b0c4fd215b5002d2(origin, t) {
    const key = (0, $ec7f110ce929cf56$export$60ca8054b2cfeba4)[origin];
    return key ? t(key) : origin || $7df21990c7b31bb5$export$ccb33e29d92c9a58;
}
function $7df21990c7b31bb5$export$b24a5134b1f0c690(source, t) {
    const key = (0, $ec7f110ce929cf56$export$70ef9c0ff7dc41b7)[source];
    return key ? t(key) : source || $7df21990c7b31bb5$export$ccb33e29d92c9a58;
}
function $7df21990c7b31bb5$export$b0a954b9d4388eb1(eventType, t) {
    const key = (0, $ec7f110ce929cf56$export$f19a5aaabf336f6c)[eventType];
    return key ? t(key) : null;
}
const $7df21990c7b31bb5$export$a8fd04b9a9ade0b6 = 4;
const $7df21990c7b31bb5$var$USD_FLOOR = 10 ** -$7df21990c7b31bb5$export$a8fd04b9a9ade0b6;
function $7df21990c7b31bb5$export$314c2519e15cb3a9(value, { formatNumber: formatNumber, t: t }) {
    if (value == null || value === '' || !Number.isFinite(Number(value))) return $7df21990c7b31bb5$export$ccb33e29d92c9a58;
    const n = Number(value);
    const options = {
        minimumFractionDigits: 0,
        maximumFractionDigits: $7df21990c7b31bb5$export$a8fd04b9a9ade0b6
    };
    if (n > 0 && n < $7df21990c7b31bb5$var$USD_FLOOR) return t('aiPricing.usd.tiny', {
        threshold: formatNumber($7df21990c7b31bb5$var$USD_FLOOR, options)
    });
    return formatNumber(n, options);
}
function $7df21990c7b31bb5$export$dc766bb5b31bee30(code, { t: t, locale: locale }) {
    const c = code || (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
    if (c === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e)) return t('common.units.tomanName');
    return (0, $fcda591c8cd139a4$export$68d15a182c6bcbf0)(c) ? (0, $fcda591c8cd139a4$export$846d8329e0c3da65)(c, $7df21990c7b31bb5$var$kitLabelLocale(c, locale)) : null;
}
/**
 * The language to ask the kit's currency table in: `locale` when the table has
 * a label in it, else the nearest hop of the panel's own fallback chain that
 * it has (fr → en → fa, PM-0185 D4). A kit that does not know a language reads
 * it as Persian — the pinned v0.21.0 table has no French — and a French reader
 * must be shown English before Persian.
 */ function $7df21990c7b31bb5$var$kitLabelLocale(code, locale) {
    const labels = (0, $fcda591c8cd139a4$export$76e9d3e89dba5250)[code]?.labels || {};
    const known = (id)=>Object.prototype.hasOwnProperty.call(labels, id);
    if (known(locale)) return locale;
    return (0, $94f36eaf2deb686d$export$c7ec71c848fb6d9a)(locale).find(known) || locale;
}
function $7df21990c7b31bb5$export$a77493cee3770d44(code, { t: t, locale: locale }) {
    const c = code || (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
    const name = $7df21990c7b31bb5$export$dc766bb5b31bee30(c, {
        t: t,
        locale: locale
    });
    return name ? t('clinic.fields.currencyValue', {
        name: name,
        code: c
    }) : c;
}
const $7df21990c7b31bb5$export$9df85c386a2af045 = (code)=>!!code && code !== (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
const $7df21990c7b31bb5$export$d2f719a5670e623a = (code)=>!code || code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
function $7df21990c7b31bb5$export$f76b597c9baf5209(code, { t: t, locale: locale = 'fa' }) {
    if ($7df21990c7b31bb5$export$d2f719a5670e623a(code)) return t('common.units.toman');
    return (0, $fcda591c8cd139a4$export$68d15a182c6bcbf0)(code) ? (0, $fcda591c8cd139a4$export$846d8329e0c3da65)(code, locale, 'short') : code;
}
const $7df21990c7b31bb5$export$cc7bc313e3696c38 = 'IRT';
const $7df21990c7b31bb5$export$d72e5b8b2761465b = (code)=>!code || code === $7df21990c7b31bb5$export$cc7bc313e3696c38;
function $7df21990c7b31bb5$export$539a7225fef603b0(price, code, { t: t, formatNumber: formatNumber, formatMoney: formatMoney, minor: minor = false }) {
    if (price == null || price === '' || !Number.isFinite(Number(price))) return $7df21990c7b31bb5$export$ccb33e29d92c9a58;
    if ($7df21990c7b31bb5$export$d72e5b8b2761465b(code)) return `${formatNumber(Number(price))} ${t('common.units.toman')}`;
    if (!(0, $fcda591c8cd139a4$export$68d15a182c6bcbf0)(code)) return `${price} ${code}`;
    const amountMinor = minor ? Number(price) : Math.round(Number(price) * (0, $fcda591c8cd139a4$export$272b829bb65f9e96)(code).displayDivisor);
    return formatMoney(amountMinor, {
        currency: code,
        withUnit: true,
        unitStyle: 'short'
    });
}
function $7df21990c7b31bb5$export$a30d2858941ab707({ price: price, currency: currency }, wallet) {
    if (price == null || price === '' || !wallet?.amountMinor) return false;
    const policyCode = currency || $7df21990c7b31bb5$export$cc7bc313e3696c38;
    const walletCode = wallet.currency || $7df21990c7b31bb5$export$cc7bc313e3696c38;
    if (policyCode !== walletCode) return true;
    const divisor = $7df21990c7b31bb5$export$d72e5b8b2761465b(walletCode) ? 1 : (0, $fcda591c8cd139a4$export$68d15a182c6bcbf0)(walletCode) ? (0, $fcda591c8cd139a4$export$272b829bb65f9e96)(walletCode).displayDivisor : null;
    if (divisor == null) return false;
    return Math.round(Number(price) * divisor) !== Number(wallet.amountMinor);
}




var $acw62 = parcelRequire("acw62");




/**
 * Grouped bars over time — one group per bucket, one bar per series.
 *
 * ── DIRECTION IS A PROP OF THE READER, NOT OF THE GEOMETRY ──────────────────
 * Time runs toward the reading direction: earliest at the inline-START, so at the
 * right in Persian and at the left in English. The predecessor hard-coded the RTL
 * layout into its arithmetic (`groupRight = width - PAD.right - gi * groupW`),
 * which is not a thing a `dir` flip can fix — under `ltr` it drew the series
 * backwards, with the newest month first. Here the bucket array is ordered for
 * the reader and then laid out left-to-right by one formula, so there is only one
 * geometry to be right.
 *
 * ── ONE Y-AXIS, ALWAYS ──────────────────────────────────────────────────────
 * Two scales on one chart is the single most common charting mistake and it makes
 * every comparison between the series a lie. Revenue is a SEPARATE chart for
 * exactly this reason: it shares the x-domain and nothing else.
 *
 * ── THE VALUE LABELS ARE NOT DECORATION ─────────────────────────────────────
 * The palette was validated computationally rather than chosen by eye — lightness
 * band, chroma floor, and worst adjacent CVD ΔE all pass — but two of the hues sit
 * below 3:1 against the card surface. That is a WARN, not a dismissal, and it
 * obligates visible relief: hence a number above every bar and a legend that is
 * always present. Identity is never carried by colour alone here.
 *
 * ── AND IT IS OPERABLE ──────────────────────────────────────────────────────
 * Every bar is a focusable `<g role="img">` with its own accessible name, so the
 * values are reachable by keyboard and readable by a screen reader. Hover-only
 * was the previous behaviour, which meant the chart's actual numbers existed for
 * mouse users exclusively.
 *
 * Props:
 *   buckets     [{ label, ...seriesKeys }] in CHRONOLOGICAL order
 *   series      [{ key, label, color }]
 *   formatValue (n) => string — axis ticks, bar labels, the accessible name
 *   formatBucket(label) => string
 *   ariaLabel   names the whole figure
 *   height      px, default 240
 */ const $17f7faa9df1ce052$var$PAD_BLOCK = {
    top: 28,
    bottom: 34
};
const $17f7faa9df1ce052$var$AXIS_GUTTER = 44; // room for the y-axis labels, on the inline-start side
const $17f7faa9df1ce052$var$EDGE_GUTTER = 12;
const $17f7faa9df1ce052$var$BAR_GAP = 2;
const $17f7faa9df1ce052$var$GROUP_GAP = 26;
const $17f7faa9df1ce052$var$RADIUS = 4;
const $17f7faa9df1ce052$var$TICKS = 5;
function $17f7faa9df1ce052$export$2e2bcd8739ae039({ buckets: buckets = [], series: series = [], formatValue: formatValue, formatBucket: formatBucket, ariaLabel: ariaLabel, height: height = 240, emptyTitle: emptyTitle, emptyDescription: emptyDescription, 'data-testid': testId = 'growth-chart' }) {
    const { t: t, isRTL: isRTL, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const fmtValue = formatValue || formatNumber;
    const fmtBucket = formatBucket || ((label)=>label);
    if (!buckets.length || !series.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: emptyTitle || t('dashboard.chart.emptyTitle'),
        description: emptyDescription || t('dashboard.chart.emptyDesc'),
        "data-testid": `${testId}-empty`
    });
    // Ordered FOR THE READER: earliest at the inline-start. Everything below then
    // lays out left-to-right, which is the only direction SVG coordinates have.
    const ordered = isRTL ? [
        ...buckets
    ].reverse() : buckets;
    // The axis sits at the inline-start edge, so its gutter swaps sides with the
    // reading direction rather than being a fixed `left`.
    const padStart = isRTL ? $17f7faa9df1ce052$var$EDGE_GUTTER : $17f7faa9df1ce052$var$AXIS_GUTTER;
    const padEnd = isRTL ? $17f7faa9df1ce052$var$AXIS_GUTTER : $17f7faa9df1ce052$var$EDGE_GUTTER;
    const max = Math.max(1, ...ordered.flatMap((b)=>series.map((s)=>Number(b[s.key]) || 0)));
    const width = Math.max(320, ordered.length * 110);
    const plotH = height - $17f7faa9df1ce052$var$PAD_BLOCK.top - $17f7faa9df1ce052$var$PAD_BLOCK.bottom;
    const plotW = width - padStart - padEnd;
    const groupW = plotW / ordered.length;
    const barW = Math.max(6, (groupW - $17f7faa9df1ce052$var$GROUP_GAP - $17f7faa9df1ce052$var$BAR_GAP * (series.length - 1)) / series.length);
    // Four recessive gridlines at values a human would say out loud. Keyed by
    // INDEX, not by value: with a small max the rounded values repeat (max=1 gives
    // 0,0,1,1,1) and React discarded the duplicates, which is a real warning the
    // test suite was printing on every run.
    const ticks = Array.from({
        length: $17f7faa9df1ce052$var$TICKS
    }, (_, i)=>({
            i: i,
            value: Math.round(max / ($17f7faa9df1ce052$var$TICKS - 1) * i)
        }));
    const axisX = isRTL ? width - padEnd + 4 : padStart - 6;
    const axisAnchor = isRTL ? 'start' : 'end';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    width: width,
                    height: height,
                    role: "img",
                    "aria-label": ariaLabel,
                    children: [
                        ticks.map(({ i: i, value: value })=>{
                            const y = $17f7faa9df1ce052$var$PAD_BLOCK.top + plotH - value / max * plotH;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                        x1: padStart,
                                        x2: width - padEnd,
                                        y1: y,
                                        y2: y,
                                        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                                        strokeWidth: "1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                        x: axisX,
                                        y: y + 4,
                                        fontSize: "10",
                                        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        textAnchor: axisAnchor,
                                        children: fmtValue(value)
                                    })
                                ]
                            }, i);
                        }),
                        ordered.map((bucket, gi)=>{
                            const groupStart = padStart + gi * groupW;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                children: [
                                    series.map((s, si)=>{
                                        const value = Number(bucket[s.key]) || 0;
                                        const barH = value === 0 ? 0 : Math.max(2, value / max * plotH);
                                        const x = groupStart + $17f7faa9df1ce052$var$GROUP_GAP / 2 + si * (barW + $17f7faa9df1ce052$var$BAR_GAP);
                                        const y = $17f7faa9df1ce052$var$PAD_BLOCK.top + plotH - barH;
                                        const isActive = active?.bucket === bucket.label && active?.key === s.key;
                                        const name = t('dashboard.chart.point', {
                                            bucket: fmtBucket(bucket.label),
                                            series: s.label,
                                            value: fmtValue(value)
                                        });
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                            role: "img",
                                            "aria-label": name,
                                            tabIndex: 0,
                                            className: "outline-none focus-visible:[&>rect]:stroke-2",
                                            onMouseEnter: ()=>setActive({
                                                    bucket: bucket.label,
                                                    key: s.key,
                                                    value: value,
                                                    series: s
                                                }),
                                            onMouseLeave: ()=>setActive(null),
                                            onFocus: ()=>setActive({
                                                    bucket: bucket.label,
                                                    key: s.key,
                                                    value: value,
                                                    series: s
                                                }),
                                            onBlur: ()=>setActive(null),
                                            children: [
                                                barH > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    x: x,
                                                    y: y,
                                                    width: barW,
                                                    height: barH,
                                                    // Rounded data-end only; the base stays anchored to the
                                                    // axis so bar heights remain comparable.
                                                    rx: Math.min($17f7faa9df1ce052$var$RADIUS, barW / 2),
                                                    fill: s.color,
                                                    stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                    strokeWidth: 0,
                                                    opacity: active && !isActive ? 0.45 : 1
                                                }) : // A zero still needs a focus target, or the keyboard path
                                                // skips the months where nothing happened — which are
                                                // exactly the ones an operator is looking for.
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                    x: x,
                                                    y: $17f7faa9df1ce052$var$PAD_BLOCK.top + plotH - 2,
                                                    width: barW,
                                                    height: 2,
                                                    fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
                                                }),
                                                value > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                                    x: x + barW / 2,
                                                    y: y - 5,
                                                    fontSize: "10",
                                                    fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                    textAnchor: "middle",
                                                    children: fmtValue(value)
                                                }) : null
                                            ]
                                        }, s.key);
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                        x: groupStart + groupW / 2,
                                        y: height - 12,
                                        fontSize: "11",
                                        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        textAnchor: "middle",
                                        children: fmtBucket(bucket.label)
                                    })
                                ]
                            }, bucket.label);
                        })
                    ]
                })
            }),
            series.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3 flex flex-wrap items-center gap-x-5 gap-y-2",
                children: [
                    series.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "inline-flex items-center gap-1.5 text-xs text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "inline-block h-2.5 w-2.5 rounded-sm",
                                    style: {
                                        background: s.color
                                    },
                                    "aria-hidden": "true"
                                }),
                                s.label
                            ]
                        }, s.key)),
                    active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xs font-semibold text-foreground",
                        "data-testid": `${testId}-hover`,
                        children: t('dashboard.chart.point', {
                            bucket: fmtBucket(active.bucket),
                            series: active.series.label,
                            value: fmtValue(active.value)
                        })
                    }) : null
                ]
            })
        ]
    });
}



parcelRequire("acw62");


function $06825f2e23315751$export$2e2bcd8739ae039({ rows: rows = [], note: note, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "flex flex-col gap-3",
                children: rows.map((row)=>{
                    // A label may be a NODE (a model id inside an LTR island); the string
                    // for `title` and the accessible name then comes from `row.title`.
                    const text = row.title ?? (typeof row.label === 'string' ? row.label : '');
                    const body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "min-w-0 flex-[2] truncate text-sm text-muted-foreground",
                                title: text,
                                children: row.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "h-2.5 w-[22%] min-w-[2.5rem] shrink-0 overflow-hidden rounded-full bg-muted",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "block h-full rounded-full transition-[width] duration-300",
                                    // A computed proportion cannot be a utility class; the colour is
                                    // still a token, never a literal.
                                    style: {
                                        width: `${row.percent}%`,
                                        background: row.tone
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "w-10 shrink-0 text-end text-sm font-semibold tabular-nums text-foreground",
                                children: row.value
                            }),
                            row.extra !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "min-w-0 flex-1 truncate text-end text-xs tabular-nums text-muted-foreground",
                                title: typeof row.extra === 'string' ? row.extra : undefined,
                                children: row.extra
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: row.href ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: row.href,
                            className: "flex items-center gap-3 rounded-lg py-0.5 outline-none transition-colors hover:bg-muted focus-visible:ring-2 focus-visible:ring-ring",
                            // The bar and the percentage are decoration around a number that
                            // is already in the row, so the link's accessible name is built
                            // from the parts that carry meaning.
                            "aria-label": t('dashboard.row.shareOf', {
                                label: text,
                                value: row.value,
                                percent: `${row.percent}%`
                            }),
                            children: body
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center gap-3 py-0.5",
                            children: body
                        })
                    }, row.key);
                })
            }),
            note ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-4 border-t border-border pt-3 text-xs text-muted-foreground",
                children: note
            }) : null
        ]
    });
}


/**
 * Archetype A (Cockpit) — the estate at a glance.
 *
 * ① PageHeader + context widget · ② alerts · ③ KPI strip · ⑤ P2 main+rail.
 *
 * ── EVERY NUMBER IS A DOOR ──────────────────────────────────────────────────
 * A KPI or a breakdown row names a filtered list that already exists one click
 * away, so each one that can be is a link. Reading «۴ بدون اشتراک» and then having
 * to go and rebuild that filter by hand is the panel making the operator do its
 * work.
 *
 * ── TWO CHARTS, NOT ONE WITH TWO AXES ───────────────────────────────────────
 * Counts and money share the x-domain and nothing else. A dual axis would make
 * every visual comparison between them meaningless, which is worse than two
 * charts. `revenueRial` and `lifetimeRevenueRial` were fetched and rendered
 * nowhere at all before this.
 */ const $812885e94a0e636d$var$METRICS_QUERY = `
  query GrowthMetrics($from: String, $bucket: String) {
    growthMetrics(from: $from, bucket: $bucket) {
      buckets {
        label signups activations renewals expirations reactivations revenueRial
      }
      totalClinics trialing active pastDue expired suspended neverExpires
      perpetual unprovisioned
      tiers { capabilitySet tierNameFa clinics mrrRial }
      mrrRial lifetimeRevenueRial trialConversionPct currency
    }
  }
`;
const $812885e94a0e636d$var$RANGES = [
    '6m',
    '12m',
    'all'
];
const $812885e94a0e636d$var$BUCKETS = [
    'month',
    'week'
];
const $812885e94a0e636d$var$SCHEMA = {
    range: {
        default: '12m',
        values: $812885e94a0e636d$var$RANGES
    },
    bucket: {
        default: 'month',
        values: $812885e94a0e636d$var$BUCKETS
    }
};
/** `range` → the ISO instant to ask the service from. `all` means no bound. */ function $812885e94a0e636d$var$rangeStart(range) {
    if (range === 'all') return null;
    const months = range === '6m' ? 6 : 12;
    const d = new Date();
    d.setMonth(d.getMonth() - months);
    return d.toISOString();
}
function $812885e94a0e636d$export$2e2bcd8739ae039() {
    const { t: t, locale: locale, formatNumber: formatNumber, formatMoney: formatMoney, formatTime: formatTime, formatPercent: formatPercent, formatList: formatList } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.dashboard');
    const [view, setView] = (0, $e77179a3ce65222f$export$6a582373474709af)($812885e94a0e636d$var$SCHEMA);
    const [metrics, setMetrics] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [updatedAt, setUpdatedAt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)($812885e94a0e636d$var$METRICS_QUERY, {
            from: $812885e94a0e636d$var$rangeStart(view.range),
            bucket: view.bucket
        }).then((d)=>{
            setMetrics(d?.growthMetrics || null);
            setUpdatedAt(Date.now());
        }).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        view.range,
        view.bucket,
        t
    ]);
    // A range or bucket change is a REFETCH, not a fresh page: the content dims
    // rather than reverting to skeletons, so the operator's eye stays where it was
    // (§2.4 stale-while-refetch).
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: !first.current
        });
        first.current = false;
    }, [
        load
    ]);
    const bucketWord = t(`dashboard.bucket.${view.bucket}`);
    const contextWidget = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                semantics: "filter",
                size: "sm",
                ariaLabel: t('dashboard.range.label'),
                options: $812885e94a0e636d$var$RANGES.map((value)=>({
                        value: value,
                        label: t(`dashboard.range.${value}`)
                    })),
                value: view.range,
                onChange: (range)=>setView({
                        range: range
                    }),
                "data-testid": "dashboard-range"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                semantics: "filter",
                size: "sm",
                ariaLabel: t('dashboard.bucket.label'),
                options: $812885e94a0e636d$var$BUCKETS.map((value)=>({
                        value: value,
                        label: t(`dashboard.bucket.${value}`)
                    })),
                value: view.bucket,
                onChange: (bucket)=>setView({
                        bucket: bucket
                    }),
                "data-testid": "dashboard-bucket"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                variant: "ghost",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                    size: 16
                }),
                label: t('dashboard.refresh'),
                title: updatedAt ? t('dashboard.updatedAt', {
                    time: formatTime(updatedAt)
                }) : t('dashboard.refresh'),
                onClick: ()=>load({
                        quiet: true
                    }),
                "data-testid": "dashboard-refresh"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "dashboard",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('dashboard.title'),
                sub: t('dashboard.sub'),
                children: contextWidget
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mx-auto w-full max-w-[1440px]",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($812885e94a0e636d$var$DashboardSkeleton, {}) : error || !metrics ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                        title: t('errors.region.dashboard'),
                        description: error || t('errors.region.noAnswer'),
                        onRetry: load,
                        retryLabel: t('common.actions.retry'),
                        "data-testid": "dashboard-error"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($812885e94a0e636d$var$DashboardContent, {
                        metrics: metrics,
                        bucketWord: bucketWord,
                        refreshing: refreshing,
                        t: t,
                        locale: locale,
                        formatNumber: formatNumber,
                        formatMoney: formatMoney,
                        formatPercent: formatPercent,
                        formatList: formatList
                    })
                })
            })
        ]
    });
}
/**
 * Mirrors the real layout: five KPI blocks in the same grid, a chart-height card
 * in main, two rail cards. A skeleton of a different shape makes the content jump
 * when it lands, which is the thing a skeleton exists to prevent (§2.4).
 */ function $812885e94a0e636d$var$DashboardSkeleton() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "dashboard-loading",
        "data-state": "loading",
        "aria-busy": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-3.5 md:grid-cols-3 xl:grid-cols-5",
                children: Array.from({
                    length: 5
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl border border-border bg-card p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                width: "60%",
                                height: 22
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                    width: "80%",
                                    height: 11
                                })
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                        ]
                    })
                ]
            })
        ]
    });
}
function $812885e94a0e636d$var$DashboardContent({ metrics: metrics, bucketWord: bucketWord, refreshing: refreshing, t: t, locale: locale, formatNumber: formatNumber, formatMoney: formatMinor, formatPercent: formatPercent, formatList: formatList }) {
    // Every money figure here is in the metrics' ONE currency (PM-0211): IRR on
    // Parsina, which reads exactly as before, the deployment's platform currency
    // elsewhere. The service refuses a mixed set rather than summing one.
    const { currency: currency } = metrics;
    const formatMoney = (minor)=>formatMinor(minor, {
            currency: currency
        });
    const unit = (0, $7df21990c7b31bb5$export$f76b597c9baf5209)(currency, {
        t: t,
        locale: locale
    });
    // The service can only count what it holds rows for, so an un-provisioned clinic
    // is invisible to it — the total has to add the gap back in or the estate looks
    // complete when it is not.
    const totalClinics = metrics.totalClinics + metrics.unprovisioned;
    const attention = metrics.pastDue + metrics.expired + metrics.suspended;
    const hasHistory = !!metrics.buckets?.length;
    // On day one the operator's actual job is to provision the estate. Saying that
    // outright is better than a wall of zeros — and it takes the PLACE of the
    // un-provisioned alert rather than adding to it, so the screen keeps exactly one
    // primary action (§10).
    const showGettingStarted = !hasHistory && metrics.unprovisioned > 0;
    const kpis = [
        {
            key: 'total',
            label: t('dashboard.kpi.total'),
            value: formatNumber(totalClinics),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight,
            href: '/clinics'
        },
        {
            key: 'inGoodStanding',
            // Deliberately NOT «با دسترسی»: `growthMetrics` returns no entitled count,
            // and a label that claims to measure entitlement while adding two statuses
            // would be a number nobody could reconcile.
            label: t('dashboard.kpi.inGoodStanding'),
            value: formatNumber(metrics.active + metrics.trialing),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e325251f2797f6cf$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight,
            href: '/clinics?status=ACTIVE'
        },
        {
            key: 'mrr',
            label: t('dashboard.kpi.mrr'),
            value: formatMoney(metrics.mrrRial),
            unit: unit,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight
        },
        {
            key: 'conversion',
            label: t('dashboard.kpi.conversion'),
            // -1 means no trial has RESOLVED yet. «۰٪» there would report a failure
            // that has not happened; the dash says "nothing to measure", and the
            // tooltip says why, because an unexplained dash reads as broken.
            // `formatPercent` takes a PERCENTAGE (55 → «۵۵٪») and does the ÷100 itself,
            // so the service's figure goes in as it arrives.
            value: metrics.trialConversionPct < 0 ? t('common.value.none') : formatPercent(metrics.trialConversionPct),
            hint: metrics.trialConversionPct < 0 ? t('dashboard.kpi.conversionHint') : undefined,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight
        },
        {
            key: 'attention',
            label: t('dashboard.kpi.attention'),
            value: formatNumber(attention),
            sub: t('dashboard.kpi.attentionSplit', {
                pastDue: formatNumber(metrics.pastDue),
                expired: formatNumber(metrics.expired),
                suspended: formatNumber(metrics.suspended)
            }),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight,
            href: '/clinics?status=EXPIRED'
        }
    ];
    const statusRows = [
        {
            key: 'active',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('ACTIVE')),
            value: metrics.active,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
            href: '/clinics?status=ACTIVE'
        },
        {
            key: 'trialing',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('TRIALING')),
            value: metrics.trialing,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            href: '/clinics?status=TRIALING'
        },
        {
            key: 'pastDue',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('PAST_DUE')),
            value: metrics.pastDue,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            href: '/clinics?status=PAST_DUE'
        },
        {
            key: 'expired',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('EXPIRED')),
            value: metrics.expired,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            href: '/clinics?status=EXPIRED'
        },
        {
            key: 'suspended',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('SUSPENDED')),
            value: metrics.suspended,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            href: '/clinics?status=SUSPENDED'
        },
        // No status filter expresses either of these, so they are plain rows rather
        // than links that would land on a list the operator cannot recognise.
        {
            key: 'neverExpires',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('NEVER_EXPIRES')),
            value: metrics.neverExpires,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        },
        {
            key: 'perpetual',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)('PERPETUAL')),
            value: metrics.perpetual,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        },
        {
            key: 'unprovisioned',
            label: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)((0, $ec7f110ce929cf56$export$bc262605061d3b3))),
            value: metrics.unprovisioned,
            tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            href: `/clinics?status=${(0, $ec7f110ce929cf56$export$bc262605061d3b3)}`
        }
    ];
    // ZERO ROWS ARE HIDDEN. Listing all eight always meant a young platform rendered
    // seven empty grey tracks and one filled bar, which reads as a broken widget
    // rather than "everything is in one bucket". What is present is shown; what is
    // absent is summarised in one line underneath.
    const present = statusRows.filter((r)=>r.value > 0);
    const absent = statusRows.filter((r)=>r.value === 0);
    const statusTotal = present.reduce((sum, r)=>sum + r.value, 0);
    const tierTotal = (metrics.tiers || []).reduce((sum, x)=>sum + (x.clinics || 0), 0);
    const TIER_TONE = {
        CLINIC_BASIC: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        CLINIC_SILVER: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        CLINIC_GOLD: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
    };
    const series = [
        {
            key: 'signups',
            label: t('dashboard.growth.series.signups'),
            color: (0, $e7c165fb515b04ea$export$6ee8bfc459aebd80).acquired
        },
        {
            key: 'activations',
            label: t('dashboard.growth.series.activations'),
            color: (0, $e7c165fb515b04ea$export$6ee8bfc459aebd80).converted
        },
        {
            key: 'renewals',
            label: t('dashboard.growth.series.renewals'),
            color: (0, $e7c165fb515b04ea$export$c7989e6ff0cf1179)[3]
        },
        {
            key: 'expirations',
            label: t('dashboard.growth.series.expirations'),
            color: (0, $e7c165fb515b04ea$export$6ee8bfc459aebd80).lost
        }
    ];
    const reactivations = (metrics.buckets || []).reduce((sum, b)=>sum + (b.reactivations || 0), 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            opacity: refreshing ? 0.45 : 1
        },
        "aria-busy": refreshing || undefined,
        className: "transition-opacity",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    metrics.unprovisioned > 0 && !showGettingStarted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        "data-testid": "dashboard-unprovisioned",
                        action: // `outline`, not the default fill: the KPI strip and the alert must
                        // not both read as the primary thing to press.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            asChild: true,
                            variant: "outline",
                            size: "sm",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/clinics?status=${(0, $ec7f110ce929cf56$export$bc262605061d3b3)}`,
                                children: t('common.actions.view')
                            })
                        }),
                        children: t('dashboard.alerts.unprovisioned', {
                            count: metrics.unprovisioned
                        })
                    }) : null,
                    metrics.pastDue > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        "data-testid": "dashboard-pastdue",
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            asChild: true,
                            variant: "outline",
                            size: "sm",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/clinics?status=PAST_DUE",
                                children: t('common.actions.view')
                            })
                        }),
                        children: t('dashboard.alerts.pastDue', {
                            count: metrics.pastDue
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-5 grid grid-cols-2 gap-3.5 md:grid-cols-3 xl:grid-cols-5",
                children: kpis.map((kpi)=>{
                    const card = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                        minWidth: 0,
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "block",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "block",
                                    children: kpi.label
                                }),
                                kpi.sub ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "mt-0.5 block text-[10.5px] text-muted-foreground",
                                    children: kpi.sub
                                }) : null
                            ]
                        }),
                        value: kpi.value,
                        unit: kpi.unit,
                        icon: kpi.icon,
                        bg: kpi.bg
                    });
                    // A linked KPI is a REAL `<a href>`, not a card with a click handler:
                    // it goes somewhere, so middle-click, ⌘-click and "copy link" have to
                    // work, and a keyboard user needs it in the tab order with link
                    // semantics rather than as a button that happens to navigate.
                    return kpi.href ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: kpi.href,
                        className: "rounded-xl outline-none transition-shadow focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                        title: kpi.hint,
                        "data-testid": `dashboard-kpi-${kpi.key}`,
                        children: card
                    }, kpi.key) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        title: kpi.hint,
                        "data-testid": `dashboard-kpi-${kpi.key}`,
                        children: card
                    }, kpi.key);
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-5 grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-col gap-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('dashboard.growth.title'),
                                sub: t('dashboard.growth.sub', {
                                    bucket: bucketWord
                                }),
                                icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17f7faa9df1ce052$export$2e2bcd8739ae039), {
                                        buckets: metrics.buckets,
                                        series: series,
                                        ariaLabel: t('dashboard.growth.aria')
                                    }),
                                    reactivations > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-muted-foreground",
                                        children: t('dashboard.growth.reactivations', {
                                            count: reactivations
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('dashboard.revenue.title'),
                                sub: t('dashboard.revenue.sub', {
                                    bucket: bucketWord
                                }),
                                icon: (0, $9ec88f95add56de8$export$2e2bcd8739ae039),
                                "data-testid": "dashboard-revenue-chart",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17f7faa9df1ce052$export$2e2bcd8739ae039), {
                                        buckets: metrics.buckets,
                                        series: [
                                            {
                                                key: 'revenueRial',
                                                label: t('dashboard.revenue.series'),
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                                            }
                                        ],
                                        // Money, so the axis and the bar labels go through the money
                                        // formatter — minor units of the metrics' currency in (rials →
                                        // toman for IRR).
                                        formatValue: (v)=>formatMoney(v),
                                        ariaLabel: t('dashboard.revenue.aria')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-muted-foreground",
                                        children: t('dashboard.revenue.lifetime', {
                                            amount: formatMoney(metrics.lifetimeRevenueRial),
                                            unit: unit
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-col gap-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('dashboard.statusMix.title'),
                                icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039),
                                children: statusTotal === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-2 text-sm text-muted-foreground",
                                    "data-testid": "status-breakdown-empty",
                                    children: t('dashboard.statusMix.empty')
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06825f2e23315751$export$2e2bcd8739ae039), {
                                    "data-testid": "status-breakdown",
                                    rows: present.map((r)=>({
                                            key: r.key,
                                            label: r.label,
                                            value: formatNumber(r.value),
                                            percent: Math.round(r.value / statusTotal * 100),
                                            tone: r.tone,
                                            href: r.href
                                        })),
                                    // `formatList`, not `join('، ')`: the separator and the final
                                    // conjunction are locale data (Persian «، », English ", " and an
                                    // "and"), and a hardcoded one is a Persian comma inside an
                                    // English sentence.
                                    note: absent.length ? t('dashboard.statusMix.absent', {
                                        list: formatList(absent.map((r)=>r.label))
                                    }) : undefined
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('dashboard.tierMix.title'),
                                sub: t('dashboard.tierMix.sub'),
                                icon: (0, $40c424bab0bc0a95$export$2e2bcd8739ae039),
                                children: !metrics.tiers?.length ? // The service predates this field, or is unreachable. Say so rather
                                // than rendering three convincing zeroes.
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-2 text-sm text-muted-foreground",
                                    "data-testid": "tier-breakdown-empty",
                                    children: t('dashboard.tierMix.unavailable')
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06825f2e23315751$export$2e2bcd8739ae039), {
                                    "data-testid": "tier-breakdown",
                                    // Unlike the status mix, EVERY tier is shown even at zero. «چند
                                    // کلینیک روی پایه داریم؟» has «هیچ‌کدام» as a real answer, and
                                    // hiding the row makes that indistinguishable from not knowing.
                                    rows: metrics.tiers.map((x)=>({
                                            key: x.capabilitySet,
                                            label: (0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(x.capabilitySet) ? t((0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(x.capabilitySet)) : x.tierNameFa || x.capabilitySet,
                                            value: formatNumber(x.clinics || 0),
                                            percent: tierTotal ? Math.round((x.clinics || 0) / tierTotal * 100) : 0,
                                            tone: TIER_TONE[x.capabilitySet] || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            extra: Number(x.mrrRial) > 0 ? `${formatMoney(x.mrrRial)} ${(0, $7df21990c7b31bb5$export$d2f719a5670e623a)(currency) ? t('common.units.tomanPerMonth') : t('common.units.perMonth', {
                                                unit: unit
                                            })}` : t('common.value.none'),
                                            href: `/clinics?tier=${x.capabilitySet}`
                                        })),
                                    note: metrics.perpetual > 0 ? t('dashboard.tierMix.perpetual', {
                                        count: metrics.perpetual
                                    }) : undefined
                                })
                            })
                        ]
                    })
                ]
            }),
            showGettingStarted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                    title: t('dashboard.start.title'),
                    icon: (0, $224502d93617e0e1$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: t('dashboard.start.body')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                asChild: true,
                                "data-testid": "dashboard-cta",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/clinics?status=${(0, $ec7f110ce929cf56$export$bc262605061d3b3)}`,
                                    children: t('dashboard.start.action')
                                })
                            })
                        ]
                    })
                })
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1b19608dd471de3d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CloudDownload", [
    [
        "path",
        {
            d: "M12 13v8l-4-4",
            key: "1f5nwf"
        }
    ],
    [
        "path",
        {
            d: "m12 21 4-4",
            key: "1lfcce"
        }
    ],
    [
        "path",
        {
            d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284",
            key: "ui1hmy"
        }
    ]
]);










/**
 * The demo-request queue's view model — pure, and the one place its rules live.
 *
 * docs/PARSINADENT_DEMO_REQUEST_DESIGN.md §3.2 (T1–T9) and D5. Nothing here is
 * stored anywhere: «unanswered» is `status = new`, a request's age is `now −
 * created`, the SLA colour is derived from working days on every render, and
 * the timeline is a merge of three lists the CRM already holds. A number
 * nobody wrote is a fabricated fact, so none is written.
 */ 

const $1528ce4aa57db78e$export$8ee0e85f454354b5 = (0, $cdf3712044ab22f9$export$8ec3d08588d2eeda);
const $1528ce4aa57db78e$var$DAY = 86400000;
/** Iran has kept +03:30 all year since 2022; the platform runs on Tehran time. */ const $1528ce4aa57db78e$var$TEHRAN_OFFSET_MS = 12600000;
const $1528ce4aa57db78e$export$73b877b58963a4f = [
    'unanswered',
    'inProgress',
    'closed',
    'all'
];
const $1528ce4aa57db78e$export$d20b8640d99f4581 = [
    'all',
    'me',
    'unassigned'
];
/**
 * What each tab asks the CRM for. «در جریان» is the four open stages AFTER
 * `new` in one query — `openOnly` would include `new`, which is exactly the
 * tab next to it.
 */ const $1528ce4aa57db78e$var$TAB_STATUSES = {
    unanswered: [
        'new'
    ],
    inProgress: [
        'contacted',
        'qualified',
        'proposal',
        'negotiation'
    ],
    closed: [
        'won',
        'lost'
    ],
    all: null
};
function $1528ce4aa57db78e$export$bf82f56eeb1cb781(tab) {
    const statuses = $1528ce4aa57db78e$var$TAB_STATUSES[tab];
    return statuses ? {
        statuses: [
            ...statuses
        ]
    } : {};
}
function $1528ce4aa57db78e$export$5c74d3ca44f490ee(owner, mySub) {
    if (owner === 'me' && mySub) return {
        ownerId: mySub
    };
    if (owner === 'unassigned') return {
        unassignedOnly: true
    };
    return {};
}
function $1528ce4aa57db78e$export$36d47f80fac5bc00(day) {
    if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
    const ms = new Date(`${day}T00:00:00+03:30`).getTime();
    return Number.isNaN(ms) ? null : ms;
}
function $1528ce4aa57db78e$export$ba56c537d5340628(from, to) {
    let start = $1528ce4aa57db78e$export$36d47f80fac5bc00(from);
    let endDay = $1528ce4aa57db78e$export$36d47f80fac5bc00(to);
    if (start != null && endDay != null && start > endDay) [start, endDay] = [
        endDay,
        start
    ];
    const out = {};
    if (start != null) out.createdFromMs = String(start);
    if (endDay != null) out.createdToMs = String(endDay + $1528ce4aa57db78e$var$DAY - 1);
    return out;
}
function $1528ce4aa57db78e$export$b3dd1f763a4b7a98(q) {
    const trimmed = String(q || '').trim();
    return trimmed.length >= (0, $cdf3712044ab22f9$export$d6920ac008449896) ? {
        query: trimmed.slice(0, 120)
    } : {};
}
function $1528ce4aa57db78e$export$bb8223cae8217a32(view, { mySub: mySub, pageSize: pageSize = $1528ce4aa57db78e$export$8ee0e85f454354b5 } = {}) {
    const page = Math.max(1, Number(view?.page) || 1);
    const intent = (0, $57e4f51624ccb99c$export$7f0da323261755e2).includes(view?.intent) ? view.intent : (0, $57e4f51624ccb99c$export$571c06e0117d64c4);
    return {
        intent: intent,
        // A doctor-page queue shows whom to call; the CRM resolves the mobile only
        // when asked (one GetCustomer per customer), so a demo page never pays it.
        ...intent === (0, $57e4f51624ccb99c$export$ef13f627afefba0c) ? {
            withMobile: true
        } : {},
        ...$1528ce4aa57db78e$export$bf82f56eeb1cb781(view?.tab || 'unanswered'),
        ...$1528ce4aa57db78e$export$5c74d3ca44f490ee(view?.owner, mySub),
        ...$1528ce4aa57db78e$export$ba56c537d5340628(view?.from, view?.to),
        ...$1528ce4aa57db78e$export$b3dd1f763a4b7a98(view?.q),
        limit: pageSize,
        offset: (page - 1) * pageSize
    };
}
function $1528ce4aa57db78e$export$e00bdcbec4a5a6e3(view) {
    return !!(view?.owner && view.owner !== 'all' || view?.from || view?.to || String(view?.q || '').trim().length >= (0, $cdf3712044ab22f9$export$d6920ac008449896));
}
function $1528ce4aa57db78e$export$7804ac8eb5cfa918(total, pageSize = $1528ce4aa57db78e$export$8ee0e85f454354b5) {
    return Math.max(1, Math.ceil((Number(total) || 0) / pageSize));
}
// ── age and the «one working day» promise ───────────────────────────────────
const $1528ce4aa57db78e$var$toMs = (value)=>{
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : null;
};
function $1528ce4aa57db78e$export$1a8136ed35963e76(startMs, endMs) {
    const a = $1528ce4aa57db78e$var$toMs(startMs);
    const b = $1528ce4aa57db78e$var$toMs(endMs);
    if (a == null || b == null || b <= a) return 0;
    // Shift into "Tehran wall-clock as UTC" so day boundaries and weekdays are Tehran's.
    let t = a + $1528ce4aa57db78e$var$TEHRAN_OFFSET_MS;
    const end = b + $1528ce4aa57db78e$var$TEHRAN_OFFSET_MS;
    const WEEK = 7 * $1528ce4aa57db78e$var$DAY;
    const weeks = Math.floor((end - t) / WEEK);
    let working = weeks * 6 * $1528ce4aa57db78e$var$DAY;
    t += weeks * WEEK;
    while(t < end){
        const dayStart = Math.floor(t / $1528ce4aa57db78e$var$DAY) * $1528ce4aa57db78e$var$DAY;
        const segmentEnd = Math.min(dayStart + $1528ce4aa57db78e$var$DAY, end);
        if (new Date(dayStart).getUTCDay() !== 5) working += segmentEnd - t; // 5 = Friday
        t = segmentEnd;
    }
    return working / $1528ce4aa57db78e$var$DAY;
}
const $1528ce4aa57db78e$export$6c736a84d2384697 = 1;
const $1528ce4aa57db78e$export$3efbf9ffbbde1222 = 3;
function $1528ce4aa57db78e$export$2640ade22ac8dfb4(lead, now = Date.now()) {
    if (!lead || lead.status !== 'new') return null;
    const days = $1528ce4aa57db78e$export$1a8136ed35963e76(lead.createdAtMs, now);
    if (days > $1528ce4aa57db78e$export$3efbf9ffbbde1222) return 'danger';
    if (days > $1528ce4aa57db78e$export$6c736a84d2384697) return 'warn';
    return null;
}
function $1528ce4aa57db78e$export$4a177b5ee2700505(lead, interactions = null) {
    const created = $1528ce4aa57db78e$var$toMs(lead?.createdAtMs);
    if (created == null) return null;
    if (Array.isArray(interactions)) {
        const times = interactions.filter((i)=>(0, $57e4f51624ccb99c$export$a95c54b781d921ce).includes(i.outcome)).map((i)=>$1528ce4aa57db78e$var$toMs(i.occurredAtMs)).filter((ms)=>ms != null && ms >= created);
        if (times.length) return Math.min(...times) - created;
    }
    if (lead.status === 'contacted') {
        const changed = $1528ce4aa57db78e$var$toMs(lead.statusChangedMs);
        if (changed != null && changed >= created) return changed - created;
    }
    return null;
}
const $1528ce4aa57db78e$export$21575dd80e7b1ae7 = (followUp, now = Date.now())=>followUp?.status === 'open' && $1528ce4aa57db78e$var$toMs(followUp.dueAtMs) != null && $1528ce4aa57db78e$var$toMs(followUp.dueAtMs) < now;
const $1528ce4aa57db78e$export$c68ebc83ed0ed3b6 = (followUps, leadId)=>(followUps || []).filter((f)=>f.leadId === leadId);
function $1528ce4aa57db78e$export$49e631926d296e58({ interactions: interactions = [], followUps: followUps = [], notes: notes = [] } = {}) {
    const items = [
        ...interactions.map((item)=>({
                kind: 'interaction',
                id: `i-${item.id}`,
                atMs: $1528ce4aa57db78e$var$toMs(item.occurredAtMs) ?? $1528ce4aa57db78e$var$toMs(item.recordedAtMs),
                item: item
            })),
        ...followUps.map((item)=>({
                kind: 'followUp',
                id: `f-${item.id}`,
                atMs: $1528ce4aa57db78e$var$toMs(item.dueAtMs) ?? $1528ce4aa57db78e$var$toMs(item.createdAtMs),
                item: item
            })),
        ...notes.map((item)=>({
                kind: 'note',
                id: `n-${item.id}`,
                atMs: $1528ce4aa57db78e$var$toMs(item.createdAtMs),
                item: item
            }))
    ];
    return items.sort((x, y)=>(y.atMs ?? -Infinity) - (x.atMs ?? -Infinity));
}
const $1528ce4aa57db78e$export$2995bda72fb8f331 = {
    practiceType: 'demoRequests.answers.practiceType',
    dentistCount: 'demoRequests.answers.dentistCount',
    demoMode: 'demoRequests.answers.demoMode',
    preferredTime: 'demoRequests.answers.preferredTime',
    currentSystem: 'demoRequests.answers.currentSystem'
};
const $1528ce4aa57db78e$export$1cfbbee75e7648ae = {
    1: 'one',
    '2-5': 'twoToFive',
    '6-15': 'sixToFifteen',
    '16+': 'sixteenPlus'
};
const $1528ce4aa57db78e$var$ANSWER_ORDER = [
    'practiceType',
    'dentistCount',
    'organization',
    'city',
    'province',
    'demoMode',
    'preferredTime',
    'currentSystem'
];
function $1528ce4aa57db78e$export$4d1facc288497224(details) {
    if (!details) return [];
    const rows = [];
    for (const field of $1528ce4aa57db78e$var$ANSWER_ORDER){
        const value = details[field];
        if (value == null || String(value).trim() === '') continue;
        const prefix = $1528ce4aa57db78e$export$2995bda72fb8f331[field];
        let valueKey = null;
        if (prefix) {
            const segment = field === 'dentistCount' ? $1528ce4aa57db78e$export$1cfbbee75e7648ae[value] : value;
            valueKey = segment ? `${prefix}.${segment}` : null;
        }
        rows.push({
            field: field,
            labelKey: `demoRequests.answers.label.${field}`,
            value: String(value),
            valueKey: valueKey
        });
    }
    return rows;
}
function $1528ce4aa57db78e$export$5828c827f90f69b0(utm) {
    if (!utm) return [];
    return [
        'source',
        'medium',
        'campaign',
        'content',
        'term'
    ].filter((k)=>utm[k] != null && String(utm[k]).trim() !== '').map((k)=>[
            k,
            String(utm[k])
        ]);
}
function $1528ce4aa57db78e$export$ec356f8cff9ad609(value) {
    if (!value) return null;
    try {
        const url = new URL(String(value));
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
    } catch  {
        return null;
    }
}
function $1528ce4aa57db78e$export$9172ea6d647155f1(customerDetail) {
    const points = (customerDetail?.contactPoints || []).filter((p)=>p.isActive !== false);
    const phones = points.filter((p)=>[
            'mobile',
            'landline'
        ].includes(p.kind));
    const emails = points.filter((p)=>p.kind === 'email');
    const byPrimary = (x, y)=>Number(!!y.isPrimary) - Number(!!x.isPrimary);
    return {
        phones: phones.sort(byPrimary),
        emails: emails.sort(byPrimary)
    };
}
function $1528ce4aa57db78e$export$9ccaed87e5cd269d(lead) {
    const allowed = Array.isArray(lead?.allowedNextStatuses) ? lead.allowedNextStatuses : [];
    const moves = allowed.filter((s)=>!(lead.status === 'new' && s === 'won'));
    return {
        advance: moves.filter((s)=>s !== 'lost'),
        canLose: moves.includes('lost')
    };
}
const $1528ce4aa57db78e$export$fd3ee28367a5e629 = (matches, customerId)=>(matches || []).filter((c)=>c.id !== customerId);
// ── doctor-page requests (intent doctor_page_appointment) ───────────────────
const $1528ce4aa57db78e$var$SLUG = /^[a-z0-9-]{3,40}$/;
function $1528ce4aa57db78e$export$6084db05dc233238(lead) {
    const ref = String(lead?.subjectRef || '');
    if (ref.startsWith('doctor_page:')) {
        const slug = ref.slice(12);
        if ($1528ce4aa57db78e$var$SLUG.test(slug)) return slug;
    }
    const fromDetails = lead?.requestDetails?.slug;
    return fromDetails && $1528ce4aa57db78e$var$SLUG.test(fromDetails) ? fromDetails : null;
}
function $1528ce4aa57db78e$export$3b4e4d8b02883f9(lead, base) {
    const slug = $1528ce4aa57db78e$export$6084db05dc233238(lead);
    if (!slug || !base) return null;
    return `${String(base).replace(/\/+$/, '')}/${slug}`;
}
const $1528ce4aa57db78e$export$d9958eaf500b69a8 = (lead)=>lead?.intent === (0, $57e4f51624ccb99c$export$ef13f627afefba0c);
function $1528ce4aa57db78e$export$7e8cd4570b148f0f(details) {
    if (!details) return [];
    const rows = [];
    const push = (field, value, valueKey = null)=>{
        if (value == null || String(value).trim() === '') return;
        rows.push({
            field: field,
            labelKey: `demoRequests.pageLeads.answers.${field}`,
            value: String(value),
            valueKey: valueKey
        });
    };
    push('doctorDisplayName', details.doctorDisplayName);
    push('councilNumber', details.councilNumber);
    push('preferredChannel', details.preferredChannel, details.preferredChannel ? `demoRequests.channel.${details.preferredChannel}` : null);
    push('preferredTime', details.preferredTime, details.preferredTime ? `${$1528ce4aa57db78e$export$2995bda72fb8f331.preferredTime}.${details.preferredTime}` : null);
    return rows;
}


function $00e3ccdc2868d16a$export$74f26bc33ef45eef(row) {
    const raw = row?.createdAt;
    if (!raw) return null;
    const text = String(raw);
    const ms = new Date(/(Z|[+-]\d{2}:?\d{2})$/i.test(text) ? text : `${text}Z`).getTime();
    return Number.isNaN(ms) ? null : ms;
}
/**
 * Narrow, sort and page the estate — a PURE function of (rows, view).
 *
 * All of it happens in the browser, and that is a property of the data rather
 * than a shortcut: the BFF's `clinics` resolver already returns every clinic,
 * because it joins the registry to ONE batched entitlement call (a lookup per
 * clinic would be thousands of round trips). Its own `search`/`status` arguments
 * then filter that same in-memory array. So asking the server to narrow costs a
 * round trip and returns a subset of what we already hold.
 *
 * Keeping it pure and out of the component is what makes the filter semantics
 * testable without rendering — the un-provisioned/tier interaction below is the
 * kind of rule that is easy to get subtly wrong and impossible to see in a
 * screenshot.
 */ /**
 * Does this row match the typed query?
 *
 * Name is matched case-insensitively; phone is matched after folding digits
 * through the kit's `phone.foldDigits`, so «۰۲۱۱۱» finds the clinic stored as
 * "02111". A search box that only accepts one digit set is a search box that
 * fails for whoever is typing on the other keyboard, which in this product is
 * everybody at some point.
 *
 * THE FOLD IS THE KIT'S, not a local table, and the difference is a digit set:
 * the table this replaced covered Persian (U+06F0) and Arabic-Indic (U+0660)
 * only, while the kit also folds FULLWIDTH U+FF10–FF19 — which some IME
 * keyboards emit, and which its Java and Python twins have always folded. A
 * clinic whose number arrived in that block was unsearchable here by any
 * spelling of it.
 *
 * BOTH SPELLINGS of the number are searched, and the second one is not
 * redundant. The registry stores E.164 now («+982112345678») while the table
 * renders the national form («02112345678») — so an operator who types what is
 * on their screen is typing a string the stored value does not contain, and the
 * list would come back empty for a clinic that is right there in it. Matching
 * the displayed form as well is what keeps "search for what you can see"
 * true; matching the stored form as well is what keeps a pasted «+98…» working.
 */ function $00e3ccdc2868d16a$var$matches(row, query) {
    const q = (0, $412e1a8a99c19c1a$exports).foldDigits(query).trim().toLowerCase();
    if (!q) return true;
    const name = String(row.name || '').toLowerCase();
    // No `|| ''` on either call: `foldDigits` answers '' for a non-string, which is
    // the right reading of a row that simply has no phone.
    const stored = (0, $412e1a8a99c19c1a$exports).foldDigits(row.officePhone);
    const shown = (0, $412e1a8a99c19c1a$exports).foldDigits((0, $412e1a8a99c19c1a$exports).forDisplay(row.officePhone));
    return name.includes(q) || stored.includes(q) || shown !== '' && shown.includes(q);
}
/** The value the status filter compares against — a missing row is its own state. */ const $00e3ccdc2868d16a$var$statusOf = (row)=>row.hasSubscription ? row.subscriptionStatus : (0, $ec7f110ce929cf56$export$bc262605061d3b3);
const $00e3ccdc2868d16a$var$SORTERS = {
    // localeCompare with the ACTIVE locale: Persian collation is not ASCII order,
    // and sorting «الف» against «ب» by code point gives an order no reader expects.
    name: (a, b, locale)=>String(a.name || '').localeCompare(String(b.name || ''), locale),
    status: (a, b)=>(0, $ec7f110ce929cf56$export$a2a7e133070551dc).indexOf($00e3ccdc2868d16a$var$statusOf(a)) - (0, $ec7f110ce929cf56$export$a2a7e133070551dc).indexOf($00e3ccdc2868d16a$var$statusOf(b)),
    tier: (a, b)=>(0, $ec7f110ce929cf56$export$d926e5d057600107)(a.capabilitySet) - (0, $ec7f110ce929cf56$export$d926e5d057600107)(b.capabilitySet),
    entitled: (a, b)=>Number(a.entitled) - Number(b.entitled),
    created: (a, b)=>String(a.createdAt || '').localeCompare(String(b.createdAt || '')),
    until: (a, b)=>String((0, $7df21990c7b31bb5$export$78fb443a25ba8d2d)(a) || '').localeCompare(String((0, $7df21990c7b31bb5$export$78fb443a25ba8d2d)(b) || ''))
};
/**
 * Columns whose value can be ABSENT, and how to tell.
 *
 * Rows with no value sort LAST in BOTH directions, so they are partitioned out
 * before the comparator rather than handled inside it. Doing it inside does not
 * work: the comparator's result is multiplied by the direction, so a `return 1`
 * for "a is missing" becomes `-1` under `desc` and the empties jump to the top —
 * which is exactly the bug this comment replaces.
 *
 * It matters because "no end date" is not the earliest date, it is the absence of
 * one. Sorted to the top of an ascending list, the clinics that need nothing would
 * sit where the urgent ones belong.
 */ const $00e3ccdc2868d16a$var$MISSING = {
    until: (r)=>!(0, $7df21990c7b31bb5$export$78fb443a25ba8d2d)(r),
    tier: (r)=>(0, $ec7f110ce929cf56$export$d926e5d057600107)(r.capabilitySet) < 0
};
const $00e3ccdc2868d16a$export$39ffba2ece42ec36 = Object.keys($00e3ccdc2868d16a$var$SORTERS);
function $00e3ccdc2868d16a$export$f755f4a1abb672d6(rows, view, { locale: locale = 'fa' } = {}) {
    const all = Array.isArray(rows) ? rows : [];
    const unprovisioned = all.filter((r)=>!r.hasSubscription).length;
    const q = String(view.q || '');
    // One character matches most of the estate and narrows nothing, so it is
    // treated as "not searching yet" rather than as a filter. Zero characters is a
    // different thing — that is cleared.
    const searching = q.trim().length >= (0, $cdf3712044ab22f9$export$d6920ac008449896);
    let out = all;
    if (view.status && view.status !== 'ALL') out = out.filter((r)=>$00e3ccdc2868d16a$var$statusOf(r) === view.status);
    if (view.tier && view.tier !== 'ALL') // An un-provisioned clinic has NO tier, so it drops out of every tier filter
    // rather than being swept into one: «بدون اشتراک» is its own state, and the
    // status filter above it is where that clinic is found. Sweeping it into a
    // tier would let an operator filter by طلایی and be shown clinics nobody
    // ever provisioned.
    out = out.filter((r)=>r.hasSubscription && r.capabilitySet === view.tier);
    if (view.entitled === '1') out = out.filter((r)=>r.entitled);
    if (view.entitled === '0') out = out.filter((r)=>!r.entitled);
    if (searching) out = out.filter((r)=>$00e3ccdc2868d16a$var$matches(r, q));
    // The registration window — two Tehran calendar days from the pickers, both
    // ends inclusive (`dateRangeFilter` covers the whole of `to` and swaps a
    // reversed range). A clinic with no readable date is OUT of any window: it
    // cannot be claimed as registered inside one.
    const range = (0, $1528ce4aa57db78e$export$ba56c537d5340628)(view.from, view.to);
    const sinceMs = range.createdFromMs == null ? null : Number(range.createdFromMs);
    const untilMs = range.createdToMs == null ? null : Number(range.createdToMs);
    const windowed = sinceMs != null || untilMs != null;
    if (windowed) out = out.filter((r)=>{
        const ms = $00e3ccdc2868d16a$export$74f26bc33ef45eef(r);
        return ms != null && (sinceMs == null || ms >= sinceMs) && (untilMs == null || ms <= untilMs);
    });
    const sortKey = $00e3ccdc2868d16a$var$SORTERS[view.sort] ? view.sort : 'created';
    const sorter = $00e3ccdc2868d16a$var$SORTERS[sortKey];
    const dir = view.dir === 'asc' ? 1 : -1;
    const isMissing = $00e3ccdc2868d16a$var$MISSING[sortKey];
    // Copy before sorting: the caller's array is React state, and sorting it in
    // place mutates the render's own input.
    const present = isMissing ? out.filter((r)=>!isMissing(r)) : [
        ...out
    ];
    const absent = isMissing ? out.filter((r)=>isMissing(r)) : [];
    out = [
        ...present.sort((a, b)=>sorter(a, b, locale) * dir),
        ...absent
    ];
    const filtered = out.length;
    const pageCount = Math.max(1, Math.ceil(filtered / (0, $cdf3712044ab22f9$export$8ec3d08588d2eeda)));
    // A filter that shrinks the list below the current page would otherwise leave
    // the operator on an empty page 4 of 1, which reads as "no results".
    const page = Math.min(Math.max(1, Number(view.page) || 1), pageCount);
    const start = (page - 1) * (0, $cdf3712044ab22f9$export$8ec3d08588d2eeda);
    return {
        rows: out.slice(start, start + (0, $cdf3712044ab22f9$export$8ec3d08588d2eeda)),
        // Every row the filters left, in the on-screen order and NOT paged — what
        // «خروجی اکسل» writes. Exporting `rows` would hand over one page of forty.
        matching: out,
        total: all.length,
        filtered: filtered,
        pageCount: pageCount,
        page: page,
        unprovisioned: unprovisioned,
        // Whether ANY narrowing is in force — drives «حذف فیلترها» and tells the
        // empty state whether to say "nothing here" or "nothing matches".
        isFiltered: searching || windowed || !!view.status && view.status !== 'ALL' || !!view.tier && view.tier !== 'ALL' || view.entitled === '0' || view.entitled === '1'
    };
}
const $00e3ccdc2868d16a$export$b83f00531415b634 = [
    'ALL',
    ...(0, $ec7f110ce929cf56$export$67a3419b6c83c58c)
];
var $00e3ccdc2868d16a$export$2e2bcd8739ae039 = $00e3ccdc2868d16a$export$f755f4a1abb672d6;






/**
 * «خروجی اکسل» of the clinics list — the rows, as a sheet.
 *
 * LATIN DIGITS AND NUMERIC DATES WHATEVER THE LOCALE, same rule as the pricing
 * screen's CSV: the on-screen formatting (۱۴۰۵/۸/۷, Persian digits) must not leak
 * into a file whose next stop is a filter, a sort or a pivot. Each registration
 * is written as BOTH calendars, so «۷ آبان» can be matched against the Gregorian
 * date a bank statement or a log carries without anyone converting by hand.
 *
 * THE DAY IS A TEHRAN DAY, like the range filter that selects the rows
 * (`demoRequestsView.dateRangeFilter`): the back office runs on Tehran time, and a
 * clinic registered at 22:00 UTC belongs to the NEXT Tehran date. Iran has kept
 * +03:30 all year since 2022. This is the OPERATOR's day, not the clinic's wall
 * clock — a clinic's own times follow its `timezone` (CLAUDE.md, «Clinic wall
 * clock»).
 */ const $b1df05aee7406d36$var$TEHRAN = 'Asia/Tehran';
const $b1df05aee7406d36$var$GREGORIAN = new Intl.DateTimeFormat('en-US', {
    timeZone: $b1df05aee7406d36$var$TEHRAN,
    calendar: 'gregory',
    numberingSystem: 'latn',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
});
const $b1df05aee7406d36$var$JALALI = new Intl.DateTimeFormat('en-US-u-ca-persian-nu-latn', {
    timeZone: $b1df05aee7406d36$var$TEHRAN,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
});
const $b1df05aee7406d36$var$parts = (formatter, ms)=>Object.fromEntries(formatter.formatToParts(new Date(ms)).map((p)=>[
            p.type,
            p.value
        ]));
function $b1df05aee7406d36$export$3aeac4caf0c86a59(row) {
    const ms = (0, $00e3ccdc2868d16a$export$74f26bc33ef45eef)(row);
    if (ms == null) return {
        jalali: '',
        gregorian: '',
        time: ''
    };
    const g = $b1df05aee7406d36$var$parts($b1df05aee7406d36$var$GREGORIAN, ms);
    const j = $b1df05aee7406d36$var$parts($b1df05aee7406d36$var$JALALI, ms);
    return {
        jalali: `${j.year}/${j.month}/${j.day}`,
        gregorian: `${g.year}-${g.month}-${g.day}`,
        time: `${g.hour}:${g.minute}`
    };
}
function $b1df05aee7406d36$export$eb9d166f36cf96e9(rows, { t: t }) {
    const header = [
        t('clinics.export.columns.name'),
        t('clinics.export.columns.type'),
        t('clinics.export.columns.phone'),
        t('clinics.export.columns.jalali'),
        t('clinics.export.columns.gregorian'),
        t('clinics.export.columns.time'),
        t('clinics.export.columns.active'),
        t('clinics.export.columns.status'),
        t('clinics.export.columns.plan'),
        t('clinics.export.columns.currency'),
        t('clinics.export.columns.id')
    ];
    const body = (rows || []).map((r)=>{
        const stamp = $b1df05aee7406d36$export$3aeac4caf0c86a59(r);
        return [
            r.name || '',
            r.clinicType || '',
            // The national form the table shows; text, so the leading 0 survives.
            r.officePhone ? (0, $412e1a8a99c19c1a$exports).forDisplay(r.officePhone) : '',
            stamp.jalali,
            stamp.gregorian,
            stamp.time,
            r.active ? t('common.value.yes') : t('common.value.no'),
            t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)(r.hasSubscription ? r.subscriptionStatus : (0, $ec7f110ce929cf56$export$bc262605061d3b3))),
            // «بدون اشتراک» has no plan; `planLabel` would answer with a dash.
            r.hasSubscription ? (0, $7df21990c7b31bb5$export$c6aafd8353c81df)(r, t) : '',
            r.currency || '',
            r.id || ''
        ];
    });
    return {
        header: header,
        rows: body
    };
}
function $b1df05aee7406d36$export$9652ad3f82731fc7({ from: from, to: to } = {}) {
    const iso = /^\d{4}-\d{2}-\d{2}$/;
    const a = iso.test(from || '') ? from : '';
    const b = iso.test(to || '') ? to : '';
    if (a && b) return `clinics-${[
        a,
        b
    ].sort().join('_')}.xlsx`;
    if (a) return `clinics-from-${a}.xlsx`;
    if (b) return `clinics-until-${b}.xlsx`;
    return 'clinics.xlsx';
}


/**
 * A minimal .xlsx writer — one sheet, a bold header row, text/number/boolean
 * cells. Pure: bytes in the browser, bytes in the test, no DOM.
 *
 * ── WHY IT IS HERE AND NOT A PACKAGE ─────────────────────────────────────────
 * The admin client carries no spreadsheet library, and the one thing the back
 * office has ever needed from one is «give me these rows in Excel». An .xlsx is a
 * ZIP of five small XML parts; writing them is ~100 lines and a dependency is a
 * supply-chain surface plus a bundle cost for every screen. If the panel ever
 * needs formulas, several sheets or styles beyond a bold header, replace this
 * with a library rather than growing it.
 *
 * ── DECISIONS THAT LOOK ARBITRARY ────────────────────────────────────────────
 *   • STRINGS ARE `inlineStr`, never shared strings: one fewer part, and Excel
 *     reads them as TEXT — so a phone number keeps its leading zero and a clinic
 *     named «=1+1» is a name, not a formula. (A CSV has neither guarantee.)
 *   • THE ZIP IS STORED, NOT DEFLATED (method 0): a few hundred rows compress to
 *     nothing worth a decoder, and a stored entry needs no zlib in the browser.
 *   • THE ENTRY TIMESTAMP IS FIXED (1980-01-01), so the same rows give the same
 *     bytes — a test can compare them.
 *   • `rtl` flips the SHEET (column A on the right), which is what a Persian
 *     reader expects of a table; the cell text itself is unaffected.
 */ const $f8d3f5eb764fc000$export$1783f1fe1bd2b30e = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const $f8d3f5eb764fc000$var$encoder = new TextEncoder();
// ── ZIP (stored) ─────────────────────────────────────────────────────────────
const $f8d3f5eb764fc000$var$CRC_TABLE = (()=>{
    const table = new Uint32Array(256);
    for(let n = 0; n < 256; n += 1){
        let c = n;
        for(let k = 0; k < 8; k += 1)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c >>> 0;
    }
    return table;
})();
function $f8d3f5eb764fc000$export$1cd93882633e45f5(bytes) {
    let c = 0xFFFFFFFF;
    for(let i = 0; i < bytes.length; i += 1)c = $f8d3f5eb764fc000$var$CRC_TABLE[(c ^ bytes[i]) & 0xFF] ^ c >>> 8;
    return (c ^ 0xFFFFFFFF) >>> 0;
}
// 1980-01-01 00:00:00 in MS-DOS date/time.
const $f8d3f5eb764fc000$var$DOS_DATE = 33;
const $f8d3f5eb764fc000$var$DOS_TIME = 0;
// Bit 11: file names are UTF-8.
const $f8d3f5eb764fc000$var$FLAGS = 0x0800;
function $f8d3f5eb764fc000$export$8410b3e5307ac21e(files) {
    const parts = [];
    const central = [];
    let offset = 0;
    for (const { name: name, data: data } of files){
        const nameBytes = $f8d3f5eb764fc000$var$encoder.encode(name);
        const crc = $f8d3f5eb764fc000$export$1cd93882633e45f5(data);
        const local = new DataView(new ArrayBuffer(30));
        local.setUint32(0, 0x04034B50, true);
        local.setUint16(4, 20, true); // version needed
        local.setUint16(6, $f8d3f5eb764fc000$var$FLAGS, true);
        local.setUint16(8, 0, true); // method: stored
        local.setUint16(10, $f8d3f5eb764fc000$var$DOS_TIME, true);
        local.setUint16(12, $f8d3f5eb764fc000$var$DOS_DATE, true);
        local.setUint32(14, crc, true);
        local.setUint32(18, data.length, true);
        local.setUint32(22, data.length, true);
        local.setUint16(26, nameBytes.length, true);
        local.setUint16(28, 0, true); // extra length
        parts.push(new Uint8Array(local.buffer), nameBytes, data);
        const entry = new DataView(new ArrayBuffer(46));
        entry.setUint32(0, 0x02014B50, true);
        entry.setUint16(4, 20, true); // version made by
        entry.setUint16(6, 20, true); // version needed
        entry.setUint16(8, $f8d3f5eb764fc000$var$FLAGS, true);
        entry.setUint16(10, 0, true);
        entry.setUint16(12, $f8d3f5eb764fc000$var$DOS_TIME, true);
        entry.setUint16(14, $f8d3f5eb764fc000$var$DOS_DATE, true);
        entry.setUint32(16, crc, true);
        entry.setUint32(20, data.length, true);
        entry.setUint32(24, data.length, true);
        entry.setUint16(28, nameBytes.length, true);
        // 30 extra, 32 comment, 34 disk, 36 internal attrs, 38 external attrs: all 0
        entry.setUint32(42, offset, true); // local header offset
        central.push(new Uint8Array(entry.buffer), nameBytes);
        offset += 30 + nameBytes.length + data.length;
    }
    const centralSize = central.reduce((sum, p)=>sum + p.length, 0);
    const end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, 0x06054B50, true);
    end.setUint16(8, files.length, true); // entries on this disk
    end.setUint16(10, files.length, true); // entries in total
    end.setUint32(12, centralSize, true);
    end.setUint32(16, offset, true); // where the central directory starts
    const all = [
        ...parts,
        ...central,
        new Uint8Array(end.buffer)
    ];
    const out = new Uint8Array(all.reduce((sum, p)=>sum + p.length, 0));
    let at = 0;
    for (const p of all){
        out.set(p, at);
        at += p.length;
    }
    return out;
}
// ── OOXML parts ──────────────────────────────────────────────────────────────
const $f8d3f5eb764fc000$var$XML_HEAD = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n';
const $f8d3f5eb764fc000$var$NS_MAIN = 'http://schemas.openxmlformats.org/spreadsheetml/2006/main';
const $f8d3f5eb764fc000$var$NS_REL = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships';
const $f8d3f5eb764fc000$var$NS_PKG_REL = 'http://schemas.openxmlformats.org/package/2006/relationships';
// Characters XML 1.0 cannot carry at all (C0 controls other than tab/LF/CR, and
// the two non-characters). One of these in a clinic's name would make the whole
// file «corrupt» to Excel, so they are dropped rather than escaped.
// eslint-disable-next-line no-control-regex
const $f8d3f5eb764fc000$var$XML_ILLEGAL = /[\u0000-\u0008\u000B\u000C\u000E-\u001F￾￿]/g;
function $f8d3f5eb764fc000$export$e50f4bf6493199fc(value) {
    return String(value).replace($f8d3f5eb764fc000$var$XML_ILLEGAL, '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function $f8d3f5eb764fc000$export$91a1004e57ba531a(index) {
    let n = index;
    let name = '';
    do {
        name = String.fromCharCode(65 + n % 26) + name;
        n = Math.floor(n / 26) - 1;
    }while (n >= 0);
    return name;
}
function $f8d3f5eb764fc000$export$61071fa18bbe16b1(name) {
    const cleaned = String(name || '').replace(/[:\\/?*[\]]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 31);
    return cleaned || 'Sheet1';
}
function $f8d3f5eb764fc000$var$cellXml(ref, value, style) {
    if (value === null || value === undefined || value === '') return '';
    const s = style ? ` s="${style}"` : '';
    if (typeof value === 'number' && Number.isFinite(value)) return `<c r="${ref}"${s}><v>${value}</v></c>`;
    if (typeof value === 'boolean') return `<c r="${ref}"${s} t="b"><v>${value ? 1 : 0}</v></c>`;
    const text = String(value);
    const keep = /^\s|\s$|\n/.test(text) ? ' xml:space="preserve"' : '';
    return `<c r="${ref}"${s} t="inlineStr"><is><t${keep}>${$f8d3f5eb764fc000$export$e50f4bf6493199fc(text)}</t></is></c>`;
}
const $f8d3f5eb764fc000$var$cellLength = (value)=>value == null ? 0 : String(value).length;
function $f8d3f5eb764fc000$var$sheetXml({ header: header, rows: rows, rtl: rtl }) {
    const widths = header.map((h, c)=>{
        // A reduce, not `Math.max(...rows)`: spreading thousands of rows into one call
        // overflows the argument limit.
        const longest = rows.reduce((max, r)=>Math.max(max, $f8d3f5eb764fc000$var$cellLength(r[c])), $f8d3f5eb764fc000$var$cellLength(h) + 2);
        return Math.min(48, Math.max(8, longest + 2));
    });
    const cols = widths.map((w, i)=>`<col min="${i + 1}" max="${i + 1}" width="${w}" customWidth="1"/>`).join('');
    const headerRow = `<row r="1">${header.map((h, c)=>$f8d3f5eb764fc000$var$cellXml(`${$f8d3f5eb764fc000$export$91a1004e57ba531a(c)}1`, h, 1)).join('')}</row>`;
    const bodyRows = rows.map((row, r)=>{
        const n = r + 2;
        return `<row r="${n}">${row.map((v, c)=>$f8d3f5eb764fc000$var$cellXml(`${$f8d3f5eb764fc000$export$91a1004e57ba531a(c)}${n}`, v)).join('')}</row>`;
    });
    return `${$f8d3f5eb764fc000$var$XML_HEAD}<worksheet xmlns="${$f8d3f5eb764fc000$var$NS_MAIN}">` + `<sheetViews><sheetView tabSelected="1" workbookViewId="0"${rtl ? ' rightToLeft="1"' : ''}>` + '<pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/>' + '<selection pane="bottomLeft"/></sheetView></sheetViews>' + `<sheetFormatPr defaultRowHeight="15"/><cols>${cols}</cols>` + `<sheetData>${headerRow}${bodyRows.join('')}</sheetData></worksheet>`;
}
const $f8d3f5eb764fc000$var$STYLES_XML = `${$f8d3f5eb764fc000$var$XML_HEAD}<styleSheet xmlns="${$f8d3f5eb764fc000$var$NS_MAIN}">` + '<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font>' + '<font><b/><sz val="11"/><name val="Calibri"/></font></fonts>' + '<fills count="2"><fill><patternFill patternType="none"/></fill>' + '<fill><patternFill patternType="gray125"/></fill></fills>' + '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>' + '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' + '<cellXfs count="2"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>' + '<xf numFmtId="0" fontId="1" fillId="0" borderId="0" xfId="0" applyFont="1"/></cellXfs>' + '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>' + '</styleSheet>';
const $f8d3f5eb764fc000$var$CONTENT_TYPES_XML = `${$f8d3f5eb764fc000$var$XML_HEAD}<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">` + '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' + '<Default Extension="xml" ContentType="application/xml"/>' + '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' + '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>' + '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>' + '</Types>';
const $f8d3f5eb764fc000$var$ROOT_RELS_XML = `${$f8d3f5eb764fc000$var$XML_HEAD}<Relationships xmlns="${$f8d3f5eb764fc000$var$NS_PKG_REL}">` + `<Relationship Id="rId1" Type="${$f8d3f5eb764fc000$var$NS_REL}/officeDocument" Target="xl/workbook.xml"/></Relationships>`;
const $f8d3f5eb764fc000$var$WORKBOOK_RELS_XML = `${$f8d3f5eb764fc000$var$XML_HEAD}<Relationships xmlns="${$f8d3f5eb764fc000$var$NS_PKG_REL}">` + `<Relationship Id="rId1" Type="${$f8d3f5eb764fc000$var$NS_REL}/worksheet" Target="worksheets/sheet1.xml"/>` + `<Relationship Id="rId2" Type="${$f8d3f5eb764fc000$var$NS_REL}/styles" Target="styles.xml"/></Relationships>`;
const $f8d3f5eb764fc000$var$workbookXml = (sheetName)=>`${$f8d3f5eb764fc000$var$XML_HEAD}<workbook xmlns="${$f8d3f5eb764fc000$var$NS_MAIN}" xmlns:r="${$f8d3f5eb764fc000$var$NS_REL}">` + `<sheets><sheet name="${$f8d3f5eb764fc000$export$e50f4bf6493199fc(sheetName)}" sheetId="1" r:id="rId1"/></sheets></workbook>`;
function $f8d3f5eb764fc000$export$f5deefed96a1eb30({ sheetName: sheetName = 'Sheet1', header: header, rows: rows, rtl: rtl = false }) {
    const part = (name, text)=>({
            name: name,
            data: $f8d3f5eb764fc000$var$encoder.encode(text)
        });
    return $f8d3f5eb764fc000$export$8410b3e5307ac21e([
        part('[Content_Types].xml', $f8d3f5eb764fc000$var$CONTENT_TYPES_XML),
        part('_rels/.rels', $f8d3f5eb764fc000$var$ROOT_RELS_XML),
        part('xl/workbook.xml', $f8d3f5eb764fc000$var$workbookXml($f8d3f5eb764fc000$export$61071fa18bbe16b1(sheetName))),
        part('xl/_rels/workbook.xml.rels', $f8d3f5eb764fc000$var$WORKBOOK_RELS_XML),
        part('xl/styles.xml', $f8d3f5eb764fc000$var$STYLES_XML),
        part('xl/worksheets/sheet1.xml', $f8d3f5eb764fc000$var$sheetXml({
            header: header,
            rows: rows,
            rtl: rtl
        }))
    ]);
}


/**
 * Hand bytes to the browser as a file download.
 *
 * The object URL is revoked on a delay, not immediately: some browsers resolve
 * the download from the URL AFTER `click()` returns, and a revoked URL is a
 * download that silently produces nothing.
 */ function $0511f6151574c7b2$export$98be4c06e43b907(filename, bytes, mime) {
    const url = URL.createObjectURL(new Blob([
        bytes
    ], {
        type: mime
    }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
var $0511f6151574c7b2$export$2e2bcd8739ae039 = $0511f6151574c7b2$export$98be4c06e43b907;






var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $26cec67c26de53a9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("FileSpreadsheet", [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M8 13h2",
            key: "yr2amv"
        }
    ],
    [
        "path",
        {
            d: "M14 13h2",
            key: "un5t4a"
        }
    ],
    [
        "path",
        {
            d: "M8 17h2",
            key: "2yhykz"
        }
    ],
    [
        "path",
        {
            d: "M14 17h2",
            key: "10kma7"
        }
    ]
]);







function $fee41f5f85099398$export$2e2bcd8739ae039({ view: view, counts: counts, onChange: onChange, onClear: onClear, isFiltered: isFiltered, resultLabel: resultLabel, onExport: onExport, exportCount: exportCount = 0 }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The field is LOCAL state so it echoes instantly, and the URL is written after
    // the debounce: putting every keystroke in the URL would either lag the caret
    // or fill the history with twenty entries.
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.q || '');
    // Adopt an externally-changed query — a «حذف فیلترها», or arriving on a deep
    // link — without fighting what the operator is typing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(view.q || '');
    }, [
        view.q
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (draft === (view.q || '')) return undefined;
        const timer = setTimeout(()=>onChange({
                q: draft,
                page: 1
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        draft,
        view.q,
        onChange
    ]);
    const focusSearch = ()=>{
        searchRef.current?.focus();
        searchRef.current?.select?.();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('f3', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.clinics')
    });
    // A bare printable key, so the registry's caret rule keeps it from firing while
    // the operator is typing into a field — «/» inside the search box is a slash.
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('/', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.clinics')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "clinics-toolbar",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "group",
                        "aria-label": t('clinics.filters.label'),
                        className: "flex flex-wrap items-center gap-1.5",
                        "data-testid": "clinics-filter",
                        children: (0, $ec7f110ce929cf56$export$7d4209ff166fcb41).map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                label: value === 'ALL' ? t('clinics.filters.all') : t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)(value)),
                                count: counts[value] == null ? undefined : formatNumber(counts[value]),
                                active: view.status === value,
                                onClick: ()=>onChange({
                                        status: value,
                                        page: 1
                                    }),
                                "data-testid": `clinics-filter-${value}`
                            }, value))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                        semantics: "filter",
                        size: "sm",
                        ariaLabel: t('clinics.filters.tierLabel'),
                        options: (0, $00e3ccdc2868d16a$export$b83f00531415b634).map((value)=>({
                                value: value,
                                label: value === 'ALL' ? t('clinics.filters.allTiers') : t((0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(value))
                            })),
                        value: view.tier,
                        onChange: (tier)=>onChange({
                                tier: tier,
                                page: 1
                            }),
                        "data-testid": "clinics-tier-filter"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('clinics.filters.from'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-44",
                            "data-testid": "clinics-from",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: view.from || '',
                                onChange: (v)=>onChange({
                                        from: v || '',
                                        page: 1
                                    }),
                                placeholder: t('clinics.filters.datePlaceholder'),
                                disableFuture: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('clinics.filters.to'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-44",
                            "data-testid": "clinics-to",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: view.to || '',
                                onChange: (v)=>onChange({
                                        to: v || '',
                                        page: 1
                                    }),
                                placeholder: t('clinics.filters.datePlaceholder'),
                                disableFuture: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-[16rem] flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                            ref: searchRef,
                            value: draft,
                            onChange: (e)=>setDraft(e.target?.value ?? e),
                            onKeyDown: (e)=>{
                                // Esc clears rather than blurring: an operator who mistyped wants
                                // the field empty, and the browser's own Esc behaviour on a search
                                // input is inconsistent between engines.
                                if (e.key === 'Escape' && draft) {
                                    e.stopPropagation();
                                    setDraft('');
                                }
                            },
                            placeholder: t('clinics.search.placeholder'),
                            "aria-label": t('clinics.search.label'),
                            "data-testid": "clinics-search"
                        })
                    }),
                    isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: onClear,
                        "data-testid": "clinics-clear-filters",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('common.actions.clearFilters')
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        size: "sm",
                        onClick: onExport,
                        disabled: !onExport || exportCount < 1,
                        title: t('clinics.export.hint', {
                            count: exportCount
                        }),
                        "data-testid": "clinics-export",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26cec67c26de53a9$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('clinics.export.button')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-3 text-xs text-muted-foreground",
                "aria-live": "polite",
                "data-testid": "clinics-count",
                children: resultLabel
            })
        ]
    });
}



parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a2dfa57d290a8089$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Ban", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m4.9 4.9 14.2 14.2",
            key: "1m5liu"
        }
    ]
]);




parcelRequire("acw62");




function $f3739acd771b8391$export$6d154e3ed680b18a({ clinic: clinic, status: status, className: className }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const value = clinic ? clinic.hasSubscription ? clinic.subscriptionStatus : (0, $ec7f110ce929cf56$export$bc262605061d3b3) : status || (0, $ec7f110ce929cf56$export$bc262605061d3b3);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: (0, $ec7f110ce929cf56$export$c26dc91cd2a16d73)[value] || 'outline',
        className: className,
        children: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)(value))
    });
}
function $f3739acd771b8391$export$8cad3a378bd626fa({ clinic: clinic, className: className }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!clinic?.hasSubscription) return null;
    const known = (0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(clinic.capabilitySet);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        // An unrecognised tier gets the neutral outline rather than a colour that
        // would imply we know where it sits on the ladder.
        variant: known && (0, $ec7f110ce929cf56$export$5ecd1cf643281a55)[clinic.capabilitySet] || 'outline',
        className: className,
        children: (0, $7df21990c7b31bb5$export$c6aafd8353c81df)(clinic, t)
    });
}
var $f3739acd771b8391$export$2e2bcd8739ae039 = $f3739acd771b8391$export$6d154e3ed680b18a;



parcelRequire("acw62");


/**
 * How close a term is to lapsing, in words, beside the date itself.
 *
 * A date alone makes an operator subtract: «۱۴۰۴/۰۶/۲۵ — is that soon?». The hint
 * answers that without replacing the date, because the date is the fact and the
 * hint is the reading.
 *
 * Deliberately ABSENT for a term with months left. A list where every row carries
 * a coloured hint has no hints — the colour budget (DESIGN-CONCEPT §10) says
 * semantic colour is spent only on what demands attention, and a healthy
 * subscription demands none.
 *
 * Never colour alone: the words carry the meaning and the tint reinforces it, so
 * the column survives being printed, being read by somebody with a colour vision
 * deficiency, and being scanned at arm's length.
 */ const $c869e0633b03089f$var$TONE_CLASS = {
    warn: 'text-[#92400E]',
    danger: 'text-destructive'
};
function $c869e0633b03089f$export$2e2bcd8739ae039({ date: date, now: now }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const hint = (0, $7df21990c7b31bb5$export$550e570667f607fb)(date, {
        t: t,
        now: now
    });
    if (!hint) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `text-[11px] ${$c869e0633b03089f$var$TONE_CLASS[hint.tone] || 'text-muted-foreground'}`,
        children: hint.text
    });
}



function $a6a07eb99da4bdf0$export$2e2bcd8739ae039({ rows: rows, view: view, onSort: onSort, onOpen: onOpen, empty: empty }) {
    const { t: t, formatDate: formatDate, locale: locale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const columns = [
        {
            key: 'name',
            header: t('clinics.columns.name'),
            sortable: true,
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            title: r.name || '',
                            children: r.name || t('common.value.none')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            dir: "auto",
                            className: "truncate text-xs text-muted-foreground",
                            children: [
                                r.clinicType || t('common.value.none'),
                                (0, $7df21990c7b31bb5$export$9df85c386a2af045)(r.currency) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    className: "ms-1.5",
                                    title: t('clinics.currencyHint', {
                                        name: (0, $7df21990c7b31bb5$export$dc766bb5b31bee30)(r.currency, {
                                            t: t,
                                            locale: locale
                                        }) || r.currency
                                    }),
                                    "data-testid": `clinics-row-${r.id}-currency`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                        children: r.currency
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
        },
        {
            key: 'status',
            header: t('clinics.columns.status'),
            sortable: true,
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$6d154e3ed680b18a), {
                            clinic: r
                        }),
                        r.active === false ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            title: t('clinics.inactiveHint'),
                            children: t('clinics.inactive')
                        }) : null
                    ]
                })
        },
        {
            key: 'tier',
            header: t('clinics.columns.tier'),
            sortable: true,
            width: '7rem',
            render: (r)=>r.hasSubscription ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$8cad3a378bd626fa), {
                    clinic: r
                }) : t('common.value.none')
        },
        {
            key: 'entitled',
            header: t('clinics.columns.entitled'),
            sortable: true,
            width: '7rem',
            // Icon AND word, never colour alone: this is the column an operator acts
            // on, and a green/red dot is unreadable in print, in monochrome, and to a
            // colour-blind reader.
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: `inline-flex items-center gap-1 text-xs font-semibold ${r.entitled ? 'text-[#166534]' : 'text-destructive'}`,
                    children: [
                        r.entitled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                            size: 13,
                            "aria-hidden": true
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                            size: 13,
                            "aria-hidden": true
                        }),
                        r.entitled ? t('clinics.entitled.yes') : t('clinics.entitled.no')
                    ]
                })
        },
        {
            key: 'until',
            header: t('clinics.columns.until'),
            sortable: true,
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: r.hasSubscription ? (0, $7df21990c7b31bb5$export$316445b56b177ccd)(r, {
                                t: t,
                                formatDate: formatDate
                            }) : t('common.value.none')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c869e0633b03089f$export$2e2bcd8739ae039), {
                            date: (0, $7df21990c7b31bb5$export$78fb443a25ba8d2d)(r)
                        })
                    ]
                })
        },
        {
            key: 'phone',
            header: t('clinics.columns.phone'),
            width: '8rem',
            // An LTR island: a phone number is a Latin-digit run and must read
            // left-to-right inside a Persian row, with `unicode-bidi: isolate` stopping
            // the neighbouring text from dragging its ends around.
            //
            // Shown in the NATIONAL form. The column is stored E.164 now
            // («+982112345678») and an operator scanning this table reads and dials
            // «02112345678». `phone.forDisplay` is the kit's read path: it tolerates a
            // landline — an office number IS one, and the strict converter answers ''
            // for every area code — and falls back to the raw value rather than
            // blanking a number it cannot parse.
            render: (r)=>r.officePhone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                    className: "tabular-nums",
                    children: (0, $412e1a8a99c19c1a$exports).forDisplay(r.officePhone)
                }) : t('common.value.none')
        },
        {
            key: 'created',
            header: t('clinics.columns.created'),
            sortable: true,
            width: '8rem',
            render: (r)=>r.createdAt ? formatDate(r.createdAt) : t('common.value.none')
        },
        {
            key: 'actions',
            // Visually hidden: the column is obvious from its contents, and a header
            // over a row of links is noise — but a `<th>` with no accessible text
            // leaves the column unnamed for a screen reader.
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: t('clinics.columns.actions')
            }),
            align: 'end',
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    asChild: true,
                    variant: "ghost",
                    size: "sm",
                    // The row's own handler would fire too and navigate twice.
                    onClick: (e)=>e.stopPropagation(),
                    "data-testid": `clinics-row-${r.id}-open`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/clinics/${r.id}`,
                        "aria-label": t('clinics.open', {
                            name: r.name || r.id
                        }),
                        children: [
                            t('common.actions.details'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: (0, $c53f9539af19d960$export$ddb338179359cccc)
                            })
                        ]
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('clinics.table.aria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.id,
        onRowActivate: (r)=>onOpen(r),
        rowProps: (r)=>({
                'data-testid': `clinics-row-${r.id}`
            }),
        sort: {
            key: view.sort,
            dir: view.dir
        },
        onSort: onSort,
        empty: empty,
        "data-testid": "clinics-table"
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



function $edf836d1b9a3c0c2$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, lead: lead, error: error, pending: pending = false, dirty: dirty = false, submitLabel: submitLabel, submitVariant: submitVariant = 'default', submitDisabled: submitDisabled = false, onSubmit: onSubmit, footerNote: footerNote, size: size, layout: layout = 'scroll', children: children, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const canSubmit = !pending && !submitDisabled;
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('ctrl+enter', ()=>{
        if (open && canSubmit) onSubmit();
    }, {
        label: t('shortcuts.action.submit'),
        enabled: open && canSubmit
    });
    /**
   * Every route out of the dialog funnels through here.
   *
   * While pending, nothing closes it: a request is in flight and closing the
   * dialog would leave the operator unsure whether the write landed. Dirty and
   * idle asks first. Clean and idle just closes.
   */ const requestClose = (next)=>{
        if (next) {
            onOpenChange(true);
            return;
        }
        if (pending) return;
        if (dirty) {
            setConfirmDiscard(true);
            return;
        }
        onOpenChange(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
                open: open,
                onOpenChange: requestClose,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
                    size: size,
                    layout: layout,
                    showClose: !pending,
                    onEscapeKeyDown: (e)=>{
                        if (pending || dirty) e.preventDefault();
                        if (dirty && !pending) setConfirmDiscard(true);
                    },
                    onPointerDownOutside: (e)=>{
                        if (pending || dirty) e.preventDefault();
                        if (dirty && !pending) setConfirmDiscard(true);
                    },
                    "data-testid": testId,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                            className: "flex flex-col gap-3",
                            children: [
                                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                    variant: "error",
                                    "data-testid": testId ? `${testId}-error` : 'dialog-error',
                                    children: error
                                }) : null,
                                lead,
                                children
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                            className: layout === 'frame' ? 'items-center justify-start gap-2' : 'mt-6 items-center justify-start gap-2',
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: submitVariant,
                                    disabled: !canSubmit,
                                    onClick: onSubmit,
                                    "aria-busy": pending || undefined,
                                    "data-testid": testId ? `${testId}-submit` : undefined,
                                    children: [
                                        pending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                            size: 16,
                                            thickness: 2,
                                            color: "currentColor"
                                        }) : null,
                                        submitLabel
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    disabled: pending,
                                    onClick: ()=>requestClose(false),
                                    "data-testid": testId ? `${testId}-cancel` : undefined,
                                    children: t('common.actions.cancel')
                                }),
                                footerNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "ms-1 text-xs text-muted-foreground",
                                    children: footerNote
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirmDiscard,
                onOpenChange: setConfirmDiscard,
                title: t('clinic.dialogs.dirty.title'),
                description: t('clinic.dialogs.dirty.body'),
                confirmLabel: t('clinic.dialogs.dirty.confirm'),
                cancelLabel: t('clinic.dialogs.dirty.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    setConfirmDiscard(false);
                    onOpenChange(false);
                },
                "data-testid": testId ? `${testId}-discard` : undefined
            })
        ]
    });
}


const $23a3bd285a2ff999$var$BACKFILL = `
  mutation Backfill($trialEndsAt: String, $dryRun: Boolean) {
    backfillSubscriptions(trialEndsAt: $trialEndsAt, dryRun: $dryRun) {
      requested created skipped failed
      results { clinicId outcome status detail }
    }
  }
`;
/** Tomorrow, as the Gregorian 'YYYY-MM-DD' every kit date component speaks. */ function $23a3bd285a2ff999$var$tomorrowISO() {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().slice(0, 10);
}
function $23a3bd285a2ff999$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, unprovisioned: unprovisioned, onDone: onDone }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('grandfather');
    const [trialEndsAt, setTrialEndsAt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the dry-run report
    const [report, setReport] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the committed report
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // 'preview' | 'commit'
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Reset on open so a second visit does not inherit the first one's preview —
    // which would let a stale «created: 40» authorise a write on new inputs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setMode('grandfather');
        setTrialEndsAt('');
        setPreview(null);
        setReport(null);
        setBusy(null);
        setError(null);
    }, [
        open
    ]);
    const trialRequired = mode === 'trial';
    const trialError = (()=>{
        if (!trialRequired) return null;
        if (!trialEndsAt) return t('validation.required');
        if (trialEndsAt < $23a3bd285a2ff999$var$tomorrowISO()) return t('validation.futureRequired');
        return null;
    })();
    // The signature of what a preview was taken FOR. Any change to the inputs
    // invalidates it, so the commit button cannot ride on a preview of something
    // else.
    const signature = `${mode}|${trialEndsAt}`;
    const previewValid = preview && preview.signature === signature;
    const run = async (dryRun)=>{
        setError(null);
        setBusy(dryRun ? 'preview' : 'commit');
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)($23a3bd285a2ff999$var$BACKFILL, {
                trialEndsAt: trialRequired ? trialEndsAt : null,
                dryRun: dryRun
            });
            const result = d.backfillSubscriptions;
            if (dryRun) setPreview({
                ...result,
                signature: signature
            });
            else setReport(result);
        } catch (e) {
            setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setBusy(null);
        }
    };
    const failedRows = (report || preview)?.results?.filter((r)=>r.outcome === 'FAILED') || [];
    const shown = report || (previewValid ? preview : null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('clinics.backfill.title'),
        error: error,
        pending: busy === 'commit',
        // Once the write has landed there is nothing unsaved left to guard, so the
        // dialog closes freely and the operator is not asked about a form they
        // already submitted.
        dirty: !report && (trialRequired ? !!trialEndsAt : false),
        submitLabel: report ? t('common.actions.close') : t('clinics.backfill.commit'),
        submitDisabled: !report && (!previewValid || preview.created === 0 || !!trialError),
        onSubmit: ()=>{
            if (report) {
                onOpenChange(false);
                onDone();
                return;
            }
            run(false);
        },
        footerNote: !report && !previewValid ? t('clinics.backfill.needPreview') : undefined,
        "data-testid": "clinics-backfill-confirm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm leading-6 text-muted-foreground",
                children: t('clinics.backfill.lead', {
                    count: unprovisioned
                })
            }),
            !report && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('clinics.backfill.modeLabel'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "clinics-backfill-mode",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $995baf94da7c0c12$export$2e2bcd8739ae039), {
                                value: mode,
                                onChange: (next)=>{
                                    setMode(next);
                                    setPreview(null);
                                },
                                options: [
                                    {
                                        value: 'grandfather',
                                        label: t('clinics.backfill.grandfather'),
                                        description: t('clinics.backfill.grandfatherDesc')
                                    },
                                    {
                                        value: 'trial',
                                        label: t('clinics.backfill.trial'),
                                        description: t('clinics.backfill.trialDesc')
                                    }
                                ]
                            })
                        })
                    }),
                    trialRequired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('clinics.backfill.trialEnd'),
                        required: true,
                        error: trialEndsAt ? trialError : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "clinics-backfill-trial-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: trialEndsAt,
                                onChange: setTrialEndsAt
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: ()=>run(true),
                            disabled: !!busy || !!trialError,
                            "aria-busy": busy === 'preview' || undefined,
                            "data-testid": "clinics-backfill-preview",
                            children: [
                                busy === 'preview' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                    size: 16,
                                    thickness: 2,
                                    color: "currentColor"
                                }) : null,
                                t('clinics.backfill.preview')
                            ]
                        })
                    })
                ]
            }),
            shown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: report ? 'success' : 'info',
                "data-testid": "clinics-backfill-report",
                children: t('clinics.backfill.previewResult', {
                    created: shown.created,
                    skipped: shown.skipped,
                    failed: shown.failed
                })
            }) : null,
            failedRows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2358e3acbc4a7e55$export$2e2bcd8739ae039), {
                title: t('clinics.backfill.failedTitle'),
                badge: formatNumber(failedRows.length),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "flex flex-col gap-1.5",
                    children: failedRows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: "text-xs",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                    className: "font-mono text-muted-foreground",
                                    children: row.clinicId
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "ms-2",
                                    dir: "auto",
                                    children: row.detail
                                })
                            ]
                        }, row.clinicId))
                })
            }) : null
        ]
    });
}


/**
 * Archetype B (Report/List) — the estate.
 *
 * ① PageHeader · ④ toolbar · ⑤ table · ⑥ pager.
 *
 * ── THE VIEW IS THE URL ─────────────────────────────────────────────────────
 * Filters, search, sort and page are query params (§3.2). They were component
 * state, which broke the flow this screen exists for: an operator narrows to
 * «مهلت تمدید», opens a clinic, comes back — and every filter is gone. It also
 * makes a view sendable, which matters when two people are working one incident.
 *
 * ── THE SERVER IS NOT ASKED TO FILTER ───────────────────────────────────────
 * `clinics` is called with NO arguments. The BFF returns the whole estate anyway
 * (it joins the registry to one batched entitlement call — a per-clinic lookup
 * would be thousands of round trips) and its own `search`/`status` arguments
 * filter that same in-memory array. So a server-side filter costs a round trip
 * and returns a subset of what is already here. `clinicsView` does it locally and
 * is a pure, tested function; when the estate outgrows that, the fix is
 * `limit`/`offset` on the query, which is a BFF change.
 */ const $8e2d594c57ce6e69$var$CLINICS_QUERY = `
  query Clinics {
    clinics {
      id name clinicType officePhone active createdAt currency
      subscriptionStatus entitled hasSubscription planCode capabilitySet tierNameFa
      currentPeriodEnd trialEndsAt
    }
  }
`;
/** The URL contract. Defaults are absent from the address. */ const $8e2d594c57ce6e69$var$SCHEMA = {
    q: {
        default: ''
    },
    status: {
        default: 'ALL',
        values: (0, $ec7f110ce929cf56$export$7d4209ff166fcb41)
    },
    tier: {
        default: 'ALL',
        values: (0, $00e3ccdc2868d16a$export$b83f00531415b634)
    },
    entitled: {
        default: '',
        values: [
            '',
            '0',
            '1'
        ]
    },
    // The registration window: picker days, 'YYYY-MM-DD'. Junk reads as no bound
    // (`dateRangeFilter` ignores anything that is not a date).
    from: {
        default: ''
    },
    to: {
        default: ''
    },
    sort: {
        default: 'created',
        values: (0, $00e3ccdc2868d16a$export$39ffba2ece42ec36)
    },
    dir: {
        default: 'desc',
        values: [
            'asc',
            'desc'
        ]
    },
    page: {
        default: 1,
        parse: (raw)=>Number(raw) || 1
    }
};
function $8e2d594c57ce6e69$export$2e2bcd8739ae039() {
    const { t: t, locale: locale, formatNumber: formatNumber, isRTL: isRTL } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.clinics');
    const [view, setView, resetView] = (0, $e77179a3ce65222f$export$6a582373474709af)($8e2d594c57ce6e69$var$SCHEMA);
    const [rawParams, setRawParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    /**
   * `?unprovisioned=1` → `?status=UNPROVISIONED`.
   *
   * The old dashboard alert linked here with that param, and so do any bookmarks
   * and ticket notes made since. It is rewritten to the canonical one on arrival
   * (with `replace`, so it leaves no history entry) rather than being carried as a
   * second way to express one filter — two spellings of the same view is how they
   * drift apart.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!rawParams.get('unprovisioned')) return;
        const next = new URLSearchParams(rawParams);
        next.delete('unprovisioned');
        next.set('status', (0, $ec7f110ce929cf56$export$bc262605061d3b3));
        setRawParams(next, {
            replace: true
        });
    }, [
        rawParams,
        setRawParams
    ]);
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [backfilling, setBackfilling] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)($8e2d594c57ce6e69$var$CLINICS_QUERY)// Default to []: a malformed or unexpected response must not put
        // `undefined` into state and white-screen the panel.
        .then((d)=>setRows(d?.clinics || [])).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        t
    ]);
    // Once. Every narrowing after this is local, so a filter change must NOT
    // refetch — that was the old behaviour and it made every chip press a round
    // trip that could fail.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $00e3ccdc2868d16a$export$f755f4a1abb672d6)(rows, view, {
            locale: locale
        }), [
        rows,
        view,
        locale
    ]);
    // Counts for the chip row, from the UNFILTERED estate: a count that changed
    // with the active filter would be a count of what you are already looking at.
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const out = {
            ALL: rows.length
        };
        for (const key of (0, $ec7f110ce929cf56$export$7d4209ff166fcb41))if (key !== 'ALL') out[key] = 0;
        for (const r of rows){
            const key = r.hasSubscription ? r.subscriptionStatus : (0, $ec7f110ce929cf56$export$bc262605061d3b3);
            if (key in out) out[key] += 1;
        }
        return out;
    }, [
        rows
    ]);
    const onSort = (key)=>{
        // desc → asc → back to the default. A third press restoring the default is
        // what makes an accidental sort undoable without hunting for the original.
        if (view.sort !== key) setView({
            sort: key,
            dir: 'desc',
            page: 1
        });
        else if (view.dir === 'desc') setView({
            dir: 'asc',
            page: 1
        });
        else setView({
            sort: $8e2d594c57ce6e69$var$SCHEMA.sort.default,
            dir: $8e2d594c57ce6e69$var$SCHEMA.dir.default,
            page: 1
        });
    };
    const openClinic = (row)=>{
        // Where the operator was, so Back returns to this exact view.
        try {
            sessionStorage.setItem('clinics.lastRow', row.id);
        } catch  {}
        navigate(`/clinics/${row.id}`);
    };
    // The whole filtered list in on-screen order — not the visible page.
    const onExport = ()=>{
        try {
            const { header: header, rows: body } = (0, $b1df05aee7406d36$export$eb9d166f36cf96e9)(result.matching, {
                t: t
            });
            const bytes = (0, $f8d3f5eb764fc000$export$f5deefed96a1eb30)({
                sheetName: t('clinics.export.sheet'),
                header: header,
                rows: body,
                rtl: isRTL
            });
            (0, $0511f6151574c7b2$export$98be4c06e43b907)((0, $b1df05aee7406d36$export$9652ad3f82731fc7)(view), bytes, (0, $f8d3f5eb764fc000$export$1783f1fe1bd2b30e));
            toast.success(t('clinics.export.done', {
                count: body.length
            }));
        } catch  {
            toast.error(t('clinics.export.failed'));
        }
    };
    const resultLabel = result.isFiltered ? t('clinics.countFiltered', {
        count: result.filtered,
        total: result.total
    }) : t('clinics.count', {
        count: result.total
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "clinics",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('clinics.title'),
                sub: t('clinics.sub'),
                children: result.unprovisioned > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: ()=>setBackfilling(true),
                    "data-testid": "clinics-backfill",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b19608dd471de3d$export$2e2bcd8739ae039), {
                            size: 16,
                            "aria-hidden": true
                        }),
                        t('clinics.backfill.trigger', {
                            count: result.unprovisioned
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fee41f5f85099398$export$2e2bcd8739ae039), {
                        view: view,
                        counts: counts,
                        isFiltered: result.isFiltered,
                        resultLabel: resultLabel,
                        onChange: setView,
                        onClear: resetView,
                        onExport: loading || error ? undefined : onExport,
                        exportCount: result.filtered
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-lg border border-border bg-card transition-opacity",
                        // Stale-while-refetch (§2.4): after a write the list dims rather than
                        // being replaced by skeletons, so the operator keeps their place.
                        style: {
                            opacity: refreshing ? 0.45 : 1
                        },
                        "aria-busy": refreshing || undefined,
                        children: loading ? // Skeleton ROWS in the real table frame, so nothing moves when the
                        // data lands. Two `SkeletonCard`s (the old loading state) were a
                        // different shape from the thing they stood in for.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "clinics-loading",
                            "data-state": "loading",
                            "aria-busy": "true",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: Array.from({
                                        length: 8
                                    }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                                            cols: 8
                                        }, i))
                                })
                            })
                        }) : error ? // The error replaces exactly the region whose query failed, INSIDE the
                        // card where the rows would be — the toolbar above it still works, so
                        // a retry does not cost the operator their filters.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                            title: t('errors.region.clinics'),
                            description: error,
                            onRetry: load,
                            retryLabel: t('common.actions.retry'),
                            "data-testid": "clinics-error"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a6a07eb99da4bdf0$export$2e2bcd8739ae039), {
                            rows: result.rows,
                            view: view,
                            onSort: onSort,
                            onOpen: openClinic,
                            empty: result.isFiltered ? // Filtered-empty and truly-empty are different facts, and telling
                            // an operator "no clinics exist" when four hundred do is a wrong
                            // answer, not a vague one.
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                    size: 44,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('clinics.emptyFiltered.title'),
                                description: t('clinics.emptyFiltered.desc'),
                                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: resetView,
                                    children: t('common.actions.clearFilters')
                                }),
                                "data-testid": "clinics-empty"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $224502d93617e0e1$export$2e2bcd8739ae039), {
                                    size: 44,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('clinics.empty.title'),
                                description: t('clinics.empty.desc'),
                                "data-testid": "clinics-empty"
                            })
                        })
                    }),
                    !loading && !error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "clinics-pager",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                            page: result.page,
                            pageCount: result.pageCount,
                            pageSize: (0, $cdf3712044ab22f9$export$8ec3d08588d2eeda),
                            onChange: (page)=>setView({
                                    page: page
                                }),
                            prevLabel: t('common.pager.prev'),
                            nextLabel: t('common.pager.next'),
                            pageLabel: (page, total)=>t('common.pager.label', {
                                    page: page,
                                    total: total
                                }),
                            formatNumber: formatNumber
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23a3bd285a2ff999$export$2e2bcd8739ae039), {
                open: backfilling,
                onOpenChange: setBackfilling,
                unprovisioned: result.unprovisioned,
                onDone: ()=>load({
                        quiet: true
                    })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f0cdbf97a5c8afc2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("KeyRound", [
    [
        "path",
        {
            d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
            key: "1s6t7t"
        }
    ],
    [
        "circle",
        {
            cx: "16.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "w0ekpg"
        }
    ]
]);












var $acw62 = parcelRequire("acw62");





const $11ac046a796b919b$var$NOTE_MAX = 500;
const $11ac046a796b919b$var$today = ()=>new Date().toISOString().slice(0, 10);
function $11ac046a796b919b$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, clinic: clinic, plans: plans, pending: pending, error: error, onSubmit: onSubmit }) {
    const { t: t, formatMoney: formatMoney } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [planCode, setPlanCode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [periodStart, setPeriodStart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [periodEnd, setPeriodEnd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmDowngrade, setConfirmDowngrade] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setPlanCode('');
        setPeriodStart('');
        setPeriodEnd('');
        setNote('');
        setConfirmDowngrade(false);
    }, [
        open
    ]);
    // Grouped by tier and ordered by capability, so the picker reads as a ladder
    // rather than as six codes in seed order.
    const planOptions = (0, $ec7f110ce929cf56$export$67a3419b6c83c58c).flatMap((tier)=>(plans || []).filter((p)=>p.capabilitySet === tier).map((p)=>({
                value: p.code,
                label: t('clinic.dialogs.activate.planOption', {
                    tier: (0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(tier) ? t((0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(tier)) : tier,
                    term: (0, $7df21990c7b31bb5$export$497627c16d0f1457)(p.periodMonths, t),
                    // In the plan's own currency (PM-0211): IRR reads «… تومان» as it always
                    // has; a USD catalogue reads «79.00 USD».
                    price: Number(p.priceRial) > 0 ? formatMoney(p.priceRial, {
                        currency: p.currency,
                        withUnit: true,
                        unitLabel: t('common.units.toman'),
                        unitStyle: 'short'
                    }) : t('common.term.free')
                })
            })));
    const selected = (plans || []).find((p)=>p.code === planCode) || null;
    const currentRank = (0, $ec7f110ce929cf56$export$d926e5d057600107)(clinic.capabilitySet);
    const targetRank = (0, $ec7f110ce929cf56$export$d926e5d057600107)(selected?.capabilitySet);
    const isDowngrade = currentRank >= 0 && targetRank >= 0 && targetRank < currentRank;
    const endError = (()=>{
        if (!periodEnd) return null;
        if (periodStart && periodEnd <= periodStart) return t('validation.endAfterStart');
        if (periodEnd < $11ac046a796b919b$var$today()) return t('validation.notPast');
        return null;
    })();
    const dirty = !!(planCode || periodStart || periodEnd || note);
    const targetTier = selected?.capabilitySet && (0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(selected.capabilitySet) ? t((0, $ec7f110ce929cf56$export$bf4a1c4dc050ab09)(selected.capabilitySet)) : selected?.capabilitySet || '';
    const submit = ()=>onSubmit({
            planCode: planCode,
            // Empty dates travel as null, which the service reads as "now" and "now + the
            // plan's term" — so the common case stays one choice and only a deliberate
            // custom term is sent.
            periodStart: periodStart || null,
            periodEnd: periodEnd || null,
            note: note || null
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
                open: open,
                onOpenChange: onOpenChange,
                title: clinic.hasSubscription ? t('clinic.dialogs.activate.title') : t('clinic.dialogs.activate.provisionTitle'),
                error: error,
                pending: pending,
                dirty: dirty,
                submitLabel: isDowngrade ? t('clinic.dialogs.downgrade.submit') : t('clinic.dialogs.activate.submit'),
                submitVariant: isDowngrade ? 'destructive' : 'default',
                submitDisabled: !planCode || !!endError,
                onSubmit: ()=>isDowngrade ? setConfirmDowngrade(true) : submit(),
                footerNote: t('clinic.dialogs.activate.helper'),
                "data-testid": "detail-activate-confirm",
                lead: isDowngrade ? // A real `Alert`, not a hand-styled paragraph pretending to be one: the
                // previous version was a <p> with a muted background and destructive
                // ink, which is a warning banner rebuilt by hand.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    "data-testid": "detail-downgrade-warning",
                    children: t('clinic.dialogs.downgrade.warning', {
                        from: (0, $7df21990c7b31bb5$export$c6aafd8353c81df)(clinic, t),
                        to: targetTier
                    })
                }) : undefined,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "detail-plan-select",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                            label: t('clinic.dialogs.activate.plan'),
                            required: true,
                            value: planCode,
                            onChange: (e)=>setPlanCode(e.target?.value ?? e),
                            options: planOptions,
                            placeholder: t('clinic.dialogs.activate.planPlaceholder')
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                                label: t('clinic.dialogs.activate.start'),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "detail-period-start",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                        value: periodStart,
                                        onChange: setPeriodStart
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                                label: t('clinic.dialogs.activate.end'),
                                error: endError || undefined,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "detail-period-end",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                        value: periodEnd,
                                        onChange: setPeriodEnd
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('clinic.dialogs.activate.note'),
                        value: note,
                        onChange: (e)=>setNote(e.target?.value ?? e),
                        placeholder: t('clinic.dialogs.activate.notePlaceholder'),
                        maxLength: $11ac046a796b919b$var$NOTE_MAX,
                        showCount: true,
                        rows: 2,
                        "data-testid": "detail-activate-note"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirmDowngrade,
                onOpenChange: setConfirmDowngrade,
                title: t('clinic.dialogs.downgrade.title'),
                description: t('clinic.dialogs.downgrade.body', {
                    from: (0, $7df21990c7b31bb5$export$c6aafd8353c81df)(clinic, t),
                    to: targetTier
                }),
                confirmLabel: t('clinic.dialogs.downgrade.confirm'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                loading: pending,
                onConfirm: ()=>{
                    setConfirmDowngrade(false);
                    submit();
                },
                "data-testid": "detail-downgrade-confirm"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $4c090b1f14649eab$var$REASON_MAX = 300;
const $4c090b1f14649eab$var$REASON_MIN = 3;
function $4c090b1f14649eab$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, pending: pending, error: error, onSubmit: onSubmit }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setReason('');
    }, [
        open
    ]);
    const trimmed = reason.trim();
    const tooShort = trimmed.length > 0 && trimmed.length < $4c090b1f14649eab$var$REASON_MIN;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('clinic.dialogs.suspend.title'),
        error: error,
        pending: pending,
        dirty: !!reason,
        submitLabel: t('clinic.dialogs.suspend.submit'),
        submitVariant: "destructive",
        submitDisabled: trimmed.length < $4c090b1f14649eab$var$REASON_MIN,
        onSubmit: ()=>onSubmit({
                reason: trimmed
            }),
        "data-testid": "detail-suspend-confirm",
        lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
            variant: "error",
            children: t('clinic.dialogs.suspend.warning')
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": "detail-suspend-reason",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('clinic.dialogs.suspend.reason'),
                required: true,
                value: reason,
                onChange: (e)=>setReason(e.target?.value ?? e),
                placeholder: t('clinic.dialogs.suspend.reasonPlaceholder'),
                error: tooShort ? t('validation.tooShort', {
                    min: $4c090b1f14649eab$var$REASON_MIN
                }) : undefined,
                maxLength: $4c090b1f14649eab$var$REASON_MAX,
                showCount: true,
                rows: 3
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * The operations an entitlement override can unblock.
 *
 * A capability IS A GraphQL FIELD NAME on the clinic BFF, checked by name in its
 * `capabilitySets.js`. That makes free text here a typo that grants nothing and
 * reports success — the operator closes the ticket, the clinic still cannot
 * book, and nothing anywhere says why. Picking from a list is the difference
 * between an un-break that works and one that silently does not.
 *
 * MIRRORS `parsina.bff.clinic/src/auth/capabilitySets.js`, deliberately as a
 * local list rather than an import: those are separate repos and separate
 * deploys, so a cross-submodule import would be a lie about how this ships. The
 * honest cost is that a new gated operation means editing two files — which the
 * `label` being a catalogue KEY makes loud rather than silent, since a missing
 * key renders as a humanised fragment an operator will report.
 *
 * These are the ones support is actually asked about: the gates a clinic hits.
 * The list is intentionally not exhaustive — an override is a targeted un-break,
 * and a picker with sixty entries is one an operator scrolls past.
 */ const $190d19745aaef65a$export$58acdae8a6644e2f = [
    'createAppointment',
    'addDoctorToClinic',
    'addStaffToClinic',
    'generateInvitationCode',
    'accountingCreateInvoice',
    'accountingRecordPayment',
    'accountingOpenShift',
    'createCustomService',
    'createExpense',
    'createWarehousingItem',
    'reportStats',
    'openChatConversation',
    'parsePatientVoiceTranscript'
];
const $190d19745aaef65a$export$ee4c6696fffc5386 = (capability)=>`clinic.capability.${capability}`;



const $5467974189c6ce5c$var$REASON_MAX = 300;
const $5467974189c6ce5c$var$REASON_MIN = 3;
const $5467974189c6ce5c$var$tomorrow = ()=>{
    const d = new Date();
    d.setDate(d.getDate() + 1);
    return d.toISOString().slice(0, 10);
};
function $5467974189c6ce5c$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, pending: pending, error: error, onSubmit: onSubmit }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [capability, setCapability] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [granted, setGranted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('grant');
    const [expiresAt, setExpiresAt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setCapability('');
        setGranted('grant');
        setExpiresAt('');
        setReason('');
    }, [
        open
    ]);
    const trimmed = reason.trim();
    const expiryError = expiresAt && expiresAt < $5467974189c6ce5c$var$tomorrow() ? t('validation.futureRequired') : null;
    const dirty = !!(capability || expiresAt || reason);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('clinic.dialogs.override.title'),
        error: error,
        pending: pending,
        dirty: dirty,
        submitLabel: granted === 'grant' ? t('clinic.dialogs.override.submitGrant') : t('clinic.dialogs.override.submitRevoke'),
        submitVariant: granted === 'grant' ? 'default' : 'destructive',
        submitDisabled: !capability || trimmed.length < $5467974189c6ce5c$var$REASON_MIN || !!expiryError,
        onSubmit: ()=>onSubmit({
                capability: capability,
                granted: granted === 'grant',
                reason: trimmed,
                expiresAt: expiresAt || null
            }),
        "data-testid": "detail-override-confirm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm leading-6 text-muted-foreground",
                children: t('clinic.dialogs.override.body')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "detail-override-capability",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                    label: t('clinic.dialogs.override.capability'),
                    required: true,
                    value: capability,
                    onChange: (e)=>setCapability(e.target?.value ?? e),
                    options: (0, $190d19745aaef65a$export$58acdae8a6644e2f).map((value)=>({
                            value: value,
                            label: t((0, $190d19745aaef65a$export$ee4c6696fffc5386)(value))
                        })),
                    placeholder: t('clinic.dialogs.override.capabilityPlaceholder')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                label: t('clinic.dialogs.override.mode'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "detail-override-granted",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                        semantics: "filter",
                        size: "sm",
                        ariaLabel: t('clinic.dialogs.override.mode'),
                        options: [
                            {
                                value: 'grant',
                                label: t('clinic.dialogs.override.grant')
                            },
                            {
                                value: 'revoke',
                                label: t('clinic.dialogs.override.revoke')
                            }
                        ],
                        value: granted,
                        onChange: setGranted
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                label: t('clinic.dialogs.override.expires'),
                error: expiryError || undefined,
                helperText: expiryError ? undefined : t('clinic.dialogs.override.expiresHelper'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "detail-override-expires",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                        value: expiresAt,
                        onChange: setExpiresAt
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "detail-override-reason",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('clinic.dialogs.override.reason'),
                    required: true,
                    value: reason,
                    onChange: (e)=>setReason(e.target?.value ?? e),
                    placeholder: t('clinic.dialogs.override.reasonPlaceholder'),
                    maxLength: $5467974189c6ce5c$var$REASON_MAX,
                    showCount: true,
                    rows: 2
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Copy", [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e17c725e7c863883$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("History", [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ],
    [
        "path",
        {
            d: "M12 7v5l4 2",
            key: "1fdv2h"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cab856bf30f1b37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Receipt", [
    [
        "path",
        {
            d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
            key: "q3az6g"
        }
    ],
    [
        "path",
        {
            d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8",
            key: "1h4pet"
        }
    ],
    [
        "path",
        {
            d: "M12 17.5v-11",
            key: "1jc1ny"
        }
    ]
]);








parcelRequire("acw62");

function $0f68e1d223f0d9b1$export$2e2bcd8739ae039({ actor: actor, name: name }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!actor) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: t('common.value.none')
    });
    if (actor === 'SYSTEM') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: t('common.value.system')
    });
    if (name) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        dir: "auto",
        children: name
    });
    const short = String(actor).slice(0, 8);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: "font-mono text-xs text-muted-foreground",
        title: actor,
        children: [
            short,
            "\u2026"
        ]
    });
}


function $bf76e55deb271988$export$a455218a85c89869({ label: label, value: value, ltr: ltr, testId: testId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-w-0",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                className: "text-xs text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                className: `truncate font-semibold text-foreground ${ltr ? 'font-mono text-[13px]' : ''}`,
                ...ltr ? (0, $c53f9539af19d960$export$3433559efc22d110) : {
                    dir: 'auto'
                },
                children: value
            })
        ]
    });
}
function $bf76e55deb271988$export$1f31b6d22e079a72({ clinic: clinic, subscription: subscription }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const titleId = 'clinic-subscription-title';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        id: "subscription",
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            id: titleId,
            children: t('clinic.sections.subscription')
        }),
        icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
        children: !clinic.hasSubscription ? // Not an error and not an empty state: this is exactly the page an
        // operator opens in order to fix it, so the card explains the situation
        // and the header's primary action does the work.
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-sm leading-6 text-muted-foreground",
            children: t('clinic.alerts.unprovisioned')
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
            className: "grid grid-cols-2 gap-4 text-sm md:grid-cols-4",
            "aria-labelledby": titleId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.plan'),
                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$8cad3a378bd626fa), {
                        clinic: clinic
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.origin'),
                    value: (0, $7df21990c7b31bb5$export$b0c4fd215b5002d2)(subscription?.origin, t)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.start'),
                    value: subscription?.currentPeriodStart ? formatDate(subscription.currentPeriodStart) : t('common.value.none')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.until'),
                    value: (0, $7df21990c7b31bb5$export$316445b56b177ccd)(subscription, {
                        t: t,
                        formatDate: formatDate
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.trialEnd'),
                    value: subscription?.trialEndsAt ? formatDate(subscription.trialEndsAt) : t('common.value.none')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.grace'),
                    value: subscription?.graceEndsAt ? `${formatDate(subscription.graceEndsAt)} (${t('clinic.fields.graceDays', {
                        count: subscription.graceDays
                    })})` : t('clinic.fields.graceDays', {
                        count: subscription?.graceDays || 0
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.created'),
                    value: subscription?.createdAt ? formatDate(subscription.createdAt) : t('common.value.none')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                    label: t('clinic.fields.version'),
                    value: subscription?.version ?? "\u2014",
                    ltr: true
                })
            ]
        })
    });
}
function $bf76e55deb271988$export$28428edc284a0314({ periods: periods }) {
    const { t: t, locale: locale, formatDate: formatDate, formatMoney: formatMoney } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const rows = [
        ...periods || []
    ].reverse(); // newest first
    // Each amount is in its own period's currency (PM-0211): IRR on Parsina, the
    // deployment's platform currency elsewhere. Rows that share one currency name
    // it in the header, exactly as the toman header always did; a table that mixes
    // them (periods recorded before a deployment's catalogue changed) names every
    // currency in the header and puts a unit on each figure, so a dollar figure is
    // never read under «تومان».
    const codes = [
        ...new Set(rows.map((p)=>p.currency || 'IRR'))
    ];
    const mixed = codes.length > 1;
    // The header NAMES the currency («Montant (toman)»): IRR reads
    // `common.units.tomanName`, not the after-amount word (PM-0185).
    const amountUnit = codes.length ? codes.map((code)=>code === 'IRR' ? t('common.units.tomanName') : (0, $7df21990c7b31bb5$export$f76b597c9baf5209)(code, {
            t: t,
            locale: locale
        })).join(' / ') : t('common.units.tomanName');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        id: "periods",
        title: t('clinic.sections.periods'),
        icon: (0, $cab856bf30f1b37f$export$2e2bcd8739ae039),
        children: rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
            dense: true,
            ariaLabel: t('clinic.periods.aria'),
            rowKey: (p)=>p.id,
            rows: rows,
            columns: [
                {
                    key: 'periodStart',
                    header: t('clinic.periods.columns.start'),
                    render: (p)=>formatDate(p.periodStart)
                },
                {
                    key: 'periodEnd',
                    header: t('clinic.periods.columns.end'),
                    render: (p)=>formatDate(p.periodEnd)
                },
                {
                    key: 'priceRial',
                    // The header carries the unit, so the cell is the bare figure —
                    // and `formatMoney` still does the rial→toman conversion, so there
                    // is no second division anywhere in the app.
                    header: t('clinic.periods.columns.amount', {
                        unit: amountUnit
                    }),
                    align: 'end',
                    render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tabular-nums",
                            children: formatMoney(p.priceRial, {
                                currency: p.currency,
                                withUnit: mixed,
                                unitLabel: t('common.units.toman'),
                                unitStyle: 'short'
                            })
                        })
                },
                {
                    key: 'source',
                    header: t('clinic.periods.columns.source'),
                    render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: (0, $7df21990c7b31bb5$export$b24a5134b1f0c690)(p.source, t)
                        })
                },
                {
                    key: 'activatedBy',
                    header: t('clinic.periods.columns.by'),
                    render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f68e1d223f0d9b1$export$2e2bcd8739ae039), {
                            actor: p.activatedBy
                        })
                },
                {
                    key: 'activatedAt',
                    header: t('clinic.periods.columns.at'),
                    render: (p)=>p.activatedAt ? formatDate(p.activatedAt) : t('common.value.none')
                },
                {
                    key: 'note',
                    header: t('clinic.periods.columns.note'),
                    render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            dir: "auto",
                            className: "block max-w-[14rem] truncate",
                            title: p.note || '',
                            children: p.note || t('common.value.none')
                        })
                }
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3206cd97f03c9458$export$2e2bcd8739ae039), {
                size: 40,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: t('clinic.periods.empty.title'),
            description: t('clinic.periods.empty.desc')
        })
    });
}
/**
 * State transition, as two badges and a direction-aware arrow.
 *
 * The predecessor wrote a literal «←» between the two labels, which points the
 * wrong way the moment the panel renders LTR — and an arrow is the only thing
 * carrying which state came first. Here the glyph mirrors with `--dir-flip`, it is
 * `aria-hidden`, and the sentence «از X به Y» is what a screen reader gets, so the
 * order does not depend on reading a 14px icon at all.
 */ function $bf76e55deb271988$var$StatusTransition({ from: from, to: to }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!from && !to) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: t('common.value.none')
    });
    // The sentence names the states in WORDS. Interpolating the raw enum would read
    // «از TRIALING به ACTIVE» to a screen reader — the one consumer that cannot see
    // the badges the sentence exists to describe.
    const label = (status)=>status ? t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)(status)) : t('common.value.none');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex items-center gap-1.5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: t('clinic.events.transition', {
                    from: label(from),
                    to: label(to)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                "aria-hidden": true,
                className: "inline-flex items-center gap-1.5",
                children: [
                    from ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$6d154e3ed680b18a), {
                        status: from
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "\u2014"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$var$ChevronGlyph, {}),
                    to ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$6d154e3ed680b18a), {
                        status: to
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "\u2014"
                    })
                ]
            })
        ]
    });
}
const $bf76e55deb271988$var$ChevronGlyph = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: (0, $c53f9539af19d960$export$ddb338179359cccc),
        className: "text-muted-foreground",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
function $bf76e55deb271988$export$22925cbb709b3e49({ events: events }) {
    const { t: t, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $cdf3712044ab22f9$export$4946d8446c21041b));
    const [openPayload, setOpenPayload] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const rows = (events || []).slice(0, shown);
    const more = (events || []).length - rows.length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        id: "events",
        title: t('clinic.sections.events'),
        sub: t('clinic.sections.eventsSub'),
        icon: (0, $e17c725e7c863883$export$2e2bcd8739ae039),
        children: rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                    dense: true,
                    ariaLabel: t('clinic.events.aria'),
                    rowKey: (e)=>e.id,
                    rows: rows,
                    "data-testid": "detail-events",
                    columns: [
                        {
                            key: 'occurredAt',
                            header: t('clinic.events.columns.at'),
                            render: (e)=>formatDateTime(e.occurredAt)
                        },
                        {
                            key: 'eventType',
                            header: t('clinic.events.columns.type'),
                            // An event type this build has never been taught is echoed as its
                            // own raw string in an LTR code span — legible and reportable,
                            // rather than swallowed or given a plausible wrong label.
                            render: (e)=>(0, $7df21990c7b31bb5$export$b0a954b9d4388eb1)(e.eventType, t) || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                    className: "text-xs text-muted-foreground",
                                    children: e.eventType
                                })
                        },
                        {
                            key: 'toStatus',
                            header: t('clinic.events.columns.change'),
                            render: (e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$var$StatusTransition, {
                                    from: e.fromStatus,
                                    to: e.toStatus
                                })
                        },
                        {
                            key: 'actor',
                            header: t('clinic.events.columns.actor'),
                            render: (e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f68e1d223f0d9b1$export$2e2bcd8739ae039), {
                                    actor: e.actor
                                })
                        },
                        {
                            key: 'payload',
                            header: t('clinic.events.columns.detail'),
                            render: (e)=>e.payload ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "ghost",
                                    size: "sm",
                                    onClick: ()=>setOpenPayload(openPayload === e.id ? null : e.id),
                                    "aria-expanded": openPayload === e.id,
                                    "aria-label": t('clinic.events.showPayload'),
                                    children: openPayload === e.id ? t('common.actions.hide') : t('common.actions.show')
                                }) : null
                        }
                    ]
                }),
                openPayload ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                    className: "mt-2 max-h-48 overflow-auto rounded-lg bg-muted p-3 text-[11px] leading-5",
                    children: (()=>{
                        const found = (events || []).find((e)=>e.id === openPayload);
                        if (!found?.payload) return '';
                        try {
                            return JSON.stringify(JSON.parse(found.payload), null, 2);
                        } catch  {
                            // Not JSON after all — show it verbatim rather than nothing.
                            return found.payload;
                        }
                    })()
                }) : null,
                more > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-1",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        size: "sm",
                        onClick: ()=>setShown((n)=>n + (0, $cdf3712044ab22f9$export$4946d8446c21041b)),
                        "data-testid": "detail-events-more",
                        children: t('clinic.events.more')
                    })
                }) : null
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                size: 40,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: t('clinic.events.empty.title'),
            description: t('clinic.events.empty.desc')
        })
    });
}
function $bf76e55deb271988$export$a70158f3e707e82c({ clinic: clinic }) {
    const { t: t, formatDate: formatDate, locale: locale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const copyId = async ()=>{
        try {
            await navigator.clipboard.writeText(clinic.id);
            toast.success(t('common.value.copied'));
        } catch  {
        // A clipboard the browser refuses is not an error worth a red banner: the
        // id is on screen and selectable.
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-5",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                title: t('clinic.rail.infoTitle'),
                icon: (0, $e325251f2797f6cf$export$2e2bcd8739ae039),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "grid grid-cols-2 gap-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                                label: t('clinic.fields.type'),
                                value: clinic.clinicType || t('common.value.none')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                                label: t('clinic.fields.phone'),
                                value: (0, $412e1a8a99c19c1a$exports).forDisplay(clinic.officePhone) || t('common.value.none'),
                                ltr: !!clinic.officePhone
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                                label: t('clinic.fields.created'),
                                value: clinic.createdAt ? formatDate(clinic.createdAt) : t('common.value.none')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                                label: t('clinic.fields.registry'),
                                value: clinic.active === false ? t('clinics.inactive') : t('common.value.yes')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf76e55deb271988$export$a455218a85c89869, {
                                label: t('clinic.fields.currency'),
                                value: (0, $7df21990c7b31bb5$export$a77493cee3770d44)(clinic.currency, {
                                    t: t,
                                    locale: locale
                                }),
                                testId: "detail-currency"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-1 flex items-center gap-2 border-t border-border pt-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-xs text-muted-foreground",
                                children: t('clinic.fields.id')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                className: "min-w-0 flex-1 truncate text-[11px] text-muted-foreground",
                                children: clinic.id
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 32,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                label: t('clinic.rail.copyId'),
                                onClick: copyId,
                                "data-testid": "detail-copy-id"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                title: t('clinic.rail.playbookTitle'),
                icon: (0, $e17c725e7c863883$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "flex flex-col gap-2.5 text-xs leading-6 text-muted-foreground",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('clinic.rail.playbookRenew')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('clinic.rail.playbookOverride')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            children: t('clinic.rail.playbookSuspend')
                        })
                    ]
                })
            })
        ]
    });
}


const $1e0e0edbd3055fc4$export$9bc44cb3c6e7ed70 = 100000;
const $1e0e0edbd3055fc4$var$NOTE_MAX = 500;
/** One id per grant attempt; the BFF turns it into the wallet's `admin-grant:<uuid>`. */ function $1e0e0edbd3055fc4$var$newRequestId() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    const b = globalThis.crypto.getRandomValues(new Uint8Array(16));
    b[6] = b[6] & 0x0f | 0x40;
    b[8] = b[8] & 0x3f | 0x80;
    const h = [
        ...b
    ].map((x)=>x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
function $1e0e0edbd3055fc4$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, clinic: clinic, pending: pending, error: error, onSubmit: onSubmit }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [amount, setAmount] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirming, setConfirming] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [requestId, setRequestId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setAmount('');
        setNote('');
        setConfirming(false);
    }, [
        open
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setRequestId($1e0e0edbd3055fc4$var$newRequestId());
    }, [
        open,
        amount
    ]);
    const value = Number(amount);
    const valid = /^\d+$/.test(amount) && value >= 1 && value <= $1e0e0edbd3055fc4$export$9bc44cb3c6e7ed70;
    const invalid = amount !== '' && !valid;
    const max = formatNumber($1e0e0edbd3055fc4$export$9bc44cb3c6e7ed70);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
                open: open,
                onOpenChange: onOpenChange,
                title: t('clinic.dialogs.grantCredits.title'),
                error: error,
                pending: pending,
                dirty: !!(amount || note),
                submitLabel: t('clinic.dialogs.grantCredits.submit'),
                submitDisabled: !valid,
                onSubmit: ()=>setConfirming(true),
                footerNote: t('clinic.dialogs.grantCredits.helper'),
                "data-testid": "detail-grant-credits-dialog",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                        "data-testid": "detail-grant-recipient",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf76e55deb271988$export$a455218a85c89869), {
                            label: t('clinic.dialogs.grantCredits.recipient'),
                            value: t('clinic.dialogs.grantCredits.recipientValue', {
                                name: clinic.name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "detail-grant-amount",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                            label: t('clinic.dialogs.grantCredits.amount'),
                            required: true,
                            value: amount,
                            onChange: (e)=>setAmount((e.target?.value ?? e).replace(/\D/g, '')),
                            unit: t('common.units.parseh'),
                            helperText: t('clinic.dialogs.grantCredits.amountHint', {
                                max: max
                            }),
                            error: invalid ? t('clinic.dialogs.grantCredits.amountRange', {
                                max: max
                            }) : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('clinic.dialogs.grantCredits.note'),
                        value: note,
                        onChange: (e)=>setNote(e.target?.value ?? e),
                        placeholder: t('clinic.dialogs.grantCredits.notePlaceholder'),
                        maxLength: $1e0e0edbd3055fc4$var$NOTE_MAX,
                        showCount: true,
                        rows: 2,
                        "data-testid": "detail-grant-note"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirming,
                onOpenChange: setConfirming,
                title: t('clinic.dialogs.grantCredits.confirmTitle', {
                    amount: valid ? formatNumber(value) : ''
                }),
                description: t('clinic.dialogs.grantCredits.confirmBody', {
                    name: clinic.name
                }),
                confirmLabel: t('clinic.dialogs.grantCredits.confirm'),
                cancelLabel: t('common.actions.cancel'),
                loading: pending,
                onConfirm: ()=>{
                    setConfirming(false);
                    onSubmit({
                        amount: value,
                        note: note.trim() || null,
                        requestId: requestId
                    });
                },
                "data-testid": "detail-grant-credits-confirm"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c2a827dd5c2d433$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Pencil", [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
]);




/**
 * The vocabulary of «کشورها» (PM-0218, docs/country-config/CONTRACT.md §2), in
 * one place.
 *
 * Fields are the admin BFF's GraphQL names (`countries.js` typeDefs), which are
 * clinicmanagement's column names in camelCase. The closed vocabularies MIRROR
 * the service's (`app/domain/country_profile.py`): a value outside them is
 * refused there with INVALID_COUNTRY_PROFILE, so offering it here would only
 * produce an error. `PAYROLL_PROFILES` is the key accounting holds payroll
 * rules for; a row naming another key still SHOWS it. `INSURANCE_CATALOGS` is
 * only the fallback: a profile's insurance catalogue offers its own country and
 * every country with insurer rows (PM-0246, `insuranceCatalogChoices`), and
 * these two when the catalogue cannot be read.
 */ const $258fced26b1fac84$export$dec9af6fc3e9284c = '*';
const $258fced26b1fac84$export$3367dc0acae8916f = 'fallback';
const $258fced26b1fac84$export$b65397eb57a7a91c = (param)=>param === $258fced26b1fac84$export$3367dc0acae8916f ? $258fced26b1fac84$export$dec9af6fc3e9284c : String(param || '').toUpperCase();
const $258fced26b1fac84$export$ff462d906c0130ec = (country)=>country === $258fced26b1fac84$export$dec9af6fc3e9284c ? $258fced26b1fac84$export$3367dc0acae8916f : country;
const $258fced26b1fac84$export$fee178fc4e5672d5 = (country)=>`/countries/${encodeURIComponent($258fced26b1fac84$export$ff462d906c0130ec(country))}`;
const $258fced26b1fac84$export$ac2186fe7fdccc71 = [
    'jalali',
    'gregory'
];
const $258fced26b1fac84$export$92a974607f6f02fc = [
    'IR',
    'GENERIC'
];
const $258fced26b1fac84$export$cac5facca8a1c388 = [
    'iran_provinces',
    'free_text'
];
const $258fced26b1fac84$export$2c8bdfbb79f9fa0f = [
    'opnaji'
];
const $258fced26b1fac84$export$b41bce00b667b66a = [
    'irimc'
];
const $258fced26b1fac84$export$423d56f651d7c4b = [
    'kavenegar'
];
const $258fced26b1fac84$export$6ee20ab36d7d5eaf = [
    'sms',
    'bale',
    'whatsapp'
];
const $258fced26b1fac84$export$149bfcf9ab6b6b62 = [
    'sepehr',
    'zarinpal',
    'bazaar'
];
const $258fced26b1fac84$export$dc939b23be22f593 = [
    'finnotech_inquiry',
    'sepehr_bill',
    'sepehr_store'
];
const $258fced26b1fac84$export$88b47174dd6cd9c = [
    'IR'
];
const $258fced26b1fac84$export$d7e8642240c28acd = [
    'IR',
    'IQ'
];
const $258fced26b1fac84$export$2092376fd002e13 = [
    'fa',
    'ar',
    'en',
    'fr',
    'de'
];
const $258fced26b1fac84$export$ecc24ef5795d74f8 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
const $258fced26b1fac84$export$4afc387281808150 = 22;
const $258fced26b1fac84$export$5ec9e4b7f6cc29c2 = {
    paymentRails: "PM-0211 \xb7 PM-0090",
    weekStart: null,
    calendar: 'PM-0068',
    printCalendar: 'D12',
    printLanguage: 'D12'
};
const $258fced26b1fac84$export$deb2cb864df03bb = (field)=>Object.prototype.hasOwnProperty.call($258fced26b1fac84$export$5ec9e4b7f6cc29c2, field);
const $258fced26b1fac84$export$ea25b1e146708fcf = [
    'nationalDialCode',
    'nationalIdRule',
    'addressModel',
    'weekendDays',
    'defaultTimezone',
    'defaultCurrency'
];
const $258fced26b1fac84$export$77dd5611192b79b9 = [
    {
        key: 'locale',
        fields: [
            {
                field: 'defaultLanguage',
                kind: 'default',
                type: 'language'
            },
            {
                field: 'calendar',
                kind: 'default',
                type: 'enum',
                options: $258fced26b1fac84$export$ac2186fe7fdccc71
            },
            {
                field: 'weekStart',
                kind: 'default',
                type: 'weekday'
            },
            {
                field: 'weekendDays',
                kind: 'default',
                type: 'weekdays'
            },
            {
                field: 'defaultCurrency',
                kind: 'default',
                type: 'currency'
            },
            {
                field: 'defaultTimezone',
                kind: 'default',
                type: 'timezone'
            }
        ]
    },
    {
        key: 'identity',
        fields: [
            {
                field: 'nationalIdRule',
                kind: 'default',
                type: 'enum',
                options: $258fced26b1fac84$export$92a974607f6f02fc
            },
            {
                field: 'nationalDialCode',
                kind: 'default',
                type: 'dialCode'
            },
            {
                field: 'addressModel',
                kind: 'default',
                type: 'enum',
                options: $258fced26b1fac84$export$cac5facca8a1c388
            },
            {
                field: 'mapView',
                kind: 'default',
                type: 'mapView'
            }
        ]
    },
    {
        key: 'capabilities',
        fields: [
            {
                field: 'erxProvider',
                column: 'erx_provider',
                kind: 'capability',
                type: 'enum',
                options: $258fced26b1fac84$export$2c8bdfbb79f9fa0f
            },
            {
                field: 'councilRegistry',
                column: 'council_registry',
                kind: 'capability',
                type: 'enum',
                options: $258fced26b1fac84$export$b41bce00b667b66a
            },
            {
                field: 'smsProvider',
                column: 'sms_provider',
                kind: 'capability',
                type: 'enum',
                options: $258fced26b1fac84$export$423d56f651d7c4b
            },
            {
                field: 'messagingChannels',
                column: 'messaging_channels',
                kind: 'capability',
                type: 'list',
                options: $258fced26b1fac84$export$6ee20ab36d7d5eaf
            },
            {
                field: 'paymentRails',
                column: 'payment_rails',
                kind: 'capability',
                type: 'list',
                options: $258fced26b1fac84$export$149bfcf9ab6b6b62
            },
            {
                field: 'billServices',
                column: 'bill_services',
                kind: 'capability',
                type: 'list',
                options: $258fced26b1fac84$export$dc939b23be22f593
            },
            {
                field: 'payrollProfile',
                column: 'payroll_profile',
                kind: 'capability',
                type: 'key',
                options: $258fced26b1fac84$export$88b47174dd6cd9c
            },
            {
                field: 'insuranceCatalog',
                column: 'insurance_catalog',
                kind: 'capability',
                type: 'key',
                options: $258fced26b1fac84$export$d7e8642240c28acd
            }
        ]
    },
    {
        key: 'print',
        fields: [
            {
                field: 'printCalendar',
                kind: 'default',
                type: 'enum',
                options: $258fced26b1fac84$export$ac2186fe7fdccc71
            },
            {
                field: 'printLanguage',
                kind: 'default',
                type: 'language'
            }
        ]
    }
];
const $258fced26b1fac84$export$9b45d48f8f4c8ce8 = $258fced26b1fac84$export$77dd5611192b79b9.flatMap((g)=>g.fields);
const $258fced26b1fac84$export$85405247c394b565 = $258fced26b1fac84$export$9b45d48f8f4c8ce8.filter((f)=>f.kind === 'capability');
const $258fced26b1fac84$export$4e5c541dacaddeec = (field)=>$258fced26b1fac84$export$9b45d48f8f4c8ce8.find((f)=>f.field === field) || null;
const $258fced26b1fac84$export$5d3ca1c99371f9d2 = (field)=>field.replace(/[A-Z]/g, (c)=>`_${c.toLowerCase()}`);
const $258fced26b1fac84$export$1abec3cbd5f1097f = (column)=>String(column).replace(/_([a-z])/g, (_, c)=>c.toUpperCase());
const $258fced26b1fac84$export$66fec3d7c7ee3b16 = [
    {
        field: 'erxEnabled',
        takes: [
            'erxProvider'
        ]
    },
    {
        field: 'smsEnabled',
        takes: [
            'smsProvider',
            'messagingChannels'
        ]
    },
    {
        field: 'insuranceEnabled',
        takes: [
            'insuranceCatalog'
        ]
    }
];
const $258fced26b1fac84$export$aa99e332cd733a0d = /^[a-z][a-z0-9_-]{1,39}$/;
const $258fced26b1fac84$export$fadcbd0571ba7f6c = 40;
const $258fced26b1fac84$export$1e3756bae5ae7aad = [
    'fa',
    'en',
    'ar',
    'fr',
    'de'
];
const $258fced26b1fac84$export$1813a36678aead02 = [
    'fa',
    'en'
];
const $258fced26b1fac84$export$6c0749a97386cf4b = 120;
const $258fced26b1fac84$export$22a434d7937a56fb = 120;
const $258fced26b1fac84$export$9bb00a937a9c35c4 = 50;
const $258fced26b1fac84$export$cc0a61e874d4c05a = [
    'basic',
    'supplementary'
];
const $258fced26b1fac84$export$a56e7fa6d9a6b884 = {
    IR: [
        'tamin',
        'salamat',
        'esakhad'
    ]
};
const $258fced26b1fac84$export$7c23c5ff831388b9 = {
    IR: [
        'tamin'
    ]
};


/**
 * Every GraphQL document «کشورها» sends, built against the contract in
 * `parsina.bff.admin/src/graphql/typeDefs/countries.js`. One file, so a
 * contract change is a diff against one place and a test can match a call by
 * its operation name.
 *
 * NULL is null on every profile field: a default "follows *", a capability is
 * none; `weekendDays: []` is a stored "no weekend".
 */ const $e710da2f947a4ef7$export$40990cfbf62fff64 = `
  country defaultLanguage calendar weekStart weekendDays defaultCurrency defaultTimezone
  nationalIdRule nationalDialCode addressModel mapView { lat lon zoom } printCalendar printLanguage
  erxProvider councilRegistry smsProvider messagingChannels paymentRails billServices
  payrollProfile insuranceCatalog updatedBy updatedAt unsetFields
`;
const $e710da2f947a4ef7$var$DEPLOYMENT_FIELDS = 'deployment { market ceilings { capability iranianValues offHere } }';
const $e710da2f947a4ef7$export$fbf2b21922819b9d = `
  query CountryProfiles {
    countryProfiles { ${$e710da2f947a4ef7$var$DEPLOYMENT_FIELDS} editorEnabled profiles { ${$e710da2f947a4ef7$export$40990cfbf62fff64} } }
  }
`;
const $e710da2f947a4ef7$export$7bfe1ff81124aa2b = `
  query CountryProfile($country: String!) {
    countryProfile(country: $country) {
      country found ${$e710da2f947a4ef7$var$DEPLOYMENT_FIELDS}
      row { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
      merged { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
      fallback { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
    }
  }
`;
const $e710da2f947a4ef7$export$405b63fbe63a37e1 = `
  query CountryProfileChanges($country: String, $limit: Int) {
    countryProfileChanges(country: $country, limit: $limit) {
      id country changedBy changedAt created before after changedFields note
    }
  }
`;
const $e710da2f947a4ef7$export$97f6dfd7010bc17a = `
  mutation UpdateCountryProfile(
    $country: String!, $changes: CountryProfileChangesInput!, $note: String!,
    $expectedUpdatedAt: String, $confirm: [String!]
  ) {
    updateCountryProfile(
      country: $country, changes: $changes, note: $note,
      expectedUpdatedAt: $expectedUpdatedAt, confirm: $confirm
    ) { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
  }
`;
const $e710da2f947a4ef7$export$50cc98b45b741128 = `
  mutation CreateCountryProfile($country: String!, $template: String, $note: String!) {
    createCountryProfile(country: $country, template: $template, note: $note) { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
  }
`;
const $e710da2f947a4ef7$var$INSURER_FIELDS = `
  id country nameFa nameEn names { locale name } kind aliases isActive isSelfPay
  registryCode verifyProvider sortOrder updatedBy updatedAt
`;
const $e710da2f947a4ef7$export$a57f29a8b9ad7075 = `
  query CountryInsurers($country: String, $includeInactive: Boolean) {
    countryInsurers(country: $country, includeInactive: $includeInactive) {
      configured country editorEnabled
      insurers { ${$e710da2f947a4ef7$var$INSURER_FIELDS} }
    }
  }
`;
const $e710da2f947a4ef7$export$cc432424fa2f5451 = `
  query InsurerCatalogCountries {
    countryInsurers(includeInactive: true) { configured insurers { country isSelfPay } }
  }
`;
const $e710da2f947a4ef7$export$9af6c654c0f40355 = `
  mutation CreateInsurer($input: InsurerInput!, $note: String!) {
    createInsurer(input: $input, note: $note) { ${$e710da2f947a4ef7$var$INSURER_FIELDS} }
  }
`;
const $e710da2f947a4ef7$export$9d31a091427e8e4a = `
  mutation UpdateInsurer($id: ID!, $input: InsurerInput!, $note: String!, $expectedUpdatedAt: String) {
    updateInsurer(id: $id, input: $input, note: $note, expectedUpdatedAt: $expectedUpdatedAt) { ${$e710da2f947a4ef7$var$INSURER_FIELDS} }
  }
`;
const $e710da2f947a4ef7$export$7e92d2b91cf1ac4e = `
  query InsurerChanges($insurerId: ID, $limit: Int) {
    insurerChanges(insurerId: $insurerId, limit: $limit) {
      insurerId changedBy changedAt created before after changedFields note
    }
  }
`;
const $e710da2f947a4ef7$var$SETTINGS_FIELDS = `
  clinicId erxEnabled smsEnabled insuranceEnabled mohmeOrgId universityId calendar updatedBy updatedAt
`;
const $e710da2f947a4ef7$var$CLINIC_VIEW_FIELDS = `
  clinicId country profileFound ${$e710da2f947a4ef7$var$DEPLOYMENT_FIELDS}
  countryProfile { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
  effective { ${$e710da2f947a4ef7$export$40990cfbf62fff64} }
  settings { ${$e710da2f947a4ef7$var$SETTINGS_FIELDS} }
  history { id actor at note before after changedFields }
`;
const $e710da2f947a4ef7$export$38f8409d7c80516d = `
  query ClinicCountrySettings($clinicId: ID!) {
    clinicCountrySettings(clinicId: $clinicId) { ${$e710da2f947a4ef7$var$CLINIC_VIEW_FIELDS} }
  }
`;
const $e710da2f947a4ef7$export$9bdeb57e068a4aa4 = `
  mutation SetClinicCountrySettings(
    $clinicId: ID!, $changes: ClinicCountrySettingsChangesInput!, $note: String!, $expectedUpdatedAt: String
  ) {
    setClinicCountrySettings(
      clinicId: $clinicId, changes: $changes, note: $note, expectedUpdatedAt: $expectedUpdatedAt
    ) {
      settings { ${$e710da2f947a4ef7$var$SETTINGS_FIELDS} }
      view { ${$e710da2f947a4ef7$var$CLINIC_VIEW_FIELDS} }
    }
  }
`;




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4e587283309fc771$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShieldHalf", [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "M12 22V2",
            key: "zs6s6o"
        }
    ]
]);







/**
 * The pure half of «کشورها» (PM-0218): what a column of a country profile SAYS,
 * what an edit CHANGES, and what a save SWITCHES OFF. No React and no `t`, so
 * every rule here is tested without rendering.
 *
 * The rules (docs/country-config/CONTRACT.md §2, REGISTRY-PROTO.md §3):
 *   • a DEFAULT column that is NULL follows `*`; NULL in `*` itself is whatever
 *     the column's consumer does with no value — for some that is today, for the
 *     dial code it is "a number must carry +" (the screen words each one).
 *     `weekendDays` is the one default list, and a stored [] there is "no
 *     weekend", not "follows *";
 *   • a CAPABILITY is authoritative: NULL or empty is NONE, never `*`'s;
 *   • an edit sends only the columns it changed, with the `updatedAt` it loaded:
 *     the BFF re-reads the row and sends the full replace, and refuses a row that
 *     moved meanwhile — so the second of two operators gets CONFLICT and
 *     re-applies, rather than silently undoing the first;
 *   • a save that changes what clinics DO today — a capability taken away, a
 *     gated default cleared or changed — is confirmed item by item, and the BFF
 *     refuses it otherwise (`confirmationsFor`).
 */ 

const $9e7bf86d7571a736$export$630801d484da15df = (v)=>v === null || v === undefined;
const $9e7bf86d7571a736$var$isEmptyList = (v)=>Array.isArray(v) && v.length === 0;
function $9e7bf86d7571a736$export$a5256796260dc47d(spec, row, fallback = null) {
    const v = row ? row[spec.field] : null;
    if (spec.kind === 'capability') return $9e7bf86d7571a736$export$630801d484da15df(v) || $9e7bf86d7571a736$var$isEmptyList(v) ? {
        state: 'none'
    } : {
        state: 'value',
        value: v
    };
    if (!$9e7bf86d7571a736$export$630801d484da15df(v)) return {
        state: 'value',
        value: v
    };
    if (!row || row.country === (0, $258fced26b1fac84$export$dec9af6fc3e9284c) || !fallback) return {
        state: 'serviceDefault'
    };
    const resolved = fallback[spec.field];
    return {
        state: 'follows',
        resolved: $9e7bf86d7571a736$export$630801d484da15df(resolved) ? null : resolved
    };
}
function $9e7bf86d7571a736$export$4f96a5307f7f7192(spec, profile) {
    return $9e7bf86d7571a736$export$a5256796260dc47d(spec, profile ? {
        ...profile,
        country: (0, $258fced26b1fac84$export$dec9af6fc3e9284c)
    } : null, null);
}
// ── the editor ────────────────────────────────────────────────────────────────
const $9e7bf86d7571a736$var$STRING_TYPES = [
    'enum',
    'language',
    'currency',
    'timezone',
    'dialCode',
    'key'
];
function $9e7bf86d7571a736$export$99cf9241a89a8991(text) {
    return (0, $c53f9539af19d960$export$e53ee9755c8a3679)(String(text ?? '').trim()).replace(/[\u066B,]/g, '.').replace(/[\u2212\u2013]/g, '-');
}
function $9e7bf86d7571a736$export$793bbffccc2934d9(fields, row) {
    const draft = {};
    for (const spec of fields){
        const v = row ? row[spec.field] : null;
        if (spec.type === 'weekdays') draft[spec.field] = {
            follow: $9e7bf86d7571a736$export$630801d484da15df(v),
            days: Array.isArray(v) ? [
                ...v
            ] : []
        };
        else if (spec.type === 'mapView') draft[spec.field] = $9e7bf86d7571a736$export$630801d484da15df(v) ? {
            follow: true,
            lat: '',
            lon: '',
            zoom: ''
        } : {
            follow: false,
            lat: String(v.lat),
            lon: String(v.lon),
            zoom: String(v.zoom)
        };
        else if (spec.type === 'list') draft[spec.field] = Array.isArray(v) ? [
            ...v
        ] : [];
        else if (spec.type === 'weekday') draft[spec.field] = $9e7bf86d7571a736$export$630801d484da15df(v) ? '' : String(v);
        else draft[spec.field] = $9e7bf86d7571a736$export$630801d484da15df(v) ? '' : String(v);
    }
    return draft;
}
function $9e7bf86d7571a736$export$7382f6d93b8122b1(spec, d) {
    if (spec.type === 'weekdays') return d.follow ? null : [
        ...new Set(d.days.map(Number))
    ].sort((a, b)=>a - b);
    if (spec.type === 'mapView') {
        if (d.follow) return null;
        return {
            lat: Number($9e7bf86d7571a736$export$99cf9241a89a8991(d.lat)),
            lon: Number($9e7bf86d7571a736$export$99cf9241a89a8991(d.lon)),
            zoom: Number($9e7bf86d7571a736$export$99cf9241a89a8991(d.zoom))
        };
    }
    if (spec.type === 'list') return (spec.options || []).filter((o)=>d.includes(o)).concat(d.filter((o)=>!(spec.options || []).includes(o)));
    if (spec.type === 'weekday') return d === '' ? null : Number(d);
    // A dial code typed in Persian or Arabic-Indic digits is the same digits.
    const s = (spec.type === 'dialCode' ? (0, $c53f9539af19d960$export$e53ee9755c8a3679)(String(d ?? '')) : String(d ?? '')).trim();
    return s === '' ? null : s;
}
function $9e7bf86d7571a736$export$eedc72592d98eead(spec, a, b) {
    if (spec.type === 'list') {
        const x = new Set(a || []);
        const y = new Set(b || []);
        return x.size === y.size && [
            ...x
        ].every((v)=>y.has(v));
    }
    if ($9e7bf86d7571a736$export$630801d484da15df(a) || $9e7bf86d7571a736$export$630801d484da15df(b)) return $9e7bf86d7571a736$export$630801d484da15df(a) && $9e7bf86d7571a736$export$630801d484da15df(b);
    if (spec.type === 'weekdays') return [
        ...a
    ].sort().join(',') === [
        ...b
    ].sort().join(',');
    if (spec.type === 'mapView') return a.lat === b.lat && a.lon === b.lon && a.zoom === b.zoom;
    return String(a) === String(b);
}
function $9e7bf86d7571a736$export$50e9395c948a8655(fields, draft, row) {
    const changes = {};
    for (const spec of fields){
        const next = $9e7bf86d7571a736$export$7382f6d93b8122b1(spec, draft[spec.field]);
        if (!$9e7bf86d7571a736$export$eedc72592d98eead(spec, row ? row[spec.field] : null, next)) changes[spec.field] = next;
    }
    return changes;
}
const $9e7bf86d7571a736$var$DIAL = /^[1-9][0-9]{0,2}$/;
const $9e7bf86d7571a736$var$LANGUAGE = /^[a-z]{2,3}$/;
const $9e7bf86d7571a736$var$CURRENCY = /^[A-Z]{3}$/;
function $9e7bf86d7571a736$export$8896c52d11774664(zone) {
    try {
        // eslint-disable-next-line no-new
        new Intl.DateTimeFormat('en-US', {
            timeZone: zone
        });
        return true;
    } catch  {
        return false;
    }
}
function $9e7bf86d7571a736$export$23bb27c41a7ad236(fields, draft) {
    const errors = {};
    for (const spec of fields){
        const d = draft[spec.field];
        if (spec.type === 'mapView') {
            if (d.follow) continue;
            const lat = Number($9e7bf86d7571a736$export$99cf9241a89a8991(d.lat));
            const lon = Number($9e7bf86d7571a736$export$99cf9241a89a8991(d.lon));
            const zoom = Number($9e7bf86d7571a736$export$99cf9241a89a8991(d.zoom));
            const bad = [
                d.lat,
                d.lon,
                d.zoom
            ].some((x)=>String(x ?? '').trim() === '') || !Number.isFinite(lat) || lat < -90 || lat > 90 || !Number.isFinite(lon) || lon < -180 || lon > 180 || !Number.isInteger(zoom) || zoom < 0 || zoom > (0, $258fced26b1fac84$export$4afc387281808150);
            if (bad) errors[spec.field] = 'mapView';
            continue;
        }
        if (spec.type === 'weekdays') {
            // Seven days off is no weekend at all — the subscription reads it as today's rule.
            if (!d.follow && new Set(d.days.map(Number)).size >= 7) errors[spec.field] = 'weekendAll';
            continue;
        }
        if (!$9e7bf86d7571a736$var$STRING_TYPES.includes(spec.type)) continue;
        const v = $9e7bf86d7571a736$export$7382f6d93b8122b1(spec, d);
        if (v === null) continue;
        if (spec.type === 'dialCode' && !$9e7bf86d7571a736$var$DIAL.test(v)) errors[spec.field] = 'dialCode';
        if (spec.type === 'timezone' && !$9e7bf86d7571a736$export$8896c52d11774664(v)) errors[spec.field] = 'timezone';
        if (spec.type === 'language' && !$9e7bf86d7571a736$var$LANGUAGE.test(v)) errors[spec.field] = 'language';
        if (spec.type === 'currency' && !$9e7bf86d7571a736$var$CURRENCY.test(v)) errors[spec.field] = 'currency';
    }
    return errors;
}
function $9e7bf86d7571a736$export$4b4be54f414be5e3(v) {
    if ($9e7bf86d7571a736$export$630801d484da15df(v)) return 'null';
    if (Array.isArray(v)) return v.join(',');
    if (typeof v === 'object') return `${v.lat},${v.lon},${v.zoom}`;
    return String(v);
}
function $9e7bf86d7571a736$export$278c903d87d48884(row, changes) {
    const out = [];
    for (const spec of (0, $258fced26b1fac84$export$85405247c394b565)){
        if (!changes || !Object.prototype.hasOwnProperty.call(changes, spec.field)) continue;
        const was = row ? row[spec.field] : null;
        const now = changes[spec.field];
        const lost = Array.isArray(was) ? was.filter((v)=>!(Array.isArray(now) ? now : []).includes(v)) : !$9e7bf86d7571a736$export$630801d484da15df(was) && was !== now ? [
            was
        ] : [];
        const column = spec.column || (0, $258fced26b1fac84$export$5d3ca1c99371f9d2)(spec.field);
        for (const value of lost)out.push({
            field: spec.field,
            column: column,
            value: value,
            token: `${column}:${value}`
        });
    }
    return out;
}
function $9e7bf86d7571a736$export$8bbecf04b3884aba(row, changes) {
    const out = [];
    for (const field of (0, $258fced26b1fac84$export$ea25b1e146708fcf)){
        if (!changes || !Object.prototype.hasOwnProperty.call(changes, field)) continue;
        const from = row ? row[field] : null;
        const to = changes[field];
        if ($9e7bf86d7571a736$export$4b4be54f414be5e3(from) === $9e7bf86d7571a736$export$4b4be54f414be5e3(to) && $9e7bf86d7571a736$export$630801d484da15df(from) === $9e7bf86d7571a736$export$630801d484da15df(to)) continue;
        const column = (0, $258fced26b1fac84$export$5d3ca1c99371f9d2)(field);
        out.push({
            field: field,
            column: column,
            from: $9e7bf86d7571a736$export$630801d484da15df(from) ? null : from,
            to: $9e7bf86d7571a736$export$630801d484da15df(to) ? null : to,
            token: `${column}:${$9e7bf86d7571a736$export$4b4be54f414be5e3(from)}`
        });
    }
    return out;
}
function $9e7bf86d7571a736$export$78df80f7338414da(row, changes) {
    return [
        ...$9e7bf86d7571a736$export$278c903d87d48884(row, changes).map((r)=>({
                ...r,
                kind: 'removal'
            })),
        ...$9e7bf86d7571a736$export$8bbecf04b3884aba(row, changes).map((c)=>({
                ...c,
                kind: 'change',
                spec: (0, $258fced26b1fac84$export$4e5c541dacaddeec)(c.field)
            }))
    ];
}
function $9e7bf86d7571a736$export$665dab2a2290d7e9(deployment, spec) {
    const column = spec.column || (0, $258fced26b1fac84$export$5d3ca1c99371f9d2)(spec.field);
    const found = (deployment?.ceilings || []).find((c)=>c.capability === column);
    return {
        iranianValues: found?.iranianValues || [],
        offHere: found?.offHere || []
    };
}
const $9e7bf86d7571a736$export$48931898a86c8e6f = (v)=>$9e7bf86d7571a736$export$630801d484da15df(v) ? [] : Array.isArray(v) ? v : [
        v
    ];
function $9e7bf86d7571a736$export$ef988fc79a4638c3(list) {
    if (!list?.configured) return null;
    return [
        ...new Set((list.insurers || []).filter((r)=>!r.isSelfPay && r.country).map((r)=>r.country))
    ];
}
function $9e7bf86d7571a736$export$2e4d7c0f6f8a921(country, insurerCountries, stored) {
    const own = country && country !== (0, $258fced26b1fac84$export$dec9af6fc3e9284c) ? country : null;
    const others = new Set([
        ...insurerCountries ?? (0, $258fced26b1fac84$export$d7e8642240c28acd),
        ...stored ? [
            stored
        ] : []
    ]);
    if (own) others.delete(own);
    return [
        ...own ? [
            own
        ] : [],
        ...[
            ...others
        ].sort()
    ];
}


/**
 * The display half of «کشورها», shared by the list, the record, the editor and
 * the clinic card — so a column reads the same wherever it appears.
 */ /** One Intl.DisplayNames per locale and type; a code ICU does not know is echoed as itself. */ function $32b5ef4e46f306ee$var$useDisplayNames(type) {
    const { locale: locale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        try {
            return new Intl.DisplayNames([
                (0, $94f36eaf2deb686d$export$57270fb1f2649979)(locale).intl
            ], {
                type: type,
                fallback: 'code'
            });
        } catch  {
            return null;
        }
    }, [
        locale,
        type
    ]);
}
const $32b5ef4e46f306ee$var$nameOr = (names, code)=>{
    try {
        return names?.of(code) || code;
    } catch  {
        return code;
    }
};
function $32b5ef4e46f306ee$export$c41202f92c8ce3ea() {
    const { t: t, locale: locale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const names = $32b5ef4e46f306ee$var$useDisplayNames('region');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((code)=>{
        if (code === (0, $258fced26b1fac84$export$dec9af6fc3e9284c)) return t('countries.fallbackName');
        if (!code) return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
        const row = (0, $412e1a8a99c19c1a$exports).findByIso2?.(code);
        const kitName = row ? (0, $412e1a8a99c19c1a$exports).countryName?.(row, locale) : '';
        return kitName || $32b5ef4e46f306ee$var$nameOr(names, code);
    }, [
        names,
        t,
        locale
    ]);
}
function $32b5ef4e46f306ee$export$16715c2c372f7c05() {
    const names = $32b5ef4e46f306ee$var$useDisplayNames('region');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((code)=>{
        try {
            const name = names?.of(code);
            return !!name && name !== code;
        } catch  {
            return false;
        }
    }, [
        names
    ]);
}
function $32b5ef4e46f306ee$export$34a98f1791d1800e({ code: code }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: "font-mono text-xs text-muted-foreground",
        children: code
    });
}
const $32b5ef4e46f306ee$var$weekdayDate = (iso)=>new Date(Date.UTC(2024, 0, Number(iso), 12)); // 2024-01-01 was a Monday
/** Types whose value is an identifier — read left-to-right, never translated. */ const $32b5ef4e46f306ee$var$IDENTIFIER_TYPES = [
    'timezone',
    'dialCode',
    'key'
];
function $32b5ef4e46f306ee$export$7ce5199f876047a() {
    const { t: t, has: has, locale: locale, formatWeekday: formatWeekday, formatList: formatList } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const languages = $32b5ef4e46f306ee$var$useDisplayNames('language');
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((spec, value)=>{
        switch(spec.type){
            case 'language':
                return `${$32b5ef4e46f306ee$var$nameOr(languages, value)} (${value})`;
            case 'weekday':
                return formatWeekday($32b5ef4e46f306ee$var$weekdayDate(value));
            case 'weekdays':
                return value.length ? formatList(value.map((d)=>formatWeekday($32b5ef4e46f306ee$var$weekdayDate(d)))) : t('countries.state.noWeekend');
            case 'currency':
                return (0, $7df21990c7b31bb5$export$a77493cee3770d44)(value, {
                    t: t,
                    locale: locale
                });
            case 'dialCode':
                return `+${value}`;
            case 'mapView':
                return `${value.lat}, ${value.lon} \xb7 ${t('countries.values.zoom', {
                    zoom: value.zoom
                })}`;
            case 'timezone':
            case 'key':
                return String(value);
            default:
                {
                    const key = `countries.values.${spec.field}.${value}`;
                    return has(key) ? t(key) : String(value);
                }
        }
    }, [
        t,
        has,
        locale,
        formatWeekday,
        formatList,
        languages
    ]);
}
function $32b5ef4e46f306ee$export$f1145af01f1d77b7({ spec: spec, value: value }) {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const valueString = $32b5ef4e46f306ee$export$7ce5199f876047a();
    const island = (text)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
            ...(0, $c53f9539af19d960$export$3433559efc22d110),
            className: "font-mono text-[12px]",
            children: text
        });
    if ($32b5ef4e46f306ee$var$IDENTIFIER_TYPES.includes(spec.type)) return island(valueString(spec, value));
    if (spec.type === 'mapView') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            island(`${value.lat}, ${value.lon}`),
            " \xb7 ",
            t('countries.values.zoom', {
                zoom: value.zoom
            })
        ]
    });
    if (spec.type === 'enum' || spec.type === 'list') return has(`countries.values.${spec.field}.${value}`) ? valueString(spec, value) : island(String(value));
    return valueString(spec, value);
}
function $32b5ef4e46f306ee$export$94b87dfb202e46b9({ field: field }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!(0, $258fced26b1fac84$export$deb2cb864df03bb)(field)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "outline",
        className: "ms-1 whitespace-nowrap align-middle",
        title: (0, $258fced26b1fac84$export$5ec9e4b7f6cc29c2)[field] ? t('countries.state.notReadHint', {
            ref: (0, $258fced26b1fac84$export$5ec9e4b7f6cc29c2)[field]
        }) : t('countries.state.notReadHintRound'),
        "data-testid": `country-not-read-${field}`,
        children: t('countries.state.notRead')
    });
}
function $32b5ef4e46f306ee$export$cc60d6d36c1a0b3c({ spec: spec, value: value, deployment: deployment }) {
    const { t: t, formatList: formatList } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const valueString = $32b5ef4e46f306ee$export$7ce5199f876047a();
    const { offHere: offHere } = (0, $9e7bf86d7571a736$export$665dab2a2290d7e9)(deployment, spec);
    const off = (0, $9e7bf86d7571a736$export$48931898a86c8e6f)(value).filter((v)=>offHere.includes(v));
    if (off.length) // A STATUS, not an error: the warning chip, never red (DESIGN_SYSTEM §1.1).
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "warning",
        className: "inline-flex items-center gap-1",
        title: t('countries.ceiling.offHereHint'),
        "data-testid": `country-ceiling-off-${spec.field}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2dfa57d290a8089$export$2e2bcd8739ae039), {
                size: 12,
                "aria-hidden": true
            }),
            t('countries.ceiling.offHere', {
                values: formatList(off.map((v)=>valueString(spec, v)))
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex items-center gap-1 text-xs text-muted-foreground",
        title: t('countries.ceiling.envHint'),
        "data-testid": `country-ceiling-${spec.field}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e587283309fc771$export$2e2bcd8739ae039), {
                size: 12,
                "aria-hidden": true
            }),
            t('countries.ceiling.env')
        ]
    });
}
const $32b5ef4e46f306ee$export$f586a56a32a0accd = (t, field)=>t(`countries.nullMeans.${field}`);
function $32b5ef4e46f306ee$export$c6f10d457200e8c6({ spec: spec, row: row, fallback: fallback, merged: merged = false, deployment: deployment, testId: testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const said = merged ? (0, $9e7bf86d7571a736$export$4f96a5307f7f7192)(spec, row) : (0, $9e7bf86d7571a736$export$a5256796260dc47d)(spec, row, fallback);
    const id = testId || `country-value-${spec.field}`;
    if (said.state === 'none') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        "data-state": "none",
        "data-testid": id,
        children: t('countries.state.none')
    });
    if (said.state === 'serviceDefault') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        "data-state": "service-default",
        "data-testid": id,
        children: $32b5ef4e46f306ee$export$f586a56a32a0accd(t, spec.field)
    });
    if (said.state === 'follows') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        "data-state": "follows",
        "data-testid": id,
        children: said.resolved == null ? t('countries.state.followsNull', {
            meaning: $32b5ef4e46f306ee$export$f586a56a32a0accd(t, spec.field)
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                t('countries.state.follows'),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-foreground",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($32b5ef4e46f306ee$export$f1145af01f1d77b7, {
                        spec: spec,
                        value: said.resolved
                    })
                })
            ]
        })
    });
    const { offHere: offHere } = spec.kind === 'capability' ? (0, $9e7bf86d7571a736$export$665dab2a2290d7e9)(deployment, spec) : {
        offHere: []
    };
    if (spec.type === 'list') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "flex flex-wrap gap-1",
        "data-state": "value",
        "data-testid": id,
        children: said.value.map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                variant: "outline",
                className: offHere.includes(v) ? 'line-through opacity-70' : undefined,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($32b5ef4e46f306ee$export$f1145af01f1d77b7, {
                    spec: spec,
                    value: v
                })
            }, v))
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: offHere.includes(said.value) ? 'line-through opacity-70' : undefined,
        "data-state": "value",
        "data-testid": id,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($32b5ef4e46f306ee$export$f1145af01f1d77b7, {
            spec: spec,
            value: said.value
        })
    });
}
function $32b5ef4e46f306ee$export$4768687337cb1384() {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((column)=>{
        const field = (0, $258fced26b1fac84$export$1abec3cbd5f1097f)(column);
        const key = `countries.fields.${field}`;
        return (0, $258fced26b1fac84$export$4e5c541dacaddeec)(field) && has(key) ? t(key) : column;
    }, [
        t,
        has
    ]);
}
function $32b5ef4e46f306ee$export$c3d2d38834f5b5cb({ by: by }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (by === 'seed') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        children: t('countries.seedActor')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f68e1d223f0d9b1$export$2e2bcd8739ae039), {
        actor: by
    });
}
const $32b5ef4e46f306ee$var$ERROR_KEYS = {
    EDITOR_DISABLED: 'countries.errors.editorDisabled',
    REGISTRY_NOT_DEPLOYED: 'countries.errors.registryNotDeployed',
    CONFLICT: 'countries.errors.conflict',
    NOTE_REQUIRED: 'countries.errors.noteRequired',
    CONFIRMATION_REQUIRED: 'countries.errors.confirmationRequired',
    INVALID_COUNTRY: 'countries.errors.invalidCountry',
    INVALID_COUNTRY_PROFILE: 'countries.errors.invalidProfile',
    INVALID_COUNTRY_SETTINGS: 'countries.errors.invalidSettings'
};
function $32b5ef4e46f306ee$export$7b930bacf3b706d8(err, t) {
    const code = err?.code;
    if (!$32b5ef4e46f306ee$var$ERROR_KEYS[code]) return (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(err, t);
    const detail = (code === 'INVALID_COUNTRY_PROFILE' || code === 'INVALID_COUNTRY_SETTINGS') && err?.message;
    if (!detail) return t($32b5ef4e46f306ee$var$ERROR_KEYS[code]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            t($32b5ef4e46f306ee$var$ERROR_KEYS[code]),
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                className: "font-mono text-[11px]",
                children: err.message
            })
        ]
    });
}
const $32b5ef4e46f306ee$var$INSURER_ERROR_KEYS = {
    INSURER_EDITOR_DISABLED: 'countries.insurers.errors.editorDisabled',
    NOT_FOUND: 'countries.insurers.errors.notFound',
    INVALID_INSURER: 'countries.insurers.errors.invalid',
    INSURER_RULE: 'countries.insurers.errors.rule',
    INSURER_IMMUTABLE: 'countries.insurers.errors.immutable',
    SELF_PAY_NOT_EDITABLE: 'countries.insurers.errors.selfPay',
    INVALID_COUNTRY: 'countries.errors.invalidCountry',
    NOTE_REQUIRED: 'countries.errors.noteRequired'
};
/** Refusals whose technical message names the field — shown after the sentence. */ const $32b5ef4e46f306ee$var$INSURER_DETAIL = [
    'INVALID_INSURER',
    'INSURER_RULE',
    'INSURER_IMMUTABLE'
];
function $32b5ef4e46f306ee$export$f3aa0376b22f8805(err, t, { creating: creating = false } = {}) {
    const code = err?.code;
    if (code === 'CONFLICT') return t(creating ? 'countries.insurers.errors.idTaken' : 'countries.insurers.errors.changed');
    if (!$32b5ef4e46f306ee$var$INSURER_ERROR_KEYS[code]) return (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(err, t);
    if (!$32b5ef4e46f306ee$var$INSURER_DETAIL.includes(code) || !err?.message) return t($32b5ef4e46f306ee$var$INSURER_ERROR_KEYS[code]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            t($32b5ef4e46f306ee$var$INSURER_ERROR_KEYS[code]),
            ' ',
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                className: "font-mono text-[11px]",
                children: err.message
            })
        ]
    });
}
function $32b5ef4e46f306ee$export$2d9f8e8c6b986160(insurer, locale) {
    if (!insurer) return '';
    const byLocale = Object.fromEntries((insurer.names || []).map((n)=>[
            n.locale,
            n.name
        ]));
    return byLocale[locale] || (locale === 'fa' ? insurer.nameFa : byLocale.en || insurer.nameEn) || insurer.nameFa || insurer.nameEn || insurer.id || '';
}




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");









const $dff16fd5ba545ec2$export$6556e5010b701a8b = 3;
const $dff16fd5ba545ec2$export$2daf5676b9ee9779 = 500;
function $dff16fd5ba545ec2$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, group: group, country: country, row: row, fallback: fallback, deployment: deployment, onSaved: onSaved }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const valueString = (0, $32b5ef4e46f306ee$export$7ce5199f876047a)();
    const columnLabel = (0, $32b5ef4e46f306ee$export$4768687337cb1384)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $9e7bf86d7571a736$export$793bbffccc2934d9)(group.fields, row));
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirming, setConfirming] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [acknowledged, setAcknowledged] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The countries with insurer rows; null = not read (yet, or at all).
    const [insurerCountries, setInsurerCountries] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // A fresh form every time it opens, from the row as it is NOW.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setDraft((0, $9e7bf86d7571a736$export$793bbffccc2934d9)(group.fields, row));
        setNote('');
        setError(null);
        setConfirming(null);
        setAcknowledged(false);
    }, [
        open,
        group,
        row
    ]);
    // `insuranceCatalog` offers the catalogues that exist (PM-0246), read when
    // the group that holds it opens; unreadable, it falls back to IR and IQ.
    const offersCatalog = group.fields.some((f)=>f.field === 'insuranceCatalog');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || !offersCatalog) return undefined;
        let live = true;
        setInsurerCountries(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$cc432424fa2f5451)).then((d)=>{
            if (live) setInsurerCountries((0, $9e7bf86d7571a736$export$ef988fc79a4638c3)(d?.countryInsurers));
        }).catch(()=>{
            if (live) setInsurerCountries(null);
        });
        return ()=>{
            live = false;
        };
    }, [
        open,
        offersCatalog
    ]);
    const isFallbackRow = country === (0, $258fced26b1fac84$export$dec9af6fc3e9284c);
    // The kit catalogue's calling code for this country, OFFERED beside an empty
    // dial-code field — one click fills it, nothing fills it silently.
    const dialSuggestion = isFallbackRow ? null : (0, $412e1a8a99c19c1a$exports).findByIso2?.(country)?.dial || null;
    const changes = (0, $9e7bf86d7571a736$export$50e9395c948a8655)(group.fields, draft, row);
    const changed = Object.keys(changes).length > 0;
    const fieldErrors = (0, $9e7bf86d7571a736$export$23bb27c41a7ad236)(group.fields, draft);
    const invalid = Object.keys(fieldErrors).length > 0;
    const trimmed = note.trim();
    const noteOk = trimmed.length >= $dff16fd5ba545ec2$export$6556e5010b701a8b && trimmed.length <= $dff16fd5ba545ec2$export$2daf5676b9ee9779;
    const groupName = t(`countries.groups.${group.key}`);
    const name = countryName(country);
    const set = (field, value)=>setDraft((d)=>({
                ...d,
                [field]: value
            }));
    /** What a NULL in this row means for one default: `*`'s value, or what the consumer does with none. */ const nullLabel = (spec)=>{
        if (isFallbackRow) return t('countries.edit.noValue', {
            meaning: (0, $32b5ef4e46f306ee$export$f586a56a32a0accd)(t, spec.field)
        });
        const resolved = fallback ? fallback[spec.field] : null;
        return (0, $9e7bf86d7571a736$export$630801d484da15df)(resolved) ? t('countries.edit.followNull', {
            meaning: (0, $32b5ef4e46f306ee$export$f586a56a32a0accd)(t, spec.field)
        }) : t('countries.edit.followValue', {
            value: valueString(spec, resolved)
        });
    };
    /** A value as the confirmation states it — NULL by what it then means. */ const stated = (spec, v)=>(0, $9e7bf86d7571a736$export$630801d484da15df)(v) ? nullLabel(spec) : valueString(spec, v);
    const save = async (confirmations)=>{
        setPending(true);
        setError(null);
        try {
            const res = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$97f6dfd7010bc17a), {
                country: country,
                changes: changes,
                note: trimmed,
                expectedUpdatedAt: row?.updatedAt ?? null,
                confirm: confirmations.map((c)=>c.token)
            });
            setConfirming(null);
            onOpenChange(false);
            toast.success(t('countries.edit.success', {
                group: groupName
            }));
            onSaved?.(res?.updateCountryProfile);
        } catch (e) {
            setConfirming(null);
            setError((0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t));
        } finally{
            setPending(false);
        }
    };
    const submit = ()=>{
        if (!changed || invalid || !noteOk || pending) return;
        const needed = (0, $9e7bf86d7571a736$export$78df80f7338414da)(row, changes);
        if (needed.length) {
            setAcknowledged(false);
            setConfirming(needed);
            return;
        }
        save([]);
    };
    const footerNote = !changed ? t('countries.edit.noChanges') : !noteOk ? t('countries.edit.noteNeeded') : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
                open: open,
                onOpenChange: onOpenChange,
                title: t('countries.edit.title', {
                    group: groupName,
                    country: name
                }),
                lead: group.key === 'capabilities' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "info",
                    "data-testid": "country-edit-ceiling",
                    children: t('countries.ceiling.intro')
                }) : null,
                error: error,
                pending: pending,
                dirty: changed || !!note,
                size: "lg",
                submitLabel: t('countries.edit.submit'),
                submitDisabled: !changed || invalid || !noteOk,
                onSubmit: submit,
                footerNote: footerNote,
                "data-testid": "country-edit",
                children: [
                    group.fields.map((spec)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dff16fd5ba545ec2$var$FieldControl, {
                            spec: spec,
                            value: draft[spec.field],
                            onChange: (v)=>set(spec.field, v),
                            nullLabel: spec.kind === 'capability' ? t('countries.state.none') : nullLabel(spec),
                            suggestion: spec.type === 'dialCode' ? dialSuggestion : null,
                            vocabulary: spec.field === 'insuranceCatalog' ? (0, $9e7bf86d7571a736$export$2e4d7c0f6f8a921)(country, insurerCountries, row ? row.insuranceCatalog : null) : undefined,
                            row: row,
                            deployment: deployment,
                            error: fieldErrors[spec.field] ? t(`countries.edit.invalid.${fieldErrors[spec.field]}`) : null,
                            disabled: pending
                        }, spec.field)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "country-edit-note",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                            label: t('countries.edit.note'),
                            required: true,
                            value: note,
                            onChange: (e)=>setNote(e.target?.value ?? e),
                            placeholder: t('countries.edit.notePlaceholder'),
                            helperText: t('countries.edit.noteHelper'),
                            maxLength: $dff16fd5ba545ec2$export$2daf5676b9ee9779,
                            showCount: true,
                            rows: 2,
                            disabled: pending
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: !!confirming,
                onOpenChange: (o)=>{
                    if (!o && !pending) setConfirming(null);
                },
                title: t('countries.edit.confirm.title', {
                    country: name
                }),
                description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3 text-sm leading-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-muted-foreground",
                            children: t('countries.edit.confirm.body')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "flex list-disc flex-col gap-1.5 ps-5",
                            "data-testid": "country-confirmations",
                            children: (confirming || []).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    "data-testid": `country-confirmation-${c.token}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold",
                                            children: columnLabel(c.column)
                                        }),
                                        " \u2014 ",
                                        c.kind === 'removal' ? t(`countries.edit.confirm.removal.${c.column}`, {
                                            value: valueString({
                                                field: c.field,
                                                type: 'enum'
                                            }, c.value),
                                            country: name
                                        }) : t(`countries.edit.confirm.change.${c.column}`, {
                                            from: stated(c.spec, c.from),
                                            to: stated(c.spec, c.to),
                                            country: name
                                        }),
                                        (0, $258fced26b1fac84$export$deb2cb864df03bb)(c.field) ? ` ${t('countries.edit.confirm.notReadYet')}` : ''
                                    ]
                                }, c.token))
                        }),
                        country === 'IR' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "warning",
                            "data-testid": "country-confirm-ir",
                            children: t('countries.edit.confirm.iran')
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                            checked: acknowledged,
                            onChange: (v)=>setAcknowledged(!!v),
                            label: t('countries.edit.confirm.acknowledge'),
                            "data-testid": "country-confirm-ack"
                        })
                    ]
                }),
                confirmLabel: t('countries.edit.confirm.submit'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                loading: pending,
                confirmDisabled: !acknowledged,
                onConfirm: ()=>save(confirming || []),
                "data-testid": "country-confirm",
                confirmTestId: "country-confirm-submit",
                cancelTestId: "country-confirm-cancel"
            })
        ]
    });
}
/** The label of a column, with «فعلاً خوانده نمی‌شود» when nothing reads it yet. */ function $dff16fd5ba545ec2$var$FieldLabel({ field: field }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            t(`countries.fields.${field}`),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$94b87dfb202e46b9), {
                field: field
            })
        ]
    });
}
/** Controls that share one name: a real fieldset and legend, its error under it. */ function $dff16fd5ba545ec2$var$Group({ field: field, error: error, disabled: disabled, testId: testId, children: children }) {
    const errorId = `${testId}-error`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
        className: "flex min-w-0 flex-col gap-2",
        disabled: disabled,
        "aria-describedby": error ? errorId : undefined,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                className: "mb-1.5 text-[11.5px] font-semibold text-muted-foreground",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dff16fd5ba545ec2$var$FieldLabel, {
                    field: field
                })
            }),
            children,
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                id: errorId,
                role: "alert",
                className: "m-0 text-[11.5px] font-medium text-destructive",
                children: error
            }) : null
        ]
    });
}
/**
 * One column's control. Single values are a <select> or a text box where ''
 * is NULL; the weekend and the map have an explicit «پیرو * / خودش» switch,
 * because their NULL and their empty mean different things.
 */ function $dff16fd5ba545ec2$var$FieldControl({ spec: spec, value: value, onChange: onChange, nullLabel: nullLabel, suggestion: suggestion, vocabulary: offered, row: row, deployment: deployment, error: error, disabled: disabled }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const valueString = (0, $32b5ef4e46f306ee$export$7ce5199f876047a)();
    const testId = `country-edit-${spec.field}`;
    const label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dff16fd5ba545ec2$var$FieldLabel, {
        field: spec.field
    });
    const ceiling = spec.kind === 'capability' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$cc60d6d36c1a0b3c), {
        spec: spec,
        value: row ? row[spec.field] : null,
        deployment: deployment
    }) : undefined;
    /** Options of a <select>: NULL first, then the vocabulary, then whatever the row holds outside it. */ const options = (vocabulary)=>{
        const known = [
            ...vocabulary
        ];
        if (value && !known.includes(value)) known.push(value);
        return [
            {
                value: '',
                label: nullLabel
            },
            ...known.map((v)=>({
                    value: String(v),
                    label: valueString(spec, spec.type === 'weekday' ? Number(v) : v)
                }))
        ];
    };
    if (spec.type === 'enum' || spec.type === 'key' || spec.type === 'language' || spec.type === 'currency' || spec.type === 'weekday') {
        const vocabulary = offered || ({
            language: (0, $258fced26b1fac84$export$2092376fd002e13),
            currency: (0, $fcda591c8cd139a4$export$729c9ac211f2ddda),
            weekday: (0, $258fced26b1fac84$export$ecc24ef5795d74f8).map(String)
        })[spec.type] || spec.options || [];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                label: label,
                value: value,
                onChange: (e)=>onChange(e.target?.value ?? e),
                options: options(vocabulary),
                placeholder: null,
                helperText: ceiling,
                error: error || undefined,
                disabled: disabled
            })
        });
    }
    if (spec.type === 'timezone' || spec.type === 'dialCode') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: label,
                value: value,
                onChange: (e)=>onChange(e.target?.value ?? e),
                dir: "ltr",
                inputMode: spec.type === 'dialCode' ? 'numeric' : undefined,
                placeholder: t(`countries.edit.example.${spec.type}`),
                helperText: error ? undefined : t('countries.edit.emptyMeans', {
                    meaning: nullLabel
                }),
                error: error || undefined,
                disabled: disabled
            }),
            suggestion && !String(value ?? '').trim() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                variant: "outline",
                size: "sm",
                className: "mt-1.5",
                onClick: ()=>onChange(suggestion),
                disabled: disabled,
                "data-testid": `${testId}-suggest`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...(0, $c53f9539af19d960$export$3433559efc22d110),
                        children: `+${suggestion}`
                    }),
                    t('countries.edit.suggested')
                ]
            }) : null
        ]
    });
    if (spec.type === 'list') {
        const known = [
            ...spec.options,
            ...value.filter((v)=>!spec.options.includes(v))
        ];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($dff16fd5ba545ec2$var$Group, {
            field: spec.field,
            error: error,
            disabled: disabled,
            testId: testId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-wrap gap-x-5 gap-y-2",
                    children: known.map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                            checked: value.includes(v),
                            onChange: (on)=>onChange(on ? [
                                    ...value,
                                    v
                                ] : value.filter((x)=>x !== v)),
                            label: valueString(spec, v),
                            "data-testid": `${testId}-${v}`
                        }, v))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-[11.5px] text-muted-foreground",
                    children: value.length ? ceiling : t('countries.state.none')
                })
            ]
        });
    }
    // Two shapes with their own «پیرو *» switch: the weekend (a list) and the map.
    const mode = value.follow ? 'follow' : 'own';
    const modeSwitch = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
        semantics: "filter",
        size: "sm",
        ariaLabel: t(`countries.fields.${spec.field}`),
        options: [
            {
                value: 'follow',
                label: nullLabel
            },
            {
                value: 'own',
                label: t('countries.edit.own')
            }
        ],
        value: mode,
        onChange: (m)=>onChange({
                ...value,
                follow: m === 'follow'
            }),
        "data-testid": `${testId}-mode`
    });
    if (spec.type === 'weekdays') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($dff16fd5ba545ec2$var$Group, {
        field: spec.field,
        error: error,
        disabled: disabled,
        testId: testId,
        children: [
            modeSwitch,
            !value.follow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-wrap gap-x-4 gap-y-2",
                        children: (0, $258fced26b1fac84$export$ecc24ef5795d74f8).map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                                checked: value.days.includes(d),
                                onChange: (on)=>onChange({
                                        ...value,
                                        days: on ? [
                                            ...value.days,
                                            d
                                        ] : value.days.filter((x)=>x !== d)
                                    }),
                                label: valueString({
                                    type: 'weekday'
                                }, d),
                                disabled: disabled,
                                "data-testid": `${testId}-${d}`
                            }, d))
                    }),
                    !value.days.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[11.5px] text-muted-foreground",
                        children: t('countries.state.noWeekend')
                    }) : null
                ]
            }) : null
        ]
    });
    // mapView
    const coord = (key, labelKey)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
            label: t(labelKey),
            value: value[key],
            onChange: (e)=>onChange({
                    ...value,
                    [key]: e.target?.value ?? e
                }),
            dir: "ltr",
            inputMode: "decimal",
            disabled: disabled,
            "data-testid": `${testId}-${key}`
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($dff16fd5ba545ec2$var$Group, {
        field: spec.field,
        error: error,
        disabled: disabled,
        testId: testId,
        children: [
            modeSwitch,
            !value.follow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-3 gap-3",
                children: [
                    coord('lat', 'countries.edit.lat'),
                    coord('lon', 'countries.edit.lon'),
                    coord('zoom', 'countries.edit.zoom')
                ]
            }) : null
        ]
    });
}


/** clinicmanagement's shape for a وزارت بهداشت id (`[A-Za-z0-9._-]`, at most 64). */ const $1ca882d10d678063$var$MOHME_ID = /^[A-Za-z0-9._-]{1,64}$/;
function $1ca882d10d678063$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, clinicId: clinicId, settings: settings, countryLabel: countryLabel, market: market, onSaved: onSaved }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const initial = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            erxEnabled: settings?.erxEnabled ?? null,
            smsEnabled: settings?.smsEnabled ?? null,
            insuranceEnabled: settings?.insuranceEnabled ?? null,
            mohmeOrgId: settings?.mohmeOrgId || '',
            universityId: settings?.universityId || '',
            calendar: settings?.calendar || ''
        }), [
        settings
    ]);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(initial);
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setDraft(initial);
        setNote('');
        setError(null);
    }, [
        open,
        initial
    ]);
    // Outside the Iranian market the e-prescription switch and the وزارت بهداشت ids
    // are not offered — and, not being in `changes`, keep whatever is stored.
    const intl = market === 'intl';
    const switches = (0, $258fced26b1fac84$export$66fec3d7c7ee3b16).filter(({ field: field })=>!(intl && field === 'erxEnabled'));
    const ids = intl ? [] : [
        'mohmeOrgId',
        'universityId'
    ];
    const changes = {};
    for (const key of Object.keys(initial)){
        const next = typeof draft[key] === 'string' ? draft[key].trim() : draft[key];
        const was = initial[key];
        if (next !== was) changes[key] = next === '' ? null : next;
    }
    const changed = Object.keys(changes).length > 0;
    const idError = (v)=>v.trim() && !$1ca882d10d678063$var$MOHME_ID.test(v.trim()) ? t('countries.clinicCard.invalidId') : null;
    const invalid = !!(idError(draft.mohmeOrgId) || idError(draft.universityId));
    const trimmed = note.trim();
    const noteOk = trimmed.length >= (0, $dff16fd5ba545ec2$export$6556e5010b701a8b) && trimmed.length <= (0, $dff16fd5ba545ec2$export$2daf5676b9ee9779);
    const submit = async ()=>{
        if (!changed || invalid || !noteOk || pending) return;
        setPending(true);
        setError(null);
        try {
            const res = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$9bdeb57e068a4aa4), {
                clinicId: clinicId,
                changes: changes,
                note: trimmed,
                expectedUpdatedAt: settings?.updatedAt ?? null
            });
            onOpenChange(false);
            toast.success(t('countries.clinicCard.success'));
            onSaved?.(res?.setClinicCountrySettings);
        } catch (e) {
            setError((0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('countries.clinicCard.dialogTitle'),
        error: error,
        pending: pending,
        dirty: changed || !!note,
        submitLabel: t('countries.edit.submit'),
        submitDisabled: !changed || invalid || !noteOk,
        onSubmit: submit,
        footerNote: !changed ? t('countries.edit.noChanges') : !noteOk ? t('countries.edit.noteNeeded') : undefined,
        "data-testid": "clinic-country-edit",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm leading-6 text-muted-foreground",
                children: t('countries.clinicCard.dialogBody', {
                    country: countryLabel
                })
            }),
            switches.map(({ field: field })=>{
                const off = draft[field] === false;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-1.5",
                    "data-testid": `clinic-country-edit-${field}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[11.5px] font-semibold text-muted-foreground",
                            children: t(`countries.clinicCard.switches.${field}`)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                            semantics: "filter",
                            size: "sm",
                            ariaLabel: t(`countries.clinicCard.switches.${field}`),
                            options: [
                                {
                                    value: 'follow',
                                    label: t('countries.clinicCard.follow')
                                },
                                {
                                    value: 'off',
                                    label: t('countries.clinicCard.off')
                                }
                            ],
                            value: off ? 'off' : 'follow',
                            // Back to «پیرو کشور» restores what was stored (null, or a stored true).
                            onChange: (m)=>setDraft((d)=>({
                                        ...d,
                                        [field]: m === 'off' ? false : initial[field] === false ? null : initial[field]
                                    }))
                        }),
                        off ? // What the choice does, not an error: warning ink, never red.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[11.5px] text-[var(--chip-warning-ink)]",
                            children: t(`countries.clinicCard.offMeans.${field}`)
                        }) : null
                    ]
                }, field);
            }),
            ids.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": `clinic-country-edit-${field}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t(`countries.clinicCard.ids.${field}`),
                        value: draft[field],
                        onChange: (e)=>setDraft((d)=>({
                                    ...d,
                                    [field]: e.target?.value ?? e
                                })),
                        dir: "ltr",
                        maxLength: 64,
                        helperText: idError(draft[field]) ? undefined : t('countries.clinicCard.ids.emptyMeans'),
                        error: idError(draft[field]) || undefined,
                        disabled: pending
                    })
                }, field)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "clinic-country-edit-calendar",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            t('countries.clinicCard.calendar'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$94b87dfb202e46b9), {
                                field: "calendar"
                            })
                        ]
                    }),
                    value: draft.calendar,
                    onChange: (e)=>setDraft((d)=>({
                                ...d,
                                calendar: e.target?.value ?? e
                            })),
                    options: [
                        {
                            value: '',
                            label: t('countries.clinicCard.follow')
                        },
                        ...(0, $258fced26b1fac84$export$ac2186fe7fdccc71).map((c)=>({
                                value: c,
                                label: t(`countries.values.calendar.${c}`)
                            }))
                    ],
                    placeholder: null,
                    disabled: pending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "clinic-country-edit-note",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('countries.edit.note'),
                    required: true,
                    value: note,
                    onChange: (e)=>setNote(e.target?.value ?? e),
                    placeholder: t('countries.clinicCard.notePlaceholder'),
                    helperText: t('countries.clinicCard.noteHelper'),
                    maxLength: (0, $dff16fd5ba545ec2$export$2daf5676b9ee9779),
                    showCount: true,
                    rows: 2,
                    disabled: pending
                })
            })
        ]
    });
}


/** The clinic switch that took a capability away, if one did. */ const $ddaabcfa9d7733ec$var$switchFor = (field)=>(0, $258fced26b1fac84$export$66fec3d7c7ee3b16).find((s)=>s.takes.includes(field))?.field || null;
function $ddaabcfa9d7733ec$export$2e2bcd8739ae039({ clinicId: clinicId }) {
    const { t: t, formatDate: formatDate, formatList: formatList } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const columnLabel = (0, $32b5ef4e46f306ee$export$4768687337cb1384)();
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        // Through a promise even if the transport throws synchronously: whatever
        // goes wrong here is this card's error state, never the record's.
        Promise.resolve().then(()=>(0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$38f8409d7c80516d), {
                clinicId: clinicId
            })).then((d)=>{
            if (!d?.clinicCountrySettings) throw new Error(t('countries.clinicCard.error'));
            setView(d.clinicCountrySettings);
        }).catch((e)=>setError((0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t))).finally(()=>setLoading(false));
    }, [
        clinicId,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    let body;
    if (loading) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "status",
        "aria-busy": "true",
        "aria-label": t('countries.clinicCard.loading'),
        "data-state": "loading",
        "data-testid": "clinic-country-loading",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
            lines: 4
        })
    });
    else if (error) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: t('countries.clinicCard.error'),
        description: error,
        onRetry: load,
        retryLabel: t('common.actions.retry'),
        "data-testid": "clinic-country-error"
    });
    else {
        const { settings: settings, effective: effective, countryProfile: countryProfile, deployment: deployment } = view;
        // Outside the Iranian market Iranian e-prescription does not exist here, so
        // neither does its switch nor the وزارت بهداشت ids it alone uses.
        const intl = deployment?.market === 'intl';
        const switches = (0, $258fced26b1fac84$export$66fec3d7c7ee3b16).filter(({ field: field })=>!(intl && field === 'erxEnabled'));
        body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            "data-state": "content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-2 text-sm",
                    "data-testid": "clinic-country-country",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs text-muted-foreground",
                            children: t('countries.clinicCard.country')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "font-semibold",
                            children: countryName(view.country)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$34a98f1791d1800e), {
                            code: view.country
                        }),
                        !view.profileFound ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "warning",
                            children: t('countries.detail.noRow')
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: (0, $258fced26b1fac84$export$fee178fc4e5672d5)(view.country),
                            className: "ms-auto text-xs text-primary hover:underline",
                            "data-testid": "clinic-country-rules-link",
                            children: t('countries.clinicCard.seeRules')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                    className: "grid grid-cols-1 gap-3 text-sm md:grid-cols-2",
                    "aria-label": t('countries.clinicCard.effective'),
                    "data-testid": "clinic-country-effective",
                    children: (0, $258fced26b1fac84$export$85405247c394b565).map((spec)=>{
                        const sw = $ddaabcfa9d7733ec$var$switchFor(spec.field);
                        const takenAway = sw && settings[sw] === false;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "min-w-0",
                            "data-testid": `clinic-country-cap-${spec.field}`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                    className: "flex flex-wrap items-center gap-1 text-xs text-muted-foreground",
                                    children: [
                                        t(`countries.fields.${spec.field}`),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$94b87dfb202e46b9), {
                                            field: spec.field
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    className: "mt-1 font-semibold",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c6f10d457200e8c6), {
                                        spec: spec,
                                        row: effective,
                                        merged: true,
                                        deployment: deployment,
                                        testId: `clinic-country-value-${spec.field}`
                                    })
                                }),
                                takenAway ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                    className: "mt-0.5 text-xs",
                                    "data-testid": `clinic-country-override-${spec.field}`,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "warning",
                                            children: t('countries.clinicCard.takenAway')
                                        }),
                                        countryProfile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "text-muted-foreground",
                                            children: [
                                                " \xb7 ",
                                                t('countries.clinicCard.countrySays'),
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c6f10d457200e8c6), {
                                                    spec: spec,
                                                    row: countryProfile,
                                                    merged: true,
                                                    deployment: deployment,
                                                    testId: `clinic-country-says-${spec.field}`
                                                })
                                            ]
                                        }) : null
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    className: "mt-0.5",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$cc60d6d36c1a0b3c), {
                                        spec: spec,
                                        value: effective[spec.field],
                                        deployment: deployment
                                    })
                                })
                            ]
                        }, spec.field);
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-3 border-t border-border pt-3 text-sm md:grid-cols-2",
                    "data-testid": "clinic-country-settings",
                    children: [
                        switches.map(({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs text-muted-foreground",
                                        children: t(`countries.clinicCard.switches.${field}`)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "font-semibold",
                                        "data-testid": `clinic-country-switch-${field}`,
                                        children: settings[field] === false ? t('countries.clinicCard.off') : t('countries.clinicCard.follow')
                                    })
                                ]
                            }, field)),
                        intl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "min-w-0 md:col-span-2",
                            "data-testid": "clinic-country-intl",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                variant: "warning",
                                children: t('countries.clinicCard.intlNote')
                            })
                        }) : [
                            'mohmeOrgId',
                            'universityId'
                        ].map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs text-muted-foreground",
                                        children: t(`countries.clinicCard.ids.${field}`)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        "data-testid": `clinic-country-id-${field}`,
                                        children: settings[field] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                            ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                            className: "font-mono text-[13px] font-semibold",
                                            children: settings[field]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: t('countries.clinicCard.ids.notRegistered')
                                        })
                                    })
                                ]
                            }, field)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-1 text-xs text-muted-foreground",
                                    children: [
                                        t('countries.clinicCard.calendar'),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$94b87dfb202e46b9), {
                                            field: "calendar"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "font-semibold",
                                    children: settings.calendar ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$f1145af01f1d77b7), {
                                        spec: {
                                            field: 'calendar',
                                            type: 'enum'
                                        },
                                        value: settings.calendar
                                    }) : t('countries.clinicCard.follow')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-2 border-t border-border pt-3 text-xs text-muted-foreground",
                    children: [
                        settings.updatedAt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "inline-flex items-center gap-1.5",
                            "data-testid": "clinic-country-updated",
                            children: [
                                t('countries.detail.updated', {
                                    date: formatDate(settings.updatedAt)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c3d2d38834f5b5cb), {
                                    by: settings.updatedBy
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: t('countries.clinicCard.neverSet')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            size: "sm",
                            className: "ms-auto",
                            onClick: ()=>setEditing(true),
                            "data-testid": "clinic-country-edit-open",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('countries.clinicCard.edit')
                            ]
                        })
                    ]
                }),
                view.history?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "flex flex-col gap-1.5 text-xs",
                    "aria-label": t('countries.clinicCard.history'),
                    "data-testid": "clinic-country-history",
                    children: view.history.slice(0, 5).map((h)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            className: "flex flex-wrap items-center gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: h.at ? formatDate(h.at) : t('common.value.none')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c3d2d38834f5b5cb), {
                                    by: h.actor
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: formatList(h.changedFields.map((f)=>$ddaabcfa9d7733ec$var$columnLabelForSetting(f, t, columnLabel)))
                                }),
                                h.note ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    dir: "auto",
                                    className: "truncate",
                                    title: h.note,
                                    children: [
                                        "\u2014 ",
                                        h.note
                                    ]
                                }) : null
                            ]
                        }, h.id))
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        id: "country",
        title: t('countries.clinicCard.title'),
        sub: t('countries.clinicCard.sub'),
        icon: (0, $cd9e54fee16cc3e5$export$2e2bcd8739ae039),
        "data-testid": "clinic-country",
        children: [
            body,
            view ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ca882d10d678063$export$2e2bcd8739ae039), {
                open: editing,
                onOpenChange: setEditing,
                clinicId: clinicId,
                settings: view.settings,
                countryLabel: countryName(view.country),
                market: view.deployment?.market,
                // The write is done once this runs. Its fresh view when the BFF could
                // read one; else the stored settings now and the rest read again.
                onSaved: (saved)=>{
                    if (saved?.view) {
                        setView(saved.view);
                        return;
                    }
                    if (saved?.settings) setView((v)=>({
                            ...v,
                            settings: saved.settings
                        }));
                    load();
                }
            }) : null
        ]
    });
}
/** A setting's name in the history line: a switch or an id by its own label. */ function $ddaabcfa9d7733ec$var$columnLabelForSetting(column, t, columnLabel) {
    const map = {
        erx_enabled: 'countries.clinicCard.switches.erxEnabled',
        sms_enabled: 'countries.clinicCard.switches.smsEnabled',
        insurance_enabled: 'countries.clinicCard.switches.insuranceEnabled',
        mohme_org_id: 'countries.clinicCard.ids.mohmeOrgId',
        university_id: 'countries.clinicCard.ids.universityId',
        calendar: 'countries.clinicCard.calendar'
    };
    return map[column] ? t(map[column]) : columnLabel(column);
}



const $42acdc1ae5c0dc8f$var$DETAIL_QUERY = `
  query ClinicDetail($clinicId: ID!) {
    clinicDetail(clinicId: $clinicId) {
      clinic {
        id name clinicType officePhone active createdAt currency ownerUserId
        subscriptionStatus entitled hasSubscription planCode capabilitySet tierNameFa
        currentPeriodEnd trialEndsAt
      }
      subscription {
        id status planCode capabilitySet tierNameFa origin graceDays notRenewing
        suspendedReason version createdAt
        currentPeriodStart currentPeriodEnd trialEndsAt graceEndsAt
        periods { id planCode periodStart periodEnd priceRial currency source activatedBy activatedAt note }
      }
      events { id eventType fromStatus toStatus actor payload occurredAt }
      staffCount
    }
    plans { code nameFa currency priceRial priceToman periodMonths capabilitySet tierNameFa }
  }
`;
const $42acdc1ae5c0dc8f$var$ACTIVATE = `
  mutation Activate(
    $clinicId: ID!, $planCode: String!, $periodStart: String, $periodEnd: String, $note: String
  ) {
    activateSubscription(
      clinicId: $clinicId, planCode: $planCode,
      periodStart: $periodStart, periodEnd: $periodEnd, note: $note
    ) { id status }
  }
`;
const $42acdc1ae5c0dc8f$var$SUSPEND = `
  mutation Suspend($clinicId: ID!, $reason: String!) {
    suspendSubscription(clinicId: $clinicId, reason: $reason) { id status }
  }
`;
const $42acdc1ae5c0dc8f$var$UNSUSPEND = `
  mutation Unsuspend($clinicId: ID!) {
    unsuspendSubscription(clinicId: $clinicId) { id status }
  }
`;
const $42acdc1ae5c0dc8f$var$GRANT_OVERRIDE = `
  mutation GrantOverride(
    $clinicId: ID!, $capability: String!, $granted: Boolean!, $reason: String, $expiresAt: String
  ) {
    grantOverride(
      clinicId: $clinicId, capability: $capability, granted: $granted,
      reason: $reason, expiresAt: $expiresAt
    ) { id status }
  }
`;
const $42acdc1ae5c0dc8f$var$GRANT_CREDITS = `
  mutation GrantCredits($ownerId: ID!, $amount: Int!, $note: String, $requestId: ID) {
    grantCredits(ownerId: $ownerId, amount: $amount, note: $note, requestId: $requestId) {
      ownerId amount reference balance
    }
  }
`;
function $42acdc1ae5c0dc8f$export$2e2bcd8739ae039({ clinicId: clinicId, navigate: navigate }) {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.clinic');
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [notFound, setNotFound] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Which dialog is open, and the state of the write it owns. One `pending`/
    // `dialogError` pair rather than one per dialog: only one can be open at a time
    // (§5.2 — no stacking), so two would be two ways to describe one fact.
    const [dialog, setDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // activate | suspend | override | unsuspend | grant
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [dialogError, setDialogError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)($42acdc1ae5c0dc8f$var$DETAIL_QUERY, {
            clinicId: clinicId
        }).then(setData).catch((e)=>{
            // A clinic that does not exist is a WHOLE-PAGE state, not a region error:
            // there is no record to show around the message, and the useful action is
            // going back to the list rather than retrying a query that will fail
            // identically.
            if (e?.code === 'NOT_FOUND') setNotFound(true);
            else setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        }).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        clinicId,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    /**
   * Run a mutation with the §2.4 lifecycle: pending → (success | failure).
   *
   * On failure the dialog STAYS OPEN with its input and shows the reason inline;
   * only a success closes it. The predecessor closed first and awaited second, so
   * a failed write silently discarded whatever the operator had typed.
   */ const run = async (mutation, variables, successKey)=>{
        setPending(true);
        setDialogError(null);
        try {
            await (0, $4d933cf7e127f21f$export$72e4926bf8358653)(mutation, variables);
            setDialog(null);
            toast.success(t(successKey));
            load({
                quiet: true
            });
        } catch (e) {
            setDialogError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const detail = data?.clinicDetail;
    const clinic = detail?.clinic;
    const subscription = detail?.subscription;
    /**
   * Credits to the clinic's owner. Same lifecycle as `run`, but the toast names
   * the amount and the owner's new balance — the result is the point — and
   * nothing on this page needs reloading: the wallet is not shown here.
   */ const grantCredits = async (vars)=>{
        setPending(true);
        setDialogError(null);
        try {
            const res = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)($42acdc1ae5c0dc8f$var$GRANT_CREDITS, {
                ownerId: clinic.ownerUserId,
                ...vars
            });
            const grant = res?.grantCredits;
            setDialog(null);
            toast.success(t('clinic.dialogs.grantCredits.success', {
                amount: formatNumber(grant?.amount ?? vars.amount),
                balance: grant?.balance == null ? t('common.value.none') : formatNumber(grant.balance)
            }));
        } catch (e) {
            setDialogError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const openActivate = ()=>{
        setDialogError(null);
        setDialog('activate');
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('r', openActivate, {
        label: t('shortcuts.action.renew'),
        group: t('shortcuts.groups.clinic'),
        enabled: !!clinic
    });
    // The same dialog under the name the button carries when there is nothing to
    // renew yet. Two keys for one action rather than one key whose label changes:
    // the `?` overlay lists what the screen's buttons actually say, and «تمدید» on
    // a clinic that has never had a subscription is a promise about a record that
    // does not exist.
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('n', openActivate, {
        label: t('shortcuts.action.provision'),
        group: t('shortcuts.groups.clinic'),
        enabled: !!clinic && !clinic.hasSubscription
    });
    if (notFound) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
        code: "404",
        titleKey: "errors.system.clinicNotFound.title",
        adviceKey: "errors.system.clinicNotFound.advice",
        testId: "detail-not-found",
        actions: [
            {
                key: 'back',
                label: t('errors.system.clinicNotFound.action'),
                onClick: ()=>navigate('/clinics')
            }
        ]
    });
    const suspended = subscription?.status === 'SUSPENDED';
    const provisioned = !!clinic?.hasSubscription;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "clinic-detail",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                // Renders from the route, so it is on screen during the first load and
                // during a failure — the way back is never the thing that disappears.
                title: clinic?.name || t('common.value.none'),
                onBack: ()=>navigate('/clinics'),
                backLabel: t('clinic.back'),
                avatar: clinic ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
                    name: clinic.name,
                    size: 40
                }) : undefined,
                status: clinic ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$6d154e3ed680b18a), {
                    clinic: clinic
                }) : undefined,
                badges: clinic ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3739acd771b8391$export$8cad3a378bd626fa), {
                            clinic: clinic
                        }),
                        subscription?.notRenewing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "warning",
                            children: t('clinic.alerts.notRenewing')
                        }) : null,
                        clinic.active === false ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            title: t('clinics.inactiveHint'),
                            children: t('clinics.inactive')
                        }) : null
                    ]
                }) : undefined,
                meta: clinic ? [
                    clinic.clinicType,
                    // National form — the panel shows what an operator would dial, not the
                    // E.164 the registry now stores. `phone.forDisplay` never blanks: an
                    // unparseable number is still the only one we hold for this clinic.
                    clinic.officePhone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...(0, $c53f9539af19d960$export$3433559efc22d110),
                        className: "tabular-nums",
                        children: (0, $412e1a8a99c19c1a$exports).forDisplay(clinic.officePhone)
                    }, "phone") : null,
                    clinic.createdAt ? t('clinic.meta.created', {
                        date: formatDate(clinic.createdAt)
                    }) : null,
                    t('clinic.meta.staff', {
                        count: detail?.staffCount || 0
                    })
                ].filter(Boolean) : undefined,
                stats: clinic ? [
                    {
                        label: t('clinic.stats.until'),
                        value: provisioned ? (0, $7df21990c7b31bb5$export$316445b56b177ccd)(subscription, {
                            t: t,
                            formatDate: formatDate
                        }) : t('common.value.none')
                    },
                    {
                        label: t('clinic.stats.entitled'),
                        value: clinic.entitled ? t('clinics.entitled.yes') : t('clinics.entitled.no'),
                        accent: !clinic.entitled
                    }
                ] : undefined,
                "data-testid": "detail-header",
                children: clinic ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: openActivate,
                            "data-testid": "detail-activate",
                            children: provisioned ? t('clinic.actions.activate') : t('clinic.actions.provision')
                        }),
                        provisioned ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: ()=>{
                                        setDialogError(null);
                                        setDialog('override');
                                    },
                                    "data-testid": "detail-override",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0cdbf97a5c8afc2$export$2e2bcd8739ae039), {
                                            size: 16,
                                            "aria-hidden": true
                                        }),
                                        t('clinic.actions.override')
                                    ]
                                }),
                                suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: ()=>{
                                        setDialogError(null);
                                        setDialog('unsuspend');
                                    },
                                    "data-testid": "detail-unsuspend",
                                    children: t('clinic.actions.unsuspend')
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: ()=>{
                                        setDialogError(null);
                                        setDialog('suspend');
                                    },
                                    "data-testid": "detail-suspend",
                                    children: t('clinic.actions.suspend')
                                })
                            ]
                        }) : null,
                        clinic.ownerUserId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: ()=>{
                                setDialogError(null);
                                setDialog('grant');
                            },
                            "data-testid": "detail-grant-credits",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                t('clinic.actions.grantCredits')
                            ]
                        }) : null
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mx-auto w-full max-w-[1440px]",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_20rem]",
                        "data-testid": "detail-loading",
                        "data-state": "loading",
                        "aria-busy": "true",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                        ]
                    }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                        title: t('errors.region.clinic'),
                        description: error,
                        onRetry: load,
                        retryLabel: t('common.actions.retry'),
                        "data-testid": "detail-error"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "transition-opacity",
                        style: {
                            opacity: refreshing ? 0.45 : 1
                        },
                        "aria-busy": refreshing || undefined,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-5 flex flex-col gap-3",
                                children: [
                                    suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "error",
                                        title: t('clinic.alerts.suspendedTitle'),
                                        "data-testid": "detail-alert-suspended",
                                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: ()=>setDialog('unsuspend'),
                                            children: t('clinic.actions.unsuspend')
                                        }),
                                        children: t('clinic.alerts.suspendedBody', {
                                            reason: subscription?.suspendedReason || t('common.value.none')
                                        })
                                    }) : null,
                                    provisioned && !clinic.entitled && !suspended ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        title: t('clinic.alerts.notEntitledTitle'),
                                        "data-testid": "detail-alert-entitlement",
                                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: openActivate,
                                            children: t('clinic.actions.activate')
                                        }),
                                        children: t('clinic.alerts.notEntitledBody', {
                                            status: t((0, $ec7f110ce929cf56$export$5aeba3c817b68975)(subscription?.status))
                                        })
                                    }) : null,
                                    !provisioned ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "info",
                                        "data-testid": "detail-alert-unprovisioned",
                                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: openActivate,
                                            children: t('clinic.actions.provision')
                                        }),
                                        children: t('clinic.alerts.unprovisioned')
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_20rem]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex min-w-0 flex-col gap-5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf76e55deb271988$export$1f31b6d22e079a72), {
                                                clinic: clinic,
                                                subscription: subscription
                                            }),
                                            provisioned ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf76e55deb271988$export$28428edc284a0314), {
                                                        periods: subscription?.periods
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf76e55deb271988$export$22925cbb709b3e49), {
                                                        events: detail.events
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10231e94a06472aa$export$7583e06808a373a5), {
                                                resetKey: clinic.id,
                                                renderFallback: (_error, reset)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                                        title: t('countries.clinicCard.error'),
                                                        onRetry: reset,
                                                        retryLabel: t('common.actions.retry'),
                                                        "data-testid": "clinic-country-crash"
                                                    }),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddaabcfa9d7733ec$export$2e2bcd8739ae039), {
                                                    clinicId: clinic.id
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf76e55deb271988$export$a70158f3e707e82c), {
                                        clinic: clinic
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            clinic ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11ac046a796b919b$export$2e2bcd8739ae039), {
                        open: dialog === 'activate',
                        onOpenChange: (open)=>setDialog(open ? 'activate' : null),
                        clinic: clinic,
                        plans: data.plans,
                        pending: pending,
                        error: dialogError,
                        onSubmit: (vars)=>run($42acdc1ae5c0dc8f$var$ACTIVATE, {
                                clinicId: clinicId,
                                ...vars
                            }, 'clinic.dialogs.activate.success')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c090b1f14649eab$export$2e2bcd8739ae039), {
                        open: dialog === 'suspend',
                        onOpenChange: (open)=>setDialog(open ? 'suspend' : null),
                        pending: pending,
                        error: dialogError,
                        onSubmit: ({ reason: reason })=>run($42acdc1ae5c0dc8f$var$SUSPEND, {
                                clinicId: clinicId,
                                reason: reason
                            }, 'clinic.dialogs.suspend.success')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5467974189c6ce5c$export$2e2bcd8739ae039), {
                        open: dialog === 'override',
                        onOpenChange: (open)=>setDialog(open ? 'override' : null),
                        pending: pending,
                        error: dialogError,
                        onSubmit: (vars)=>run($42acdc1ae5c0dc8f$var$GRANT_OVERRIDE, {
                                clinicId: clinicId,
                                ...vars
                            }, 'clinic.dialogs.override.success')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e0e0edbd3055fc4$export$2e2bcd8739ae039), {
                        open: dialog === 'grant',
                        onOpenChange: (open)=>setDialog(open ? 'grant' : null),
                        clinic: clinic,
                        pending: pending,
                        error: dialogError,
                        onSubmit: grantCredits
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                        open: dialog === 'unsuspend',
                        onOpenChange: (open)=>setDialog(open ? 'unsuspend' : null),
                        title: t('clinic.dialogs.unsuspend.title', {
                            name: clinic.name
                        }),
                        description: t('clinic.dialogs.unsuspend.body'),
                        confirmLabel: t('clinic.dialogs.unsuspend.confirm'),
                        cancelLabel: t('common.actions.cancel'),
                        loading: pending,
                        onConfirm: ()=>run($42acdc1ae5c0dc8f$var$UNSUSPEND, {
                                clinicId: clinicId
                            }, 'clinic.dialogs.unsuspend.success'),
                        "data-testid": "detail-unsuspend-confirm"
                    })
                ]
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");






/**
 * Pure view logic for the AI cost & Parseh pricing screen.
 *
 * Everything here is a function of (rows, view) with no React in it, for the
 * same reason `clinicsView.js` is: the rules that are easy to get subtly wrong —
 * where a NULL sorts, which chip narrows what, what a CSV must never contain —
 * are the ones a screenshot cannot show and a headless test can.
 *
 * Money and averages arrive from the BFF as STRINGS ("0.00420000") and a figure
 * that does not exist arrives as `null`. This module parses for ordering and
 * for export only; it never does arithmetic on them (design §11.1).
 */ 
const $ad1ad54ff7f74a69$export$50bf86b71c5fd0d9 = [
    'overview',
    'models',
    'services',
    'policies',
    'ledger',
    'visits'
];
const $ad1ad54ff7f74a69$export$2a4322aefdc3a504 = [
    '7',
    '30',
    '90'
];
const $ad1ad54ff7f74a69$export$b60010c1a0b9cee5 = '30';
const $ad1ad54ff7f74a69$export$cf7fe2da72761aae = (0, $cdf3712044ab22f9$export$8ec3d08588d2eeda);
const $ad1ad54ff7f74a69$var$DAY_MS = 86400000;
function $ad1ad54ff7f74a69$export$b579fde59a974853(w, now = Date.now()) {
    const days = Number(w);
    const span = $ad1ad54ff7f74a69$export$2a4322aefdc3a504.includes(String(w)) ? days : Number($ad1ad54ff7f74a69$export$b60010c1a0b9cee5);
    const to = new Date(now);
    const from = new Date(now - span * $ad1ad54ff7f74a69$var$DAY_MS);
    return {
        from: from.toISOString(),
        to: to.toISOString()
    };
}
function $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(value) {
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}
/** Fold Persian and Arabic-Indic digits to ASCII so a typed id matches. */ const $ad1ad54ff7f74a69$var$ASCII_DIGITS = (()=>{
    const map = new Map();
    for (const base of [
        0x06f0,
        0x0660
    ])for(let d = 0; d <= 9; d += 1)map.set(String.fromCharCode(base + d), String(d));
    return map;
})();
const $ad1ad54ff7f74a69$var$foldDigits = (text)=>String(text ?? '').replace(/./gu, (ch)=>$ad1ad54ff7f74a69$var$ASCII_DIGITS.get(ch) ?? ch);
const $ad1ad54ff7f74a69$var$norm = (text)=>$ad1ad54ff7f74a69$var$foldDigits(text).trim().toLowerCase();
function $ad1ad54ff7f74a69$export$bbd9db50ee591c80(rows, valueOf, dir = 'desc', tieBreak) {
    const sign = dir === 'asc' ? 1 : -1;
    const present = [];
    const absent = [];
    for (const row of rows)(valueOf(row) == null ? absent : present).push(row);
    present.sort((a, b)=>{
        const d = valueOf(a) - valueOf(b);
        if (d !== 0) return d * sign;
        return tieBreak ? tieBreak(a, b) : 0;
    });
    return [
        ...present,
        ...absent
    ];
}
/** Severity order for the alert zone: the dangerous ones first, stable within. */ const $ad1ad54ff7f74a69$var$SEVERITY_RANK = {
    danger: 0,
    warning: 1,
    info: 2
};
function $ad1ad54ff7f74a69$export$d5d270d2f9954e4a(alerts) {
    return [
        ...alerts || []
    ].map((alert, index)=>({
            alert: alert,
            index: index
        })).sort((a, b)=>{
        const d = ($ad1ad54ff7f74a69$var$SEVERITY_RANK[a.alert.severity] ?? 3) - ($ad1ad54ff7f74a69$var$SEVERITY_RANK[b.alert.severity] ?? 3);
        return d !== 0 ? d : a.index - b.index;
    }).map(({ alert: alert })=>alert);
}
const $ad1ad54ff7f74a69$export$b255870b874eb4 = {
    no_active_policy: {
        view: 'policies'
    },
    unpriced_models: {
        view: 'models'
    },
    provider_drift: {
        view: 'models'
    },
    wallet_value_changed: {
        view: 'policies'
    },
    negative_margin: {
        view: 'services',
        sort: 'margin',
        dir: 'asc'
    },
    apps_mismatch: {
        view: 'services',
        mismatch: '1'
    },
    telemetry_dropped: {
        view: 'ledger'
    },
    deprecated_in_use: {
        view: 'models',
        deprecated: '1'
    },
    // PM-0427 — the nightly dollar. A stale rate is read in the policies view's
    // «نرخ دلار شبانه» history; a held night is a DRAFT a person must look at,
    // so that door opens the draft itself (`alertTarget` adds its id).
    fx_stale: {
        view: 'policies'
    },
    fx_reprice_held: {
        view: 'policies'
    }
};
function $ad1ad54ff7f74a69$export$acb36081c21cceb4(alert) {
    const target = $ad1ad54ff7f74a69$export$b255870b874eb4[alert?.kind];
    if (!target) return null;
    if (alert.kind === 'fx_reprice_held') {
        const id = $ad1ad54ff7f74a69$var$foldDigits(alert.detail).trim();
        return /^\d+$/.test(id) ? {
            ...target,
            policy: id
        } : target;
    }
    return target;
}
// ── services ─────────────────────────────────────────────────────────────────
const $ad1ad54ff7f74a69$var$SERVICE_SORTERS = {
    invocations: (r)=>r.invocations ?? null,
    cost: (r)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(r.meanCostUsd),
    margin: (r)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(r.marginPct),
    revenue: (r)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(r.revenueParseh),
    price: (r)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(r.effectiveParseh)
};
const $ad1ad54ff7f74a69$export$5514c818b0e2f165 = Object.keys($ad1ad54ff7f74a69$var$SERVICE_SORTERS);
function $ad1ad54ff7f74a69$var$serviceMatches(row, q, label) {
    const needle = $ad1ad54ff7f74a69$var$norm(q);
    if (!needle) return true;
    return $ad1ad54ff7f74a69$var$norm(label(row)).includes(needle) || $ad1ad54ff7f74a69$var$norm(row.serviceKey).includes(needle);
}
function $ad1ad54ff7f74a69$export$bd0c93a9682bcfaa(rows, view, { label: label = (r)=>r.labelFa } = {}) {
    const all = Array.isArray(rows) ? rows : [];
    const q = String(view.q || '');
    const searching = q.trim().length >= (0, $cdf3712044ab22f9$export$d6920ac008449896);
    let out = all;
    if (view.negative === '1') out = out.filter((r)=>($ad1ad54ff7f74a69$export$61cc6a0be4938a2a(r.marginPct) ?? 0) < 0);
    if (view.unpriced === '1') out = out.filter((r)=>r.hasUnpricedModel);
    if (view.mismatch === '1') out = out.filter((r)=>r.appsMismatch);
    if (searching) out = out.filter((r)=>$ad1ad54ff7f74a69$var$serviceMatches(r, q, label));
    const sortKey = $ad1ad54ff7f74a69$var$SERVICE_SORTERS[view.sort] ? view.sort : 'cost';
    const dir = view.dir === 'asc' ? 'asc' : 'desc';
    out = $ad1ad54ff7f74a69$export$bbd9db50ee591c80(out, $ad1ad54ff7f74a69$var$SERVICE_SORTERS[sortKey], dir, (a, b)=>String(a.serviceKey).localeCompare(String(b.serviceKey)));
    return {
        rows: out,
        total: all.length,
        filtered: out.length,
        isFiltered: searching || view.negative === '1' || view.unpriced === '1' || view.mismatch === '1'
    };
}
// ── models ───────────────────────────────────────────────────────────────────
const $ad1ad54ff7f74a69$var$MODEL_STATUS_RANK = {
    unknown: 0,
    active: 1,
    deprecated: 2
};
function $ad1ad54ff7f74a69$var$modelMatches(row, q) {
    const needle = $ad1ad54ff7f74a69$var$norm(q);
    if (!needle) return true;
    return $ad1ad54ff7f74a69$var$norm(row.modelId).includes(needle) || $ad1ad54ff7f74a69$var$norm(row.displayName).includes(needle) || $ad1ad54ff7f74a69$var$norm(row.provider).includes(needle);
}
function $ad1ad54ff7f74a69$export$f00694959a6a89ca(rows, view) {
    const all = Array.isArray(rows) ? rows : [];
    const q = String(view.q || '');
    const searching = q.trim().length >= (0, $cdf3712044ab22f9$export$d6920ac008449896);
    let out = all;
    if (view.deprecated !== '1') out = out.filter((r)=>r.status !== 'deprecated');
    if (searching) out = out.filter((r)=>$ad1ad54ff7f74a69$var$modelMatches(r, q));
    const dir = view.dir === 'asc' ? 'asc' : 'desc';
    const valueOf = view.sort === 'calls' ? (r)=>r.callsInWindow ?? null : (r)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(r.costUsdInWindow);
    const sorted = $ad1ad54ff7f74a69$export$bbd9db50ee591c80(out, valueOf, dir, (a, b)=>String(a.modelId).localeCompare(String(b.modelId)));
    const banded = [
        ...sorted
    ].sort((a, b)=>($ad1ad54ff7f74a69$var$MODEL_STATUS_RANK[a.status] ?? 1) - ($ad1ad54ff7f74a69$var$MODEL_STATUS_RANK[b.status] ?? 1));
    return {
        rows: banded,
        total: all.length,
        filtered: banded.length,
        isFiltered: searching || view.deprecated === '1'
    };
}
const $ad1ad54ff7f74a69$export$b138e5343ad1a7e8 = [
    'cost',
    'calls'
];
function $ad1ad54ff7f74a69$export$47713a0f1f69cef5(source) {
    const text = String(source || '');
    if (text.startsWith('policy:')) return {
        kind: 'policy',
        id: text.slice(7)
    };
    if (text === 'override') return {
        kind: 'override',
        id: null
    };
    return {
        kind: 'code_default',
        id: null
    };
}
const $ad1ad54ff7f74a69$export$c905d1784509c2ab = [
    'ok',
    'error',
    'aborted'
];
const $ad1ad54ff7f74a69$export$60b33fb147a66c = [
    'doctor',
    'clinic',
    'student'
];
function $ad1ad54ff7f74a69$export$b391194b3ee0175d(view, now = Date.now()) {
    const preset = $ad1ad54ff7f74a69$export$b579fde59a974853(view.w, now);
    const from = view.dfrom ? new Date(`${view.dfrom}T00:00:00+03:30`).toISOString() : preset.from;
    const to = view.dto ? new Date(new Date(`${view.dto}T00:00:00+03:30`).getTime() + $ad1ad54ff7f74a69$var$DAY_MS).toISOString() : preset.to;
    const filter = {
        window: {
            from: from,
            to: to
        }
    };
    if (view.service) filter.serviceKey = view.service;
    if (view.model) filter.modelId = view.model;
    if (view.owner) filter.ownerType = view.owner;
    if (view.ownerId) filter.ownerId = $ad1ad54ff7f74a69$var$foldDigits(view.ownerId).trim();
    if (view.status) filter.status = view.status;
    if (view.charged === 'yes' || view.charged === 'no') filter.charged = view.charged;
    return filter;
}
function $ad1ad54ff7f74a69$export$690c9e0c046cafec(view) {
    return !!(view.service || view.model || view.owner || view.ownerId || view.status || view.charged || view.dfrom || view.dto);
}
function $ad1ad54ff7f74a69$export$a3a372017b8de354(total, pageSize = $ad1ad54ff7f74a69$export$cf7fe2da72761aae) {
    return Math.max(1, Math.ceil((Number(total) || 0) / pageSize));
}
const $ad1ad54ff7f74a69$export$e91ee2b842347321 = [
    'none',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11-15',
    '16-20',
    '21-30',
    '31+'
];
function $ad1ad54ff7f74a69$export$eb7dad68aa29935b(bucket) {
    const key = String(bucket || '');
    if (!$ad1ad54ff7f74a69$export$e91ee2b842347321.includes(key)) return null;
    if (key === 'none') return {
        recorded: 'no',
        min: 0,
        max: 0
    };
    if (key.endsWith('+')) return {
        recorded: '',
        min: Number(key.slice(0, -1)),
        max: 0
    };
    const [lo, hi = lo] = key.split('-').map(Number);
    return {
        recorded: '',
        min: lo,
        max: hi
    };
}
const $ad1ad54ff7f74a69$export$d41745fe1a55405b = [
    'started',
    'earned',
    'paid',
    'margin',
    'minutes'
];
const $ad1ad54ff7f74a69$export$2e671f256b71a45c = 'started';
function $ad1ad54ff7f74a69$export$d2a4aad4766fea6f(view) {
    const key = $ad1ad54ff7f74a69$export$d41745fe1a55405b.includes(view.sort) ? view.sort : $ad1ad54ff7f74a69$export$2e671f256b71a45c;
    const dir = view.dir === 'asc' ? 'asc' : 'desc';
    return `${key}:${dir}`;
}
function $ad1ad54ff7f74a69$export$ee0f41584dd52d33(view) {
    const filter = {};
    if (view.owner) filter.ownerType = view.owner;
    if (view.ownerId) filter.ownerId = $ad1ad54ff7f74a69$var$foldDigits(view.ownerId).trim();
    if (view.service) filter.serviceKey = view.service;
    const range = $ad1ad54ff7f74a69$export$eb7dad68aa29935b(view.mins);
    if (range) {
        if (range.recorded) filter.recorded = range.recorded;
        if (range.min) filter.minBilledMinutes = range.min;
        if (range.max) filter.maxBilledMinutes = range.max;
    }
    if (!filter.recorded && (view.rec === 'yes' || view.rec === 'no')) filter.recorded = view.rec;
    return filter;
}
function $ad1ad54ff7f74a69$export$1aae0b1012f7f914(view) {
    return !!(view.owner || view.ownerId || view.service || view.rec || view.mins);
}
/**
 * A decimal string → `{ digits: BigInt, scale }` with value = digits / 10^scale,
 * or null. Accepts what the wire sends — «0.00420000», «278000», «-12», and an
 * exponent form in case one ever arrives.
 */ function $ad1ad54ff7f74a69$var$parseDecimal(value) {
    const text = $ad1ad54ff7f74a69$var$foldDigits(value).trim();
    const m = /^([+-])?(\d*)(?:\.(\d*))?(?:[eE]([+-]?\d+))?$/.exec(text);
    if (!m || !m[2] && !m[3]) return null;
    const frac = m[3] || '';
    let digits = BigInt(`${m[2] || '0'}${frac}` || '0');
    let scale = frac.length - Number(m[4] || 0);
    if (scale < 0) {
        digits *= BigInt(`1${'0'.repeat(-scale)}`);
        scale = 0;
    }
    return {
        digits: m[1] === '-' ? -digits : digits,
        scale: scale
    };
}
function $ad1ad54ff7f74a69$export$8c21d38d7c4a7d0a(a, b) {
    const x = $ad1ad54ff7f74a69$var$parseDecimal(a);
    const y = $ad1ad54ff7f74a69$var$parseDecimal(b);
    if (!x || !y) return null;
    const product = x.digits * y.digits;
    const scale = x.scale + y.scale;
    const negative = product < BigInt(0);
    const raw = (negative ? -product : product).toString().padStart(scale + 1, '0');
    const whole = raw.slice(0, raw.length - scale);
    const frac = scale ? raw.slice(raw.length - scale).replace(/0+$/, '') : '';
    return `${negative ? '-' : ''}${whole}${frac ? `.${frac}` : ''}`;
}
function $ad1ad54ff7f74a69$export$b7288dbeceba22c2(money) {
    const irt = !money?.creditCurrency || money.creditCurrency === 'IRT';
    const parsehRate = irt ? money?.parsehToman : null;
    const usdRate = irt ? money?.fxTomanPerUsd : null;
    return {
        irt: irt,
        hasRate: $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(usdRate) != null && $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(parsehRate) != null,
        fromParseh: (parseh)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(parsehRate) == null ? null : $ad1ad54ff7f74a69$export$8c21d38d7c4a7d0a(parseh, parsehRate),
        fromUsd: (usd)=>$ad1ad54ff7f74a69$export$61cc6a0be4938a2a(usdRate) == null ? null : $ad1ad54ff7f74a69$export$8c21d38d7c4a7d0a(usd, usdRate)
    };
}
const $ad1ad54ff7f74a69$export$ba194ab73a5e5e06 = 10;
// ── CSV ──────────────────────────────────────────────────────────────────────
/**
 * RFC 4180 cell: quoted when it holds a comma, a quote or a newline; quotes
 * doubled. `null`/`undefined` become the EMPTY cell, not the word "null".
 */ function $ad1ad54ff7f74a69$var$csvCell(value) {
    if (value == null) return '';
    const text = String(value);
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}
function $ad1ad54ff7f74a69$export$171e304ea3e0c0ae(columns, rows) {
    const lines = [
        columns.map((c)=>$ad1ad54ff7f74a69$var$csvCell(c.header)).join(',')
    ];
    for (const row of rows || [])lines.push(columns.map((c)=>$ad1ad54ff7f74a69$var$csvCell($ad1ad54ff7f74a69$var$foldDigits(c.value(row)))).join(','));
    return `${lines.join('\r\n')}\r\n`;
}
const $ad1ad54ff7f74a69$export$fe9e2c1c888f4b9b = [
    'mean',
    'p50',
    'p90',
    'declared',
    'actual'
];
const $ad1ad54ff7f74a69$export$c5fe1557c05c3963 = [
    'ceil_0_1',
    'ceil_int',
    'nearest_int',
    'step_5'
];
const $ad1ad54ff7f74a69$export$518d68fe9c6bde52 = 'ceil_0_1';
function $ad1ad54ff7f74a69$export$443f876604f74cf4(value) {
    const text = $ad1ad54ff7f74a69$var$foldDigits(value).trim();
    if (text === '') return true;
    const m = /^[+-]?(\d*)(?:\.(\d*))?$/.exec(text);
    if (!m || m[1] === '' && (m[2] == null || m[2] === '')) return false;
    return (m[2] || '').replace(/0+$/, '').length <= 1;
}
const $ad1ad54ff7f74a69$export$9fa273245baa497 = [
    7,
    30,
    90
];
function $ad1ad54ff7f74a69$export$fc10758f8b4247f3({ fxTomanPerUsd: fxTomanPerUsd = '' } = {}) {
    return {
        name: '',
        fxTomanPerUsd: fxTomanPerUsd || '',
        targetMarginPct: '85',
        overheadPct: '0',
        costBasis: 'mean',
        windowDays: 30,
        rounding: $ad1ad54ff7f74a69$export$518d68fe9c6bde52,
        minParseh: '1',
        note: ''
    };
}
function $ad1ad54ff7f74a69$export$c27a63561573784e(policy) {
    if (!policy) return $ad1ad54ff7f74a69$export$fc10758f8b4247f3();
    return {
        name: policy.name || '',
        fxTomanPerUsd: policy.fxTomanPerUsd || '',
        targetMarginPct: policy.targetMarginPct || '',
        overheadPct: policy.overheadPct || '0',
        costBasis: policy.costBasis || 'mean',
        windowDays: Number(policy.windowDays) || 30,
        rounding: policy.rounding || $ad1ad54ff7f74a69$export$518d68fe9c6bde52,
        minParseh: policy.minParseh || '1',
        note: policy.note || ''
    };
}
function $ad1ad54ff7f74a69$export$852b9bdc9ffe68a8(a, b) {
    if (!a || !b) return false;
    const numeric = [
        'fxTomanPerUsd',
        'targetMarginPct',
        'overheadPct',
        'minParseh',
        'windowDays'
    ];
    for (const key of Object.keys($ad1ad54ff7f74a69$export$fc10758f8b4247f3())){
        const x = a[key];
        const y = b[key];
        if (numeric.includes(key)) {
            const nx = $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(x);
            const ny = $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(y);
            if (nx !== ny) return false;
        } else if (String(x ?? '') !== String(y ?? '')) return false;
    }
    return true;
}
function $ad1ad54ff7f74a69$export$e842cfdc0a8000eb(locale) {
    if (!locale) return false;
    try {
        const group = new Intl.NumberFormat(locale).formatToParts(1234567).find((p)=>p.type === 'group');
        return group?.value === '.';
    } catch  {
        return false;
    }
}
function $ad1ad54ff7f74a69$export$da691c727d601914(input, { withFx: withFx = true, locale: locale } = {}) {
    const errors = {};
    if (!String(input.name || '').trim()) errors.name = 'aiPricing.policies.editor.nameRequired';
    if (withFx) {
        const fx = $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(input.fxTomanPerUsd);
        if (fx == null || fx <= 0) errors.fxTomanPerUsd = 'aiPricing.policies.editor.fxRequired';
        else if (fx < 1000 && String(input.fxTomanPerUsd).includes('.') && $ad1ad54ff7f74a69$export$e842cfdc0a8000eb(locale)) errors.fxTomanPerUsd = 'aiPricing.policies.editor.fxGrouped';
    }
    const margin = $ad1ad54ff7f74a69$export$61cc6a0be4938a2a(input.targetMarginPct);
    if (margin == null || margin < 0 || margin > 99) errors.targetMarginPct = 'validation.required';
    // A minimum price is a price: tenths only, like an override (PM-0427).
    if (!$ad1ad54ff7f74a69$export$443f876604f74cf4(input.minParseh)) errors.minParseh = 'aiPricing.policies.editor.tenthsOnly';
    return errors;
}
function $ad1ad54ff7f74a69$export$516570a68aa812d5(input, { withFx: withFx = true } = {}) {
    return {
        name: String(input.name || '').trim(),
        fxTomanPerUsd: withFx ? String(input.fxTomanPerUsd) : '',
        targetMarginPct: String(input.targetMarginPct),
        overheadPct: String(input.overheadPct ?? '0'),
        costBasis: input.costBasis,
        windowDays: Number(input.windowDays),
        rounding: input.rounding,
        minParseh: String(input.minParseh ?? '1'),
        note: String(input.note || '').trim() || null
    };
}
var $ad1ad54ff7f74a69$export$2e2bcd8739ae039 = $ad1ad54ff7f74a69$export$bd0c93a9682bcfaa;


/**
 * Every GraphQL document the AI pricing screen sends, built against the frozen
 * contract in `parsina.bff.admin/src/graphql/typeDefs/aiCost.js` field for
 * field. They live in one file so a contract change is a diff against one
 * place, and so a test can match a call by the operation name it carries.
 */ const $3ece07ed3ee6f427$var$PRICE_FIELDS = `
  id modelId effectiveFrom
  inputUsdPerM outputUsdPerM cachedInputUsdPerM audioInputUsdPerM audioUsdPerMinute requestUsd
  source note createdAt createdBy
`;
const $3ece07ed3ee6f427$var$SERVICE_ROW_FIELDS = `
  serviceKey labelFa labelEn walletServiceType chargeMode chargeCondition
  defaultParseh declaredEstimateUsd active
  invocations chargedRate avgCalls avgInputTokens avgOutputTokens avgCachedTokens
  meanCostUsd p50CostUsd p90CostUsd pricedShare costPerMinuteUsd totalCostUsd
  revenueParseh revenueUsd marginPct meanCostToman
  effectiveParseh priceSource unit declaredInAppsParseh appsMismatch
  models { modelId role calls avgInputTokens avgOutputTokens costUsd shareOfCostPct shareOfCallsPct unpriced }
  hasUnpricedModel declaredRolesMismatch
`;
const $3ece07ed3ee6f427$var$DAILY_FIELDS = 'day costUsd revenueUsd invocations calls';
const $3ece07ed3ee6f427$var$INVOCATION_FIELDS = `
  requestId serviceKey ownerType ownerId appointmentId startedAt finishedAt status
  calls inputTokens outputTokens cachedTokens audioSeconds costUsd providerCostUsd
  chargedParseh chargeReason priceSource walletTransactionId billedMinutes
`;
const $3ece07ed3ee6f427$var$POLICY_FIELDS = `
  id status name fxTomanPerUsd targetMarginPct overheadPct costBasis windowDays rounding
  minParseh note parsehToman version computedAt activatedAt activatedBy archivedAt
  createdAt createdBy servicesPriced negativeMargins creditPrice creditCurrency
  fxSource basePolicyId
`;
const $3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS = `
  policy { ${$3ece07ed3ee6f427$var$POLICY_FIELDS} }
  prices {
    serviceKey labelFa labelEn unit basisCostUsd basisSource basisSample chargedRate
    costParseh computedParseh overrideParseh effectiveParseh marginPct activeParseh
    deltaParseh defaultParseh
  }
  walletParsehToman projectedBlendedMarginPct cheaper dearer negative
`;
const $3ece07ed3ee6f427$export$c378ca4a0e2c9fec = `
  query AiCostOverview($window: CostWindow!, $ownerType: String) {
    aiCostOverview(window: $window, ownerType: $ownerType) {
      totalCostUsd totalCostToman revenueParseh revenueUsd
      blendedCostPerParsehUsd blendedMarginPct invocations calls pricedShare
      daily { ${$3ece07ed3ee6f427$var$DAILY_FIELDS} }
      byService { key label costUsd sharePct count }
      byModel { key label costUsd sharePct count }
      alerts { kind severity count detail }
      activePolicyId activePolicyName fxTomanPerUsd parsehToman walletParsehToman
      mostExpensiveService creditCurrency
    }
  }
`;
const $3ece07ed3ee6f427$export$8aa64dc73f1d6413 = `
  query AiModels($window: CostWindow!, $includeDeprecated: Boolean) {
    aiModels(window: $window, includeDeprecated: $includeDeprecated) {
      modelId provider displayName modalities status notes createdAt updatedAt
      currentPrice { ${$3ece07ed3ee6f427$var$PRICE_FIELDS} }
      callsInWindow costUsdInWindow usedByServices
    }
  }
`;
const $3ece07ed3ee6f427$export$4b2a8d20113f379a = `
  query AiModelPrices($modelId: ID!) {
    aiModelPrices(modelId: $modelId) { ${$3ece07ed3ee6f427$var$PRICE_FIELDS} }
  }
`;
const $3ece07ed3ee6f427$export$4475822d064e2b52 = `
  mutation UpsertAiModel($input: AiModelInput!) {
    upsertAiModel(input: $input) { modelId status }
  }
`;
const $3ece07ed3ee6f427$export$8dab3cf01b4320f2 = `
  mutation AddAiModelPrice($input: AiModelPriceInput!) {
    addAiModelPrice(input: $input) {
      price { ${$3ece07ed3ee6f427$var$PRICE_FIELDS} }
      recomputedCalls recomputedInvocations
    }
  }
`;
const $3ece07ed3ee6f427$export$48f6848d495596f6 = `
  query AiServices($window: CostWindow!, $policyId: ID, $includeInactive: Boolean) {
    aiServices(window: $window, policyId: $policyId, includeInactive: $includeInactive) {
      services { ${$3ece07ed3ee6f427$var$SERVICE_ROW_FIELDS} }
      policyId fxTomanPerUsd parsehToman creditCurrency
    }
  }
`;
const $3ece07ed3ee6f427$export$a23fde56dda002a7 = `
  query AiServiceDetail($serviceKey: ID!, $window: CostWindow!, $policyId: ID) {
    aiServiceDetail(serviceKey: $serviceKey, window: $window, policyId: $policyId) {
      row { ${$3ece07ed3ee6f427$var$SERVICE_ROW_FIELDS} }
      models { modelId role calls avgInputTokens avgOutputTokens costUsd shareOfCostPct shareOfCallsPct unpriced }
      steps { step callsPerInvocation avgInputTokens avgOutputTokens costUsd shareOfCostPct }
      declaredRoles { role stepHint expectedCalls observed }
      daily { ${$3ece07ed3ee6f427$var$DAILY_FIELDS} }
      pricing {
        basisCostUsd basisSource basisSample fxTomanPerUsd parsehToman
        computedParseh overrideParseh effectiveParseh marginPct policyId policyName
        creditPrice creditCurrency
      }
      billedMinutes audioMinutesSent
    }
  }
`;
const $3ece07ed3ee6f427$export$fd8ae8d35dcf3788 = `
  query AiInvocations($filter: AiInvocationFilter!, $page: Int!, $pageSize: Int!) {
    aiInvocations(filter: $filter, page: $page, pageSize: $pageSize) {
      invocations { ${$3ece07ed3ee6f427$var$INVOCATION_FIELDS} }
      total page pageSize
    }
  }
`;
const $3ece07ed3ee6f427$export$159e6a3d72bee3d9 = `
  query AiInvocation($requestId: ID!) {
    aiInvocation(requestId: $requestId) {
      invocation { ${$3ece07ed3ee6f427$var$INVOCATION_FIELDS} }
      calls {
        id step role provider modelId inputTokens outputTokens cachedTokens audioSeconds
        tokensEstimated priceId costUsd providerCostUsd latencyMs status calledAt
      }
    }
  }
`;
const $3ece07ed3ee6f427$export$8b221c1a60d2c3e2 = `
  query AiLedgerOptions($window: CostWindow!) {
    aiServices(window: $window, includeInactive: true) {
      services { serviceKey labelFa labelEn }
    }
    aiModels(window: $window, includeDeprecated: true) { modelId }
  }
`;
const $3ece07ed3ee6f427$export$f4a42e7153fdade0 = `
  query AiPricingPolicies {
    aiPricingPolicies { ${$3ece07ed3ee6f427$var$POLICY_FIELDS} }
  }
`;
const $3ece07ed3ee6f427$export$84ae42ec2dcc16d3 = `
  query AiPricingPolicy($id: ID!) {
    aiPricingPolicy(id: $id) { ${$3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS} }
  }
`;
const $3ece07ed3ee6f427$export$98b1d4a88625c723 = `
  query CreditPricing {
    creditPricing { parsehToman creditPrice { amountMinor currency } }
  }
`;
const $3ece07ed3ee6f427$export$236ee48da43a068e = `
  query AiPricingEvents($page: Int!, $pageSize: Int!) {
    aiPricingEvents(page: $page, pageSize: $pageSize) {
      events { id at actorSub kind entity entityId before after }
      total
    }
  }
`;
const $3ece07ed3ee6f427$export$b8d505c6d165d5f = `
  mutation SaveAiPricingPolicyDraft($id: ID, $cloneFromId: ID, $input: AiPricingPolicyInput!, $expectedVersion: Int) {
    saveAiPricingPolicyDraft(id: $id, cloneFromId: $cloneFromId, input: $input, expectedVersion: $expectedVersion) {
      ${$3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS}
    }
  }
`;
const $3ece07ed3ee6f427$export$93fcc4313bb8f40f = `
  mutation SimulateAiPricingPolicy($id: ID, $input: AiPricingPolicyInput) {
    simulateAiPricingPolicy(id: $id, input: $input) { ${$3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS} }
  }
`;
const $3ece07ed3ee6f427$export$2e5e77992ce92703 = `
  mutation SetAiServiceOverride($policyId: ID!, $serviceKey: ID!, $parseh: String, $expectedVersion: Int!) {
    setAiServiceOverride(policyId: $policyId, serviceKey: $serviceKey, parseh: $parseh, expectedVersion: $expectedVersion) {
      ${$3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS}
    }
  }
`;
const $3ece07ed3ee6f427$export$74a6d36ce8e6a68a = `
  mutation ActivateAiPricingPolicy($id: ID!, $expectedVersion: Int!) {
    activateAiPricingPolicy(id: $id, expectedVersion: $expectedVersion) { ${$3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS} }
  }
`;
const $3ece07ed3ee6f427$export$935985951b6b72f6 = `
  mutation ArchiveAiPricingPolicy($id: ID!) {
    archiveAiPricingPolicy(id: $id) { ${$3ece07ed3ee6f427$var$POLICY_DETAIL_FIELDS} }
  }
`;
const $3ece07ed3ee6f427$export$13d314dcdb28d936 = `
  query AiFxRates($page: Int!, $pageSize: Int!) {
    aiFxRates(page: $page, pageSize: $pageSize) {
      rates {
        id rateDate fetchedAt source quotedAt marketTomanPerUsd premiumPct fxTomanPerUsd
        status reason outcome policyId
      }
      total page pageSize
    }
  }
`;
const $3ece07ed3ee6f427$export$d1d6015cb7566cb0 = `
  mutation SimulateAiNightlyFx($policyId: ID, $marketToman: String) {
    simulateAiNightlyFx(policyId: $policyId, marketToman: $marketToman) {
      outcome status reason marketToman source quotedAt premiumPct fxToman currentFxToman
      baseFxToman policyId basePolicyId standIn repriceEnabled minChangePct maxStepPct whyHeld
      runAt
      changes { serviceKey unit fromParseh toParseh changePct marginPct tooLarge newlyNegative }
    }
  }
`;
const $3ece07ed3ee6f427$export$dfc0f3cce358cc87 = `
  query AiServiceLabels($window: CostWindow!) {
    aiServices(window: $window, includeInactive: true) {
      services { serviceKey labelFa labelEn }
    }
  }
`;
// ── visits (PM-0427) ──────────────────────────────────────────────────────────
// The operation names keep their «(»: fixtures route by `query.includes(name)`,
// and «query AiVisit» alone would also match «query AiVisits».
const $3ece07ed3ee6f427$var$VISIT_MONEY_FIELDS = 'policyId policyName policyStatus fxTomanPerUsd parsehToman creditPrice creditCurrency';
const $3ece07ed3ee6f427$var$VISIT_ROW_FIELDS = `
  appointmentId firstAt lastAt ownerType ownerId owners billedMinutes recordings runs
  chargedRuns earnedParseh earnedUsd paidUsd providerPaidUsd marginPct unpricedRuns
`;
const $3ece07ed3ee6f427$var$VISIT_FEATURE_FIELDS = `
  key labelFa labelEn group visitsUsing shareOfVisits runsPerVisit chargedRunsPerVisit
  earnedParsehPerVisit earnedUsdPerVisit paidUsdPerVisit marginPct pricedShare unpricedRuns
`;
const $3ece07ed3ee6f427$export$ee9e628a7c3681e3 = `
  query AiVisitEconomics($window: CostWindow!, $filter: AiVisitFilter, $policyId: ID) {
    aiVisitEconomics(window: $window, filter: $filter, policyId: $policyId) {
      stats {
        visits recordedVisits runsPerVisit chargedRunsPerVisit recordingsPerVisit meanBilledMinutes
        totalEarnedParseh meanEarnedParseh p50EarnedParseh p90EarnedParseh meanEarnedUsd
        totalPaidUsd meanPaidUsd p50PaidUsd p90PaidUsd pricedVisits meanProviderPaidUsd
        marginPct pricedShare unpricedRuns
      }
      groups {
        total { ${$3ece07ed3ee6f427$var$VISIT_FEATURE_FIELDS} }
        services { ${$3ece07ed3ee6f427$var$VISIT_FEATURE_FIELDS} }
      }
      byMinutes {
        bucket minMinutes maxMinutes visits meanEarnedParseh meanEarnedUsd meanPaidUsd marginPct
        pricedVisits
      }
      unattributed {
        serviceKey labelFa labelEn group runs withoutIdRuns chargedRuns earnedParseh earnedUsd
        paidUsd unpricedRuns perVisitEarnedParseh perVisitPaidUsd
      }
      money { ${$3ece07ed3ee6f427$var$VISIT_MONEY_FIELDS} }
    }
  }
`;
const $3ece07ed3ee6f427$export$55ebeb4628201c = `
  query AiVisits($window: CostWindow!, $filter: AiVisitFilter, $policyId: ID, $page: Int!, $pageSize: Int!, $sort: String) {
    aiVisits(window: $window, filter: $filter, policyId: $policyId, page: $page, pageSize: $pageSize, sort: $sort) {
      visits { ${$3ece07ed3ee6f427$var$VISIT_ROW_FIELDS} }
      total page pageSize
      money { ${$3ece07ed3ee6f427$var$VISIT_MONEY_FIELDS} }
    }
  }
`;
const $3ece07ed3ee6f427$export$512faac54c275f2e = `
  query AiVisit($appointmentId: ID!, $policyId: ID) {
    aiVisit(appointmentId: $appointmentId, policyId: $policyId) {
      visit { ${$3ece07ed3ee6f427$var$VISIT_ROW_FIELDS} }
      lines {
        serviceKey labelFa labelEn group runs chargedRuns earnedParseh earnedUsd paidUsd
        providerPaidUsd unpricedRuns billedMinutes
      }
      invocations { ${$3ece07ed3ee6f427$var$INVOCATION_FIELDS} }
      money { ${$3ece07ed3ee6f427$var$VISIT_MONEY_FIELDS} }
      invocationsTruncated
    }
  }
`;
const $3ece07ed3ee6f427$export$484ee2a5146b27cf = `
  query AiVisitOptions($window: CostWindow!) {
    aiServices(window: $window, includeInactive: true) {
      services { serviceKey labelFa labelEn }
    }
    aiPricingPolicies { id name status fxSource }
  }
`;



parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $88e75a6fb6edc067$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Activity", [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $52885985d1db6c06$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("DollarSign", [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "2",
            y2: "22",
            key: "7eqyqh"
        }
    ],
    [
        "path",
        {
            d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
            key: "1b0p4s"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b97e024910b40ff$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Percent", [
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "5",
            y2: "19",
            key: "1x9vlm"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "6.5",
            r: "2.5",
            key: "4mh3h7"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "2.5",
            key: "1mdrzq"
        }
    ]
]);








var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $864b7a37d506b74d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Link2", [
    [
        "path",
        {
            d: "M9 17H7A5 5 0 0 1 7 7h2",
            key: "8i5ue5"
        }
    ],
    [
        "path",
        {
            d: "M15 7h2a5 5 0 1 1 0 10h-2",
            key: "1b9ql8"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "12",
            y2: "12",
            key: "1jonct"
        }
    ]
]);







parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






function $b758277144067032$export$77dd77850115e3ad() {
    const { readsPersianData: readsPersianData } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((row)=>(readsPersianData ? row?.labelFa : row?.labelEn) || row?.labelFa || row?.labelEn || row?.serviceKey || (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58), [
        readsPersianData
    ]);
}
function $b758277144067032$export$fd47d6972da0c54a(prefix) {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        if (value == null || value === '') return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
        const key = `${prefix}.${value}`;
        return has && has(key) ? t(key) : String(value);
    }, [
        t,
        has,
        prefix
    ]);
}
function $b758277144067032$export$52f0f02147b12c03({ children: children, className: className = '', title: title }) {
    if (children == null || children === '') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: `font-mono text-[12px] ${className}`,
        title: title,
        children: children
    });
}
function $b758277144067032$export$f6baea096b75c630({ value: value, title: title, className: className = '' }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `tabular-nums ${className}`,
        title: title,
        children: (0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(value, {
            formatNumber: formatNumber,
            t: t
        })
    });
}
function $b758277144067032$export$f44e97762c5ad47d({ value: value, suffix: suffix, className: className = '' }) {
    const { formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: `tabular-nums ${className}`,
        children: [
            n == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber(n, {
                maximumFractionDigits: 2
            }),
            n != null && suffix ? suffix : null
        ]
    });
}
function $b758277144067032$export$929d988af23c0aeb({ value: value, className: className = '' }) {
    const { formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `tabular-nums ${className}`,
        children: n == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber(n, {
            maximumFractionDigits: 0
        })
    });
}
function $b758277144067032$export$7105c6425efc4723({ value: value, options: options, className: className = '' }) {
    const { formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `tabular-nums ${className}`,
        children: n == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber(n, options)
    });
}
function $b758277144067032$export$b39126116ceb31d8({ value: value, className: className = '' }) {
    const { formatPercent: formatPercent } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `tabular-nums ${className}`,
        children: n == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatPercent(n)
    });
}
function $b758277144067032$export$db52fc8e9d633a4({ value: value, 'data-testid': testId }) {
    const { formatPercent: formatPercent } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    if (n == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "data-testid": testId,
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    const variant = n < 0 ? 'destructive' : n < 30 ? 'warning' : 'success';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: variant,
        className: "tabular-nums",
        "data-testid": testId,
        "data-tone": variant,
        children: formatPercent(n)
    });
}
function $b758277144067032$export$330c7c36e660c06a({ source: source }) {
    const { t: t, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const { kind: kind, id: id } = (0, $ad1ad54ff7f74a69$export$47713a0f1f69cef5)(source);
    if (kind === 'policy') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "outline",
        children: t('aiPricing.services.source.policy', {
            id: formatDigits(id)
        })
    });
    if (kind === 'override') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "default",
        children: t('aiPricing.services.source.override')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "warning",
        children: t('aiPricing.services.source.code_default')
    });
}
async function $b758277144067032$export$c8531afc97e1e0f8(text) {
    try {
        if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch  {}
    try {
        const area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.className = 'sr-only';
        document.body.appendChild(area);
        area.select();
        const ok = document.execCommand ? document.execCommand('copy') : false;
        area.remove();
        return !!ok;
    } catch  {
        return false;
    }
}
function $b758277144067032$export$935c32d013fb644d({ columns: columns, rows: rows, disabled: disabled, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const onClick = async ()=>{
        const ok = await $b758277144067032$export$c8531afc97e1e0f8((0, $ad1ad54ff7f74a69$export$171e304ea3e0c0ae)(columns, rows));
        if (ok) toast.success(t('aiPricing.csv.copied'));
        else toast.error(t('aiPricing.csv.failed'));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onClick,
        disabled: disabled || !rows?.length,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26cec67c26de53a9$export$2e2bcd8739ae039), {
                size: 14,
                "aria-hidden": true
            }),
            t('aiPricing.csv.export')
        ]
    });
}
function $b758277144067032$export$c0b7ebe42c310b67({ open: open, onClose: onClose, title: title, sub: sub, width: width = 640, children: children, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('esc', onClose, {
        label: t('shortcuts.action.closeDrawer'),
        group: t('shortcuts.groups.aiPricing'),
        enabled: open
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": typeof title === 'string' ? title : undefined,
            className: "flex h-full min-h-0 flex-col",
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$bb68d554ded258ea), {
                    title: title,
                    sub: sub,
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$4ed8420cdfcb2b8f), {
                    children: children
                })
            ]
        })
    });
}
function $b758277144067032$export$7afc19c20799c3c1({ cols: cols = 8, rows: rows = 8, label: label, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": testId,
        "data-state": "loading",
        role: "status",
        "aria-busy": "true",
        "aria-label": label,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: Array.from({
                    length: rows
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                        cols: cols
                    }, i))
            })
        })
    });
}
function $b758277144067032$export$830e362f63e40ce4({ lines: lines = 4, height: height = 14 }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col gap-3",
        "aria-hidden": true,
        children: Array.from({
            length: lines
        }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                width: `${90 - i % 3 * 20}%`,
                height: height
            }, i))
    });
}
function $b758277144067032$export$4b67f8be7a5e4a15({ label: label, value: value, ltr: ltr }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-w-0",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                className: "text-xs text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                className: "truncate font-semibold text-foreground",
                ...ltr ? (0, $c53f9539af19d960$export$3433559efc22d110) : {},
                children: value == null || value === '' ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : value
            })
        ]
    });
}


const $a3efca5e6be95bd1$export$897b8ff0ab6a0edf = (modelId)=>String(modelId || '').split('/').pop();
function $a3efca5e6be95bd1$export$2e2bcd8739ae039({ models: models = [], max: max = 3 }) {
    const { t: t, formatPercent: formatPercent } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const shown = models.slice(0, max);
    const rest = models.slice(max);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex flex-wrap items-center gap-1",
        children: [
            shown.map((m)=>{
                const share = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(m.shareOfCostPct);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: m.unpriced ? 'destructive' : 'outline',
                    title: m.modelId,
                    className: "gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                            children: $a3efca5e6be95bd1$export$897b8ff0ab6a0edf(m.modelId)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            "aria-hidden": true,
                            children: "\xb7"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tabular-nums",
                            children: m.unpriced ? t('aiPricing.models.status.unknown') : share == null ? t('common.value.none') : formatPercent(share)
                        })
                    ]
                }, `${m.modelId}:${m.role}`);
            }),
            rest.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                variant: "outline",
                title: rest.map((m)=>m.modelId).join(', '),
                children: t('aiPricing.services.moreModels', {
                    count: rest.length
                })
            }) : null
        ]
    });
}



function $bafc3d1f52abf20d$export$2e2bcd8739ae039({ serviceKey: serviceKey, window: window, href: href, 'data-testid': testId = 'ai-overview-chain' }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const basisLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.services.drawer.basisSource');
    const [detail, setDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$a23fde56dda002a7), {
            serviceKey: serviceKey,
            window: window
        }).then((d)=>setDetail(d?.aiServiceDetail || null)).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        serviceKey,
        window,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const row = detail?.row;
    const pricing = detail?.pricing;
    const steps = row ? [
        {
            key: 'agent',
            label: t('aiPricing.overview.chain.agent'),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: label(row)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                        children: row.serviceKey
                    })
                ]
            })
        },
        {
            key: 'models',
            label: t('aiPricing.overview.chain.models'),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3efca5e6be95bd1$export$2e2bcd8739ae039), {
                models: detail.models?.length ? detail.models : row.models
            })
        },
        {
            key: 'tokens',
            label: t('aiPricing.overview.chain.tokens'),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "tabular-nums",
                children: t('aiPricing.overview.chain.tokensValue', {
                    input: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(row.avgInputTokens) == null ? t('common.value.none') : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(row.avgInputTokens), {
                        maximumFractionDigits: 0
                    }),
                    output: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(row.avgOutputTokens) == null ? t('common.value.none') : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(row.avgOutputTokens), {
                        maximumFractionDigits: 0
                    })
                })
            })
        },
        {
            key: 'usd',
            label: t('aiPricing.overview.chain.usd'),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                        value: row.meanCostUsd
                    }),
                    " ",
                    t('common.units.usd')
                ]
            })
        },
        {
            key: 'loaded',
            label: t('aiPricing.overview.chain.loaded'),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "inline-flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                        value: pricing?.basisCostUsd
                    }),
                    " ",
                    t('common.units.usd'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: "outline",
                        children: basisLabel(pricing?.basisSource)
                    })
                ]
            })
        },
        {
            key: 'policy',
            label: t('aiPricing.overview.chain.policy'),
            value: pricing?.policyName || t('aiPricing.overview.chain.codeDefault')
        },
        {
            key: 'price',
            label: t('aiPricing.overview.chain.price'),
            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "inline-flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                        value: row.effectiveParseh,
                        suffix: row.unit === 'minute' ? t('aiPricing.units.perMinute') : ''
                    }),
                    t('common.units.parseh'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                        value: row.marginPct
                    })
                ]
            })
        }
    ] : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        title: t('aiPricing.overview.chain.title'),
        sub: t('aiPricing.overview.chain.sub'),
        icon: (0, $864b7a37d506b74d$export$2e2bcd8739ae039),
        "data-testid": testId,
        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-state": "loading",
            role: "status",
            "aria-busy": "true",
            "aria-label": t('aiPricing.overview.chain.loading'),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
                lines: 2,
                height: 40
            })
        }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('aiPricing.overview.chain.error'),
            description: error,
            onRetry: load,
            retryLabel: t('common.actions.retry'),
            "data-testid": `${testId}-error`
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
            to: href,
            className: "block rounded-lg outline-none transition-colors hover:bg-muted focus-visible:ring-2 focus-visible:ring-ring",
            "aria-label": `${t('aiPricing.overview.chain.open')}: ${label(row)}`,
            "data-testid": `${testId}-link`,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                className: "flex flex-wrap items-stretch gap-2 p-1",
                children: steps.map((step, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "min-w-[8rem] rounded-lg border border-border bg-card px-3 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-[11px] text-muted-foreground",
                                        children: step.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-1 text-sm text-foreground",
                                        children: step.value
                                    })
                                ]
                            }),
                            i < steps.length - 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true,
                                style: (0, $c53f9539af19d960$export$ddb338179359cccc),
                                className: "shrink-0 text-muted-foreground"
                            }) : null
                        ]
                    }, step.key))
            })
        })
    });
}




const $bef04d4396ec295a$var$TOP_N = 8;
function $bef04d4396ec295a$export$2e2bcd8739ae039({ overview: overview, loading: loading, error: error, onRetry: onRetry, window: window, view: view, go: go }) {
    const { t: t, formatNumber: formatNumber, formatPercent: formatPercent, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const ownerChips = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "group",
        "aria-label": t('aiPricing.overview.owner.label'),
        className: "mb-4 flex flex-wrap items-center gap-1.5",
        "data-testid": "ai-overview-owner",
        children: [
            '',
            ...(0, $ad1ad54ff7f74a69$export$60b33fb147a66c)
        ].map((value)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                label: t(`aiPricing.overview.owner.${value || 'all'}`),
                active: (view.owner || '') === value,
                onClick: ()=>go({
                        owner: value
                    }),
                "data-testid": `ai-overview-owner-${value || 'all'}`
            }, value || 'all'))
    });
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ownerChips,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bef04d4396ec295a$var$OverviewSkeleton, {
                label: t('aiPricing.overview.loading')
            })
        ]
    });
    if (error || !overview) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            ownerChips,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('aiPricing.overview.error'),
                description: error || t('errors.region.noAnswer'),
                onRetry: onRetry,
                retryLabel: t('common.actions.retry'),
                "data-testid": "ai-overview-error"
            })
        ]
    });
    const o = overview;
    const usd = (v)=>(0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(v, {
            formatNumber: formatNumber,
            t: t
        });
    const pct = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatPercent((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v));
    const kpis = [
        {
            key: 'cost',
            label: t('aiPricing.overview.kpi.cost'),
            value: usd(o.totalCostUsd),
            unit: t('common.units.usd'),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight
        },
        // Toman is a plain number + the unit word — NOT `formatMoney`, which takes
        // rials and would show a tenth of the figure.
        // Only where a credit is priced in toman (PM-0211): a USD deployment has no
        // FX, so no toman cost exists to show.
        (0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(o.creditCurrency) ? {
            key: 'costToman',
            label: t('aiPricing.overview.kpi.costToman'),
            value: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.totalCostToman) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.totalCostToman), {
                maximumFractionDigits: 0
            }),
            unit: t('common.units.toman'),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight
        } : null,
        {
            key: 'revenue',
            label: t('aiPricing.overview.kpi.revenue'),
            value: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.revenueParseh) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.revenueParseh), {
                maximumFractionDigits: 0
            }),
            unit: t('common.units.parseh'),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight
        },
        {
            key: 'blended',
            label: t('aiPricing.overview.kpi.blended'),
            hint: t('aiPricing.overview.kpi.blendedHint'),
            value: usd(o.blendedCostPerParsehUsd),
            unit: t('common.units.usd'),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c424bab0bc0a95$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight
        },
        {
            key: 'margin',
            label: t('aiPricing.overview.kpi.margin'),
            value: pct(o.blendedMarginPct),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b97e024910b40ff$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.blendedMarginPct) != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.blendedMarginPct) < 0 ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
            }),
            bg: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.blendedMarginPct) != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(o.blendedMarginPct) < 0 ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight
        },
        {
            key: 'invocations',
            label: t('aiPricing.overview.kpi.invocations'),
            sub: t('aiPricing.overview.kpi.invocationsSub', {
                calls: o.calls ?? 0
            }),
            value: formatNumber(o.invocations ?? 0),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight
        }
    ].filter(Boolean);
    const daily = o.daily || [];
    const costReadings = daily.map((d)=>({
            id: d.day,
            value: d.costUsd,
            day: d.day
        }));
    const revenueReadings = daily.map((d)=>({
            id: d.day,
            value: d.revenueUsd,
            day: d.day
        }));
    const formatX = (r)=>formatDate(r.day, 'dayMonth');
    const formatAxis = (v)=>formatNumber(v, {
            maximumFractionDigits: 2
        });
    const breakdown = (items, hrefOf, labelOf)=>{
        const list = items || [];
        const top = list.slice(0, $bef04d4396ec295a$var$TOP_N);
        const rest = list.slice($bef04d4396ec295a$var$TOP_N);
        const rows = top.map((x)=>({
                key: x.key,
                label: labelOf ? labelOf(x) : x.label || x.key,
                title: x.label || x.key,
                value: usd(x.costUsd),
                percent: Math.max(0, Math.min(100, Math.round((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(x.sharePct) ?? 0))),
                tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                extra: formatNumber(x.count ?? 0),
                href: hrefOf(x)
            }));
        if (rest.length) {
            // «سایر» is a DISPLAY aggregate of what the top eight leave out; the
            // figures are the BFF's, added for the row rather than derived anew.
            const restCost = rest.reduce((s, x)=>s + ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(x.costUsd) ?? 0), 0);
            const restShare = rest.reduce((s, x)=>s + ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(x.sharePct) ?? 0), 0);
            rows.push({
                key: '__other',
                label: t('aiPricing.overview.other'),
                value: usd(restCost),
                percent: Math.max(0, Math.min(100, Math.round(restShare))),
                tone: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                extra: formatNumber(rest.reduce((s, x)=>s + (x.count || 0), 0))
            });
        }
        return rows;
    };
    const byService = breakdown(o.byService, (x)=>`/ai-pricing?view=services&service=${encodeURIComponent(x.key)}&w=${view.w}`);
    const byModel = breakdown(o.byModel, (x)=>`/ai-pricing?view=models&model=${encodeURIComponent(x.key)}&w=${view.w}`, (x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
            children: (0, $a3efca5e6be95bd1$export$897b8ff0ab6a0edf)(x.label || x.key)
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-overview",
        "data-state": "content",
        children: [
            ownerChips,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-3.5 md:grid-cols-3 xl:grid-cols-6",
                "data-testid": "ai-overview-kpis",
                children: kpis.map((kpi)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        title: kpi.hint,
                        "data-testid": `ai-overview-kpi-${kpi.key}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                            minWidth: 0,
                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "block",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block",
                                        children: kpi.label
                                    }),
                                    kpi.sub ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "mt-0.5 block text-[10.5px] text-muted-foreground",
                                        children: kpi.sub
                                    }) : null
                                ]
                            }),
                            value: kpi.value,
                            unit: kpi.unit,
                            icon: kpi.icon,
                            bg: kpi.bg
                        })
                    }, kpi.key))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-5 grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-col gap-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('aiPricing.overview.chart.title'),
                                sub: t('aiPricing.overview.chart.sub'),
                                icon: (0, $c9921f4f81a419f0$export$2e2bcd8739ae039),
                                "data-testid": "ai-overview-chart",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid grid-cols-1 gap-4 md:grid-cols-2",
                                        children: [
                                            {
                                                key: 'cost',
                                                label: t('aiPricing.overview.chart.cost'),
                                                readings: costReadings,
                                                color: (0, $e7c165fb515b04ea$export$c7989e6ff0cf1179)[2]
                                            },
                                            {
                                                key: 'revenue',
                                                label: t('aiPricing.overview.chart.revenue'),
                                                readings: revenueReadings,
                                                color: (0, $e7c165fb515b04ea$export$c7989e6ff0cf1179)[1]
                                            }
                                        ].map((series)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                "data-testid": `ai-overview-chart-${series.key}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mb-1 inline-flex items-center gap-1.5 text-xs text-muted-foreground",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "inline-block h-2.5 w-2.5 rounded-sm",
                                                                style: {
                                                                    background: series.color
                                                                },
                                                                "aria-hidden": true
                                                            }),
                                                            series.label
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7b57ad44712e2b0$export$2e2bcd8739ae039), {
                                                        readings: series.readings,
                                                        color: series.color,
                                                        height: 150,
                                                        formatX: formatX,
                                                        formatValue: formatAxis,
                                                        emptyLabel: t('aiPricing.overview.chart.empty')
                                                    })
                                                ]
                                            }, series.key))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-xs text-muted-foreground",
                                        children: t('aiPricing.overview.chart.summary', {
                                            days: daily.length,
                                            cost: usd(o.totalCostUsd),
                                            revenue: usd(o.revenueUsd)
                                        })
                                    })
                                ]
                            }),
                            o.mostExpensiveService ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bafc3d1f52abf20d$export$2e2bcd8739ae039), {
                                serviceKey: o.mostExpensiveService,
                                window: window,
                                href: `/ai-pricing?view=services&service=${encodeURIComponent(o.mostExpensiveService)}&w=${view.w}`
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-w-0 flex-col gap-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('aiPricing.overview.byService.title'),
                                sub: t('aiPricing.overview.byService.sub'),
                                icon: (0, $40c424bab0bc0a95$export$2e2bcd8739ae039),
                                children: byService.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06825f2e23315751$export$2e2bcd8739ae039), {
                                    rows: byService,
                                    "data-testid": "ai-overview-by-service"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-2 text-sm text-muted-foreground",
                                    "data-testid": "ai-overview-by-service-empty",
                                    children: t('aiPricing.overview.breakdownEmpty')
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                title: t('aiPricing.overview.byModel.title'),
                                sub: t('aiPricing.overview.byModel.sub'),
                                icon: (0, $40c424bab0bc0a95$export$2e2bcd8739ae039),
                                children: byModel.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06825f2e23315751$export$2e2bcd8739ae039), {
                                    rows: byModel,
                                    "data-testid": "ai-overview-by-model"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "py-2 text-sm text-muted-foreground",
                                    "data-testid": "ai-overview-by-model-empty",
                                    children: t('aiPricing.overview.breakdownEmpty')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/** Six KPI blocks in the real grid, then the P2 shape — nothing jumps on arrival. */ function $bef04d4396ec295a$var$OverviewSkeleton({ label: label }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "ai-overview-loading",
        "data-state": "loading",
        role: "status",
        "aria-busy": "true",
        "aria-label": label,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-3.5 md:grid-cols-3 xl:grid-cols-6",
                children: Array.from({
                    length: 6
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl border border-border bg-card p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                width: "60%",
                                height: 22
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                    width: "80%",
                                    height: 11
                                })
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e8859e855a5dc92a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Cpu", [
    [
        "rect",
        {
            width: "16",
            height: "16",
            x: "4",
            y: "4",
            rx: "2",
            key: "14l7u7"
        }
    ],
    [
        "rect",
        {
            width: "6",
            height: "6",
            x: "9",
            y: "9",
            rx: "1",
            key: "5aljv4"
        }
    ],
    [
        "path",
        {
            d: "M15 2v2",
            key: "13l42r"
        }
    ],
    [
        "path",
        {
            d: "M15 20v2",
            key: "15mkzm"
        }
    ],
    [
        "path",
        {
            d: "M2 15h2",
            key: "1gxd5l"
        }
    ],
    [
        "path",
        {
            d: "M2 9h2",
            key: "1bbxkp"
        }
    ],
    [
        "path",
        {
            d: "M20 15h2",
            key: "19e6y8"
        }
    ],
    [
        "path",
        {
            d: "M20 9h2",
            key: "19tzq7"
        }
    ],
    [
        "path",
        {
            d: "M9 2v2",
            key: "165o2o"
        }
    ],
    [
        "path",
        {
            d: "M9 20v2",
            key: "i2bqo8"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a72a452dcd95d49b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("SearchX", [
    [
        "path",
        {
            d: "m13.5 8.5-5 5",
            key: "1cs55j"
        }
    ],
    [
        "path",
        {
            d: "m8.5 8.5 5 5",
            key: "a8mexj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
]);









parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8872a1d80d2463f9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Tag", [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
]);






const $d0f1d11436befcdb$var$STATUS_VARIANT = {
    active: 'success',
    deprecated: 'outline',
    unknown: 'destructive'
};
function $d0f1d11436befcdb$export$2e2bcd8739ae039({ rows: rows, view: view, onSort: onSort, onOpen: onOpen, onPrice: onPrice, empty: empty }) {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const usd = (v)=>(0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(v, {
            formatNumber: formatNumber,
            t: t
        });
    const providerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.provider');
    const modalityLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.modality');
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.status');
    const audio = (price)=>{
        if (!price) return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
        if ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(price.audioUsdPerMinute) != null) return t('aiPricing.models.audioPerMinute', {
            value: usd(price.audioUsdPerMinute)
        });
        if ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(price.audioInputUsdPerM) != null) return t('aiPricing.models.audioPerM', {
            value: usd(price.audioInputUsdPerM)
        });
        return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
    };
    const columns = [
        {
            key: 'model',
            header: t('aiPricing.models.columns.model'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate font-semibold text-foreground",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                title: r.modelId,
                                children: r.modelId
                            })
                        }),
                        r.displayName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate text-xs text-muted-foreground",
                            children: r.displayName
                        }) : null
                    ]
                })
        },
        {
            key: 'provider',
            header: t('aiPricing.models.columns.provider'),
            width: '7rem',
            render: (r)=>providerLabel(r.provider)
        },
        {
            key: 'modalities',
            header: t('aiPricing.models.columns.modalities'),
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "inline-flex flex-wrap gap-1",
                    children: (r.modalities || []).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: modalityLabel(m)
                        }, m))
                })
        },
        {
            key: 'status',
            header: t('aiPricing.models.columns.status'),
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: $d0f1d11436befcdb$var$STATUS_VARIANT[r.status] || 'outline',
                    children: statusLabel(r.status)
                })
        },
        {
            key: 'input',
            header: t('aiPricing.models.columns.input'),
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                    value: r.currentPrice?.inputUsdPerM
                })
        },
        {
            key: 'output',
            header: t('aiPricing.models.columns.output'),
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                    value: r.currentPrice?.outputUsdPerM
                })
        },
        {
            key: 'audio',
            header: t('aiPricing.models.columns.audio'),
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tabular-nums",
                    children: audio(r.currentPrice)
                })
        },
        {
            key: 'since',
            header: t('aiPricing.models.columns.since'),
            width: '8rem',
            render: (r)=>r.currentPrice?.effectiveFrom ? formatDate(r.currentPrice.effectiveFrom) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'calls',
            header: t('aiPricing.models.columns.calls'),
            sortable: true,
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                    value: r.callsInWindow
                })
        },
        {
            key: 'cost',
            header: t('aiPricing.models.columns.cost'),
            sortable: true,
            align: 'end',
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                    value: r.costUsdInWindow
                })
        },
        {
            key: 'actions',
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: t('aiPricing.models.columns.actions')
            }),
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: r.status === 'unknown' ? 'default' : 'ghost',
                    size: "sm",
                    onClick: (e)=>{
                        e.stopPropagation();
                        onPrice(r);
                    },
                    "data-testid": `ai-models-row-${r.modelId}-price`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": true
                        }),
                        r.status === 'unknown' ? t('aiPricing.models.setPrice') : t('aiPricing.models.updatePrice')
                    ]
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.models.tableAria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.modelId,
        onRowActivate: onOpen,
        rowProps: (r)=>({
                'data-testid': `ai-models-row-${r.modelId}`,
                'aria-label': t('aiPricing.models.open', {
                    model: r.modelId
                })
            }),
        sort: {
            key: view.sort || 'cost',
            dir: view.dir || 'desc'
        },
        onSort: onSort,
        empty: empty,
        "data-testid": "ai-models-table"
    });
}




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");







const $cf95a4b1c84d9327$var$SOURCES = [
    'manual',
    'openrouter_api'
];
const $cf95a4b1c84d9327$export$cea9846d43ecc40e = (now = new Date())=>{
    const tehran = new Date(now.getTime() + (210 + now.getTimezoneOffset()) * 60000);
    return tehran.toISOString().slice(0, 10);
};
const $cf95a4b1c84d9327$export$b76a2e1c37878c58 = (date)=>new Date(`${date}T00:00:00+03:30`).toISOString();
function $cf95a4b1c84d9327$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, model: model, onDone: onDone }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [effectiveFrom, setEffectiveFrom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($cf95a4b1c84d9327$export$cea9846d43ecc40e());
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [source, setSource] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('manual');
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirmBackdate, setConfirmBackdate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setEffectiveFrom($cf95a4b1c84d9327$export$cea9846d43ecc40e());
        setFields({});
        setSource('manual');
        setNote('');
        setError(null);
        setConfirmBackdate(false);
    }, [
        open
    ]);
    const set = (key)=>(e)=>setFields((f)=>({
                    ...f,
                    [key]: e.target?.value ?? e
                }));
    const rates = [
        'inputUsdPerM',
        'outputUsdPerM',
        'cachedInputUsdPerM',
        'audioInputUsdPerM',
        'audioUsdPerMinute',
        'requestUsd'
    ];
    const hasRate = rates.some((k)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(fields[k]) != null);
    const dirty = hasRate || !!note || effectiveFrom !== $cf95a4b1c84d9327$export$cea9846d43ecc40e();
    const backdated = !!effectiveFrom && effectiveFrom < $cf95a4b1c84d9327$export$cea9846d43ecc40e();
    const validate = (v)=>{
        if (!v) return '';
        const n = Number(v);
        if (!Number.isFinite(n) || n < 0) return t('validation.required');
        return '';
    };
    const submit = async ()=>{
        setPending(true);
        setError(null);
        try {
            const input = {
                modelId: model.modelId,
                effectiveFrom: $cf95a4b1c84d9327$export$b76a2e1c37878c58(effectiveFrom),
                source: source,
                note: note.trim() || null,
                // Always: a price effective today already covers this morning's calls,
                // and the service bounds the recompute by `[effectiveFrom, now)` itself.
                recompute: true
            };
            for (const k of rates)input[k] = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(fields[k]) == null ? null : String(fields[k]);
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$8dab3cf01b4320f2), {
                input: input
            });
            const result = d?.addAiModelPrice;
            toast.success(t('aiPricing.models.price.success'));
            if (result && (result.recomputedCalls || result.recomputedInvocations)) toast.info(t('aiPricing.models.price.recomputed', {
                calls: result.recomputedCalls || 0,
                invocations: result.recomputedInvocations || 0
            }));
            onOpenChange(false);
            onDone?.(result);
        } catch (e) {
            setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const onSubmit = ()=>{
        if (!hasRate) {
            setError(t('aiPricing.models.price.needOne'));
            return;
        }
        if (backdated) setConfirmBackdate(true);
        else submit();
    };
    const field = (key, labelKey)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
            label: t(`aiPricing.models.price.${labelKey}`),
            value: fields[key] || '',
            onChange: set(key),
            validate: validate,
            unit: t('common.units.usd'),
            "data-testid": `ai-models-price-${key}`
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
                open: open,
                onOpenChange: onOpenChange,
                title: model ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        t('aiPricing.models.price.title'),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                            children: model.modelId
                        })
                    ]
                }) : t('aiPricing.models.price.title'),
                error: error,
                pending: pending,
                dirty: dirty,
                submitLabel: t('aiPricing.models.price.submit'),
                submitDisabled: !effectiveFrom,
                onSubmit: onSubmit,
                "data-testid": "ai-models-price-dialog",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('aiPricing.models.price.effectiveFrom'),
                        helperText: t('aiPricing.models.price.effectiveFromHelp'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "ai-models-price-effective",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: effectiveFrom,
                                onChange: setEffectiveFrom,
                                placeholder: t('aiPricing.ledger.filters.datePlaceholder')
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: [
                            field('inputUsdPerM', 'input'),
                            field('outputUsdPerM', 'output'),
                            field('cachedInputUsdPerM', 'cached'),
                            field('audioInputUsdPerM', 'audioTokens'),
                            field('audioUsdPerMinute', 'audioMinute'),
                            field('requestUsd', 'request')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.models.price.source'),
                        value: source,
                        onChange: (e)=>setSource(e.target?.value ?? e),
                        options: $cf95a4b1c84d9327$var$SOURCES.map((s)=>({
                                value: s,
                                label: t(`aiPricing.models.drawer.source.${s}`)
                            })),
                        placeholder: t('aiPricing.models.price.source')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: t('aiPricing.models.price.note'),
                        value: note,
                        onChange: (e)=>setNote(e.target?.value ?? e),
                        rows: 2,
                        maxLength: 300,
                        showCount: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirmBackdate,
                onOpenChange: setConfirmBackdate,
                title: t('aiPricing.models.price.backdated.title'),
                description: t('aiPricing.models.price.backdated.body', {
                    date: formatDate($cf95a4b1c84d9327$export$b76a2e1c37878c58(effectiveFrom))
                }),
                confirmLabel: t('aiPricing.models.price.backdated.confirm'),
                cancelLabel: t('common.actions.cancel'),
                loading: pending,
                onConfirm: ()=>{
                    setConfirmBackdate(false);
                    submit();
                },
                "data-testid": "ai-models-price-backdate",
                confirmTestId: "ai-models-price-backdate-confirm"
            })
        ]
    });
}


const $38bf4301cc22c6ee$export$b35c40687956bf9e = [
    'openrouter',
    'google',
    'openai',
    'groq',
    'external'
];
const $38bf4301cc22c6ee$export$76ac7f5402ced8a5 = [
    'text',
    'vision',
    'audio_in',
    'audio_out',
    'embedding'
];
const $38bf4301cc22c6ee$var$STATUSES = [
    'active',
    'deprecated'
];
const $38bf4301cc22c6ee$var$MODEL_ID = /^[A-Za-z0-9][A-Za-z0-9._\/:-]*$/;
function $38bf4301cc22c6ee$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, model: model, onDone: onDone }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const editing = !!model;
    const [modelId, setModelId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [displayName, setDisplayName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [modalities, setModalities] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('active');
    const [notes, setNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [inputUsd, setInputUsd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [outputUsd, setOutputUsd] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setModelId(model?.modelId || '');
        setProvider(model?.provider || '');
        setDisplayName(model?.displayName || '');
        setModalities(model?.modalities || []);
        setStatus(model?.status === 'deprecated' ? 'deprecated' : 'active');
        setNotes(model?.notes || '');
        setInputUsd('');
        setOutputUsd('');
        setError(null);
    }, [
        open,
        model
    ]);
    const idInvalid = !!modelId && !$38bf4301cc22c6ee$var$MODEL_ID.test(modelId);
    const dirty = editing ? provider !== (model.provider || '') || displayName !== (model.displayName || '') || notes !== (model.notes || '') || status !== (model.status === 'deprecated' ? 'deprecated' : 'active') || modalities.join() !== (model.modalities || []).join() : !!(modelId || provider || displayName || notes || modalities.length || inputUsd || outputUsd);
    const submit = async ()=>{
        setPending(true);
        setError(null);
        try {
            const input = {
                modelId: modelId.trim(),
                provider: provider,
                displayName: displayName.trim() || null,
                modalities: modalities,
                status: status,
                notes: notes.trim() || null
            };
            if (!editing && ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(inputUsd) != null || (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(outputUsd) != null)) input.initialPrice = {
                modelId: modelId.trim(),
                effectiveFrom: (0, $cf95a4b1c84d9327$export$b76a2e1c37878c58)((0, $cf95a4b1c84d9327$export$cea9846d43ecc40e)()),
                inputUsdPerM: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(inputUsd) == null ? null : String(inputUsd),
                outputUsdPerM: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(outputUsd) == null ? null : String(outputUsd),
                source: 'manual'
            };
            await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$4475822d064e2b52), {
                input: input
            });
            toast.success(t('aiPricing.models.dialog.success'));
            onOpenChange(false);
            onDone?.();
        } catch (e) {
            setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: editing ? t('aiPricing.models.dialog.editTitle') : t('aiPricing.models.dialog.title'),
        error: error,
        pending: pending,
        dirty: dirty,
        submitLabel: t('aiPricing.models.dialog.submit'),
        submitDisabled: !modelId.trim() || idInvalid || !provider,
        onSubmit: submit,
        "data-testid": "ai-models-dialog",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('aiPricing.models.dialog.modelId'),
                required: true,
                value: modelId,
                onChange: (e)=>setModelId(e.target?.value ?? e),
                disabled: editing,
                dir: "ltr",
                helperText: t('aiPricing.models.dialog.modelIdHelp'),
                error: idInvalid ? t('aiPricing.models.dialog.modelIdInvalid') : undefined,
                inputStyle: {
                    fontFamily: 'monospace'
                },
                "data-testid": "ai-models-dialog-id"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "ai-models-dialog-provider",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                    label: t('aiPricing.models.dialog.provider'),
                    required: true,
                    value: provider,
                    onChange: (e)=>setProvider(e.target?.value ?? e),
                    options: $38bf4301cc22c6ee$export$b35c40687956bf9e.map((p)=>({
                            value: p,
                            label: t(`aiPricing.models.provider.${p}`)
                        })),
                    placeholder: t('aiPricing.models.dialog.providerPlaceholder')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('aiPricing.models.dialog.displayName'),
                value: displayName,
                onChange: (e)=>setDisplayName(e.target?.value ?? e),
                "data-testid": "ai-models-dialog-name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcaca06c97c91379$export$2e2bcd8739ae039), {
                label: t('aiPricing.models.dialog.modalities'),
                multi: true,
                value: modalities,
                onChange: setModalities,
                options: $38bf4301cc22c6ee$export$76ac7f5402ced8a5.map((m)=>({
                        value: m,
                        label: t(`aiPricing.models.modality.${m}`)
                    }))
            }),
            editing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                label: t('aiPricing.models.dialog.status'),
                value: status,
                onChange: (e)=>setStatus(e.target?.value ?? e),
                options: $38bf4301cc22c6ee$var$STATUSES.map((s)=>({
                        value: s,
                        label: t(`aiPricing.models.status.${s}`)
                    })),
                placeholder: t('aiPricing.models.dialog.status')
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                label: t('aiPricing.models.dialog.firstPrice'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                            label: t('aiPricing.models.price.input'),
                            value: inputUsd,
                            onChange: (e)=>setInputUsd(e.target?.value ?? e),
                            unit: t('common.units.usd'),
                            "data-testid": "ai-models-dialog-input-usd"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                            label: t('aiPricing.models.price.output'),
                            value: outputUsd,
                            onChange: (e)=>setOutputUsd(e.target?.value ?? e),
                            unit: t('common.units.usd'),
                            "data-testid": "ai-models-dialog-output-usd"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('aiPricing.models.dialog.notes'),
                value: notes,
                onChange: (e)=>setNotes(e.target?.value ?? e),
                rows: 2,
                maxLength: 500,
                showCount: true
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








function $e9bf4e2fc966d361$export$2e2bcd8739ae039({ model: model, modelId: modelId, onClose: onClose, onAddPrice: onAddPrice, onEdit: onEdit, reloadKey: reloadKey }) {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const usd = (v)=>(0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(v, {
            formatNumber: formatNumber,
            t: t
        });
    const providerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.provider');
    const modalityLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.modality');
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.status');
    const sourceLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.models.drawer.source');
    const [prices, setPrices] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$4b2a8d20113f379a), {
            modelId: modelId
        }).then((d)=>setPrices(d?.aiModelPrices || [])).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        modelId,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load,
        reloadKey
    ]);
    // Newest first: the version in force is the one the operator opened the
    // drawer to check.
    const history = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            ...prices || []
        ].sort((a, b)=>String(b.effectiveFrom).localeCompare(String(a.effectiveFrom)) || Number(b.id) - Number(a.id)), [
        prices
    ]);
    const csvColumns = [
        {
            key: 'effectiveFrom',
            header: t('aiPricing.models.drawer.columns.from'),
            value: (p)=>p.effectiveFrom
        },
        {
            key: 'inputUsdPerM',
            header: t('aiPricing.models.drawer.columns.input'),
            value: (p)=>p.inputUsdPerM
        },
        {
            key: 'outputUsdPerM',
            header: t('aiPricing.models.drawer.columns.output'),
            value: (p)=>p.outputUsdPerM
        },
        {
            key: 'cachedInputUsdPerM',
            header: t('aiPricing.models.drawer.columns.cached'),
            value: (p)=>p.cachedInputUsdPerM
        },
        {
            key: 'audio',
            header: t('aiPricing.models.drawer.columns.audio'),
            value: (p)=>p.audioUsdPerMinute ?? p.audioInputUsdPerM
        },
        {
            key: 'requestUsd',
            header: t('aiPricing.models.drawer.columns.request'),
            value: (p)=>p.requestUsd
        },
        {
            key: 'source',
            header: t('aiPricing.models.drawer.columns.source'),
            value: (p)=>p.source
        },
        {
            key: 'createdBy',
            header: t('aiPricing.models.drawer.columns.by'),
            value: (p)=>p.createdBy
        }
    ];
    const audioOf = (p)=>{
        if ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(p.audioUsdPerMinute) != null) return t('aiPricing.models.audioPerMinute', {
            value: usd(p.audioUsdPerMinute)
        });
        if ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(p.audioInputUsdPerM) != null) return t('aiPricing.models.audioPerM', {
            value: usd(p.audioInputUsdPerM)
        });
        return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$c0b7ebe42c310b67), {
        open: true,
        onClose: onClose,
        title: t('aiPricing.models.drawer.title'),
        sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
            children: modelId
        }),
        "data-testid": "ai-models-drawer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: onAddPrice,
                            "data-testid": "ai-models-drawer-add-price",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                t('aiPricing.models.drawer.addVersion')
                            ]
                        }),
                        model ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: onEdit,
                            "data-testid": "ai-models-drawer-edit",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                t('aiPricing.models.dialog.editTitle')
                            ]
                        }) : null
                    ]
                }),
                model ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                    className: "grid grid-cols-2 gap-4 text-sm",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                            label: t('aiPricing.models.columns.provider'),
                            value: providerLabel(model.provider)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                            label: t('aiPricing.models.columns.status'),
                            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                variant: model.status === 'unknown' ? 'destructive' : model.status === 'active' ? 'success' : 'outline',
                                children: statusLabel(model.status)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                            label: t('aiPricing.models.dialog.displayName'),
                            value: model.displayName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                            label: t('aiPricing.models.columns.modalities'),
                            value: (model.modalities || []).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline-flex flex-wrap gap-1",
                                children: model.modalities.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: modalityLabel(m)
                                    }, m))
                            }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                            label: t('aiPricing.models.columns.calls'),
                            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                value: model.callsInWindow
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                            label: t('aiPricing.models.columns.cost'),
                            value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                value: model.costUsdInWindow
                            })
                        }),
                        model.notes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "col-span-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                label: t('aiPricing.models.dialog.notes'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "auto",
                                    children: model.notes
                                })
                            })
                        }) : null
                    ]
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-2 flex items-center justify-between gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "inline-flex items-center gap-1.5 text-sm font-bold text-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                            size: 16,
                                            "aria-hidden": true
                                        }),
                                        t('aiPricing.models.drawer.history')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                                    columns: csvColumns,
                                    rows: history,
                                    "data-testid": "ai-models-drawer-csv"
                                })
                            ]
                        }),
                        loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-state": "loading",
                            role: "status",
                            "aria-busy": "true",
                            "aria-label": t('aiPricing.models.drawer.loading'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
                                lines: 3
                            })
                        }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                            title: t('aiPricing.models.drawer.error'),
                            description: error,
                            onRetry: load,
                            retryLabel: t('common.actions.retry'),
                            "data-testid": "ai-models-drawer-error"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto rounded-lg border border-border",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                dense: true,
                                ariaLabel: t('aiPricing.models.drawer.historyAria'),
                                rows: history,
                                rowKey: (p)=>p.id,
                                columns: [
                                    {
                                        key: 'from',
                                        header: t('aiPricing.models.drawer.columns.from'),
                                        render: (p)=>formatDate(p.effectiveFrom)
                                    },
                                    {
                                        key: 'input',
                                        header: t('aiPricing.models.drawer.columns.input'),
                                        align: 'end',
                                        render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: p.inputUsdPerM
                                            })
                                    },
                                    {
                                        key: 'output',
                                        header: t('aiPricing.models.drawer.columns.output'),
                                        align: 'end',
                                        render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: p.outputUsdPerM
                                            })
                                    },
                                    {
                                        key: 'cached',
                                        header: t('aiPricing.models.drawer.columns.cached'),
                                        align: 'end',
                                        render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: p.cachedInputUsdPerM
                                            })
                                    },
                                    {
                                        key: 'audio',
                                        header: t('aiPricing.models.drawer.columns.audio'),
                                        align: 'end',
                                        render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tabular-nums",
                                                children: audioOf(p)
                                            })
                                    },
                                    {
                                        key: 'request',
                                        header: t('aiPricing.models.drawer.columns.request'),
                                        align: 'end',
                                        render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: p.requestUsd
                                            })
                                    },
                                    {
                                        key: 'source',
                                        header: t('aiPricing.models.drawer.columns.source'),
                                        render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                children: sourceLabel(p.source)
                                            })
                                    },
                                    {
                                        key: 'by',
                                        header: t('aiPricing.models.drawer.columns.by'),
                                        render: (p)=>p.createdBy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                                title: p.createdBy,
                                                children: String(p.createdBy).slice(0, 8)
                                            }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                                    }
                                ],
                                empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                        size: 28,
                                        strokeWidth: 1.5,
                                        "aria-hidden": true
                                    }),
                                    title: t('aiPricing.models.drawer.historyEmpty'),
                                    "data-testid": "ai-models-drawer-history-empty"
                                }),
                                "data-testid": "ai-models-drawer-history"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mb-2 text-sm font-bold text-foreground",
                            children: t('aiPricing.models.drawer.services')
                        }),
                        model?.usedByServices?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "flex flex-wrap gap-1.5",
                            "data-testid": "ai-models-drawer-services",
                            children: model.usedByServices.map((key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                            children: key
                                        })
                                    })
                                }, key))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            children: t('aiPricing.models.drawer.servicesEmpty')
                        })
                    ]
                })
            ]
        })
    });
}




function $9a9d6e27ab0bf8e0$export$2e2bcd8739ae039({ window: window, view: view, go: go }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [reloadKey, setReloadKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [adding, setAdding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pricing, setPricing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const includeDeprecated = view.deprecated === '1';
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$8aa64dc73f1d6413), {
            window: window,
            includeDeprecated: includeDeprecated
        }).then((d)=>setRows(d?.aiModels || [])).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        window,
        includeDeprecated,
        t
    ]);
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: !first.current
        });
        first.current = false;
    }, [
        load
    ]);
    const refresh = ()=>{
        load({
            quiet: true
        });
        setReloadKey((k)=>k + 1);
    };
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$f00694959a6a89ca)(rows, view), [
        rows,
        view
    ]);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.q || '');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(view.q || '');
    }, [
        view.q
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (draft === (view.q || '')) return undefined;
        const timer = setTimeout(()=>go({
                q: draft
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        draft,
        view.q,
        go
    ]);
    const focusSearch = ()=>{
        searchRef.current?.focus();
        searchRef.current?.select?.();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('/', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.aiPricing')
    });
    const onSort = (key)=>{
        const current = view.sort || 'cost';
        const dir = view.dir || 'desc';
        if (current !== key) go({
            sort: key,
            dir: 'desc'
        });
        else if (dir === 'desc') go({
            dir: 'asc'
        });
        else go({
            sort: '',
            dir: ''
        });
    };
    const selected = view.model ? rows.find((r)=>r.modelId === view.model) || null : null;
    const csvColumns = [
        {
            key: 'modelId',
            header: t('aiPricing.models.columns.model'),
            value: (r)=>r.modelId
        },
        {
            key: 'provider',
            header: t('aiPricing.models.columns.provider'),
            value: (r)=>r.provider
        },
        {
            key: 'status',
            header: t('aiPricing.models.columns.status'),
            value: (r)=>r.status
        },
        {
            key: 'input',
            header: t('aiPricing.models.columns.input'),
            value: (r)=>r.currentPrice?.inputUsdPerM
        },
        {
            key: 'output',
            header: t('aiPricing.models.columns.output'),
            value: (r)=>r.currentPrice?.outputUsdPerM
        },
        {
            key: 'audio',
            header: t('aiPricing.models.columns.audio'),
            value: (r)=>r.currentPrice?.audioUsdPerMinute ?? r.currentPrice?.audioInputUsdPerM
        },
        {
            key: 'since',
            header: t('aiPricing.models.columns.since'),
            value: (r)=>r.currentPrice?.effectiveFrom
        },
        {
            key: 'calls',
            header: t('aiPricing.models.columns.calls'),
            value: (r)=>r.callsInWindow
        },
        {
            key: 'cost',
            header: t('aiPricing.models.columns.cost'),
            value: (r)=>r.costUsdInWindow
        }
    ];
    const countLabel = result.isFiltered ? t('aiPricing.models.countFiltered', {
        count: result.filtered,
        total: result.total
    }) : t('aiPricing.models.count', {
        count: result.total
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-models",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
                "data-testid": "ai-models-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-[16rem] flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                            ref: searchRef,
                            value: draft,
                            onChange: (e)=>setDraft(e.target?.value ?? e),
                            onKeyDown: (e)=>{
                                if (e.key === 'Escape' && draft) {
                                    e.stopPropagation();
                                    setDraft('');
                                }
                            },
                            placeholder: t('aiPricing.models.search'),
                            "aria-label": t('aiPricing.models.search'),
                            "data-testid": "ai-models-search"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                        label: t('aiPricing.models.showDeprecated'),
                        active: includeDeprecated,
                        onClick: ()=>go({
                                deprecated: includeDeprecated ? '' : '1'
                            }),
                        "data-testid": "ai-models-deprecated"
                    }),
                    result.isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: ()=>go({
                                q: '',
                                deprecated: ''
                            }),
                        "data-testid": "ai-models-clear",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('common.actions.clearFilters')
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                        columns: csvColumns,
                        rows: result.rows,
                        "data-testid": "ai-models-csv"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: ()=>setAdding(true),
                        "data-testid": "ai-models-add",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            t('aiPricing.models.add')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-3 text-xs text-muted-foreground",
                "aria-live": "polite",
                "data-testid": "ai-models-count",
                children: countLabel
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: refreshing ? 0.45 : 1
                },
                "aria-busy": refreshing || undefined,
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 9,
                    label: t('aiPricing.models.loading'),
                    "data-testid": "ai-models-loading"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.models.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-models-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0f1d11436befcdb$export$2e2bcd8739ae039), {
                    rows: result.rows,
                    view: view,
                    onSort: onSort,
                    onOpen: (r)=>go({
                            model: r.modelId
                        }),
                    onPrice: (r)=>{
                        go({
                            model: r.modelId
                        });
                        setPricing(r);
                    },
                    empty: result.isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.models.emptyFiltered.title'),
                        description: t('aiPricing.models.emptyFiltered.desc'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: ()=>go({
                                    q: '',
                                    deprecated: ''
                                }),
                            children: t('common.actions.clearFilters')
                        }),
                        "data-testid": "ai-models-empty"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e8859e855a5dc92a$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.models.empty.title'),
                        description: t('aiPricing.models.empty.desc'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: ()=>setAdding(true),
                            children: t('aiPricing.models.add')
                        }),
                        "data-testid": "ai-models-empty"
                    })
                })
            }),
            view.model ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9bf4e2fc966d361$export$2e2bcd8739ae039), {
                model: selected,
                modelId: view.model,
                reloadKey: reloadKey,
                onClose: ()=>go({
                        model: ''
                    }),
                onAddPrice: ()=>setPricing(selected || {
                        modelId: view.model
                    }),
                onEdit: ()=>setEditing(selected)
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38bf4301cc22c6ee$export$2e2bcd8739ae039), {
                open: adding || !!editing,
                onOpenChange: (open)=>{
                    if (!open) {
                        setAdding(false);
                        setEditing(null);
                    }
                },
                model: editing,
                onDone: refresh
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf95a4b1c84d9327$export$2e2bcd8739ae039), {
                open: !!pricing,
                onOpenChange: (open)=>{
                    if (!open) setPricing(null);
                },
                model: pricing,
                onDone: refresh
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");









parcelRequire("acw62");






function $87a04b55dfc22f96$export$2e2bcd8739ae039({ rows: rows, view: view, onSort: onSort, onOpen: onOpen, empty: empty, creditCurrency: creditCurrency }) {
    const { t: t, formatNumber: formatNumber, formatPercent: formatPercent } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const usd = (v)=>(0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(v, {
            formatNumber: formatNumber,
            t: t
        });
    const tokens = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 0
        });
    const columns = [
        {
            key: 'service',
            header: t('aiPricing.services.columns.service'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate font-semibold text-foreground",
                            title: label(r),
                            children: label(r)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate text-xs text-muted-foreground",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                children: r.serviceKey
                            })
                        })
                    ]
                })
        },
        {
            key: 'models',
            header: t('aiPricing.services.columns.models'),
            width: '16rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3efca5e6be95bd1$export$2e2bcd8739ae039), {
                    models: r.models || []
                })
        },
        {
            key: 'invocations',
            header: t('aiPricing.services.columns.invocations'),
            sortable: true,
            align: 'end',
            width: '8rem',
            render: (r)=>{
                const rate = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.chargedRate);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                            value: r.invocations
                        }),
                        rate != null && rate < 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            className: "tabular-nums",
                            title: t('aiPricing.services.chargedRate', {
                                pct: formatPercent(rate * 100)
                            }),
                            children: t('aiPricing.services.chargedRate', {
                                pct: formatPercent(rate * 100)
                            })
                        }) : null
                    ]
                });
            }
        },
        {
            key: 'tokens',
            header: t('aiPricing.services.columns.tokens'),
            align: 'end',
            width: '10rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "tabular-nums",
                    title: t('aiPricing.services.cachedHint', {
                        value: tokens(r.avgCachedTokens)
                    }),
                    children: [
                        tokens(r.avgInputTokens),
                        " / ",
                        tokens(r.avgOutputTokens)
                    ]
                })
        },
        {
            key: 'cost',
            header: t('aiPricing.services.columns.costUsd'),
            sortable: true,
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                            value: r.meanCostUsd,
                            title: t('aiPricing.services.p50Hint', {
                                value: usd(r.p50CostUsd)
                            })
                        }),
                        r.hasUnpricedModel && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.pricedShare) != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.pricedShare) < 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "destructive",
                            title: t('aiPricing.services.unpricedRow', {
                                share: formatPercent((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.pricedShare) * 100)
                            }),
                            children: formatPercent((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.pricedShare) * 100)
                        }) : null
                    ]
                })
        },
        // A toman cost exists only where a credit is priced in toman (PM-0211); a
        // USD deployment has no FX and therefore no such column.
        (0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(creditCurrency) ? {
            key: 'costToman',
            header: t('aiPricing.services.columns.costToman'),
            align: 'end',
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                    value: r.meanCostToman
                })
        } : null,
        {
            key: 'price',
            header: t('aiPricing.services.columns.price'),
            sortable: true,
            align: 'end',
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-wrap items-center justify-end gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                            value: r.effectiveParseh,
                            suffix: r.unit === 'minute' ? t('aiPricing.services.perMinute') : '',
                            className: "font-semibold"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$330c7c36e660c06a), {
                            source: r.priceSource
                        })
                    ]
                })
        },
        {
            key: 'margin',
            header: t('aiPricing.services.columns.margin'),
            sortable: true,
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                    value: r.marginPct,
                    "data-testid": `ai-services-row-${r.serviceKey}-margin`
                })
        },
        {
            key: 'declared',
            header: t('aiPricing.services.columns.declared'),
            align: 'end',
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex items-center justify-end gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                            value: r.declaredInAppsParseh
                        }),
                        r.appsMismatch ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "warning",
                            children: t('aiPricing.services.mismatchBadge')
                        }) : null
                    ]
                })
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.services.tableAria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.serviceKey,
        onRowActivate: onOpen,
        rowProps: (r)=>({
                'data-testid': `ai-services-row-${r.serviceKey}`,
                'aria-label': t('aiPricing.services.open', {
                    label: label(r)
                })
            }),
        sort: {
            key: view.sort || 'cost',
            dir: view.dir || 'desc'
        },
        onSort: onSort,
        empty: empty,
        "data-testid": "ai-services-table"
    });
}





var $acw62 = parcelRequire("acw62");









function $3d99fd0a703876ef$export$2e2bcd8739ae039({ serviceKey: serviceKey, window: window, onClose: onClose, onClonePolicy: onClonePolicy }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate, formatMoney: formatMoney } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const roleLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.services.role');
    const chargeModeLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.services.chargeMode');
    const basisLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.services.drawer.basisSource');
    const usd = (v)=>(0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(v, {
            formatNumber: formatNumber,
            t: t
        });
    const tokens = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 0
        });
    const [detail, setDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$a23fde56dda002a7), {
            serviceKey: serviceKey,
            window: window
        }).then((d)=>setDetail(d?.aiServiceDetail || null)).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        serviceKey,
        window,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const row = detail?.row;
    const pricing = detail?.pricing;
    const observedRoles = new Set((detail?.models || []).map((m)=>m.role));
    const declared = detail?.declaredRoles || [];
    const rolesMismatch = row?.declaredRolesMismatch || declared.some((r)=>!r.observed);
    const daily = detail?.daily || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$c0b7ebe42c310b67), {
        open: true,
        onClose: onClose,
        title: row ? label(row) : t('aiPricing.services.columns.service'),
        sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
            children: serviceKey
        }),
        "data-testid": "ai-services-drawer",
        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-state": "loading",
            role: "status",
            "aria-busy": "true",
            "aria-label": t('aiPricing.services.drawer.loading'),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
                lines: 6,
                height: 18
            })
        }) : error || !detail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('aiPricing.services.drawer.error'),
            description: error || t('errors.region.noAnswer'),
            onRetry: load,
            retryLabel: t('common.actions.retry'),
            "data-testid": "ai-services-drawer-error"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-6",
            "data-state": "content",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            className: "grid grid-cols-2 gap-4 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.walletType'),
                                    value: row.walletServiceType,
                                    ltr: true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.chargeMode'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "inline-flex flex-wrap gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                children: chargeModeLabel(row.chargeMode)
                                            }),
                                            row.chargeCondition ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                children: t(`aiPricing.services.chargeCondition.${row.chargeCondition}`)
                                            }) : null
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.columns.invocations'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                        value: row.invocations
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.columns.callsPer'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                        value: row.avgCalls,
                                        options: {
                                            maximumFractionDigits: 1
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "mb-1 text-xs text-muted-foreground",
                                    children: t('aiPricing.services.drawer.roles')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap gap-1.5",
                                    "data-testid": "ai-services-drawer-roles",
                                    children: [
                                        declared.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: r.observed ? 'success' : 'warning',
                                                title: r.expectedCalls != null ? t('aiPricing.services.drawer.expectedCalls', {
                                                    expected: r.expectedCalls,
                                                    observed: tokens(row.avgCalls)
                                                }) : undefined,
                                                children: [
                                                    roleLabel(r.role),
                                                    r.observed ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "ms-1 opacity-80",
                                                        children: [
                                                            "(",
                                                            t('aiPricing.services.drawer.roleNotObserved'),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }, r.role)),
                                        [
                                            ...observedRoles
                                        ].filter((role)=>!declared.some((d)=>d.role === role)).map((role)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                title: t('aiPricing.services.drawer.rolesObserved'),
                                                children: roleLabel(role)
                                            }, `obs-${role}`))
                                    ]
                                }),
                                rolesMismatch ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    "data-testid": "ai-services-drawer-roles-mismatch",
                                    children: t('aiPricing.services.drawer.rolesMismatch')
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mb-2 text-sm font-bold text-foreground",
                            children: t('aiPricing.services.drawer.modelsTitle')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto rounded-lg border border-border",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                dense: true,
                                ariaLabel: t('aiPricing.services.drawer.modelsAria'),
                                rows: detail.models || [],
                                rowKey: (m)=>`${m.modelId}:${m.role}`,
                                columns: [
                                    {
                                        key: 'model',
                                        header: t('aiPricing.services.drawer.columns.model'),
                                        render: (m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                                title: m.modelId,
                                                children: m.modelId
                                            })
                                    },
                                    {
                                        key: 'role',
                                        header: t('aiPricing.services.drawer.columns.role'),
                                        render: (m)=>roleLabel(m.role)
                                    },
                                    {
                                        key: 'calls',
                                        header: t('aiPricing.services.drawer.columns.calls'),
                                        align: 'end',
                                        render: (m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                                value: m.calls
                                            })
                                    },
                                    {
                                        key: 'avgIn',
                                        header: t('aiPricing.services.drawer.columns.avgIn'),
                                        align: 'end',
                                        render: (m)=>tokens(m.avgInputTokens)
                                    },
                                    {
                                        key: 'avgOut',
                                        header: t('aiPricing.services.drawer.columns.avgOut'),
                                        align: 'end',
                                        render: (m)=>tokens(m.avgOutputTokens)
                                    },
                                    {
                                        key: 'cost',
                                        header: t('aiPricing.services.drawer.columns.cost'),
                                        align: 'end',
                                        render: (m)=>m.unpriced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "destructive",
                                                children: t('aiPricing.models.status.unknown')
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: m.costUsd
                                            })
                                    },
                                    {
                                        key: 'share',
                                        header: t('aiPricing.services.drawer.columns.share'),
                                        align: 'end',
                                        render: (m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$b39126116ceb31d8), {
                                                value: m.shareOfCostPct
                                            })
                                    }
                                ],
                                empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "p-4 text-sm text-muted-foreground",
                                    children: t('aiPricing.models.drawer.servicesEmpty')
                                }),
                                "data-testid": "ai-services-drawer-models"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mb-2 text-sm font-bold text-foreground",
                            children: t('aiPricing.services.drawer.stepsTitle')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "overflow-x-auto rounded-lg border border-border",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                dense: true,
                                ariaLabel: t('aiPricing.services.drawer.stepsAria'),
                                rows: detail.steps || [],
                                rowKey: (s)=>s.step,
                                columns: [
                                    {
                                        key: 'step',
                                        header: t('aiPricing.services.drawer.columns.step'),
                                        render: (s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                                children: s.step
                                            })
                                    },
                                    {
                                        key: 'callsPer',
                                        header: t('aiPricing.services.drawer.columns.callsPer'),
                                        align: 'end',
                                        render: (s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                                value: s.callsPerInvocation,
                                                options: {
                                                    maximumFractionDigits: 2
                                                }
                                            })
                                    },
                                    {
                                        key: 'avgIn',
                                        header: t('aiPricing.services.drawer.columns.avgIn'),
                                        align: 'end',
                                        render: (s)=>tokens(s.avgInputTokens)
                                    },
                                    {
                                        key: 'avgOut',
                                        header: t('aiPricing.services.drawer.columns.avgOut'),
                                        align: 'end',
                                        render: (s)=>tokens(s.avgOutputTokens)
                                    },
                                    {
                                        key: 'cost',
                                        header: t('aiPricing.services.drawer.columns.cost'),
                                        align: 'end',
                                        render: (s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: s.costUsd
                                            })
                                    },
                                    {
                                        key: 'share',
                                        header: t('aiPricing.services.drawer.columns.share'),
                                        align: 'end',
                                        render: (s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$b39126116ceb31d8), {
                                                value: s.shareOfCostPct
                                            })
                                    }
                                ],
                                empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "p-4 text-sm text-muted-foreground",
                                    children: t('aiPricing.overview.breakdownEmpty')
                                }),
                                "data-testid": "ai-services-drawer-steps"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    "data-testid": "ai-services-drawer-trend",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mb-2 text-sm font-bold text-foreground",
                            children: t('aiPricing.services.drawer.trendTitle')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-1 gap-4 md:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mb-1 text-xs text-muted-foreground",
                                            children: t('aiPricing.services.drawer.trendCost')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7b57ad44712e2b0$export$2e2bcd8739ae039), {
                                            readings: daily.map((d)=>({
                                                    id: d.day,
                                                    value: d.costUsd,
                                                    day: d.day
                                                })),
                                            color: (0, $e7c165fb515b04ea$export$c7989e6ff0cf1179)[2],
                                            height: 130,
                                            formatX: (r)=>formatDate(r.day, 'dayMonth'),
                                            formatValue: (v)=>formatNumber(v, {
                                                    maximumFractionDigits: 2
                                                }),
                                            emptyLabel: t('aiPricing.overview.chart.empty')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mb-1 text-xs text-muted-foreground",
                                            children: t('aiPricing.services.drawer.trendInvocations')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7b57ad44712e2b0$export$2e2bcd8739ae039), {
                                            readings: daily.map((d)=>({
                                                    id: d.day,
                                                    value: d.invocations,
                                                    day: d.day
                                                })),
                                            color: (0, $e7c165fb515b04ea$export$c7989e6ff0cf1179)[0],
                                            height: 130,
                                            formatX: (r)=>formatDate(r.day, 'dayMonth'),
                                            formatValue: (v)=>formatNumber(v, {
                                                    maximumFractionDigits: 0
                                                }),
                                            emptyLabel: t('aiPricing.overview.chart.empty')
                                        })
                                    ]
                                })
                            ]
                        }),
                        row.unit === 'minute' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "mt-2 text-xs text-muted-foreground",
                            title: t('aiPricing.services.drawer.minutesRatio'),
                            children: t('aiPricing.services.drawer.minutesRatioValue', {
                                sent: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.audioMinutesSent) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.audioMinutesSent), {
                                    maximumFractionDigits: 1
                                }),
                                billed: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.billedMinutes) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.billedMinutes), {
                                    maximumFractionDigits: 1
                                })
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                    className: "rounded-lg border border-border bg-muted/40 p-4",
                    "data-testid": "ai-services-drawer-pricing",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mb-3 text-sm font-bold text-foreground",
                            children: t('aiPricing.services.drawer.pricingTitle')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            className: "grid grid-cols-2 gap-4 text-sm md:grid-cols-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.basis'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "inline-flex flex-wrap items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                                value: pricing.basisCostUsd
                                            }),
                                            " ",
                                            t('common.units.usd'),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: pricing.basisSource === 'none' ? 'destructive' : pricing.basisSource === 'declared' ? 'warning' : 'outline',
                                                children: basisLabel(pricing.basisSource)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xs text-muted-foreground",
                                                children: t('aiPricing.services.drawer.basisSample', {
                                                    count: pricing.basisSample || 0
                                                })
                                            })
                                        ]
                                    })
                                }),
                                (0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(pricing.creditCurrency) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                            label: t('aiPricing.services.drawer.fx'),
                                            value: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(pricing.fxTomanPerUsd) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                                                        value: pricing.fxTomanPerUsd
                                                    }),
                                                    " ",
                                                    t('common.units.toman')
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                            label: t('aiPricing.services.drawer.parseh'),
                                            value: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(pricing.parsehToman) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                                                        value: pricing.parsehToman
                                                    }),
                                                    " ",
                                                    t('common.units.toman')
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.parseh'),
                                    value: (0, $7df21990c7b31bb5$export$539a7225fef603b0)(pricing.creditPrice, pricing.creditCurrency, {
                                        t: t,
                                        formatNumber: formatNumber,
                                        formatMoney: formatMoney
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.computed'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                        value: pricing.computedParseh
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.override'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                        value: pricing.overrideParseh
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.effective'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "inline-flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                                value: pricing.effectiveParseh,
                                                suffix: row.unit === 'minute' ? t('aiPricing.services.perMinute') : '',
                                                className: "font-semibold"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$330c7c36e660c06a), {
                                                source: row.priceSource
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                                    label: t('aiPricing.services.drawer.margin'),
                                    value: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(row.chargedRate) === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-muted-foreground",
                                        children: t('aiPricing.services.drawer.neverCharged')
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                                        value: pricing.marginPct
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mt-4 flex flex-wrap items-center gap-2",
                            children: pricing.policyId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        disabled: true,
                                        title: t('aiPricing.services.drawer.editActiveHint'),
                                        "data-testid": "ai-services-drawer-edit-active",
                                        children: t('aiPricing.services.drawer.editActive')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        onClick: ()=>onClonePolicy(pricing.policyId),
                                        "data-testid": "ai-services-drawer-clone",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                size: 16,
                                                "aria-hidden": true
                                            }),
                                            t('aiPricing.services.drawer.clone')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-muted-foreground",
                                        children: pricing.policyName
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-muted-foreground",
                                        children: t('aiPricing.services.drawer.noPolicy')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        onClick: ()=>onClonePolicy(null),
                                        "data-testid": "ai-services-drawer-clone",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                                size: 16,
                                                "aria-hidden": true
                                            }),
                                            t('aiPricing.services.drawer.clone')
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}



const $b3f68a6992acc87e$var$CHIPS = [
    'negative',
    'unpriced',
    'mismatch'
];
function $b3f68a6992acc87e$export$2e2bcd8739ae039({ window: window, view: view, go: go }) {
    const { t: t, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$48f6848d495596f6), {
            window: window
        }).then((d)=>setData(d?.aiServices || {
                services: []
            })).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        window,
        t
    ]);
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: !first.current
        });
        first.current = false;
    }, [
        load
    ]);
    const rows = data?.services || [];
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$bd0c93a9682bcfaa)(rows, view, {
            label: label
        }), [
        rows,
        view,
        label
    ]);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.q || '');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(view.q || '');
    }, [
        view.q
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (draft === (view.q || '')) return undefined;
        const timer = setTimeout(()=>go({
                q: draft
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        draft,
        view.q,
        go
    ]);
    const focusSearch = ()=>{
        searchRef.current?.focus();
        searchRef.current?.select?.();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('/', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.aiPricing')
    });
    const onSort = (key)=>{
        const current = view.sort || 'cost';
        const dir = view.dir || 'desc';
        if (current !== key) go({
            sort: key,
            dir: 'desc'
        });
        else if (dir === 'desc') go({
            dir: 'asc'
        });
        else go({
            sort: '',
            dir: ''
        });
    };
    const clear = ()=>go({
            q: '',
            negative: '',
            unpriced: '',
            mismatch: ''
        });
    const csvColumns = [
        {
            key: 'serviceKey',
            header: t('aiPricing.services.columns.service'),
            value: (r)=>r.serviceKey
        },
        {
            key: 'label',
            header: t('aiPricing.services.columns.service'),
            value: (r)=>label(r)
        },
        {
            key: 'invocations',
            header: t('aiPricing.services.columns.invocations'),
            value: (r)=>r.invocations
        },
        {
            key: 'chargedRate',
            header: t('aiPricing.services.chargedRate', {
                pct: ''
            }).trim(),
            value: (r)=>r.chargedRate
        },
        {
            key: 'avgIn',
            header: t('aiPricing.services.drawer.columns.avgIn'),
            value: (r)=>r.avgInputTokens
        },
        {
            key: 'avgOut',
            header: t('aiPricing.services.drawer.columns.avgOut'),
            value: (r)=>r.avgOutputTokens
        },
        {
            key: 'meanCostUsd',
            header: t('aiPricing.services.columns.costUsd'),
            value: (r)=>r.meanCostUsd
        },
        (0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(data?.creditCurrency) ? {
            key: 'meanCostToman',
            header: t('aiPricing.services.columns.costToman'),
            value: (r)=>r.meanCostToman
        } : null,
        {
            key: 'effectiveParseh',
            header: t('aiPricing.services.columns.price'),
            value: (r)=>r.effectiveParseh
        },
        {
            key: 'priceSource',
            header: t('aiPricing.ledger.columns.source'),
            value: (r)=>r.priceSource
        },
        {
            key: 'marginPct',
            header: t('aiPricing.services.columns.margin'),
            value: (r)=>r.marginPct
        },
        {
            key: 'declared',
            header: t('aiPricing.services.columns.declared'),
            value: (r)=>r.declaredInAppsParseh
        }
    ].filter(Boolean);
    const countLabel = result.isFiltered ? t('aiPricing.services.countFiltered', {
        count: result.filtered,
        total: result.total
    }) : t('aiPricing.services.count', {
        count: result.total
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-services",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
                "data-testid": "ai-services-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "group",
                        "aria-label": t('aiPricing.services.filters.label'),
                        className: "flex flex-wrap items-center gap-1.5",
                        "data-testid": "ai-services-filter",
                        children: $b3f68a6992acc87e$var$CHIPS.map((chip)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                label: t(`aiPricing.services.filters.${chip}`),
                                active: view[chip] === '1',
                                onClick: ()=>go({
                                        [chip]: view[chip] === '1' ? '' : '1'
                                    }),
                                "data-testid": `ai-services-filter-${chip}`
                            }, chip))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-[16rem] flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                            ref: searchRef,
                            value: draft,
                            onChange: (e)=>setDraft(e.target?.value ?? e),
                            onKeyDown: (e)=>{
                                if (e.key === 'Escape' && draft) {
                                    e.stopPropagation();
                                    setDraft('');
                                }
                            },
                            placeholder: t('aiPricing.services.search'),
                            "aria-label": t('aiPricing.services.search'),
                            "data-testid": "ai-services-search"
                        })
                    }),
                    result.isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: clear,
                        "data-testid": "ai-services-clear",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('common.actions.clearFilters')
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                        columns: csvColumns,
                        rows: result.rows,
                        "data-testid": "ai-services-csv"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-3 flex flex-wrap items-center gap-x-3 text-xs text-muted-foreground",
                "aria-live": "polite",
                "data-testid": "ai-services-count",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: countLabel
                    }),
                    data && !loading && !error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "data-testid": "ai-services-rate",
                        children: data.policyId ? t('aiPricing.atRate', {
                            name: formatDigits(data.policyId)
                        }) : t('aiPricing.noRate')
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: refreshing ? 0.45 : 1
                },
                "aria-busy": refreshing || undefined,
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 9,
                    label: t('aiPricing.services.loading'),
                    "data-testid": "ai-services-loading"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.services.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-services-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87a04b55dfc22f96$export$2e2bcd8739ae039), {
                    rows: result.rows,
                    creditCurrency: data?.creditCurrency,
                    view: view,
                    onSort: onSort,
                    onOpen: (r)=>go({
                            service: r.serviceKey
                        }),
                    empty: result.isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.services.emptyFiltered.title'),
                        description: t('aiPricing.services.emptyFiltered.desc'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: clear,
                            children: t('common.actions.clearFilters')
                        }),
                        "data-testid": "ai-services-empty"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.services.empty.title'),
                        description: t('aiPricing.services.empty.desc'),
                        "data-testid": "ai-services-empty"
                    })
                })
            }),
            view.service ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d99fd0a703876ef$export$2e2bcd8739ae039), {
                serviceKey: view.service,
                window: window,
                onClose: ()=>go({
                        service: ''
                    }),
                onClonePolicy: (policyId)=>go({
                        view: 'policies',
                        service: '',
                        policy: 'new',
                        from: policyId || ''
                    })
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $357b00fa120a5c4e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Archive", [
    [
        "rect",
        {
            width: "20",
            height: "5",
            x: "2",
            y: "3",
            rx: "1",
            key: "1wp1u1"
        }
    ],
    [
        "path",
        {
            d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
            key: "1s80jp"
        }
    ],
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00b4789eeda33397$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Zap", [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
]);











var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b547c0f28739ad4$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Play", [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db54edda7e508228$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Save", [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
]);










var $acw62 = parcelRequire("acw62");




function $ab8ae46088ca8cb0$export$2e2bcd8739ae039({ prices: prices, canOverride: canOverride, overrideDisabledReason: overrideDisabledReason, onOverride: onOverride, pendingKey: pendingKey }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const basisLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.services.drawer.basisSource');
    const columns = [
        {
            key: 'service',
            header: t('aiPricing.policies.editor.results.columns.service'),
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate font-semibold text-foreground",
                            children: label(p)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate text-xs text-muted-foreground",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                children: p.serviceKey
                            })
                        })
                    ]
                })
        },
        {
            key: 'basis',
            header: t('aiPricing.policies.editor.results.columns.basis'),
            align: 'end',
            width: '11rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                            value: p.basisCostUsd
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "inline-flex items-center gap-1 text-[11px] text-muted-foreground",
                            children: [
                                p.basisSource === 'declared' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    children: t('aiPricing.policies.editor.results.badge.declared')
                                }) : p.basisSource === 'none' || (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(p.basisCostUsd) == null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "destructive",
                                    children: t('aiPricing.policies.editor.results.badge.none')
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: basisLabel(p.basisSource)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tabular-nums",
                                    children: t('aiPricing.policies.editor.results.sample', {
                                        count: p.basisSample || 0
                                    })
                                })
                            ]
                        })
                    ]
                })
        },
        {
            key: 'costParseh',
            header: t('aiPricing.policies.editor.results.columns.costParseh'),
            align: 'end',
            width: '7rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                    value: p.costParseh
                })
        },
        {
            key: 'computed',
            header: t('aiPricing.policies.editor.results.columns.computed'),
            align: 'end',
            width: '7rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                    value: p.computedParseh
                })
        },
        {
            key: 'override',
            header: t('aiPricing.policies.editor.results.columns.override'),
            align: 'end',
            width: '9rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab8ae46088ca8cb0$var$OverrideCell, {
                    price: p,
                    disabled: !canOverride,
                    reason: overrideDisabledReason,
                    pending: pendingKey === p.serviceKey,
                    onCommit: (value)=>onOverride(p.serviceKey, value),
                    ariaLabel: t('aiPricing.policies.editor.results.overrideLabel', {
                        service: label(p)
                    })
                })
        },
        {
            key: 'effective',
            header: t('aiPricing.policies.editor.results.columns.effective'),
            align: 'end',
            width: '8rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                    value: p.effectiveParseh,
                    suffix: p.unit === 'minute' ? t('aiPricing.services.perMinute') : '',
                    className: "font-semibold"
                })
        },
        {
            key: 'margin',
            header: t('aiPricing.policies.editor.results.columns.margin'),
            align: 'end',
            width: '6rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                    value: p.marginPct,
                    "data-testid": `ai-policy-row-${p.serviceKey}-margin`
                })
        },
        {
            key: 'active',
            header: t('aiPricing.policies.editor.results.columns.active'),
            align: 'end',
            width: '7rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                    value: p.activeParseh
                })
        },
        {
            key: 'delta',
            header: t('aiPricing.policies.editor.results.columns.delta'),
            align: 'end',
            width: '5rem',
            render: (p)=>{
                const d = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(p.deltaParseh);
                if (d == null || d === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: d === 0 ? formatNumber(0) : t('common.value.none')
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: d > 0 ? 'warning' : 'success',
                    className: "tabular-nums",
                    children: formatNumber(d, {
                        maximumFractionDigits: 2,
                        signDisplay: 'always'
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.policies.editor.results.aria'),
        columns: columns,
        rows: prices,
        rowKey: (p)=>p.serviceKey,
        rowProps: (p)=>({
                'data-testid': `ai-policy-row-${p.serviceKey}`,
                'data-delta': (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(p.deltaParseh) || 0
            }),
        empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "p-6 text-center text-sm text-muted-foreground",
            "data-testid": "ai-policy-results-empty",
            children: t('aiPricing.policies.editor.results.empty')
        }),
        "data-testid": "ai-policy-results"
    });
}
/**
 * A price is a whole number of tenths (PM-0427): «3» or «3.1», never «3.21».
 * The service refuses anything finer; the field says so first and keeps the
 * typed figure, rather than sending it to fail.
 */ function $ab8ae46088ca8cb0$var$OverrideCell({ price: price, disabled: disabled, reason: reason, pending: pending, onCommit: onCommit, ariaLabel: ariaLabel }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(price.overrideParseh ?? '');
    const [invalid, setInvalid] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(price.overrideParseh ?? '');
        setInvalid(false);
    }, [
        price.overrideParseh
    ]);
    const commit = ()=>{
        const next = String(draft).trim();
        const current = price.overrideParseh == null ? '' : String(price.overrideParseh);
        if (!(0, $ad1ad54ff7f74a69$export$443f876604f74cf4)(next)) {
            setInvalid(true);
            return;
        }
        setInvalid(false);
        if ((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(next) === (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(current)) return;
        onCommit(next === '' ? null : next);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-24",
        title: disabled ? reason : undefined,
        "data-testid": `ai-policy-row-${price.serviceKey}-override`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
            value: draft,
            onChange: (e)=>{
                setDraft(e.target?.value ?? e);
                if (invalid) setInvalid(false);
            },
            onBlur: commit,
            error: invalid ? t('aiPricing.policies.editor.tenthsOnly') : undefined,
            onKeyDown: (e)=>{
                if (e.key === 'Enter') {
                    e.preventDefault();
                    commit();
                }
            },
            placeholder: t('aiPricing.policies.editor.results.overridePlaceholder'),
            disabled: disabled || pending,
            "aria-label": ariaLabel,
            "aria-busy": pending || undefined,
            style: {
                margin: 0
            }
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $77b97fa5312eb73e$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, detail: detail, pending: pending, error: error, conflict: conflict, onConfirm: onConfirm, onReload: onReload, creditChange: // The editor's sentence when a credit priced in another currency than toman
// (PM-0211) has changed price in the wallet since this policy was computed.
creditChange = null }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [typed, setTyped] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) setTyped('');
    }, [
        open
    ]);
    const policy = detail?.policy;
    const negative = detail?.negative || 0;
    const word = t('aiPricing.policies.editor.activateDialog.confirmWord');
    const needsWord = negative > 0;
    // Toman against toman only — a policy whose credit is priced in another
    // currency (PM-0211) has no toman snapshot to compare.
    const walletChanged = (0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(policy?.creditCurrency) && detail?.walletParsehToman != null && policy?.parsehToman != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.walletParsehToman) !== (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(policy.parsehToman);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('aiPricing.policies.editor.activateDialog.title', {
            name: policy?.name || ''
        }),
        description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    "data-testid": "ai-policy-activate-error",
                    action: conflict ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        size: "sm",
                        onClick: onReload,
                        "data-testid": "ai-policy-activate-reload",
                        children: t('aiPricing.policies.editor.activateDialog.reload')
                    }) : undefined,
                    children: conflict ? t('aiPricing.policies.editor.activateDialog.conflict') : error
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    "data-testid": "ai-policy-activate-summary",
                    children: t('aiPricing.policies.editor.activateDialog.summary', {
                        total: detail?.prices?.length || 0,
                        dearer: detail?.dearer || 0,
                        cheaper: detail?.cheaper || 0,
                        negative: negative
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-muted-foreground",
                    children: t('aiPricing.policies.editor.activateDialog.consequence')
                }),
                walletChanged ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    "data-testid": "ai-policy-activate-wallet",
                    children: t('aiPricing.policies.editor.parsehChanged', {
                        wallet: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.walletParsehToman)),
                        snapshot: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(policy.parsehToman))
                    })
                }) : creditChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    "data-testid": "ai-policy-activate-wallet",
                    children: creditChange
                }) : null,
                needsWord ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "error",
                            "data-testid": "ai-policy-activate-negative",
                            children: t('aiPricing.policies.editor.activateDialog.negativeWarning', {
                                count: negative,
                                word: word
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                            label: t('aiPricing.policies.editor.activateDialog.typeToConfirm'),
                            value: typed,
                            onChange: (e)=>setTyped(e.target?.value ?? e),
                            placeholder: word,
                            "data-testid": "ai-policy-confirm-word"
                        })
                    ]
                }) : null
            ]
        }),
        confirmLabel: t('aiPricing.policies.editor.activateDialog.confirm'),
        cancelLabel: t('common.actions.cancel'),
        destructive: needsWord,
        loading: pending,
        confirmDisabled: needsWord && typed.trim() !== word,
        onConfirm: onConfirm,
        "data-testid": "ai-policy-activate-confirm",
        confirmTestId: "ai-policy-activate-confirm-submit",
        cancelTestId: "ai-policy-activate-confirm-cancel"
    });
}



const $4a2eb25e6d7157ad$var$STATUS_VARIANT = {
    draft: 'outline',
    active: 'success',
    archived: 'outline'
};
/** A stable key for "the parameters as they are now", for simulate-gating. */ const $4a2eb25e6d7157ad$var$inputKey = (input)=>JSON.stringify((0, $ad1ad54ff7f74a69$export$516570a68aa812d5)(input));
function $4a2eb25e6d7157ad$export$2e2bcd8739ae039({ policyId: policyId, cloneFromId: cloneFromId, policies: policies, onExit: onExit, onDirtyChange: onDirtyChange, onActivated: onActivated, onSaved: onSaved, onOpenPolicy: onOpenPolicy }) {
    const { t: t, locale: locale, formatNumber: formatNumber, formatPercent: formatPercent, formatDigits: formatDigits, formatMoney: formatMoney } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const basisLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.editor.basisOptions');
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.status');
    const fxSourceLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.fxSource');
    const isNew = policyId === 'new';
    const [detail, setDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $ad1ad54ff7f74a69$export$fc10758f8b4247f3)());
    const [savedInput, setSavedInput] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [simulatedFor, setSimulatedFor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [walletParseh, setWalletParseh] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [walletCredit, setWalletCredit] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { amountMinor, currency }
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // save | simulate | activate | override:<key>
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [activating, setActivating] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [activateError, setActivateError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [conflict, setConflict] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Read through a ref: the list is only a pre-fill for a blank draft, and a
    // `load` that depended on it re-fetched — discarding the operator's edits —
    // the moment the policies list finished loading beside the editor.
    const policiesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(policies);
    policiesRef.current = policies;
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setLoadError(null);
        const source = isNew ? cloneFromId : policyId;
        const detailPromise = source ? (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$84ae42ec2dcc16d3), {
            id: source
        }).then((d)=>d?.aiPricingPolicy || null) : Promise.resolve(null);
        const walletPromise = (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$98b1d4a88625c723)).then((d)=>d?.creditPricing ?? null).catch(()=>null);
        Promise.all([
            detailPromise,
            walletPromise
        ]).then(([loaded, wallet])=>{
            setWalletParseh(wallet?.parsehToman ?? null);
            setWalletCredit(wallet?.creditPrice ?? null);
            if (isNew) {
                // A blank draft pre-fills the FX from the most recent policy; a
                // clone pre-fills everything and keeps the name for the operator to edit.
                const last = (policiesRef.current || [])[0];
                setForm(loaded ? (0, $ad1ad54ff7f74a69$export$c27a63561573784e)(loaded.policy) : (0, $ad1ad54ff7f74a69$export$fc10758f8b4247f3)({
                    fxTomanPerUsd: last?.fxTomanPerUsd
                }));
                setDetail(loaded ? {
                    ...loaded,
                    policy: {
                        ...loaded.policy,
                        id: null,
                        status: 'draft',
                        version: null
                    }
                } : null);
                setSavedInput(null);
                setSimulatedFor(null);
            } else {
                setDetail(loaded);
                const input = (0, $ad1ad54ff7f74a69$export$c27a63561573784e)(loaded?.policy);
                setForm(input);
                setSavedInput(input);
                // A draft the server has already computed can be activated as it stands.
                setSimulatedFor(loaded?.policy?.computedAt ? $4a2eb25e6d7157ad$var$inputKey(input) : null);
            }
            setTouched(false);
        }).catch((e)=>setLoadError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        policyId,
        cloneFromId,
        isNew,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const policy = detail?.policy;
    const status = isNew ? 'draft' : policy?.status || 'draft';
    const editable = status === 'draft';
    const dirty = editable && (savedInput ? !(0, $ad1ad54ff7f74a69$export$852b9bdc9ffe68a8)(form, savedInput) : touched);
    // What this policy prices a credit in: its own record, or for a new draft the
    // wallet's — today's IRT when neither says.
    const creditCurrency = isNew && walletCredit?.currency || policy?.creditCurrency || walletCredit?.currency || (0, $7df21990c7b31bb5$export$cc7bc313e3696c38);
    const withFx = (0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(creditCurrency);
    const errors = (0, $ad1ad54ff7f74a69$export$da691c727d601914)(form, {
        withFx: withFx,
        locale: locale
    });
    const valid = Object.keys(errors).length === 0;
    const simulated = simulatedFor === $4a2eb25e6d7157ad$var$inputKey(form);
    const canSave = editable && valid && !pending && (dirty || isNew);
    const canSimulate = editable && valid && !pending;
    const canActivate = editable && !isNew && !!policy?.id && !dirty && simulated && !pending;
    const canOverride = editable && !isNew && !!policy?.id && !pending;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onDirtyChange?.(dirty);
    }, [
        dirty,
        onDirtyChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>onDirtyChange?.(false), [
        onDirtyChange
    ]);
    // Reload / close with unsaved parameters asks first (§10 dirty guard).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!dirty) return undefined;
        const handler = (e)=>{
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handler);
        return ()=>window.removeEventListener('beforeunload', handler);
    }, [
        dirty
    ]);
    const set = (key)=>(e)=>{
            setTouched(true);
            setForm((f)=>({
                    ...f,
                    [key]: e?.target ? e.target.value : e
                }));
        };
    const runWrite = async (kind, mutation, variables, onOk)=>{
        setPending(kind);
        setError(null);
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)(mutation, variables);
            onOk(d);
        } catch (e) {
            setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
            throw e;
        } finally{
            setPending(null);
        }
    };
    const save = ()=>{
        if (!canSave) return;
        return runWrite('save', (0, $3ece07ed3ee6f427$export$b8d505c6d165d5f), {
            id: isNew ? null : policy?.id,
            cloneFromId: isNew ? cloneFromId || null : null,
            input: (0, $ad1ad54ff7f74a69$export$516570a68aa812d5)(form, {
                withFx: withFx
            }),
            expectedVersion: isNew ? null : policy?.version ?? null
        }, (d)=>{
            const next = d?.saveAiPricingPolicyDraft;
            setDetail(next);
            const input = (0, $ad1ad54ff7f74a69$export$c27a63561573784e)(next?.policy);
            setForm(input);
            setSavedInput(input);
            setSimulatedFor(null);
            setTouched(false);
            toast.success(t('aiPricing.policies.editor.saved'));
            onSaved?.(next?.policy?.id);
        }).catch(()=>{});
    };
    const simulate = ()=>{
        if (!canSimulate) return;
        // A saved, unchanged draft recomputes its persisted rows; anything else is a
        // dry run of the parameters on screen, which persists nothing (§8.4).
        const persisted = !isNew && policy?.id && !dirty;
        return runWrite('simulate', (0, $3ece07ed3ee6f427$export$93fcc4313bb8f40f), persisted ? {
            id: policy.id
        } : {
            id: null,
            input: (0, $ad1ad54ff7f74a69$export$516570a68aa812d5)(form, {
                withFx: withFx
            })
        }, (d)=>{
            const next = d?.simulateAiPricingPolicy;
            setDetail((prev)=>persisted || !prev ? next : {
                    ...next,
                    policy: prev.policy
                });
            setSimulatedFor($4a2eb25e6d7157ad$var$inputKey(form));
            toast.success(t('aiPricing.policies.editor.simulated'));
        }).catch(()=>{});
    };
    const override = (serviceKey, parseh)=>{
        if (!canOverride) return;
        return runWrite(`override:${serviceKey}`, (0, $3ece07ed3ee6f427$export$2e5e77992ce92703), {
            policyId: policy.id,
            serviceKey: serviceKey,
            parseh: parseh,
            expectedVersion: policy.version
        }, (d)=>{
            setDetail(d?.setAiServiceOverride);
            toast.success(t('aiPricing.policies.editor.overrideSaved'));
        }).catch(()=>{});
    };
    const activate = async ()=>{
        setPending('activate');
        setActivateError(null);
        setConflict(false);
        try {
            await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$74a6d36ce8e6a68a), {
                id: policy.id,
                expectedVersion: policy.version
            });
            setActivating(false);
            toast.success(t('aiPricing.policies.editor.activated'));
            onActivated?.();
        } catch (e) {
            setActivateError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
            setConflict(e?.code === 'BUSINESS_RULE');
        } finally{
            setPending(null);
        }
    };
    const reloadAfterConflict = ()=>{
        setActivateError(null);
        setConflict(false);
        setActivating(false);
        setSimulatedFor(null);
        load();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('ctrl+s', save, {
        label: t('shortcuts.action.saveDraft'),
        group: t('shortcuts.groups.aiPricing'),
        enabled: canSave
    });
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('ctrl+enter', simulate, {
        label: t('shortcuts.action.simulate'),
        group: t('shortcuts.groups.aiPricing'),
        enabled: canSimulate && !activating
    });
    const title = isNew ? t('aiPricing.policies.editor.newTitle') : policy?.name || t('common.value.none');
    // Toman against toman only: a USD policy has no toman snapshot, while the
    // wallet still reports its COIN_PRICE_TOMAN.
    const walletChanged = withFx && walletParseh != null && policy?.parsehToman != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(walletParseh) !== (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(policy.parsehToman);
    // The same warning for a credit priced in another currency: the wallet's live
    // price against the one this policy was computed on.
    const priceArgs = {
        t: t,
        formatNumber: formatNumber,
        formatMoney: formatMoney
    };
    const creditChange = !withFx && policy && (0, $7df21990c7b31bb5$export$a30d2858941ab707)({
        price: policy.creditPrice,
        currency: policy.creditCurrency
    }, walletCredit) ? t('aiPricing.policies.editor.creditChanged', {
        wallet: (0, $7df21990c7b31bb5$export$539a7225fef603b0)(walletCredit.amountMinor, walletCredit.currency, {
            ...priceArgs,
            minor: true
        }),
        snapshot: (0, $7df21990c7b31bb5$export$539a7225fef603b0)(policy.creditPrice, policy.creditCurrency, priceArgs)
    }) : null;
    const csvColumns = [
        {
            key: 'serviceKey',
            header: t('aiPricing.policies.editor.results.columns.service'),
            value: (p)=>p.serviceKey
        },
        {
            key: 'basisCostUsd',
            header: t('aiPricing.policies.editor.results.columns.basis'),
            value: (p)=>p.basisCostUsd
        },
        {
            key: 'basisSource',
            header: t('aiPricing.services.drawer.basis'),
            value: (p)=>p.basisSource
        },
        {
            key: 'costParseh',
            header: t('aiPricing.policies.editor.results.columns.costParseh'),
            value: (p)=>p.costParseh
        },
        {
            key: 'computedParseh',
            header: t('aiPricing.policies.editor.results.columns.computed'),
            value: (p)=>p.computedParseh
        },
        {
            key: 'overrideParseh',
            header: t('aiPricing.policies.editor.results.columns.override'),
            value: (p)=>p.overrideParseh
        },
        {
            key: 'effectiveParseh',
            header: t('aiPricing.policies.editor.results.columns.effective'),
            value: (p)=>p.effectiveParseh
        },
        {
            key: 'marginPct',
            header: t('aiPricing.policies.editor.results.columns.margin'),
            value: (p)=>p.marginPct
        },
        {
            key: 'activeParseh',
            header: t('aiPricing.policies.editor.results.columns.active'),
            value: (p)=>p.activeParseh
        },
        {
            key: 'deltaParseh',
            header: t('aiPricing.policies.editor.results.columns.delta'),
            value: (p)=>p.deltaParseh
        }
    ];
    const numberField = (key, labelKey, { unit: unit, min: min, max: max, step: step } = {})=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
            label: t(`aiPricing.policies.editor.${labelKey}`),
            value: form[key] ?? '',
            onChange: set(key),
            unit: unit,
            min: min,
            max: max,
            validate: (v)=>{
                if (!v) return '';
                const n = Number(v);
                if (!Number.isFinite(n)) return t('validation.required');
                if (min != null && n < min) return t('validation.required');
                if (max != null && n > max) return t('validation.required');
                return '';
            },
            error: errors[key] ? t(errors[key]) : undefined,
            disabled: !editable,
            "data-testid": `ai-policy-${key}`,
            inputMode: "decimal",
            step: step
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full min-h-0 flex-col",
        "data-testid": "ai-policy-editor",
        "data-state": loading ? 'loading' : loadError ? 'error' : 'content',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                title: title,
                onBack: onExit,
                backLabel: t('aiPricing.policies.editor.back'),
                status: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: $4a2eb25e6d7157ad$var$STATUS_VARIANT[status] || 'outline',
                    children: statusLabel(status)
                }),
                badges: policy?.version != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                children: [
                                    "v",
                                    policy.version
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: policy.fxSource === 'nightly' ? 'default' : 'outline',
                            "data-testid": "ai-policy-fx-source",
                            children: fxSourceLabel(policy.fxSource || 'manual')
                        }),
                        policy.basePolicyId && onOpenPolicy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "link",
                            size: "sm",
                            className: "h-auto p-0",
                            onClick: ()=>onOpenPolicy(policy.basePolicyId),
                            "data-testid": "ai-policy-base",
                            children: t('aiPricing.policies.basedOn', {
                                id: formatDigits(policy.basePolicyId)
                            })
                        }) : null
                    ]
                }) : undefined,
                "data-testid": "ai-policy-header"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mx-auto w-full max-w-[1440px]",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-5 xl:grid-cols-[22rem_minmax(0,1fr)]",
                        "data-testid": "ai-policy-loading",
                        "data-state": "loading",
                        role: "status",
                        "aria-busy": "true",
                        "aria-label": t('aiPricing.policies.editor.loading'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                        ]
                    }) : loadError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                        title: t('aiPricing.policies.editor.error'),
                        description: loadError,
                        onRetry: load,
                        retryLabel: t('common.actions.retry'),
                        "data-testid": "ai-policy-error"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-5 flex flex-col gap-3",
                                children: [
                                    !editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "info",
                                        "data-testid": "ai-policy-readonly",
                                        children: t('aiPricing.policies.editor.readOnly', {
                                            status: statusLabel(status)
                                        })
                                    }) : null,
                                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "error",
                                        "data-testid": "ai-policy-write-error",
                                        children: error
                                    }) : null,
                                    editable && !simulated && !isNew && savedInput ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        "data-testid": "ai-policy-unsimulated",
                                        children: t('aiPricing.policies.editor.unsimulated')
                                    }) : null,
                                    walletChanged ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        "data-testid": "ai-policy-wallet-changed",
                                        children: t('aiPricing.policies.editor.parsehChanged', {
                                            wallet: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(walletParseh)),
                                            snapshot: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(policy.parsehToman))
                                        })
                                    }) : creditChange ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        "data-testid": "ai-policy-wallet-changed",
                                        children: creditChange
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 gap-5 xl:grid-cols-[22rem_minmax(0,1fr)]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                        className: "flex min-w-0 flex-col gap-3 rounded-lg border border-border bg-card p-5",
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            simulate();
                                        },
                                        "aria-label": t('aiPricing.policies.editor.params'),
                                        "data-testid": "ai-policy-params",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-sm font-bold text-foreground",
                                                children: t('aiPricing.policies.editor.params')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('aiPricing.policies.editor.name'),
                                                required: true,
                                                value: form.name,
                                                onChange: set('name'),
                                                error: touched && errors.name ? t(errors.name) : undefined,
                                                disabled: !editable,
                                                "data-testid": "ai-policy-name"
                                            }),
                                            withFx ? numberField('fxTomanPerUsd', 'fx', {
                                                unit: t('aiPricing.policies.editor.fxUnit'),
                                                min: 1
                                            }) : null,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                                                label: t('aiPricing.policies.editor.parseh'),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "rounded-lg border border-border bg-muted px-3 py-2 text-sm tabular-nums",
                                                    "data-testid": "ai-policy-parseh",
                                                    children: withFx ? policy?.parsehToman != null ? t('aiPricing.policies.editor.parsehSnapshot', {
                                                        value: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(policy.parsehToman))
                                                    }) : walletParseh != null ? t('aiPricing.policies.editor.parsehFrom', {
                                                        value: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(walletParseh))
                                                    }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : policy?.creditPrice != null && !isNew ? t('aiPricing.policies.editor.creditSnapshot', {
                                                        value: (0, $7df21990c7b31bb5$export$539a7225fef603b0)(policy.creditPrice, policy.creditCurrency, priceArgs)
                                                    }) : walletCredit ? t('aiPricing.policies.editor.creditFrom', {
                                                        value: (0, $7df21990c7b31bb5$export$539a7225fef603b0)(walletCredit.amountMinor, walletCredit.currency, {
                                                            ...priceArgs,
                                                            minor: true
                                                        })
                                                    }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                                                })
                                            }),
                                            numberField('targetMarginPct', 'margin', {
                                                unit: t('aiPricing.policies.editor.percent'),
                                                min: 0,
                                                max: 99
                                            }),
                                            numberField('overheadPct', 'overhead', {
                                                unit: t('aiPricing.policies.editor.percent'),
                                                min: 0
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                                label: t('aiPricing.policies.editor.basis'),
                                                value: form.costBasis,
                                                onChange: set('costBasis'),
                                                options: (0, $ad1ad54ff7f74a69$export$fe9e2c1c888f4b9b).map((b)=>({
                                                        value: b,
                                                        label: basisLabel(b)
                                                    })),
                                                placeholder: t('aiPricing.policies.editor.basis'),
                                                disabled: !editable,
                                                "data-testid": "ai-policy-basis"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                                label: t('aiPricing.policies.editor.window'),
                                                value: String(form.windowDays),
                                                onChange: (e)=>{
                                                    setTouched(true);
                                                    setForm((f)=>({
                                                            ...f,
                                                            windowDays: Number(e.target?.value ?? e)
                                                        }));
                                                },
                                                options: (0, $ad1ad54ff7f74a69$export$9fa273245baa497).map((d)=>({
                                                        value: String(d),
                                                        label: t(`aiPricing.policies.editor.windowOptions.${d}`)
                                                    })),
                                                placeholder: t('aiPricing.policies.editor.window'),
                                                disabled: !editable,
                                                "data-testid": "ai-policy-window"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                                label: t('aiPricing.policies.editor.rounding'),
                                                value: form.rounding,
                                                onChange: set('rounding'),
                                                options: (0, $ad1ad54ff7f74a69$export$c5fe1557c05c3963).map((r)=>({
                                                        value: r,
                                                        label: t(`aiPricing.policies.editor.roundingOptions.${r}`)
                                                    })),
                                                placeholder: t('aiPricing.policies.editor.rounding'),
                                                disabled: !editable,
                                                "data-testid": "ai-policy-rounding"
                                            }),
                                            numberField('minParseh', 'minParseh', {
                                                unit: t('common.units.parseh'),
                                                min: 0
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                                label: t('aiPricing.policies.editor.note'),
                                                value: form.note,
                                                onChange: set('note'),
                                                rows: 2,
                                                maxLength: 500,
                                                disabled: !editable,
                                                "data-testid": "ai-policy-note"
                                            }),
                                            editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                type: "submit",
                                                variant: "outline",
                                                disabled: !canSimulate,
                                                "aria-keyshortcuts": "Control+Enter",
                                                "data-testid": "ai-policy-simulate",
                                                children: [
                                                    pending === 'simulate' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                                        size: 16,
                                                        thickness: 2,
                                                        color: "currentColor"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b547c0f28739ad4$export$2e2bcd8739ae039), {
                                                        size: 16,
                                                        "aria-hidden": true
                                                    }),
                                                    t('aiPricing.policies.editor.simulate'),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2acbbdcdb6ac534$export$5e66ad77b1eb2956), {
                                                        combo: "ctrl+enter",
                                                        style: {
                                                            background: 'transparent',
                                                            border: '1px solid currentColor',
                                                            opacity: 0.6
                                                        }
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                        className: "min-w-0 rounded-lg border border-border bg-card",
                                        "aria-label": t('aiPricing.policies.editor.results.title'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-wrap items-center justify-between gap-2 border-b border-border px-4 py-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                        className: "text-sm font-bold text-foreground",
                                                        children: t('aiPricing.policies.editor.results.title')
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground",
                                                        "data-testid": "ai-policy-results-summary",
                                                        children: [
                                                            detail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        "data-testid": "ai-policy-projected",
                                                                        children: t('aiPricing.policies.editor.results.projected', {
                                                                            pct: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.projectedBlendedMarginPct) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatPercent((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail.projectedBlendedMarginPct))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: t('aiPricing.policies.editor.results.counts', {
                                                                            dearer: detail.dearer || 0,
                                                                            cheaper: detail.cheaper || 0,
                                                                            negative: detail.negative || 0
                                                                        })
                                                                    })
                                                                ]
                                                            }) : null,
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                                                                columns: csvColumns,
                                                                rows: detail?.prices || [],
                                                                "data-testid": "ai-policy-csv"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab8ae46088ca8cb0$export$2e2bcd8739ae039), {
                                                prices: detail?.prices || [],
                                                canOverride: canOverride,
                                                overrideDisabledReason: isNew ? t('aiPricing.policies.editor.saveFirst') : t('aiPricing.services.drawer.editActiveHint'),
                                                onOverride: override,
                                                pendingKey: pending?.startsWith('override:') ? pending.slice(9) : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            !loading && !loadError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sticky bottom-0 flex flex-wrap items-center gap-2 border-t border-border bg-card px-8 py-3",
                "data-testid": "ai-policy-savebar",
                children: [
                    editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: save,
                                disabled: !canSave,
                                "aria-keyshortcuts": "Control+S",
                                "data-testid": "ai-policy-save",
                                children: [
                                    pending === 'save' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 16,
                                        thickness: 2,
                                        color: "currentColor"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    t('aiPricing.policies.editor.saveDraft'),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2acbbdcdb6ac534$export$5e66ad77b1eb2956), {
                                        combo: "ctrl+s",
                                        style: {
                                            background: 'transparent',
                                            border: '1px solid currentColor',
                                            opacity: 0.6
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                onClick: ()=>{
                                    setActivateError(null);
                                    setConflict(false);
                                    setActivating(true);
                                },
                                disabled: !canActivate,
                                title: canActivate ? undefined : t('aiPricing.policies.editor.activateHint'),
                                "data-testid": "ai-policy-activate",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00b4789eeda33397$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    t('aiPricing.policies.editor.activate')
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        onClick: onExit,
                        "data-testid": "ai-policy-cancel",
                        children: t('aiPricing.policies.editor.cancel')
                    }),
                    policy?.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ms-auto text-xs text-muted-foreground",
                        children: t('aiPricing.services.source.policy', {
                            id: formatDigits(policy.id)
                        })
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77b97fa5312eb73e$export$2e2bcd8739ae039), {
                open: activating,
                onOpenChange: (open)=>{
                    if (!open && pending !== 'activate') setActivating(false);
                },
                detail: detail,
                pending: pending === 'activate',
                error: activateError,
                conflict: conflict,
                onConfirm: activate,
                onReload: reloadAfterConflict,
                creditChange: creditChange
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7b20c5205e441d74$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowLeft", [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7bd01277b42cc315$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("FlaskConical", [
    [
        "path",
        {
            d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2",
            key: "pzvekw"
        }
    ],
    [
        "path",
        {
            d: "M8.5 2h7",
            key: "csnxdl"
        }
    ],
    [
        "path",
        {
            d: "M7 16h10",
            key: "wp8him"
        }
    ]
]);








const $68c8920a36d2e950$var$OUTCOME_VARIANT = {
    repriced: 'success',
    recorded: 'success',
    unchanged: 'outline',
    held: 'warning',
    rejected: 'destructive',
    no_policy: 'warning',
    disabled: 'outline'
};
const $68c8920a36d2e950$var$STATUS_VARIANT = {
    accepted: 'success',
    rejected: 'destructive'
};
function $68c8920a36d2e950$export$2e2bcd8739ae039({ policies: policies, window: window, go: go }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mt-6 rounded-lg border border-border bg-card",
        "aria-labelledby": "ai-fx-title",
        "data-testid": "ai-fx",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-b border-border px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        id: "ai-fx-title",
                        className: "inline-flex items-center gap-1.5 text-sm font-bold text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            t('aiPricing.fx.title')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-0.5 text-xs text-muted-foreground",
                        children: t('aiPricing.fx.sub')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-6 p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68c8920a36d2e950$var$Simulation, {
                        policies: policies,
                        window: window,
                        go: go
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68c8920a36d2e950$var$FxHistory, {
                        go: go
                    })
                ]
            })
        ]
    });
}
function $68c8920a36d2e950$var$Simulation({ policies: policies, window: window, go: go }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.status');
    const [policyId, setPolicyId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [market, setMarket] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [result, setResult] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [labels, setLabels] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // The price changes carry service keys only; their names are a convenience.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!result || labels.length) return undefined;
        let alive = true;
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$dfc0f3cce358cc87), {
            window: window
        }).then((d)=>{
            if (alive) setLabels(d?.aiServices?.services || []);
        }).catch(()=>{});
        return ()=>{
            alive = false;
        };
    }, [
        result,
        labels.length,
        window
    ]);
    const marketValid = market === '' || (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(market) != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(market) > 0;
    const run = async ()=>{
        if (pending || !marketValid) return;
        setPending(true);
        setError(null);
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$d1d6015cb7566cb0), {
                policyId: policyId || null,
                marketToman: market === '' ? null : String(market)
            });
            setResult(d?.simulateAiNightlyFx || null);
        } catch (e) {
            setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const choices = (policies || []).filter((p)=>p.status !== 'archived');
    const state = pending ? 'loading' : error ? 'error' : result ? 'content' : 'idle';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-fx-sim",
        "data-state": state,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "mb-2 inline-flex items-center gap-1.5 text-sm font-bold text-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bd01277b42cc315$export$2e2bcd8739ae039), {
                        size: 15,
                        "aria-hidden": true
                    }),
                    t('aiPricing.fx.sim.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: "grid grid-cols-1 items-end gap-3 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto]",
                onSubmit: (e)=>{
                    e.preventDefault();
                    run();
                },
                "aria-label": t('aiPricing.fx.sim.title'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.fx.sim.policy'),
                        value: policyId,
                        onChange: (e)=>setPolicyId(e.target?.value ?? e),
                        options: [
                            {
                                value: '',
                                label: t('aiPricing.fx.sim.policyActive')
                            },
                            ...choices.map((p)=>({
                                    value: String(p.id),
                                    label: t('aiPricing.visits.filters.rateOption', {
                                        name: p.name,
                                        status: statusLabel(p.status)
                                    })
                                }))
                        ],
                        placeholder: t('aiPricing.fx.sim.policyActive'),
                        disabled: pending,
                        "data-testid": "ai-fx-sim-policy"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                        label: t('aiPricing.fx.sim.market'),
                        helperText: t('aiPricing.fx.sim.marketHelp'),
                        value: market,
                        onChange: (e)=>setMarket(e.target?.value ?? e),
                        unit: t('common.units.toman'),
                        min: 1,
                        error: marketValid ? undefined : t('aiPricing.fx.sim.marketInvalid'),
                        disabled: pending,
                        "data-testid": "ai-fx-sim-market"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "outline",
                        disabled: pending || !marketValid,
                        "aria-busy": pending || undefined,
                        "data-testid": "ai-fx-sim-run",
                        children: [
                            pending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                size: 16,
                                thickness: 2,
                                color: "currentColor"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bd01277b42cc315$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            t('aiPricing.fx.sim.run')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-xs text-muted-foreground",
                children: t('aiPricing.fx.sim.readOnly')
            }),
            pending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-3 text-xs text-muted-foreground",
                role: "status",
                "aria-live": "polite",
                "data-testid": "ai-fx-sim-pending",
                children: t(market === '' ? 'aiPricing.fx.sim.pendingMarket' : 'aiPricing.fx.sim.pending')
            }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                className: "mt-3",
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    size: "sm",
                    onClick: run,
                    children: t('common.actions.retry')
                }),
                "data-testid": "ai-fx-sim-error",
                children: error
            }) : result ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68c8920a36d2e950$var$SimulationResult, {
                result: result,
                labels: labels,
                go: go
            }) : null
        ]
    });
}
function $68c8920a36d2e950$var$SimulationResult({ result: r, labels: labels, go: go }) {
    const { t: t, has: has, formatDigits: formatDigits, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const pct = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 2
        });
    const verdictKey = `aiPricing.fx.sim.verdict.${r.outcome}`;
    const outcomeLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.outcome');
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.status');
    const sourceLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.source');
    const unitLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.unit');
    const serviceLabel = (0, $b758277144067032$export$77dd77850115e3ad)();
    const labelOf = (key)=>{
        const row = labels.find((s)=>s.serviceKey === key);
        return row ? serviceLabel(row) : key;
    };
    const rate = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "whitespace-nowrap",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                    value: v
                }),
                " ",
                t('common.units.toman')
            ]
        });
    const policyLink = (id)=>id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "link",
            size: "sm",
            className: "h-auto p-0",
            onClick: ()=>go({
                    policy: String(id)
                }),
            "data-testid": `ai-fx-sim-policy-${id}`,
            children: t('aiPricing.services.source.policy', {
                id: formatDigits(id)
            })
        }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 flex flex-col gap-4",
        "data-testid": "ai-fx-sim-result",
        "data-outcome": r.outcome,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: $68c8920a36d2e950$var$OUTCOME_VARIANT[r.outcome] || 'outline',
                        "data-testid": "ai-fx-sim-outcome",
                        children: outcomeLabel(r.outcome)
                    }),
                    has && has(verdictKey) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-sm text-foreground",
                        children: t(verdictKey)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "grid grid-cols-2 gap-4 text-sm md:grid-cols-4",
                "data-testid": "ai-fx-sim-rates",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.marketRate'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "inline-flex flex-wrap items-center gap-1",
                            children: [
                                rate(r.marketToman),
                                r.source ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: sourceLabel(r.source)
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.pricingRate', {
                            premium: pct(r.premiumPct)
                        }),
                        value: rate(r.fxToman)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.currentRate'),
                        value: rate(r.currentFxToman)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.baseRate'),
                        value: rate(r.baseFxToman)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.check'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: $68c8920a36d2e950$var$STATUS_VARIANT[r.status] || 'outline',
                            children: statusLabel(r.status)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.simulated'),
                        value: r.standIn ? t('aiPricing.fx.sim.standIn') : policyLink(r.policyId)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.base'),
                        value: policyLink(r.basePolicyId)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.guards'),
                        value: t('aiPricing.fx.sim.guardsValue', {
                            min: pct(r.minChangePct),
                            max: pct(r.maxStepPct)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.runAt'),
                        value: r.runAt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            ...(0, $c53f9539af19d960$export$3433559efc22d110),
                            className: "tabular-nums",
                            children: formatDigits(r.runAt)
                        }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.fx.sim.reprice'),
                        value: r.repriceEnabled ? t('common.value.yes') : t('common.value.no')
                    })
                ]
            }),
            r.whyHeld ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                "data-testid": "ai-fx-sim-why",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: t('aiPricing.fx.sim.whyHeld')
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...(0, $c53f9539af19d960$export$3433559efc22d110),
                        children: r.whyHeld
                    })
                ]
            }) : null,
            r.reason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: r.status === 'rejected' ? 'error' : 'info',
                "data-testid": "ai-fx-sim-reason",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: t('aiPricing.fx.sim.reason')
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...(0, $c53f9539af19d960$export$3433559efc22d110),
                        children: r.reason
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto rounded-lg border border-border",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                    dense: true,
                    ariaLabel: t('aiPricing.fx.sim.changesAria'),
                    rows: r.changes || [],
                    rowKey: (c)=>c.serviceKey,
                    rowProps: (c)=>({
                            'data-testid': `ai-fx-sim-change-${c.serviceKey}`,
                            'data-flagged': c.tooLarge || c.newlyNegative ? 'true' : undefined
                        }),
                    columns: [
                        {
                            key: 'service',
                            header: t('aiPricing.fx.sim.columns.service'),
                            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "truncate text-foreground",
                                            children: labelOf(c.serviceKey)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "truncate text-xs text-muted-foreground",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                                children: c.serviceKey
                                            })
                                        })
                                    ]
                                })
                        },
                        {
                            key: 'unit',
                            header: t('aiPricing.fx.sim.columns.unit'),
                            width: '7rem',
                            render: (c)=>unitLabel(c.unit)
                        },
                        {
                            key: 'move',
                            header: t('aiPricing.fx.sim.columns.move', {
                                coin: t('common.units.parseh')
                            }),
                            align: 'end',
                            width: '10rem',
                            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex items-center gap-1 whitespace-nowrap tabular-nums",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                            value: c.fromParseh
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b20c5205e441d74$export$2e2bcd8739ae039), {
                                            size: 13,
                                            "aria-hidden": true,
                                            style: (0, $c53f9539af19d960$export$ddb338179359cccc)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "sr-only",
                                            children: t('aiPricing.fx.sim.to')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                            value: c.toParseh,
                                            className: "font-semibold"
                                        })
                                    ]
                                })
                        },
                        {
                            key: 'change',
                            header: t('aiPricing.fx.sim.columns.change'),
                            align: 'end',
                            width: '6rem',
                            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$b39126116ceb31d8), {
                                    value: c.changePct
                                })
                        },
                        {
                            key: 'margin',
                            header: t('aiPricing.fx.sim.columns.margin'),
                            align: 'end',
                            width: '6rem',
                            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                                    value: c.marginPct
                                })
                        },
                        {
                            key: 'flags',
                            header: t('aiPricing.fx.sim.columns.flags'),
                            width: '11rem',
                            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex flex-wrap gap-1",
                                    children: [
                                        c.tooLarge ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "warning",
                                            "data-testid": `ai-fx-sim-change-${c.serviceKey}-too-large`,
                                            children: t('aiPricing.fx.sim.tooLarge')
                                        }) : null,
                                        c.newlyNegative ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "destructive",
                                            "data-testid": `ai-fx-sim-change-${c.serviceKey}-negative`,
                                            children: t('aiPricing.fx.sim.newlyNegative')
                                        }) : null,
                                        !c.tooLarge && !c.newlyNegative ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                                        }) : null
                                    ]
                                })
                        }
                    ],
                    empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "p-4 text-sm text-muted-foreground",
                        "data-testid": "ai-fx-sim-changes-empty",
                        children: t('aiPricing.fx.sim.noChanges')
                    }),
                    "data-testid": "ai-fx-sim-changes"
                })
            })
        ]
    });
}
/** Every night's read of the dollar, newest first, server-paged. */ function $68c8920a36d2e950$var$FxHistory({ go: go }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate, formatDateTime: formatDateTime, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const outcomeLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.outcome');
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.status');
    const sourceLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.fx.source');
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$13d314dcdb28d936), {
            page: page,
            pageSize: (0, $ad1ad54ff7f74a69$export$ba194ab73a5e5e06)
        }).then((d)=>setData(d?.aiFxRates || {
                rates: [],
                total: 0
            })).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        page,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const rate = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
            value: v
        });
    const rows = data?.rates || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-fx-history",
        "data-state": loading ? 'loading' : error ? 'error' : rows.length ? 'content' : 'empty',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "mb-2 inline-flex items-center gap-1.5 text-sm font-bold text-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                        size: 15,
                        "aria-hidden": true
                    }),
                    t('aiPricing.fx.history.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-x-auto rounded-lg border border-border",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 7,
                    rows: 4,
                    label: t('aiPricing.fx.history.loading'),
                    "data-testid": "ai-fx-history-loading"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.fx.history.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-fx-history-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                    dense: true,
                    ariaLabel: t('aiPricing.fx.history.aria'),
                    rows: rows,
                    rowKey: (r)=>r.id,
                    rowProps: (r)=>({
                            'data-testid': `ai-fx-history-row-${r.id}`
                        }),
                    columns: [
                        {
                            key: 'date',
                            header: t('aiPricing.fx.history.columns.date'),
                            width: '11rem',
                            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    title: r.fetchedAt ? formatDateTime(r.fetchedAt) : undefined,
                                    children: /^\d{4}-\d{2}-\d{2}$/.test(r.rateDate || '') ? formatDate(`${r.rateDate}T12:00:00Z`) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                                })
                        },
                        {
                            key: 'market',
                            header: t('aiPricing.fx.history.columns.market', {
                                unit: t('common.units.toman')
                            }),
                            align: 'end',
                            width: '9rem',
                            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex flex-col items-end gap-0.5",
                                    children: [
                                        rate(r.marketTomanPerUsd),
                                        r.source ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[11px] text-muted-foreground",
                                            children: sourceLabel(r.source)
                                        }) : null
                                    ]
                                })
                        },
                        {
                            key: 'pricing',
                            header: t('aiPricing.fx.history.columns.pricing', {
                                unit: t('common.units.toman')
                            }),
                            align: 'end',
                            width: '9rem',
                            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex flex-col items-end gap-0.5",
                                    children: [
                                        rate(r.fxTomanPerUsd),
                                        (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.premiumPct) != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[11px] text-muted-foreground",
                                            children: t('aiPricing.fx.history.premium', {
                                                pct: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.premiumPct), {
                                                    maximumFractionDigits: 2
                                                })
                                            })
                                        }) : null
                                    ]
                                })
                        },
                        {
                            key: 'status',
                            header: t('aiPricing.fx.history.columns.status'),
                            width: '7rem',
                            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: $68c8920a36d2e950$var$STATUS_VARIANT[r.status] || 'outline',
                                    children: statusLabel(r.status)
                                })
                        },
                        {
                            key: 'outcome',
                            header: t('aiPricing.fx.history.columns.outcome'),
                            width: '8rem',
                            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: $68c8920a36d2e950$var$OUTCOME_VARIANT[r.outcome] || 'outline',
                                    children: outcomeLabel(r.outcome)
                                })
                        },
                        {
                            key: 'reason',
                            header: t('aiPricing.fx.history.columns.reason'),
                            render: (r)=>r.reason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                    className: "block max-w-[28rem] truncate text-xs",
                                    title: r.reason,
                                    children: r.reason
                                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                        },
                        {
                            key: 'policy',
                            header: t('aiPricing.fx.history.columns.policy'),
                            width: '8rem',
                            render: (r)=>r.policyId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    size: "sm",
                                    className: "h-auto p-0",
                                    onClick: ()=>go({
                                            policy: String(r.policyId)
                                        }),
                                    "data-testid": `ai-fx-history-row-${r.id}-policy`,
                                    children: t('aiPricing.services.source.policy', {
                                        id: formatDigits(r.policyId)
                                    })
                                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                        }
                    ],
                    empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.fx.history.empty.title'),
                        description: t('aiPricing.fx.history.empty.desc'),
                        "data-testid": "ai-fx-history-empty"
                    }),
                    "data-testid": "ai-fx-history-table"
                })
            }),
            !loading && !error && (data?.total || 0) > (0, $ad1ad54ff7f74a69$export$ba194ab73a5e5e06) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "ai-fx-history-pager",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                    page: page,
                    pageCount: (0, $ad1ad54ff7f74a69$export$a3a372017b8de354)(data?.total, (0, $ad1ad54ff7f74a69$export$ba194ab73a5e5e06)),
                    pageSize: (0, $ad1ad54ff7f74a69$export$ba194ab73a5e5e06),
                    onChange: setPage,
                    prevLabel: t('common.pager.prev'),
                    nextLabel: t('common.pager.next'),
                    pageLabel: (p, total)=>t('common.pager.label', {
                            page: p,
                            total: total
                        }),
                    formatNumber: formatNumber
                })
            }) : null
        ]
    });
}



const $b2bfd28cffb3dfed$var$STATUS_VARIANT = {
    draft: 'outline',
    active: 'success',
    archived: 'outline'
};
const $b2bfd28cffb3dfed$var$EVENTS_PAGE_SIZE = 20;
function $b2bfd28cffb3dfed$export$2e2bcd8739ae039({ window: window, view: view, go: go, onEditorDirty: onEditorDirty }) {
    const { t: t, formatDate: formatDate, formatDateTime: formatDateTime, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.status');
    const basisLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.editor.basisOptions');
    const kindLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.events.kind');
    const fxSourceLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.fxSource');
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [creating, setCreating] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [source, setSource] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [archiving, setArchiving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$f4a42e7153fdade0)).then((d)=>setRows(d?.aiPricingPolicies || [])).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const active = rows.find((p)=>p.status === 'active') || null;
    const archive = async ()=>{
        setPending(true);
        try {
            await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$935985951b6b72f6), {
                id: archiving.id
            });
            toast.success(t('aiPricing.policies.archiveDialog.success'));
            setArchiving(null);
            load({
                quiet: true
            });
        } catch (e) {
            toast.error((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    if (view.policy) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a2eb25e6d7157ad$export$2e2bcd8739ae039), {
        policyId: view.policy,
        cloneFromId: view.from || null,
        policies: rows,
        onExit: ()=>go({
                policy: '',
                from: ''
            }),
        onDirtyChange: onEditorDirty,
        onActivated: ()=>{
            go({
                policy: '',
                from: ''
            });
            load({
                quiet: true
            });
        },
        onSaved: (id)=>{
            if (view.policy === 'new' && id) go({
                policy: id,
                from: ''
            });
        },
        onOpenPolicy: (id)=>go({
                policy: String(id),
                from: ''
            })
    }, view.policy);
    // The USD rate exists only for a credit priced in toman (PM-0211). A list with
    // no such policy — a USD deployment — has no rate column at all; a mixed one
    // shows the dash on the rows that never had a rate.
    const withFx = !rows.length || rows.some((p)=>(0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(p.creditCurrency));
    const csvColumns = [
        {
            key: 'id',
            header: 'id',
            value: (p)=>p.id
        },
        {
            key: 'name',
            header: t('aiPricing.policies.columns.name'),
            value: (p)=>p.name
        },
        {
            key: 'status',
            header: t('aiPricing.policies.columns.status'),
            value: (p)=>p.status
        },
        {
            key: 'fxSource',
            header: t('aiPricing.policies.columns.fxSource'),
            value: (p)=>p.fxSource || 'manual'
        },
        {
            key: 'basePolicyId',
            header: t('aiPricing.policies.columns.base'),
            value: (p)=>p.basePolicyId
        },
        withFx ? {
            key: 'fx',
            header: t('aiPricing.policies.columns.fx'),
            value: (p)=>p.fxTomanPerUsd
        } : null,
        {
            key: 'margin',
            header: t('aiPricing.policies.columns.margin'),
            value: (p)=>p.targetMarginPct
        },
        {
            key: 'basis',
            header: t('aiPricing.policies.editor.basis'),
            value: (p)=>p.costBasis
        },
        {
            key: 'window',
            header: t('aiPricing.policies.editor.window'),
            value: (p)=>p.windowDays
        },
        {
            key: 'priced',
            header: t('aiPricing.policies.columns.priced'),
            value: (p)=>p.servicesPriced
        },
        {
            key: 'activatedAt',
            header: t('aiPricing.policies.columns.activated'),
            value: (p)=>p.activatedAt
        }
    ].filter(Boolean);
    const columns = [
        {
            key: 'name',
            header: t('aiPricing.policies.columns.name'),
            render: (p)=>{
                // PM-0427: who set this policy's dollar — an operator, or the nightly
                // dollar, which derives its prices from an operator's policy (the link).
                const source = p.fxSource || 'manual';
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            children: p.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t('aiPricing.services.source.policy', {
                                        id: formatDigits(p.id)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: source === 'nightly' ? 'default' : 'outline',
                                    "data-testid": `ai-policies-row-${p.id}-fx-source`,
                                    "data-source": source,
                                    children: fxSourceLabel(source)
                                }),
                                p.basePolicyId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    size: "sm",
                                    className: "h-auto p-0 text-xs",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        go({
                                            policy: String(p.basePolicyId)
                                        });
                                    },
                                    "data-testid": `ai-policies-row-${p.id}-base`,
                                    children: t('aiPricing.policies.basedOn', {
                                        id: formatDigits(p.basePolicyId)
                                    })
                                }) : null
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: 'status',
            header: t('aiPricing.policies.columns.status'),
            width: '7rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: $b2bfd28cffb3dfed$var$STATUS_VARIANT[p.status] || 'outline',
                    children: statusLabel(p.status)
                })
        },
        withFx ? {
            key: 'fx',
            header: t('aiPricing.policies.columns.fx'),
            align: 'end',
            width: '8rem',
            render: (p)=>(0, $7df21990c7b31bb5$export$d72e5b8b2761465b)(p.creditCurrency) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                            value: p.fxTomanPerUsd
                        }),
                        " ",
                        t('common.units.toman')
                    ]
                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        } : null,
        {
            key: 'margin',
            header: t('aiPricing.policies.columns.margin'),
            align: 'end',
            width: '7rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$b39126116ceb31d8), {
                    value: p.targetMarginPct
                })
        },
        {
            key: 'basis',
            header: t('aiPricing.policies.columns.basis'),
            width: '9rem',
            render: (p)=>t('aiPricing.policies.basisWindow', {
                    basis: basisLabel(p.costBasis),
                    days: p.windowDays
                })
        },
        {
            key: 'priced',
            header: t('aiPricing.policies.columns.priced'),
            align: 'end',
            width: '8rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                            value: p.servicesPriced
                        }),
                        (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(p.negativeMargins) > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "destructive",
                            className: "tabular-nums",
                            children: formatDigits(p.negativeMargins)
                        }) : null
                    ]
                })
        },
        {
            key: 'activated',
            header: t('aiPricing.policies.columns.activated'),
            width: '13rem',
            render: (p)=>p.activatedAt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-wrap items-center gap-1",
                    children: [
                        formatDate(p.activatedAt),
                        p.activatedBy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f68e1d223f0d9b1$export$2e2bcd8739ae039), {
                            actor: p.activatedBy
                        }) : null
                    ]
                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'actions',
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: t('aiPricing.policies.columns.actions')
            }),
            align: 'end',
            width: '18rem',
            render: (p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-wrap items-center justify-end gap-1",
                    children: [
                        p.status === 'draft' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            size: "sm",
                            onClick: (e)=>{
                                e.stopPropagation();
                                go({
                                    policy: p.id
                                });
                            },
                            "data-testid": `ai-policies-row-${p.id}-activate`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00b4789eeda33397$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('aiPricing.policies.actions.activate')
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            size: "sm",
                            onClick: (e)=>{
                                e.stopPropagation();
                                go({
                                    policy: 'new',
                                    from: p.id
                                });
                            },
                            "data-testid": `ai-policies-row-${p.id}-clone`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('aiPricing.policies.actions.clone')
                            ]
                        }),
                        p.status === 'draft' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            size: "sm",
                            onClick: (e)=>{
                                e.stopPropagation();
                                setArchiving(p);
                            },
                            "data-testid": `ai-policies-row-${p.id}-archive`,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $357b00fa120a5c4e$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('aiPricing.policies.actions.archive')
                            ]
                        }) : null
                    ]
                })
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-policies",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-muted-foreground",
                        "aria-live": "polite",
                        "data-testid": "ai-policies-count",
                        children: t('aiPricing.policies.count', {
                            count: rows.length
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                                columns: csvColumns,
                                rows: rows,
                                "data-testid": "ai-policies-csv"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setSource(active ? active.id : '');
                                    setCreating(true);
                                },
                                "data-testid": "ai-policies-new",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    t('aiPricing.policies.new')
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: refreshing ? 0.45 : 1
                },
                "aria-busy": refreshing || undefined,
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 8,
                    rows: 4,
                    label: t('aiPricing.policies.loading'),
                    "data-testid": "ai-policies-loading"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.policies.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-policies-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                    dense: true,
                    ariaLabel: t('aiPricing.policies.tableAria'),
                    columns: columns,
                    rows: rows,
                    rowKey: (p)=>p.id,
                    onRowActivate: (p)=>go({
                            policy: p.id
                        }),
                    rowProps: (p)=>({
                            'data-testid': `ai-policies-row-${p.id}`,
                            'aria-label': `${t('aiPricing.policies.actions.open')}: ${p.name}`
                        }),
                    empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adb270212de20834$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.policies.empty.title'),
                        description: t('aiPricing.policies.empty.desc'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setSource('');
                                setCreating(true);
                            },
                            children: t('aiPricing.policies.new')
                        }),
                        "data-testid": "ai-policies-empty"
                    }),
                    "data-testid": "ai-policies-table"
                })
            }),
            !loading && withFx ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68c8920a36d2e950$export$2e2bcd8739ae039), {
                policies: rows,
                window: window,
                go: go
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b2bfd28cffb3dfed$var$EventsSection, {
                kindLabel: kindLabel,
                formatDateTime: formatDateTime
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
                open: creating,
                onOpenChange: setCreating,
                title: t('aiPricing.policies.newDialog.title'),
                submitLabel: t('aiPricing.policies.newDialog.submit'),
                onSubmit: ()=>{
                    setCreating(false);
                    go({
                        policy: 'new',
                        from: source || ''
                    });
                },
                "data-testid": "ai-policies-new-dialog",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "ai-policies-new-source",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.policies.newDialog.source'),
                        value: source,
                        onChange: (e)=>setSource(e.target?.value ?? e),
                        options: [
                            {
                                value: '',
                                label: t('aiPricing.policies.newDialog.blank')
                            },
                            ...rows.map((p)=>({
                                    value: p.id,
                                    label: t('aiPricing.policies.newDialog.fromPolicy', {
                                        name: p.name
                                    })
                                }))
                        ],
                        placeholder: t('aiPricing.policies.newDialog.source')
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: !!archiving,
                onOpenChange: (open)=>{
                    if (!open && !pending) setArchiving(null);
                },
                title: t('aiPricing.policies.archiveDialog.title', {
                    name: archiving?.name || ''
                }),
                description: t('aiPricing.policies.archiveDialog.body'),
                confirmLabel: t('aiPricing.policies.archiveDialog.confirm'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                loading: pending,
                onConfirm: archive,
                "data-testid": "ai-policies-archive-confirm",
                confirmTestId: "ai-policies-archive-confirm-submit"
            })
        ]
    });
}
/** «تاریخچهٔ تغییرات» — the audit trail (flow F16), server-paged. */ function $b2bfd28cffb3dfed$var$EventsSection({ kindLabel: kindLabel, formatDateTime: formatDateTime }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$236ee48da43a068e), {
            page: page,
            pageSize: $b2bfd28cffb3dfed$var$EVENTS_PAGE_SIZE
        }).then((d)=>setData(d?.aiPricingEvents || {
                events: [],
                total: 0
            })).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        page,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mt-6",
        "data-testid": "ai-policies-events",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "mb-2 inline-flex items-center gap-1.5 text-sm font-bold text-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    t('aiPricing.policies.events.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 4,
                    rows: 3,
                    label: t('aiPricing.policies.events.loading'),
                    "data-testid": "ai-policies-events-loading"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.policies.events.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-policies-events-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                    dense: true,
                    ariaLabel: t('aiPricing.policies.events.aria'),
                    rows: data?.events || [],
                    rowKey: (e)=>e.id,
                    columns: [
                        {
                            key: 'at',
                            header: t('aiPricing.policies.events.columns.at'),
                            width: '11rem',
                            render: (e)=>formatDateTime(e.at)
                        },
                        {
                            key: 'actor',
                            header: t('aiPricing.policies.events.columns.actor'),
                            width: '10rem',
                            render: (e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f68e1d223f0d9b1$export$2e2bcd8739ae039), {
                                    actor: e.actorSub
                                })
                        },
                        {
                            key: 'kind',
                            header: t('aiPricing.policies.events.columns.kind'),
                            width: '12rem',
                            render: (e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: kindLabel(e.kind)
                                })
                        },
                        {
                            key: 'entity',
                            header: t('aiPricing.policies.events.columns.entity'),
                            render: (e)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                    children: `${e.entity}/${e.entityId}`
                                })
                        }
                    ],
                    empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "p-4 text-sm text-muted-foreground",
                        "data-testid": "ai-policies-events-empty",
                        children: t('aiPricing.policies.events.empty')
                    }),
                    "data-testid": "ai-policies-events-table"
                })
            }),
            !loading && !error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "ai-policies-events-pager",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                    page: page,
                    pageCount: (0, $ad1ad54ff7f74a69$export$a3a372017b8de354)(data?.total, $b2bfd28cffb3dfed$var$EVENTS_PAGE_SIZE),
                    pageSize: $b2bfd28cffb3dfed$var$EVENTS_PAGE_SIZE,
                    onChange: setPage,
                    prevLabel: t('common.pager.prev'),
                    nextLabel: t('common.pager.next'),
                    pageLabel: (p, total)=>t('common.pager.label', {
                            page: p,
                            total: total
                        }),
                    formatNumber: formatNumber
                })
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");







parcelRequire("acw62");




const $589f6b225149599c$var$STATUS_VARIANT = {
    ok: 'success',
    error: 'destructive',
    aborted: 'warning'
};
function $589f6b225149599c$export$2e2bcd8739ae039({ rows: rows, onOpen: onOpen, empty: empty, labelOf: labelOf }) {
    const { t: t, formatDateTime: formatDateTime, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.ledger.status');
    const ownerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.overview.owner');
    const reasonLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.ledger.chargeReason');
    const columns = [
        {
            key: 'time',
            header: t('aiPricing.ledger.columns.time'),
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tabular-nums",
                    children: formatDateTime(r.startedAt)
                })
        },
        {
            key: 'service',
            header: t('aiPricing.ledger.columns.service'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate font-semibold text-foreground",
                            children: labelOf(r.serviceKey)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "truncate text-xs text-muted-foreground",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                children: r.serviceKey
                            })
                        })
                    ]
                })
        },
        {
            key: 'owner',
            header: t('aiPricing.ledger.columns.owner'),
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-xs text-muted-foreground",
                            children: ownerLabel(r.ownerType)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                            title: r.ownerId,
                            children: String(r.ownerId || '').slice(0, 12)
                        })
                    ]
                })
        },
        {
            key: 'calls',
            header: t('aiPricing.ledger.columns.calls'),
            align: 'end',
            width: '5rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                    value: r.calls
                })
        },
        {
            key: 'tokens',
            header: t('aiPricing.ledger.columns.tokens'),
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "tabular-nums",
                    children: [
                        formatNumber(r.inputTokens ?? 0),
                        " / ",
                        formatNumber(r.outputTokens ?? 0)
                    ]
                })
        },
        {
            key: 'cost',
            header: t('aiPricing.ledger.columns.cost'),
            align: 'end',
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                    value: r.costUsd
                })
        },
        {
            key: 'charged',
            header: t('aiPricing.ledger.columns.charged'),
            align: 'end',
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                            value: r.chargedParseh
                        }),
                        (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.chargedParseh) === 0 && r.chargeReason && r.chargeReason !== 'charged' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: r.chargeReason === 'wallet_error' ? 'destructive' : 'outline',
                            children: reasonLabel(r.chargeReason)
                        }) : null
                    ]
                })
        },
        {
            key: 'source',
            header: t('aiPricing.ledger.columns.source'),
            width: '7rem',
            render: (r)=>r.priceSource ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$330c7c36e660c06a), {
                    source: r.priceSource
                }) : t('common.value.none')
        },
        {
            key: 'status',
            header: t('aiPricing.ledger.columns.status'),
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: $589f6b225149599c$var$STATUS_VARIANT[r.status] || 'outline',
                    children: statusLabel(r.status)
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.ledger.tableAria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.requestId,
        onRowActivate: onOpen,
        rowProps: (r)=>({
                'data-testid': `ai-ledger-row-${r.requestId}`,
                'aria-label': t('aiPricing.ledger.open', {
                    id: r.requestId
                })
            }),
        empty: empty,
        "data-testid": "ai-ledger-table"
    });
}




var $acw62 = parcelRequire("acw62");







const $badde8da5965018c$var$CALL_STATUS_VARIANT = {
    ok: 'success',
    error: 'destructive',
    fallback: 'warning'
};
function $badde8da5965018c$export$2e2bcd8739ae039({ requestId: requestId, onClose: onClose, labelOf: labelOf }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [serviceKey, setServiceKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$c0b7ebe42c310b67), {
        open: true,
        onClose: onClose,
        title: serviceKey ? labelOf(serviceKey) : t('aiPricing.ledger.drawer.title'),
        sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
            children: requestId
        }),
        "data-testid": "ai-ledger-drawer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($badde8da5965018c$export$7bca27a2b2eae6de, {
            requestId: requestId,
            onLoaded: (inv)=>setServiceKey(inv?.serviceKey || null),
            testId: "ai-ledger-drawer"
        })
    });
}
function $badde8da5965018c$export$7bca27a2b2eae6de({ requestId: requestId, onLoaded: onLoaded, testId: testId = 'ai-ledger-drawer' }) {
    const { t: t, formatDateTime: formatDateTime, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.ledger.status');
    const ownerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.overview.owner');
    const reasonLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.ledger.chargeReason');
    const roleLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.services.role');
    const [detail, setDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const onLoadedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onLoaded);
    onLoadedRef.current = onLoaded;
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$159e6a3d72bee3d9), {
            requestId: requestId
        }).then((d)=>{
            const next = d?.aiInvocation || null;
            setDetail(next);
            onLoadedRef.current?.(next?.invocation || null);
        }).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        requestId,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const inv = detail?.invocation;
    const seconds = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 1
        });
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-state": "loading",
        role: "status",
        "aria-busy": "true",
        "aria-label": t('aiPricing.ledger.drawer.loading'),
        "data-testid": `${testId}-loading`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
            lines: 6,
            height: 18
        })
    });
    if (error || !detail) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: t('aiPricing.ledger.drawer.error'),
        description: error || t('errors.region.noAnswer'),
        onRetry: load,
        retryLabel: t('common.actions.retry'),
        "data-testid": `${testId}-error`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        "data-state": "content",
        "data-testid": `${testId}-detail`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "grid grid-cols-2 gap-4 text-sm md:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.requestId'),
                        value: inv.requestId,
                        ltr: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.owner'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                ownerLabel(inv.ownerType),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                    children: inv.ownerId
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.appointment'),
                        value: inv.appointmentId,
                        ltr: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.started'),
                        value: formatDateTime(inv.startedAt)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.finished'),
                        value: inv.finishedAt ? formatDateTime(inv.finishedAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.columns.status'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: $badde8da5965018c$var$CALL_STATUS_VARIANT[inv.status] || 'warning',
                            children: statusLabel(inv.status)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.columns.cost'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                    value: inv.costUsd
                                }),
                                " ",
                                t('common.units.usd')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.columns.charged'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                    value: inv.chargedParseh
                                }),
                                " ",
                                t('common.units.parseh')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.chargeReason'),
                        value: reasonLabel(inv.chargeReason)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.priceSource'),
                        value: inv.priceSource ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$330c7c36e660c06a), {
                            source: inv.priceSource
                        }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.wallet'),
                        value: inv.walletTransactionId,
                        ltr: true
                    }),
                    inv.billedMinutes != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.billedMinutes'),
                        value: seconds(inv.billedMinutes)
                    }) : null,
                    inv.audioSeconds != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.audioSeconds'),
                        value: seconds(inv.audioSeconds)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "mb-2 text-sm font-bold text-foreground",
                        children: t('aiPricing.ledger.drawer.calls')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto rounded-lg border border-border",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                            dense: true,
                            ariaLabel: t('aiPricing.ledger.drawer.callsAria'),
                            rows: detail.calls || [],
                            rowKey: (c)=>c.id,
                            columns: [
                                {
                                    key: 'step',
                                    header: t('aiPricing.ledger.drawer.columns.step'),
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                            children: c.step
                                        })
                                },
                                {
                                    key: 'role',
                                    header: t('aiPricing.ledger.drawer.columns.role'),
                                    render: (c)=>roleLabel(c.role)
                                },
                                {
                                    key: 'model',
                                    header: t('aiPricing.ledger.drawer.columns.model'),
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                            title: c.modelId,
                                            children: c.modelId
                                        })
                                },
                                {
                                    key: 'tokens',
                                    header: t('aiPricing.ledger.drawer.columns.tokens'),
                                    align: 'end',
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "tabular-nums",
                                            children: [
                                                formatNumber(c.inputTokens ?? 0),
                                                " / ",
                                                formatNumber(c.outputTokens ?? 0),
                                                " / ",
                                                formatNumber(c.cachedTokens ?? 0),
                                                c.tokensEstimated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: "outline",
                                                    className: "ms-1",
                                                    children: t('aiPricing.ledger.drawer.estimated')
                                                }) : null
                                            ]
                                        })
                                },
                                {
                                    key: 'audio',
                                    header: t('aiPricing.ledger.drawer.columns.audio'),
                                    align: 'end',
                                    render: (c)=>seconds(c.audioSeconds)
                                },
                                {
                                    key: 'cost',
                                    header: t('aiPricing.ledger.drawer.columns.cost'),
                                    align: 'end',
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                            value: c.costUsd
                                        })
                                },
                                {
                                    key: 'providerCost',
                                    header: t('aiPricing.ledger.drawer.columns.providerCost'),
                                    align: 'end',
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                            value: c.providerCostUsd
                                        })
                                },
                                {
                                    key: 'latency',
                                    header: t('aiPricing.ledger.drawer.columns.latency'),
                                    align: 'end',
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                            value: c.latencyMs
                                        })
                                },
                                {
                                    key: 'status',
                                    header: t('aiPricing.ledger.drawer.columns.status'),
                                    render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: $badde8da5965018c$var$CALL_STATUS_VARIANT[c.status] || 'outline',
                                            children: statusLabel(c.status)
                                        })
                                }
                            ],
                            empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "p-4 text-sm text-muted-foreground",
                                children: t('aiPricing.overview.breakdownEmpty')
                            }),
                            "data-testid": `${testId}-calls`
                        })
                    })
                ]
            })
        ]
    });
}



function $c8bdcc01e6fb30df$export$2e2bcd8739ae039({ window: window, view: view, go: go }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const [options, setOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        services: [],
        models: []
    });
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$8b221c1a60d2c3e2), {
            window: window
        }).then((d)=>{
            if (!alive) return;
            setOptions({
                services: d?.aiServices?.services || [],
                models: (d?.aiModels || []).map((m)=>m.modelId)
            });
        })// The option lists are a convenience; the ledger itself reports failure.
        .catch(()=>{});
        return ()=>{
            alive = false;
        };
    }, [
        window
    ]);
    const filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$b391194b3ee0175d)({
            ...view,
            w: view.w
        }), [
        view
    ]);
    const page = Math.max(1, Number(view.page) || 1);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$fd8ae8d35dcf3788), {
            filter: filter,
            page: page,
            pageSize: (0, $ad1ad54ff7f74a69$export$cf7fe2da72761aae)
        }).then((d)=>setData(d?.aiInvocations || {
                invocations: [],
                total: 0,
                page: page,
                pageSize: (0, $ad1ad54ff7f74a69$export$cf7fe2da72761aae)
            })).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        filter,
        page,
        t
    ]);
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: !first.current
        });
        first.current = false;
    }, [
        load
    ]);
    const labelOf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key)=>{
        const row = options.services.find((s)=>s.serviceKey === key);
        return row ? label(row) : key;
    }, [
        options.services,
        label
    ]);
    const rows = data?.invocations || [];
    const isFiltered = (0, $ad1ad54ff7f74a69$export$690c9e0c046cafec)(view);
    const clear = ()=>go({
            service: '',
            model: '',
            owner: '',
            ownerId: '',
            status: '',
            charged: '',
            dfrom: '',
            dto: '',
            page: 1
        });
    const setFilter = (patch)=>go({
            ...patch,
            page: 1
        });
    const csvColumns = [
        {
            key: 'requestId',
            header: t('aiPricing.ledger.drawer.requestId'),
            value: (r)=>r.requestId
        },
        {
            key: 'startedAt',
            header: t('aiPricing.ledger.columns.time'),
            value: (r)=>r.startedAt
        },
        {
            key: 'serviceKey',
            header: t('aiPricing.ledger.columns.service'),
            value: (r)=>r.serviceKey
        },
        {
            key: 'ownerType',
            header: t('aiPricing.ledger.filters.ownerType'),
            value: (r)=>r.ownerType
        },
        {
            key: 'ownerId',
            header: t('aiPricing.ledger.filters.ownerId'),
            value: (r)=>r.ownerId
        },
        {
            key: 'calls',
            header: t('aiPricing.ledger.columns.calls'),
            value: (r)=>r.calls
        },
        {
            key: 'inputTokens',
            header: t('aiPricing.services.drawer.columns.avgIn'),
            value: (r)=>r.inputTokens
        },
        {
            key: 'outputTokens',
            header: t('aiPricing.services.drawer.columns.avgOut'),
            value: (r)=>r.outputTokens
        },
        {
            key: 'costUsd',
            header: t('aiPricing.ledger.columns.cost'),
            value: (r)=>r.costUsd
        },
        {
            key: 'chargedParseh',
            header: t('aiPricing.ledger.columns.charged'),
            value: (r)=>r.chargedParseh
        },
        {
            key: 'chargeReason',
            header: t('aiPricing.ledger.drawer.chargeReason'),
            value: (r)=>r.chargeReason
        },
        {
            key: 'priceSource',
            header: t('aiPricing.ledger.columns.source'),
            value: (r)=>r.priceSource
        },
        {
            key: 'status',
            header: t('aiPricing.ledger.columns.status'),
            value: (r)=>r.status
        },
        {
            key: 'walletTransactionId',
            header: t('aiPricing.ledger.drawer.wallet'),
            value: (r)=>r.walletTransactionId
        }
    ];
    const all = {
        value: '',
        label: t('aiPricing.ledger.filters.all')
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-ledger",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 grid grid-cols-2 gap-3 rounded-lg border border-border bg-card p-3 md:grid-cols-4 xl:grid-cols-8",
                role: "group",
                "aria-label": t('aiPricing.ledger.filters.label'),
                "data-testid": "ai-ledger-filters",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.service'),
                        value: view.service || '',
                        onChange: (e)=>setFilter({
                                service: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...options.services.map((s)=>({
                                    value: s.serviceKey,
                                    label: label(s)
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-ledger-filter-service"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.model'),
                        value: view.model || '',
                        onChange: (e)=>setFilter({
                                model: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...options.models.map((m)=>({
                                    value: m,
                                    label: m
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        // Model ids are identifiers: the whole control is an LTR island.
                        dir: "ltr",
                        "data-testid": "ai-ledger-filter-model"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.ownerType'),
                        value: view.owner || '',
                        onChange: (e)=>setFilter({
                                owner: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...(0, $ad1ad54ff7f74a69$export$60b33fb147a66c).map((o)=>({
                                    value: o,
                                    label: t(`aiPricing.overview.owner.${o}`)
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-ledger-filter-owner"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.ownerId'),
                        value: view.ownerId || '',
                        onChange: (e)=>setFilter({
                                ownerId: e.target?.value ?? e
                            }),
                        dir: "ltr",
                        inputStyle: {
                            fontFamily: 'monospace'
                        },
                        "data-testid": "ai-ledger-filter-owner-id"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.status'),
                        value: view.status || '',
                        onChange: (e)=>setFilter({
                                status: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...(0, $ad1ad54ff7f74a69$export$c905d1784509c2ab).map((s)=>({
                                    value: s,
                                    label: t(`aiPricing.ledger.status.${s}`)
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-ledger-filter-status"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.charged'),
                        value: view.charged || '',
                        onChange: (e)=>setFilter({
                                charged: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            {
                                value: 'yes',
                                label: t('aiPricing.ledger.charged.yes')
                            },
                            {
                                value: 'no',
                                label: t('aiPricing.ledger.charged.no')
                            }
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-ledger-filter-charged"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.from'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "ai-ledger-filter-from",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: view.dfrom || '',
                                onChange: (v)=>setFilter({
                                        dfrom: v || ''
                                    }),
                                placeholder: t('aiPricing.ledger.filters.datePlaceholder'),
                                disableFuture: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.to'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "ai-ledger-filter-to",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: view.dto || '',
                                onChange: (v)=>setFilter({
                                        dto: v || ''
                                    }),
                                placeholder: t('aiPricing.ledger.filters.datePlaceholder'),
                                disableFuture: true
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-muted-foreground",
                        "aria-live": "polite",
                        "data-testid": "ai-ledger-count",
                        children: data ? t('aiPricing.ledger.count', {
                            count: data.total || 0
                        }) : null
                    }),
                    isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: clear,
                        "data-testid": "ai-ledger-clear",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('common.actions.clearFilters')
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                            columns: csvColumns,
                            rows: rows,
                            "data-testid": "ai-ledger-csv"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: refreshing ? 0.45 : 1
                },
                "aria-busy": refreshing || undefined,
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 9,
                    label: t('aiPricing.ledger.loading'),
                    "data-testid": "ai-ledger-loading"
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.ledger.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-ledger-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $589f6b225149599c$export$2e2bcd8739ae039), {
                    rows: rows,
                    labelOf: labelOf,
                    onOpen: (r)=>go({
                            inv: r.requestId
                        }),
                    empty: isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.ledger.emptyFiltered.title'),
                        description: t('aiPricing.ledger.emptyFiltered.desc'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: clear,
                            children: t('common.actions.clearFilters')
                        }),
                        "data-testid": "ai-ledger-empty"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                            size: 44,
                            strokeWidth: 1.5,
                            "aria-hidden": true
                        }),
                        title: t('aiPricing.ledger.empty.title'),
                        description: t('aiPricing.ledger.empty.desc'),
                        "data-testid": "ai-ledger-empty"
                    })
                })
            }),
            !loading && !error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "ai-ledger-pager",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                    page: page,
                    pageCount: (0, $ad1ad54ff7f74a69$export$a3a372017b8de354)(data?.total),
                    pageSize: (0, $ad1ad54ff7f74a69$export$cf7fe2da72761aae),
                    onChange: (next)=>go({
                            page: next
                        }),
                    prevLabel: t('common.pager.prev'),
                    nextLabel: t('common.pager.next'),
                    pageLabel: (p, total)=>t('common.pager.label', {
                            page: p,
                            total: total
                        }),
                    formatNumber: formatNumber
                })
            }) : null,
            view.inv ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $badde8da5965018c$export$2e2bcd8739ae039), {
                requestId: view.inv,
                labelOf: labelOf,
                onClose: ()=>go({
                        inv: ''
                    })
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3883d84d119a3732$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Stethoscope", [
    [
        "path",
        {
            d: "M11 2v2",
            key: "1539x4"
        }
    ],
    [
        "path",
        {
            d: "M5 2v2",
            key: "1yf1q8"
        }
    ],
    [
        "path",
        {
            d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
            key: "rb5t3r"
        }
    ],
    [
        "path",
        {
            d: "M8 15a6 6 0 0 0 12 0v-3",
            key: "x18d4x"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "10",
            r: "2",
            key: "ts1r5v"
        }
    ]
]);










var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");





function $eef57b608897d088$export$7f716336c9af2338(money) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$b7288dbeceba22c2)(money), [
        money
    ]);
}
function $eef57b608897d088$export$90d9f048d9ec3fff(conv) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return conv.irt ? t('common.units.toman') : t('common.units.parseh');
}
function $eef57b608897d088$export$6ce50a86c963cdef(conv) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return conv.irt ? t('common.units.toman') : t('common.units.usd');
}
function $eef57b608897d088$export$9f587ac36c10fe60({ parseh: parseh, conv: conv, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!conv.irt) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
        value: parseh
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex flex-col items-end gap-0.5",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                value: conv.fromParseh(parseh),
                className: "font-semibold"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "whitespace-nowrap text-[11px] text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                        value: parseh
                    }),
                    " ",
                    (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(parseh) == null ? null : t('common.units.parseh')
                ]
            })
        ]
    });
}
function $eef57b608897d088$export$34b504926b1dfde7({ usd: usd, conv: conv, partial: partial, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const floor = partial ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: "warning",
        title: t('aiPricing.visits.partialHint'),
        children: t('aiPricing.visits.partial')
    }) : null;
    if (!conv.irt) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex flex-col items-end gap-0.5",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                value: usd
            }),
            floor
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "inline-flex flex-col items-end gap-0.5",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$929d988af23c0aeb), {
                value: conv.fromUsd(usd),
                className: "font-semibold"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "whitespace-nowrap text-[11px] text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                        value: usd
                    }),
                    " ",
                    (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(usd) == null ? null : t('common.units.usd')
                ]
            }),
            floor
        ]
    });
}
function $eef57b608897d088$export$ee0bfeed4f25153c({ value: value, className: className = '' }) {
    const { formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `tabular-nums ${className}`,
        children: n == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber(n, {
            style: 'percent',
            maximumFractionDigits: 0
        })
    });
}
function $eef57b608897d088$export$9f8cfdcaa92e5dae({ value: value, className: className = '' }) {
    const { formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const n = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(value);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `tabular-nums ${className}`,
        children: n == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber(n, {
            maximumFractionDigits: 2
        })
    });
}
function $eef57b608897d088$export$cec52cbdb949bbd5({ money: money, conv: conv, 'data-testid': testId }) {
    const { t: t, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.status');
    if (!conv.irt) return null;
    if (!money?.policyId || !conv.hasRate) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "data-testid": testId,
        "data-rate": "none",
        children: t('aiPricing.visits.noRate')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "data-testid": testId,
        "data-rate": money.policyId,
        children: t('aiPricing.visits.atRate', {
            name: money.policyName || formatDigits(money.policyId),
            status: statusLabel(money.policyStatus)
        })
    });
}


function $6176acd88470b4ae$export$2e2bcd8739ae039({ groups: groups, stats: stats, conv: conv }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const groupLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.visits.groups');
    const serviceLabel = (0, $b758277144067032$export$77dd77850115e3ad)();
    const earnedUnit = (0, $eef57b608897d088$export$90d9f048d9ec3fff)(conv);
    const paidUnit = (0, $eef57b608897d088$export$6ce50a86c963cdef)(conv);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const toggle = (key)=>setOpen((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    const rows = [];
    for (const g of groups || []){
        const key = g.total?.key || g.total?.group;
        rows.push({
            kind: 'group',
            id: `group-${key}`,
            key: key,
            row: g.total,
            count: (g.services || []).length
        });
        if (open.has(key)) for (const s of g.services || [])rows.push({
            kind: 'service',
            id: `service-${s.key}`,
            key: s.key,
            row: s
        });
    }
    if (stats && rows.length) rows.push({
        kind: 'total',
        id: 'total',
        key: 'total',
        row: {
            visitsUsing: stats.visits,
            shareOfVisits: null,
            runsPerVisit: stats.runsPerVisit,
            chargedRunsPerVisit: stats.chargedRunsPerVisit,
            earnedParsehPerVisit: stats.meanEarnedParseh,
            paidUsdPerVisit: stats.meanPaidUsd,
            marginPct: stats.marginPct,
            unpricedRuns: stats.unpricedRuns
        }
    });
    const columns = [
        {
            key: 'feature',
            header: t('aiPricing.visits.features.columns.feature'),
            render: (r)=>{
                if (r.kind === 'total') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "font-bold text-foreground",
                    children: t('aiPricing.visits.features.total')
                });
                if (r.kind === 'service') {
                    const label = serviceLabel({
                        ...r.row,
                        serviceKey: r.row.key
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0 ps-7",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "truncate text-foreground",
                                title: label,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "truncate text-xs text-muted-foreground",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                    children: r.row.key
                                })
                            })
                        ]
                    });
                }
                const expanded = open.has(r.key);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex items-center gap-1",
                    children: [
                        r.count ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            size: "sm",
                            "aria-expanded": expanded,
                            "aria-label": t(expanded ? 'aiPricing.visits.features.collapse' : 'aiPricing.visits.features.expand', {
                                group: groupLabel(r.key)
                            }),
                            onClick: ()=>toggle(r.key),
                            "data-testid": `ai-visits-features-toggle-${r.key}`,
                            children: expanded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b397e876e35a9277$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f88028b3cc726f6$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "font-semibold text-foreground",
                            children: groupLabel(r.key)
                        })
                    ]
                });
            }
        },
        {
            key: 'share',
            header: t('aiPricing.visits.features.columns.share'),
            align: 'end',
            width: '8rem',
            render: (r)=>r.kind === 'total' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                    value: r.row.visitsUsing
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$ee0bfeed4f25153c), {
                            value: r.row.shareOfVisits
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[11px] text-muted-foreground",
                            children: t('aiPricing.visits.features.visitsUsing', {
                                count: r.row.visitsUsing ?? 0
                            })
                        })
                    ]
                })
        },
        {
            key: 'runs',
            header: t('aiPricing.visits.features.columns.runs'),
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f8cfdcaa92e5dae), {
                    value: r.row.runsPerVisit
                })
        },
        {
            key: 'charged',
            header: t('aiPricing.visits.features.columns.charged'),
            align: 'end',
            width: '7rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f8cfdcaa92e5dae), {
                    value: r.row.chargedRunsPerVisit
                })
        },
        {
            key: 'earned',
            header: t('aiPricing.visits.features.columns.earned', {
                unit: earnedUnit
            }),
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f587ac36c10fe60), {
                    parseh: r.row.earnedParsehPerVisit,
                    conv: conv,
                    "data-testid": `ai-visits-features-${r.id}-earned`
                })
        },
        {
            key: 'paid',
            header: t('aiPricing.visits.features.columns.paid', {
                unit: paidUnit
            }),
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$34b504926b1dfde7), {
                    usd: r.row.paidUsdPerVisit,
                    conv: conv,
                    partial: (r.row.unpricedRuns || 0) > 0,
                    "data-testid": `ai-visits-features-${r.id}-paid`
                })
        },
        {
            key: 'margin',
            header: t('aiPricing.visits.features.columns.margin'),
            align: 'end',
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                    value: r.row.marginPct,
                    "data-testid": `ai-visits-features-${r.id}-margin`
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.visits.features.aria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.id,
        rowProps: (r)=>({
                'data-testid': `ai-visits-features-row-${r.id}`,
                'data-kind': r.kind,
                className: r.kind === 'total' ? 'bg-muted' : undefined
            }),
        "data-testid": "ai-visits-features-table"
    });
}



parcelRequire("acw62");




function $b9d3039323ff300f$export$2e2bcd8739ae039({ buckets: buckets, conv: conv, active: active, onPick: onPick }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const earnedUnit = (0, $eef57b608897d088$export$90d9f048d9ec3fff)(conv);
    const paidUnit = (0, $eef57b608897d088$export$6ce50a86c963cdef)(conv);
    const bucketLabel = (b)=>{
        if (b.bucket === 'none') return t('aiPricing.visits.minutes.none');
        if (b.bucket.endsWith('+')) return t('aiPricing.visits.minutes.atLeast', {
            min: formatNumber(Number(b.bucket.slice(0, -1)))
        });
        const [lo, hi] = b.bucket.split('-');
        return hi ? t('aiPricing.visits.minutes.range', {
            min: formatNumber(Number(lo)),
            max: formatNumber(Number(hi))
        }) : t('aiPricing.visits.minutes.exact', {
            count: Number(lo),
            value: formatNumber(Number(lo))
        });
    };
    const columns = [
        {
            key: 'bucket',
            header: t('aiPricing.visits.minutes.columns.bucket'),
            render: (b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "font-semibold text-foreground",
                            children: bucketLabel(b)
                        }),
                        active === b.bucket ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: t('aiPricing.visits.minutes.filtered')
                        }) : null
                    ]
                })
        },
        {
            key: 'visits',
            header: t('aiPricing.visits.minutes.columns.visits'),
            align: 'end',
            width: '7rem',
            render: (b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                    value: b.visits
                })
        },
        {
            key: 'earned',
            header: t('aiPricing.visits.minutes.columns.earned', {
                unit: earnedUnit
            }),
            align: 'end',
            width: '9rem',
            render: (b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f587ac36c10fe60), {
                    parseh: b.meanEarnedParseh,
                    conv: conv
                })
        },
        {
            key: 'paid',
            header: t('aiPricing.visits.minutes.columns.paid', {
                unit: paidUnit
            }),
            align: 'end',
            width: '9rem',
            render: (b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$34b504926b1dfde7), {
                    usd: b.meanPaidUsd,
                    conv: conv,
                    partial: b.visits > 0 && (b.pricedVisits ?? b.visits) < b.visits
                })
        },
        {
            key: 'margin',
            header: t('aiPricing.visits.minutes.columns.margin'),
            align: 'end',
            width: '6rem',
            render: (b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                    value: b.marginPct
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.visits.minutes.aria'),
        columns: columns,
        rows: buckets || [],
        rowKey: (b)=>b.bucket,
        onRowActivate: (b)=>{
            if (b.visits > 0 || active === b.bucket) onPick(active === b.bucket ? '' : b.bucket);
        },
        rowProps: (b)=>({
                'data-testid': `ai-visits-minutes-row-${b.bucket}`,
                'aria-label': t('aiPricing.visits.minutes.open', {
                    bucket: bucketLabel(b)
                }),
                'aria-current': active === b.bucket ? 'true' : undefined
            }),
        "data-testid": "ai-visits-minutes-table"
    });
}



parcelRequire("acw62");






function $7e3da008ce168d8d$export$2e2bcd8739ae039({ rows: rows, conv: conv, view: view, onSort: onSort, onOpen: onOpen, empty: empty }) {
    const { t: t, formatDateTime: formatDateTime, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const ownerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.overview.owner');
    const earnedUnit = (0, $eef57b608897d088$export$90d9f048d9ec3fff)(conv);
    const paidUnit = (0, $eef57b608897d088$export$6ce50a86c963cdef)(conv);
    const minutes = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 1
        });
    const columns = [
        {
            key: 'started',
            header: t('aiPricing.visits.table.columns.time'),
            sortable: true,
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tabular-nums",
                    children: formatDateTime(r.firstAt)
                })
        },
        {
            key: 'owner',
            header: t('aiPricing.visits.table.columns.owner'),
            width: '12rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "inline-flex items-center gap-1 text-xs text-muted-foreground",
                            children: [
                                ownerLabel(r.ownerType),
                                (r.owners || 0) > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    title: t('aiPricing.visits.multiOwnerHint'),
                                    children: t('aiPricing.visits.multiOwner', {
                                        count: r.owners
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                            title: r.ownerId || undefined,
                            children: r.ownerId ? String(r.ownerId).slice(0, 12) : null
                        })
                    ]
                })
        },
        {
            key: 'appointment',
            header: t('aiPricing.visits.table.columns.appointment'),
            width: '12rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                    title: r.appointmentId,
                    children: String(r.appointmentId).slice(0, 14)
                })
        },
        {
            key: 'minutes',
            header: t('aiPricing.visits.table.columns.minutes'),
            sortable: true,
            align: 'end',
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tabular-nums",
                            children: minutes(r.billedMinutes)
                        }),
                        r.recordings ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[11px] text-muted-foreground",
                            children: t('aiPricing.visits.table.recordings', {
                                count: r.recordings
                            })
                        }) : null
                    ]
                })
        },
        {
            key: 'runs',
            header: t('aiPricing.visits.table.columns.runs'),
            align: 'end',
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "inline-flex flex-col items-end gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                            value: r.runs
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[11px] text-muted-foreground",
                            children: t('aiPricing.visits.table.charged', {
                                count: r.chargedRuns ?? 0
                            })
                        })
                    ]
                })
        },
        {
            key: 'earned',
            header: t('aiPricing.visits.table.columns.earned', {
                unit: earnedUnit
            }),
            sortable: true,
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f587ac36c10fe60), {
                    parseh: r.earnedParseh,
                    conv: conv,
                    "data-testid": `ai-visits-row-${r.appointmentId}-earned`
                })
        },
        {
            key: 'paid',
            header: t('aiPricing.visits.table.columns.paid', {
                unit: paidUnit
            }),
            sortable: true,
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$34b504926b1dfde7), {
                    usd: r.paidUsd,
                    conv: conv,
                    partial: (r.unpricedRuns || 0) > 0,
                    "data-testid": `ai-visits-row-${r.appointmentId}-paid`
                })
        },
        {
            key: 'margin',
            header: t('aiPricing.visits.table.columns.margin'),
            sortable: true,
            align: 'end',
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                    value: r.marginPct,
                    "data-testid": `ai-visits-row-${r.appointmentId}-margin`
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        ariaLabel: t('aiPricing.visits.table.aria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.appointmentId,
        sort: {
            key: view.sort || (0, $ad1ad54ff7f74a69$export$2e671f256b71a45c),
            dir: view.dir === 'asc' ? 'asc' : 'desc'
        },
        onSort: onSort,
        onRowActivate: onOpen,
        rowProps: (r)=>({
                'data-testid': `ai-visits-row-${r.appointmentId}`,
                'aria-label': t('aiPricing.visits.table.open', {
                    id: r.appointmentId
                })
            }),
        empty: empty,
        "data-testid": "ai-visits-table"
    });
}




var $acw62 = parcelRequire("acw62");










const $765f1898f8709677$var$STATUS_VARIANT = {
    ok: 'success',
    error: 'destructive',
    aborted: 'warning'
};
function $765f1898f8709677$export$2e2bcd8739ae039({ appointmentId: appointmentId, policyId: policyId, inv: inv, onOpenInvocation: onOpenInvocation, onBack: onBack, onClose: onClose, labelOf: labelOf }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [detail, setDetail] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [invService, setInvService] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$512faac54c275f2e), {
            appointmentId: appointmentId,
            policyId: policyId || null
        }).then((d)=>setDetail(d?.aiVisit || null)).catch((e)=>setError({
                message: (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t),
                notFound: e?.code === 'NOT_FOUND'
            })).finally(()=>setLoading(false));
    }, [
        appointmentId,
        policyId,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!inv) setInvService(null);
    }, [
        inv
    ]);
    const title = inv ? invService ? labelOf(invService) : t('aiPricing.ledger.drawer.title') : t('aiPricing.visits.drawer.title');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$c0b7ebe42c310b67), {
        open: true,
        onClose: onClose,
        width: 720,
        title: title,
        sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
            children: inv || appointmentId
        }),
        "data-testid": "ai-visit-drawer",
        children: inv ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-4",
            "data-testid": "ai-visit-drawer-invocation",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: onBack,
                        "data-testid": "ai-visit-drawer-back",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: (0, $c53f9539af19d960$export$ddb338179359cccc)
                            }),
                            t('aiPricing.visits.drawer.back')
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $badde8da5965018c$export$7bca27a2b2eae6de), {
                    requestId: inv,
                    onLoaded: (row)=>setInvService(row?.serviceKey || null),
                    testId: "ai-visit-drawer-invocation"
                })
            ]
        }) : loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-state": "loading",
            role: "status",
            "aria-busy": "true",
            "aria-label": t('aiPricing.visits.drawer.loading'),
            "data-testid": "ai-visit-drawer-loading",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
                lines: 8,
                height: 18
            })
        }) : error || !detail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: error?.notFound ? t('aiPricing.visits.drawer.notFound') : t('aiPricing.visits.drawer.error'),
            description: error?.notFound ? t('aiPricing.visits.drawer.notFoundDesc') : error?.message || t('errors.region.noAnswer'),
            onRetry: error?.notFound ? undefined : load,
            retryLabel: t('common.actions.retry'),
            "data-testid": "ai-visit-drawer-error"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($765f1898f8709677$var$VisitBody, {
            detail: detail,
            labelOf: labelOf,
            onOpenInvocation: onOpenInvocation
        })
    });
}
function $765f1898f8709677$var$VisitBody({ detail: detail, labelOf: labelOf, onOpenInvocation: onOpenInvocation }) {
    const { t: t, formatDateTime: formatDateTime, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const ownerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.overview.owner');
    const statusLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.ledger.status');
    const reasonLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.ledger.chargeReason');
    const serviceLabel = (0, $b758277144067032$export$77dd77850115e3ad)();
    const conv = (0, $eef57b608897d088$export$7f716336c9af2338)(detail.money);
    const earnedUnit = (0, $eef57b608897d088$export$90d9f048d9ec3fff)(conv);
    const paidUnit = (0, $eef57b608897d088$export$6ce50a86c963cdef)(conv);
    const v = detail.visit;
    const minutes = (x)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(x) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(x), {
            maximumFractionDigits: 1
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-6",
        "data-state": "content",
        "data-testid": "ai-visit-drawer-content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "grid grid-cols-2 gap-4 text-sm md:grid-cols-3",
                "data-testid": "ai-visit-drawer-facts",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.appointment'),
                        value: v.appointmentId,
                        ltr: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.owner'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "inline-flex flex-wrap items-center gap-1",
                            children: [
                                ownerLabel(v.ownerType),
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                    children: v.ownerId
                                }),
                                (v.owners || 0) > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    children: t('aiPricing.visits.multiOwner', {
                                        count: v.owners
                                    })
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.first'),
                        value: formatDateTime(v.firstAt)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.last'),
                        value: v.lastAt ? formatDateTime(v.lastAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.ledger.drawer.billedMinutes'),
                        value: minutes(v.billedMinutes)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.recordings'),
                        value: formatNumber(v.recordings ?? 0)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.runs'),
                        value: t('aiPricing.visits.drawer.runsValue', {
                            runs: formatNumber(v.runs ?? 0),
                            charged: formatNumber(v.chargedRuns ?? 0)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.earned', {
                            unit: earnedUnit
                        }),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f587ac36c10fe60), {
                            parseh: v.earnedParseh,
                            conv: conv
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.earnedUsd'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                            value: v.earnedUsd
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.paid', {
                            unit: paidUnit
                        }),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$34b504926b1dfde7), {
                            usd: v.paidUsd,
                            conv: conv,
                            partial: (v.unpricedRuns || 0) > 0
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.providerPaid'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                            value: v.providerPaidUsd
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.table.columns.margin'),
                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$db52fc8e9d633a4), {
                            value: v.marginPct
                        })
                    }),
                    (v.unpricedRuns || 0) > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$4b67f8be7a5e4a15), {
                        label: t('aiPricing.visits.drawer.unpriced'),
                        value: formatNumber(v.unpricedRuns)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "mb-2 text-sm font-bold text-foreground",
                        children: t('aiPricing.visits.drawer.lines')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto rounded-lg border border-border",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                            dense: true,
                            ariaLabel: t('aiPricing.visits.drawer.linesAria'),
                            rows: detail.lines || [],
                            rowKey: (l)=>l.serviceKey,
                            rowProps: (l)=>({
                                    'data-testid': `ai-visit-drawer-line-${l.serviceKey}`
                                }),
                            columns: [
                                {
                                    key: 'service',
                                    header: t('aiPricing.visits.features.columns.feature'),
                                    render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "truncate text-foreground",
                                                    children: serviceLabel(l)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "truncate text-xs text-muted-foreground",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$52f0f02147b12c03), {
                                                        children: l.serviceKey
                                                    })
                                                })
                                            ]
                                        })
                                },
                                {
                                    key: 'runs',
                                    header: t('aiPricing.visits.table.columns.runs'),
                                    align: 'end',
                                    render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "inline-flex flex-col items-end gap-0.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7105c6425efc4723), {
                                                    value: l.runs
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-[11px] text-muted-foreground",
                                                    children: t('aiPricing.visits.table.charged', {
                                                        count: l.chargedRuns ?? 0
                                                    })
                                                })
                                            ]
                                        })
                                },
                                {
                                    key: 'minutes',
                                    header: t('aiPricing.visits.table.columns.minutes'),
                                    align: 'end',
                                    render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tabular-nums",
                                            children: minutes(l.billedMinutes)
                                        })
                                },
                                {
                                    key: 'earned',
                                    header: t('aiPricing.visits.table.columns.earned', {
                                        unit: earnedUnit
                                    }),
                                    align: 'end',
                                    render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$9f587ac36c10fe60), {
                                            parseh: l.earnedParseh,
                                            conv: conv
                                        })
                                },
                                {
                                    key: 'paid',
                                    header: t('aiPricing.visits.table.columns.paid', {
                                        unit: paidUnit
                                    }),
                                    align: 'end',
                                    render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$34b504926b1dfde7), {
                                            usd: l.paidUsd,
                                            conv: conv,
                                            partial: (l.unpricedRuns || 0) > 0
                                        })
                                },
                                {
                                    key: 'provider',
                                    header: t('aiPricing.visits.drawer.providerPaidShort'),
                                    align: 'end',
                                    render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                            value: l.providerPaidUsd
                                        })
                                }
                            ],
                            empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "p-4 text-sm text-muted-foreground",
                                children: t('aiPricing.overview.breakdownEmpty')
                            }),
                            "data-testid": "ai-visit-drawer-lines"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "mb-2 text-sm font-bold text-foreground",
                        children: t('aiPricing.visits.drawer.invocations')
                    }),
                    detail.invocationsTruncated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        className: "mb-2",
                        "data-testid": "ai-visit-drawer-truncated",
                        children: t('aiPricing.visits.drawer.truncated', {
                            count: (detail.invocations || []).length
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto rounded-lg border border-border",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                            dense: true,
                            ariaLabel: t('aiPricing.visits.drawer.invocationsAria'),
                            rows: detail.invocations || [],
                            rowKey: (r)=>r.requestId,
                            onRowActivate: (r)=>onOpenInvocation(r.requestId),
                            rowProps: (r)=>({
                                    'data-testid': `ai-visit-drawer-inv-${r.requestId}`,
                                    'aria-label': t('aiPricing.ledger.open', {
                                        id: r.requestId
                                    })
                                }),
                            columns: [
                                {
                                    key: 'time',
                                    header: t('aiPricing.ledger.columns.time'),
                                    width: '10rem',
                                    render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tabular-nums",
                                            children: formatDateTime(r.startedAt)
                                        })
                                },
                                {
                                    key: 'service',
                                    header: t('aiPricing.ledger.columns.service'),
                                    render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "truncate",
                                            children: labelOf(r.serviceKey)
                                        })
                                },
                                {
                                    key: 'cost',
                                    header: t('aiPricing.ledger.columns.cost'),
                                    align: 'end',
                                    render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f6baea096b75c630), {
                                            value: r.costUsd
                                        })
                                },
                                {
                                    key: 'charged',
                                    header: t('aiPricing.ledger.columns.charged'),
                                    align: 'end',
                                    render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "inline-flex flex-col items-end gap-0.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$f44e97762c5ad47d), {
                                                    value: r.chargedParseh
                                                }),
                                                (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(r.chargedParseh) === 0 && r.chargeReason && r.chargeReason !== 'charged' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: r.chargeReason === 'wallet_error' ? 'destructive' : 'outline',
                                                    children: reasonLabel(r.chargeReason)
                                                }) : null
                                            ]
                                        })
                                },
                                {
                                    key: 'status',
                                    header: t('aiPricing.ledger.columns.status'),
                                    render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: $765f1898f8709677$var$STATUS_VARIANT[r.status] || 'outline',
                                            children: statusLabel(r.status)
                                        })
                                }
                            ],
                            empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "p-4 text-sm text-muted-foreground",
                                children: t('aiPricing.overview.breakdownEmpty')
                            }),
                            "data-testid": "ai-visit-drawer-invocations"
                        })
                    })
                ]
            })
        ]
    });
}





function $6714308ae651b53c$export$2e2bcd8739ae039({ window: window, view: view, go: go }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    const ownerLabel = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.overview.owner');
    const policyStatus = (0, $b758277144067032$export$fd47d6972da0c54a)('aiPricing.policies.status');
    // ── option lists (a convenience: the regions report their own failures) ──
    const [options, setOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        services: [],
        policies: []
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$484ee2a5146b27cf), {
            window: window
        }).then((d)=>{
            if (!alive) return;
            setOptions({
                services: d?.aiServices?.services || [],
                policies: d?.aiPricingPolicies || []
            });
        }).catch(()=>{});
        return ()=>{
            alive = false;
        };
    }, [
        window
    ]);
    const filter = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$ee0f41584dd52d33)(view), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        view.owner,
        view.ownerId,
        view.service,
        view.rec,
        view.mins
    ]);
    const policyId = view.rate || null;
    const page = Math.max(1, Number(view.page) || 1);
    const sort = (0, $ad1ad54ff7f74a69$export$d2a4aad4766fea6f)(view);
    // ── summary: aiVisitEconomics ─────────────────────────────────────────────
    const [summary, setSummary] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [summaryLoading, setSummaryLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [summaryRefreshing, setSummaryRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [summaryError, setSummaryError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loadSummary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setSummaryRefreshing(true);
        else setSummaryLoading(true);
        setSummaryError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$ee9e628a7c3681e3), {
            window: window,
            filter: filter,
            policyId: policyId
        }).then((d)=>setSummary(d?.aiVisitEconomics || null)).catch((e)=>setSummaryError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setSummaryLoading(false);
            setSummaryRefreshing(false);
        });
    }, [
        window,
        filter,
        policyId,
        t
    ]);
    const firstSummary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadSummary({
            quiet: !firstSummary.current
        });
        firstSummary.current = false;
    }, [
        loadSummary
    ]);
    // ── list: aiVisits ────────────────────────────────────────────────────────
    const [list, setList] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [listLoading, setListLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [listRefreshing, setListRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [listError, setListError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loadList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setListRefreshing(true);
        else setListLoading(true);
        setListError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$55ebeb4628201c), {
            window: window,
            filter: filter,
            policyId: policyId,
            page: page,
            pageSize: (0, $ad1ad54ff7f74a69$export$cf7fe2da72761aae),
            sort: sort
        }).then((d)=>setList(d?.aiVisits || {
                visits: [],
                total: 0,
                page: page,
                pageSize: (0, $ad1ad54ff7f74a69$export$cf7fe2da72761aae)
            })).catch((e)=>setListError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setListLoading(false);
            setListRefreshing(false);
        });
    }, [
        window,
        filter,
        policyId,
        page,
        sort,
        t
    ]);
    const firstList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadList({
            quiet: !firstList.current
        });
        firstList.current = false;
    }, [
        loadList
    ]);
    // The rate either answer names; the summary's when both have one.
    const money = summary?.money || list?.money || null;
    const conv = (0, $eef57b608897d088$export$7f716336c9af2338)(money);
    const listConv = $6714308ae651b53c$var$useVisitMoneyFallback(list?.money, conv);
    // ── the owner-id field echoes keystrokes; the URL follows after a pause ──
    const [ownerDraft, setOwnerDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.ownerId || '');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOwnerDraft(view.ownerId || '');
    }, [
        view.ownerId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (ownerDraft === (view.ownerId || '')) return undefined;
        const timer = setTimeout(()=>go({
                ownerId: ownerDraft,
                page: 1
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        ownerDraft,
        view.ownerId,
        go
    ]);
    const setFilter = (patch)=>go({
            ...patch,
            page: 1
        });
    const isFiltered = (0, $ad1ad54ff7f74a69$export$1aae0b1012f7f914)(view);
    const clear = ()=>{
        setOwnerDraft('');
        go({
            owner: '',
            ownerId: '',
            service: '',
            rec: '',
            mins: '',
            page: 1
        });
    };
    const onSort = (key)=>{
        const current = view.sort || 'started';
        const dir = view.dir || 'desc';
        if (current !== key) go({
            sort: key,
            dir: 'desc',
            page: 1
        });
        else if (dir === 'desc') go({
            dir: 'asc',
            page: 1
        });
        else go({
            sort: '',
            dir: '',
            page: 1
        });
    };
    const labelOf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key)=>{
        const row = options.services.find((s)=>s.serviceKey === key);
        return row ? label(row) : key;
    }, [
        options.services,
        label
    ]);
    const all = {
        value: '',
        label: t('aiPricing.ledger.filters.all')
    };
    const bucketOption = (b)=>{
        if (b === 'none') return t('aiPricing.visits.minutes.none');
        if (b.endsWith('+')) return t('aiPricing.visits.minutes.atLeast', {
            min: formatNumber(Number(b.slice(0, -1)))
        });
        const [lo, hi] = b.split('-');
        return hi ? t('aiPricing.visits.minutes.range', {
            min: formatNumber(Number(lo)),
            max: formatNumber(Number(hi))
        }) : t('aiPricing.visits.minutes.exact', {
            count: Number(lo),
            value: formatNumber(Number(lo))
        });
    };
    const rows = list?.visits || [];
    const csvColumns = [
        {
            key: 'appointmentId',
            header: t('aiPricing.visits.table.columns.appointment'),
            value: (r)=>r.appointmentId
        },
        {
            key: 'firstAt',
            header: t('aiPricing.visits.drawer.first'),
            value: (r)=>r.firstAt
        },
        {
            key: 'lastAt',
            header: t('aiPricing.visits.drawer.last'),
            value: (r)=>r.lastAt
        },
        {
            key: 'ownerType',
            header: t('aiPricing.ledger.filters.ownerType'),
            value: (r)=>r.ownerType
        },
        {
            key: 'billedMinutes',
            header: t('aiPricing.ledger.drawer.billedMinutes'),
            value: (r)=>r.billedMinutes
        },
        {
            key: 'recordings',
            header: t('aiPricing.visits.drawer.recordings'),
            value: (r)=>r.recordings
        },
        {
            key: 'runs',
            header: t('aiPricing.visits.table.columns.runs'),
            value: (r)=>r.runs
        },
        {
            key: 'chargedRuns',
            header: t('aiPricing.visits.csv.chargedRuns'),
            value: (r)=>r.chargedRuns
        },
        {
            key: 'earnedParseh',
            header: t('aiPricing.visits.csv.earnedParseh'),
            value: (r)=>r.earnedParseh
        },
        {
            key: 'earnedUsd',
            header: t('aiPricing.visits.drawer.earnedUsd'),
            value: (r)=>r.earnedUsd
        },
        {
            key: 'paidUsd',
            header: t('aiPricing.visits.csv.paidUsd'),
            value: (r)=>r.paidUsd
        },
        {
            key: 'providerPaidUsd',
            header: t('aiPricing.visits.drawer.providerPaid'),
            value: (r)=>r.providerPaidUsd
        },
        {
            key: 'marginPct',
            header: t('aiPricing.visits.table.columns.margin'),
            value: (r)=>r.marginPct
        },
        {
            key: 'unpricedRuns',
            header: t('aiPricing.visits.drawer.unpriced'),
            value: (r)=>r.unpricedRuns
        }
    ];
    const stats = summary?.stats || null;
    const noVisits = !!summary && (stats?.visits ?? 0) === 0;
    // No answer yet and no failure is still loading — a quiet refetch clears the
    // error before its answer lands, and that gap must not render "content".
    const summaryPending = summaryLoading || !summary && !summaryError;
    const summaryState = summaryPending ? 'loading' : summaryError ? 'error' : noVisits ? 'empty' : 'content';
    const emptyVisits = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('aiPricing.visits.empty.title'),
        description: t('aiPricing.visits.empty.desc'),
        "data-testid": "ai-visits-empty"
    });
    const emptyFiltered = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('aiPricing.visits.emptyFiltered.title'),
        description: t('aiPricing.visits.emptyFiltered.desc'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "outline",
            onClick: clear,
            children: t('common.actions.clearFilters')
        }),
        "data-testid": "ai-visits-empty"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ai-visits",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 grid grid-cols-2 gap-3 rounded-lg border border-border bg-card p-3 md:grid-cols-3 xl:grid-cols-6",
                role: "group",
                "aria-label": t('aiPricing.visits.filters.label'),
                "data-testid": "ai-visits-filters",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.ownerType'),
                        value: view.owner || '',
                        onChange: (e)=>setFilter({
                                owner: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...(0, $ad1ad54ff7f74a69$export$60b33fb147a66c).map((o)=>({
                                    value: o,
                                    label: ownerLabel(o)
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-visits-filter-owner"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('aiPricing.ledger.filters.ownerId'),
                        value: ownerDraft,
                        onChange: (e)=>setOwnerDraft(e.target?.value ?? e),
                        dir: "ltr",
                        inputStyle: {
                            fontFamily: 'monospace'
                        },
                        "data-testid": "ai-visits-filter-owner-id"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.visits.filters.recorded'),
                        value: view.rec || '',
                        onChange: (e)=>setFilter({
                                rec: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            {
                                value: 'yes',
                                label: t('aiPricing.visits.filters.recordedYes')
                            },
                            {
                                value: 'no',
                                label: t('aiPricing.visits.filters.recordedNo')
                            }
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-visits-filter-recorded"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.visits.filters.minutes'),
                        value: view.mins || '',
                        onChange: (e)=>setFilter({
                                mins: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...(0, $ad1ad54ff7f74a69$export$e91ee2b842347321).map((b)=>({
                                    value: b,
                                    label: bucketOption(b)
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-visits-filter-minutes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.visits.filters.service'),
                        value: view.service || '',
                        onChange: (e)=>setFilter({
                                service: e.target?.value ?? e
                            }),
                        options: [
                            all,
                            ...options.services.map((s)=>({
                                    value: s.serviceKey,
                                    label: label(s)
                                }))
                        ],
                        placeholder: t('aiPricing.ledger.filters.all'),
                        "data-testid": "ai-visits-filter-service"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('aiPricing.visits.filters.rate'),
                        value: view.rate || '',
                        // The rate is not a filter: it changes no visit, only the toman figures.
                        onChange: (e)=>go({
                                rate: e.target?.value ?? e
                            }),
                        options: [
                            {
                                value: '',
                                label: t('aiPricing.visits.filters.rateActive')
                            },
                            ...options.policies.map((p)=>({
                                    value: String(p.id),
                                    label: t('aiPricing.visits.filters.rateOption', {
                                        name: p.name,
                                        status: policyStatus(p.status)
                                    })
                                }))
                        ],
                        placeholder: t('aiPricing.visits.filters.rateActive'),
                        "data-testid": "ai-visits-filter-rate"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "flex flex-wrap items-center gap-x-3 text-xs text-muted-foreground",
                        "aria-live": "polite",
                        "data-testid": "ai-visits-count",
                        children: [
                            list && !listLoading && !listError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('aiPricing.visits.count', {
                                    count: list.total || 0
                                })
                            }) : null,
                            money ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eef57b608897d088$export$cec52cbdb949bbd5), {
                                money: money,
                                conv: conv,
                                "data-testid": "ai-visits-rate"
                            }) : null
                        ]
                    }),
                    isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: clear,
                        "data-testid": "ai-visits-clear",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('common.actions.clearFilters')
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ms-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$935c32d013fb644d), {
                            columns: csvColumns,
                            rows: rows,
                            "data-testid": "ai-visits-csv"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "transition-opacity",
                style: {
                    opacity: summaryRefreshing ? 0.45 : 1
                },
                "aria-busy": summaryRefreshing || undefined,
                "data-testid": "ai-visits-summary",
                "data-state": summaryState,
                children: summaryPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6714308ae651b53c$var$SummarySkeleton, {
                    label: t('aiPricing.visits.loading')
                }) : summaryError ? // Money is hidden on error: no strip of zeros beside a failure.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.visits.summaryError'),
                    description: summaryError,
                    onRetry: loadSummary,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-visits-summary-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6714308ae651b53c$var$VisitKpis, {
                            stats: stats,
                            conv: conv
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-5 grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                    title: t('aiPricing.visits.features.title'),
                                    sub: t('aiPricing.visits.features.sub'),
                                    icon: (0, $40c424bab0bc0a95$export$2e2bcd8739ae039),
                                    "data-testid": "ai-visits-features",
                                    "data-state": noVisits || !(summary.groups || []).length ? 'empty' : 'content',
                                    children: [
                                        noVisits || !(summary.groups || []).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                                                size: 44,
                                                strokeWidth: 1.5,
                                                "aria-hidden": true
                                            }),
                                            title: isFiltered ? t('aiPricing.visits.emptyFiltered.title') : t('aiPricing.visits.empty.title'),
                                            description: isFiltered ? t('aiPricing.visits.emptyFiltered.desc') : t('aiPricing.visits.empty.desc'),
                                            "data-testid": "ai-visits-features-empty"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "overflow-x-auto",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6176acd88470b4ae$export$2e2bcd8739ae039), {
                                                groups: summary.groups,
                                                stats: stats,
                                                conv: conv
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6714308ae651b53c$var$Unattributed, {
                                            rows: summary.unattributed || [],
                                            conv: conv
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
                                    title: t('aiPricing.visits.minutes.title'),
                                    sub: t('aiPricing.visits.minutes.sub'),
                                    icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
                                    "data-testid": "ai-visits-minutes",
                                    "data-state": noVisits ? 'empty' : 'content',
                                    children: noVisits ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88e75a6fb6edc067$export$2e2bcd8739ae039), {
                                            size: 44,
                                            strokeWidth: 1.5,
                                            "aria-hidden": true
                                        }),
                                        title: isFiltered ? t('aiPricing.visits.emptyFiltered.title') : t('aiPricing.visits.empty.title'),
                                        description: t('aiPricing.visits.minutes.emptyDesc'),
                                        "data-testid": "ai-visits-minutes-empty"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9d3039323ff300f$export$2e2bcd8739ae039), {
                                            buckets: summary.byMinutes || [],
                                            conv: conv,
                                            active: view.mins || '',
                                            onPick: (mins)=>setFilter({
                                                    mins: mins
                                                })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "mb-2 mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3883d84d119a3732$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    t('aiPricing.visits.table.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: listRefreshing ? 0.45 : 1
                },
                "aria-busy": listRefreshing || undefined,
                "data-testid": "ai-visits-list",
                "data-state": listLoading ? 'loading' : listError ? 'error' : rows.length ? 'content' : 'empty',
                children: listLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$7afc19c20799c3c1), {
                    cols: 9,
                    label: t('aiPricing.visits.table.loading'),
                    "data-testid": "ai-visits-loading"
                }) : listError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('aiPricing.visits.table.error'),
                    description: listError,
                    onRetry: loadList,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "ai-visits-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7e3da008ce168d8d$export$2e2bcd8739ae039), {
                    rows: rows,
                    conv: listConv,
                    view: view,
                    onSort: onSort,
                    onOpen: (r)=>go({
                            visit: r.appointmentId,
                            inv: ''
                        }),
                    empty: isFiltered ? emptyFiltered : emptyVisits
                })
            }),
            !listLoading && !listError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "ai-visits-pager",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6714308ae651b53c$var$PagerFor, {
                    list: list,
                    page: page,
                    go: go
                })
            }) : null,
            view.visit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $765f1898f8709677$export$2e2bcd8739ae039), {
                appointmentId: view.visit,
                policyId: policyId,
                inv: view.inv,
                labelOf: labelOf,
                onOpenInvocation: (requestId)=>go({
                        inv: requestId
                    }),
                onBack: ()=>go({
                        inv: ''
                    }),
                onClose: ()=>go({
                        visit: '',
                        inv: ''
                    })
            }, view.visit) : view.inv ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $badde8da5965018c$export$2e2bcd8739ae039), {
                requestId: view.inv,
                labelOf: labelOf,
                onClose: ()=>go({
                        inv: ''
                    })
            }) : null
        ]
    });
}
/**
 * The list converts at the rate ITS answer names; until a list has answered,
 * the summary's. They are the same policy unless one request raced a change
 * of the picker.
 */ function $6714308ae651b53c$var$useVisitMoneyFallback(money, fallback) {
    const own = (0, $eef57b608897d088$export$7f716336c9af2338)(money);
    return money ? own : fallback;
}
function $6714308ae651b53c$var$PagerFor({ list: list, page: page, go: go }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
        page: page,
        pageCount: (0, $ad1ad54ff7f74a69$export$a3a372017b8de354)(list?.total),
        pageSize: (0, $ad1ad54ff7f74a69$export$cf7fe2da72761aae),
        onChange: (next)=>go({
                page: next
            }),
        prevLabel: t('common.pager.prev'),
        nextLabel: t('common.pager.next'),
        pageLabel: (p, total)=>t('common.pager.label', {
                page: p,
                total: total
            }),
        formatNumber: formatNumber
    });
}
/**
 * ③ Six KPIs. A figure the service could not compute is «—»; the visit count
 * is a real count, so zero visits is «۰», not a dash.
 */ function $6714308ae651b53c$var$VisitKpis({ stats: stats, conv: conv }) {
    const { t: t, formatNumber: formatNumber, formatPercent: formatPercent } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const s = stats || {};
    const toman = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 0
        });
    const parseh = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 2
        });
    const usd = (v)=>(0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(v, {
            formatNumber: formatNumber,
            t: t
        });
    const tomanUnit = t('common.units.toman');
    const parsehUnit = t('common.units.parseh');
    const usdUnit = t('common.units.usd');
    // Earned is پارسه, paid is USD; where the credit is sold in toman both read
    // toman first, at the policy's rate, with the native figure underneath.
    const earned = (v)=>conv.irt ? {
            value: toman(conv.fromParseh(v)),
            unit: tomanUnit,
            native: `${parseh(v)} ${parsehUnit}`
        } : {
            value: parseh(v),
            unit: parsehUnit,
            native: null
        };
    const paid = (v)=>conv.irt ? {
            value: toman(conv.fromUsd(v)),
            unit: tomanUnit,
            native: `${usd(v)} ${usdUnit}`
        } : {
            value: usd(v),
            unit: usdUnit,
            native: null
        };
    // A percentile tile reads the visit's EARNED figure, its PAID one beneath.
    const paidLine = (p)=>[
            t('aiPricing.visits.kpi.paidLine', {
                value: p.value === (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : `${p.value} ${p.unit}`
            })
        ];
    const meanEarned = earned(s.meanEarnedParseh);
    const meanPaid = paid(s.meanPaidUsd);
    const p50e = earned(s.p50EarnedParseh);
    const p50p = paid(s.p50PaidUsd);
    const p90e = earned(s.p90EarnedParseh);
    const p90p = paid(s.p90PaidUsd);
    const negative = (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(s.marginPct) != null && (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(s.marginPct) < 0;
    const kpis = [
        {
            key: 'visits',
            label: t('aiPricing.visits.kpi.visits'),
            sub: [
                t('aiPricing.visits.kpi.recorded', {
                    count: s.recordedVisits ?? 0
                })
            ],
            value: formatNumber(s.visits ?? 0),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3883d84d119a3732$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight
        },
        {
            key: 'earned',
            label: t('aiPricing.visits.kpi.meanEarned'),
            sub: meanEarned.native ? [
                meanEarned.native
            ] : [],
            value: meanEarned.value,
            unit: meanEarned.unit,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ec88f95add56de8$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight
        },
        {
            key: 'paid',
            label: t('aiPricing.visits.kpi.meanPaid'),
            sub: [
                ...meanPaid.native ? [
                    meanPaid.native
                ] : [],
                ...s.meanProviderPaidUsd != null ? [
                    t('aiPricing.visits.kpi.provider', {
                        value: usd(s.meanProviderPaidUsd)
                    })
                ] : []
            ],
            value: meanPaid.value,
            unit: meanPaid.unit,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52885985d1db6c06$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight
        },
        {
            key: 'margin',
            label: t('aiPricing.visits.kpi.margin'),
            sub: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(s.pricedShare) == null ? [] : [
                t('aiPricing.visits.kpi.pricedShare', {
                    share: formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(s.pricedShare), {
                        style: 'percent',
                        maximumFractionDigits: 0
                    })
                })
            ],
            value: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(s.marginPct) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatPercent((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(s.marginPct)),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b97e024910b40ff$export$2e2bcd8739ae039), {
                size: 20,
                color: negative ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
            }),
            bg: negative ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight
        },
        {
            key: 'median',
            label: t('aiPricing.visits.kpi.median'),
            sub: paidLine(p50p),
            value: p50e.value,
            unit: p50e.unit,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight
        },
        {
            key: 'p90',
            label: t('aiPricing.visits.kpi.p90'),
            sub: paidLine(p90p),
            value: p90e.value,
            unit: p90e.unit,
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9921f4f81a419f0$export$2e2bcd8739ae039), {
                size: 20,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
            }),
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "grid grid-cols-2 gap-3.5 md:grid-cols-3 xl:grid-cols-6",
        "data-testid": "ai-visits-kpis",
        children: kpis.map((kpi)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": `ai-visits-kpi-${kpi.key}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                    minWidth: 0,
                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "block",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block",
                                children: kpi.label
                            }),
                            kpi.sub.map((line)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "mt-0.5 block text-[10.5px] text-muted-foreground",
                                    children: line
                                }, line))
                        ]
                    }),
                    value: kpi.value,
                    unit: kpi.value === (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) ? undefined : kpi.unit,
                    icon: kpi.icon,
                    bg: kpi.bg
                })
            }, kpi.key))
    });
}
/**
 * The runs that no visit could claim (PM-0432): a patient id or a file id
 * where an appointment id belongs, or no id at all. Shown as a note under the
 * feature table — with a per-visit ESTIMATE, labelled as one — so «نکات
 * بالینی» stays visible instead of silently missing from the visit's cost.
 */ function $6714308ae651b53c$var$Unattributed({ rows: rows, conv: conv }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const label = (0, $b758277144067032$export$77dd77850115e3ad)();
    if (!rows.length) return null;
    const toman = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 0
        });
    const parseh = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v), {
            maximumFractionDigits: 2
        });
    const estimate = (r)=>conv.irt ? t('aiPricing.visits.unattributed.estimateToman', {
            earned: toman(conv.fromParseh(r.perVisitEarnedParseh)),
            paid: toman(conv.fromUsd(r.perVisitPaidUsd))
        }) : t('aiPricing.visits.unattributed.estimateNative', {
            earned: parseh(r.perVisitEarnedParseh),
            paid: (0, $7df21990c7b31bb5$export$314c2519e15cb3a9)(r.perVisitPaidUsd, {
                formatNumber: formatNumber,
                t: t
            })
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mt-4 rounded-lg border border-border bg-muted px-4 py-3 text-xs text-muted-foreground",
        role: "note",
        "data-testid": "ai-visits-unattributed",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-1.5 font-semibold text-foreground",
                children: t('aiPricing.visits.unattributed.title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "flex flex-col gap-1",
                children: rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        "data-testid": `ai-visits-unattributed-${r.serviceKey}`,
                        children: [
                            t('aiPricing.visits.unattributed.row', {
                                service: label(r),
                                runs: formatNumber(r.runs ?? 0),
                                withoutId: formatNumber(r.withoutIdRuns ?? 0)
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "whitespace-nowrap",
                                children: estimate(r)
                            })
                        ]
                    }, r.serviceKey))
            })
        ]
    });
}
/** Six KPI blocks and two table cards, in the real grid — nothing jumps on arrival. */ function $6714308ae651b53c$var$SummarySkeleton({ label: label }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-5",
        "data-testid": "ai-visits-summary-loading",
        "data-state": "loading",
        role: "status",
        "aria-busy": "true",
        "aria-label": label,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-3.5 md:grid-cols-3 xl:grid-cols-6",
                children: Array.from({
                    length: 6
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-xl border border-border bg-card p-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                width: "60%",
                                height: 22
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                    width: "80%",
                                    height: 11
                                })
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-xl border border-border bg-card p-5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
                            lines: 7,
                            height: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-xl border border-border bg-card p-5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b758277144067032$export$830e362f63e40ce4), {
                            lines: 7,
                            height: 16
                        })
                    })
                ]
            })
        ]
    });
}


const $6b629834167c25c0$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const $6b629834167c25c0$var$dateParam = {
    default: '',
    parse: (raw)=>$6b629834167c25c0$var$ISO_DATE.test(raw) ? raw : ''
};
const $6b629834167c25c0$var$flag = {
    default: '',
    values: [
        '',
        '1'
    ]
};
/** The URL contract (design §12.1). Defaults are absent from the address. */ const $6b629834167c25c0$var$SCHEMA = {
    view: {
        default: 'overview',
        values: (0, $ad1ad54ff7f74a69$export$50bf86b71c5fd0d9)
    },
    w: {
        default: (0, $ad1ad54ff7f74a69$export$b60010c1a0b9cee5),
        values: (0, $ad1ad54ff7f74a69$export$2a4322aefdc3a504)
    },
    owner: {
        default: '',
        values: [
            '',
            ...(0, $ad1ad54ff7f74a69$export$60b33fb147a66c)
        ]
    },
    q: {
        default: ''
    },
    sort: {
        default: ''
    },
    dir: {
        default: '',
        values: [
            '',
            'asc',
            'desc'
        ]
    },
    page: {
        default: 1,
        parse: (raw)=>Number(raw) || 1
    },
    service: {
        default: ''
    },
    model: {
        default: ''
    },
    policy: {
        default: ''
    },
    from: {
        default: ''
    },
    inv: {
        default: ''
    },
    negative: $6b629834167c25c0$var$flag,
    unpriced: $6b629834167c25c0$var$flag,
    mismatch: $6b629834167c25c0$var$flag,
    deprecated: $6b629834167c25c0$var$flag,
    status: {
        default: '',
        values: [
            '',
            ...(0, $ad1ad54ff7f74a69$export$c905d1784509c2ab)
        ]
    },
    charged: {
        default: '',
        values: [
            '',
            'yes',
            'no'
        ]
    },
    ownerId: {
        default: ''
    },
    dfrom: $6b629834167c25c0$var$dateParam,
    dto: $6b629834167c25c0$var$dateParam,
    // «ویزیت‌ها» (PM-0427). `rate` is the policy whose dollar converts the
    // visits' money — NOT `policy`, which opens the policy editor and hides the
    // alert zone. `visit` opens a visit's drawer; `inv` inside it swaps the body.
    visit: {
        default: ''
    },
    rec: {
        default: '',
        values: [
            '',
            'yes',
            'no'
        ]
    },
    mins: {
        default: '',
        values: [
            '',
            ...(0, $ad1ad54ff7f74a69$export$e91ee2b842347321)
        ]
    },
    rate: {
        default: '',
        parse: (raw)=>/^\d+$/.test(raw) ? raw : ''
    }
};
/** Everything a view owns; switching views clears it, the window survives. */ const $6b629834167c25c0$var$VIEW_LOCAL = {
    q: '',
    sort: '',
    dir: '',
    page: 1,
    service: '',
    model: '',
    policy: '',
    from: '',
    inv: '',
    negative: '',
    unpriced: '',
    mismatch: '',
    deprecated: '',
    status: '',
    charged: '',
    ownerId: '',
    dfrom: '',
    dto: '',
    visit: '',
    rec: '',
    mins: '',
    rate: ''
};
const $6b629834167c25c0$var$SEVERITY_VARIANT = {
    danger: 'error',
    warning: 'warning',
    info: 'info'
};
function $6b629834167c25c0$export$2e2bcd8739ae039() {
    const { t: t, formatNumber: formatNumber, formatPercent: formatPercent, formatDate: formatDate, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.aiPricing');
    const [view, setView] = (0, $e77179a3ce65222f$export$6a582373474709af)($6b629834167c25c0$var$SCHEMA);
    // `to` is "now" at the moment the window was chosen; re-deriving it on every
    // render would refetch forever.
    const window = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$b579fde59a974853)(view.w), [
        view.w
    ]);
    const [overview, setOverview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loadOverview = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $3ece07ed3ee6f427$export$c378ca4a0e2c9fec), {
            window: window,
            ownerType: view.owner || null
        }).then((d)=>setOverview(d?.aiCostOverview || null)).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        window,
        view.owner,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        loadOverview();
    }, [
        loadOverview
    ]);
    // ── dirty guard ────────────────────────────────────────────────────────────
    const [editorDirty, setEditorDirty] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [pendingPatch, setPendingPatch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const leavesEditor = (patch)=>editorDirty && view.policy && ('view' in patch && patch.view !== 'policies' || 'policy' in patch && patch.policy !== view.policy);
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch)=>{
        if (leavesEditor(patch)) {
            setPendingPatch(patch);
            return;
        }
        setView(patch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setView,
        editorDirty,
        view.policy
    ]);
    const changeView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (next === view.view) return;
        go({
            ...$6b629834167c25c0$var$VIEW_LOCAL,
            view: next
        });
    }, [
        go,
        view.view
    ]);
    const goToAlert = (alert)=>{
        const target = (0, $ad1ad54ff7f74a69$export$acb36081c21cceb4)(alert);
        if (!target) return;
        const { view: next, ...rest } = target;
        go({
            ...$6b629834167c25c0$var$VIEW_LOCAL,
            view: next,
            ...rest
        });
    };
    // `1`–`6` switch views; bare digits never fire while typing (registry rule).
    (0, $ad1ad54ff7f74a69$export$50bf86b71c5fd0d9).forEach((name, i)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)(String(i + 1), ()=>changeView(name), {
            label: t('shortcuts.action.view', {
                view: t(`aiPricing.views.${name}`)
            }),
            group: t('shortcuts.groups.aiPricing')
        });
    });
    const alerts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $ad1ad54ff7f74a69$export$d5d270d2f9954e4a)(overview?.alerts), [
        overview
    ]);
    const alertText = (alert)=>{
        const detail = alert.detail == null ? '' : String(alert.detail);
        switch(alert.kind){
            case 'provider_drift':
                return t('aiPricing.alerts.provider_drift', {
                    pct: (0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail) == null ? detail : formatPercent((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(detail))
                });
            case 'wallet_value_changed':
                {
                    const [from, to] = detail.split(/\s*(?:->|→|←|,|;|\|)\s*/);
                    const fmt = (v)=>(0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v) == null ? v || t('common.value.none') : formatNumber((0, $ad1ad54ff7f74a69$export$61cc6a0be4938a2a)(v));
                    return t('aiPricing.alerts.wallet_value_changed', {
                        from: fmt(from),
                        to: fmt(to ?? from)
                    });
                }
            case 'fx_stale':
                // detail = the last night a rate was accepted (YYYY-MM-DD), or none at all.
                return /^\d{4}-\d{2}-\d{2}$/.test(detail) ? t('aiPricing.alerts.fx_stale', {
                    date: formatDate(`${detail}T12:00:00Z`)
                }) : t('aiPricing.alerts.fx_stale_never');
            case 'fx_reprice_held':
                // detail = the held draft's id; the door opens that draft.
                return t('aiPricing.alerts.fx_reprice_held', {
                    id: detail ? formatDigits(detail) : t('common.value.none')
                });
            case 'no_active_policy':
            case 'unpriced_models':
            case 'negative_margin':
            case 'apps_mismatch':
            case 'telemetry_dropped':
            case 'deprecated_in_use':
                return t(`aiPricing.alerts.${alert.kind}`, {
                    count: alert.count ?? 0
                });
            default:
                // A kind this build has not been taught is echoed, not swallowed.
                return detail || alert.kind;
        }
    };
    const viewProps = {
        window: window,
        view: view,
        go: go
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative flex h-full flex-col bg-background",
        "data-testid": "ai-pricing",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('aiPricing.title'),
                sub: t('aiPricing.sub'),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                        semantics: "tabs",
                        size: "sm",
                        ariaLabel: t('aiPricing.views.label'),
                        options: (0, $ad1ad54ff7f74a69$export$50bf86b71c5fd0d9).map((value)=>({
                                value: value,
                                label: t(`aiPricing.views.${value}`)
                            })),
                        value: view.view,
                        onChange: changeView,
                        "data-testid": "ai-pricing-tabs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                        semantics: "filter",
                        size: "sm",
                        ariaLabel: t('aiPricing.window.label'),
                        options: (0, $ad1ad54ff7f74a69$export$2a4322aefdc3a504).map((value)=>({
                                value: value,
                                label: t(`aiPricing.window.d${value}`)
                            })),
                        value: view.w,
                        onChange: (w)=>go({
                                w: w,
                                page: 1
                            }),
                        "data-testid": "ai-pricing-window"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto w-full max-w-[1440px]",
                    children: [
                        !view.policy ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-5 flex flex-col gap-3",
                            "aria-label": t('aiPricing.alerts.label'),
                            "data-testid": "ai-pricing-alerts",
                            children: [
                                error && view.view !== 'overview' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                    variant: "error",
                                    "data-testid": "ai-pricing-alerts-error",
                                    action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        size: "sm",
                                        onClick: loadOverview,
                                        children: t('common.actions.retry')
                                    }),
                                    children: t('aiPricing.overview.error')
                                }) : null,
                                alerts.map((alert)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: $6b629834167c25c0$var$SEVERITY_VARIANT[alert.severity] || 'info',
                                        "data-testid": `ai-pricing-alert-${alert.kind}`,
                                        "data-severity": alert.severity,
                                        action: (0, $ad1ad54ff7f74a69$export$acb36081c21cceb4)(alert) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: ()=>goToAlert(alert),
                                            "data-testid": `ai-pricing-alert-${alert.kind}-open`,
                                            children: alert.kind === 'fx_reprice_held' ? t('aiPricing.alerts.openDraft') : t('aiPricing.alerts.view')
                                        }) : undefined,
                                        children: alertText(alert)
                                    }, alert.kind))
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            role: "tabpanel",
                            "aria-label": t(`aiPricing.views.${view.view}`),
                            "data-testid": `ai-pricing-panel-${view.view}`,
                            children: view.view === 'overview' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bef04d4396ec295a$export$2e2bcd8739ae039), {
                                ...viewProps,
                                overview: overview,
                                loading: loading,
                                error: error,
                                onRetry: loadOverview
                            }) : view.view === 'models' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a9d6e27ab0bf8e0$export$2e2bcd8739ae039), {
                                ...viewProps
                            }) : view.view === 'services' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f68a6992acc87e$export$2e2bcd8739ae039), {
                                ...viewProps
                            }) : view.view === 'policies' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2bfd28cffb3dfed$export$2e2bcd8739ae039), {
                                ...viewProps,
                                onEditorDirty: setEditorDirty
                            }) : view.view === 'visits' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6714308ae651b53c$export$2e2bcd8739ae039), {
                                ...viewProps
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c8bdcc01e6fb30df$export$2e2bcd8739ae039), {
                                ...viewProps
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: !!pendingPatch,
                onOpenChange: (open)=>{
                    if (!open) setPendingPatch(null);
                },
                title: t('aiPricing.policies.editor.dirty.title'),
                description: t('aiPricing.policies.editor.dirty.body'),
                confirmLabel: t('aiPricing.policies.editor.dirty.confirm'),
                cancelLabel: t('aiPricing.policies.editor.dirty.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    const patch = pendingPatch;
                    setPendingPatch(null);
                    setEditorDirty(false);
                    setView(patch);
                },
                "data-testid": "ai-pricing-dirty-guard",
                confirmTestId: "ai-pricing-dirty-guard-confirm",
                cancelTestId: "ai-pricing-dirty-guard-cancel"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db2e87076da45383$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ImageOff", [
    [
        "line",
        {
            x1: "2",
            x2: "22",
            y1: "2",
            y2: "22",
            key: "a6p6uj"
        }
    ],
    [
        "path",
        {
            d: "M10.41 10.41a2 2 0 1 1-2.83-2.83",
            key: "1bzlo9"
        }
    ],
    [
        "line",
        {
            x1: "13.5",
            x2: "6",
            y1: "13.5",
            y2: "21",
            key: "1q0aeu"
        }
    ],
    [
        "line",
        {
            x1: "18",
            x2: "21",
            y1: "12",
            y2: "15",
            key: "5mozeu"
        }
    ],
    [
        "path",
        {
            d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
            key: "mmje98"
        }
    ],
    [
        "path",
        {
            d: "M21 15V5a2 2 0 0 0-2-2H9",
            key: "43el77"
        }
    ]
]);



/**
 * Every GraphQL document the marketplace screen sends, built against the
 * contract in `parsina.bff.admin/src/graphql/typeDefs/marketplace.js`. One
 * file, so a contract change is a diff against one place and a test can match
 * a call by its operation name.
 *
 * Money fields are MINOR UNITS of the row's `currency` — whole rials for IRR,
 * which is also what a missing currency means; the screen renders them through
 * `formatMoney` in that currency. A settlement's lines are in its currency.
 */ const $1cdfc8d3d71ea720$var$VENDOR_FIELDS = `
  clinicId slug displayName tagline description logoUrl city clinicType
  status marketplaceStatus marketplaceRejectionReason marketplaceReviewedAt
  commissionPct payoutAccountId contactPhone
  readiness { canActivate canRequestMarketplace missing }
  createdAt
`;
const $1cdfc8d3d71ea720$var$LISTING_FIELDS = `
  id clinicId vendorSlug vendorName kind title description
  images { id url sortOrder alt }
  productType priceRial listPriceRial currency reviewStatus reviewNote reviewedAt
  visibility status sourceInactive updatedAt
`;
const $1cdfc8d3d71ea720$var$SETTLEMENT_FIELDS = `
  id clinicId vendorName vendorSlug period grossRial commissionRial refundsRial netRial currency
  status paidAt paidReference payoutAccountId incomePosted
  lines { id orderId orderNumber kind grossRial commissionRial netRial at }
`;
const $1cdfc8d3d71ea720$export$efdaef91199fc8fd = `
  query MarketplaceVendorRequests($status: String, $cursor: String, $limit: Int) {
    marketplaceVendorRequests(status: $status, cursor: $cursor, limit: $limit) {
      nextCursor items { ${$1cdfc8d3d71ea720$var$VENDOR_FIELDS} }
    }
  }
`;
const $1cdfc8d3d71ea720$export$562e6cc04606dc31 = `
  mutation ReviewMarketplaceVendor($clinicId: ID!, $decision: MarketplaceVendorDecision!, $note: String) {
    reviewMarketplaceVendor(clinicId: $clinicId, decision: $decision, note: $note) { ${$1cdfc8d3d71ea720$var$VENDOR_FIELDS} }
  }
`;
const $1cdfc8d3d71ea720$export$ba4e45a5792ba241 = `
  query MarketplaceListingReviews($status: String, $cursor: String, $limit: Int) {
    marketplaceListingReviews(status: $status, cursor: $cursor, limit: $limit) {
      nextCursor total items { ${$1cdfc8d3d71ea720$var$LISTING_FIELDS} }
    }
  }
`;
const $1cdfc8d3d71ea720$export$da00e866db78ce6b = `
  mutation ReviewMarketplaceListing($clinicId: ID!, $id: ID!, $decision: MarketplaceListingDecision!, $note: String) {
    reviewMarketplaceListing(clinicId: $clinicId, id: $id, decision: $decision, note: $note) { ${$1cdfc8d3d71ea720$var$LISTING_FIELDS} }
  }
`;
const $1cdfc8d3d71ea720$export$712e2250ed1e3997 = `
  query MarketplaceSettlementsAdmin($status: String, $period: String, $cursor: String, $limit: Int) {
    marketplaceSettlementsAdmin(status: $status, period: $period, cursor: $cursor, limit: $limit) {
      nextCursor items { ${$1cdfc8d3d71ea720$var$SETTLEMENT_FIELDS} }
    }
  }
`;
const $1cdfc8d3d71ea720$export$79708f9e88a194e6 = `
  mutation CloseMarketplaceSettlement($id: ID!) {
    closeMarketplaceSettlement(id: $id) { ${$1cdfc8d3d71ea720$var$SETTLEMENT_FIELDS} }
  }
`;
const $1cdfc8d3d71ea720$export$d20177dff2c44fc5 = `
  mutation MarkMarketplaceSettlementPaid($id: ID!, $reference: String!) {
    markMarketplaceSettlementPaid(id: $id, reference: $reference) { ${$1cdfc8d3d71ea720$var$SETTLEMENT_FIELDS} }
  }
`;
const $1cdfc8d3d71ea720$export$1b38368620ec5074 = `
  query PlatformMarketplaceSettings {
    platformMarketplaceSettings { commissionPct updatedAt }
  }
`;
const $1cdfc8d3d71ea720$export$dd9745a8f5df2cab = `
  mutation SetPlatformCommission($pct: Float!) {
    setPlatformCommission(pct: $pct) { commissionPct updatedAt }
  }
`;
const $1cdfc8d3d71ea720$export$289631666dd6bd31 = `
  query MarketplaceCategories {
    marketplaceCategories { id name parentId sortOrder }
  }
`;
const $1cdfc8d3d71ea720$export$87f87226598659d5 = `
  mutation UpsertMarketplaceCategory($input: MarketplaceCategoryInput!) {
    upsertMarketplaceCategory(input: $input) { id name parentId sortOrder }
  }
`;




var $acw62 = parcelRequire("acw62");







const $07312e74f48e4df8$export$b48b5ef5da1651d3 = 50;
const $07312e74f48e4df8$export$6556e5010b701a8b = 3;
const $07312e74f48e4df8$export$2daf5676b9ee9779 = 500;
function $07312e74f48e4df8$export$fd47d6972da0c54a(prefix) {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        if (value == null || value === '') return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
        const key = `${prefix}.${value}`;
        return has && has(key) ? t(key) : String(value);
    }, [
        t,
        has,
        prefix
    ]);
}
function $07312e74f48e4df8$export$52f0f02147b12c03({ children: children, className: className = '' }) {
    if (children == null || children === '') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: `font-mono text-[12px] ${className}`,
        children: children
    });
}
function $07312e74f48e4df8$export$4b67f8be7a5e4a15({ label: label, value: value, wide: wide }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `min-w-0 ${wide ? 'col-span-2' : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                className: "text-xs text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                className: "break-words font-semibold text-foreground",
                children: value == null || value === '' ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : value
            })
        ]
    });
}
const $07312e74f48e4df8$var$TONE = {
    pending: 'warning',
    approved: 'success',
    rejected: 'destructive',
    suspended: 'destructive',
    not_requested: 'outline',
    open: 'outline',
    closed: 'warning',
    paid: 'success'
};
function $07312e74f48e4df8$export$fd5345d4562e9833({ value: value, prefix: prefix, 'data-testid': testId }) {
    const label = $07312e74f48e4df8$export$fd47d6972da0c54a(prefix);
    if (!value) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: $07312e74f48e4df8$var$TONE[value] || 'outline',
        "data-testid": testId,
        "data-tone": $07312e74f48e4df8$var$TONE[value] || 'outline',
        children: label(value)
    });
}
const $07312e74f48e4df8$export$d2f719a5670e623a = (currency)=>!currency || currency === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
const $07312e74f48e4df8$export$108b7a54972a94af = (rows)=>(rows || []).every((r)=>$07312e74f48e4df8$export$d2f719a5670e623a(r?.currency));
function $07312e74f48e4df8$export$6e447984ddf9f65e({ rials: rials, currency: currency, withUnit: withUnit = false, className: className = '' }) {
    const { t: t, formatMoney: formatMoney } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const text = formatMoney(rials, {
        currency: currency,
        withUnit: withUnit || !$07312e74f48e4df8$export$d2f719a5670e623a(currency),
        unitLabel: t('common.units.toman'),
        unitStyle: 'short'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `whitespace-nowrap tabular-nums ${className}`,
        children: text
    });
}
function $07312e74f48e4df8$export$7afc19c20799c3c1({ cols: cols, label: label, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": testId,
        "data-state": "loading",
        role: "status",
        "aria-busy": "true",
        "aria-label": label,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: Array.from({
                    length: 6
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                        cols: cols
                    }, i))
            })
        })
    });
}
function $07312e74f48e4df8$export$9690426acfcf6a63({ onClose: onClose, title: title, sub: sub, children: children, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('esc', onClose, {
        label: t('shortcuts.action.closeDrawer'),
        group: t('shortcuts.groups.marketplace')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
        open: true,
        onClose: onClose,
        width: 560,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": title,
            className: "flex h-full min-h-0 flex-col",
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$bb68d554ded258ea), {
                    title: title,
                    sub: sub,
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$4ed8420cdfcb2b8f), {
                    children: children
                })
            ]
        })
    });
}
function $07312e74f48e4df8$export$c0904bebf502a0f5({ 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('marketplace.drawer.notInList'),
        description: t('marketplace.drawer.notInListDesc'),
        "data-testid": testId
    });
}
function $07312e74f48e4df8$export$f96b036b4524bebb({ action: action, onClose: onClose, onDone: onDone, onError: onError, testId: testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setValue('');
        setTouched(false);
        setError(null);
        setPending(false);
    }, [
        action?.key
    ]);
    if (!action) return null;
    const trimmed = value.trim();
    const invalid = action.field === 'rejectNote' ? trimmed.length < $07312e74f48e4df8$export$6556e5010b701a8b : action.field === 'reference' ? !trimmed : false;
    const inlineError = touched && invalid ? action.field === 'reference' ? t('marketplace.settlements.confirm.referenceRequired') : t('marketplace.note.required', {
        min: $07312e74f48e4df8$export$6556e5010b701a8b
    }) : undefined;
    const run = async ()=>{
        setTouched(true);
        if (invalid || pending) return;
        setPending(true);
        setError(null);
        try {
            const data = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)(action.document, action.variables(action.field === 'reference' ? (0, $c53f9539af19d960$export$e53ee9755c8a3679)(trimmed) : trimmed || null));
            toast.success(action.success);
            onDone?.(data);
            onClose();
        } catch (e) {
            const message = (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t);
            setError(message);
            onError?.(message);
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
        open: true,
        onOpenChange: (open)=>{
            if (!open && !pending) onClose();
        },
        title: action.title,
        description: action.body,
        confirmLabel: action.confirmLabel,
        cancelLabel: t('common.actions.cancel'),
        destructive: action.destructive,
        loading: pending,
        confirmDisabled: invalid,
        onConfirm: run,
        "data-testid": testId,
        confirmTestId: `${testId}-confirm`,
        cancelTestId: `${testId}-cancel`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    "data-testid": `${testId}-error`,
                    children: error
                }) : null,
                action.field === 'reference' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": `${testId}-reference`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('marketplace.settlements.confirm.reference'),
                        required: true,
                        value: value,
                        onChange: (e)=>setValue(e.target?.value ?? e),
                        onBlur: ()=>setTouched(true),
                        dir: "ltr",
                        maxLength: 120,
                        error: inlineError,
                        disabled: pending
                    })
                }) : action.field ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": `${testId}-note`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                        label: action.field === 'rejectNote' ? t('marketplace.note.rejectLabel') : t('marketplace.note.optional'),
                        required: action.field === 'rejectNote',
                        helperText: action.field === 'rejectNote' ? t('marketplace.note.rejectHelp') : undefined,
                        value: value,
                        onChange: (e)=>setValue(e.target?.value ?? e),
                        onBlur: ()=>setTouched(true),
                        error: inlineError,
                        maxLength: $07312e74f48e4df8$export$2daf5676b9ee9779,
                        showCount: true,
                        rows: 3,
                        disabled: pending
                    })
                }) : null
            ]
        })
    });
}
function $07312e74f48e4df8$export$5ecaec9f8bdac0eb({ onClick: onClick, pending: pending, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex justify-center border-t border-border p-2",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "ghost",
            size: "sm",
            onClick: onClick,
            disabled: pending,
            "data-testid": testId,
            children: t('marketplace.loadMore')
        })
    });
}
function $07312e74f48e4df8$export$6ee34b00fd42c538(document, pick, variables) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [moreLoading, setMoreLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const key = JSON.stringify(variables);
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        return (0, $4d933cf7e127f21f$export$72e4926bf8358653)(document, {
            ...JSON.parse(key),
            limit: $07312e74f48e4df8$export$b48b5ef5da1651d3
        }).then((d)=>{
            const page = pick(d);
            setRows(page?.items || []);
            setCursor(page?.nextCursor || null);
        }).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        document,
        key,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: !first.current && rows.length > 0
        });
        first.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        load
    ]);
    const more = ()=>{
        if (!cursor) return;
        setMoreLoading(true);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)(document, {
            ...JSON.parse(key),
            cursor: cursor,
            limit: $07312e74f48e4df8$export$b48b5ef5da1651d3
        }).then((d)=>{
            const page = pick(d);
            setRows((r)=>[
                    ...r,
                    ...page?.items || []
                ]);
            setCursor(page?.nextCursor || null);
        }).catch((e)=>toast.error((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setMoreLoading(false));
    };
    /** Replace one row in place after a write returned it. */ const replace = (match, next)=>setRows((r)=>r.map((row)=>match(row) ? {
                    ...row,
                    ...next
                } : row));
    return {
        rows: rows,
        cursor: cursor,
        loading: loading,
        refreshing: refreshing,
        moreLoading: moreLoading,
        error: error,
        reload: ()=>load({
                quiet: true
            }),
        retry: ()=>load(),
        more: more,
        replace: replace
    };
}


const $5ef4a68932f09af5$export$33b242c82e5c0bc9 = [
    'pending',
    'approved',
    'rejected',
    'suspended'
];
const $5ef4a68932f09af5$export$fca203ae3dbe98b8 = {
    pending: [
        'approve',
        'reject'
    ],
    approved: [
        'suspend'
    ],
    suspended: [
        'reinstate'
    ],
    rejected: [],
    not_requested: []
};
const $5ef4a68932f09af5$var$pickVendors = (d)=>d?.marketplaceVendorRequests;
function $5ef4a68932f09af5$export$2e2bcd8739ae039({ view: view, go: go }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const list = (0, $07312e74f48e4df8$export$6ee34b00fd42c538)((0, $1cdfc8d3d71ea720$export$efdaef91199fc8fd), $5ef4a68932f09af5$var$pickVendors, {
        status: view.status || 'pending'
    });
    const selected = view.vendor ? list.rows.find((r)=>r.clinicId === view.vendor) : null;
    const columns = [
        {
            key: 'name',
            header: t('marketplace.vendors.columns.name'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    className: "font-semibold text-foreground",
                    children: r.displayName
                })
        },
        {
            key: 'slug',
            header: t('marketplace.vendors.columns.slug'),
            width: '11rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                    children: r.slug
                })
        },
        {
            key: 'city',
            header: t('marketplace.vendors.columns.city'),
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    children: r.city || "\u2014"
                })
        },
        {
            key: 'type',
            header: t('marketplace.vendors.columns.type'),
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    children: r.clinicType || "\u2014"
                })
        },
        {
            key: 'status',
            header: t('marketplace.vendors.columns.status'),
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$fd5345d4562e9833), {
                    value: r.marketplaceStatus,
                    prefix: "marketplace.vendors.status"
                })
        },
        {
            key: 'requestedAt',
            header: t('marketplace.vendors.columns.requestedAt'),
            width: '9rem',
            render: (r)=>formatDate(r.createdAt)
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "mk-vendors",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-3 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "group",
                    "aria-label": t('marketplace.vendors.filters.label'),
                    className: "flex flex-wrap gap-1.5",
                    "data-testid": "mk-vendors-filter",
                    children: $5ef4a68932f09af5$export$33b242c82e5c0bc9.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                            label: t(`marketplace.vendors.filters.${s}`),
                            active: (view.status || 'pending') === s,
                            onClick: ()=>go({
                                    status: s,
                                    vendor: ''
                                }),
                            "data-testid": `mk-vendors-filter-${s}`
                        }, s))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: list.refreshing ? 0.45 : 1
                },
                "aria-busy": list.refreshing || undefined,
                children: list.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$7afc19c20799c3c1), {
                    cols: 6,
                    label: t('marketplace.vendors.loading'),
                    "data-testid": "mk-vendors-loading"
                }) : list.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('marketplace.vendors.error'),
                    description: list.error,
                    onRetry: list.retry,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "mk-vendors-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                            dense: true,
                            ariaLabel: t('marketplace.vendors.tableAria'),
                            columns: columns,
                            rows: list.rows,
                            rowKey: (r)=>r.clinicId,
                            onRowActivate: (r)=>go({
                                    vendor: r.clinicId
                                }),
                            rowProps: (r)=>({
                                    'data-testid': `mk-vendors-row-${r.clinicId}`,
                                    'aria-label': t('marketplace.vendors.open', {
                                        name: r.displayName
                                    })
                                }),
                            empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f17d085e2e0469d$export$2e2bcd8739ae039), {
                                    size: 44,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('marketplace.vendors.empty.title'),
                                description: t('marketplace.vendors.empty.desc'),
                                "data-testid": "mk-vendors-empty"
                            }),
                            "data-testid": "mk-vendors-table"
                        }),
                        list.cursor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$5ecaec9f8bdac0eb), {
                            onClick: list.more,
                            pending: list.moreLoading,
                            "data-testid": "mk-vendors-more"
                        }) : null
                    ]
                })
            }),
            view.vendor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ef4a68932f09af5$var$VendorDrawer, {
                vendor: selected,
                onClose: ()=>go({
                        vendor: ''
                    }),
                onChanged: (next)=>{
                    list.replace((r)=>r.clinicId === next.clinicId, next);
                    list.reload();
                }
            }) : null
        ]
    });
}
function $5ef4a68932f09af5$var$VendorDrawer({ vendor: vendor, onClose: onClose, onChanged: onChanged }) {
    const { t: t, formatDate: formatDate, formatPercent: formatPercent } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const storeStatus = (0, $07312e74f48e4df8$export$fd47d6972da0c54a)('marketplace.vendors.storeStatus');
    const missingLabel = (0, $07312e74f48e4df8$export$fd47d6972da0c54a)('marketplace.vendors.missing');
    const [action, setAction] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    if (!vendor) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$9690426acfcf6a63), {
        onClose: onClose,
        title: t('marketplace.vendors.drawer.title'),
        "data-testid": "mk-vendor-drawer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$c0904bebf502a0f5), {
            "data-testid": "mk-vendor-drawer-missing"
        })
    });
    const actions = $5ef4a68932f09af5$export$fca203ae3dbe98b8[vendor.marketplaceStatus] || [];
    const open = (decision)=>{
        setError(null);
        setAction({
            key: decision,
            decision: decision,
            title: t(`marketplace.vendors.confirm.${decision}`, {
                name: vendor.displayName
            }),
            body: t(`marketplace.vendors.confirm.${decision}Body`),
            confirmLabel: t(`marketplace.vendors.actions.${decision}`),
            destructive: decision === 'reject' || decision === 'suspend',
            field: decision === 'reject' ? 'rejectNote' : 'note',
            document: (0, $1cdfc8d3d71ea720$export$562e6cc04606dc31),
            variables: (note)=>({
                    clinicId: vendor.clinicId,
                    decision: decision,
                    note: note
                }),
            success: t(`marketplace.vendors.success.${decision}`)
        });
    };
    const missing = vendor.readiness?.missing || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $07312e74f48e4df8$export$9690426acfcf6a63), {
        onClose: onClose,
        title: t('marketplace.vendors.drawer.title'),
        sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
            children: vendor.slug
        }),
        "data-testid": "mk-vendor-drawer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-5",
                children: [
                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "error",
                        "data-testid": "mk-vendor-drawer-error",
                        children: t('marketplace.drawer.failed', {
                            message: error
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            vendor.logoUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: vendor.logoUrl,
                                alt: t('marketplace.vendors.drawer.logo'),
                                className: "h-16 w-16 rounded-lg border border-border object-cover"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex h-16 w-16 items-center justify-center rounded-lg border border-border bg-muted text-muted-foreground",
                                title: t('marketplace.vendors.drawer.noLogo'),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db2e87076da45383$export$2e2bcd8739ae039), {
                                    size: 24,
                                    "aria-label": t('marketplace.vendors.drawer.noLogo')
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        dir: "auto",
                                        className: "truncate text-base font-bold text-foreground",
                                        children: vendor.displayName
                                    }),
                                    vendor.tagline ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        dir: "auto",
                                        className: "truncate text-sm text-muted-foreground",
                                        children: vendor.tagline
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$fd5345d4562e9833), {
                                            value: vendor.marketplaceStatus,
                                            prefix: "marketplace.vendors.status",
                                            "data-testid": "mk-vendor-drawer-status"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.drawer.actions')
                            }),
                            actions.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: actions.map((decision)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: decision === 'approve' || decision === 'reinstate' ? 'default' : 'destructive',
                                        onClick: ()=>open(decision),
                                        "data-testid": `mk-vendor-${decision}`,
                                        children: t(`marketplace.vendors.actions.${decision}`)
                                    }, decision))
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: t('marketplace.drawer.noActions')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.vendors.drawer.profile')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                                className: "grid grid-cols-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.columns.city'),
                                        value: vendor.city ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            dir: "auto",
                                            children: vendor.city
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.columns.type'),
                                        value: vendor.clinicType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            dir: "auto",
                                            children: vendor.clinicType
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.drawer.storeStatus'),
                                        value: storeStatus(vendor.status)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.columns.requestedAt'),
                                        value: vendor.createdAt ? formatDate(vendor.createdAt) : null
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.drawer.phone'),
                                        value: vendor.contactPhone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                                            children: vendor.contactPhone
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.drawer.commission'),
                                        value: vendor.commissionPct == null ? t('marketplace.vendors.drawer.commissionDefault') : formatPercent(vendor.commissionPct, {
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.drawer.payout'),
                                        value: vendor.payoutAccountId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                                            children: vendor.payoutAccountId
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        label: t('marketplace.vendors.drawer.reviewedAt'),
                                        value: vendor.marketplaceReviewedAt ? formatDate(vendor.marketplaceReviewedAt) : null
                                    }),
                                    vendor.marketplaceRejectionReason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        wide: true,
                                        label: t('marketplace.vendors.drawer.rejection'),
                                        value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            dir: "auto",
                                            children: vendor.marketplaceRejectionReason
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                        wide: true,
                                        label: t('marketplace.vendors.drawer.description'),
                                        value: vendor.description ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            dir: "auto",
                                            className: "whitespace-pre-line font-normal",
                                            children: vendor.description
                                        }) : null
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        "data-testid": "mk-vendor-drawer-readiness",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.vendors.drawer.readiness')
                            }),
                            missing.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mb-2 text-xs text-muted-foreground",
                                        children: t('marketplace.vendors.drawer.missing')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "flex flex-wrap gap-1.5",
                                        children: missing.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: "warning",
                                                    children: missingLabel(m)
                                                })
                                            }, m))
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: t('marketplace.vendors.drawer.ready')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$f96b036b4524bebb), {
                action: action,
                testId: "mk-vendor-dialog",
                onClose: ()=>setAction(null),
                onError: setError,
                onDone: (d)=>{
                    setError(null);
                    if (d?.reviewMarketplaceVendor) onChanged(d.reviewMarketplaceVendor);
                }
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df8ae1eff5d02c3d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("PackageSearch", [
    [
        "path",
        {
            d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
            key: "e7tb2h"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "22",
            y2: "12",
            key: "a4e8g8"
        }
    ],
    [
        "circle",
        {
            cx: "18.5",
            cy: "15.5",
            r: "2.5",
            key: "b5zd12"
        }
    ],
    [
        "path",
        {
            d: "M20.27 17.27 22 19",
            key: "1l4muz"
        }
    ]
]);





const $41803b07642b8433$export$ea28eaee9bce13a8 = [
    'pending',
    'approved',
    'rejected'
];
const $41803b07642b8433$export$3944572e5dc580c3 = {
    pending: [
        'approve',
        'reject'
    ],
    approved: [
        'reject'
    ],
    rejected: [
        'approve'
    ]
};
const $41803b07642b8433$var$pickListings = (d)=>d?.marketplaceListingReviews;
function $41803b07642b8433$var$Thumb({ image: image, size: size = 40 }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (image?.url) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
        src: image.url,
        alt: image.alt || '',
        className: "rounded-md border border-border object-cover",
        style: {
            width: size,
            height: size
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "inline-flex items-center justify-center rounded-md border border-border bg-muted text-muted-foreground",
        style: {
            width: size,
            height: size
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db2e87076da45383$export$2e2bcd8739ae039), {
            size: 16,
            "aria-label": t('marketplace.listings.drawer.noImages')
        })
    });
}
function $41803b07642b8433$export$2e2bcd8739ae039({ view: view, go: go }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const kindLabel = (0, $07312e74f48e4df8$export$fd47d6972da0c54a)('marketplace.listings.kind');
    const status = view.status || 'pending';
    const list = (0, $07312e74f48e4df8$export$6ee34b00fd42c538)((0, $1cdfc8d3d71ea720$export$ba4e45a5792ba241), $41803b07642b8433$var$pickListings, {
        status: status
    });
    const selected = view.listing ? list.rows.find((r)=>r.id === view.listing) : null;
    // The queue spans stores, and stores may price in different currencies: an
    // all-IRR page keeps «قیمت (تومان)», any other names no unit in the header
    // and puts one on every price.
    const unitPerFigure = !(0, $07312e74f48e4df8$export$108b7a54972a94af)(list.rows);
    const columns = [
        {
            key: 'thumb',
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: t('marketplace.listings.columns.thumb')
            }),
            width: '4rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41803b07642b8433$var$Thumb, {
                    image: r.images?.[0]
                })
        },
        {
            key: 'title',
            header: t('marketplace.listings.columns.title'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    className: "font-semibold text-foreground",
                    children: r.title
                })
        },
        {
            key: 'vendor',
            header: t('marketplace.listings.columns.vendor'),
            width: '12rem',
            render: (r)=>r.vendorName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    children: r.vendorName
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: t('marketplace.listings.unknownVendor')
                })
        },
        {
            key: 'kind',
            header: t('marketplace.listings.columns.kind'),
            width: '6rem',
            render: (r)=>kindLabel(r.kind)
        },
        {
            key: 'price',
            header: unitPerFigure ? t('marketplace.listings.columnsNoUnit.price') : t('marketplace.listings.columns.price'),
            align: 'end',
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                    rials: r.priceRial,
                    currency: r.currency,
                    withUnit: unitPerFigure
                })
        },
        {
            key: 'submitted',
            header: t('marketplace.listings.columns.submitted'),
            width: '9rem',
            render: (r)=>formatDate(r.updatedAt)
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "mk-listings",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mb-3 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "group",
                    "aria-label": t('marketplace.listings.filters.label'),
                    className: "flex flex-wrap gap-1.5",
                    "data-testid": "mk-listings-filter",
                    children: $41803b07642b8433$export$ea28eaee9bce13a8.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                            label: t(`marketplace.listings.filters.${s}`),
                            active: status === s,
                            onClick: ()=>go({
                                    status: s,
                                    listing: ''
                                }),
                            "data-testid": `mk-listings-filter-${s}`
                        }, s))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: list.refreshing ? 0.45 : 1
                },
                "aria-busy": list.refreshing || undefined,
                children: list.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$7afc19c20799c3c1), {
                    cols: 6,
                    label: t('marketplace.listings.loading'),
                    "data-testid": "mk-listings-loading"
                }) : list.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('marketplace.listings.error'),
                    description: list.error,
                    onRetry: list.retry,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "mk-listings-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                            dense: true,
                            ariaLabel: t('marketplace.listings.tableAria'),
                            columns: columns,
                            rows: list.rows,
                            rowKey: (r)=>r.id,
                            onRowActivate: (r)=>go({
                                    listing: r.id
                                }),
                            rowProps: (r)=>({
                                    'data-testid': `mk-listings-row-${r.id}`,
                                    'aria-label': t('marketplace.listings.open', {
                                        title: r.title
                                    })
                                }),
                            empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df8ae1eff5d02c3d$export$2e2bcd8739ae039), {
                                    size: 44,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('marketplace.listings.empty.title'),
                                description: t('marketplace.listings.empty.desc'),
                                "data-testid": "mk-listings-empty"
                            }),
                            "data-testid": "mk-listings-table"
                        }),
                        list.cursor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$5ecaec9f8bdac0eb), {
                            onClick: list.more,
                            pending: list.moreLoading,
                            "data-testid": "mk-listings-more"
                        }) : null
                    ]
                })
            }),
            view.listing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($41803b07642b8433$var$ListingDrawer, {
                listing: selected,
                onClose: ()=>go({
                        listing: ''
                    }),
                onChanged: (next)=>{
                    list.replace((r)=>r.id === next.id, next);
                    list.reload();
                }
            }) : null
        ]
    });
}
function $41803b07642b8433$var$ListingDrawer({ listing: listing, onClose: onClose, onChanged: onChanged }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const kindLabel = (0, $07312e74f48e4df8$export$fd47d6972da0c54a)('marketplace.listings.kind');
    const [action, setAction] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    if (!listing) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$9690426acfcf6a63), {
        onClose: onClose,
        title: t('marketplace.listings.drawer.title'),
        "data-testid": "mk-listing-drawer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$c0904bebf502a0f5), {
            "data-testid": "mk-listing-drawer-missing"
        })
    });
    const actions = $41803b07642b8433$export$3944572e5dc580c3[listing.reviewStatus] || [];
    const open = (decision)=>{
        setError(null);
        setAction({
            key: decision,
            title: t(`marketplace.listings.confirm.${decision}`, {
                title: listing.title
            }),
            body: t(`marketplace.listings.confirm.${decision}Body`),
            confirmLabel: t(`marketplace.listings.actions.${decision}`),
            destructive: decision === 'reject',
            field: decision === 'reject' ? 'rejectNote' : 'note',
            document: (0, $1cdfc8d3d71ea720$export$da00e866db78ce6b),
            variables: (note)=>({
                    clinicId: listing.clinicId,
                    id: listing.id,
                    decision: decision,
                    note: note
                }),
            success: t(`marketplace.listings.success.${decision}`)
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $07312e74f48e4df8$export$9690426acfcf6a63), {
        onClose: onClose,
        title: t('marketplace.listings.drawer.title'),
        sub: listing.vendorSlug ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
            children: listing.vendorSlug
        }) : undefined,
        "data-testid": "mk-listing-drawer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-5",
                children: [
                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "error",
                        "data-testid": "mk-listing-drawer-error",
                        children: t('marketplace.drawer.failed', {
                            message: error
                        })
                    }) : null,
                    listing.sourceInactive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        children: t('marketplace.listings.drawer.sourceInactive')
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                className: "text-base font-bold text-foreground",
                                children: listing.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1 flex flex-wrap items-center gap-2 text-sm text-muted-foreground",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        dir: "auto",
                                        children: listing.vendorName || t('marketplace.listings.unknownVendor')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$fd5345d4562e9833), {
                                        value: listing.reviewStatus,
                                        prefix: "marketplace.listings.review",
                                        "data-testid": "mk-listing-drawer-status"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.drawer.actions')
                            }),
                            actions.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: actions.map((decision)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: decision === 'approve' ? 'default' : 'destructive',
                                        onClick: ()=>open(decision),
                                        "data-testid": `mk-listing-${decision}`,
                                        children: t(`marketplace.listings.actions.${decision}`)
                                    }, decision))
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: t('marketplace.drawer.noActions')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        "data-testid": "mk-listing-drawer-gallery",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.listings.drawer.gallery')
                            }),
                            listing.images?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "grid grid-cols-3 gap-2",
                                children: listing.images.map((img, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: img.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: img.url,
                                            alt: img.alt || t('marketplace.listings.image', {
                                                n: i + 1
                                            }),
                                            className: "aspect-square w-full rounded-lg border border-border object-cover"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex aspect-square w-full items-center justify-center rounded-lg border border-border bg-muted text-muted-foreground",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db2e87076da45383$export$2e2bcd8739ae039), {
                                                size: 20,
                                                "aria-label": t('marketplace.listings.image', {
                                                    n: i + 1
                                                })
                                            })
                                        })
                                    }, img.id))
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: t('marketplace.listings.drawer.noImages')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "grid grid-cols-2 gap-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.listings.columns.kind'),
                                value: kindLabel(listing.kind)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.listings.drawer.productType'),
                                value: listing.productType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                                    children: listing.productType
                                }) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.listings.drawer.price'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                                    rials: listing.priceRial,
                                    currency: listing.currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.listings.drawer.listPrice'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                                    rials: listing.listPriceRial,
                                    currency: listing.currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.listings.columns.submitted'),
                                value: listing.updatedAt ? formatDate(listing.updatedAt) : null
                            }),
                            listing.reviewNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                wide: true,
                                label: t('marketplace.listings.drawer.reviewNote'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "auto",
                                    children: listing.reviewNote
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                wide: true,
                                label: t('marketplace.listings.drawer.description'),
                                value: listing.description ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "auto",
                                    className: "whitespace-pre-line font-normal",
                                    children: listing.description
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-normal text-muted-foreground",
                                    children: t('marketplace.listings.drawer.noDescription')
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$f96b036b4524bebb), {
                action: action,
                testId: "mk-listing-dialog",
                onClose: ()=>setAction(null),
                onError: setError,
                onDone: (d)=>{
                    setError(null);
                    if (d?.reviewMarketplaceListing) onChanged(d.reviewMarketplaceListing);
                }
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1571f1c57333e026$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Banknote", [
    [
        "rect",
        {
            width: "20",
            height: "12",
            x: "2",
            y: "6",
            rx: "2",
            key: "9lu3g6"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ],
    [
        "path",
        {
            d: "M6 12h.01M18 12h.01",
            key: "113zkx"
        }
    ]
]);






const $22345a43e74c21cf$export$ddca288605957f16 = [
    '',
    'open',
    'closed',
    'paid'
];
const $22345a43e74c21cf$export$f12f51f6e19d77e1 = /^\d{4}\/\d{2}$/;
const $22345a43e74c21cf$var$pickSettlements = (d)=>d?.marketplaceSettlementsAdmin;
function $22345a43e74c21cf$export$2e2bcd8739ae039({ view: view, go: go }) {
    const { t: t, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const period = $22345a43e74c21cf$export$f12f51f6e19d77e1.test(view.period) ? view.period : '';
    const list = (0, $07312e74f48e4df8$export$6ee34b00fd42c538)((0, $1cdfc8d3d71ea720$export$712e2250ed1e3997), $22345a43e74c21cf$var$pickSettlements, {
        status: view.sstatus || null,
        period: period || null
    });
    const selected = view.settlement ? list.rows.find((r)=>r.id === view.settlement) : null;
    const filtered = !!(view.sstatus || period);
    // The month field is typed; it narrows once it is a whole "yyyy/mm".
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.period ? formatDigits(view.period) : '');
    const ascii = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(draft).trim();
    const draftInvalid = !!ascii && !$22345a43e74c21cf$export$f12f51f6e19d77e1.test(ascii);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (ascii === (view.period || '') || draftInvalid) return undefined;
        const timer = setTimeout(()=>go({
                period: ascii,
                settlement: ''
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        ascii,
        draftInvalid,
        view.period,
        go
    ]);
    const clear = ()=>{
        setDraft('');
        go({
            sstatus: '',
            period: '',
            settlement: ''
        });
    };
    // Settlements of different stores may be in different currencies. An all-IRR
    // page is exactly what it was; otherwise the headers name no unit and every
    // figure carries its own.
    const unitPerFigure = !(0, $07312e74f48e4df8$export$108b7a54972a94af)(list.rows);
    const amountHeader = (key)=>unitPerFigure ? t(`marketplace.settlements.columnsNoUnit.${key}`) : t(`marketplace.settlements.columns.${key}`);
    const amount = (r, field, className)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
            rials: r[field],
            currency: r.currency,
            withUnit: unitPerFigure,
            className: className
        });
    const columns = [
        {
            key: 'vendor',
            header: t('marketplace.settlements.columns.vendor'),
            render: (r)=>r.vendorName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    className: "font-semibold text-foreground",
                    children: r.vendorName
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: t('marketplace.listings.unknownVendor')
                })
        },
        {
            key: 'period',
            header: t('marketplace.settlements.columns.period'),
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tabular-nums",
                    children: formatDigits(r.period)
                })
        },
        {
            key: 'gross',
            header: amountHeader('gross'),
            align: 'end',
            width: '9rem',
            render: (r)=>amount(r, 'grossRial')
        },
        {
            key: 'commission',
            header: amountHeader('commission'),
            align: 'end',
            width: '9rem',
            render: (r)=>amount(r, 'commissionRial')
        },
        {
            key: 'refunds',
            header: amountHeader('refunds'),
            align: 'end',
            width: '9rem',
            render: (r)=>amount(r, 'refundsRial')
        },
        {
            key: 'net',
            header: amountHeader('net'),
            align: 'end',
            width: '9rem',
            render: (r)=>amount(r, 'netRial', 'font-semibold')
        },
        {
            key: 'status',
            header: t('marketplace.settlements.columns.status'),
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$fd5345d4562e9833), {
                    value: r.status,
                    prefix: "marketplace.settlements.status"
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "mk-settlements",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex flex-wrap items-end gap-3 rounded-lg border border-border bg-card p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                        semantics: "filter",
                        size: "sm",
                        ariaLabel: t('marketplace.settlements.filters.label'),
                        options: $22345a43e74c21cf$export$ddca288605957f16.map((value)=>({
                                value: value,
                                label: t(`marketplace.settlements.filters.${value || 'all'}`)
                            })),
                        value: view.sstatus || '',
                        onChange: (sstatus)=>go({
                                sstatus: sstatus,
                                settlement: ''
                            }),
                        "data-testid": "mk-settlements-filter"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-44",
                        "data-testid": "mk-settlements-period",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                            label: t('marketplace.settlements.period'),
                            value: draft,
                            onChange: (e)=>setDraft(e.target?.value ?? e),
                            dir: "ltr",
                            maxLength: 7,
                            error: draftInvalid ? t('marketplace.settlements.periodInvalid') : undefined
                        })
                    }),
                    filtered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: clear,
                        "data-testid": "mk-settlements-clear",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('common.actions.clearFilters')
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card transition-opacity",
                style: {
                    opacity: list.refreshing ? 0.45 : 1
                },
                "aria-busy": list.refreshing || undefined,
                children: list.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$7afc19c20799c3c1), {
                    cols: 7,
                    label: t('marketplace.settlements.loading'),
                    "data-testid": "mk-settlements-loading"
                }) : list.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('marketplace.settlements.error'),
                    description: list.error,
                    onRetry: list.retry,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "mk-settlements-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "overflow-x-auto",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                            dense: true,
                            ariaLabel: t('marketplace.settlements.tableAria'),
                            columns: columns,
                            rows: list.rows,
                            rowKey: (r)=>r.id,
                            onRowActivate: (r)=>go({
                                    settlement: r.id
                                }),
                            rowProps: (r)=>({
                                    'data-testid': `mk-settlements-row-${r.id}`,
                                    'aria-label': t('marketplace.settlements.open', {
                                        vendor: r.vendorName || t('marketplace.listings.unknownVendor'),
                                        period: formatDigits(r.period)
                                    })
                                }),
                            empty: filtered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                                    size: 44,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('marketplace.settlements.emptyFiltered.title'),
                                description: t('marketplace.settlements.emptyFiltered.desc'),
                                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: clear,
                                    children: t('common.actions.clearFilters')
                                }),
                                "data-testid": "mk-settlements-empty"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1571f1c57333e026$export$2e2bcd8739ae039), {
                                    size: 44,
                                    strokeWidth: 1.5,
                                    "aria-hidden": true
                                }),
                                title: t('marketplace.settlements.empty.title'),
                                description: t('marketplace.settlements.empty.desc'),
                                "data-testid": "mk-settlements-empty"
                            }),
                            "data-testid": "mk-settlements-table"
                        }),
                        list.cursor ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$5ecaec9f8bdac0eb), {
                            onClick: list.more,
                            pending: list.moreLoading,
                            "data-testid": "mk-settlements-more"
                        }) : null
                    ]
                })
            }),
            view.settlement ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($22345a43e74c21cf$var$SettlementDrawer, {
                settlement: selected,
                onClose: ()=>go({
                        settlement: ''
                    }),
                onChanged: (next)=>{
                    list.replace((r)=>r.id === next.id, next);
                    list.reload();
                }
            }) : null
        ]
    });
}
function $22345a43e74c21cf$var$SettlementDrawer({ settlement: settlement, onClose: onClose, onChanged: onChanged }) {
    const { t: t, formatDate: formatDate, formatDigits: formatDigits } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const lineKind = (0, $07312e74f48e4df8$export$fd47d6972da0c54a)('marketplace.settlements.drawer.lineKind');
    const [action, setAction] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    if (!settlement) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$9690426acfcf6a63), {
        onClose: onClose,
        title: t('marketplace.settlements.drawer.title'),
        "data-testid": "mk-settlement-drawer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$c0904bebf502a0f5), {
            "data-testid": "mk-settlement-drawer-missing"
        })
    });
    const vendor = settlement.vendorName || t('marketplace.listings.unknownVendor');
    const period = formatDigits(settlement.period);
    // One settlement is one store's month: one currency. The «(تومان)» labels
    // are right only for IRR; any other currency's figures carry their own code.
    const { currency: currency } = settlement;
    const amountLabel = (key)=>(0, $07312e74f48e4df8$export$d2f719a5670e623a)(currency) ? t(`marketplace.settlements.columns.${key}`) : t(`marketplace.settlements.columnsNoUnit.${key}`);
    const open = (kind)=>{
        setError(null);
        setAction(kind === 'close' ? {
            key: 'close',
            title: t('marketplace.settlements.confirm.close', {
                vendor: vendor,
                period: period
            }),
            body: t('marketplace.settlements.confirm.closeBody'),
            confirmLabel: t('marketplace.settlements.actions.close'),
            field: null,
            document: (0, $1cdfc8d3d71ea720$export$79708f9e88a194e6),
            variables: ()=>({
                    id: settlement.id
                }),
            success: t('marketplace.settlements.success.close')
        } : {
            key: 'markPaid',
            title: t('marketplace.settlements.confirm.markPaid', {
                vendor: vendor,
                period: period
            }),
            body: t('marketplace.settlements.confirm.markPaidBody'),
            confirmLabel: t('marketplace.settlements.actions.markPaid'),
            field: 'reference',
            document: (0, $1cdfc8d3d71ea720$export$d20177dff2c44fc5),
            variables: (reference)=>({
                    id: settlement.id,
                    reference: reference
                }),
            success: t('marketplace.settlements.success.markPaid')
        });
    };
    const lineColumns = [
        {
            key: 'order',
            header: t('marketplace.settlements.drawer.lineColumns.order'),
            render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                    children: l.orderNumber
                })
        },
        {
            key: 'kind',
            header: t('marketplace.settlements.drawer.lineColumns.kind'),
            render: (l)=>lineKind(l.kind)
        },
        {
            key: 'at',
            header: t('marketplace.settlements.drawer.lineColumns.at'),
            render: (l)=>formatDate(l.at)
        },
        {
            key: 'gross',
            header: t('marketplace.settlements.drawer.lineColumns.gross'),
            align: 'end',
            render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                    rials: l.grossRial,
                    currency: currency
                })
        },
        {
            key: 'commission',
            header: t('marketplace.settlements.drawer.lineColumns.commission'),
            align: 'end',
            render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                    rials: l.commissionRial,
                    currency: currency
                })
        },
        {
            key: 'net',
            header: t('marketplace.settlements.drawer.lineColumns.net'),
            align: 'end',
            render: (l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                    rials: l.netRial,
                    currency: currency
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $07312e74f48e4df8$export$9690426acfcf6a63), {
        onClose: onClose,
        title: t('marketplace.settlements.drawer.title'),
        sub: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "tabular-nums",
            children: period
        }),
        "data-testid": "mk-settlement-drawer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-5",
                children: [
                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "error",
                        "data-testid": "mk-settlement-drawer-error",
                        children: t('marketplace.drawer.failed', {
                            message: error
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dir: "auto",
                                className: "text-base font-bold text-foreground",
                                children: vendor
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$fd5345d4562e9833), {
                                value: settlement.status,
                                prefix: "marketplace.settlements.status",
                                "data-testid": "mk-settlement-drawer-status"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.drawer.actions')
                            }),
                            settlement.status === 'open' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: ()=>open('close'),
                                "data-testid": "mk-settlement-close",
                                children: t('marketplace.settlements.actions.close')
                            }) : settlement.status === 'closed' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: ()=>open('markPaid'),
                                "data-testid": "mk-settlement-mark-paid",
                                children: t('marketplace.settlements.actions.markPaid')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: t('marketplace.drawer.noActions')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "grid grid-cols-2 gap-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: amountLabel('gross'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                                    rials: settlement.grossRial,
                                    currency: currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: amountLabel('commission'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                                    rials: settlement.commissionRial,
                                    currency: currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: amountLabel('refunds'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                                    rials: settlement.refundsRial,
                                    currency: currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: amountLabel('net'),
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$6e447984ddf9f65e), {
                                    rials: settlement.netRial,
                                    currency: currency
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.settlements.drawer.paidAt'),
                                value: settlement.paidAt ? formatDate(settlement.paidAt) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.settlements.drawer.reference'),
                                value: settlement.paidReference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                                    children: settlement.paidReference
                                }) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.settlements.drawer.payout'),
                                value: settlement.payoutAccountId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$52f0f02147b12c03), {
                                    children: settlement.payoutAccountId
                                }) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$4b67f8be7a5e4a15), {
                                label: t('marketplace.settlements.drawer.income'),
                                value: settlement.incomePosted ? t('marketplace.settlements.drawer.incomePosted') : t('marketplace.settlements.drawer.incomePending')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "mb-2 text-sm font-bold text-foreground",
                                children: t('marketplace.settlements.drawer.lines')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "overflow-x-auto rounded-lg border border-border",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                    dense: true,
                                    ariaLabel: t('marketplace.settlements.drawer.linesAria'),
                                    columns: lineColumns,
                                    rows: settlement.lines || [],
                                    rowKey: (l)=>l.id,
                                    empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                        title: t('marketplace.settlements.drawer.noLines'),
                                        "data-testid": "mk-settlement-lines-empty"
                                    }),
                                    "data-testid": "mk-settlement-lines"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07312e74f48e4df8$export$f96b036b4524bebb), {
                action: action,
                testId: "mk-settlement-dialog",
                onClose: ()=>setAction(null),
                onError: setError,
                onDone: (d)=>{
                    setError(null);
                    const next = d?.closeMarketplaceSettlement || d?.markMarketplaceSettlementPaid;
                    if (next) onChanged(next);
                }
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $bbdac64a7bcef74d$export$fc230a876245748c(raw) {
    // The Arabic/Persian decimal separator (U+066B), the Arabic comma (U+060C) and
    // the ASCII comma (the French decimal mark, «7,5») all mean a decimal point
    // here: a percentage is never grouped, so a comma can only be a decimal.
    const text = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(String(raw ?? '')).replace(/[\u066B\u060C,]/g, '.').trim();
    if (!text || !/^\d{1,3}(\.\d{1,2})?$/.test(text)) return null;
    const n = Number(text);
    return n >= 0 && n <= 100 ? n : null;
}
function $bbdac64a7bcef74d$var$Card({ title: title, children: children, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "rounded-lg border border-border bg-card p-4",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "mb-3 text-sm font-bold text-foreground",
                children: title
            }),
            children
        ]
    });
}
function $bbdac64a7bcef74d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
        className: "flex flex-col gap-4",
        "aria-label": t('marketplace.settings.title'),
        "data-testid": "mk-settings",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bbdac64a7bcef74d$var$CommissionCard, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bbdac64a7bcef74d$var$CategoriesCard, {})
        ]
    });
}
function $bbdac64a7bcef74d$var$CommissionCard() {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [settings, setSettings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $1cdfc8d3d71ea720$export$1b38368620ec5074)).then((d)=>{
            const s = d?.platformMarketplaceSettings || null;
            setSettings(s);
            // Prefilled in the form NumberInput itself stores — ASCII digits, «.» as
            // the decimal point — never a locale-formatted number: French formats
            // 7.5 as «7,5», which the field's own edit path would not read back.
            setValue(s ? String(s.commissionPct) : '');
        }).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const parsed = $bbdac64a7bcef74d$export$fc230a876245748c(value);
    const dirty = settings && parsed !== settings.commissionPct;
    const invalid = value !== '' && parsed == null;
    const save = async ()=>{
        if (parsed == null || pending) return;
        setPending(true);
        setSaveError(null);
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $1cdfc8d3d71ea720$export$dd9745a8f5df2cab), {
                pct: parsed
            });
            setSettings(d?.setPlatformCommission || settings);
            toast.success(t('marketplace.settings.commission.saved'));
        } catch (e) {
            setSaveError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bbdac64a7bcef74d$var$Card, {
        title: t('marketplace.settings.commission.title'),
        "data-testid": "mk-commission",
        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            role: "status",
            "aria-busy": "true",
            "aria-label": t('marketplace.settings.commission.loading'),
            "data-testid": "mk-commission-loading",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                    width: "60%",
                    height: 14
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                        width: "100%",
                        height: 36
                    })
                })
            ]
        }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('marketplace.settings.commission.error'),
            description: error,
            onRetry: load,
            retryLabel: t('common.actions.retry'),
            "data-testid": "mk-commission-error"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                saveError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    "data-testid": "mk-commission-save-error",
                    children: saveError
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "mk-commission-input",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                        label: t('marketplace.settings.commission.label'),
                        value: value,
                        onChange: (e)=>setValue(e.target?.value ?? e),
                        unit: "%",
                        helperText: t('marketplace.settings.commission.help'),
                        error: invalid ? t('marketplace.settings.commission.invalid') : undefined,
                        disabled: pending
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs text-muted-foreground",
                            children: settings?.updatedAt ? t('marketplace.settings.commission.updatedAt', {
                                date: formatDate(settings.updatedAt)
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            size: "sm",
                            onClick: save,
                            disabled: !dirty || invalid || pending,
                            "aria-busy": pending || undefined,
                            "data-testid": "mk-commission-save",
                            children: t('marketplace.settings.commission.save')
                        })
                    ]
                })
            ]
        })
    });
}
function $bbdac64a7bcef74d$var$CategoriesCard() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { id, name }
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $1cdfc8d3d71ea720$export$289631666dd6bd31)).then((d)=>setRows(d?.marketplaceCategories || [])).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>setLoading(false));
    }, [
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const upsert = async (input, successKey, after)=>{
        setPending(true);
        setSaveError(null);
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $1cdfc8d3d71ea720$export$87f87226598659d5), {
                input: input
            });
            const saved = d?.upsertMarketplaceCategory;
            if (saved) setRows((r)=>r.some((c)=>c.id === saved.id) ? r.map((c)=>c.id === saved.id ? saved : c) : [
                    ...r,
                    saved
                ]);
            toast.success(t(successKey));
            after();
        } catch (e) {
            setSaveError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const add = ()=>{
        const name = draft.trim();
        if (!name) return;
        const sortOrder = rows.reduce((m, c)=>Math.max(m, c.sortOrder), 0) + 1;
        upsert({
            name: name,
            sortOrder: sortOrder
        }, 'marketplace.settings.categories.added', ()=>setDraft(''));
    };
    const rename = ()=>{
        const name = editing?.name.trim();
        const original = rows.find((c)=>c.id === editing?.id);
        if (!name || !original) return;
        upsert({
            id: original.id,
            name: name,
            parentId: original.parentId,
            sortOrder: original.sortOrder
        }, 'marketplace.settings.categories.renamed', ()=>setEditing(null));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bbdac64a7bcef74d$var$Card, {
        title: t('marketplace.settings.categories.title'),
        "data-testid": "mk-categories",
        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "status",
            "aria-busy": "true",
            "aria-label": t('marketplace.settings.categories.loading'),
            "data-testid": "mk-categories-loading",
            children: [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                        width: `${80 - i * 15}%`,
                        height: 14
                    })
                }, i))
        }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('marketplace.settings.categories.error'),
            description: error,
            onRetry: load,
            retryLabel: t('common.actions.retry'),
            "data-testid": "mk-categories-error"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-3",
            children: [
                saveError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    "data-testid": "mk-categories-save-error",
                    children: saveError
                }) : null,
                rows.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    "aria-label": t('marketplace.settings.categories.aria'),
                    className: "flex flex-col divide-y divide-border",
                    "data-testid": "mk-categories-list",
                    children: rows.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                            className: "flex items-center gap-2 py-1.5",
                            "data-testid": `mk-category-${c.id}`,
                            children: editing?.id === c.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "min-w-0 flex-1",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                            label: t('marketplace.settings.categories.nameLabel'),
                                            value: editing.name,
                                            onChange: (e)=>setEditing({
                                                    ...editing,
                                                    name: e.target?.value ?? e
                                                }),
                                            maxLength: 80,
                                            disabled: pending
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        onClick: rename,
                                        disabled: pending || !editing.name.trim() || editing.name.trim() === c.name,
                                        "data-testid": `mk-category-${c.id}-save`,
                                        children: t('marketplace.settings.categories.save')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "ghost",
                                        onClick: ()=>setEditing(null),
                                        disabled: pending,
                                        children: t('marketplace.settings.categories.cancel')
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        dir: "auto",
                                        className: "min-w-0 flex-1 truncate text-sm text-foreground",
                                        children: c.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "ghost",
                                        onClick: ()=>{
                                            setSaveError(null);
                                            setEditing({
                                                id: c.id,
                                                name: c.name
                                            });
                                        },
                                        "aria-label": t('marketplace.settings.categories.rename', {
                                            name: c.name
                                        }),
                                        "data-testid": `mk-category-${c.id}-rename`,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                            size: 14,
                                            "aria-hidden": true
                                        })
                                    })
                                ]
                            })
                        }, c.id))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-sm text-muted-foreground",
                    "data-testid": "mk-categories-empty",
                    children: t('marketplace.settings.categories.empty')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex items-end gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "min-w-0 flex-1",
                            "data-testid": "mk-categories-new",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('marketplace.settings.categories.nameLabel'),
                                placeholder: t('marketplace.settings.categories.newPlaceholder'),
                                value: draft,
                                onChange: (e)=>setDraft(e.target?.value ?? e),
                                maxLength: 80,
                                disabled: pending
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            size: "sm",
                            variant: "outline",
                            onClick: add,
                            disabled: pending || !draft.trim(),
                            "data-testid": "mk-categories-add",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('marketplace.settings.categories.add')
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


const $0c03978b3e0593cd$export$50bf86b71c5fd0d9 = [
    'vendors',
    'listings',
    'settlements'
];
/**
 * The URL contract. `status` is shared by vendors and listings (each view
 * validates its own values); settlements use `sstatus` because «باز» is not a
 * review state. Defaults are absent from the address.
 */ const $0c03978b3e0593cd$var$SCHEMA = {
    view: {
        default: 'vendors',
        values: $0c03978b3e0593cd$export$50bf86b71c5fd0d9
    },
    status: {
        default: '',
        values: [
            '',
            ...new Set([
                ...(0, $5ef4a68932f09af5$export$33b242c82e5c0bc9),
                ...(0, $41803b07642b8433$export$ea28eaee9bce13a8)
            ])
        ]
    },
    sstatus: {
        default: '',
        values: (0, $22345a43e74c21cf$export$ddca288605957f16)
    },
    period: {
        default: ''
    },
    vendor: {
        default: ''
    },
    listing: {
        default: ''
    },
    settlement: {
        default: ''
    }
};
/** What a view owns; switching views clears it. */ const $0c03978b3e0593cd$var$VIEW_LOCAL = {
    status: '',
    sstatus: '',
    period: '',
    vendor: '',
    listing: '',
    settlement: ''
};
function $0c03978b3e0593cd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.marketplace');
    const [view, setView] = (0, $e77179a3ce65222f$export$6a582373474709af)($0c03978b3e0593cd$var$SCHEMA);
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch)=>setView(patch), [
        setView
    ]);
    const changeView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (next !== view.view) setView({
            ...$0c03978b3e0593cd$var$VIEW_LOCAL,
            view: next
        });
    }, [
        setView,
        view.view
    ]);
    $0c03978b3e0593cd$export$50bf86b71c5fd0d9.forEach((name, i)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)(String(i + 1), ()=>changeView(name), {
            label: t('shortcuts.action.view', {
                view: t(`marketplace.views.${name}`)
            }),
            group: t('shortcuts.groups.marketplace')
        });
    });
    // A listing status the vendors view does not know (and vice versa) is junk.
    const scoped = {
        ...view,
        status: view.view === 'vendors' ? (0, $5ef4a68932f09af5$export$33b242c82e5c0bc9).includes(view.status) ? view.status : '' : (0, $41803b07642b8433$export$ea28eaee9bce13a8).includes(view.status) ? view.status : ''
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative flex h-full flex-col bg-background",
        "data-testid": "marketplace",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('marketplace.title'),
                sub: t('marketplace.sub'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                    semantics: "tabs",
                    size: "sm",
                    ariaLabel: t('marketplace.views.label'),
                    options: $0c03978b3e0593cd$export$50bf86b71c5fd0d9.map((value)=>({
                            value: value,
                            label: t(`marketplace.views.${value}`)
                        })),
                    value: view.view,
                    onChange: changeView,
                    "data-testid": "marketplace-tabs"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto grid w-full max-w-[1440px] gap-6 xl:grid-cols-[minmax(0,1fr)_20rem]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            role: "tabpanel",
                            "aria-label": t(`marketplace.views.${view.view}`),
                            className: "min-w-0",
                            "data-testid": `marketplace-panel-${view.view}`,
                            children: view.view === 'vendors' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ef4a68932f09af5$export$2e2bcd8739ae039), {
                                view: scoped,
                                go: go
                            }) : view.view === 'listings' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41803b07642b8433$export$2e2bcd8739ae039), {
                                view: scoped,
                                go: go
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22345a43e74c21cf$export$2e2bcd8739ae039), {
                                view: scoped,
                                go: go
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bbdac64a7bcef74d$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $8b78587e05097331$var$__defProp = Object.defineProperty;
var $8b78587e05097331$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8b78587e05097331$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8b78587e05097331$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8b78587e05097331$var$__defNormalProp = (obj, key, value)=>key in obj ? $8b78587e05097331$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8b78587e05097331$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8b78587e05097331$var$__hasOwnProp.call(b, prop)) $8b78587e05097331$var$__defNormalProp(a, prop, b[prop]);
    if ($8b78587e05097331$var$__getOwnPropSymbols) {
        for (var prop of $8b78587e05097331$var$__getOwnPropSymbols(b))if ($8b78587e05097331$var$__propIsEnum.call(b, prop)) $8b78587e05097331$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8b78587e05097331$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8b78587e05097331$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8b78587e05097331$var$__getOwnPropSymbols) {
        for (var prop of $8b78587e05097331$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8b78587e05097331$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $8b78587e05097331$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class _QrCode {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        // Modified to expose modules for easy access
        getModules() {
            return this.modules;
        }
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
    _QrCode.MIN_VERSION = 1;
    // The maximum version number supported in the QR Code Model 2 standard.
    _QrCode.MAX_VERSION = 40;
    // For use in getPenaltyScore(), when evaluating which mask is best.
    _QrCode.PENALTY_N1 = 3;
    _QrCode.PENALTY_N2 = 3;
    _QrCode.PENALTY_N3 = 40;
    _QrCode.PENALTY_N4 = 10;
    _QrCode.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Low
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        // Medium
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Quartile
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    _QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        // Low
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        // Medium
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        // Quartile
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    let QrCode = _QrCode;
    qrcodegen2.QrCode = _QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class _QrSegment {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        getData() {
            return this.bitData.slice();
        }
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        }
    };
    /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
    _QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    // Describes precisely all strings that are encodable in alphanumeric mode.
    _QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    // The set of all legal characters in alphanumeric mode,
    // where each character value maps to the index in the string.
    _QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    let QrSegment = _QrSegment;
    qrcodegen2.QrSegment = _QrSegment;
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class _Ecc {
            // The QR Code can tolerate about 30% erroneous codewords
            /*-- Constructor and fields --*/ constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        /*-- Constants --*/ _Ecc.LOW = new _Ecc(0, 1);
        // The QR Code can tolerate about  7% erroneous codewords
        _Ecc.MEDIUM = new _Ecc(1, 0);
        // The QR Code can tolerate about 15% erroneous codewords
        _Ecc.QUARTILE = new _Ecc(2, 3);
        // The QR Code can tolerate about 25% erroneous codewords
        _Ecc.HIGH = new _Ecc(3, 2);
        let Ecc = _Ecc;
        QrCode2.Ecc = _Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class _Mode {
            /*-- Constructor and fields --*/ constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        /*-- Constants --*/ _Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        _Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        _Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        _Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        _Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        let Mode = _Mode;
        QrSegment2.Mode = _Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($8b78587e05097331$var$qrcodegen || ($8b78587e05097331$var$qrcodegen = {}));
var $8b78587e05097331$var$qrcodegen_default = $8b78587e05097331$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $8b78587e05097331$var$ERROR_LEVEL_MAP = {
    L: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $8b78587e05097331$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $8b78587e05097331$var$DEFAULT_SIZE = 128;
var $8b78587e05097331$var$DEFAULT_LEVEL = "L";
var $8b78587e05097331$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $8b78587e05097331$var$DEFAULT_FGCOLOR = "#000000";
var $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN = false;
var $8b78587e05097331$var$DEFAULT_MINVERSION = 1;
var $8b78587e05097331$var$SPEC_MARGIN_SIZE = 4;
var $8b78587e05097331$var$DEFAULT_MARGIN_SIZE = 0;
var $8b78587e05097331$var$DEFAULT_IMG_SCALE = 0.1;
function $8b78587e05097331$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $8b78587e05097331$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $8b78587e05097331$var$getImageSettings(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $8b78587e05097331$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    const opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    const crossOrigin = imageSettings.crossOrigin;
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation,
        opacity: opacity,
        crossOrigin: crossOrigin
    };
}
function $8b78587e05097331$var$getMarginSize(includeMargin, marginSize) {
    if (marginSize != null) return Math.max(Math.floor(marginSize), 0);
    return includeMargin ? $8b78587e05097331$var$SPEC_MARGIN_SIZE : $8b78587e05097331$var$DEFAULT_MARGIN_SIZE;
}
function $8b78587e05097331$var$useQRCode({ value: value, level: level, minVersion: minVersion, includeMargin: includeMargin, marginSize: marginSize, imageSettings: imageSettings, size: size, boostLevel: boostLevel }) {
    let qrcode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        const segments = values.reduce((accum, v)=>{
            accum.push(...$8b78587e05097331$var$qrcodegen_default.QrSegment.makeSegments(v));
            return accum;
        }, []);
        return $8b78587e05097331$var$qrcodegen_default.QrCode.encodeSegments(segments, $8b78587e05097331$var$ERROR_LEVEL_MAP[level], minVersion, void 0, void 0, boostLevel);
    }, [
        value,
        level,
        minVersion,
        boostLevel
    ]);
    const { cells: cells, margin: margin, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        let cells2 = qrcode.getModules();
        const margin2 = $8b78587e05097331$var$getMarginSize(includeMargin, marginSize);
        const numCells2 = cells2.length + margin2 * 2;
        const calculatedImageSettings2 = $8b78587e05097331$var$getImageSettings(cells2, size, margin2, imageSettings);
        return {
            cells: cells2,
            margin: margin2,
            numCells: numCells2,
            calculatedImageSettings: calculatedImageSettings2
        };
    }, [
        qrcode,
        size,
        imageSettings,
        includeMargin,
        marginSize
    ]);
    return {
        qrcode: qrcode,
        margin: margin,
        cells: cells,
        numCells: numCells,
        calculatedImageSettings: calculatedImageSettings
    };
}
var $8b78587e05097331$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var $8b78587e05097331$export$7e3713cf0c0fe9d0 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function QRCodeCanvas2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $8b78587e05097331$var$DEFAULT_SIZE, level: level = $8b78587e05097331$var$DEFAULT_LEVEL, bgColor: bgColor = $8b78587e05097331$var$DEFAULT_BGCOLOR, fgColor: fgColor = $8b78587e05097331$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $8b78587e05097331$var$DEFAULT_MINVERSION, boostLevel: boostLevel, marginSize: marginSize, imageSettings: imageSettings } = _a, extraProps = $8b78587e05097331$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "marginSize",
        "imageSettings"
    ]);
    const _b = extraProps, { style: style } = _b, otherProps = $8b78587e05097331$var$__objRest(_b, [
        "style"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const _image = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const setCanvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((node)=>{
        _canvas.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef
    ]);
    const [isImgLoaded, setIsImageLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $8b78587e05097331$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cellsToDraw = cells;
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cellsToDraw = $8b78587e05097331$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($8b78587e05097331$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($8b78587e05097331$var$generatePath(cellsToDraw, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (calculatedImageSettings) ctx.globalAlpha = calculatedImageSettings.opacity;
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $8b78587e05097331$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image,
        crossOrigin: calculatedImageSettings == null ? void 0 : calculatedImageSettings.crossOrigin
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", $8b78587e05097331$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: setCanvasRef,
        role: "img"
    }, otherProps)), img);
});
$8b78587e05097331$export$7e3713cf0c0fe9d0.displayName = "QRCodeCanvas";
var $8b78587e05097331$export$10307208e61210e9 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function QRCodeSVG2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $8b78587e05097331$var$DEFAULT_SIZE, level: level = $8b78587e05097331$var$DEFAULT_LEVEL, bgColor: bgColor = $8b78587e05097331$var$DEFAULT_BGCOLOR, fgColor: fgColor = $8b78587e05097331$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $8b78587e05097331$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $8b78587e05097331$var$DEFAULT_MINVERSION, boostLevel: boostLevel, title: title, marginSize: marginSize, imageSettings: imageSettings } = _a, otherProps = $8b78587e05097331$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "title",
        "marginSize",
        "imageSettings"
    ]);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $8b78587e05097331$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    let cellsToDraw = cells;
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cellsToDraw = $8b78587e05097331$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("image", {
            href: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none",
            opacity: calculatedImageSettings.opacity,
            crossOrigin: calculatedImageSettings.crossOrigin
        });
    }
    const fgPath = $8b78587e05097331$var$generatePath(cellsToDraw, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $8b78587e05097331$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`,
        ref: forwardedRef,
        role: "img"
    }, otherProps), !!title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
});
$8b78587e05097331$export$10307208e61210e9.displayName = "QRCodeSVG";


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $78d86622bf08f9a7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("QrCode", [
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "3",
            rx: "1",
            key: "1tu5fj"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "16",
            y: "3",
            rx: "1",
            key: "1v8r4q"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "1x03jg"
        }
    ],
    [
        "path",
        {
            d: "M21 16h-3a2 2 0 0 0-2 2v3",
            key: "177gqh"
        }
    ],
    [
        "path",
        {
            d: "M21 21v.01",
            key: "ents32"
        }
    ],
    [
        "path",
        {
            d: "M12 7v3a2 2 0 0 1-2 2H7",
            key: "8crl2c"
        }
    ],
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M12 3h.01",
            key: "n36tog"
        }
    ],
    [
        "path",
        {
            d: "M12 16v.01",
            key: "133mhm"
        }
    ],
    [
        "path",
        {
            d: "M16 12h1",
            key: "1slzba"
        }
    ],
    [
        "path",
        {
            d: "M21 12v.01",
            key: "1lwtk9"
        }
    ],
    [
        "path",
        {
            d: "M12 21v-1",
            key: "1880an"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8695263a8c6cd2c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Smartphone", [
    [
        "rect",
        {
            width: "14",
            height: "20",
            x: "5",
            y: "2",
            rx: "2",
            ry: "2",
            key: "1yt0o3"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ]
]);







// «واتس‌اپ پارسینا» — the company number's link state, and the two things an
// operator may do to it.
//
// The pairing conversation is NOT here: codes rotate every ~20 seconds and the
// link completes on the gateway's own socket, so it is streamed from
// `GET /integrations/whatsapp/pairing` and read by the kit's
// `useWhatsappPairing`. A code carried on a query would be dead before it
// rendered.
const $de0df10ef0555958$export$556350d13dc6293b = `
  query PlatformWhatsappSession {
    platformWhatsappSession {
      accountId
      state
      phone
      deviceLabel
      linkedAt
      detail
      sentLastHour
      maxPerHour
      sendDisabled
      configured
    }
  }
`;
const $de0df10ef0555958$export$c7f8735327da61a4 = `
  mutation UnlinkPlatformWhatsapp {
    unlinkPlatformWhatsapp
  }
`;
const $de0df10ef0555958$export$af083861359c27c1 = `
  mutation SendPlatformWhatsappTest($phone: String!) {
    sendPlatformWhatsappTest(phone: $phone) {
      sent
      detail
    }
  }
`;
const $de0df10ef0555958$export$ecb9fb9a825220fd = '/integrations/whatsapp/pairing';


function $8b6cc7b7fc97d4bc$export$2e2bcd8739ae039() {
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.whatsapp');
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [method, setMethod] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('QR');
    const [phone, setPhone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [startError, setStartError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [confirmUnlink, setConfirmUnlink] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const loadSession = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>(await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $de0df10ef0555958$export$556350d13dc6293b)))?.platformWhatsappSession || null, []);
    const unlinkSession = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $de0df10ef0555958$export$c7f8735327da61a4));
    }, []);
    const { session: session, loading: loading, error: error, pairing: pairing, refetch: refetch, startLink: startLink, stopPairing: stopPairing, unlink: unlink } = (0, $1cf0083ab82acba7$export$8f772b88f40431ca)({
        pairingUrl: `${(0, $d87bd335296b449f$export$60d50aa713e44074)}${(0, $de0df10ef0555958$export$ecb9fb9a825220fd)}`,
        getToken: $3bdb28763df76ec7$export$257b2d10b709d8ef,
        loadSession: loadSession,
        unlinkSession: unlinkSession
    });
    const configured = session?.configured !== false;
    const state = session?.state || 'UNSPECIFIED';
    const linked = state === 'CONNECTED' || state === 'DISCONNECTED';
    const begin = async (nextMethod)=>{
        setStartError(null);
        const typed = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(phone).replace(/[^\d+]/g, '');
        if (nextMethod === 'PAIRING_CODE' && !typed) {
            setStartError(t('whatsapp.link.phoneRequired'));
            return;
        }
        setMethod(nextMethod);
        try {
            await startLink(nextMethod, nextMethod === 'PAIRING_CODE' ? typed : '');
        } catch (err) {
            // `serverMessage` ONLY, never `err.message`. The BFF's sentence when it has
            // one — it knows whether this was a missing permission or an unreachable
            // gateway, and the screen does not — and our own catalogue otherwise.
            // Rendering `err.message` is how the browser's «signal is aborted without
            // reason» once reached an operator on a Persian page (kit v0.18.14).
            setStartError(err?.serverMessage || t('whatsapp.link.failed'));
        }
    };
    const doUnlink = async ()=>{
        setConfirmUnlink(false);
        setBusy(true);
        try {
            await unlink();
            toast.success(t('whatsapp.unlink.done'));
        } catch (err) {
            toast.error((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(err, t));
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4",
        "data-testid": "wa-screen",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('whatsapp.title'),
                sub: t('whatsapp.subtitle')
            }),
            !configured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                "data-testid": "wa-not-configured",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        className: "block",
                        children: t('whatsapp.notConfigured.title')
                    }),
                    t('whatsapp.notConfigured.body')
                ]
            }),
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                lines: 4
            }),
            !loading && error && !session && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('whatsapp.errors.load'),
                description: (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(error, t),
                onRetry: refetch,
                retryLabel: t('common.actions.retry'),
                "data-testid": "wa-error"
            }),
            !loading && session && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "flex flex-col gap-4 rounded-lg border border-border bg-card p-4",
                "data-testid": "wa-card",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "flex flex-wrap items-center justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: $8b6cc7b7fc97d4bc$var$badgeVariant(state),
                                        "data-testid": "wa-state",
                                        children: t(`whatsapp.state.${state}`)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-muted-foreground",
                                        dir: "ltr",
                                        children: t('whatsapp.account', {
                                            account: session.accountId
                                        })
                                    })
                                ]
                            }),
                            linked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                onClick: ()=>setConfirmUnlink(true),
                                disabled: busy,
                                "data-testid": "wa-unlink",
                                children: t('whatsapp.unlink.action')
                            })
                        ]
                    }),
                    (state === 'DISCONNECTED' || state === 'LOGGED_OUT' || state === 'UNSPECIFIED') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: state === 'DISCONNECTED' ? 'info' : 'warning',
                        "data-testid": "wa-hint",
                        children: session.detail || t(`whatsapp.hint.${state}`)
                    }),
                    session.sendDisabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        "data-testid": "wa-send-disabled",
                        children: t('whatsapp.session.sendDisabled')
                    }),
                    linked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "grid grid-cols-1 gap-3 text-sm sm:grid-cols-2",
                        "data-testid": "wa-facts",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$var$Fact, {
                                label: t('whatsapp.session.phone'),
                                value: session.phone,
                                ltr: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$var$Fact, {
                                label: t('whatsapp.session.device'),
                                value: session.deviceLabel
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$var$Fact, {
                                label: t('whatsapp.session.linkedAt'),
                                value: session.linkedAt ? formatDate(session.linkedAt) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$var$Fact, {
                                label: t('whatsapp.session.hourly'),
                                value: t('whatsapp.session.hourlyValue', {
                                    sent: formatNumber(session.sentLastHour || 0),
                                    max: formatNumber(session.maxPerHour || 0)
                                })
                            })
                        ]
                    }),
                    configured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$var$LinkPanel, {
                        t: t,
                        state: state,
                        pairing: pairing,
                        method: method,
                        phone: phone,
                        onPhone: setPhone,
                        onBegin: begin,
                        onStop: ()=>{
                            stopPairing();
                            setStartError(null);
                        },
                        error: startError || (error ? (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(error, t) : null)
                    })
                ]
            }),
            linked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$var$TestSend, {
                t: t,
                toast: toast
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirmUnlink,
                onOpenChange: setConfirmUnlink,
                title: t('whatsapp.unlink.confirmTitle'),
                description: t('whatsapp.unlink.confirmBody'),
                confirmLabel: t('whatsapp.unlink.action'),
                cancelLabel: t('common.actions.cancel'),
                onConfirm: doUnlink,
                destructive: true
            })
        ]
    });
}
function $8b6cc7b7fc97d4bc$var$Fact({ label: label, value: value, ltr: ltr }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                className: "text-xs text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                className: "font-medium text-foreground",
                dir: ltr ? 'ltr' : undefined,
                children: value || "\u2014"
            })
        ]
    });
}
/**
 * Starting, showing and abandoning a link attempt.
 *
 * `CONNECTING` is its own state and not a spinner on the button: the first code
 * can take a second or two to arrive from WhatsApp, and a button that merely
 * looks busy invites a second press — which aborts the first attempt and opens
 * yet another device.
 */ function $8b6cc7b7fc97d4bc$var$LinkPanel({ t: t, state: state, pairing: pairing, method: method, phone: phone, onPhone: onPhone, onBegin: onBegin, onStop: onStop, error: error }) {
    const live = !!pairing;
    const showQr = pairing?.kind === 'QR' && pairing.code;
    const showCode = pairing?.kind === 'PAIRING_CODE' && pairing.code;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        "data-testid": "wa-link",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                "data-testid": "wa-link-error",
                children: error
            }),
            !live && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: ()=>onBegin('QR'),
                                "data-testid": "wa-start-qr",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d86622bf08f9a7$export$2e2bcd8739ae039), {
                                        className: "size-4",
                                        "aria-hidden": true
                                    }),
                                    state === 'UNLINKED' ? t('whatsapp.link.start') : t('whatsapp.link.relink'),
                                    " \xb7 ",
                                    t('whatsapp.link.qrTab')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                onClick: ()=>onBegin('PAIRING_CODE'),
                                "data-testid": "wa-start-code",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8695263a8c6cd2c2$export$2e2bcd8739ae039), {
                                        className: "size-4",
                                        "aria-hidden": true
                                    }),
                                    t('whatsapp.link.codeTab')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('whatsapp.link.phoneLabel'),
                        placeholder: t('whatsapp.link.phonePlaceholder'),
                        value: phone,
                        onChange: (e)=>onPhone(e.target.value),
                        dir: "ltr",
                        "data-testid": "wa-phone"
                    })
                ]
            }),
            live && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-center gap-3 rounded-lg border border-border p-4",
                children: [
                    pairing.kind === 'CONNECTING' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-muted-foreground",
                        "data-testid": "wa-connecting",
                        children: t('whatsapp.link.connecting')
                    }),
                    showQr && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rounded-md bg-white p-3",
                                "data-testid": "wa-qr",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b78587e05097331$export$10307208e61210e9), {
                                    value: pairing.code,
                                    size: 220,
                                    includeMargin: false
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-center text-xs text-muted-foreground",
                                children: t('whatsapp.link.qrHint')
                            })
                        ]
                    }),
                    showCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "select-all font-mono text-3xl font-bold tracking-[0.25em] text-foreground",
                                dir: "ltr",
                                "data-testid": "wa-code",
                                children: pairing.code
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-center text-xs text-muted-foreground",
                                children: t('whatsapp.link.codeHint')
                            })
                        ]
                    }),
                    pairing.kind === 'TIMEOUT' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-foreground",
                        "data-testid": "wa-timeout",
                        children: pairing.message || t('whatsapp.link.timeout')
                    }),
                    pairing.expiresAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b6cc7b7fc97d4bc$export$53819c0e58f98d49, {
                        t: t,
                        expiresAt: pairing.expiresAt
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        onClick: onStop,
                        "data-testid": "wa-cancel",
                        children: t('whatsapp.link.cancel')
                    })
                ]
            })
        ]
    });
}
function $8b6cc7b7fc97d4bc$export$53819c0e58f98d49({ t: t, expiresAt: expiresAt }) {
    const left = ()=>Math.max(0, Math.round((Date.parse(expiresAt) - Date.now()) / 1000));
    const [seconds, setSeconds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(left);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setSeconds(left());
        const timer = setInterval(()=>setSeconds(left()), 1000);
        return ()=>clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expiresAt
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "text-xs text-muted-foreground",
        "data-testid": "wa-countdown",
        children: seconds > 0 ? t('whatsapp.link.expiresIn', {
            seconds: seconds
        }) : t('whatsapp.link.expired')
    });
}
/**
 * One message to a number the operator types.
 *
 * This is how the link is proved. Without it the first real message this number
 * ever sends goes to a doctor who just signed up, and an operator has no way to
 * find out beforehand that the session is linked but the number is, say, banned.
 */ function $8b6cc7b7fc97d4bc$var$TestSend({ t: t, toast: toast }) {
    const [phone, setPhone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const send = async ()=>{
        const typed = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(phone).replace(/[^\d+]/g, '');
        if (!typed || pending) return;
        setPending(true);
        try {
            const data = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $de0df10ef0555958$export$af083861359c27c1), {
                phone: typed
            });
            const res = data?.sendPlatformWhatsappTest;
            if (res?.sent) toast.success(t('whatsapp.test.sent'));
            else toast.error(res?.detail || t('whatsapp.link.failed'));
        } catch (err) {
            toast.error((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(err, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-3 rounded-lg border border-border bg-card p-4",
        "data-testid": "wa-test",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-sm font-bold text-foreground",
                        children: t('whatsapp.test.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "mt-1 text-xs text-muted-foreground",
                        children: t('whatsapp.test.body')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-end gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "min-w-56 flex-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                            label: t('whatsapp.test.phoneLabel'),
                            placeholder: t('whatsapp.link.phonePlaceholder'),
                            value: phone,
                            onChange: (e)=>setPhone(e.target.value),
                            dir: "ltr",
                            "data-testid": "wa-test-phone"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: send,
                        disabled: pending || !phone.trim(),
                        "data-testid": "wa-test-send",
                        children: t('whatsapp.test.send')
                    })
                ]
            })
        ]
    });
}
function $8b6cc7b7fc97d4bc$var$badgeVariant(state) {
    if (state === 'CONNECTED') return 'success';
    if (state === 'DISCONNECTED') return 'warning';
    if (state === 'LOGGED_OUT') return 'destructive';
    return 'outline';
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3c35b0991cad9668$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ExternalLink", [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
]);










/**
 * Every GraphQL document the «صفحات پزشکان» screen sends, built against the
 * contract in `parsina.bff.admin/src/graphql/typeDefs/doctorPage.js`. One file,
 * so a contract change is a diff against one place and a test can match a call
 * by its operation name.
 *
 * Timestamps are ISO-8601 strings; `null` means "never" (never published,
 * never suspended).
 */ const $e57337e272a1b908$var$PAGE_FIELDS = `
  pageId slug status displayName councilNumber specialty
  publishedAt updatedAt suspendedReason suspendedBy suspendedAt publicUrl
`;
const $e57337e272a1b908$export$933eba7e22cb5441 = `
  query DoctorPages($status: String, $query: String, $limit: Int, $offset: Int) {
    doctorPages(status: $status, query: $query, limit: $limit, offset: $offset) {
      total
      pages { ${$e57337e272a1b908$var$PAGE_FIELDS} }
    }
  }
`;
const $e57337e272a1b908$export$d8b4897d7aac1623 = `
  mutation SuspendDoctorPage($pageId: ID!, $reason: String!) {
    suspendDoctorPage(pageId: $pageId, reason: $reason) { ${$e57337e272a1b908$var$PAGE_FIELDS} }
  }
`;
const $e57337e272a1b908$export$8e74c791033242ae = `
  mutation RestoreDoctorPage($pageId: ID!) {
    restoreDoctorPage(pageId: $pageId) { ${$e57337e272a1b908$var$PAGE_FIELDS} }
  }
`;



parcelRequire("acw62");



const $8d78f9df46b9c862$export$c3bf375920040a8d = [
    'published',
    'suspended',
    'unpublished',
    'draft'
];
const $8d78f9df46b9c862$export$6e7522bf44b266d = 50;
const $8d78f9df46b9c862$export$2e4e357314362f35 = 3;
const $8d78f9df46b9c862$export$e0eeef539779b73 = 500;
const $8d78f9df46b9c862$export$a56d5ee60e3d04c9 = {
    published: 'suspend',
    unpublished: 'suspend',
    suspended: 'restore',
    draft: null
};
const $8d78f9df46b9c862$export$8e622f92e44f6a61 = (status)=>$8d78f9df46b9c862$export$a56d5ee60e3d04c9[status] || null;
const $8d78f9df46b9c862$var$TONE = {
    published: 'success',
    unpublished: 'outline',
    draft: 'outline',
    suspended: 'destructive'
};
function $8d78f9df46b9c862$export$850ca4af769310({ status: status, 'data-testid': testId }) {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!status) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    const key = `doctorPages.status.${status}`;
    const label = has && has(key) ? t(key) : String(status);
    const tone = $8d78f9df46b9c862$var$TONE[status] || 'outline';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: tone,
        "data-tone": tone,
        "data-testid": testId,
        children: label
    });
}




var $acw62 = parcelRequire("acw62");




function $6f95975fd0d57cfa$export$2e2bcd8739ae039({ page: page, pending: pending, error: error, onOpenChange: onOpenChange, onSubmit: onSubmit }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setReason('');
        setTouched(false);
    }, [
        page?.pageId
    ]);
    const trimmed = reason.trim();
    const invalid = trimmed.length < (0, $8d78f9df46b9c862$export$2e4e357314362f35);
    const name = page?.displayName || page?.slug || '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: !!page,
        onOpenChange: onOpenChange,
        title: t('doctorPages.suspend.title', {
            name: name
        }),
        error: error,
        pending: pending,
        dirty: !!reason,
        submitLabel: t('doctorPages.suspend.submit'),
        submitVariant: "destructive",
        submitDisabled: invalid,
        onSubmit: ()=>{
            setTouched(true);
            if (!invalid) onSubmit({
                reason: trimmed
            });
        },
        "data-testid": "doctor-pages-suspend",
        lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
            variant: "error",
            children: t('doctorPages.suspend.warning')
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": "doctor-pages-suspend-reason",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('doctorPages.suspend.reason'),
                required: true,
                helperText: t('doctorPages.suspend.reasonHelp'),
                value: reason,
                onChange: (e)=>setReason(e.target?.value ?? e),
                onBlur: ()=>setTouched(true),
                placeholder: t('doctorPages.suspend.reasonPlaceholder'),
                error: touched && reason && invalid ? t('validation.tooShort', {
                    min: (0, $8d78f9df46b9c862$export$2e4e357314362f35)
                }) : undefined,
                maxLength: (0, $8d78f9df46b9c862$export$e0eeef539779b73),
                showCount: true,
                rows: 3,
                disabled: pending
            })
        })
    });
}


/** The URL contract (DESIGN_CONCEPT §3.2). Defaults are absent from the address. */ const $9d4de09da3da4fb2$var$SCHEMA = {
    status: {
        default: '',
        values: [
            '',
            ...(0, $8d78f9df46b9c862$export$c3bf375920040a8d)
        ]
    },
    q: {
        default: ''
    },
    page: {
        default: 1,
        parse: (raw)=>Number(raw) || 1
    }
};
function $9d4de09da3da4fb2$export$d059234ff699c09d(view, pageSize = (0, $8d78f9df46b9c862$export$6e7522bf44b266d)) {
    const q = String(view?.q || '').trim();
    const page = Math.max(1, Number(view?.page) || 1);
    return {
        status: view?.status || '',
        query: q.length >= (0, $cdf3712044ab22f9$export$d6920ac008449896) ? q.slice(0, 120) : '',
        limit: pageSize,
        offset: (page - 1) * pageSize
    };
}
function $9d4de09da3da4fb2$export$2e2bcd8739ae039() {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.doctorPages');
    const [view, setView, resetView] = (0, $e77179a3ce65222f$export$6a582373474709af)($9d4de09da3da4fb2$var$SCHEMA);
    const variables = $9d4de09da3da4fb2$export$d059234ff699c09d(view);
    const key = JSON.stringify(variables);
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loaded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        return (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e57337e272a1b908$export$933eba7e22cb5441), JSON.parse(key)).then((d)=>{
            setData(d?.doctorPages || {
                pages: [],
                total: 0
            });
            loaded.current = true;
        }).catch((e)=>setError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t))).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        key,
        t
    ]);
    // A filter or page change after the first load dims the table rather than
    // replacing it with skeletons, so the operator keeps their place.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: loaded.current
        });
    }, [
        load
    ]);
    // ── the two writes ──────────────────────────────────────────────────────
    const [suspending, setSuspending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the row
    const [restoring, setRestoring] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the row
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [dialogError, setDialogError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const openSuspend = (row)=>{
        setDialogError(null);
        setSuspending(row);
    };
    const openRestore = (row)=>{
        setDialogError(null);
        setRestoring(row);
    };
    /** §2.4: pending → success closes + toasts + refetches | failure stays open inline. */ const run = async (document, vars, successKey, close)=>{
        setPending(true);
        setDialogError(null);
        try {
            await (0, $4d933cf7e127f21f$export$72e4926bf8358653)(document, vars);
            close();
            toast.success(t(successKey));
            load({
                quiet: true
            });
        } catch (e) {
            setDialogError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const pages = data?.pages || [];
    const total = Number(data?.total || 0);
    const pageCount = Math.max(1, Math.ceil(total / (0, $8d78f9df46b9c862$export$6e7522bf44b266d)));
    const isFiltered = !!(view.status || String(view.q || '').trim().length >= (0, $cdf3712044ab22f9$export$d6920ac008449896));
    const columns = [
        {
            key: 'name',
            header: t('doctorPages.columns.name'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            title: r.displayName || '',
                            children: r.displayName || t('doctorPages.unnamed')
                        }),
                        r.specialty ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate text-xs text-muted-foreground",
                            title: r.specialty,
                            children: r.specialty
                        }) : null
                    ]
                })
        },
        {
            key: 'council',
            header: t('doctorPages.columns.council'),
            width: '8rem',
            render: (r)=>r.councilNumber ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                    className: "font-mono text-xs",
                    children: r.councilNumber
                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'slug',
            header: t('doctorPages.columns.slug'),
            width: '14rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d4de09da3da4fb2$var$PublicLink, {
                    row: r
                })
        },
        {
            key: 'status',
            header: t('doctorPages.columns.status'),
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d78f9df46b9c862$export$850ca4af769310), {
                    status: r.status,
                    "data-testid": `doctor-pages-status-${r.pageId}`
                })
        },
        {
            key: 'publishedAt',
            header: t('doctorPages.columns.publishedAt'),
            width: '8rem',
            render: (r)=>r.publishedAt ? formatDate(r.publishedAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'reason',
            header: t('doctorPages.columns.reason'),
            width: '14rem',
            render: (r)=>{
                if (!r.suspendedReason) return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
                const by = r.suspendedBy || r.suspendedAt ? t('doctorPages.suspendedBy', {
                    actor: r.suspendedBy || (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58),
                    date: r.suspendedAt ? formatDate(r.suspendedAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                }) : '';
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    dir: "auto",
                    className: "truncate text-sm",
                    title: by ? `${r.suspendedReason} \u{2014} ${by}` : r.suspendedReason,
                    "data-testid": `doctor-pages-reason-${r.pageId}`,
                    children: r.suspendedReason
                });
            }
        },
        {
            key: 'actions',
            header: t('doctorPages.columns.actions'),
            width: '8rem',
            render: (r)=>{
                const action = (0, $8d78f9df46b9c862$export$8e622f92e44f6a61)(r.status);
                const name = r.displayName || r.slug;
                if (action === 'suspend') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    size: "sm",
                    variant: "outline",
                    className: "text-destructive",
                    onClick: ()=>openSuspend(r),
                    "aria-label": t('doctorPages.actions.suspendAria', {
                        name: name
                    }),
                    "data-testid": `doctor-pages-suspend-${r.pageId}`,
                    children: t('doctorPages.actions.suspend')
                });
                if (action === 'restore') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    size: "sm",
                    variant: "outline",
                    onClick: ()=>openRestore(r),
                    "aria-label": t('doctorPages.actions.restoreAria', {
                        name: name
                    }),
                    "data-testid": `doctor-pages-restore-${r.pageId}`,
                    children: t('doctorPages.actions.restore')
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: t('doctorPages.actions.none')
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "doctor-pages",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('doctorPages.title'),
                sub: t('doctorPages.sub', {
                    site: (0, $d87bd335296b449f$export$3c6615908c3d10c3)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9d4de09da3da4fb2$var$Toolbar, {
                        view: view,
                        onChange: setView,
                        onClear: resetView,
                        isFiltered: isFiltered,
                        resultLabel: !loading && !error ? t('doctorPages.count', {
                            count: total
                        }) : ''
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "rounded-lg border border-border bg-card transition-opacity",
                        style: {
                            opacity: refreshing ? 0.45 : 1
                        },
                        "aria-busy": refreshing || undefined,
                        children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "doctor-pages-loading",
                            "data-state": "loading",
                            role: "status",
                            "aria-busy": "true",
                            "aria-label": t('doctorPages.loading'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    children: Array.from({
                                        length: 8
                                    }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                                            cols: 7
                                        }, i))
                                })
                            })
                        }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                            title: t('doctorPages.error'),
                            description: error,
                            onRetry: ()=>load(),
                            retryLabel: t('common.actions.retry'),
                            "data-testid": "doctor-pages-error"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-state": pages.length ? 'content' : 'empty',
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                dense: true,
                                ariaLabel: t('doctorPages.tableAria'),
                                columns: columns,
                                rows: pages,
                                rowKey: (r)=>r.pageId,
                                rowProps: (r)=>({
                                        'data-testid': `doctor-pages-row-${r.pageId}`
                                    }),
                                empty: isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                                        size: 44,
                                        strokeWidth: 1.5,
                                        "aria-hidden": true
                                    }),
                                    title: t('doctorPages.emptyFiltered.title'),
                                    description: t('doctorPages.emptyFiltered.desc'),
                                    action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        onClick: resetView,
                                        children: t('common.actions.clearFilters')
                                    }),
                                    "data-testid": "doctor-pages-empty"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b51f4920eac1ba0$export$2e2bcd8739ae039), {
                                        size: 44,
                                        strokeWidth: 1.5,
                                        "aria-hidden": true
                                    }),
                                    title: t('doctorPages.empty.title'),
                                    description: t('doctorPages.empty.desc'),
                                    "data-testid": "doctor-pages-empty"
                                }),
                                "data-testid": "doctor-pages-table"
                            })
                        })
                    }),
                    !loading && !error && pageCount > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "doctor-pages-pager",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                            page: Math.min(Math.max(1, view.page), pageCount),
                            pageCount: pageCount,
                            pageSize: (0, $8d78f9df46b9c862$export$6e7522bf44b266d),
                            onChange: (page)=>setView({
                                    page: page
                                }),
                            prevLabel: t('common.pager.prev'),
                            nextLabel: t('common.pager.next'),
                            pageLabel: (page, count)=>t('common.pager.label', {
                                    page: page,
                                    total: count
                                }),
                            formatNumber: formatNumber
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f95975fd0d57cfa$export$2e2bcd8739ae039), {
                page: suspending,
                pending: pending,
                error: dialogError,
                onOpenChange: (open)=>{
                    if (!open && !pending) setSuspending(null);
                },
                onSubmit: ({ reason: reason })=>run((0, $e57337e272a1b908$export$d8b4897d7aac1623), {
                        pageId: suspending.pageId,
                        reason: reason
                    }, 'doctorPages.suspend.success', ()=>setSuspending(null))
            }),
            restoring ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: true,
                onOpenChange: (open)=>{
                    if (!open && !pending) setRestoring(null);
                },
                title: t('doctorPages.restore.title', {
                    name: restoring.displayName || restoring.slug
                }),
                description: t('doctorPages.restore.body'),
                confirmLabel: t('doctorPages.restore.submit'),
                cancelLabel: t('common.actions.cancel'),
                loading: pending,
                onConfirm: ()=>run((0, $e57337e272a1b908$export$8e74c791033242ae), {
                        pageId: restoring.pageId
                    }, 'doctorPages.restore.success', ()=>setRestoring(null)),
                "data-testid": "doctor-pages-restore",
                confirmTestId: "doctor-pages-restore-confirm",
                cancelTestId: "doctor-pages-restore-cancel",
                children: dialogError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    "data-testid": "doctor-pages-restore-error",
                    children: dialogError
                }) : null
            }) : null
        ]
    });
}
/**
 * The slug, and — only while the page is actually public — a link to it. A
 * link to a suspended or unpublished page would open the site's 404, which
 * reads as "the page is broken" rather than "the page is down on purpose".
 */ function $9d4de09da3da4fb2$var$PublicLink({ row: row }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const slug = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: "truncate font-mono text-xs",
        children: row.slug
    });
    if (row.status !== 'published' || !row.publicUrl) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "inline-flex min-w-0 items-center",
        title: t('doctorPages.notPublic'),
        children: slug
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
        href: row.publicUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "inline-flex min-w-0 items-center gap-1 text-primary hover:underline",
        "aria-label": t('doctorPages.openPublic', {
            slug: row.slug
        }),
        title: row.publicUrl,
        "data-testid": `doctor-pages-link-${row.pageId}`,
        children: [
            slug,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                size: 13,
                "aria-hidden": true,
                className: "shrink-0"
            })
        ]
    });
}
/**
 * Zone ④. Status chips apply at once; the search echoes instantly and writes
 * the URL after the debounce (DESIGN_CONCEPT §8, §9.2). `F3` and `/` focus it
 * through the shortcut registry.
 */ function $9d4de09da3da4fb2$var$Toolbar({ view: view, onChange: onChange, onClear: onClear, isFiltered: isFiltered, resultLabel: resultLabel }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.q || '');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(view.q || '');
    }, [
        view.q
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (draft === (view.q || '')) return undefined;
        const timer = setTimeout(()=>onChange({
                q: draft,
                page: 1
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        draft,
        view.q,
        onChange
    ]);
    const focusSearch = ()=>{
        searchRef.current?.focus();
        searchRef.current?.select?.();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('f3', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.doctorPages')
    });
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('/', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.doctorPages')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mb-3 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
        "data-testid": "doctor-pages-toolbar",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "group",
                "aria-label": t('doctorPages.filters.label'),
                className: "flex flex-wrap gap-1.5",
                "data-testid": "doctor-pages-filter",
                children: [
                    '',
                    ...(0, $8d78f9df46b9c862$export$c3bf375920040a8d)
                ].map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                        label: s ? t(`doctorPages.status.${s}`) : t('doctorPages.filters.all'),
                        active: (view.status || '') === s,
                        onClick: ()=>onChange({
                                status: s,
                                page: 1
                            }),
                        "data-testid": `doctor-pages-filter-${s || 'all'}`
                    }, s || 'all'))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-w-[16rem] flex-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                    ref: searchRef,
                    value: draft,
                    onChange: (e)=>setDraft(e.target?.value ?? e),
                    onKeyDown: (e)=>{
                        if (e.key === 'Escape' && draft) {
                            e.stopPropagation();
                            setDraft('');
                        }
                    },
                    placeholder: t('doctorPages.search.placeholder'),
                    "aria-label": t('doctorPages.search.label'),
                    "data-testid": "doctor-pages-search"
                })
            }),
            resultLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-sm text-muted-foreground",
                "aria-live": "polite",
                children: resultLabel
            }) : null,
            isFiltered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                variant: "ghost",
                size: "sm",
                onClick: onClear,
                "data-testid": "doctor-pages-clear",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                        size: 14,
                        "aria-hidden": true
                    }),
                    t('common.actions.clearFilters')
                ]
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9b45f4377dc2b059$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CalendarHeart", [
    [
        "path",
        {
            d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7",
            key: "136lmk"
        }
    ],
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
            key: "1t7hil"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8796e625a2ec43cf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Hourglass", [
    [
        "path",
        {
            d: "M5 22h14",
            key: "ehvnwv"
        }
    ],
    [
        "path",
        {
            d: "M5 2h14",
            key: "pdyrp9"
        }
    ],
    [
        "path",
        {
            d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
            key: "1d314k"
        }
    ],
    [
        "path",
        {
            d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
            key: "1vvvr6"
        }
    ]
]);














var $acw62 = parcelRequire("acw62");






function $32b67e09d1d7998f$export$2e2bcd8739ae039({ view: view, onChange: onChange, onClear: onClear, filtered: filtered, resultLabel: resultLabel, canFilterMine: canFilterMine }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(view.q || '');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(view.q || '');
    }, [
        view.q
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (draft === (view.q || '')) return undefined;
        const timer = setTimeout(()=>onChange({
                q: draft,
                page: 1
            }), (0, $cdf3712044ab22f9$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    }, [
        draft,
        view.q,
        onChange
    ]);
    const focusSearch = ()=>{
        searchRef.current?.focus();
        searchRef.current?.select?.();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('/', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.demoRequests')
    });
    const owners = (0, $1528ce4aa57db78e$export$d20b8640d99f4581).map((value)=>({
            value: value,
            label: t(`demoRequests.filters.owner.${value}`),
            // «Mine» needs to know who «me» is; without `me` it cannot narrow.
            disabled: value === 'me' && !canFilterMine
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "demo-requests-toolbar",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-end gap-3 rounded-lg border border-border bg-card p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('demoRequests.filters.owner.label'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex h-11 items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                semantics: "filter",
                                size: "sm",
                                ariaLabel: t('demoRequests.filters.owner.label'),
                                options: owners,
                                value: view.owner,
                                onChange: (owner)=>onChange({
                                        owner: owner,
                                        page: 1
                                    }),
                                "data-testid": "demo-requests-owner"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('demoRequests.filters.from'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-44",
                            "data-testid": "demo-requests-from",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: view.from || '',
                                onChange: (v)=>onChange({
                                        from: v || '',
                                        page: 1
                                    }),
                                placeholder: t('demoRequests.filters.datePlaceholder'),
                                disableFuture: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('demoRequests.filters.to'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-44",
                            "data-testid": "demo-requests-to",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                                value: view.to || '',
                                onChange: (v)=>onChange({
                                        to: v || '',
                                        page: 1
                                    }),
                                placeholder: t('demoRequests.filters.datePlaceholder'),
                                disableFuture: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                        label: t('demoRequests.search.label'),
                        style: {
                            flex: '1 1 16rem',
                            minWidth: '16rem'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                            ref: searchRef,
                            value: draft,
                            onChange: (e)=>setDraft(e.target?.value ?? e),
                            onKeyDown: (e)=>{
                                if (e.key === 'Escape' && draft) {
                                    e.stopPropagation();
                                    setDraft('');
                                }
                            },
                            placeholder: t('demoRequests.search.placeholder'),
                            "aria-label": t('demoRequests.search.label'),
                            clearLabel: t('shortcuts.action.clear'),
                            "data-testid": "demo-requests-search"
                        })
                    }),
                    filtered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex h-11 items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            size: "sm",
                            onClick: onClear,
                            "data-testid": "demo-requests-clear-filters",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('common.actions.clearFilters')
                            ]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb-3 text-xs text-muted-foreground",
                "aria-live": "polite",
                "data-testid": "demo-requests-count",
                children: resultLabel
            })
        ]
    });
}



parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3e90c7d0608d8b54$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("AlarmClock", [
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "8",
            key: "3y4lt7"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4l2 2",
            key: "1c63tq"
        }
    ],
    [
        "path",
        {
            d: "M5 3 2 6",
            key: "18tl5t"
        }
    ],
    [
        "path",
        {
            d: "m22 6-3-3",
            key: "1opdir"
        }
    ],
    [
        "path",
        {
            d: "M6.38 18.7 4 21",
            key: "17xu3x"
        }
    ],
    [
        "path",
        {
            d: "M17.64 18.67 20 21",
            key: "kv2oe2"
        }
    ]
]);









var $acw62 = parcelRequire("acw62");






function $9f22b712dea3cd47$export$f11afaaa0ce37bd0() {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((key, raw)=>{
        if (raw == null || raw === '') return 0, $7df21990c7b31bb5$export$ccb33e29d92c9a58;
        return key && has && has(key) ? t(key) : String(raw);
    }, [
        t,
        has
    ]);
}
function $9f22b712dea3cd47$export$a35d1b968acb385({ status: status, 'data-testid': testId }) {
    const label = $9f22b712dea3cd47$export$f11afaaa0ce37bd0();
    if (!status) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    const tone = (0, $57e4f51624ccb99c$export$82bc72f537d8f36)[status] || 'outline';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: tone,
        "data-tone": tone,
        "data-status": status,
        "data-testid": testId,
        children: label((0, $57e4f51624ccb99c$export$dab13a906eae6c67)(status), status)
    });
}
function $9f22b712dea3cd47$export$52f0f02147b12c03({ children: children, className: className = '', title: title, 'data-testid': testId }) {
    if (children == null || children === '') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: `font-mono text-[12px] ${className}`,
        title: title,
        "data-testid": testId,
        children: children
    });
}
function $9f22b712dea3cd47$export$e67d2dec3698bb2({ value: value, 'data-testid': testId }) {
    if (!value) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f22b712dea3cd47$export$52f0f02147b12c03, {
        "data-testid": testId,
        children: value
    });
    const short = value.length > 12 ? value.slice(0, 8) : value;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9f22b712dea3cd47$export$52f0f02147b12c03, {
        title: value,
        "data-testid": testId,
        children: short
    });
}
function $9f22b712dea3cd47$export$4b67f8be7a5e4a15({ label: label, value: value, wide: wide, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `min-w-0 ${wide ? 'col-span-2' : ''}`,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                className: "text-xs text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                className: "break-words font-semibold text-foreground",
                children: value == null || value === '' ? (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58) : value
            })
        ]
    });
}
function $9f22b712dea3cd47$export$c490570edc799722({ ownerId: ownerId, mySub: mySub }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!ownerId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-muted-foreground",
        children: t('demoRequests.owner.none')
    });
    if (mySub && ownerId === mySub) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "font-semibold",
        children: t('demoRequests.owner.you')
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f68e1d223f0d9b1$export$2e2bcd8739ae039), {
        actor: ownerId
    });
}
function $9f22b712dea3cd47$export$4f2558dd25106ae2({ value: value, label: label, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [done, setDone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const copy = async ()=>{
        try {
            await navigator.clipboard.writeText(String(value));
            setDone(true);
            toast.success(t('common.value.copied'));
            setTimeout(()=>setDone(false), 1500);
        } catch  {
            toast.error(t('demoRequests.drawer.copyFailed'));
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "sm",
        onClick: copy,
        "aria-label": label,
        title: label,
        "data-testid": testId,
        className: "h-8 w-8 p-0",
        children: done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
            size: 15,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
            size: 15,
            "aria-hidden": true
        })
    });
}
function $9f22b712dea3cd47$export$6e2c8f0811a474ce({ title: title, action: action, children: children, 'data-testid': testId }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "flex flex-col gap-2.5",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-sm font-bold text-foreground",
                        children: title
                    }),
                    action
                ]
            }),
            children
        ]
    });
}


/**
 * The queue as a table (§3.2 T1).
 *
 * Columns answer «who is waiting, for how long, and who has it»: age (the SLA
 * colour, derived — amber past one working day, red past three, only while
 * unanswered), the person, what kind of practice, how they want the demo,
 * status, owner, and the reference code the visitor was shown.
 *
 * Rows activate on click, Enter and Space (`onRowActivate`) and open the
 * drawer; the lead's uuid is the only thing that reaches the URL.
 */ const $fe834c39e294ca41$var$AGE_BADGE = {
    warn: 'warning',
    danger: 'destructive'
};
function $fe834c39e294ca41$var$AgeCell({ lead: lead, now: now }) {
    const { t: t, formatRelativeTime: formatRelativeTime, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const tone = (0, $1528ce4aa57db78e$export$2640ade22ac8dfb4)(lead, now);
    const created = Number(lead.createdAtMs) || null;
    const text = created ? formatRelativeTime(created, now) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58);
    const exact = created ? formatDateTime(created) : '';
    if (!tone) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "whitespace-nowrap text-sm text-muted-foreground",
        title: exact,
        children: text
    });
    // Colour AND an icon AND words: the SLA state is never carried by colour alone.
    const why = t(`demoRequests.age.${tone}`);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: $fe834c39e294ca41$var$AGE_BADGE[tone],
        className: "gap-1 whitespace-nowrap",
        title: `${exact} \xb7 ${why}`,
        "data-tone": tone,
        "data-testid": `demo-requests-age-${lead.id}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                size: 12,
                "aria-hidden": true
            }),
            text,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: ` \u{2014} ${why}`
            })
        ]
    });
}
function $fe834c39e294ca41$export$cf060141faaf6cdf({ lead: lead, base: base = (0, $d87bd335296b449f$export$92162f94eb6c49d9), 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const slug = (0, $1528ce4aa57db78e$export$6084db05dc233238)(lead);
    const href = (0, $1528ce4aa57db78e$export$3b4e4d8b02883f9)(lead, base);
    if (!slug || !href) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "inline-flex min-w-0 items-center gap-1 text-primary hover:underline",
        "aria-label": t('demoRequests.pageLeads.openPage', {
            slug: slug
        }),
        title: href,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: (e)=>e.stopPropagation(),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                className: "truncate font-mono text-xs",
                children: slug
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                size: 13,
                "aria-hidden": true,
                className: "shrink-0"
            })
        ]
    });
}
function $fe834c39e294ca41$export$2e2bcd8739ae039({ rows: rows, loading: loading, mySub: mySub, overdue: overdue, onOpen: onOpen, empty: empty, intent: intent, now: now = Date.now() }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const vocab = (0, $9f22b712dea3cd47$export$f11afaaa0ce37bd0)();
    const answer = (field, value)=>{
        if (value == null || value === '') return null;
        const segment = field === 'dentistCount' ? (0, $1528ce4aa57db78e$export$1cfbbee75e7648ae)[value] : value;
        return vocab(segment ? `${(0, $1528ce4aa57db78e$export$2995bda72fb8f331)[field]}.${segment}` : null, value);
    };
    const statusColumn = {
        key: 'status',
        header: t('demoRequests.columns.status'),
        width: '10rem',
        render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$a35d1b968acb385), {
                        status: r.status,
                        "data-testid": `demo-requests-status-${r.id}`
                    }),
                    overdue?.has(r.id) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex text-destructive",
                        title: t('demoRequests.followUp.overdueRow'),
                        "data-testid": `demo-requests-overdue-${r.id}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e90c7d0608d8b54$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: t('demoRequests.followUp.overdueRow')
                            })
                        ]
                    }) : null
                ]
            })
    };
    const ageColumn = {
        key: 'age',
        header: t('demoRequests.columns.age'),
        width: '9.5rem',
        render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fe834c39e294ca41$var$AgeCell, {
                lead: r,
                now: now
            })
    };
    const ownerColumn = {
        key: 'owner',
        header: t('demoRequests.columns.owner'),
        width: '8rem',
        render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$c490570edc799722), {
                ownerId: r.ownerId,
                mySub: mySub
            })
    };
    // A patient's appointment request from a doctor's public page (§D7): whom to
    // call, for which doctor, from which page, and how they want to be reached.
    const pageColumns = [
        ageColumn,
        {
            key: 'visitor',
            header: t('demoRequests.pageLeads.columns.visitor'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            title: r.customerName || '',
                            children: r.customerName || t('demoRequests.unnamed')
                        }),
                        r.customerMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            ...(0, $c53f9539af19d960$export$3433559efc22d110),
                            className: "truncate font-mono text-xs text-muted-foreground",
                            "data-testid": `demo-requests-mobile-${r.id}`,
                            children: r.customerMobile
                        }) : null
                    ]
                })
        },
        {
            key: 'doctor',
            header: t('demoRequests.pageLeads.columns.doctor'),
            render: (r)=>{
                const d = r.requestDetails || {};
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate text-sm",
                            title: d.doctorDisplayName || '',
                            children: d.doctorDisplayName || (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                        }),
                        d.councilNumber ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            ...(0, $c53f9539af19d960$export$3433559efc22d110),
                            className: "truncate font-mono text-xs text-muted-foreground",
                            children: d.councilNumber
                        }) : null
                    ]
                });
            }
        },
        {
            key: 'page',
            header: t('demoRequests.pageLeads.columns.page'),
            width: '10rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fe834c39e294ca41$export$cf060141faaf6cdf, {
                    lead: r,
                    "data-testid": `demo-requests-page-${r.id}`
                })
        },
        {
            key: 'preferredContact',
            header: t('demoRequests.pageLeads.columns.preferred'),
            width: '11rem',
            render: (r)=>{
                const d = r.requestDetails || {};
                const parts = [
                    d.preferredChannel ? vocab(`demoRequests.channel.${d.preferredChannel}`, d.preferredChannel) : null,
                    answer('preferredTime', d.preferredTime)
                ].filter(Boolean);
                const text = parts.length ? parts.join(" \xb7 ") : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "truncate text-sm",
                    title: text,
                    children: text
                });
            }
        },
        statusColumn,
        ownerColumn
    ];
    const demoColumns = [
        {
            key: 'age',
            header: t('demoRequests.columns.age'),
            width: '9.5rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fe834c39e294ca41$var$AgeCell, {
                    lead: r,
                    now: now
                })
        },
        {
            key: 'name',
            header: t('demoRequests.columns.name'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            title: r.customerName || '',
                            children: r.customerName || t('demoRequests.unnamed')
                        }),
                        r.requestDetails?.organization ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate text-xs text-muted-foreground",
                            title: r.requestDetails.organization,
                            children: r.requestDetails.organization
                        }) : null
                    ]
                })
        },
        {
            key: 'practice',
            header: t('demoRequests.columns.practice'),
            render: (r)=>{
                const d = r.requestDetails || {};
                const parts = [
                    answer('practiceType', d.practiceType),
                    answer('dentistCount', d.dentistCount),
                    d.city || null
                ].filter(Boolean);
                const text = parts.length ? parts.join(" \xb7 ") : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    dir: "auto",
                    className: "truncate text-sm",
                    title: text,
                    children: text
                });
            }
        },
        {
            key: 'preferred',
            header: t('demoRequests.columns.preferred'),
            width: '11rem',
            render: (r)=>{
                const d = r.requestDetails || {};
                const parts = [
                    answer('demoMode', d.demoMode),
                    answer('preferredTime', d.preferredTime)
                ].filter(Boolean);
                const text = parts.length ? parts.join(" \xb7 ") : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "truncate text-sm",
                    title: text,
                    children: text
                });
            }
        },
        statusColumn,
        ownerColumn,
        {
            key: 'reference',
            header: t('demoRequests.columns.reference'),
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$e67d2dec3698bb2), {
                    value: r.requestDetails?.reference
                })
        }
    ];
    const columns = intent === (0, $57e4f51624ccb99c$export$ef13f627afefba0c) ? pageColumns : demoColumns;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
        dense: true,
        loading: loading,
        skeletonRows: 8,
        ariaLabel: t('demoRequests.tableAria'),
        columns: columns,
        rows: rows,
        rowKey: (r)=>r.id,
        onRowActivate: onOpen,
        rowProps: (r)=>({
                'data-testid': `demo-requests-row-${r.id}`,
                // Names the row for a screen reader by the only thing that is not PII
                // in the address bar sense — it is on screen anyway, and the row must
                // say what Enter will open.
                'aria-label': t('demoRequests.open', {
                    name: r.customerName || t('demoRequests.unnamed')
                })
            }),
        empty: empty,
        "data-testid": "demo-requests-table"
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a7edb116254b1792$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowUpLeft", [
    [
        "path",
        {
            d: "M7 17V7h10",
            key: "11bw93"
        }
    ],
    [
        "path",
        {
            d: "M17 17 7 7",
            key: "2786uv"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7c62dd403424a2a8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CalendarClock", [
    [
        "path",
        {
            d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
            key: "1osxxc"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M3 10h5",
            key: "r794hk"
        }
    ],
    [
        "path",
        {
            d: "M17.5 17.5 16 16.3V14",
            key: "akvzfd"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "16",
            r: "6",
            key: "qoo3c4"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ec4bb5a5195718c6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CalendarPlus", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
            key: "3spt84"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M16 19h6",
            key: "xwg31i"
        }
    ],
    [
        "path",
        {
            d: "M19 16v6",
            key: "tddt3s"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleCheck", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d6fe951f3901e9a6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Mail", [
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
            key: "1ocrg3"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $198f0fcb2df6a37f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("MessageSquare", [
    [
        "path",
        {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
            key: "1lielz"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $970c5cdf933ea69e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Phone", [
    [
        "path",
        {
            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
            key: "foiqr5"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $49970070655cdfb3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("PhoneCall", [
    [
        "path",
        {
            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
            key: "foiqr5"
        }
    ],
    [
        "path",
        {
            d: "M14.05 2a9 9 0 0 1 8 7.94",
            key: "vmijpz"
        }
    ],
    [
        "path",
        {
            d: "M14.05 6A5 5 0 0 1 18 10",
            key: "13nbpp"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ecb8e5bcb990e28a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("StickyNote", [
    [
        "path",
        {
            d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z",
            key: "qazsjp"
        }
    ],
    [
        "path",
        {
            d: "M15 3v4a2 2 0 0 0 2 2h4",
            key: "40519r"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d957a6b316cfc10$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UserCheck", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "polyline",
        {
            points: "16 11 18 13 22 9",
            key: "1pwet4"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2bc764dc168352a5$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UserMinus", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "11",
            y2: "11",
            key: "1shjgl"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c38b5b11d1e2b813$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Users", [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "path",
        {
            d: "M16 3.13a4 4 0 0 1 0 7.75",
            key: "1da9ce"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("CircleX", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
]);













var $acw62 = parcelRequire("acw62");






function $08c2883b6f610dc9$export$d636d60bacab1aba(raw) {
    const text = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(String(raw ?? '')).trim();
    if (!text) return {
        value: null,
        invalid: false
    };
    if (!/^\d{1,3}$/.test(text)) return {
        value: null,
        invalid: true
    };
    const n = Number(text);
    return n > 600 ? {
        value: null,
        invalid: true
    } : {
        value: n,
        invalid: false
    };
}
function $08c2883b6f610dc9$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, lead: lead, onDone: onDone }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [channel, setChannel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('call');
    const [outcome, setOutcome] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [minutes, setMinutes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [advance, setAdvance] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setChannel('call');
        setOutcome('');
        setMinutes('');
        setNote('');
        setAdvance(true);
        setTouched(false);
        setError(null);
    }, [
        open
    ]);
    const canAdvance = lead?.status === 'new' && (lead?.allowedNextStatuses || []).includes('contacted') && (0, $57e4f51624ccb99c$export$a95c54b781d921ce).includes(outcome);
    const duration = $08c2883b6f610dc9$export$d636d60bacab1aba(minutes);
    const outcomeError = touched && !outcome ? t('demoRequests.logContact.outcomeRequired') : undefined;
    const dirty = !!(outcome || minutes || note || channel !== 'call');
    const submit = async ()=>{
        setTouched(true);
        if (!outcome || duration.invalid || pending) return;
        setPending(true);
        setError(null);
        let logged = false;
        try {
            await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$da09a68702ba103c), {
                customerId: lead.customerId,
                input: {
                    leadId: lead.id,
                    channel: channel,
                    direction: 'outbound',
                    outcome: outcome,
                    body: note.trim() || null,
                    durationSeconds: duration.value == null ? null : duration.value * 60
                }
            });
            logged = true;
            if (canAdvance && advance) {
                await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$1b8b6acfc93feabe), {
                    leadId: lead.id,
                    status: 'contacted',
                    lostReason: null
                });
                toast.success(t('demoRequests.logContact.successAdvanced'));
            } else toast.success(t('demoRequests.logContact.success'));
            onOpenChange(false);
            onDone?.();
        } catch (e) {
            if (logged) {
                // The call IS recorded; keeping the dialog open would invite a second copy.
                toast.error(t('demoRequests.logContact.advanceFailed', {
                    message: (0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t)
                }));
                onOpenChange(false);
                onDone?.();
            } else setError((0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('demoRequests.logContact.title'),
        error: error,
        pending: pending,
        dirty: dirty,
        submitLabel: t('demoRequests.logContact.submit'),
        submitDisabled: duration.invalid,
        onSubmit: submit,
        "data-testid": "demo-log-dialog",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('demoRequests.logContact.channel'),
                        value: channel,
                        onChange: (e)=>setChannel(e.target?.value ?? e),
                        options: (0, $57e4f51624ccb99c$export$c0ddbbb7e1c927ca).map((c)=>({
                                value: c,
                                label: t((0, $57e4f51624ccb99c$export$a390fae083956549)(c))
                            })),
                        placeholder: "",
                        disabled: pending,
                        "data-testid": "demo-log-channel"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('demoRequests.logContact.outcome'),
                        value: outcome,
                        onChange: (e)=>{
                            setOutcome(e.target?.value ?? e);
                            setTouched(true);
                        },
                        onBlur: ()=>setTouched(true),
                        options: (0, $57e4f51624ccb99c$export$c648f9daf410fc3a).map((o)=>({
                                value: o,
                                label: t((0, $57e4f51624ccb99c$export$aab9b9c5e06fb4fa)(o))
                            })),
                        placeholder: t('demoRequests.logContact.outcomePlaceholder'),
                        error: outcomeError,
                        disabled: pending,
                        "data-testid": "demo-log-outcome"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('demoRequests.logContact.minutes'),
                value: minutes,
                onChange: (e)=>setMinutes(e.target?.value ?? e),
                inputMode: "numeric",
                dir: "ltr",
                maxLength: 3,
                helperText: t('demoRequests.logContact.minutesHelp'),
                error: duration.invalid ? t('demoRequests.logContact.minutesInvalid') : undefined,
                disabled: pending,
                style: {
                    maxWidth: '12rem'
                },
                "data-testid": "demo-log-minutes"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('demoRequests.logContact.note'),
                value: note,
                onChange: (e)=>setNote(e.target?.value ?? e),
                maxLength: (0, $57e4f51624ccb99c$export$2daf5676b9ee9779),
                showCount: true,
                rows: 3,
                disabled: pending,
                "data-testid": "demo-log-note"
            }),
            canAdvance ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                "data-testid": "demo-log-advance",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                    checked: advance,
                    onChange: (v)=>setAdvance(v === true),
                    disabled: pending,
                    label: t('demoRequests.logContact.advance', {
                        status: t((0, $57e4f51624ccb99c$export$dab13a906eae6c67)('contacted'))
                    }),
                    "data-testid": "demo-log-advance-checkbox"
                })
            }) : lead?.status === 'new' && outcome && !(0, $57e4f51624ccb99c$export$a95c54b781d921ce).includes(outcome) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs text-muted-foreground",
                "data-testid": "demo-log-no-advance",
                children: t('demoRequests.logContact.noAdvance')
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");






const $54895e39431ac833$var$CUSTOM = 'custom';
function $54895e39431ac833$export$e1e51e4cd9c2d39b(value) {
    const { date: date, time: time } = (0, $d9dd19094c9f758e$export$565a3e0423f3fda3)(value);
    if (!date || !time) return null;
    const ms = new Date(`${date}T${time}:00+03:30`).getTime();
    return Number.isNaN(ms) ? null : ms;
}
function $54895e39431ac833$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, lead: lead, mySub: mySub, onDone: onDone, now: now = ()=>Date.now() }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [preset, setPreset] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $57e4f51624ccb99c$export$45895a8451f5beee)[0]);
    const [custom, setCustom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [due, setDue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setPreset((0, $57e4f51624ccb99c$export$45895a8451f5beee)[0]);
        setCustom('');
        setDue('');
        setNote('');
        setTouched(false);
        setError(null);
    }, [
        open
    ]);
    const title = preset === $54895e39431ac833$var$CUSTOM ? custom.trim() : t((0, $57e4f51624ccb99c$export$676e59173ed33c48)(preset));
    const dueMs = $54895e39431ac833$export$e1e51e4cd9c2d39b(due);
    const titleError = touched && !title ? t('demoRequests.followUp.titleRequired') : undefined;
    const dueError = !touched ? undefined : dueMs == null ? t('demoRequests.followUp.dueRequired') : dueMs < now() - 60000 ? t('demoRequests.followUp.duePast') : undefined;
    const dirty = !!(custom || due || note || preset !== (0, $57e4f51624ccb99c$export$45895a8451f5beee)[0]);
    const submit = async ()=>{
        setTouched(true);
        if (!title || dueMs == null || dueMs < now() - 60000 || pending) return;
        setPending(true);
        setError(null);
        try {
            await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$f69e2454bd83b8eb), {
                customerId: lead.customerId,
                input: {
                    title: title,
                    note: note.trim() || null,
                    dueAtMs: String(dueMs),
                    leadId: lead.id,
                    assignedTo: mySub || null
                }
            });
            toast.success(t('demoRequests.followUp.success'));
            onOpenChange(false);
            onDone?.();
        } catch (e) {
            setError((0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('demoRequests.followUp.title'),
        error: error,
        pending: pending,
        dirty: dirty,
        submitLabel: t('demoRequests.followUp.submit'),
        onSubmit: submit,
        footerNote: mySub ? t('demoRequests.followUp.assignedToYou') : undefined,
        "data-testid": "demo-followup-dialog",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "demo-followup-preset",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcaca06c97c91379$export$2e2bcd8739ae039), {
                    label: t('demoRequests.followUp.titleLabel'),
                    value: preset,
                    onChange: (v)=>setPreset(v || (0, $57e4f51624ccb99c$export$45895a8451f5beee)[0]),
                    options: [
                        ...(0, $57e4f51624ccb99c$export$45895a8451f5beee).map((p)=>({
                                value: p,
                                label: t((0, $57e4f51624ccb99c$export$676e59173ed33c48)(p))
                            })),
                        {
                            value: $54895e39431ac833$var$CUSTOM,
                            label: t('demoRequests.followUp.presets.custom')
                        }
                    ],
                    disabled: pending
                })
            }),
            preset === $54895e39431ac833$var$CUSTOM ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                label: t('demoRequests.followUp.customTitle'),
                value: custom,
                onChange: (e)=>setCustom(e.target?.value ?? e),
                onBlur: ()=>setTouched(true),
                maxLength: (0, $57e4f51624ccb99c$export$e4869c977fd21324),
                error: titleError,
                disabled: pending,
                "data-testid": "demo-followup-custom"
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
                label: t('demoRequests.followUp.due'),
                error: dueError,
                helperText: t('demoRequests.followUp.dueHelp'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "demo-followup-due",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                        value: due,
                        onChange: (v)=>{
                            setDue(v || '');
                            setTouched(true);
                        },
                        withTime: true,
                        placeholder: t('demoRequests.followUp.duePlaceholder'),
                        disabled: pending
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('demoRequests.followUp.note'),
                value: note,
                onChange: (e)=>setNote(e.target?.value ?? e),
                maxLength: (0, $57e4f51624ccb99c$export$2daf5676b9ee9779),
                showCount: true,
                rows: 3,
                disabled: pending,
                "data-testid": "demo-followup-note"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $075e58d1dc92dc07$export$980f4bf92e21e16a(presetLabel, text) {
    const extra = String(text || '').trim();
    if (presetLabel && extra) return `${presetLabel}: ${extra}`;
    return presetLabel || extra;
}
function $075e58d1dc92dc07$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, lead: lead, onDone: onDone }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [preset, setPreset] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [text, setText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [archive, setArchive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setPreset('');
        setText('');
        setArchive(false);
        setTouched(false);
        setError(null);
    }, [
        open
    ]);
    const reason = $075e58d1dc92dc07$export$980f4bf92e21e16a(preset ? (0, $57e4f51624ccb99c$export$e4bb73c65f68314b)[preset] : '', text);
    const tooLong = reason.length > (0, $57e4f51624ccb99c$export$312e35cca8fa1c08);
    const reasonError = touched && !reason ? t('demoRequests.lost.reasonRequired') : tooLong ? t('demoRequests.lost.tooLong', {
        max: (0, $57e4f51624ccb99c$export$312e35cca8fa1c08)
    }) : undefined;
    const dirty = !!(preset || text);
    const submit = async ()=>{
        setTouched(true);
        if (!reason || tooLong || pending) return;
        setPending(true);
        setError(null);
        let closed = false;
        try {
            await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$1b8b6acfc93feabe), {
                leadId: lead.id,
                status: 'lost',
                lostReason: reason
            });
            closed = true;
            if (preset === 'spam' && archive) await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$c2bde8b8b24a9d2e), {
                id: lead.customerId,
                reason: reason
            });
            toast.success(t('demoRequests.lost.success'));
            onOpenChange(false);
            onDone?.();
        } catch (e) {
            if (closed) {
                toast.error(t('demoRequests.lost.archiveFailed', {
                    message: (0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t)
                }));
                onOpenChange(false);
                onDone?.();
            } else setError((0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t));
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('demoRequests.lost.title'),
        lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
            variant: "warning",
            children: t('demoRequests.lost.consequence', {
                status: t((0, $57e4f51624ccb99c$export$dab13a906eae6c67)('lost'))
            })
        }),
        error: error,
        pending: pending,
        dirty: dirty,
        submitLabel: t('demoRequests.lost.submit'),
        submitVariant: "destructive",
        submitDisabled: tooLong,
        onSubmit: submit,
        "data-testid": "demo-lost-dialog",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "demo-lost-presets",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcaca06c97c91379$export$2e2bcd8739ae039), {
                    label: t('demoRequests.lost.presetLabel'),
                    value: preset,
                    onChange: (v)=>{
                        setPreset(v || '');
                        setTouched(true);
                    },
                    options: (0, $57e4f51624ccb99c$export$8af1706d329452f8).map((p)=>({
                            value: p,
                            label: t((0, $57e4f51624ccb99c$export$10fc55516681f8b1)(p))
                        })),
                    disabled: pending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: preset ? t('demoRequests.lost.detailOptional') : t('demoRequests.lost.detail'),
                value: text,
                onChange: (e)=>setText(e.target?.value ?? e),
                onBlur: ()=>setTouched(true),
                maxLength: (0, $57e4f51624ccb99c$export$312e35cca8fa1c08),
                showCount: true,
                rows: 3,
                error: reasonError,
                disabled: pending,
                "data-testid": "demo-lost-reason"
            }),
            preset === 'spam' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                checked: archive,
                onChange: (v)=>setArchive(v === true),
                disabled: pending,
                label: t('demoRequests.lost.archive'),
                "data-testid": "demo-lost-archive"
            }) : null
        ]
    });
}


/**
 * One demo request, beside the queue (§3.2 T2–T10). Deep-linkable as
 * `?lead=<uuid>` — the lead's id is the only identifier that reaches the URL.
 *
 * It loads on its own (never from the list page, so a deep link to a lead on
 * another page or tab still opens), and it REFETCHES ON WINDOW FOCUS: two reps
 * can open the same request, the owner is last-write-wins (§3.2 T3), and the
 * current owner is shown prominently rather than the one from ten minutes ago.
 *
 * The reverse lookup «other requests with this number» is audited by the CRM
 * on every call, so it runs ONCE per drawer open, not on refetch.
 *
 * A closed lead (won/lost) renders read-only: the service refuses every edit.
 */ const $e955eb5b229ff433$var$CHANNEL_ICON = {
    call: (0, $49970070655cdfb3$export$2e2bcd8739ae039),
    whatsapp: (0, $59ab4c4f93bd486b$export$2e2bcd8739ae039),
    sms: (0, $198f0fcb2df6a37f$export$2e2bcd8739ae039),
    email: (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039),
    in_person: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039)
};
function $e955eb5b229ff433$export$5e538a3e073acaf5(ms, t) {
    const minutes = Math.max(1, Math.round(ms / 60000));
    if (minutes < 60) return t('demoRequests.span.minutes', {
        count: minutes
    });
    const hours = Math.round(minutes / 60);
    if (hours < 48) return t('demoRequests.span.hours', {
        count: hours
    });
    return t('demoRequests.span.days', {
        count: Math.round(hours / 24)
    });
}
function $e955eb5b229ff433$var$useLeadDetail(leadId) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'loading'
    });
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [refreshFailed, setRefreshFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const seq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ quiet: quiet = false } = {})=>{
        seq.current += 1;
        const mine = seq.current;
        if (quiet) setRefreshing(true);
        else setState({
            status: 'loading'
        });
        try {
            const d = await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$9a9bca587ad2669c), {
                id: leadId
            });
            const lead = d?.crmLead;
            if (!lead) {
                if (mine === seq.current) setState({
                    status: 'missing'
                });
                return;
            }
            const c = await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$586fa2c0c410c3b3), {
                customerId: lead.customerId,
                leadId: lead.id
            });
            if (mine !== seq.current) return;
            setRefreshFailed(false);
            setState({
                status: 'ready',
                lead: lead,
                customer: c?.crmCustomer || null,
                interactions: c?.crmInteractions?.interactions || [],
                followUps: (0, $1528ce4aa57db78e$export$c68ebc83ed0ed3b6)(c?.crmFollowUps?.followUps, lead.id),
                notes: c?.crmNotes?.notes || []
            });
        } catch (err) {
            if (mine !== seq.current) return;
            if (err?.code === 'NOT_FOUND') {
                setState({
                    status: 'missing'
                });
                return;
            }
            // A failed background refresh keeps what is on screen and says so; only
            // a failed FIRST load replaces the body with the error state.
            if (quiet) setRefreshFailed(true);
            else setState({
                status: 'error',
                error: err
            });
        } finally{
            if (mine === seq.current) setRefreshing(false);
        }
    }, [
        leadId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    return {
        ...state,
        refreshing: refreshing,
        refreshFailed: refreshFailed,
        reload: ()=>load({
                quiet: true
            }),
        retry: ()=>load()
    };
}
/** «Other requests from this number» — one audited lookup per drawer open. */ function $e955eb5b229ff433$var$useSameNumber(leadId, customerId, contact, intent) {
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'idle',
        items: []
    });
    const done = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!customerId || !contact || done.current === leadId) return;
        done.current = leadId;
        let live = true;
        setState({
            status: 'loading',
            items: []
        });
        (async ()=>{
            try {
                const d = await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$73df17fa4f19ea3e), {
                    value: contact.value,
                    kind: contact.kind
                });
                const others = (0, $1528ce4aa57db78e$export$fd3ee28367a5e629)(d?.crmFindByContact, customerId).slice(0, 5);
                const withLeads = await Promise.all(others.map(async (customer)=>{
                    const l = await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$b86d435ecf91a978), {
                        customerId: customer.id,
                        ...intent ? {
                            intent: intent
                        } : {}
                    }).catch(()=>null);
                    return {
                        customer: customer,
                        leads: l?.crmLeads?.leads || []
                    };
                }));
                if (live) setState({
                    status: 'ready',
                    items: withLeads
                });
            } catch  {
                if (live) setState({
                    status: 'error',
                    items: []
                });
            }
        })();
        return ()=>{
            live = false;
        };
    }, [
        leadId,
        customerId,
        contact,
        intent
    ]);
    return state;
}
function $e955eb5b229ff433$var$DrawerSkeleton() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: t('demoRequests.drawer.loading'),
        "data-testid": "demo-drawer-loading",
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                width: "45%",
                height: 18
            }),
            [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                            width: "25%",
                            height: 12
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    height: 32
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    height: 32
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    height: 32
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    height: 32
                                })
                            ]
                        })
                    ]
                }, i))
        ]
    });
}
/** Mobile/landline as a tel: link + copy; e-mail as mailto: + copy. Both LTR islands. */ function $e955eb5b229ff433$var$ContactRow({ point: point, testId: testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const isEmail = point.kind === 'email';
    const display = isEmail ? point.value : (0, $412e1a8a99c19c1a$exports).forDisplay(point.value) || point.value;
    const href = isEmail ? `mailto:${point.value}` : `tel:${point.value}`;
    const Icon = isEmail ? (0, $d6fe951f3901e9a6$export$2e2bcd8739ae039) : (0, $970c5cdf933ea69e$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
        className: "flex items-center gap-2",
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: 15,
                "aria-hidden": true,
                className: "shrink-0 text-muted-foreground"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: href,
                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                className: "font-semibold text-primary tabular-nums hover:underline",
                children: display
            }),
            point.isPrimary ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                variant: "outline",
                children: t('demoRequests.drawer.primary')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4f2558dd25106ae2), {
                value: point.value,
                label: isEmail ? t('demoRequests.drawer.copyEmail') : t('demoRequests.drawer.copyPhone'),
                "data-testid": `${testId}-copy`
            })
        ]
    });
}
function $e955eb5b229ff433$var$TimelineItem({ entry: entry, mySub: mySub, closed: closed, onComplete: onComplete, completing: completing }) {
    const { t: t, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const vocab = (0, $9f22b712dea3cd47$export$f11afaaa0ce37bd0)();
    const { kind: kind, item: item } = entry;
    const at = entry.atMs ? formatDateTime(entry.atMs) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58);
    if (kind === 'interaction') {
        const Icon = $e955eb5b229ff433$var$CHANNEL_ICON[item.channel] || (0, $49970070655cdfb3$export$2e2bcd8739ae039);
        const minutes = item.durationSeconds ? Math.round(item.durationSeconds / 60) : null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
            className: "flex gap-3",
            "data-testid": `demo-timeline-${entry.id}`,
            "data-kind": "interaction",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 16,
                    "aria-hidden": true,
                    className: "mt-0.5 shrink-0 text-muted-foreground"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-semibold",
                                    children: vocab((0, $57e4f51624ccb99c$export$a390fae083956549)(item.channel), item.channel)
                                }),
                                item.outcome ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: vocab((0, $57e4f51624ccb99c$export$aab9b9c5e06fb4fa)(item.outcome), item.outcome)
                                }) : null,
                                minutes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-xs text-muted-foreground",
                                    children: t('demoRequests.span.minutes', {
                                        count: minutes
                                    })
                                }) : null
                            ]
                        }),
                        item.body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            dir: "auto",
                            className: "mt-1 whitespace-pre-line text-sm text-foreground",
                            children: item.body
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-1 flex flex-wrap items-center gap-x-2 text-xs text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: at
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    "aria-hidden": true,
                                    children: "\xb7"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$c490570edc799722), {
                                    ownerId: item.actorId,
                                    mySub: mySub
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (kind === 'followUp') {
        const overdue = (0, $1528ce4aa57db78e$export$21575dd80e7b1ae7)(item);
        const statusTone = overdue ? 'destructive' : item.status === 'done' ? 'success' : item.status === 'open' ? 'warning' : 'outline';
        const statusLabel = overdue ? t('demoRequests.followUp.overdue') : vocab(`demoRequests.followUp.status.${item.status}`, item.status);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
            className: "flex gap-3",
            "data-testid": `demo-timeline-${entry.id}`,
            "data-kind": "followUp",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c62dd403424a2a8$export$2e2bcd8739ae039), {
                    size: 16,
                    "aria-hidden": true,
                    className: "mt-0.5 shrink-0 text-muted-foreground"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "auto",
                                    className: "font-semibold",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: statusTone,
                                    "data-testid": `demo-followup-status-${item.id}`,
                                    children: statusLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mt-1 text-xs text-muted-foreground",
                            children: t('demoRequests.followUp.dueAt', {
                                when: at
                            })
                        }),
                        item.note ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            dir: "auto",
                            className: "mt-1 whitespace-pre-line text-sm",
                            children: item.note
                        }) : null,
                        item.outcomeNote ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            dir: "auto",
                            className: "mt-1 whitespace-pre-line text-sm text-muted-foreground",
                            children: item.outcomeNote
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t('demoRequests.followUp.assignee')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$c490570edc799722), {
                                    ownerId: item.assignedTo,
                                    mySub: mySub
                                }),
                                item.status === 'open' && !closed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    size: "sm",
                                    className: "ms-auto",
                                    onClick: ()=>onComplete(item),
                                    disabled: completing,
                                    "aria-busy": completing || undefined,
                                    "data-testid": `demo-followup-done-${item.id}`,
                                    children: [
                                        completing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                            size: 14,
                                            thickness: 2,
                                            color: "currentColor"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                            size: 14,
                                            "aria-hidden": true
                                        }),
                                        t('demoRequests.followUp.markDone')
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
        className: "flex gap-3",
        "data-testid": `demo-timeline-${entry.id}`,
        "data-kind": "note",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecb8e5bcb990e28a$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true,
                className: "mt-0.5 shrink-0 text-muted-foreground"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        dir: "auto",
                        className: "whitespace-pre-line text-sm",
                        children: item.body
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-1 flex flex-wrap items-center gap-x-2 text-xs text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: at
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": true,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$c490570edc799722), {
                                ownerId: item.actorId,
                                mySub: mySub
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $e955eb5b229ff433$export$2e2bcd8739ae039({ leadId: leadId, mySub: mySub, onClose: onClose, onChanged: onChanged, onOpenLead: onOpenLead }) {
    const { t: t, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const vocab = (0, $9f22b712dea3cd47$export$f11afaaa0ce37bd0)();
    const detail = $e955eb5b229ff433$var$useLeadDetail(leadId);
    // Which overlay is open above the drawer: 'log' | 'followUp' | 'lost' | {move}.
    const [overlay, setOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // which inline action is in flight
    const [moveError, setMoveError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [noteDraft, setNoteDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Esc belongs to the TOP overlay: while a dialog is open the drawer must not
    // close under it (the kit Drawer listens for Escape itself, so its onClose is
    // made inert too — the only place that decides is here).
    const closeDrawer = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!overlay) onClose();
    }, [
        overlay,
        onClose
    ]);
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('esc', closeDrawer, {
        label: t('shortcuts.action.closeDrawer'),
        group: t('shortcuts.groups.demoRequests'),
        enabled: !overlay
    });
    // Refetch on focus: the owner is last-write-wins between reps.
    const { reload: reload } = detail;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onFocus = ()=>reload();
        window.addEventListener('focus', onFocus);
        return ()=>window.removeEventListener('focus', onFocus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        leadId
    ]);
    const lead = detail.status === 'ready' ? detail.lead : null;
    const contacts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $1528ce4aa57db78e$export$9172ea6d647155f1)(detail.customer), [
        detail.customer
    ]);
    const firstPhone = contacts.phones[0] || null;
    const sameNumber = $e955eb5b229ff433$var$useSameNumber(leadId, lead?.customerId, firstPhone, lead?.intent);
    const afterWrite = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        detail.reload();
        onChanged?.();
        (0, $d25e8e437795d8de$export$ebec4e912cbab394)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        detail.reload,
        onChanged
    ]);
    /** A drawer-level action (not inside a dialog): failure is a toast (DESIGN_CONCEPT §7). */ const act = async (key, fn, success)=>{
        if (busy) return;
        setBusy(key);
        try {
            await fn();
            toast.success(success);
            afterWrite();
        } catch (e) {
            toast.error((0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t));
        } finally{
            setBusy(null);
        }
    };
    const takeOwnership = ()=>act('own', ()=>(0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$7db0f0dc8b39b035), {
                leadId: leadId,
                input: {
                    ownerId: mySub
                }
            }), t('demoRequests.owner.taken'));
    const release = ()=>act('own', ()=>(0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$7db0f0dc8b39b035), {
                leadId: leadId,
                input: {
                    ownerId: ''
                }
            }), t('demoRequests.owner.released'));
    const completeFollowUp = (f)=>act(`fu-${f.id}`, ()=>(0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$e8cc1e431380fd2f), {
                followUpId: f.id,
                status: 'done',
                outcomeNote: null
            }), t('demoRequests.followUp.doneSuccess'));
    const addNote = ()=>{
        const body = noteDraft.trim();
        if (!body || !lead) return;
        act('note', async ()=>{
            await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$cb9f0bb579809bdc), {
                customerId: lead.customerId,
                body: body
            });
            setNoteDraft('');
        }, t('demoRequests.note.success'));
    };
    const confirmMove = async ()=>{
        const target = overlay?.move;
        if (!target || busy) return;
        setBusy('move');
        setMoveError(null);
        try {
            await (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$1b8b6acfc93feabe), {
                leadId: leadId,
                status: target,
                lostReason: null
            });
            toast.success(t('demoRequests.move.success', {
                status: vocab((0, $57e4f51624ccb99c$export$dab13a906eae6c67)(target), target)
            }));
            setOverlay(null);
            afterWrite();
        } catch (e) {
            // The service's own wording (NOT_ALLOWED / BAD_INPUT) — e.g. a move the
            // lead's state no longer permits because someone else moved it first.
            setMoveError((0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t));
        } finally{
            setBusy(null);
        }
    };
    const title = lead?.customerName || t('demoRequests.drawer.title');
    let body;
    if (detail.status === 'loading') body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e955eb5b229ff433$var$DrawerSkeleton, {});
    else if (detail.status === 'error') body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: t('demoRequests.drawer.error'),
        description: (0, $d25e8e437795d8de$export$9818a52a86c726ab)(detail.error, t),
        onRetry: detail.retry,
        retryLabel: t('common.actions.retry'),
        "data-testid": "demo-drawer-error"
    });
    else if (detail.status === 'missing') body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('demoRequests.drawer.missing'),
        description: t('demoRequests.drawer.missingDesc'),
        "data-testid": "demo-drawer-missing"
    });
    else {
        const closed = (0, $57e4f51624ccb99c$export$9c9ec7eceea5d445)(lead.status);
        const details = lead.requestDetails || {};
        // A doctor-page request carries the page's facts, and the patient's
        // message travels as the lead's NOTE (never in the details).
        const pageLead = (0, $1528ce4aa57db78e$export$d9958eaf500b69a8)(lead);
        const rows = pageLead ? (0, $1528ce4aa57db78e$export$7e8cd4570b148f0f)(details) : (0, $1528ce4aa57db78e$export$4d1facc288497224)(details);
        const message = pageLead ? lead.note || null : details.message;
        const utm = (0, $1528ce4aa57db78e$export$5828c827f90f69b0)(details.utm);
        const landing = (0, $1528ce4aa57db78e$export$ec356f8cff9ad609)(details.landingUrl);
        const timeline = (0, $1528ce4aa57db78e$export$49e631926d296e58)({
            interactions: detail.interactions,
            followUps: detail.followUps,
            notes: detail.notes
        });
        const overdueCount = detail.followUps.filter((f)=>(0, $1528ce4aa57db78e$export$21575dd80e7b1ae7)(f)).length;
        const response = (0, $1528ce4aa57db78e$export$4a177b5ee2700505)(lead, detail.interactions);
        const customer = detail.customer?.customer;
        const mine = !!mySub && lead.ownerId === mySub;
        body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col gap-6 transition-opacity",
            style: {
                opacity: detail.refreshing ? 0.6 : 1
            },
            "aria-busy": detail.refreshing || undefined,
            "data-state": "content",
            "data-testid": "demo-drawer-content",
            children: [
                detail.refreshFailed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    "data-testid": "demo-drawer-stale",
                    children: t('demoRequests.drawer.refreshFailed')
                }) : null,
                customer?.doNotContact ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    title: t('demoRequests.drawer.doNotContact'),
                    "data-testid": "demo-drawer-dnc",
                    children: customer.doNotContactReason ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        dir: "auto",
                        children: customer.doNotContactReason
                    }) : t('demoRequests.drawer.doNotContactHint')
                }) : null,
                closed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "neutral",
                    "data-testid": "demo-drawer-closed",
                    children: lead.status === 'lost' && lead.lostReason ? t('demoRequests.drawer.closedLost', {
                        reason: lead.lostReason
                    }) : t('demoRequests.drawer.closed')
                }) : null,
                overdueCount ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    "data-testid": "demo-drawer-overdue",
                    children: t('demoRequests.followUp.overdueAlert', {
                        count: overdueCount
                    })
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap items-center gap-3 rounded-lg border border-border bg-muted/40 p-3",
                    "data-testid": "demo-drawer-owner",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs text-muted-foreground",
                            children: t('demoRequests.owner.label')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$c490570edc799722), {
                                ownerId: lead.ownerId,
                                mySub: mySub
                            })
                        }),
                        !closed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ms-auto flex gap-2",
                            children: !mine ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: lead.ownerId ? 'outline' : 'default',
                                onClick: takeOwnership,
                                disabled: !mySub || !!busy,
                                title: !mySub ? t('demoRequests.owner.unknownMe') : undefined,
                                "aria-busy": busy === 'own' || undefined,
                                "data-testid": "demo-drawer-take",
                                children: [
                                    busy === 'own' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 14,
                                        thickness: 2,
                                        color: "currentColor"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d957a6b316cfc10$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    lead.ownerId ? t('demoRequests.owner.takeOver') : t('demoRequests.owner.take')
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "outline",
                                onClick: release,
                                disabled: !!busy,
                                "aria-busy": busy === 'own' || undefined,
                                "data-testid": "demo-drawer-release",
                                children: [
                                    busy === 'own' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 14,
                                        thickness: 2,
                                        color: "currentColor"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bc764dc168352a5$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    t('demoRequests.owner.release')
                                ]
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$6e2c8f0811a474ce), {
                    title: t('demoRequests.drawer.sections.contact'),
                    "data-testid": "demo-drawer-contact",
                    children: contacts.phones.length || contacts.emails.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "flex flex-col gap-1.5",
                        children: [
                            contacts.phones.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e955eb5b229ff433$var$ContactRow, {
                                    point: p,
                                    testId: `demo-drawer-phone-${p.id}`
                                }, p.id)),
                            contacts.emails.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e955eb5b229ff433$var$ContactRow, {
                                    point: p,
                                    testId: `demo-drawer-email-${p.id}`
                                }, p.id))
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-muted-foreground",
                        children: t('demoRequests.drawer.noContact')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f22b712dea3cd47$export$6e2c8f0811a474ce), {
                    title: t('demoRequests.drawer.sections.request'),
                    "data-testid": "demo-drawer-request",
                    children: [
                        rows.length || pageLead ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            className: "grid grid-cols-2 gap-4 text-sm",
                            children: [
                                rows.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                        label: t(r.labelKey),
                                        value: r.valueKey ? vocab(r.valueKey, r.value) : r.field === 'councilNumber' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                            className: "font-mono",
                                            children: r.value
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            dir: "auto",
                                            children: r.value
                                        }),
                                        "data-testid": `demo-drawer-answer-${r.field}`
                                    }, r.field)),
                                pageLead ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                    wide: true,
                                    label: t('demoRequests.pageLeads.answers.page'),
                                    value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe834c39e294ca41$export$cf060141faaf6cdf), {
                                        lead: lead,
                                        "data-testid": "demo-drawer-page-link"
                                    }),
                                    "data-testid": "demo-drawer-answer-page"
                                }) : null
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            children: t('demoRequests.drawer.noAnswers')
                        }),
                        message ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("blockquote", {
                            dir: "auto",
                            className: "whitespace-pre-line rounded-lg border border-border bg-muted/40 p-3 text-sm",
                            "aria-label": pageLead ? t('demoRequests.pageLeads.message') : undefined,
                            "data-testid": "demo-drawer-message",
                            children: message
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$6e2c8f0811a474ce), {
                    title: t('demoRequests.drawer.sections.origin'),
                    "data-testid": "demo-drawer-origin",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "grid grid-cols-2 gap-4 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                label: t('demoRequests.drawer.reference'),
                                value: details.reference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "inline-flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$52f0f02147b12c03), {
                                            children: details.reference
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4f2558dd25106ae2), {
                                            value: details.reference,
                                            label: t('demoRequests.drawer.copyReference'),
                                            "data-testid": "demo-drawer-reference-copy"
                                        })
                                    ]
                                }) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                label: t('demoRequests.drawer.receivedAt'),
                                value: lead.createdAtMs ? formatDateTime(Number(lead.createdAtMs)) : null
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                label: t('demoRequests.drawer.firstResponse'),
                                // «Not replied to yet» is a claim only a NEW lead can make. A lead
                                // past `new` was answered; when its time cannot be derived (no
                                // contact-made interaction, and the status has moved on since
                                // `contacted`) the honest value is unknown — the dash — not "never".
                                value: response != null ? t('demoRequests.drawer.responseAfter', {
                                    span: $e955eb5b229ff433$export$5e538a3e073acaf5(response, t)
                                }) : lead.status === 'new' ? t('demoRequests.drawer.noResponseYet') : null,
                                "data-testid": "demo-drawer-first-response"
                            }),
                            !pageLead ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                label: t('demoRequests.drawer.formId'),
                                value: details.formId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$52f0f02147b12c03), {
                                    children: details.formId
                                }) : null
                            }) : null,
                            details.landingUrl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                wide: true,
                                label: t('demoRequests.drawer.landingUrl'),
                                "data-testid": "demo-drawer-landing",
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    className: "flex min-w-0 items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                            className: "min-w-0 truncate font-mono text-[12px] font-normal",
                                            title: details.landingUrl,
                                            children: details.landingUrl
                                        }),
                                        landing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            href: landing,
                                            target: "_blank",
                                            rel: "noopener noreferrer nofollow",
                                            className: "inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-primary hover:underline",
                                            "data-testid": "demo-drawer-landing-link",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c35b0991cad9668$export$2e2bcd8739ae039), {
                                                    size: 13,
                                                    "aria-hidden": true
                                                }),
                                                t('demoRequests.drawer.openLink')
                                            ]
                                        }) : null
                                    ]
                                })
                            }) : null,
                            utm.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$4b67f8be7a5e4a15), {
                                wide: true,
                                label: t('demoRequests.drawer.utm'),
                                "data-testid": "demo-drawer-utm",
                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "flex flex-wrap gap-1.5",
                                    children: utm.map(([k, v])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                                className: "font-mono",
                                                children: `utm_${k}=${v}`
                                            })
                                        }, k))
                                })
                            }) : null
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$6e2c8f0811a474ce), {
                    title: t('demoRequests.drawer.sections.sameNumber'),
                    "data-testid": "demo-drawer-same-number",
                    children: sameNumber.status === 'loading' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                        width: "60%"
                    }) : sameNumber.status === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-muted-foreground",
                        children: t('demoRequests.drawer.sameNumberError')
                    }) : !firstPhone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-muted-foreground",
                        children: t('demoRequests.drawer.noContact')
                    }) : sameNumber.items.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "flex flex-col gap-2",
                        children: sameNumber.items.map(({ customer: other, leads: leads })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: "rounded-lg border border-border p-2.5 text-sm",
                                "data-testid": `demo-same-${other.id}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                dir: "auto",
                                                className: "font-semibold",
                                                children: other.fullName
                                            }),
                                            other.createdAtMs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xs text-muted-foreground",
                                                children: formatDateTime(Number(other.createdAtMs))
                                            }) : null,
                                            other.archivedAtMs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                children: t('demoRequests.drawer.archived')
                                            }) : null
                                        ]
                                    }),
                                    leads.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "mt-1.5 flex flex-wrap gap-2",
                                        children: leads.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                    variant: "ghost",
                                                    size: "sm",
                                                    onClick: ()=>onOpenLead(l.id),
                                                    "data-testid": `demo-same-open-${l.id}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7edb116254b1792$export$2e2bcd8739ae039), {
                                                            size: 13,
                                                            "aria-hidden": true,
                                                            style: (0, $c53f9539af19d960$export$ddb338179359cccc)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$52f0f02147b12c03), {
                                                            children: l.requestDetails?.reference || l.id.slice(0, 8)
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$a35d1b968acb385), {
                                                            status: l.status
                                                        })
                                                    ]
                                                })
                                            }, l.id))
                                    }) : null
                                ]
                            }, other.id))
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-muted-foreground",
                        "data-testid": "demo-drawer-same-none",
                        children: t('demoRequests.drawer.sameNumberNone')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f22b712dea3cd47$export$6e2c8f0811a474ce), {
                    title: t('demoRequests.drawer.sections.timeline'),
                    "data-testid": "demo-drawer-timeline",
                    children: [
                        !closed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            "data-testid": "demo-note-composer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                    label: t('demoRequests.note.label'),
                                    value: noteDraft,
                                    onChange: (e)=>setNoteDraft(e.target?.value ?? e),
                                    maxLength: (0, $57e4f51624ccb99c$export$2daf5676b9ee9779),
                                    rows: 2,
                                    disabled: busy === 'note',
                                    "data-testid": "demo-note-input"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        size: "sm",
                                        variant: "outline",
                                        onClick: addNote,
                                        disabled: !noteDraft.trim() || !!busy,
                                        "aria-busy": busy === 'note' || undefined,
                                        "data-testid": "demo-note-add",
                                        children: [
                                            busy === 'note' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                                size: 14,
                                                thickness: 2,
                                                color: "currentColor"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecb8e5bcb990e28a$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": true
                                            }),
                                            t('demoRequests.note.add')
                                        ]
                                    })
                                })
                            ]
                        }) : null,
                        timeline.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                            className: "flex flex-col gap-4",
                            children: timeline.map((entry)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e955eb5b229ff433$var$TimelineItem, {
                                    entry: entry,
                                    mySub: mySub,
                                    closed: closed,
                                    completing: busy === `fu-${entry.item.id}`,
                                    onComplete: completeFollowUp
                                }, entry.id))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            "data-testid": "demo-drawer-timeline-empty",
                            children: t('demoRequests.timeline.empty')
                        })
                    ]
                })
            ]
        });
    }
    const closed = lead ? (0, $57e4f51624ccb99c$export$9c9ec7eceea5d445)(lead.status) : true;
    const moves = lead ? (0, $1528ce4aa57db78e$export$9ccaed87e5cd269d)(lead) : {
        advance: [],
        canLose: false
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
        open: true,
        onClose: closeDrawer,
        width: 640,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": t('demoRequests.drawer.title'),
                className: "flex h-full min-h-0 flex-col",
                "data-testid": "demo-drawer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$bb68d554ded258ea), {
                        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            dir: "auto",
                            "data-testid": "demo-drawer-name",
                            children: title
                        }),
                        sub: lead ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "mt-1 flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$a35d1b968acb385), {
                                    status: lead.status,
                                    "data-testid": "demo-drawer-status"
                                }),
                                lead.requestDetails?.reference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f22b712dea3cd47$export$e67d2dec3698bb2), {
                                    value: lead.requestDetails.reference
                                }) : null
                            ]
                        }) : null,
                        onClose: closeDrawer
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$4ed8420cdfcb2b8f), {
                        children: body
                    }),
                    lead && !closed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$d05a7d25ec5abf06), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex w-full flex-wrap items-center gap-2",
                            "data-testid": "demo-drawer-actions",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    onClick: ()=>setOverlay('log'),
                                    disabled: !!busy,
                                    "data-testid": "demo-action-log",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $970c5cdf933ea69e$export$2e2bcd8739ae039), {
                                            size: 15,
                                            "aria-hidden": true
                                        }),
                                        t('demoRequests.actions.logContact')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: ()=>setOverlay('followUp'),
                                    disabled: !!busy,
                                    "data-testid": "demo-action-followup",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec4bb5a5195718c6$export$2e2bcd8739ae039), {
                                            size: 15,
                                            "aria-hidden": true
                                        }),
                                        t('demoRequests.actions.followUp')
                                    ]
                                }),
                                moves.advance.map((status)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        onClick: ()=>{
                                            setMoveError(null);
                                            setOverlay({
                                                move: status
                                            });
                                        },
                                        disabled: !!busy,
                                        "data-testid": `demo-action-move-${status}`,
                                        children: t('demoRequests.actions.moveTo', {
                                            status: vocab((0, $57e4f51624ccb99c$export$dab13a906eae6c67)(status), status)
                                        })
                                    }, status)),
                                moves.canLose ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "ghost",
                                    className: "ms-auto text-destructive",
                                    onClick: ()=>setOverlay('lost'),
                                    disabled: !!busy,
                                    "data-testid": "demo-action-lost",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                            size: 15,
                                            "aria-hidden": true
                                        }),
                                        t('demoRequests.actions.lost')
                                    ]
                                }) : null
                            ]
                        })
                    }) : null
                ]
            }),
            lead ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08c2883b6f610dc9$export$2e2bcd8739ae039), {
                        open: overlay === 'log',
                        onOpenChange: (o)=>{
                            if (!o) setOverlay(null);
                        },
                        lead: lead,
                        onDone: afterWrite
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54895e39431ac833$export$2e2bcd8739ae039), {
                        open: overlay === 'followUp',
                        onOpenChange: (o)=>{
                            if (!o) setOverlay(null);
                        },
                        lead: lead,
                        mySub: mySub,
                        onDone: afterWrite
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $075e58d1dc92dc07$export$2e2bcd8739ae039), {
                        open: overlay === 'lost',
                        onOpenChange: (o)=>{
                            if (!o) setOverlay(null);
                        },
                        lead: lead,
                        onDone: afterWrite
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                        open: !!overlay?.move,
                        onOpenChange: (o)=>{
                            if (!o && busy !== 'move') setOverlay(null);
                        },
                        title: overlay?.move ? t('demoRequests.move.title', {
                            status: vocab((0, $57e4f51624ccb99c$export$dab13a906eae6c67)(overlay.move), overlay.move)
                        }) : '',
                        description: overlay?.move === 'won' ? t('demoRequests.move.bodyWon') : t('demoRequests.move.body'),
                        confirmLabel: t('demoRequests.move.confirm'),
                        cancelLabel: t('common.actions.cancel'),
                        loading: busy === 'move',
                        onConfirm: confirmMove,
                        "data-testid": "demo-move-dialog",
                        confirmTestId: "demo-move-dialog-confirm",
                        cancelTestId: "demo-move-dialog-cancel",
                        children: moveError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "error",
                            "data-testid": "demo-move-dialog-error",
                            children: moveError
                        }) : null
                    })
                ]
            }) : null
        ]
    });
}


/** A lead id is a uuid; anything else in `?lead=` is junk and falls back to «no drawer». */ const $481676a2f3744c90$var$LEAD_ID = /^[A-Za-z0-9-]{8,64}$/;
/**
 * The URL contract. Defaults are absent from the address; the only entity id
 * that ever appears is the lead's uuid (DESIGN_CONCEPT §13.2) — never a name,
 * a phone number or an e-mail.
 */ const $481676a2f3744c90$var$SCHEMA = {
    // Which queue: demo requests (the default, so every existing link is
    // unchanged) or patients' appointment requests from doctor pages (§D7).
    intent: {
        default: (0, $57e4f51624ccb99c$export$571c06e0117d64c4),
        values: (0, $57e4f51624ccb99c$export$7f0da323261755e2)
    },
    tab: {
        default: 'unanswered',
        values: (0, $1528ce4aa57db78e$export$73b877b58963a4f)
    },
    owner: {
        default: 'all',
        values: (0, $1528ce4aa57db78e$export$d20b8640d99f4581)
    },
    from: {
        default: '',
        parse: (raw)=>/^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : null
    },
    to: {
        default: '',
        parse: (raw)=>/^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : null
    },
    q: {
        default: ''
    },
    page: {
        default: 1,
        parse: (raw)=>Number(raw) || 1
    },
    lead: {
        default: '',
        parse: (raw)=>$481676a2f3744c90$var$LEAD_ID.test(raw) ? raw : null
    }
};
const $481676a2f3744c90$var$EMPTY_ICON = {
    unanswered: (0, $3206cd97f03c9458$export$2e2bcd8739ae039),
    inProgress: (0, $8796e625a2ec43cf$export$2e2bcd8739ae039),
    closed: (0, $357b00fa120a5c4e$export$2e2bcd8739ae039),
    all: (0, $c1d1f5631e6bb3d2$export$2e2bcd8739ae039)
};
/** The list, server-paged and latest-wins; a refetch after a write dims, never blanks. */ function $481676a2f3744c90$var$useLeadList(variables) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const key = JSON.stringify(variables);
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        leads: [],
        total: 0
    });
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [stamp, setStamp] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const seq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const first = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        seq.current += 1;
        const mine = seq.current;
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$9529f28a1af7c0ca), JSON.parse(key)).then((d)=>{
            if (mine !== seq.current) return;
            setData({
                leads: d?.crmLeads?.leads || [],
                total: Number(d?.crmLeads?.total || 0)
            });
            setStamp((s)=>s + 1);
        }).catch((e)=>{
            if (mine === seq.current) setError((0, $d25e8e437795d8de$export$9818a52a86c726ab)(e, t));
        }).finally(()=>{
            if (mine === seq.current) {
                setLoading(false);
                setRefreshing(false);
            }
        });
    }, [
        key,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            quiet: !first.current
        });
        first.current = false;
    }, [
        load
    ]);
    return {
        ...data,
        loading: loading,
        refreshing: refreshing,
        error: error,
        stamp: stamp,
        reload: ()=>load({
                quiet: true
            }),
        retry: ()=>load()
    };
}
/** Lead ids with an OPEN follow-up already past due — a decoration, so a failure is silent. */ function $481676a2f3744c90$var$useOverdueLeads(stamp) {
    const [ids, setIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!stamp) return undefined;
        let live = true;
        (0, $d25e8e437795d8de$export$4ca7f0e3754e6cff)((0, $7a0de4ba2300127a$export$96db00428c5a8fe2), {
            dueBeforeMs: String(Date.now())
        }).then((d)=>{
            if (!live) return;
            setIds(new Set((d?.crmFollowUps?.followUps || []).map((f)=>f.leadId).filter(Boolean)));
        }).catch(()=>{});
        return ()=>{
            live = false;
        };
    }, [
        stamp
    ]);
    return ids;
}
function $481676a2f3744c90$export$2e2bcd8739ae039({ me: me }) {
    const { t: t, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.demoRequests');
    const [view, setView] = (0, $e77179a3ce65222f$export$6a582373474709af)($481676a2f3744c90$var$SCHEMA);
    const mySub = me?.sub || null;
    const variables = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $1528ce4aa57db78e$export$bb8223cae8217a32)(view, {
            mySub: mySub
        }), // `lead` deliberately absent: opening a drawer must not refetch the list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        view.intent,
        view.tab,
        view.owner,
        view.from,
        view.to,
        view.q,
        view.page,
        mySub
    ]);
    const list = $481676a2f3744c90$var$useLeadList(variables);
    const overdue = $481676a2f3744c90$var$useOverdueLeads(list.stamp);
    const newCount = (0, $27f8b163a2bd6068$export$2e2bcd8739ae039)({
        intent: view.intent
    });
    const pageQueue = view.intent === (0, $57e4f51624ccb99c$export$ef13f627afefba0c);
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((patch)=>setView(patch), [
        setView
    ]);
    // Switching queue keeps the tab and filters (they mean the same thing in
    // both), goes back to page 1 and closes a drawer that belongs to the other.
    const changeIntent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((intent)=>{
        if (intent !== view.intent) setView({
            intent: intent,
            page: 1,
            lead: ''
        });
    }, [
        setView,
        view.intent
    ]);
    const changeTab = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((tab)=>{
        if (tab !== view.tab) setView({
            tab: tab,
            page: 1
        });
    }, [
        setView,
        view.tab
    ]);
    // Opening a record is navigation (Back closes it); filters use replace.
    const openLead = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>setView({
            lead: id
        }, {
            push: true
        }), [
        setView
    ]);
    const closeLead = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setView({
            lead: ''
        }), [
        setView
    ]);
    const clearFilters = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setView({
            owner: 'all',
            from: '',
            to: '',
            q: '',
            page: 1
        });
    }, [
        setView
    ]);
    (0, $1528ce4aa57db78e$export$73b877b58963a4f).forEach((name, i)=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)(String(i + 1), ()=>changeTab(name), {
            label: t('shortcuts.action.view', {
                view: t(`demoRequests.tabs.${name}`)
            }),
            group: t('shortcuts.groups.demoRequests')
        });
    });
    // Listed, not claimed: the kit Table opens a focused row on Enter itself.
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('enter', null, {
        label: t('shortcuts.action.openRow'),
        group: t('shortcuts.groups.demoRequests'),
        passive: true
    });
    const filtered = (0, $1528ce4aa57db78e$export$e00bdcbec4a5a6e3)(view);
    const tabLabel = (name)=>name === 'unanswered' && newCount != null ? t('demoRequests.tabs.unansweredCount', {
            count: newCount
        }) : t(`demoRequests.tabs.${name}`);
    const resultLabel = list.loading ? t('demoRequests.loading') : t('demoRequests.count', {
        count: list.total
    });
    const EmptyIcon = pageQueue ? (0, $9b45f4377dc2b059$export$2e2bcd8739ae039) : $481676a2f3744c90$var$EMPTY_ICON[view.tab] || (0, $c1d1f5631e6bb3d2$export$2e2bcd8739ae039);
    const empty = filtered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('demoRequests.emptyFiltered.title'),
        description: t('demoRequests.emptyFiltered.desc'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "outline",
            onClick: clearFilters,
            children: t('common.actions.clearFilters')
        }),
        "data-testid": "demo-requests-empty"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(EmptyIcon, {
            size: 44,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: pageQueue ? t('demoRequests.pageLeads.empty.title') : t(`demoRequests.empty.${view.tab}.title`),
        description: pageQueue ? t('demoRequests.pageLeads.empty.desc') : t(`demoRequests.empty.${view.tab}.desc`),
        "data-testid": "demo-requests-empty"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative flex h-full flex-col bg-background",
        "data-testid": "demo-requests",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('demoRequests.title'),
                sub: pageQueue ? t('demoRequests.pageLeads.sub', {
                    site: (0, $d87bd335296b449f$export$3c6615908c3d10c3)
                }) : t('demoRequests.sub'),
                children: newCount != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: newCount > 0 ? 'warning' : 'outline',
                    className: "text-xs",
                    "data-testid": "demo-requests-new-count",
                    children: t('demoRequests.newCount', {
                        count: newCount
                    })
                }) : null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-3 flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                semantics: "filter",
                                size: "sm",
                                ariaLabel: t('demoRequests.intent.label'),
                                options: (0, $57e4f51624ccb99c$export$7f0da323261755e2).map((value)=>({
                                        value: value,
                                        label: t((0, $57e4f51624ccb99c$export$a3dd10d1dbe08007)(value))
                                    })),
                                value: view.intent,
                                onChange: changeIntent,
                                "data-testid": "demo-requests-intent"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                semantics: "tabs",
                                size: "sm",
                                ariaLabel: t('demoRequests.tabs.label'),
                                options: (0, $1528ce4aa57db78e$export$73b877b58963a4f).map((value)=>({
                                        value: value,
                                        label: tabLabel(value)
                                    })),
                                value: view.tab,
                                onChange: changeTab,
                                "data-testid": "demo-requests-tabs"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "tabpanel",
                        "aria-label": t(`demoRequests.tabs.${view.tab}`),
                        "data-testid": `demo-requests-panel-${view.tab}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b67e09d1d7998f$export$2e2bcd8739ae039), {
                                view: view,
                                onChange: go,
                                onClear: clearFilters,
                                filtered: filtered,
                                resultLabel: resultLabel,
                                canFilterMine: !!mySub
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "rounded-lg border border-border bg-card transition-opacity",
                                style: {
                                    opacity: list.refreshing ? 0.45 : 1
                                },
                                "aria-busy": list.refreshing || undefined,
                                children: list.error && !list.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                    title: t('demoRequests.error'),
                                    description: list.error,
                                    onRetry: list.retry,
                                    retryLabel: t('common.actions.retry'),
                                    "data-testid": "demo-requests-error"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe834c39e294ca41$export$2e2bcd8739ae039), {
                                    intent: view.intent,
                                    rows: list.leads,
                                    loading: list.loading,
                                    mySub: mySub,
                                    overdue: overdue,
                                    onOpen: (r)=>openLead(r.id),
                                    empty: empty
                                })
                            }),
                            !list.loading && !list.error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "demo-requests-pager",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                                    page: Math.max(1, Number(view.page) || 1),
                                    pageCount: (0, $1528ce4aa57db78e$export$7804ac8eb5cfa918)(list.total),
                                    pageSize: (0, $1528ce4aa57db78e$export$8ee0e85f454354b5),
                                    onChange: (page)=>go({
                                            page: page
                                        }),
                                    prevLabel: t('common.pager.prev'),
                                    nextLabel: t('common.pager.next'),
                                    pageLabel: (p, total)=>t('common.pager.label', {
                                            page: p,
                                            total: total
                                        }),
                                    formatNumber: formatNumber
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            view.lead ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e955eb5b229ff433$export$2e2bcd8739ae039), {
                leadId: view.lead,
                mySub: mySub,
                onClose: closeLead,
                onChanged: list.reload,
                onOpenLead: openLead
            }, view.lead) : null
        ]
    });
}



parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");









const $e2c87456717d10d5$var$ISO2 = /^[A-Za-z]{2}$/;
/**
 * Folded for SEARCH, never for display: lower case, no Latin diacritics, «ß»
 * spelled out — «turk» finds «Türkiye» — and Persian left as it is. The kit's
 * own `phone.countryMatches` is used where the pinned kit has it.
 */ const $e2c87456717d10d5$var$fold = (text)=>String(text ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\u00df/g, 'ss').toLowerCase().trim();
function $e2c87456717d10d5$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, existing: existing, onCreated: onCreated }) {
    const { t: t, locale: locale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const knownRegion = (0, $32b5ef4e46f306ee$export$16715c2c372f7c05)();
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [country, setCountry] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [template, setTemplate] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $258fced26b1fac84$export$dec9af6fc3e9284c));
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setQuery('');
        setCountry('');
        setTemplate((0, $258fced26b1fac84$export$dec9af6fc3e9284c));
        setNote('');
        setError(null);
    }, [
        open
    ]);
    const taken = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new Set((existing || []).map((r)=>r.country)), [
        existing
    ]);
    /** Every catalogue country without a row, by name in the panel's language. */ const candidates = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>((0, $412e1a8a99c19c1a$exports).COUNTRIES || []).filter((row)=>!taken.has(row.iso2)).map((row)=>({
                code: row.iso2,
                name: countryName(row.iso2),
                row: row
            })).sort((a, b)=>a.name.localeCompare(b.name, locale)), [
        taken,
        countryName,
        locale
    ]);
    const q = $e2c87456717d10d5$var$fold(query);
    const matches = q ? candidates.filter((c)=>((0, $412e1a8a99c19c1a$exports).countryMatches ? (0, $412e1a8a99c19c1a$exports).countryMatches(c.row, query) : false) || [
            c.code,
            c.name,
            c.row.en,
            c.row.fa
        ].some((n)=>$e2c87456717d10d5$var$fold(n).includes(q))) : candidates;
    // A code the catalogue does not carry: offered when typed in full and known.
    const typed = query.trim().toUpperCase();
    const extra = $e2c87456717d10d5$var$ISO2.test(typed) && !taken.has(typed) && !candidates.some((c)=>c.code === typed) && knownRegion(typed) ? {
        code: typed,
        name: countryName(typed)
    } : null;
    const choices = extra ? [
        ...matches,
        extra
    ] : matches;
    const templates = [
        (0, $258fced26b1fac84$export$dec9af6fc3e9284c),
        ...(existing || []).map((r)=>r.country).filter((c)=>c !== (0, $258fced26b1fac84$export$dec9af6fc3e9284c))
    ];
    const trimmed = note.trim();
    const noteOk = trimmed.length >= (0, $dff16fd5ba545ec2$export$6556e5010b701a8b) && trimmed.length <= (0, $dff16fd5ba545ec2$export$2daf5676b9ee9779);
    const dirty = !!(country || query || note || template !== (0, $258fced26b1fac84$export$dec9af6fc3e9284c));
    const submit = async ()=>{
        if (!country || !noteOk || pending) return;
        setPending(true);
        setError(null);
        try {
            const res = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$50cc98b45b741128), {
                country: country,
                template: template,
                note: trimmed
            });
            const created = res?.createCountryProfile?.country || country;
            onOpenChange(false);
            toast.success(t('countries.create.success', {
                country: countryName(created)
            }));
            onCreated?.(created);
        } catch (e) {
            // Already there — just made by someone else, or never seen by this list.
            setError(e?.code === 'CONFLICT' ? t('countries.create.conflict') : (0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t));
        } finally{
            setPending(false);
        }
    };
    const templateName = template === (0, $258fced26b1fac84$export$dec9af6fc3e9284c) ? '' : `${countryName(template)} (${template})`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('countries.create.title'),
        error: error,
        pending: pending,
        dirty: dirty,
        size: "lg",
        submitLabel: t('countries.create.submit'),
        submitDisabled: !country || !noteOk,
        onSubmit: submit,
        footerNote: !country ? t('countries.create.pickCountry') : !noteOk ? t('countries.edit.noteNeeded') : undefined,
        "data-testid": "country-create",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-sm leading-6 text-muted-foreground",
                children: t('countries.create.body')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "flex min-w-0 flex-col gap-2",
                disabled: pending,
                "data-testid": "country-create-picker",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "mb-1.5 text-[11.5px] font-semibold text-muted-foreground",
                        children: t('countries.create.country')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                        value: query,
                        onChange: (e)=>setQuery(e.target?.value ?? e),
                        onKeyDown: (e)=>{
                            if (e.key === 'Escape' && query) {
                                e.stopPropagation();
                                setQuery('');
                            }
                        },
                        placeholder: t('countries.create.searchPlaceholder'),
                        "aria-label": t('countries.create.searchLabel'),
                        autoFocus: true,
                        "data-testid": "country-create-search"
                    }),
                    !candidates.length && !extra ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "m-0 py-3 text-sm text-muted-foreground",
                        "data-state": "empty",
                        "data-testid": "country-create-empty",
                        children: t('countries.create.empty')
                    }) : !choices.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2 py-3 text-sm text-muted-foreground",
                        "data-state": "empty",
                        "data-testid": "country-create-no-match",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('countries.create.noMatch')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: "sm",
                                onClick: ()=>setQuery(''),
                                children: t('countries.create.clearSearch')
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "radiogroup",
                        "aria-label": t('countries.create.country'),
                        className: "flex max-h-60 flex-col overflow-y-auto rounded-lg border border-border",
                        "data-state": "content",
                        "data-testid": "country-create-choices",
                        children: choices.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex cursor-pointer items-center gap-2.5 border-b border-border px-3 py-2 text-sm last:border-b-0 hover:bg-muted",
                                "data-testid": `country-create-choice-${c.code}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "radio",
                                        name: "country-create-choice",
                                        value: c.code,
                                        checked: country === c.code,
                                        onChange: ()=>setCountry(c.code),
                                        className: "h-4 w-4 accent-primary"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "min-w-0 flex-1 truncate",
                                        children: c.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$34a98f1791d1800e), {
                                        code: c.code
                                    })
                                ]
                            }, c.code))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "country-create-template",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                    label: t('countries.create.template'),
                    value: template,
                    onChange: (e)=>setTemplate(e.target?.value ?? e),
                    options: templates.map((code)=>({
                            value: code,
                            label: code === (0, $258fced26b1fac84$export$dec9af6fc3e9284c) ? t('countries.create.templateFallback') : `${countryName(code)} (${code})`
                        })),
                    placeholder: null,
                    disabled: pending
                })
            }),
            template === (0, $258fced26b1fac84$export$dec9af6fc3e9284c) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "m-0 text-xs leading-5 text-muted-foreground",
                "data-testid": "country-create-same",
                children: t('countries.create.sameAsToday')
            }) : // Not an error: what the choice does — the warning tone, never red.
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                "data-testid": "country-create-copies",
                children: t('countries.create.copiesTemplate', {
                    template: templateName
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "country-create-note",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('countries.edit.note'),
                    required: true,
                    value: note,
                    onChange: (e)=>setNote(e.target?.value ?? e),
                    placeholder: t('countries.create.notePlaceholder'),
                    helperText: t('countries.edit.noteHelper'),
                    maxLength: (0, $dff16fd5ba545ec2$export$2daf5676b9ee9779),
                    showCount: true,
                    rows: 2,
                    disabled: pending
                })
            })
        ]
    });
}


function $a3149e611fd7f21f$export$2e2bcd8739ae039() {
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [creating, setCreating] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$fbf2b21922819b9d)).then((d)=>{
            if (!d?.countryProfiles) throw new Error(t('countries.list.error'));
            setData(d.countryProfiles);
        }).catch((e)=>setError((0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t))).finally(()=>setLoading(false));
    }, [
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const deployment = data?.deployment;
    const rows = data?.profiles || [];
    const fallback = rows.find((r)=>r.country === (0, $258fced26b1fac84$export$dec9af6fc3e9284c)) || null;
    const total = (0, $258fced26b1fac84$export$85405247c394b565).length;
    // false = the editor contract does not answer here; null = could not tell —
    // then the action is offered and the write reports what is wrong.
    const canCreate = !!data && data.editorEnabled !== false;
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('n', ()=>setCreating(true), {
        label: t('countries.create.title'),
        group: t('nav.items.countries'),
        enabled: canCreate && !creating
    });
    const columns = [
        {
            key: 'country',
            header: t('countries.list.columns.country'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex min-w-0 items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "truncate font-semibold text-foreground",
                            children: countryName(r.country)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$34a98f1791d1800e), {
                            code: r.country
                        })
                    ]
                })
        },
        {
            key: 'language',
            header: t('countries.fields.defaultLanguage'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c6f10d457200e8c6), {
                    spec: (0, $258fced26b1fac84$export$4e5c541dacaddeec)('defaultLanguage'),
                    row: r,
                    fallback: fallback
                })
        },
        {
            key: 'currency',
            header: t('countries.fields.defaultCurrency'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c6f10d457200e8c6), {
                    spec: (0, $258fced26b1fac84$export$4e5c541dacaddeec)('defaultCurrency'),
                    row: r,
                    fallback: fallback
                })
        },
        {
            key: 'timezone',
            header: t('countries.fields.defaultTimezone'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c6f10d457200e8c6), {
                    spec: (0, $258fced26b1fac84$export$4e5c541dacaddeec)('defaultTimezone'),
                    row: r,
                    fallback: fallback
                })
        },
        {
            key: 'capabilities',
            header: t('countries.list.columns.capabilities'),
            render: (r)=>{
                const on = (0, $258fced26b1fac84$export$85405247c394b565).filter((s)=>(0, $9e7bf86d7571a736$export$48931898a86c8e6f)(r[s.field]).length);
                const off = (0, $258fced26b1fac84$export$85405247c394b565).filter((s)=>{
                    const { offHere: offHere } = (0, $9e7bf86d7571a736$export$665dab2a2290d7e9)(deployment, s);
                    return (0, $9e7bf86d7571a736$export$48931898a86c8e6f)(r[s.field]).some((v)=>offHere.includes(v));
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "flex flex-wrap items-center gap-x-2",
                    "data-testid": `countries-capabilities-${r.country}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tabular-nums",
                            title: on.map((s)=>t(`countries.fields.${s.field}`)).join(" \xb7 ") || undefined,
                            children: t('countries.list.capabilitiesOn', {
                                on: formatNumber(on.length),
                                total: formatNumber(total)
                            })
                        }),
                        off.length ? // A status, not an error: the warning chip, never red.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "warning",
                            title: t('countries.ceiling.offHereHint'),
                            children: t('countries.list.offHere', {
                                count: off.length
                            })
                        }) : null
                    ]
                });
            }
        },
        {
            key: 'updated',
            header: t('countries.list.columns.updated'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: r.updatedAt ? formatDate(r.updatedAt) : t('common.value.none')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c3d2d38834f5b5cb), {
                            by: r.updatedBy
                        })
                    ]
                })
        },
        {
            key: 'open',
            header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: t('countries.list.columns.open')
            }),
            align: 'end',
            width: '6rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    asChild: true,
                    variant: "ghost",
                    size: "sm",
                    // The row's own handler would fire too and navigate twice.
                    onClick: (e)=>e.stopPropagation(),
                    "data-testid": `countries-row-${r.country}-open`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: (0, $258fced26b1fac84$export$fee178fc4e5672d5)(r.country),
                        "aria-label": t('countries.list.open', {
                            name: countryName(r.country)
                        }),
                        children: [
                            t('common.actions.details'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c31db635520dc385$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: (0, $c53f9539af19d960$export$ddb338179359cccc)
                            })
                        ]
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            canCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: ()=>setCreating(true),
                    "data-testid": "countries-create",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                            size: 16,
                            "aria-hidden": true
                        }),
                        t('countries.create.action')
                    ]
                })
            }) : null,
            deployment?.market === 'intl' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                title: t('countries.ceiling.intlTitle'),
                "data-testid": "countries-alert-intl",
                children: t('countries.ceiling.intlBody')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "countries-loading",
                    "data-state": "loading",
                    role: "status",
                    "aria-busy": "true",
                    "aria-label": t('countries.list.loading'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: Array.from({
                                length: 3
                            }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                                    cols: 7
                                }, i))
                        })
                    })
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('countries.list.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "countries-error"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-state": rows.length ? 'content' : 'empty',
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                        dense: true,
                        ariaLabel: t('countries.list.aria'),
                        columns: columns,
                        rows: rows,
                        rowKey: (r)=>r.country,
                        onRowActivate: (r)=>navigate((0, $258fced26b1fac84$export$fee178fc4e5672d5)(r.country)),
                        rowProps: (r)=>({
                                'data-testid': `countries-row-${r.country}`
                            }),
                        empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd9e54fee16cc3e5$export$2e2bcd8739ae039), {
                                size: 44,
                                strokeWidth: 1.5,
                                "aria-hidden": true
                            }),
                            title: t('countries.list.empty.title'),
                            description: t('countries.list.empty.desc'),
                            "data-testid": "countries-empty"
                        }),
                        "data-testid": "countries-table"
                    })
                })
            }),
            canCreate ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2c87456717d10d5$export$2e2bcd8739ae039), {
                open: creating,
                onOpenChange: setCreating,
                existing: rows,
                onCreated: (code)=>navigate((0, $258fced26b1fac84$export$fee178fc4e5672d5)(code))
            }) : null
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $948595fc4549df01$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ShieldOff", [
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
            key: "1jlk70"
        }
    ],
    [
        "path",
        {
            d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
            key: "18rp1v"
        }
    ]
]);











var $acw62 = parcelRequire("acw62");








/** One spelling: trimmed, inner whitespace collapsed — as the service stores it. */ const $11776ee285d02717$var$squash = (text)=>String(text ?? '').split(/\s+/).filter(Boolean).join(' ');
function $11776ee285d02717$export$2166a2a58c15fd74(text) {
    const out = [];
    for (const line of String(text ?? '').split('\n')){
        const alias = $11776ee285d02717$var$squash(line);
        if (alias && !out.includes(alias)) out.push(alias);
    }
    return out;
}
function $11776ee285d02717$export$793bbffccc2934d9(insurer, country = '') {
    const names = Object.fromEntries((0, $258fced26b1fac84$export$1e3756bae5ae7aad).map((l)=>[
            l,
            ''
        ]));
    for (const n of insurer?.names || [])if (n.locale in names) names[n.locale] = n.name || '';
    // A row written before `names` existed carries only its two columns.
    if (insurer && !Object.values(names).some(Boolean)) {
        names.fa = insurer.nameFa || '';
        names.en = insurer.nameEn || '';
    }
    return {
        id: insurer?.id || '',
        country: insurer?.country || country || '',
        kind: (0, $258fced26b1fac84$export$cc0a61e874d4c05a).includes(insurer?.kind) ? insurer.kind : '',
        names: names,
        aliases: (insurer?.aliases || []).join('\n'),
        registryCode: insurer?.registryCode || '',
        verifyProvider: insurer?.verifyProvider || '',
        // Taken as sent by the service: a new insurer is active unless switched off.
        isActive: insurer ? !!insurer.isActive : true
    };
}
function $11776ee285d02717$export$ceb29a52b83a6e3b(draft) {
    return {
        kind: draft.kind,
        names: (0, $258fced26b1fac84$export$1e3756bae5ae7aad).map((locale)=>({
                locale: locale,
                name: $11776ee285d02717$var$squash(draft.names[locale])
            })).filter((n)=>n.name),
        aliases: $11776ee285d02717$export$2166a2a58c15fd74(draft.aliases),
        registryCode: (0, $258fced26b1fac84$export$a56e7fa6d9a6b884)[draft.country] ? draft.registryCode : '',
        verifyProvider: (0, $258fced26b1fac84$export$7c23c5ff831388b9)[draft.country] ? draft.verifyProvider : '',
        isActive: !!draft.isActive
    };
}
function $11776ee285d02717$export$2fa47d1673d3340e(draft, creating) {
    const p = {};
    if (creating) {
        if (!draft.country) p.country = 'pickCountry';
        const id = draft.id.trim();
        if (!id) p.id = 'idNeeded';
        else if (!(0, $258fced26b1fac84$export$aa99e332cd733a0d).test(id)) p.id = 'idInvalid';
    }
    if (!(0, $258fced26b1fac84$export$cc0a61e874d4c05a).includes(draft.kind)) p.kind = 'pickKind';
    if (!(0, $258fced26b1fac84$export$1813a36678aead02).some((l)=>$11776ee285d02717$var$squash(draft.names[l]))) p.names = 'namesNeeded';
    const aliases = $11776ee285d02717$export$2166a2a58c15fd74(draft.aliases);
    if (aliases.length > (0, $258fced26b1fac84$export$9bb00a937a9c35c4)) p.aliases = 'tooManyAliases';
    else if (aliases.some((a)=>a.length > (0, $258fced26b1fac84$export$22a434d7937a56fb))) p.aliases = 'aliasTooLong';
    return p;
}
const $11776ee285d02717$var$PROBLEM_ORDER = [
    'country',
    'id',
    'kind',
    'names',
    'aliases'
];
function $11776ee285d02717$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, insurer: insurer = null, defaultCountry: defaultCountry = '', catalogs: catalogs = [], onSaved: onSaved }) {
    const { t: t, locale: locale, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const valueString = (0, $32b5ef4e46f306ee$export$7ce5199f876047a)();
    const creating = !insurer;
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$11776ee285d02717$export$793bbffccc2934d9(insurer, defaultCountry));
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // A fresh form every time it opens, from the row as the list holds it NOW.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setDraft($11776ee285d02717$export$793bbffccc2934d9(insurer, defaultCountry));
        setNote('');
        setError(null);
    }, [
        open,
        insurer,
        defaultCountry
    ]);
    const set = (field, value)=>setDraft((d)=>({
                ...d,
                [field]: value
            }));
    const setName = (l, value)=>setDraft((d)=>({
                ...d,
                names: {
                    ...d.names,
                    [l]: value
                }
            }));
    // The catalogues there is data for first, then every other country of the
    // kit's catalogue — each by its name in the panel's language.
    const catalogKey = [
        ...new Set([
            ...(0, $258fced26b1fac84$export$d7e8642240c28acd),
            ...catalogs,
            ...defaultCountry ? [
                defaultCountry
            ] : []
        ])
    ].join(',');
    const countries = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const byName = (a, b)=>countryName(a).localeCompare(countryName(b), locale);
        const known = catalogKey.split(',').filter(Boolean).sort(byName);
        const rest = ((0, $412e1a8a99c19c1a$exports).COUNTRIES || []).map((r)=>r.iso2).filter((c)=>c && !known.includes(c)).sort(byName);
        return [
            ...known,
            ...rest
        ];
    }, [
        catalogKey,
        countryName,
        locale
    ]);
    const registryCodes = (0, $258fced26b1fac84$export$a56e7fa6d9a6b884)[draft.country] || null;
    const verifyProviders = (0, $258fced26b1fac84$export$7c23c5ff831388b9)[draft.country] || null;
    const problems = $11776ee285d02717$export$2fa47d1673d3340e(draft, creating);
    const input = $11776ee285d02717$export$ceb29a52b83a6e3b(draft);
    const changed = creating || JSON.stringify(input) !== JSON.stringify($11776ee285d02717$export$ceb29a52b83a6e3b($11776ee285d02717$export$793bbffccc2934d9(insurer)));
    const trimmed = note.trim();
    const noteOk = trimmed.length >= (0, $dff16fd5ba545ec2$export$6556e5010b701a8b) && trimmed.length <= (0, $dff16fd5ba545ec2$export$2daf5676b9ee9779);
    const valid = Object.keys(problems).length === 0;
    const dirty = creating ? JSON.stringify(draft) !== JSON.stringify($11776ee285d02717$export$793bbffccc2934d9(null, defaultCountry)) || !!note : changed || !!note;
    const maxOf = (problem)=>formatNumber(problem === 'tooManyAliases' ? (0, $258fced26b1fac84$export$9bb00a937a9c35c4) : (0, $258fced26b1fac84$export$22a434d7937a56fb));
    const problemText = (problem)=>t(`countries.insurers.editor.problem.${problem}`, {
            max: maxOf(problem)
        });
    const first = $11776ee285d02717$var$PROBLEM_ORDER.map((k)=>problems[k]).find(Boolean);
    const footerNote = first ? problemText(first) : !changed ? t('countries.edit.noChanges') : !noteOk ? t('countries.edit.noteNeeded') : undefined;
    const name = (0, $32b5ef4e46f306ee$export$2d9f8e8c6b986160)(insurer, locale);
    /** The saved row's name, for the toast — the panel's language first, like the list. */ const savedName = (saved)=>(0, $32b5ef4e46f306ee$export$2d9f8e8c6b986160)(saved, locale) || (0, $32b5ef4e46f306ee$export$2d9f8e8c6b986160)({
            names: input.names,
            nameFa: '',
            nameEn: ''
        }, locale) || draft.id;
    const submit = async ()=>{
        if (pending || !valid || !changed || !noteOk) return;
        setPending(true);
        setError(null);
        try {
            let saved;
            if (creating) {
                const res = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$9af6c654c0f40355), {
                    input: {
                        id: draft.id.trim(),
                        country: draft.country,
                        ...input
                    },
                    note: trimmed
                });
                saved = res?.createInsurer;
            } else {
                const res = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$9d31a091427e8e4a), {
                    id: insurer.id,
                    input: input,
                    note: trimmed,
                    expectedUpdatedAt: insurer.updatedAt ?? null
                });
                saved = res?.updateInsurer;
            }
            onOpenChange(false);
            toast.success(creating ? t('countries.insurers.editor.created', {
                name: savedName(saved),
                country: countryName(draft.country)
            }) : t('countries.insurers.editor.saved', {
                name: savedName(saved)
            }));
            onSaved?.(saved || null);
        } catch (e) {
            setError((0, $32b5ef4e46f306ee$export$f3aa0376b22f8805)(e, t, {
                creating: creating
            }));
        } finally{
            setPending(false);
        }
    };
    /** A key select: «هیچ» first, then the closed list, then whatever the row holds outside it. */ const keyOptions = (list, current)=>{
        const known = [
            ...list,
            ...current && !list.includes(current) ? [
                current
            ] : []
        ];
        return [
            {
                value: '',
                label: t('countries.state.none')
            },
            ...known.map((k)=>({
                    value: k,
                    label: list.includes(k) ? `${t(`countries.insurers.registryName.${k}`)} (${k})` : k
                }))
        ];
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: creating ? t('countries.insurers.editor.createTitle') : t('countries.insurers.editor.editTitle', {
            name: name
        }),
        error: error,
        pending: pending,
        dirty: dirty,
        size: "lg",
        // A long form: the header and the submit stay put while the fields scroll.
        layout: "frame",
        submitLabel: creating ? t('countries.insurers.editor.submitCreate') : t('countries.edit.submit'),
        submitDisabled: !valid || !changed || !noteOk,
        onSubmit: submit,
        footerNote: footerNote,
        "data-testid": "insurer-editor",
        children: [
            creating ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "m-0 text-sm leading-6 text-muted-foreground",
                        children: t('countries.insurers.editor.body')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-3 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "insurer-editor-country",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                    label: t('countries.insurers.editor.country'),
                                    required: true,
                                    value: draft.country,
                                    onChange: (e)=>set('country', e.target?.value ?? e),
                                    options: countries.map((code)=>({
                                            value: code,
                                            label: `${countryName(code)} (${code})`
                                        })),
                                    placeholder: t('countries.insurers.editor.countryPick'),
                                    disabled: pending
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "insurer-editor-id",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('countries.insurers.editor.id'),
                                    required: true,
                                    value: draft.id,
                                    onChange: (e)=>set('id', e.target?.value ?? e),
                                    dir: "ltr",
                                    autoComplete: "off",
                                    spellCheck: false,
                                    maxLength: (0, $258fced26b1fac84$export$fadcbd0571ba7f6c),
                                    placeholder: t('countries.insurers.editor.idExample'),
                                    helperText: problems.id === 'idInvalid' ? undefined : t('countries.insurers.editor.idRule'),
                                    error: problems.id === 'idInvalid' ? t('countries.insurers.editor.idInvalid') : undefined,
                                    disabled: pending
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1.5",
                "data-testid": "insurer-editor-fixed",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                        className: "m-0 grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-4 gap-y-1.5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: t('countries.insurers.editor.id')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "m-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                    className: "font-mono text-xs",
                                    "data-testid": "insurer-editor-fixed-id",
                                    children: insurer.id
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                className: "text-muted-foreground",
                                children: t('countries.insurers.editor.country')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: "m-0 flex items-center gap-2",
                                "data-testid": "insurer-editor-fixed-country",
                                children: [
                                    countryName(insurer.country),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$34a98f1791d1800e), {
                                        code: insurer.country
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "m-0 text-xs leading-5 text-muted-foreground",
                        children: t('countries.insurers.editor.fixed')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "flex min-w-0 flex-col gap-2",
                disabled: pending,
                "data-testid": "insurer-editor-kind",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "mb-1.5 text-[11.5px] font-semibold text-muted-foreground",
                        children: t('countries.insurers.editor.kind')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "radiogroup",
                        "aria-label": t('countries.insurers.editor.kind'),
                        className: "grid grid-cols-1 gap-2 md:grid-cols-2",
                        children: (0, $258fced26b1fac84$export$cc0a61e874d4c05a).map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex cursor-pointer items-start gap-2.5 rounded-lg border border-border px-3 py-2.5 text-sm hover:bg-muted",
                                "data-state": draft.kind === k ? 'checked' : 'unchecked',
                                "data-testid": `insurer-editor-kind-${k}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "radio",
                                        name: "insurer-editor-kind",
                                        value: k,
                                        checked: draft.kind === k,
                                        onChange: ()=>set('kind', k),
                                        className: "mt-1 h-4 w-4 shrink-0 accent-primary"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "flex min-w-0 flex-col gap-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-semibold text-foreground",
                                                children: t(`countries.insurers.kind.${k}`)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xs leading-5 text-muted-foreground",
                                                children: t(`countries.insurers.editor.kindHint.${k}`)
                                            })
                                        ]
                                    })
                                ]
                            }, k))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                className: "flex min-w-0 flex-col gap-2",
                disabled: pending,
                "data-testid": "insurer-editor-names",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                        className: "mb-1.5 text-[11.5px] font-semibold text-muted-foreground",
                        children: t('countries.insurers.editor.names')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "m-0 text-[11.5px] leading-5 text-muted-foreground",
                        children: t('countries.insurers.editor.namesRule')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-1 gap-x-3 gap-y-2 md:grid-cols-2",
                        children: (0, $258fced26b1fac84$export$1e3756bae5ae7aad).map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": `insurer-editor-name-${l}`,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: valueString({
                                        type: 'language'
                                    }, l),
                                    value: draft.names[l],
                                    onChange: (e)=>setName(l, e.target?.value ?? e),
                                    // User content: its own direction, whatever the panel's (DESKTOP_WEB §13).
                                    dir: "auto",
                                    lang: l,
                                    maxLength: (0, $258fced26b1fac84$export$6c0749a97386cf4b),
                                    disabled: pending
                                })
                            }, l))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "insurer-editor-aliases",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('countries.insurers.editor.aliases'),
                    value: draft.aliases,
                    onChange: (e)=>set('aliases', e.target?.value ?? e),
                    helperText: problems.aliases ? undefined : t('countries.insurers.editor.aliasesHelper'),
                    error: problems.aliases ? problemText(problems.aliases) : undefined,
                    rows: 3,
                    dir: "auto",
                    disabled: pending
                })
            }),
            registryCodes || verifyProviders ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-1 gap-3 md:grid-cols-2",
                "data-testid": "insurer-editor-keys",
                children: [
                    registryCodes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "insurer-editor-registry",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                            label: t('countries.insurers.columns.registry'),
                            value: draft.registryCode,
                            onChange: (e)=>set('registryCode', e.target?.value ?? e),
                            options: keyOptions(registryCodes, draft.registryCode),
                            placeholder: null,
                            helperText: t('countries.insurers.editor.registryHint'),
                            disabled: pending
                        })
                    }) : null,
                    verifyProviders ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "data-testid": "insurer-editor-verify",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                            label: t('countries.insurers.columns.verify'),
                            value: draft.verifyProvider,
                            onChange: (e)=>set('verifyProvider', e.target?.value ?? e),
                            options: keyOptions(verifyProviders, draft.verifyProvider),
                            placeholder: null,
                            helperText: t('countries.insurers.editor.verifyHint'),
                            disabled: pending
                        })
                    }) : null
                ]
            }) : draft.country ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "m-0 text-xs leading-5 text-muted-foreground",
                "data-testid": "insurer-editor-no-keys",
                children: t('countries.insurers.editor.noRegistry', {
                    country: countryName(draft.country)
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                checked: draft.isActive,
                onChange: (v)=>set('isActive', !!v),
                label: t('countries.insurers.editor.active'),
                disabled: pending,
                "data-testid": "insurer-editor-active"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "insurer-editor-note",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('countries.edit.note'),
                    required: true,
                    value: note,
                    onChange: (e)=>setNote(e.target?.value ?? e),
                    placeholder: t('countries.insurers.editor.notePlaceholder'),
                    helperText: t('countries.edit.noteHelper'),
                    maxLength: (0, $dff16fd5ba545ec2$export$2daf5676b9ee9779),
                    showCount: true,
                    rows: 2,
                    disabled: pending
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");







/** The most a history read asks for (the contract's ceiling). */ const $43c8882324ab8a63$var$HISTORY_LIMIT = 200;
/**
 * The service's snapshot keys → the label they read as. Columns that move
 * together read as one: the names map and its two copies, the verifier and
 * the legacy `tamin_code` that follows it.
 */ const $43c8882324ab8a63$var$FIELD_LABELS = {
    id: 'id',
    country: 'country',
    kind: 'kind',
    names: 'names',
    name_fa: 'names',
    name_en: 'names',
    aliases: 'aliases',
    registry_code: 'registry',
    verify_provider: 'verify',
    tamin_code: 'verify',
    is_active: 'active',
    sort_order: 'sortOrder',
    is_self_pay: 'selfPay'
};
/** A snapshot (JSON), pretty-printed — or verbatim if it is not JSON. */ function $43c8882324ab8a63$var$pretty(json) {
    if (!json) return '';
    try {
        return JSON.stringify(JSON.parse(json), null, 2);
    } catch  {
        return json;
    }
}
function $43c8882324ab8a63$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, insurer: insurer = null, name: name = '', nameOfId: nameOfId }) {
    const { t: t, has: has, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        loading: true,
        error: null,
        changes: []
    });
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $cdf3712044ab22f9$export$4946d8446c21041b));
    const [opened, setOpened] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const seq = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const insurerId = insurer?.id ?? null;
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const call = ++seq.current;
        setState({
            loading: true,
            error: null,
            changes: []
        });
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$7e92d2b91cf1ac4e), {
            insurerId: insurerId,
            limit: $43c8882324ab8a63$var$HISTORY_LIMIT
        }).then((d)=>{
            if (call !== seq.current) return;
            if (!Array.isArray(d?.insurerChanges)) throw new Error(t('countries.insurers.history.error'));
            setState({
                loading: false,
                error: null,
                changes: d.insurerChanges
            });
        }).catch((e)=>{
            if (call !== seq.current) return;
            setState({
                loading: false,
                error: (0, $32b5ef4e46f306ee$export$f3aa0376b22f8805)(e, t),
                changes: []
            });
        });
    }, [
        insurerId,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setShown((0, $cdf3712044ab22f9$export$4946d8446c21041b));
        setOpened(null);
        load();
    }, [
        open,
        load
    ]);
    /** The labels of a change's columns, each once, in the order the BFF sorted them. */ const fieldLabels = (fields)=>[
            ...new Set((fields || []).map((f)=>{
                const key = `countries.insurers.fields.${$43c8882324ab8a63$var$FIELD_LABELS[f] || f}`;
                return has(key) ? t(key) : f;
            }))
        ];
    const all = state.changes;
    const rows = all.slice(0, shown).map((c, i)=>({
            ...c,
            key: i
        }));
    const more = all.length - rows.length;
    const detailRow = rows.find((c)=>c.key === opened);
    const columns = [
        {
            key: 'at',
            header: t('countries.history.columns.at'),
            render: (c)=>c.changedAt ? formatDateTime(c.changedAt) : t('common.value.none')
        },
        ...insurer ? [] : [
            {
                key: 'insurer',
                header: t('countries.insurers.history.insurer'),
                render: (c)=>{
                    const label = nameOfId?.(c.insurerId);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex min-w-0 items-center gap-2",
                        children: [
                            label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dir: "auto",
                                className: "truncate",
                                children: label
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                className: "font-mono text-xs text-muted-foreground",
                                children: c.insurerId
                            })
                        ]
                    });
                }
            }
        ],
        {
            key: 'by',
            header: t('countries.history.columns.by'),
            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c3d2d38834f5b5cb), {
                    by: c.changedBy
                })
        },
        {
            key: 'fields',
            header: t('countries.insurers.history.fields'),
            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "flex flex-wrap gap-1",
                    children: c.created ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: "outline",
                        children: t('countries.insurers.history.created')
                    }) : fieldLabels(c.changedFields).map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: f
                        }, f))
                })
        },
        {
            key: 'note',
            header: t('countries.history.columns.note'),
            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    className: "block max-w-[16rem] truncate",
                    title: c.note || '',
                    children: c.note || t('common.value.none')
                })
        },
        {
            key: 'detail',
            header: t('countries.history.columns.detail'),
            render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "ghost",
                    size: "sm",
                    onClick: ()=>setOpened(opened === c.key ? null : c.key),
                    "aria-expanded": opened === c.key,
                    "aria-label": t('countries.history.showRow'),
                    "data-testid": `insurer-history-toggle-${c.key}`,
                    children: opened === c.key ? t('common.actions.hide') : t('common.actions.show')
                })
        }
    ];
    let body;
    if (state.loading) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "status",
        "aria-busy": "true",
        "aria-label": t('countries.insurers.history.loading'),
        "data-state": "loading",
        "data-testid": "insurer-history-loading",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: Array.from({
                    length: 3
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                        cols: insurer ? 5 : 6
                    }, i))
            })
        })
    });
    else if (state.error) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: t('countries.insurers.history.error'),
        description: state.error,
        onRetry: load,
        retryLabel: t('common.actions.retry'),
        "data-testid": "insurer-history-error"
    });
    else if (!rows.length) {
        const empty = insurer ? 'empty' : 'allEmpty';
        body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                size: 40,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: t(`countries.insurers.history.${empty}.title`),
            description: t(`countries.insurers.history.${empty}.desc`),
            "data-testid": "insurer-history-empty"
        });
    } else body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2",
        "data-state": "content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                dense: true,
                ariaLabel: t('countries.insurers.history.aria'),
                rowKey: (c)=>c.key,
                rows: rows,
                rowProps: (c)=>({
                        'data-testid': `insurer-history-row-${c.key}`
                    }),
                columns: columns,
                "data-testid": "insurer-history-table"
            }),
            detailRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-1 gap-3 md:grid-cols-2",
                "data-testid": "insurer-history-detail",
                children: [
                    [
                        'before',
                        detailRow.before
                    ],
                    [
                        'after',
                        detailRow.after
                    ]
                ].map(([side, json])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-1 text-xs text-muted-foreground",
                                children: t(`countries.history.${side}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                className: "max-h-64 overflow-auto rounded-lg bg-muted p-3 text-[11px] leading-5",
                                children: json ? $43c8882324ab8a63$var$pretty(json) : t('common.value.none')
                            })
                        ]
                    }, side))
            }) : null,
            more > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    size: "sm",
                    onClick: ()=>setShown((n)=>n + (0, $cdf3712044ab22f9$export$4946d8446c21041b)),
                    "data-testid": "insurer-history-more",
                    children: t('countries.history.more')
                })
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            size: "xl",
            "data-testid": "insurer-history",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                        children: insurer ? t('countries.insurers.history.title', {
                            name: name
                        }) : t('countries.insurers.history.allTitle')
                    })
                }),
                body,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    className: "mt-6 items-center justify-start gap-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        onClick: ()=>onOpenChange(false),
                        "data-testid": "insurer-history-close",
                        children: t('common.actions.close')
                    })
                })
            ]
        })
    });
}


function $b32b937ff5e8a67b$export$2e2bcd8739ae039({ view: view, onChange: onChange }) {
    const { t: t, locale: locale } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The row a dialog is about is kept apart from whether it is open, so a
    // closing dialog does not flip to «add» on its way out.
    const [editOpen, setEditOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [editRow, setEditRow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [historyOpen, setHistoryOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [historyRow, setHistoryRow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const variables = {
        country: view.catalog || null,
        includeInactive: view.inactive === '1'
    };
    const key = JSON.stringify(variables);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$a57f29a8b9ad7075), JSON.parse(key)).then((d)=>{
            if (!d?.countryInsurers) throw new Error(t('countries.insurers.error'));
            setData(d.countryInsurers);
        }).catch((e)=>setError((0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t))).finally(()=>setLoading(false));
    }, [
        key,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    // The catalogues there is data for, plus one the URL names (a deep link to a
    // key accounting does not hold yet is still a question worth answering).
    const catalogs = [
        ...new Set([
            ...(0, $258fced26b1fac84$export$d7e8642240c28acd),
            ...view.catalog ? [
                view.catalog
            ] : []
        ])
    ];
    const insurers = data?.insurers || [];
    // false = the editor does not answer here; null = could not tell — offered.
    const canEdit = !!data?.configured && data.editorEnabled !== false;
    const nameOf = (r)=>(0, $32b5ef4e46f306ee$export$2d9f8e8c6b986160)(r, locale);
    const openEditor = (row)=>{
        setEditRow(row);
        setEditOpen(true);
    };
    const openHistory = (row)=>{
        setHistoryRow(row);
        setHistoryOpen(true);
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('n', ()=>openEditor(null), {
        label: t('countries.insurers.editor.createTitle'),
        group: t('nav.items.countries'),
        enabled: canEdit && !editOpen && !historyOpen
    });
    /** After a write: read the list again; a new insurer outside the filter brings its country's catalogue into view. */ const saved = (record)=>{
        if (record?.country && view.catalog && record.country !== view.catalog && !record.isSelfPay) {
            onChange({
                catalog: record.country
            });
            return;
        }
        load();
    };
    const columns = [
        {
            key: 'name',
            header: t('countries.insurers.columns.name'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    className: "truncate font-semibold text-foreground",
                    title: r.nameFa,
                    children: nameOf(r)
                })
        },
        {
            key: 'country',
            header: t('countries.insurers.columns.catalog'),
            render: (r)=>r.isSelfPay ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: t('countries.insurers.everyCatalog')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: "flex items-center gap-2",
                    children: [
                        countryName(r.country),
                        " ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$34a98f1791d1800e), {
                            code: r.country
                        })
                    ]
                })
        },
        {
            key: 'kind',
            header: t('countries.insurers.columns.kind'),
            render: (r)=>r.isSelfPay ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "outline",
                    children: t('countries.insurers.selfPay')
                }) : t(`countries.insurers.kind.${r.kind}`)
        },
        {
            key: 'registry',
            header: t('countries.insurers.columns.registry'),
            render: (r)=>r.registryCode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                    className: "font-mono text-xs",
                    children: r.registryCode
                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'verify',
            header: t('countries.insurers.columns.verify'),
            render: (r)=>r.verifyProvider ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                    ...(0, $c53f9539af19d960$export$3433559efc22d110),
                    className: "font-mono text-xs",
                    children: r.verifyProvider
                }) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'active',
            header: t('countries.insurers.columns.status'),
            render: (r)=>r.isActive ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "success",
                    children: t('countries.insurers.active')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "outline",
                    children: t('countries.insurers.inactive')
                })
        },
        ...canEdit ? [
            {
                key: 'actions',
                header: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "sr-only",
                    children: t('countries.insurers.columns.actions')
                }),
                align: 'end',
                render: (r)=>r.isSelfPay ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "whitespace-nowrap text-xs text-muted-foreground",
                        title: t('countries.insurers.selfPayHint'),
                        "data-testid": `countries-insurer-${r.id}-read-only`,
                        children: t('countries.insurers.readOnlyRow')
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "flex items-center justify-end gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: "sm",
                                onClick: ()=>openHistory(r),
                                "aria-label": t('countries.insurers.actions.historyOf', {
                                    name: nameOf(r)
                                }),
                                "data-testid": `countries-insurer-${r.id}-history`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    t('countries.insurers.actions.history')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: "sm",
                                onClick: ()=>openEditor(r),
                                "aria-label": t('countries.insurers.actions.editOf', {
                                    name: nameOf(r)
                                }),
                                "data-testid": `countries-insurer-${r.id}-edit`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    t('countries.insurers.actions.edit')
                                ]
                            })
                        ]
                    })
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3",
                "data-testid": "countries-insurers-toolbar",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "group",
                        "aria-label": t('countries.insurers.filterLabel'),
                        className: "flex flex-wrap gap-1.5",
                        children: [
                            '',
                            ...catalogs
                        ].map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                label: c ? `${countryName(c)} (${c})` : t('countries.insurers.all'),
                                active: (view.catalog || '') === c,
                                onClick: ()=>onChange({
                                        catalog: c
                                    }),
                                "data-testid": `countries-insurers-filter-${c || 'all'}`
                            }, c || 'all'))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                        checked: view.inactive === '1',
                        onChange: (v)=>onChange({
                                inactive: v ? '1' : ''
                            }),
                        label: t('countries.insurers.showInactive'),
                        "data-testid": "countries-insurers-inactive"
                    }),
                    canEdit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ms-auto flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                size: "sm",
                                onClick: ()=>openHistory(null),
                                "data-testid": "countries-insurers-history",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    t('countries.insurers.actions.allHistory')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                size: "sm",
                                onClick: ()=>openEditor(null),
                                "data-testid": "countries-insurers-create",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true
                                    }),
                                    t('countries.insurers.actions.create')
                                ]
                            })
                        ]
                    }) : data?.configured ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ms-auto text-xs text-muted-foreground",
                        "data-testid": "countries-insurers-read-only",
                        children: t('countries.insurers.readOnly')
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rounded-lg border border-border bg-card",
                children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-testid": "countries-insurers-loading",
                    "data-state": "loading",
                    role: "status",
                    "aria-busy": "true",
                    "aria-label": t('countries.insurers.loading'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                            children: Array.from({
                                length: 5
                            }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                                    cols: 6
                                }, i))
                        })
                    })
                }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                    title: t('countries.insurers.error'),
                    description: error,
                    onRetry: load,
                    retryLabel: t('common.actions.retry'),
                    "data-testid": "countries-insurers-error"
                }) : !data.configured ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $948595fc4549df01$export$2e2bcd8739ae039), {
                        size: 44,
                        strokeWidth: 1.5,
                        "aria-hidden": true
                    }),
                    title: t('countries.insurers.unconfigured.title'),
                    description: t('countries.insurers.unconfigured.desc'),
                    "data-testid": "countries-insurers-unconfigured"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-state": insurers.length ? 'content' : 'empty',
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                        dense: true,
                        ariaLabel: t('countries.insurers.aria'),
                        columns: columns,
                        rows: insurers,
                        rowKey: (r)=>r.id,
                        rowProps: (r)=>({
                                'data-testid': `countries-insurer-${r.id}`
                            }),
                        empty: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                                size: 44,
                                strokeWidth: 1.5,
                                "aria-hidden": true
                            }),
                            title: t('countries.insurers.empty.title'),
                            description: t('countries.insurers.empty.desc'),
                            "data-testid": "countries-insurers-empty"
                        }),
                        "data-testid": "countries-insurers-table"
                    })
                })
            }),
            canEdit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11776ee285d02717$export$2e2bcd8739ae039), {
                        open: editOpen,
                        onOpenChange: setEditOpen,
                        insurer: editRow,
                        defaultCountry: view.catalog || '',
                        catalogs: [
                            ...catalogs,
                            ...insurers.filter((r)=>!r.isSelfPay).map((r)=>r.country)
                        ],
                        onSaved: saved
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43c8882324ab8a63$export$2e2bcd8739ae039), {
                        open: historyOpen,
                        onOpenChange: setHistoryOpen,
                        insurer: historyRow,
                        name: nameOf(historyRow),
                        nameOfId: (id)=>{
                            const row = insurers.find((r)=>r.id === id);
                            return row ? nameOf(row) : null;
                        }
                    })
                ]
            }) : null
        ]
    });
}


const $be488fb1238302b9$export$50bf86b71c5fd0d9 = [
    'profiles',
    'insurers'
];
/** The URL contract (DESIGN_CONCEPT §3.2). Defaults are absent from the address. */ const $be488fb1238302b9$var$SCHEMA = {
    view: {
        default: 'profiles',
        values: $be488fb1238302b9$export$50bf86b71c5fd0d9
    },
    // The insurer catalogue shown: an ISO key (IR, IQ …); '' = every row. Junk
    // is dropped rather than sent (the BFF would refuse it).
    catalog: {
        default: '',
        parse: (raw)=>/^[A-Za-z]{2}$/.test(raw) ? raw.toUpperCase() : null
    },
    inactive: {
        default: '',
        values: [
            '',
            '1'
        ]
    }
};
function $be488fb1238302b9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.countries');
    const [view, setView] = (0, $e77179a3ce65222f$export$6a582373474709af)($be488fb1238302b9$var$SCHEMA);
    const changeView = (next)=>{
        if (next !== view.view) setView({
            view: next,
            catalog: '',
            inactive: ''
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "countries",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('countries.title'),
                sub: t('countries.sub'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                    semantics: "tabs",
                    size: "sm",
                    ariaLabel: t('countries.views.label'),
                    options: $be488fb1238302b9$export$50bf86b71c5fd0d9.map((value)=>({
                            value: value,
                            label: t(`countries.views.${value}`)
                        })),
                    value: view.view,
                    onChange: changeView,
                    "data-testid": "countries-tabs"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "tabpanel",
                    "aria-label": t(`countries.views.${view.view}`),
                    className: "mx-auto w-full max-w-[1440px]",
                    "data-testid": `countries-panel-${view.view}`,
                    children: view.view === 'insurers' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b32b937ff5e8a67b$export$2e2bcd8739ae039), {
                        view: view,
                        onChange: setView
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3149e611fd7f21f$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $745f31c3d9f7add9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Fingerprint", [
    [
        "path",
        {
            d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4",
            key: "1nerag"
        }
    ],
    [
        "path",
        {
            d: "M14 13.12c0 2.38 0 6.38-1 8.88",
            key: "o46ks0"
        }
    ],
    [
        "path",
        {
            d: "M17.29 21.02c.12-.6.43-2.3.5-3.02",
            key: "ptglia"
        }
    ],
    [
        "path",
        {
            d: "M2 12a10 10 0 0 1 18-6",
            key: "ydlgp0"
        }
    ],
    [
        "path",
        {
            d: "M2 16h.01",
            key: "1gqxmh"
        }
    ],
    [
        "path",
        {
            d: "M21.8 16c.2-2 .131-5.354 0-6",
            key: "drycrb"
        }
    ],
    [
        "path",
        {
            d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2",
            key: "1tidbn"
        }
    ],
    [
        "path",
        {
            d: "M8.65 22c.21-.66.45-1.32.57-2",
            key: "13wd9y"
        }
    ],
    [
        "path",
        {
            d: "M9 6.8a6 6 0 0 1 9 5.2v2",
            key: "1fr1j5"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $623cbfccc983e6a1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Languages", [
    [
        "path",
        {
            d: "m5 8 6 6",
            key: "1wu5hv"
        }
    ],
    [
        "path",
        {
            d: "m4 14 6-6 2-3",
            key: "1k1g8d"
        }
    ],
    [
        "path",
        {
            d: "M2 5h12",
            key: "or177f"
        }
    ],
    [
        "path",
        {
            d: "M7 2h1",
            key: "1t2jsx"
        }
    ],
    [
        "path",
        {
            d: "m22 22-5-10-5 10",
            key: "don7ne"
        }
    ],
    [
        "path",
        {
            d: "M14 18h6",
            key: "1m8k6r"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8572ce782cce49ee$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Plug", [
    [
        "path",
        {
            d: "M12 22v-5",
            key: "1ega77"
        }
    ],
    [
        "path",
        {
            d: "M9 8V2",
            key: "14iosj"
        }
    ],
    [
        "path",
        {
            d: "M15 8V2",
            key: "18g5xt"
        }
    ],
    [
        "path",
        {
            d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z",
            key: "osxo6l"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1cbb901abf788f33$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Printer", [
    [
        "path",
        {
            d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
            key: "143wyd"
        }
    ],
    [
        "path",
        {
            d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6",
            key: "1itne7"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "14",
            width: "12",
            height: "8",
            rx: "1",
            key: "1ue0tg"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9a9bbf84fd0f8247$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ScrollText", [
    [
        "path",
        {
            d: "M15 12h-5",
            key: "r7krc0"
        }
    ],
    [
        "path",
        {
            d: "M15 8h-5",
            key: "1khuty"
        }
    ],
    [
        "path",
        {
            d: "M19 17V5a2 2 0 0 0-2-2H4",
            key: "zz82l3"
        }
    ],
    [
        "path",
        {
            d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
            key: "1ph1d7"
        }
    ]
]);












var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e20ffdae2aa9b33f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Lock", [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
]);





/** A history snapshot (JSON keyed by column), pretty-printed — or verbatim if it is not JSON. */ function $c219c659acd3378b$var$pretty(json) {
    if (!json) return '';
    try {
        return JSON.stringify(JSON.parse(json), null, 2);
    } catch  {
        return json;
    }
}
function $c219c659acd3378b$export$2e2bcd8739ae039({ loading: loading, error: error, disabled: disabled, changes: changes, onRetry: onRetry }) {
    const { t: t, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const columnLabel = (0, $32b5ef4e46f306ee$export$4768687337cb1384)();
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $cdf3712044ab22f9$export$4946d8446c21041b));
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const rows = (changes || []).slice(0, shown);
    const more = (changes || []).length - rows.length;
    const opened = (changes || []).find((c)=>c.id === open);
    let body;
    if (loading) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "status",
        "aria-busy": "true",
        "aria-label": t('countries.history.loading'),
        "data-state": "loading",
        "data-testid": "country-history-loading",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: Array.from({
                    length: 3
                }).map((_, i)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                        cols: 5
                    }, i))
            })
        })
    });
    else if (disabled) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e20ffdae2aa9b33f$export$2e2bcd8739ae039), {
            size: 40,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('countries.history.disabled.title'),
        description: t('countries.history.disabled.desc'),
        "data-testid": "country-history-disabled"
    });
    else if (error) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: t('countries.history.error'),
        description: error,
        onRetry: onRetry,
        retryLabel: t('common.actions.retry'),
        "data-testid": "country-history-error"
    });
    else if (!rows.length) body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
            size: 40,
            strokeWidth: 1.5,
            "aria-hidden": true
        }),
        title: t('countries.history.empty.title'),
        description: t('countries.history.empty.desc'),
        "data-testid": "country-history-empty"
    });
    else body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                dense: true,
                ariaLabel: t('countries.history.aria'),
                rowKey: (c)=>c.id,
                rows: rows,
                rowProps: (c)=>({
                        'data-testid': `country-history-row-${c.id}`
                    }),
                "data-testid": "country-history-table",
                columns: [
                    {
                        key: 'at',
                        header: t('countries.history.columns.at'),
                        render: (c)=>c.changedAt ? formatDateTime(c.changedAt) : t('common.value.none')
                    },
                    {
                        key: 'by',
                        header: t('countries.history.columns.by'),
                        render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c3d2d38834f5b5cb), {
                                by: c.changedBy
                            })
                    },
                    {
                        key: 'fields',
                        header: t('countries.history.columns.fields'),
                        render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "flex flex-wrap gap-1",
                                children: [
                                    c.created ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: t('countries.history.created')
                                    }) : null,
                                    c.changedFields.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: columnLabel(f)
                                        }, f))
                                ]
                            })
                    },
                    {
                        key: 'note',
                        header: t('countries.history.columns.note'),
                        render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dir: "auto",
                                className: "block max-w-[16rem] truncate",
                                title: c.note || '',
                                children: c.note || t('common.value.none')
                            })
                    },
                    {
                        key: 'detail',
                        header: t('countries.history.columns.detail'),
                        render: (c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: "sm",
                                onClick: ()=>setOpen(open === c.id ? null : c.id),
                                "aria-expanded": open === c.id,
                                "aria-label": t('countries.history.showRow'),
                                "data-testid": `country-history-toggle-${c.id}`,
                                children: open === c.id ? t('common.actions.hide') : t('common.actions.show')
                            })
                    }
                ]
            }),
            opened ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-2 grid grid-cols-1 gap-3 md:grid-cols-2",
                "data-testid": "country-history-detail",
                children: [
                    [
                        'before',
                        opened.before
                    ],
                    [
                        'after',
                        opened.after
                    ]
                ].map(([side, json])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-1 text-xs text-muted-foreground",
                                children: t(`countries.history.${side}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                className: "max-h-64 overflow-auto rounded-lg bg-muted p-3 text-[11px] leading-5",
                                children: json ? $c219c659acd3378b$var$pretty(json) : t('common.value.none')
                            })
                        ]
                    }, side))
            }) : null,
            more > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-1",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    size: "sm",
                    onClick: ()=>setShown((n)=>n + (0, $cdf3712044ab22f9$export$4946d8446c21041b)),
                    "data-testid": "country-history-more",
                    children: t('countries.history.more')
                })
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        id: "history",
        title: t('countries.history.title'),
        sub: t('countries.history.sub'),
        icon: (0, $e17c725e7c863883$export$2e2bcd8739ae039),
        "data-testid": "country-history",
        children: body
    });
}


const $3c6e97bf45eb3ebd$var$GROUP_ICONS = {
    locale: (0, $623cbfccc983e6a1$export$2e2bcd8739ae039),
    identity: (0, $745f31c3d9f7add9$export$2e2bcd8739ae039),
    capabilities: (0, $8572ce782cce49ee$export$2e2bcd8739ae039),
    print: (0, $1cbb901abf788f33$export$2e2bcd8739ae039)
};
function $3c6e97bf45eb3ebd$export$2e2bcd8739ae039({ country: country, navigate: navigate }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.country');
    const countryName = (0, $32b5ef4e46f306ee$export$c41202f92c8ce3ea)();
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [refreshing, setRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [notFound, setNotFound] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [history, setHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        loading: true,
        error: null,
        disabled: false,
        changes: []
    });
    const [editing, setEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ quiet: quiet = false } = {})=>{
        if (quiet) setRefreshing(true);
        else setLoading(true);
        setError(null);
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$7bfe1ff81124aa2b), {
            country: country
        }).then((d)=>{
            if (!d?.countryProfile) throw new Error(t('countries.detail.error'));
            setData(d.countryProfile);
        }).catch((e)=>{
            // Not a country key at all: a whole-page state, like a clinic that does not exist.
            if (e?.code === 'INVALID_COUNTRY') setNotFound(true);
            else setError((0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t));
        }).finally(()=>{
            setLoading(false);
            setRefreshing(false);
        });
    }, [
        country,
        t
    ]);
    // The history is its own region: it sits behind the editor's platform_admin
    // contract, which a deployment may not have enabled while the reads work.
    const loadHistory = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setHistory((h)=>({
                ...h,
                loading: true,
                error: null
            }));
        (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $e710da2f947a4ef7$export$405b63fbe63a37e1), {
            country: country,
            limit: 100
        }).then((d)=>setHistory({
                loading: false,
                error: null,
                disabled: false,
                changes: d?.countryProfileChanges || []
            })).catch((e)=>setHistory({
                loading: false,
                disabled: e?.code === 'EDITOR_DISABLED',
                error: e?.code === 'EDITOR_DISABLED' ? null : (0, $32b5ef4e46f306ee$export$7b930bacf3b706d8)(e, t),
                changes: []
            }));
    }, [
        country,
        t
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
        loadHistory();
    }, [
        load,
        loadHistory
    ]);
    if (notFound) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
        code: "404",
        titleKey: "countries.detail.notFound.title",
        adviceKey: "countries.detail.notFound.advice",
        testId: "country-not-found",
        actions: [
            {
                key: 'back',
                label: t('countries.detail.back'),
                onClick: ()=>navigate('/countries')
            }
        ]
    });
    const row = data?.row || null;
    const merged = data?.merged || null;
    const fallback = data?.fallback || null;
    const deployment = data?.deployment;
    const isFallbackRow = country === (0, $258fced26b1fac84$export$dec9af6fc3e9284c);
    const canEdit = !!row && !history.disabled && !history.loading;
    const shown = row || merged;
    // ② at most two, and none of them ever dropped: a country WITHOUT a row is
    // «no row of its own» (+ the market), and offers no edit, so whether the editor
    // is enabled does not apply to it; a country WITH a row is the editor's state
    // (+ the market). What `*` is lives in the rail beside the rules, not here.
    const alerts = [];
    if (data && !row && !isFallbackRow) alerts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "info",
        "data-testid": "country-alert-no-row",
        children: t('countries.detail.alerts.noRow')
    }, "norow"));
    else if (history.disabled) alerts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "info",
        title: t('countries.detail.alerts.editorDisabledTitle'),
        "data-testid": "country-alert-editor-disabled",
        children: t('countries.detail.alerts.editorDisabledBody')
    }, "editor"));
    if (deployment?.market === 'intl') alerts.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "warning",
        title: t('countries.ceiling.intlTitle'),
        "data-testid": "country-alert-intl",
        children: t('countries.ceiling.intlBody')
    }, "intl"));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "country-detail",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                title: countryName(country),
                onBack: ()=>navigate('/countries'),
                backLabel: t('countries.detail.back'),
                status: data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: row ? 'outline' : 'warning',
                    "data-testid": "country-row-badge",
                    children: isFallbackRow ? t('countries.detail.fallbackRow') : row ? t('countries.detail.ownRow') : t('countries.detail.noRow')
                }) : undefined,
                meta: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$34a98f1791d1800e), {
                        code: country
                    }, "code"),
                    shown?.updatedAt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "inline-flex items-center gap-1.5",
                        children: [
                            t('countries.detail.updated', {
                                date: formatDate(shown.updatedAt)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c3d2d38834f5b5cb), {
                                by: shown.updatedBy
                            })
                        ]
                    }, "updated") : null
                ].filter(Boolean),
                "data-testid": "country-header"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mx-auto w-full max-w-[1440px]",
                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_20rem]",
                        "data-testid": "country-loading",
                        "data-state": "loading",
                        "aria-busy": "true",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                        ]
                    }) : error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                        title: t('countries.detail.error'),
                        description: error,
                        onRetry: ()=>load(),
                        retryLabel: t('common.actions.retry'),
                        "data-testid": "country-error"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "transition-opacity",
                        style: {
                            opacity: refreshing ? 0.45 : 1
                        },
                        "aria-busy": refreshing || undefined,
                        "data-state": "content",
                        children: [
                            alerts.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-5 flex flex-col gap-3",
                                children: alerts
                            }) : null,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_20rem]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex min-w-0 flex-col gap-5",
                                        children: [
                                            (0, $258fced26b1fac84$export$77dd5611192b79b9).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c6e97bf45eb3ebd$var$GroupSection, {
                                                    group: group,
                                                    row: row,
                                                    merged: merged,
                                                    fallback: fallback,
                                                    deployment: deployment,
                                                    canEdit: canEdit,
                                                    onEdit: ()=>setEditing(group.key)
                                                }, group.key)),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c219c659acd3378b$export$2e2bcd8739ae039), {
                                                loading: history.loading,
                                                error: history.error,
                                                disabled: history.disabled,
                                                changes: history.changes,
                                                onRetry: loadHistory
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c6e97bf45eb3ebd$var$RulesRail, {
                                        isFallbackRow: isFallbackRow
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            row ? (0, $258fced26b1fac84$export$77dd5611192b79b9).map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dff16fd5ba545ec2$export$2e2bcd8739ae039), {
                    open: editing === group.key,
                    onOpenChange: (o)=>setEditing(o ? group.key : null),
                    group: group,
                    country: country,
                    row: row,
                    fallback: fallback,
                    deployment: deployment,
                    onSaved: ()=>{
                        load({
                            quiet: true
                        });
                        loadHistory();
                    }
                }, group.key)) : null
        ]
    });
}
/**
 * One of the contract's four groups. With a row of its own the STORED row is
 * shown — NULL as «پیرو *» / «هیچ» — so what the editor changes is what is on
 * screen; without one, the merge with `*` the country actually reads.
 */ function $3c6e97bf45eb3ebd$var$GroupSection({ group: group, row: row, merged: merged, fallback: fallback, deployment: deployment, canEdit: canEdit, onEdit: onEdit }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const titleId = `country-group-${group.key}-title`;
    const Icon = $3c6e97bf45eb3ebd$var$GROUP_ICONS[group.key] || (0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039);
    const groupName = t(`countries.groups.${group.key}`);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        id: `group-${group.key}`,
        title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            id: titleId,
            children: groupName
        }),
        sub: t(`countries.groupHints.${group.key}`),
        icon: Icon,
        "data-testid": `country-group-${group.key}`,
        children: [
            group.key === 'capabilities' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs leading-5 text-muted-foreground",
                "data-testid": "country-ceiling-intro",
                children: t('countries.ceiling.intro')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                className: "grid grid-cols-1 gap-4 text-sm md:grid-cols-2",
                "aria-labelledby": titleId,
                children: group.fields.map((spec)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "min-w-0",
                        "data-testid": `country-field-${spec.field}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                className: "flex flex-wrap items-center gap-1 text-xs text-muted-foreground",
                                children: [
                                    t(`countries.fields.${spec.field}`),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$94b87dfb202e46b9), {
                                        field: spec.field
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                className: "mt-1 font-semibold text-foreground",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$c6f10d457200e8c6), {
                                        spec: spec,
                                        row: row || merged,
                                        fallback: row ? fallback : null,
                                        merged: !row,
                                        deployment: deployment
                                    }),
                                    spec.field === 'insuranceCatalog' && (row || merged)?.insuranceCatalog ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/countries?view=insurers&catalog=${encodeURIComponent((row || merged).insuranceCatalog)}`,
                                        className: "ms-2 text-xs font-normal text-primary hover:underline",
                                        "data-testid": "country-insurers-link",
                                        children: t('countries.detail.seeInsurers')
                                    }) : null
                                ]
                            }),
                            spec.kind === 'capability' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "mt-0.5",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32b5ef4e46f306ee$export$cc60d6d36c1a0b3c), {
                                    spec: spec,
                                    value: (row || merged)?.[spec.field],
                                    deployment: deployment
                                })
                            }) : null
                        ]
                    }, spec.field))
            }),
            canEdit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mt-1 flex justify-end border-t border-border pt-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    size: "sm",
                    onClick: onEdit,
                    "aria-label": t('countries.detail.editAria', {
                        group: groupName
                    }),
                    "data-testid": `country-edit-${group.key}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": true
                        }),
                        t('countries.detail.edit')
                    ]
                })
            }) : null
        ]
    });
}
/** The reading rules, beside the page they govern — what NULL, empty and the ceiling mean. */ function $3c6e97bf45eb3ebd$var$RulesRail({ isFallbackRow: isFallbackRow }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f9cbffc25828c55$export$2e2bcd8739ae039), {
        title: t('countries.rules.title'),
        icon: (0, $9a9bbf84fd0f8247$export$2e2bcd8739ae039),
        "data-testid": "country-rules",
        children: [
            isFallbackRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-xs leading-6 text-foreground",
                "data-testid": "country-rules-fallback",
                children: t('countries.detail.alerts.fallback')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "flex flex-col gap-2.5 text-xs leading-6 text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: t('countries.rules.defaults')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: t('countries.rules.capabilities')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: t('countries.rules.ceiling')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: t('countries.rules.notes')
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e583651be68dae50$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ArrowLeftRight", [
    [
        "path",
        {
            d: "M8 3 4 7l4 4",
            key: "9rb6wj"
        }
    ],
    [
        "path",
        {
            d: "M4 7h16",
            key: "6tx8e3"
        }
    ],
    [
        "path",
        {
            d: "m16 21 4-4-4-4",
            key: "siv7j2"
        }
    ],
    [
        "path",
        {
            d: "M20 17H4",
            key: "h6l3hr"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2814ca8ca76f8609$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Unlink", [
    [
        "path",
        {
            d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
            key: "yqzxt4"
        }
    ],
    [
        "path",
        {
            d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
            key: "4qinb0"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "2",
            y2: "5",
            key: "1041cp"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "5",
            y1: "8",
            y2: "8",
            key: "14m1p5"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "19",
            y2: "22",
            key: "rzdirn"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "22",
            y1: "16",
            y2: "16",
            key: "ox905f"
        }
    ]
]);

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a78b469f600ecb2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("UserSearch", [
    [
        "circle",
        {
            cx: "10",
            cy: "7",
            r: "4",
            key: "e45bow"
        }
    ],
    [
        "path",
        {
            d: "M10.3 15H7a4 4 0 0 0-4 4v2",
            key: "3bnktk"
        }
    ],
    [
        "circle",
        {
            cx: "17",
            cy: "17",
            r: "3",
            key: "18b49y"
        }
    ],
    [
        "path",
        {
            d: "m21 21-1.9-1.9",
            key: "1g2n9r"
        }
    ]
]);







/**
 * Every GraphQL document the «یکی کردن حساب‌ها» screen sends, built against the
 * contract in `parsina.bff.admin/src/graphql/typeDefs/accounts.js` (PM-0536 P5b,
 * PM-0546). One file, so a contract change is a diff against one place and a test
 * can match a call by its operation name.
 *
 * The Keycloak accounts are every environment's (one realm serves them all); the
 * records are THIS environment's.
 */ const $518d49f1ac10720a$var$RECORD_FIELDS = `
  id fullName nationalId birthDate gender phoneNumber keycloakUserId createdAt
`;
const $518d49f1ac10720a$var$ACCOUNT_FIELDS = `
  id username enabled firstName lastName createdAt
  phoneNumber phoneVerified formerPhoneNumber nationalId clinicId
  patientIdAttribute { value state record { ${$518d49f1ac10720a$var$RECORD_FIELDS} } }
  roles nonPatientRoles groups practitionerClinics
  records { ${$518d49f1ac10720a$var$RECORD_FIELDS} }
`;
const $518d49f1ac10720a$export$af8c98140ef77898 = `
  query PatientAccounts($phone: String, $nationalId: String) {
    patientAccounts(phone: $phone, nationalId: $nationalId) {
      configured
      accounts { ${$518d49f1ac10720a$var$ACCOUNT_FIELDS} }
      records { ${$518d49f1ac10720a$var$RECORD_FIELDS} }
    }
  }
`;
const $518d49f1ac10720a$export$4d723c073bff2626 = `
  query AccountConsolidationPreview($keepUserId: ID!, $dropUserId: ID!) {
    accountConsolidationPreview(keepUserId: $keepUserId, dropUserId: $dropUserId) {
      keep { ${$518d49f1ac10720a$var$ACCOUNT_FIELDS} }
      drop { ${$518d49f1ac10720a$var$ACCOUNT_FIELDS} }
      refusals { code message }
      allowed
      confirmationText
      formerPhoneNumberKept
    }
  }
`;
const $518d49f1ac10720a$export$d259072266eb88ce = `
  mutation ConsolidatePatientAccounts(
    $keepUserId: ID!, $dropUserId: ID!, $reason: String!, $confirmation: String!
  ) {
    consolidatePatientAccounts(
      keepUserId: $keepUserId, dropUserId: $dropUserId, reason: $reason, confirmation: $confirmation
    ) {
      result patientId mergeId mergedIds proofsMoved eventId
      formerPhoneNumber phoneNumberCleared disabled loggedOut patientIdAttribute
      failedStep notes
    }
  }
`;
const $518d49f1ac10720a$export$ac88d8cadf56c983 = `
  mutation ReleasePatientAccount($patientId: ID!, $keycloakUserId: ID!, $reason: String!) {
    releasePatientAccount(patientId: $patientId, keycloakUserId: $keycloakUserId, reason: $reason) {
      patientId eventId releasedAt
    }
  }
`;



parcelRequire("acw62");



const $fc9920ce3d443f68$export$2e4e357314362f35 = 3;
const $fc9920ce3d443f68$export$e0eeef539779b73 = 500;
const $fc9920ce3d443f68$export$190fdd7c86e5a6c7 = [
    'merged',
    'moved',
    'none'
];
const $fc9920ce3d443f68$export$f86789687d9d8bb2 = [
    'HERE',
    'MERGED',
    'ABSENT'
];
const $fc9920ce3d443f68$export$3ced33b00d433512 = [
    'clear_phone',
    'disable',
    'logout',
    'patient_id'
];
function $fc9920ce3d443f68$export$673d074274e937c4(account) {
    if (!account) return [];
    const codes = [];
    if (account.nonPatientRoles?.length) codes.push('DROP_HAS_ROLES');
    if (account.groups?.length) codes.push('DROP_IN_GROUP');
    if (account.clinicId) codes.push('DROP_HAS_CLINIC');
    if (account.practitionerClinics == null) codes.push('PRACTITIONER_UNKNOWN');
    else if (account.practitionerClinics > 0) codes.push('DROP_IS_PRACTITIONER');
    return codes;
}
function $fc9920ce3d443f68$export$16f65510b68df0eb(first, second) {
    const firstBlocked = $fc9920ce3d443f68$export$673d074274e937c4(first).length > 0;
    const secondBlocked = $fc9920ce3d443f68$export$673d074274e937c4(second).length > 0;
    if (secondBlocked && !firstBlocked) return {
        keepId: second.id,
        dropId: first.id
    };
    if (!firstBlocked && !secondBlocked && !first.enabled && second.enabled) return {
        keepId: second.id,
        dropId: first.id
    };
    return {
        keepId: first.id,
        dropId: second.id
    };
}
function $fc9920ce3d443f68$export$5383b50b2c89c3a5(lookup) {
    const byId = new Map();
    for (const r of lookup?.records || [])byId.set(r.id, r);
    for (const a of lookup?.accounts || [])for (const r of a.records || [])if (!byId.has(r.id)) byId.set(r.id, r);
    return [
        ...byId.values()
    ];
}
function $fc9920ce3d443f68$export$a752fdf250b6b9c9({ phone: phone, nationalId: nationalId } = {}) {
    const p = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(String(phone ?? '')).trim();
    const n = (0, $c53f9539af19d960$export$e53ee9755c8a3679)(String(nationalId ?? '')).trim();
    return {
        phone: p || null,
        nationalId: n || null
    };
}
function $fc9920ce3d443f68$export$d0f464870998e995(account) {
    if (!account) return '';
    const name = [
        account.firstName,
        account.lastName
    ].filter(Boolean).join(' ').trim();
    return name || account.username || account.id;
}
function $fc9920ce3d443f68$export$331e9b6bdecaac5f({ value: value, className: className = '', 'data-testid': testId }) {
    if (!value) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "data-testid": testId,
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        ...(0, $c53f9539af19d960$export$3433559efc22d110),
        className: `font-mono text-xs ${className}`,
        "data-testid": testId,
        children: value
    });
}
function $fc9920ce3d443f68$export$4e0ae723fbb61240({ enabled: enabled, 'data-testid': testId }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: enabled ? 'success' : 'outline',
        "data-testid": testId,
        children: enabled ? t('accounts.account.enabled') : t('accounts.account.disabled')
    });
}
const $fc9920ce3d443f68$var$ATTRIBUTE_TONE = {
    HERE: 'success',
    MERGED: 'warning',
    ABSENT: 'outline'
};
function $fc9920ce3d443f68$export$c38a3d4ed11a8df({ attribute: attribute, 'data-testid': testId }) {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!attribute) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "data-testid": testId,
        children: t('accounts.attribute.none')
    });
    const key = `accounts.attribute.state.${attribute.state}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
        variant: $fc9920ce3d443f68$var$ATTRIBUTE_TONE[attribute.state] || 'outline',
        title: has && has(`accounts.attribute.hint.${attribute.state}`) ? t(`accounts.attribute.hint.${attribute.state}`) : undefined,
        "data-testid": testId,
        children: has && has(key) ? t(key) : String(attribute.state)
    });
}
function $fc9920ce3d443f68$export$355bbea6297ed3eb(t, has, refusal) {
    const key = `accounts.refusals.${refusal.code}`;
    return has && has(key) ? t(key) : refusal.message || refusal.code;
}



parcelRequire("acw62");

/**
 * @license lucide-react v0.446.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ec781acee04dc321$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("Merge", [
    [
        "path",
        {
            d: "m8 6 4-4 4 4",
            key: "ybng9g"
        }
    ],
    [
        "path",
        {
            d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22",
            key: "1hyw0i"
        }
    ],
    [
        "path",
        {
            d: "m20 22-5-5",
            key: "1m27yz"
        }
    ]
]);





function $46236f517dfaa3f5$export$2e2bcd8739ae039({ status: status, preview: preview, error: error, onRetry: onRetry, onKeep: onKeep, onConsolidate: onConsolidate, onClose: onClose }) {
    const { t: t, has: has } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "mt-4 rounded-lg border border-border bg-card p-4",
        "aria-labelledby": "accounts-preview-title",
        "data-testid": "accounts-preview",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-3 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        id: "accounts-preview-title",
                        className: "text-base font-bold text-foreground",
                        children: t('accounts.preview.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: "sm",
                        onClick: onClose,
                        "data-testid": "accounts-preview-close",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('accounts.preview.close')
                        ]
                    })
                ]
            }),
            status === 'loading' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid gap-4 md:grid-cols-2",
                role: "status",
                "aria-busy": "true",
                "aria-label": t('accounts.preview.loading'),
                "data-testid": "accounts-preview-loading",
                "data-state": "loading",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5956eb8f2ff4afde), {})
                ]
            }) : status === 'error' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('accounts.preview.error'),
                description: error,
                onRetry: onRetry,
                retryLabel: t('common.actions.retry'),
                "data-testid": "accounts-preview-error"
            }) : preview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-state": "content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid gap-4 md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($46236f517dfaa3f5$var$AccountPanel, {
                                account: preview.keep,
                                other: preview.drop,
                                role: "keep",
                                onKeep: onKeep
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($46236f517dfaa3f5$var$AccountPanel, {
                                account: preview.drop,
                                other: preview.keep,
                                role: "drop",
                                onKeep: onKeep
                            })
                        ]
                    }),
                    !preview.formerPhoneNumberKept ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        className: "mt-3",
                        "data-testid": "accounts-preview-former-not-kept",
                        children: t('accounts.preview.formerNotKept')
                    }) : null,
                    preview.refusals?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "error",
                        title: t('accounts.preview.refusedTitle'),
                        className: "mt-3",
                        "data-testid": "accounts-preview-refusals",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "list-disc ps-5",
                            children: preview.refusals.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    "data-testid": `accounts-refusal-${r.code}`,
                                    children: (0, $fc9920ce3d443f68$export$355bbea6297ed3eb)(t, has, r)
                                }, r.code))
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-4 flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "destructive",
                                disabled: !preview.allowed,
                                "aria-describedby": !preview.allowed ? 'accounts-preview-blocked' : undefined,
                                onClick: onConsolidate,
                                "data-testid": "accounts-consolidate-open",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec781acee04dc321$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    t('accounts.preview.consolidate')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm text-muted-foreground",
                                id: "accounts-preview-blocked",
                                children: preview.allowed ? t('accounts.preview.summary', {
                                    keep: (0, $fc9920ce3d443f68$export$d0f464870998e995)(preview.keep),
                                    drop: (0, $fc9920ce3d443f68$export$d0f464870998e995)(preview.drop)
                                }) : t('accounts.preview.blocked')
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}
/** One account's card: what it is, what it holds here, and whether it can stay. */ function $46236f517dfaa3f5$var$AccountPanel({ account: account, other: other, role: role, onKeep: onKeep }) {
    const { t: t, has: has, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const keeping = role === 'keep';
    // Keeping THIS one drops the other; a doctor's or staff account is never dropped.
    const blockers = keeping ? [] : (0, $fc9920ce3d443f68$export$673d074274e937c4)(other);
    const reasonId = `accounts-keep-blocked-${account.id}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
        className: `rounded-lg border p-4 ${keeping ? 'border-primary' : 'border-border'}`,
        "aria-label": t(keeping ? 'accounts.preview.keepAria' : 'accounts.preview.dropAria', {
            name: (0, $fc9920ce3d443f68$export$d0f464870998e995)(account)
        }),
        "data-testid": `accounts-preview-${role}`,
        "data-account-id": account.id,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                className: "mb-3 flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        dir: "auto",
                        className: "min-w-0 truncate font-semibold text-foreground",
                        children: (0, $fc9920ce3d443f68$export$d0f464870998e995)(account)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: keeping ? 'success' : 'destructive',
                        "data-testid": `accounts-preview-${role}-role`,
                        children: keeping ? t('accounts.preview.stays') : t('accounts.preview.goes')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "grid grid-cols-[minmax(7rem,auto)_1fr] gap-x-3 gap-y-1.5 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.username')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: account.username
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.status')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$4e0ae723fbb61240), {
                            enabled: account.enabled
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.phone')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                        className: "flex flex-wrap items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                                value: account.phoneNumber,
                                "data-testid": `accounts-preview-${role}-phone`
                            }),
                            account.phoneNumber ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-xs text-muted-foreground",
                                children: account.phoneVerified ? t('accounts.account.verified') : t('accounts.account.unverified')
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.formerPhone')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: account.formerPhoneNumber
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.nationalId')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: account.nationalId
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.roles')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        "data-testid": `accounts-preview-${role}-roles`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($46236f517dfaa3f5$export$f28593264fbf36da, {
                            account: account
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.practitioner')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: account.practitionerClinics == null ? t('accounts.account.practitionerUnknown') : account.practitionerClinics > 0 ? t('accounts.account.practitionerAt', {
                            count: account.practitionerClinics
                        }) : t('accounts.account.practitionerNone')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.records')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        "data-testid": `accounts-preview-${role}-records`,
                        children: account.records?.length ? account.records.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        dir: "auto",
                                        children: r.fullName || t('accounts.records.unnamed')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                                        value: r.id
                                    })
                                ]
                            }, r.id)) : t('accounts.records.noneHere')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.attribute')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                        className: "flex flex-wrap items-center gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$c38a3d4ed11a8df), {
                                attribute: account.patientIdAttribute
                            }),
                            account.patientIdAttribute ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                                value: account.patientIdAttribute.value
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        className: "text-muted-foreground",
                        children: t('accounts.fields.createdAt')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: account.createdAt ? formatDate(account.createdAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: keeping ? 'default' : 'outline',
                        "aria-pressed": keeping,
                        disabled: keeping || blockers.length > 0,
                        "aria-describedby": blockers.length ? reasonId : undefined,
                        onClick: ()=>onKeep(account.id),
                        "data-testid": `accounts-keep-${account.id}`,
                        children: keeping ? t('accounts.preview.kept') : t('accounts.preview.keepThis')
                    }),
                    blockers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        id: reasonId,
                        className: "mt-1.5 text-xs text-[var(--chip-danger-ink)]",
                        "data-testid": `accounts-keep-reason-${account.id}`,
                        children: [
                            t('accounts.preview.keepBlocked', {
                                name: (0, $fc9920ce3d443f68$export$d0f464870998e995)(other)
                            }),
                            ' ',
                            blockers.map((code)=>(0, $fc9920ce3d443f68$export$355bbea6297ed3eb)(t, has, {
                                    code: code
                                })).join(' ')
                        ]
                    }) : null
                ]
            })
        ]
    });
}
function $46236f517dfaa3f5$export$f28593264fbf36da({ account: account }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const nonPatient = new Set(account.nonPatientRoles || []);
    const roles = account.roles || [];
    if (!roles.length && !account.groups?.length && !account.clinicId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "flex flex-wrap gap-1",
        children: [
            roles.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: nonPatient.has(r) ? 'warning' : 'outline',
                    dir: "ltr",
                    children: r
                }, r)),
            (account.groups || []).map((g)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "warning",
                    title: t('accounts.account.group'),
                    dir: "ltr",
                    children: g
                }, `g:${g}`)),
            account.clinicId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                variant: "warning",
                title: t('accounts.account.clinic'),
                dir: "ltr",
                children: `clinic_id: ${account.clinicId}`
            }) : null
        ]
    });
}



parcelRequire("acw62");





function $4f54096b0e9a440c$export$2e2bcd8739ae039({ entry: entry, onRerun: onRerun, onDismiss: onDismiss }) {
    const { t: t, has: has, formatNumber: formatNumber } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const { report: report, keep: keep, drop: drop } = entry;
    const resultKey = `accounts.result.kind.${report.result}`;
    const failed = !!report.failedStep;
    // A step is done when nothing failed, or when it ran before the one that did:
    // the BFF stops at the first failure, in this order.
    const stoppedAt = failed ? (0, $fc9920ce3d443f68$export$3ced33b00d433512).indexOf(report.failedStep) : -1;
    const done = (key)=>!failed || (0, $fc9920ce3d443f68$export$3ced33b00d433512).indexOf(key) < stoppedAt;
    const DETAIL = {
        clear_phone: $4f54096b0e9a440c$var$formerText(t, has, report.formerPhoneNumber),
        patient_id: has(`accounts.result.attribute.${report.patientIdAttribute}`) ? t(`accounts.result.attribute.${report.patientIdAttribute}`) : report.patientIdAttribute
    };
    const steps = (0, $fc9920ce3d443f68$export$3ced33b00d433512).map((key)=>({
            key: key,
            done: done(key),
            detail: done(key) ? DETAIL[key] : null
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: failed ? 'warning' : 'success',
        title: failed ? t('accounts.result.partialTitle') : t('accounts.result.title'),
        className: "mb-4",
        "data-testid": "accounts-result",
        "data-result": report.result,
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex gap-2",
            children: [
                failed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    size: "sm",
                    variant: "outline",
                    onClick: onRerun,
                    "data-testid": "accounts-result-rerun",
                    children: t('accounts.result.rerun')
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    size: "sm",
                    variant: "ghost",
                    onClick: onDismiss,
                    "data-testid": "accounts-result-dismiss",
                    children: t('accounts.result.dismiss')
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                "data-testid": "accounts-result-kind",
                children: [
                    has(resultKey) ? t(resultKey) : String(report.result),
                    " \u2014 ",
                    t('accounts.result.pair', {
                        keep: (0, $fc9920ce3d443f68$export$d0f464870998e995)(keep),
                        drop: (0, $fc9920ce3d443f68$export$d0f464870998e995)(drop)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "mt-2 grid grid-cols-[minmax(7rem,auto)_1fr] gap-x-3 gap-y-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        children: t('accounts.result.patientId')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: report.patientId,
                            "data-testid": "accounts-result-patient"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        children: t('accounts.result.mergeId')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: report.mergeId,
                            "data-testid": "accounts-result-merge"
                        })
                    }),
                    report.mergedIds?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                children: t('accounts.result.mergedIds')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                className: "flex flex-wrap gap-1.5",
                                children: report.mergedIds.map((id)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                                        value: id
                                    }, id))
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                        children: t('accounts.result.proofsMoved')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                        children: formatNumber(report.proofsMoved || 0)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-2 space-y-1 text-sm",
                "aria-label": t('accounts.result.stepsLabel'),
                "data-testid": "accounts-result-steps",
                children: steps.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "flex flex-wrap items-center gap-1.5",
                        "data-testid": `accounts-step-${s.key}`,
                        "data-done": s.done ? 'true' : 'false',
                        children: [
                            s.done ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true,
                                className: "text-[var(--chip-success-ink)]"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true,
                                className: "text-[var(--chip-danger-ink)]"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t(`accounts.result.steps.${s.key}`)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: s.done ? t('accounts.result.done') : t('accounts.result.notDone')
                            }),
                            s.detail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-muted-foreground",
                                children: `\xb7 ${s.detail}`
                            }) : null
                        ]
                    }, s.key))
            }),
            failed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mt-2 text-sm font-semibold",
                "data-testid": "accounts-result-failed",
                children: t('accounts.result.failedAt', {
                    step: has(`accounts.result.steps.${report.failedStep}`) ? t(`accounts.result.steps.${report.failedStep}`) : report.failedStep
                })
            }) : null,
            report.notes?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "mt-2 list-disc ps-5 text-sm",
                "data-testid": "accounts-result-notes",
                children: report.notes.map((n)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        dir: "auto",
                        children: n
                    }, n))
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4f54096b0e9a440c$export$f8d2986ceb8651c4, {
                entry: entry
            })
        ]
    });
}
function $4f54096b0e9a440c$var$formerText(t, has, value) {
    const key = `accounts.result.former.${value}`;
    return has(key) ? t(key) : value;
}
function $4f54096b0e9a440c$export$f8d2986ceb8651c4({ entry: entry }) {
    const { t: t, formatDateTime: formatDateTime } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        className: "mt-3 border-t border-border pt-2 text-xs text-muted-foreground",
        "data-testid": "accounts-audit",
        children: t(entry.kind === 'release' ? 'accounts.audit.release' : 'accounts.audit.consolidate', {
            actor: entry.actor || t('accounts.audit.unknownActor'),
            at: formatDateTime(entry.at),
            keep: (0, $fc9920ce3d443f68$export$d0f464870998e995)(entry.keep),
            drop: (0, $fc9920ce3d443f68$export$d0f464870998e995)(entry.drop),
            record: entry.record?.fullName || entry.record?.id || (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58),
            holder: entry.holderLabel || (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58),
            reason: entry.reason,
            event: entry.report?.eventId || (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $0fa9c6c4132c43ff$export$2e2bcd8739ae039({ preview: preview, pending: pending, error: error, onOpenChange: onOpenChange, onSubmit: onSubmit }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [confirmation, setConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const keepId = preview?.keep?.id;
    const dropId = preview?.drop?.id;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setReason('');
        setConfirmation('');
        setTouched(false);
    }, [
        keepId,
        dropId
    ]);
    const trimmed = reason.trim();
    const reasonInvalid = trimmed.length < (0, $fc9920ce3d443f68$export$2e4e357314362f35);
    const expected = preview?.confirmationText || '';
    const confirmed = !!expected && confirmation.trim() === expected;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: !!preview,
        onOpenChange: onOpenChange,
        title: t('accounts.consolidate.title'),
        error: error,
        pending: pending,
        dirty: !!(reason || confirmation),
        submitLabel: t('accounts.consolidate.submit'),
        submitVariant: "destructive",
        submitDisabled: reasonInvalid || !confirmed,
        onSubmit: ()=>{
            setTouched(true);
            if (!reasonInvalid && confirmed) onSubmit({
                reason: trimmed,
                confirmation: confirmation.trim()
            });
        },
        "data-testid": "accounts-consolidate",
        lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
            variant: "error",
            "data-testid": "accounts-consolidate-warning",
            children: t('accounts.consolidate.warning', {
                keep: (0, $fc9920ce3d443f68$export$d0f464870998e995)(preview?.keep),
                drop: (0, $fc9920ce3d443f68$export$d0f464870998e995)(preview?.drop)
            })
        }),
        children: [
            preview && !preview.formerPhoneNumberKept ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                "data-testid": "accounts-consolidate-former-not-kept",
                children: t('accounts.preview.formerNotKept')
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "accounts-consolidate-reason",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    label: t('accounts.consolidate.reason'),
                    required: true,
                    helperText: t('accounts.consolidate.reasonHelp'),
                    value: reason,
                    onChange: (e)=>setReason(e.target?.value ?? e),
                    onBlur: ()=>setTouched(true),
                    placeholder: t('accounts.consolidate.reasonPlaceholder'),
                    error: touched && reason && reasonInvalid ? t('validation.tooShort', {
                        min: (0, $fc9920ce3d443f68$export$2e4e357314362f35)
                    }) : undefined,
                    maxLength: (0, $fc9920ce3d443f68$export$e0eeef539779b73),
                    showCount: true,
                    rows: 3,
                    disabled: pending
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "mb-1.5 text-sm text-muted-foreground",
                        id: "accounts-consolidate-expected",
                        children: [
                            t('accounts.consolidate.confirmHint'),
                            ' ',
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                ...(0, $c53f9539af19d960$export$3433559efc22d110),
                                className: "font-mono text-foreground",
                                "data-testid": "accounts-consolidate-expected",
                                children: expected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('accounts.consolidate.confirmLabel'),
                        required: true,
                        dir: "ltr",
                        autoComplete: "off",
                        spellCheck: false,
                        value: confirmation,
                        onChange: (e)=>setConfirmation(e.target?.value ?? e),
                        "aria-describedby": "accounts-consolidate-expected",
                        // Not while they are still typing it: only once it is as long as the text.
                        error: confirmation && confirmation.trim().length >= expected.length && !confirmed ? t('accounts.consolidate.confirmMismatch') : undefined,
                        disabled: pending,
                        "data-testid": "accounts-consolidate-confirm"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




function $04f6b0ad053c29e4$export$2e2bcd8739ae039({ target: target, pending: pending, error: error, onOpenChange: onOpenChange, onSubmit: onSubmit }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const [reason, setReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setReason('');
        setTouched(false);
    }, [
        target?.record?.id
    ]);
    const trimmed = reason.trim();
    const invalid = trimmed.length < (0, $fc9920ce3d443f68$export$2e4e357314362f35);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edf836d1b9a3c0c2$export$2e2bcd8739ae039), {
        open: !!target,
        onOpenChange: onOpenChange,
        title: t('accounts.release.title', {
            name: target?.record?.fullName || target?.record?.id || ''
        }),
        error: error,
        pending: pending,
        dirty: !!reason,
        submitLabel: t('accounts.release.submit'),
        submitVariant: "destructive",
        submitDisabled: invalid,
        onSubmit: ()=>{
            setTouched(true);
            if (!invalid) onSubmit({
                reason: trimmed
            });
        },
        "data-testid": "accounts-release",
        lead: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
            variant: "warning",
            "data-testid": "accounts-release-warning",
            children: t('accounts.release.warning', {
                holder: target?.holderLabel || ''
            })
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-testid": "accounts-release-reason",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                label: t('accounts.release.reason'),
                required: true,
                helperText: t('accounts.release.reasonHelp'),
                value: reason,
                onChange: (e)=>setReason(e.target?.value ?? e),
                onBlur: ()=>setTouched(true),
                error: touched && reason && invalid ? t('validation.tooShort', {
                    min: (0, $fc9920ce3d443f68$export$2e4e357314362f35)
                }) : undefined,
                maxLength: (0, $fc9920ce3d443f68$export$e0eeef539779b73),
                showCount: true,
                rows: 3,
                disabled: pending
            })
        })
    });
}


function $0eddb926277c0163$export$2e2bcd8739ae039({ me: me }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    (0, $eb17209f5f553d78$export$2e2bcd8739ae039)('nav.title.patientAccounts');
    // ── the lookup ────────────────────────────────────────────────────────────
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        phone: '',
        nationalId: ''
    });
    const [formError, setFormError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [searched, setSearched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the variables last sent
    const [lookup, setLookup] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        status: 'idle',
        data: null,
        error: null
    });
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]); // up to two account ids
    const runLookup = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((variables, { quiet: quiet = false } = {})=>{
        setLookup((prev)=>({
                status: quiet && prev.data ? 'refreshing' : 'loading',
                data: quiet ? prev.data : null,
                error: null
            }));
        return (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $518d49f1ac10720a$export$af8c98140ef77898), variables).then((d)=>setLookup({
                status: 'content',
                data: d?.patientAccounts || {
                    configured: true,
                    accounts: [],
                    records: []
                },
                error: null
            })).catch((e)=>setLookup({
                status: 'error',
                data: null,
                error: (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t)
            }));
    }, [
        t
    ]);
    const submitSearch = (e)=>{
        e?.preventDefault?.();
        const variables = (0, $fc9920ce3d443f68$export$a752fdf250b6b9c9)(form);
        if (!variables.phone && !variables.nationalId) {
            setFormError(t('accounts.search.needOne'));
            return;
        }
        setFormError(null);
        setSearched(variables);
        setSelected([]);
        setPreview(null);
        runLookup(variables);
    };
    const phoneRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const focusSearch = ()=>{
        phoneRef.current?.focus();
        phoneRef.current?.select?.();
    };
    (0, $a2acbbdcdb6ac534$export$b0ebbe7904d8d94a)('f3', focusSearch, {
        label: t('shortcuts.action.search'),
        group: t('shortcuts.groups.patientAccounts')
    });
    // ── the preview ───────────────────────────────────────────────────────────
    // { keepId, dropId, status, data, error } | null
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const loadPreview = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((keepId, dropId)=>{
        setPreview({
            keepId: keepId,
            dropId: dropId,
            status: 'loading',
            data: null,
            error: null
        });
        return (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $518d49f1ac10720a$export$4d723c073bff2626), {
            keepUserId: keepId,
            dropUserId: dropId
        }).then((d)=>setPreview((p)=>p && p.keepId === keepId && p.dropId === dropId ? {
                    ...p,
                    status: 'content',
                    data: d?.accountConsolidationPreview || null
                } : p)).catch((e)=>setPreview((p)=>p && p.keepId === keepId && p.dropId === dropId ? {
                    ...p,
                    status: 'error',
                    error: (0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t)
                } : p));
    }, [
        t
    ]);
    const accounts = lookup.data?.accounts || [];
    const byId = new Map(accounts.map((a)=>[
            a.id,
            a
        ]));
    const openPreview = ()=>{
        const [a, b] = selected.map((id)=>byId.get(id));
        if (!a || !b) return;
        const { keepId: keepId, dropId: dropId } = (0, $fc9920ce3d443f68$export$16f65510b68df0eb)(a, b);
        loadPreview(keepId, dropId);
    };
    /** «این حساب بماند» on the other card: keep `id`, drop the one kept so far. */ const keepAccount = (id)=>{
        if (!preview || preview.keepId === id) return;
        loadPreview(id, preview.keepId);
    };
    // ── the writes ────────────────────────────────────────────────────────────
    const [consolidating, setConsolidating] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // the preview data
    const [releasing, setReleasing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { record, holderLabel }
    const [pending, setPending] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [dialogError, setDialogError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [lastEntry, setLastEntry] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // what the last write did
    const actor = me?.name || me?.username || '';
    const consolidate = async ({ reason: reason, confirmation: confirmation })=>{
        const target = consolidating;
        setPending(true);
        setDialogError(null);
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $518d49f1ac10720a$export$d259072266eb88ce), {
                keepUserId: target.keep.id,
                dropUserId: target.drop.id,
                reason: reason,
                confirmation: confirmation
            });
            const report = d?.consolidatePatientAccounts;
            setConsolidating(null);
            setPreview(null);
            setSelected([]);
            setLastEntry({
                kind: 'consolidate',
                report: report,
                keep: target.keep,
                drop: target.drop,
                reason: reason,
                actor: actor,
                at: new Date().toISOString()
            });
            if (report?.failedStep) toast.error(t('accounts.result.partialTitle'));
            else toast.success(t('accounts.result.title'));
            if (searched) runLookup(searched, {
                quiet: true
            });
        } catch (e) {
            setDialogError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const release = async ({ reason: reason })=>{
        const target = releasing;
        setPending(true);
        setDialogError(null);
        try {
            const d = await (0, $4d933cf7e127f21f$export$72e4926bf8358653)((0, $518d49f1ac10720a$export$ac88d8cadf56c983), {
                patientId: target.record.id,
                keycloakUserId: target.record.keycloakUserId,
                reason: reason
            });
            setReleasing(null);
            setLastEntry({
                kind: 'release',
                report: d?.releasePatientAccount,
                record: target.record,
                holderLabel: target.holderLabel,
                reason: reason,
                actor: actor,
                at: new Date().toISOString()
            });
            toast.success(t('accounts.release.success'));
            if (searched) runLookup(searched, {
                quiet: true
            });
        } catch (e) {
            setDialogError((0, $4d933cf7e127f21f$export$493b5823483d2c4e)(e, t));
        } finally{
            setPending(false);
        }
    };
    const holderLabel = (userId)=>{
        const holder = byId.get(userId);
        return holder ? (0, $fc9920ce3d443f68$export$d0f464870998e995)(holder) : userId;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex h-full flex-col bg-background",
        "data-testid": "patient-accounts",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('accounts.title'),
                sub: t('accounts.sub')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-y-auto px-8 py-6",
                children: [
                    lastEntry?.kind === 'consolidate' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f54096b0e9a440c$export$2e2bcd8739ae039), {
                        entry: lastEntry,
                        onRerun: ()=>loadPreview(lastEntry.keep.id, lastEntry.drop.id),
                        onDismiss: ()=>setLastEntry(null)
                    }) : null,
                    lastEntry?.kind === 'release' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "success",
                        title: t('accounts.release.success'),
                        className: "mb-4",
                        "data-testid": "accounts-release-result",
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            size: "sm",
                            variant: "ghost",
                            onClick: ()=>setLastEntry(null),
                            children: t('accounts.result.dismiss')
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f54096b0e9a440c$export$f8d2986ceb8651c4), {
                            entry: lastEntry
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        onSubmit: submitSearch,
                        className: "mb-4 flex flex-wrap items-end gap-3 rounded-lg border border-border bg-card p-3",
                        role: "search",
                        "aria-label": t('accounts.search.label'),
                        "data-testid": "accounts-search",
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "min-w-[14rem] flex-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    ref: phoneRef,
                                    label: t('accounts.search.phone'),
                                    dir: "ltr",
                                    inputMode: "tel",
                                    autoComplete: "off",
                                    value: form.phone,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                phone: e.target?.value ?? e
                                            })),
                                    placeholder: t('accounts.search.phonePlaceholder'),
                                    "data-testid": "accounts-search-phone"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "min-w-[14rem] flex-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('accounts.search.nationalId'),
                                    dir: "ltr",
                                    inputMode: "numeric",
                                    autoComplete: "off",
                                    value: form.nationalId,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                nationalId: e.target?.value ?? e
                                            })),
                                    "data-testid": "accounts-search-national-id"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                type: "submit",
                                disabled: lookup.status === 'loading',
                                "data-testid": "accounts-search-submit",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": true
                                    }),
                                    t('accounts.search.submit')
                                ]
                            }),
                            formError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "basis-full text-sm text-[var(--chip-danger-ink)]",
                                role: "alert",
                                "data-testid": "accounts-search-error",
                                children: formError
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0eddb926277c0163$var$Results, {
                        lookup: lookup,
                        selected: selected,
                        onToggle: (id, on)=>setSelected((s)=>on ? [
                                    ...s,
                                    id
                                ].slice(-2) : s.filter((x)=>x !== id)),
                        onRetry: ()=>searched && runLookup(searched),
                        onCompare: openPreview,
                        onRelease: (record)=>{
                            setDialogError(null);
                            setReleasing({
                                record: record,
                                holderLabel: holderLabel(record.keycloakUserId)
                            });
                        },
                        holderLabel: holderLabel
                    }),
                    preview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46236f517dfaa3f5$export$2e2bcd8739ae039), {
                        status: preview.status,
                        preview: preview.data,
                        error: preview.error,
                        onRetry: ()=>loadPreview(preview.keepId, preview.dropId),
                        onKeep: keepAccount,
                        onConsolidate: ()=>{
                            setDialogError(null);
                            setConsolidating(preview.data);
                        },
                        onClose: ()=>setPreview(null)
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fa9c6c4132c43ff$export$2e2bcd8739ae039), {
                preview: consolidating,
                pending: pending,
                error: dialogError,
                onOpenChange: (open)=>{
                    if (!open && !pending) setConsolidating(null);
                },
                onSubmit: consolidate
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04f6b0ad053c29e4$export$2e2bcd8739ae039), {
                target: releasing,
                pending: pending,
                error: dialogError,
                onOpenChange: (open)=>{
                    if (!open && !pending) setReleasing(null);
                },
                onSubmit: release
            })
        ]
    });
}
/** The lookup region: idle, loading, error, not configured, empty, content. */ function $0eddb926277c0163$var$Results({ lookup: lookup, selected: selected, onToggle: onToggle, onRetry: onRetry, onCompare: onCompare, onRelease: onRelease, holderLabel: holderLabel }) {
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (lookup.status === 'idle') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-lg border border-border bg-card",
        "data-state": "idle",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a78b469f600ecb2$export$2e2bcd8739ae039), {
                size: 44,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: t('accounts.idle.title'),
            description: t('accounts.idle.desc'),
            "data-testid": "accounts-idle"
        })
    });
    if (lookup.status === 'loading') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-lg border border-border bg-card",
        "data-testid": "accounts-loading",
        "data-state": "loading",
        role: "status",
        "aria-busy": "true",
        "aria-label": t('accounts.loading'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: Array.from({
                    length: 3
                }).map((_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8bbcb87f63697989), {
                        cols: 7
                    }, i))
            })
        })
    });
    if (lookup.status === 'error') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-lg border border-border bg-card",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('accounts.error'),
            description: lookup.error,
            onRetry: onRetry,
            retryLabel: t('common.actions.retry'),
            "data-testid": "accounts-error"
        })
    });
    const data = lookup.data || {};
    if (data.configured === false) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "warning",
        title: t('accounts.notConfigured.title'),
        "data-testid": "accounts-not-configured",
        children: t('accounts.notConfigured.desc')
    });
    const accounts = data.accounts || [];
    const records = (0, $fc9920ce3d443f68$export$5383b50b2c89c3a5)(data);
    if (!accounts.length && !records.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-lg border border-border bg-card",
        "data-state": "empty",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a72a452dcd95d49b$export$2e2bcd8739ae039), {
                size: 44,
                strokeWidth: 1.5,
                "aria-hidden": true
            }),
            title: t('accounts.empty.title'),
            description: t('accounts.empty.desc'),
            "data-testid": "accounts-empty"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-4 transition-opacity",
        style: {
            opacity: lookup.status === 'refreshing' ? 0.45 : 1
        },
        "aria-busy": lookup.status === 'refreshing' || undefined,
        "data-state": "content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0eddb926277c0163$var$AccountsTable, {
                accounts: accounts,
                selected: selected,
                onToggle: onToggle,
                onCompare: onCompare
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0eddb926277c0163$var$RecordsTable, {
                records: records,
                onRelease: onRelease,
                holderLabel: holderLabel
            })
        ]
    });
}
function $0eddb926277c0163$var$AccountsTable({ accounts: accounts, selected: selected, onToggle: onToggle, onCompare: onCompare }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const full = selected.length >= 2;
    const columns = [
        {
            key: 'select',
            header: t('accounts.columns.select'),
            width: '4.5rem',
            render: (a)=>{
                const on = selected.includes(a.id);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                    checked: on,
                    disabled: !on && full,
                    onChange: (v)=>onToggle(a.id, !!v),
                    // Inside the <label>, so it names the checkbox; the row shows the name already.
                    label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "sr-only",
                        children: t('accounts.columns.selectAria', {
                            name: (0, $fc9920ce3d443f68$export$d0f464870998e995)(a)
                        })
                    }),
                    "data-testid": `accounts-select-${a.id}`
                });
            }
        },
        {
            key: 'account',
            header: t('accounts.columns.account'),
            render: (a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            children: (0, $fc9920ce3d443f68$export$d0f464870998e995)(a)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: a.username,
                            className: "text-muted-foreground"
                        })
                    ]
                })
        },
        {
            key: 'phone',
            header: t('accounts.columns.phone'),
            width: '10rem',
            render: (a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: a.phoneNumber
                        }),
                        a.formerPhoneNumber ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-xs text-muted-foreground",
                            children: [
                                t('accounts.account.former'),
                                ' ',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                                    value: a.formerPhoneNumber
                                })
                            ]
                        }) : null
                    ]
                })
        },
        {
            key: 'nationalId',
            header: t('accounts.columns.nationalId'),
            width: '8rem',
            render: (a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                    value: a.nationalId
                })
        },
        {
            key: 'status',
            header: t('accounts.columns.status'),
            width: '6rem',
            render: (a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$4e0ae723fbb61240), {
                    enabled: a.enabled,
                    "data-testid": `accounts-enabled-${a.id}`
                })
        },
        {
            key: 'roles',
            header: t('accounts.columns.roles'),
            render: (a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    "data-testid": `accounts-roles-${a.id}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46236f517dfaa3f5$export$f28593264fbf36da), {
                            account: a
                        }),
                        (0, $fc9920ce3d443f68$export$673d074274e937c4)(a).length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "destructive",
                            className: "mt-1",
                            "data-testid": `accounts-staff-${a.id}`,
                            children: t('accounts.account.neverDropped')
                        }) : null
                    ]
                })
        },
        {
            key: 'records',
            header: t('accounts.columns.records'),
            width: '12rem',
            render: (a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0 text-sm",
                    children: [
                        a.records?.length ? a.records.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                className: "truncate",
                                children: r.fullName || t('accounts.records.unnamed')
                            }, r.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-muted-foreground",
                            children: t('accounts.records.noneHere')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$c38a3d4ed11a8df), {
                            attribute: a.patientIdAttribute,
                            "data-testid": `accounts-attribute-${a.id}`
                        })
                    ]
                })
        },
        {
            key: 'createdAt',
            header: t('accounts.columns.createdAt'),
            width: '7rem',
            render: (a)=>a.createdAt ? formatDate(a.createdAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "rounded-lg border border-border bg-card",
        "aria-labelledby": "accounts-accounts-title",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3 border-b border-border p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        id: "accounts-accounts-title",
                        className: "text-sm font-bold text-foreground",
                        children: t('accounts.accountsTitle', {
                            count: accounts.length
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-xs text-muted-foreground",
                        "aria-live": "polite",
                        children: t('accounts.selectHint', {
                            count: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        disabled: selected.length !== 2,
                        onClick: onCompare,
                        "data-testid": "accounts-compare",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e583651be68dae50$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('accounts.compare')
                        ]
                    })
                ]
            }),
            accounts.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                dense: true,
                ariaLabel: t('accounts.accountsAria'),
                columns: columns,
                rows: accounts,
                rowKey: (a)=>a.id,
                rowProps: (a)=>({
                        'data-testid': `accounts-row-${a.id}`
                    }),
                "data-testid": "accounts-table"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "p-4 text-sm text-muted-foreground",
                "data-testid": "accounts-no-accounts",
                children: t('accounts.noAccounts')
            })
        ]
    });
}
function $0eddb926277c0163$var$RecordsTable({ records: records, onRelease: onRelease, holderLabel: holderLabel }) {
    const { t: t, formatDate: formatDate } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    if (!records.length) return null;
    const columns = [
        {
            key: 'name',
            header: t('accounts.records.columns.name'),
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            className: "truncate font-semibold text-foreground",
                            children: r.fullName || t('accounts.records.unnamed')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                            value: r.id,
                            className: "text-muted-foreground"
                        })
                    ]
                })
        },
        {
            key: 'nationalId',
            header: t('accounts.records.columns.nationalId'),
            width: '8rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                    value: r.nationalId
                })
        },
        {
            key: 'phone',
            header: t('accounts.records.columns.phone'),
            width: '9rem',
            render: (r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc9920ce3d443f68$export$331e9b6bdecaac5f), {
                    value: r.phoneNumber
                })
        },
        {
            key: 'holder',
            header: t('accounts.records.columns.holder'),
            width: '12rem',
            render: (r)=>r.keycloakUserId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "auto",
                    className: "truncate",
                    "data-testid": `accounts-record-holder-${r.id}`,
                    children: holderLabel(r.keycloakUserId)
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    "data-testid": `accounts-record-holder-${r.id}`,
                    children: t('accounts.records.unheld')
                })
        },
        {
            key: 'createdAt',
            header: t('accounts.records.columns.createdAt'),
            width: '7rem',
            render: (r)=>r.createdAt ? formatDate(r.createdAt) : (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
        },
        {
            key: 'actions',
            header: t('accounts.records.columns.actions'),
            width: '9rem',
            render: (r)=>r.keycloakUserId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    size: "sm",
                    variant: "outline",
                    className: "text-destructive",
                    onClick: ()=>onRelease(r),
                    "aria-label": t('accounts.release.aria', {
                        name: r.fullName || r.id
                    }),
                    "data-testid": `accounts-release-${r.id}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2814ca8ca76f8609$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": true
                        }),
                        t('accounts.release.action')
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-muted-foreground",
                    children: (0, $7df21990c7b31bb5$export$ccb33e29d92c9a58)
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "rounded-lg border border-border bg-card",
        "aria-labelledby": "accounts-records-title",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "border-b border-border p-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        id: "accounts-records-title",
                        className: "text-sm font-bold text-foreground",
                        children: t('accounts.records.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-muted-foreground",
                        children: t('accounts.records.sub')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                dense: true,
                ariaLabel: t('accounts.records.aria'),
                columns: columns,
                rows: records,
                rowKey: (r)=>r.id,
                rowProps: (r)=>({
                        'data-testid': `accounts-record-${r.id}`
                    }),
                "data-testid": "accounts-records"
            })
        ]
    });
}



function $3712292999d2a2f0$var$DetailRoute() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { clinicId: clinicId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    // Keyed on the id so moving between two clinics remounts the screen rather
    // than showing the previous one's sections while the new query is in flight.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $42acdc1ae5c0dc8f$export$2e2bcd8739ae039), {
        clinicId: clinicId,
        navigate: navigate
    }, clinicId);
}
function $3712292999d2a2f0$var$CountryRoute() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { country: country } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    // `/countries/fallback` is the `*` row; keyed like the clinic record.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c6e97bf45eb3ebd$export$2e2bcd8739ae039), {
        country: (0, $258fced26b1fac84$export$b65397eb57a7a91c)(country),
        navigate: navigate
    }, country);
}
function $3712292999d2a2f0$var$NotFound({ access: access }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { t: t } = (0, $a3661f2c9a55da7f$export$2e2bcd8739ae039)();
    const home = (0, $92377dba2841090c$export$5d5930b97498321d)(access);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28747882bd241f7d$export$2e2bcd8739ae039), {
        code: "404",
        titleKey: "errors.system.notFound.title",
        adviceKey: "errors.system.notFound.advice",
        testId: "system-404",
        actions: home ? [
            {
                key: 'home',
                label: home === '/dashboard' ? t('common.actions.goToDashboard') : t('common.actions.goToDemoRequests'),
                onClick: ()=>navigate(home)
            }
        ] : []
    });
}
function $3712292999d2a2f0$var$App() {
    const session = (0, $592c9188583a4dfe$export$2e2bcd8739ae039)();
    const { me: me } = session;
    const access = (0, $92377dba2841090c$export$2152ba8ad7f65e08)(session);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b338720a444d7bab$export$2e2bcd8739ae039), {
        me: me,
        access: access,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $205f65ac2abc44f3$export$b94310965bed44e6), {
                            access: access
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $205f65ac2abc44f3$export$2e2bcd8739ae039), {
                            access: access,
                            need: "platform"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/dashboard",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $812885e94a0e636d$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/clinics",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e2d594c57ce6e69$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/clinics/:clinicId",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$DetailRoute, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/ai-pricing",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b629834167c25c0$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/marketplace",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c03978b3e0593cd$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/whatsapp",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b6cc7b7fc97d4bc$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/doctor-pages",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d4de09da3da4fb2$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/countries",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $be488fb1238302b9$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/countries/:country",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$CountryRoute, {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/patient-accounts",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0eddb926277c0163$export$2e2bcd8739ae039), {
                                    me: me
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $205f65ac2abc44f3$export$2e2bcd8739ae039), {
                            access: access,
                            need: "crm"
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/demo-requests",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $481676a2f3744c90$export$2e2bcd8739ae039), {
                                me: me
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$NotFound, {
                            access: access
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf276cdc77beba46$export$2e2bcd8739ae039), {})
        ]
    });
}
(0, $7e96a608cb33bf79$exports.createRoot)(document.getElementById('root')).render(/*
    The OUTER boundary, above every provider, with STATIC copy.

    It exists for exactly the case the inner one cannot cover: the i18n provider
    itself throwing. A fallback that called `t` there would throw again inside
    its own error path and produce the white page it was added to prevent — so
    this one's strings are literals, in the product's default language, and that
    is the one place in the app where a literal is correct.

    The inner boundary (in AdminShell, keyed on the pathname) is what makes a
    broken screen cost that screen instead of the session.
  */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10231e94a06472aa$export$2e2bcd8739ae039), {
    // i18n-exempt: static copy for the boundary that catches the i18n provider.
    title: "\u067E\u0646\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    body: "\u0635\u0641\u062D\u0647 \u0631\u0627 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0627\u0632 \u06A9\u0646\u06CC\u062F. \u0627\u06AF\u0631 \u062A\u06A9\u0631\u0627\u0631 \u0634\u062F\u060C \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    retryLabel: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
    fullscreen: true,
    testId: "boot-error-boundary",
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a278322405d51c25$export$2e2bcd8739ae039), {
        fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$e2b0760399e6dece), {}),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $352ffee698fbd002$export$f5d03d415824e0e), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2dcfdcdd64e961a3$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2acbbdcdb6ac534$export$87dd7790e69558a9), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$App, {})
                    })
                })
            })
        })
    })
}));


//# sourceMappingURL=app.cc6a90ee.js.map
